export const BOOKS = [
  {
    "id": 1,
    "title": "Project Hail Mary",
    "author": "Andy Weir",
    "publicationYear": 2021,
    "isbn": "0593135202",
    "googleBooksId": "9ZlgEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=9ZlgEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "Ryland Grace wakes up on a spaceship with no memory of how he got there. He's millions of miles from home, and if he fails, humanity—and Earth itself—will perish. Alone on this tiny ship, it's just Grace and a mission: to conquer an extinction-level threat to humanity, with wit, science, and a lot of duct tape.",
    "rating": 4.5,
    "ratingsCount": 1151488,
    "pageCount": 476,
    "awards": [
      "Hugo Award Best Novel (2022)",
      "Goodreads Choice Award Science Fiction (2021)",
      "Audie Award Best Audiobook and Science Fiction (2022)"
    ],
    "categories": [
      "Science Fiction",
      "Thriller"
    ],
    "scores": {
      "scifi": 10,
      "thriller": 7,
      "character": 9,
      "fast": 9,
      "optimistic": 9,
      "plot": 10,
      "standalone": 10,
      "modern": 10,
      "mind": 8,
      "emotional": 7
    }
  },
  {
    "id": 2,
    "title": "The Name of the Wind",
    "author": "Patrick Rothfuss",
    "publicationYear": 2007,
    "series": {
      "name": "The Kingkiller Chronicle",
      "position": 1
    },
    "isbn": "0756404746",
    "googleBooksId": "Icadapted_placeholder",
    "image": "https://books.google.com/books/content?id=AHbtCgAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "Told in Kvothe's own voice, this is the tale of the magically gifted young man who grows to be the most notorious wizard his world has ever seen. A high-action story written with a poet's hand, The Name of the Wind is a masterpiece that will transport readers into the body and mind of a wizard.",
    "rating": 4.52,
    "ratingsCount": 1085161,
    "pageCount": 662,
    "awards": [
      "Locus Award Best First Novel (2008)",
      "Locus Award Best Fantasy Novel (2008)",
      "ALA Alex Award (2008)",
      "Quill Award Science Fiction/Fantasy/Horror (2007)",
      "Compton Crook Award (2008)"
    ],
    "categories": [
      "Fantasy",
      "Epic"
    ],
    "scores": {
      "fantasy": 10,
      "literary": 9,
      "character": 10,
      "slow": 8,
      "dark": 6,
      "atmosphere": 10,
      "series": 10,
      "classic": 7,
      "mind": 7,
      "emotional": 8
    }
  },
  {
    "id": 3,
    "title": "Anxious People",
    "author": "Fredrik Backman",
    "publicationYear": 2019,
    "isbn": "1501160842",
    "googleBooksId": "placeholder3",
    "image": "https://books.google.com/books/content?id=KyHADwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "A failed bank robber locks himself in an apartment viewing, holding eight complete strangers hostage. What ensues is a hostage drama with comic and tragic overtones, a meditation on the anxieties of modern life, and a deeply moving exploration of the ways we try to connect with one another.",
    "rating": 4.17,
    "ratingsCount": 811201,
    "pageCount": 336,
    "awards": [
      "Goodreads Choice Award Fiction (2020)",
      "Book of the Month Book of the Year Award (2020)"
    ],
    "categories": [
      "Contemporary Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "contemporary": 10,
      "literary": 8,
      "character": 10,
      "medium": 7,
      "optimistic": 8,
      "atmosphere": 9,
      "standalone": 10,
      "modern": 10,
      "heart": 10,
      "emotional": 10
    }
  },
  {
    "id": 4,
    "title": "The Silent Patient",
    "author": "Alex Michaelides",
    "publicationYear": 2019,
    "isbn": "1250301696",
    "googleBooksId": "placeholder4",
    "image": "https://books.google.com/books/content?id=4jNgDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "Alicia Berenson shoots her husband five times in the face and then never speaks another word. A criminal psychotherapist becomes obsessed with uncovering her motive. But his determination to get her to talk and unravel the mystery of why she shot her husband takes him down a twisting path into his own motivations.",
    "rating": 4.17,
    "ratingsCount": 3285890,
    "pageCount": 336,
    "awards": [
      "Barry Award Best First Novel (2020)",
      "Goodreads Choice Award Mystery & Thriller (2019)",
      "Book of the Month Book of the Year Award (2019)",
      "Dublin Literary Award (2021)",
      "Barnes & Noble Book of the Year Award (2019)"
    ],
    "categories": [
      "Thriller",
      "Mystery",
      "Psychological"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 10,
      "character": 7,
      "fast": 6,
      "slow": 7,
      "dark": 9,
      "plot": 10,
      "standalone": 10,
      "modern": 10,
      "mind": 9,
      "emotional": 6
    }
  },
  {
    "id": 5,
    "title": "Educated",
    "author": "Tara Westover",
    "publicationYear": 2018,
    "isbn": "0399590501",
    "googleBooksId": "placeholder5",
    "image": "https://books.google.com/books/content?id=2ObWDgAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "An unforgettable memoir about a young woman who, kept out of school, leaves her survivalist family and goes on to earn a PhD from Cambridge University. Born to survivalists in the mountains of Idaho, Tara Westover was seventeen the first time she set foot in a classroom. Her quest for knowledge transformed her, taking her over oceans and across continents.",
    "rating": 4.46,
    "ratingsCount": 1868739,
    "pageCount": 352,
    "awards": [
      "Goodreads Choice Award Memoir & Autobiography (2018)",
      "National Book Critics Circle Award Autobiography (2018)",
      "Los Angeles Times Book Prize Biography (2018)",
      "ALA Alex Award (2019)",
      "Dayton Literary Peace Prize Nonfiction (2019)"
    ],
    "categories": [
      "Memoir",
      "Biography",
      "Nonfiction"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "character": 10,
      "medium": 6,
      "dark": 8,
      "atmosphere": 8,
      "standalone": 10,
      "modern": 10,
      "heart": 10,
      "emotional": 10
    }
  },
  {
    "id": 6,
    "title": "Atomic Habits",
    "author": "James Clear",
    "publicationYear": 2018,
    "isbn": "0735211299",
    "googleBooksId": "placeholder6",
    "image": "https://books.google.com/books/content?id=XfFvDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "No matter your goals, Atomic Habits offers a proven framework for improving every day. James Clear reveals practical strategies that will teach you exactly how to form good habits, break bad ones, and master the tiny behaviors that lead to remarkable results.",
    "rating": 4.32,
    "ratingsCount": 1308641,
    "pageCount": 319,
    "awards": [
      "Goodreads Choice Award Nominee Nonfiction (2018)"
    ],
    "categories": [
      "Self-Help",
      "Nonfiction",
      "Psychology"
    ],
    "scores": {
      "nonfiction": 10,
      "selfhelp": 10,
      "character": 3,
      "fast": 8,
      "optimistic": 10,
      "plot": 3,
      "standalone": 10,
      "modern": 10,
      "mind": 10,
      "emotional": 4
    }
  },
  {
    "id": 7,
    "title": "The Midnight Library",
    "author": "Matt Haig",
    "publicationYear": 2020,
    "series": {
      "name": "The Midnight World",
      "position": 1
    },
    "isbn": "0525559477",
    "googleBooksId": "placeholder7",
    "image": "https://books.google.com/books/content?id=9RN1DwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "Between life and death there is a library containing infinite books, each one the story of another reality. One tells the story of your life as it is, while countless others detail how your life might have been different. Nora Seed finds herself faced with this decision in the Midnight Library.",
    "rating": 3.98,
    "ratingsCount": 2474187,
    "pageCount": 288,
    "awards": [
      "Goodreads Choice Award Fiction (2020)"
    ],
    "categories": [
      "Contemporary Fiction",
      "Fantasy"
    ],
    "scores": {
      "contemporary": 9,
      "fantasy": 7,
      "literary": 8,
      "character": 9,
      "fast": 7,
      "optimistic": 10,
      "atmosphere": 10,
      "standalone": 10,
      "modern": 10,
      "heart": 10,
      "emotional": 10
    }
  },
  {
    "id": 8,
    "title": "Sapiens: A Brief History of Humankind",
    "author": "Yuval Noah Harari",
    "publicationYear": 2011,
    "series": {
      "name": "Homo",
      "position": 1
    },
    "isbn": "0062316095",
    "googleBooksId": "placeholder8",
    "image": "https://books.google.com/books/content?id=1EiJAwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "100,000 years ago, at least six human species inhabited the earth. Today there is just one. Us. Homo sapiens. How did our species succeed in the battle for dominance? Sapiens is a provocative account of human history, from our origins to our future.",
    "rating": 4.33,
    "ratingsCount": 1266785,
    "pageCount": 512,
    "awards": [
      "Royal Society of Biology General Book Prize (2015)"
    ],
    "categories": [
      "History",
      "Nonfiction",
      "Science"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 10,
      "character": 2,
      "medium": 6,
      "dark": 5,
      "plot": 4,
      "standalone": 10,
      "modern": 10,
      "mind": 10,
      "emotional": 4
    }
  },
  {
    "id": 9,
    "title": "Where the Crawdads Sing",
    "author": "Delia Owens",
    "publicationYear": 2018,
    "isbn": "0735219095",
    "googleBooksId": "placeholder9",
    "image": "https://books.google.com/books/content?id=4ZFkDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "For years, rumors of the 'Marsh Girl' haunted Barkley Cove. So when Chase Andrews is found dead, the locals immediately suspect Kya Clark, the so-called Marsh Girl. But Kya is not what they say. A stunning coming-of-age tale of murder and mystery.",
    "rating": 4.37,
    "ratingsCount": 3641937,
    "pageCount": 384,
    "awards": [
      "Edgar Award Best First Novel by an American Author (2019)",
      "Goodreads Choice Award Historical Fiction (2018)",
      "Idaho Book of the Year (2018)"
    ],
    "categories": [
      "Contemporary Fiction",
      "Mystery",
      "Literary Fiction"
    ],
    "scores": {
      "contemporary": 9,
      "mystery": 8,
      "literary": 9,
      "character": 10,
      "slow": 7,
      "dark": 7,
      "atmosphere": 10,
      "standalone": 10,
      "modern": 10,
      "heart": 9,
      "emotional": 10
    }
  },
  {
    "id": 10,
    "title": "The Thursday Murder Club",
    "author": "Richard Osman",
    "publicationYear": 2020,
    "series": {
      "name": "Thursday Murder Club",
      "position": 1
    },
    "isbn": "1984880985",
    "googleBooksId": "placeholder10",
    "image": "https://books.google.com/books/content?id=yxWgDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "In a peaceful retirement village, four unlikely friends meet weekly to investigate unsolved killings. But when a local developer is found dead with a mysterious photograph next to his body, the Thursday Murder Club suddenly find themselves in the middle of their first live case.",
    "rating": 3.86,
    "ratingsCount": 783698,
    "pageCount": 382,
    "awards": [
      "Barry Award Best First Novel Nominee (2021)",
      "Anthony Award Best First Novel Nominee (2021)",
      "ITW Thriller Award Hardcover Novel Nominee (2021)",
      "Edgar Award Best Novel Nominee (2021)"
    ],
    "categories": [
      "Mystery",
      "Contemporary Fiction",
      "Humor"
    ],
    "scores": {
      "mystery": 10,
      "contemporary": 8,
      "character": 10,
      "medium": 8,
      "optimistic": 9,
      "plot": 9,
      "series": 8,
      "modern": 10,
      "heart": 9,
      "emotional": 7
    }
  },
  {
    "id": 12,
    "title": "Dune",
    "author": "Frank Herbert",
    "publicationYear": 1965,
    "series": {
      "name": "Dune",
      "position": 1
    },
    "isbn": "0441172717",
    "googleBooksId": "placeholder12",
    "image": "https://books.google.com/books/content?id=B1hSG45JCX4C&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "Set on the desert planet Arrakis, Dune is the story of Paul Atreides—who would become known as Muad'Dib. Paul's family is thrust into a treacherous political landscape where every decision can be deadly. With the universe's most precious resource at stake, Paul must navigate prophecy, politics, and spice.",
    "rating": 4.29,
    "ratingsCount": 1632478,
    "pageCount": 658,
    "awards": [
      "Hugo Award Best Novel (1966)",
      "Nebula Award Best Novel (1965)",
      "Seiun Award Best Foreign Novel (1974)"
    ],
    "categories": [
      "Science Fiction",
      "Fantasy",
      "Classic"
    ],
    "scores": {
      "scifi": 10,
      "fantasy": 7,
      "literary": 9,
      "character": 8,
      "slow": 7,
      "dark": 7,
      "atmosphere": 10,
      "series": 10,
      "classic": 10,
      "mind": 9,
      "emotional": 6
    }
  },
  {
    "id": 13,
    "title": "The Psychology of Money",
    "author": "Morgan Housel",
    "publicationYear": 2020,
    "isbn": "0857197681",
    "googleBooksId": "placeholder13",
    "image": "https://books.google.com/books/content?id=TnrrDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "Doing well with money isn't necessarily about what you know. It's about how you behave. And behavior is hard to teach. This book is a collection of 19 short stories exploring the strange ways people think about money and teaches you how to make better sense of one of life's most important matters.",
    "rating": 4.28,
    "ratingsCount": 324556,
    "pageCount": 242,
    "categories": [
      "Business",
      "Nonfiction",
      "Finance"
    ],
    "scores": {
      "nonfiction": 10,
      "selfhelp": 7,
      "character": 2,
      "fast": 8,
      "optimistic": 7,
      "plot": 2,
      "standalone": 10,
      "modern": 10,
      "mind": 10,
      "emotional": 5
    }
  },
  {
    "id": 14,
    "title": "The Song of Achilles",
    "author": "Madeline Miller",
    "publicationYear": 2011,
    "isbn": "0062060627",
    "googleBooksId": "placeholder14",
    "image": "https://books.google.com/books/content?id=E_ckQN0nDM0C&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "Achilles, 'the best of all the Greeks,' is everything Patroclus is not—strong, beautiful, the child of a goddess—and by all rights their paths should never cross. Yet one day, Achilles takes the shamed prince under his wing and soon their bond blooms into something far deeper.",
    "rating": 4.3,
    "ratingsCount": 1999861,
    "pageCount": 408,
    "awards": [
      "Orange Prize Fiction (2012)",
      "Stonewall Book Award Literature (2013)",
      "Chautauqua Prize (2013)",
      "Gaylactic Spectrum Award Best Novel (2013)"
    ],
    "categories": [
      "Fantasy",
      "Historical Fiction",
      "LGBTQ+",
      "Literary Fiction"
    ],
    "scores": {
      "fantasy": 8,
      "historical": 10,
      "literary": 10,
      "character": 10,
      "medium": 7,
      "dark": 8,
      "atmosphere": 10,
      "standalone": 10,
      "classic": 8,
      "heart": 10,
      "emotional": 10
    }
  },
  {
    "id": 15,
    "title": "Verity",
    "author": "Colleen Hoover",
    "publicationYear": 2018,
    "isbn": "1791392792",
    "googleBooksId": "placeholder15",
    "image": "https://books.google.com/books/content?id=zL6EDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "Lowen Ashleigh is a struggling writer hired to complete the remaining books in a successful series. While gathering notes from the author's home, she discovers an unfinished autobiography containing bone-chilling admissions, including Verity's recollection of the night her family was forever altered.",
    "rating": 4.3,
    "ratingsCount": 3833306,
    "pageCount": 336,
    "awards": [
      "British Book Award Pageturner (2023)",
      "Goodreads Choice Award Nominee Romance (2019)"
    ],
    "categories": [
      "Thriller",
      "Romance",
      "Mystery"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 9,
      "contemporary": 8,
      "character": 8,
      "fast": 10,
      "dark": 10,
      "plot": 10,
      "standalone": 10,
      "modern": 10,
      "mind": 8,
      "emotional": 8
    }
  },
  {
    "id": 16,
    "title": "The House in the Cerulean Sea",
    "author": "TJ Klune",
    "publicationYear": 2020,
    "series": {
      "name": "Cerulean Chronicles",
      "position": 1
    },
    "isbn": "1250217318",
    "googleBooksId": "placeholder16",
    "image": "https://books.google.com/books/content?id=FV2CDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "Linus Baker leads a quiet life. Then he's summoned by Extremely Upper Management and given a curious assignment: travel to an orphanage where six dangerous children reside. Linus must determine whether they could bring about the end of the world. But there's a surprise: he finds a family.",
    "rating": 4.36,
    "ratingsCount": 979535,
    "pageCount": 394,
    "awards": [
      "Mythopoeic Fantasy Award Adult Literature (2021)",
      "ALA Alex Award (2021)",
      "Goodreads Choice Award Fantasy (2020)"
    ],
    "categories": [
      "Fantasy",
      "LGBTQ+",
      "Contemporary"
    ],
    "scores": {
      "fantasy": 9,
      "contemporary": 8,
      "character": 10,
      "medium": 7,
      "optimistic": 10,
      "heart": 10,
      "standalone": 10,
      "modern": 10,
      "mind": 6,
      "emotional": 9
    }
  },
  {
    "id": 17,
    "title": "Circe",
    "author": "Madeline Miller",
    "publicationYear": 2018,
    "isbn": "0316556343",
    "googleBooksId": "placeholder17",
    "image": "https://books.google.com/books/content?id=W6j2swEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In the house of Helios, god of the sun and mightiest of the Titans, a daughter is born. Circe is a strange child, scorned and rejected. When she discovers her power of witchcraft, she is banished to a deserted island. There she learns to harness her power and choose her destiny.",
    "rating": 4.22,
    "ratingsCount": 1355848,
    "pageCount": 393,
    "awards": [
      "Women's Prize for Fiction (2019)",
      "Mythopoeic Fantasy Award Adult Literature (2019)",
      "Goodreads Choice Award Fantasy (2018)",
      "Book of the Month Book of the Year Award (2018)"
    ],
    "categories": [
      "Fantasy",
      "Historical Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "fantasy": 9,
      "historical": 9,
      "literary": 10,
      "character": 10,
      "medium": 6,
      "dark": 7,
      "atmosphere": 10,
      "standalone": 10,
      "classic": 7,
      "heart": 8,
      "emotional": 9
    }
  },
  {
    "id": 18,
    "title": "The Invisible Life of Addie LaRue",
    "author": "V.E. Schwab",
    "publicationYear": 2020,
    "isbn": "0765387565",
    "googleBooksId": "placeholder18",
    "image": "https://books.google.com/books/content?id=WF5gDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "France, 1714. Addie LaRue makes a Faustian bargain to live forever but is cursed to be forgotten by everyone she meets. Until, after nearly 300 years, she stumbles across a young man in a hidden bookshop, and he remembers her name.",
    "rating": 4.16,
    "ratingsCount": 1514531,
    "pageCount": 448,
    "awards": [
      "Locus Award Best Fantasy Novel (2021)",
      "Goodreads Choice Award Fantasy (2020)",
      "Book of the Month Book of the Year Award (2020)"
    ],
    "categories": [
      "Fantasy",
      "Historical Fiction",
      "Romance"
    ],
    "scores": {
      "fantasy": 10,
      "historical": 8,
      "literary": 9,
      "character": 10,
      "slow": 7,
      "dark": 6,
      "atmosphere": 10,
      "standalone": 10,
      "modern": 10,
      "heart": 9,
      "emotional": 10
    }
  },
  {
    "id": 19,
    "title": "11/22/63",
    "author": "Stephen King",
    "publicationYear": 2011,
    "isbn": "1451627289",
    "googleBooksId": "placeholder19",
    "image": "https://books.google.com/books/content?id=LdmODQAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "Jake Epping, a thirty-five-year-old English teacher, travels back to 1958 and sets out to prevent the Kennedy assassination. But history doesn't want to be changed, and Jake becomes enmeshed in a dangerous race against time itself.",
    "rating": 4.35,
    "ratingsCount": 657022,
    "pageCount": 849,
    "awards": [
      "Locus Award Best SF Novel (2012)",
      "World Fantasy Award Best Novel (2012)",
      "ITW Thriller Award Best Hard Cover Novel (2012)",
      "British Fantasy Award Best Novel (2012)",
      "Goodreads Choice Award Science Fiction (2011)"
    ],
    "categories": [
      "Science Fiction",
      "Thriller",
      "Historical Fiction"
    ],
    "scores": {
      "scifi": 7,
      "thriller": 9,
      "historical": 9,
      "character": 8,
      "slow": 5,
      "dark": 7,
      "plot": 10,
      "series": 0,
      "standalone": 10,
      "classic": 7,
      "mind": 8,
      "emotional": 8
    }
  },
  {
    "id": 20,
    "title": "The Martian",
    "author": "Andy Weir",
    "publicationYear": 2011,
    "series": {
      "name": "The Martian",
      "position": 1
    },
    "isbn": "0553418025",
    "googleBooksId": "placeholder20",
    "image": "https://books.google.com/books/content?id=1g-FAwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "Six days ago, astronaut Mark Watney became one of the first people to walk on Mars. Now, he's sure he'll be the first person to die there. After a dust storm nearly kills him, Watney finds himself stranded and completely alone with no way to signal Earth. He must rely on his ingenuity to survive.",
    "rating": 4.42,
    "ratingsCount": 1290693,
    "pageCount": 369,
    "awards": [
      "John W. Campbell Memorial Award Best Science Fiction Novel (2015)",
      "Audie Award Science Fiction (2015)",
      "ALA Alex Award (2015)",
      "Goodreads Choice Award Science Fiction (2014)"
    ],
    "categories": [
      "Science Fiction",
      "Thriller"
    ],
    "scores": {
      "scifi": 10,
      "thriller": 8,
      "character": 9,
      "fast": 9,
      "optimistic": 9,
      "plot": 10,
      "standalone": 10,
      "modern": 10,
      "mind": 9,
      "emotional": 6
    }
  },
  {
    "id": 21,
    "title": "Born a Crime",
    "author": "Trevor Noah",
    "publicationYear": 2016,
    "isbn": "0399588191",
    "googleBooksId": "placeholder21",
    "image": "https://books.google.com/books/content?id=nHNvDQAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "Trevor Noah's unlikely path from apartheid South Africa to the desk of The Daily Show began with a criminal act: his birth. Born to a white Swiss father and a black Xhosa mother at a time when such a union was punishable by five years in prison, Trevor was kept mostly indoors for the first years of his life.",
    "rating": 4.49,
    "ratingsCount": 809656,
    "pageCount": 289,
    "awards": [
      "NAACP Image Award Debut Author and Biography/Auto-biography (2017)",
      "Thurber Prize American Humor (2017)",
      "Pennsylvania Young Readers' Choice Award Young Adult (2018)",
      "Lincoln Award (2019)"
    ],
    "categories": [
      "Memoir",
      "Biography",
      "Humor"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "character": 10,
      "medium": 7,
      "optimistic": 7,
      "dark": 6,
      "standalone": 10,
      "modern": 10,
      "heart": 9,
      "emotional": 9
    }
  },
  {
    "id": 22,
    "title": "The Subtle Art of Not Giving a F*ck",
    "author": "Mark Manson",
    "publicationYear": 2016,
    "series": {
      "name": "Mark Manson Collection",
      "position": 1
    },
    "isbn": "0062457713",
    "googleBooksId": "placeholder22",
    "image": "https://books.google.com/books/content?id=yng_CwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "For decades we've been told that positive thinking is the key to a happy, rich life. Mark Manson doesn't sugar-coat or equivocate. Instead, he's going to tell you that life is tough and we should get used to it. In this candid and funny book, he shows us that the key to a better life is caring less.",
    "rating": 3.86,
    "ratingsCount": 1414892,
    "pageCount": 212,
    "categories": [
      "Self-Help",
      "Nonfiction",
      "Psychology"
    ],
    "scores": {
      "nonfiction": 10,
      "selfhelp": 10,
      "character": 3,
      "fast": 9,
      "optimistic": 6,
      "plot": 2,
      "standalone": 10,
      "modern": 10,
      "mind": 8,
      "emotional": 5
    }
  },
  {
    "id": 23,
    "title": "Normal People",
    "author": "Sally Rooney",
    "publicationYear": 2018,
    "isbn": "1984822187",
    "googleBooksId": "placeholder23",
    "image": "https://books.google.com/books/content?id=F7lhDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "Connell and Marianne grow up in the same small town in the west of Ireland, but the similarities end there. In school, Connell is popular while Marianne is a loner. But when they both earn places at Trinity College, a connection that has grown between them lasts long into the following years.",
    "rating": 3.81,
    "ratingsCount": 1876602,
    "pageCount": 273,
    "awards": [
      "Booker Prize Longlist (2018)",
      "British Book Award Book of the Year (2019)",
      "Costa Book Award Novel (2018)",
      "Goodreads Choice Award Fiction (2019)"
    ],
    "categories": [
      "Contemporary Fiction",
      "Literary Fiction",
      "Romance"
    ],
    "scores": {
      "contemporary": 10,
      "literary": 10,
      "character": 10,
      "medium": 6,
      "dark": 6,
      "atmosphere": 8,
      "standalone": 10,
      "modern": 10,
      "heart": 8,
      "emotional": 10
    }
  },
  {
    "id": 24,
    "title": "The Nightingale",
    "author": "Kristin Hannah",
    "publicationYear": 2015,
    "isbn": "0312577222",
    "googleBooksId": "placeholder24",
    "image": "https://books.google.com/books/content?id=gEe8AAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "France, 1939. In the quiet village of Carriveau, Vianne Mauriac says goodbye to her husband as he heads for the Front. She doesn't believe that the Nazis will invade France but soon she is forced to take an enemy into her house. But Vianne's younger sister Isabelle is living in Paris and is determined to fight the enemy.",
    "rating": 4.65,
    "ratingsCount": 2129076,
    "pageCount": 564,
    "awards": [
      "Audie Award Fiction (2016)",
      "Goodreads Choice Award Historical Fiction (2015)",
      "Dublin Literary Award (2017)",
      "RUSA CODES Reading List Historical Fiction (2016)"
    ],
    "categories": [
      "Historical Fiction",
      "War"
    ],
    "scores": {
      "historical": 10,
      "literary": 8,
      "character": 10,
      "medium": 6,
      "dark": 8,
      "atmosphere": 9,
      "standalone": 10,
      "classic": 6,
      "heart": 10,
      "emotional": 10
    }
  },
  {
    "id": 25,
    "title": "Red Rising",
    "author": "Pierce Brown",
    "publicationYear": 2014,
    "series": {
      "name": "Red Rising Saga",
      "position": 1
    },
    "isbn": "0345539788",
    "googleBooksId": "placeholder25",
    "image": "https://books.google.com/books/content?id=bBxWAgAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "Darrow is a Red, a member of the lowest caste in the color-coded society of the future. Like his fellow Reds, he works all day, believing that he and his people are making the surface of Mars livable for future generations. Yet he discovers that humanity already reached the surface generations ago.",
    "rating": 4.27,
    "ratingsCount": 787917,
    "pageCount": 382,
    "awards": [
      "Audie Award Audio Drama (2024)",
      "Goodreads Choice Award Debut Author (2014)",
      "Gateway Readers Award (2017)"
    ],
    "categories": [
      "Science Fiction",
      "Dystopian",
      "Fantasy"
    ],
    "scores": {
      "scifi": 10,
      "fantasy": 7,
      "thriller": 8,
      "character": 8,
      "fast": 10,
      "dark": 9,
      "plot": 10,
      "series": 10,
      "modern": 10,
      "mind": 7,
      "emotional": 7
    }
  },
  {
    "id": 26,
    "title": "The Lincoln Highway",
    "author": "Amor Towles",
    "publicationYear": 2021,
    "isbn": "0735222355",
    "googleBooksId": "placeholder26",
    "image": "https://books.google.com/books/content?id=sJbiDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "In June 1954, eighteen-year-old Emmett Watson is driven home to Nebraska by the warden of the juvenile work farm where he has just served fifteen months for involuntary manslaughter. But when the warden drives away, Emmett discovers that two friends from the work farm have hidden themselves in the trunk of the warden's car.",
    "rating": 4.22,
    "ratingsCount": 312845,
    "pageCount": 576,
    "awards": [
      "Goodreads Choice Award Nominee Historical Fiction (2021)",
      "Book of the Month Book of the Year Award (2022)"
    ],
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "historical": 9,
      "literary": 10,
      "contemporary": 7,
      "character": 10,
      "medium": 5,
      "optimistic": 7,
      "atmosphere": 10,
      "standalone": 10,
      "classic": 7,
      "heart": 8,
      "emotional": 8
    }
  },
  {
    "id": 27,
    "title": "The Code Breaker",
    "author": "Walter Isaacson",
    "publicationYear": 2021,
    "isbn": "1982115858",
    "googleBooksId": "placeholder27",
    "image": "https://books.google.com/books/content?id=BrnwDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "When Jennifer Doudna was in sixth grade, she came home one day to find that her dad had left a paperback on her bed. She put it aside, thinking it was one of those detective tales she loved. On a rainy Saturday, she cracked it open and was enthralled by the story of the double helix.",
    "rating": 4.28,
    "ratingsCount": 41314,
    "pageCount": 560,
    "awards": [
      "Goodreads Choice Award History & Biography Nominee (2021)"
    ],
    "categories": [
      "Biography",
      "Science",
      "Nonfiction"
    ],
    "scores": {
      "nonfiction": 10,
      "memoir": 7,
      "character": 8,
      "medium": 6,
      "optimistic": 7,
      "standalone": 10,
      "modern": 10,
      "mind": 10,
      "emotional": 6,
      "plot": 5
    }
  },
  {
    "id": 28,
    "title": "A Gentleman in Moscow",
    "author": "Amor Towles",
    "publicationYear": 2016,
    "isbn": "0670026190",
    "googleBooksId": "placeholder28",
    "image": "https://books.google.com/books/content?id=UkGXCwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "In 1922, Count Alexander Rostov is deemed an unrepentant aristocrat by a Bolshevik tribunal and is sentenced to house arrest in the Metropol, a grand hotel across the street from the Kremlin. Rostov has never worked a day in his life, and must now live in an attic room while some of the most tumultuous decades in Russian history unfold outside the hotel's doors.",
    "rating": 4.32,
    "ratingsCount": 670092,
    "pageCount": 495,
    "awards": [
      "Kirkus Prize Fiction (2016)",
      "Goodreads Choice Award Historical Fiction (2016)"
    ],
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "historical": 10,
      "literary": 10,
      "character": 10,
      "slow": 6,
      "optimistic": 8,
      "atmosphere": 10,
      "standalone": 10,
      "classic": 8,
      "heart": 9,
      "emotional": 8
    }
  },
  {
    "id": 29,
    "title": "The Goldfinch",
    "author": "Donna Tartt",
    "publicationYear": 2013,
    "isbn": "0316055433",
    "googleBooksId": "placeholder29",
    "image": "https://books.google.com/books/content?id=TpRMAAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "Theo Decker survives an accident that kills his mother. Alone and determined to avoid being taken in by the city, Theo turfs himself to an affluent family. Theo is tormented by longing for his mother and down the years he clings to the one thing that reminds him of her: a small, captivating painting.",
    "rating": 3.96,
    "ratingsCount": 1043486,
    "pageCount": 771,
    "awards": [
      "Pulitzer Prize for Fiction (2014)",
      "Andrew Carnegie Medal for Fiction (2014)",
      "Goodreads Choice Award Fiction (2013)"
    ],
    "categories": [
      "Literary Fiction",
      "Contemporary Fiction"
    ],
    "scores": {
      "literary": 10,
      "contemporary": 9,
      "character": 10,
      "slow": 8,
      "dark": 8,
      "atmosphere": 10,
      "standalone": 10,
      "modern": 8,
      "mind": 8,
      "emotional": 9
    }
  },
  {
    "id": 30,
    "title": "Becoming",
    "author": "Michelle Obama",
    "publicationYear": 2018,
    "isbn": "1524763136",
    "googleBooksId": "placeholder30",
    "image": "https://books.google.com/books/content?id=hivSDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "In her memoir, former First Lady Michelle Obama invites readers into her world, chronicling the experiences that have shaped her—from her childhood on the South Side of Chicago to her years as an executive balancing the demands of motherhood and work, to her time spent at the world's most famous address.",
    "rating": 4.43,
    "ratingsCount": 1201057,
    "pageCount": 448,
    "awards": [
      "Audie Award Autobiography/Memoir (2020)",
      "Los Angeles Times Book Prize Current Interest (2018)",
      "Grammy Award Best Spoken Word Album (2020)",
      "Goodreads Choice Award Memoir & Autobiography (2018)",
      "NAACP Image Award Biography/Autobiography (2019)"
    ],
    "categories": [
      "Memoir",
      "Biography",
      "Nonfiction"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "character": 10,
      "medium": 6,
      "optimistic": 9,
      "standalone": 10,
      "modern": 10,
      "heart": 10,
      "emotional": 10,
      "plot": 5
    }
  },
  {
    "id": 31,
    "title": "The Poppy War",
    "author": "R.F. Kuang",
    "publicationYear": 2018,
    "series": {
      "name": "The Poppy War",
      "position": 1
    },
    "isbn": "0062662562",
    "googleBooksId": "placeholder31",
    "image": "https://books.google.com/books/content?id=h1UxDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "When Rin aced the Keju—the Empire-wide test to find the most talented youth to learn at the Academies—it was a shock to everyone: to the test officials, who couldn't believe a war orphan from Rooster Province could pass without cheating; to Rin's guardians, who had hoped to get rich selling her.",
    "rating": 4.16,
    "ratingsCount": 487193,
    "pageCount": 545,
    "awards": [
      "Nebula Award Best Novel Nominee (2018)",
      "Locus Award First Novel (2019)",
      "World Fantasy Award Best Novel Nominee (2019)",
      "Compton Crook Award (2019)",
      "British Fantasy Award Best Newcomer (2019)",
      "Goodreads Choice Award Fantasy Nominee (2018)",
      "Reddit Stabby Award Best Debut Novel (2018)"
    ],
    "categories": [
      "Fantasy",
      "War",
      "Historical Fiction"
    ],
    "scores": {
      "fantasy": 10,
      "historical": 8,
      "character": 9,
      "fast": 8,
      "dark": 10,
      "atmosphere": 9,
      "series": 10,
      "modern": 10,
      "mind": 7,
      "emotional": 8
    }
  },
  {
    "id": 33,
    "title": "Untamed",
    "author": "Glennon Doyle",
    "publicationYear": 2020,
    "isbn": "1984801252",
    "googleBooksId": "placeholder33",
    "image": "https://books.google.com/books/content?id=fVmyDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "There is a voice of longing inside each woman. We strive so mightily to be good: good partners, daughters, mothers, employees, and friends. We hope all this striving will make us feel alive. Instead, it leaves us feeling weary, stuck, overwhelmed, and underwhelmed. Glennon Doyle shows us how to find our way back to ourselves.",
    "rating": 3.98,
    "ratingsCount": 516201,
    "pageCount": 333,
    "awards": [
      "Goodreads Choice Award Nominee for Memoir & Autobiography (2020)"
    ],
    "categories": [
      "Self-Help",
      "Memoir",
      "Nonfiction"
    ],
    "scores": {
      "memoir": 8,
      "nonfiction": 10,
      "selfhelp": 10,
      "character": 9,
      "medium": 7,
      "optimistic": 9,
      "standalone": 10,
      "modern": 10,
      "heart": 10,
      "emotional": 10
    }
  },
  {
    "id": 34,
    "title": "The Way of Kings",
    "author": "Brandon Sanderson",
    "publicationYear": 2010,
    "series": {
      "name": "The Stormlight Archive",
      "position": 1
    },
    "isbn": "0765326353",
    "googleBooksId": "placeholder34",
    "image": "https://books.google.com/books/content?id=vhKs9AEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Roshar is a world of stone and storms. Uncanny tempests of incredible power sweep across the rocky terrain. It has been centuries since the fall of the ten consecrated orders known as the Knights Radiant, but their Shardblades and Shardplate remain. Men trade kingdoms for Shardblades.",
    "rating": 4.66,
    "ratingsCount": 673308,
    "pageCount": 1007,
    "awards": [
      "Locus Award Best Fantasy Novel (2011)",
      "David Gemmell Legend Award (2011)"
    ],
    "categories": [
      "Fantasy",
      "Epic"
    ],
    "scores": {
      "fantasy": 10,
      "literary": 7,
      "character": 9,
      "slow": 7,
      "dark": 7,
      "atmosphere": 10,
      "series": 10,
      "modern": 10,
      "mind": 9,
      "emotional": 7
    }
  },
  {
    "id": 35,
    "title": "Thinking, Fast and Slow",
    "author": "Daniel Kahneman",
    "publicationYear": 2011,
    "isbn": "0374533555",
    "googleBooksId": "placeholder35",
    "image": "https://books.google.com/books/content?id=ZuKTvERuPG8C&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "In this groundbreaking tour de force, Daniel Kahneman takes us on a tour of the mind and explains the two systems that drive the way we think. System 1 is fast, intuitive, and emotional; System 2 is slower, more deliberative, and more logical. Kahneman exposes the extraordinary capabilities—and also the faults and biases—of fast thinking.",
    "rating": 4.17,
    "ratingsCount": 590888,
    "pageCount": 499,
    "awards": [
      "Los Angeles Times Book Prize Current Interest (2011)",
      "Best Book of Ideas Prize (2012)",
      "Andrew Carnegie Medal Nonfiction (2012)"
    ],
    "categories": [
      "Psychology",
      "Nonfiction",
      "Science"
    ],
    "scores": {
      "nonfiction": 10,
      "character": 2,
      "medium": 5,
      "optimistic": 6,
      "plot": 3,
      "standalone": 10,
      "modern": 9,
      "mind": 10,
      "emotional": 4,
      "accessible": 7
    }
  },
  {
    "id": 37,
    "title": "The Vanishing Half",
    "author": "Brit Bennett",
    "publicationYear": 2020,
    "isbn": "0525536299",
    "googleBooksId": "placeholder37",
    "image": "https://books.google.com/books/content?id=9oDoDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "The Vignes twin sisters will always be identical. But after growing up together in a small, southern black community and running away at age sixteen, it's not just the shape of their daily lives that is different as adults, it's everything: their families, their communities, their racial identities.",
    "rating": 4.12,
    "ratingsCount": 857566,
    "pageCount": 343,
    "awards": [
      "Goodreads Choice Award Historical Fiction (2020)",
      "Women's Prize for Fiction Shortlist (2021)",
      "NAACP Image Award Fiction (2021)",
      "Barnes & Noble Book of the Year Award (2020)"
    ],
    "categories": [
      "Contemporary Fiction",
      "Historical Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "contemporary": 9,
      "historical": 8,
      "literary": 10,
      "character": 10,
      "medium": 6,
      "dark": 7,
      "atmosphere": 9,
      "standalone": 10,
      "modern": 10,
      "heart": 8,
      "emotional": 10
    }
  },
  {
    "id": 38,
    "title": "The Institute",
    "author": "Stephen King",
    "publicationYear": 2019,
    "isbn": "1982110562",
    "googleBooksId": "placeholder38",
    "image": "https://books.google.com/books/content?id=W5aYDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "In the middle of the night, in a house on a quiet street in suburban Minneapolis, intruders silently murder Luke Ellis's parents and load him into a black SUV. Luke will wake up at The Institute, in a room that looks just like his own, except there's no window. And outside his door are other doors, behind which are other kids with special talents.",
    "rating": 4.19,
    "ratingsCount": 343132,
    "pageCount": 561,
    "awards": [
      "Goodreads Choice Award Horror (2019)",
      "Locus Award Best Horror Novel (2020)",
      "Audie Award Thriller/Suspense (2020)",
      "British Fantasy Award Best Horror Novel (2020)"
    ],
    "categories": [
      "Thriller",
      "Science Fiction",
      "Horror"
    ],
    "scores": {
      "thriller": 10,
      "scifi": 7,
      "character": 8,
      "fast": 9,
      "dark": 9,
      "plot": 10,
      "standalone": 10,
      "modern": 10,
      "mind": 7,
      "emotional": 7
    }
  },
  {
    "id": 39,
    "title": "Eleanor Oliphant Is Completely Fine",
    "author": "Gail Honeyman",
    "publicationYear": 2017,
    "isbn": "0735220689",
    "googleBooksId": "placeholder39",
    "image": "https://books.google.com/books/content?id=Cz8_DgAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "Eleanor Oliphant has learned how to survive—but not how to live. She struggles with appropriate social skills and tends to say exactly what she's thinking. Nothing is missing in her carefully timetabled life of avoiding unnecessary human contact, where weekends are punctuated by frozen pizza, vodka, and phone chats with Mummy.",
    "rating": 4.23,
    "ratingsCount": 1430330,
    "pageCount": 390,
    "awards": [
      "British Book Award Book of the Year (2018)",
      "Costa Book Award First Novel (2017)",
      "Audie Award Fiction (2018)",
      "Women's Prize for Fiction Longlist (2018)",
      "Goodreads Choice Award Fiction (2017)"
    ],
    "categories": [
      "Contemporary Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "contemporary": 10,
      "literary": 8,
      "character": 10,
      "medium": 6,
      "optimistic": 8,
      "atmosphere": 8,
      "standalone": 10,
      "modern": 10,
      "heart": 10,
      "emotional": 10
    }
  },
  {
    "id": 40,
    "title": "Pachinko",
    "author": "Min Jin Lee",
    "publicationYear": 2017,
    "isbn": "1455563927",
    "googleBooksId": "placeholder40",
    "image": "https://books.google.com/books/content?id=EqNjDQAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "In the early 1900s, teenaged Sunja becomes pregnant by a married yakuza and accepts an offer of marriage from a gentle minister passing through on his way to Japan. Sunja and her family will endure struggles and triumphs across four generations, through wars, wealth, and the fight to maintain their dignity.",
    "rating": 4.34,
    "ratingsCount": 629284,
    "pageCount": 496,
    "awards": [
      "National Book Award Fiction Finalist (2017)",
      "Goodreads Choice Award Historical Fiction (2017)",
      "Dayton Literary Peace Prize Fiction (2018)",
      "Dublin Literary Award (2019)"
    ],
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "historical": 10,
      "literary": 10,
      "character": 10,
      "medium": 5,
      "dark": 7,
      "atmosphere": 10,
      "standalone": 10,
      "classic": 7,
      "heart": 9,
      "emotional": 10
    }
  },
  {
    "id": 41,
    "title": "The Alchemist",
    "author": "Paulo Coelho",
    "publicationYear": 1988,
    "isbn": "0062315005",
    "googleBooksId": "placeholder41",
    "image": "https://books.google.com/books/content?id=FzVjBgAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "Paulo Coelho's masterpiece tells the mystical story of Santiago, an Andalusian shepherd boy who yearns to travel in search of a worldly treasure. His quest will lead him to riches far different—and far more satisfying—than he ever imagined. The story of the treasures we seek and the treasures we find.",
    "rating": 3.92,
    "ratingsCount": 3583440,
    "pageCount": 182,
    "awards": [
      "NBDB National Book Awards Translation (2015)",
      "Grand Prix des lectrices de Elle roman (1995)",
      "Premio Grinzane Cavour Narrativa Straniera (1996)",
      "Corine Internationaler Buchpreis Belletristik (2002)"
    ],
    "categories": [
      "Literary Fiction",
      "Fantasy",
      "Philosophy"
    ],
    "scores": {
      "literary": 9,
      "fantasy": 6,
      "character": 8,
      "medium": 7,
      "optimistic": 10,
      "atmosphere": 9,
      "standalone": 10,
      "classic": 9,
      "mind": 8,
      "heart": 9,
      "emotional": 8
    }
  },
  {
    "id": 43,
    "title": "The Tattooist of Auschwitz",
    "author": "Heather Morris",
    "publicationYear": 2018,
    "series": {
      "name": "The Tattooist of Auschwitz",
      "position": 1
    },
    "isbn": "0062797158",
    "googleBooksId": "placeholder43",
    "image": "https://books.google.com/books/content?id=fVpBDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "In 1942, Lale Sokolov arrived in Auschwitz-Birkenau. He was given the job of tattooing the prisoners marked for survival. One day he meets Gita, and falls in love. Based on the true story of Lale and Gita Sokolov, this is a testament to the endurance of love and humanity under the darkest possible circumstances.",
    "rating": 4.32,
    "ratingsCount": 1170762,
    "pageCount": 272,
    "awards": [
      "Audie Award Fiction (2019)",
      "Goodreads Choice Award Historical Fiction (2018)",
      "Goodreads Choice Award Debut Author (2018)"
    ],
    "categories": [
      "Historical Fiction",
      "War",
      "Romance"
    ],
    "scores": {
      "historical": 10,
      "character": 9,
      "medium": 7,
      "dark": 9,
      "atmosphere": 9,
      "standalone": 10,
      "classic": 6,
      "heart": 10,
      "emotional": 10,
      "plot": 5
    }
  },
  {
    "id": 44,
    "title": "The Four Winds",
    "author": "Kristin Hannah",
    "publicationYear": 2021,
    "isbn": "1250178606",
    "googleBooksId": "placeholder44",
    "image": "https://books.google.com/books/content?id=9BbjDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "Texas, 1934. The earth is in drought, cruel winds erode the land, and people are struggling to survive. Elsa must choose between fighting for the land she loves or heading west to California in search of a better life. An epic story of love, heroism, and the American Dream.",
    "rating": 4.3,
    "ratingsCount": 990937,
    "pageCount": 464,
    "awards": [
      "Goodreads Choice Award Nominee Historical Fiction (2021)",
      "Book of the Month Book of the Year Award (2021)"
    ],
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "historical": 10,
      "literary": 8,
      "character": 10,
      "medium": 6,
      "dark": 8,
      "atmosphere": 10,
      "standalone": 10,
      "classic": 7,
      "heart": 10,
      "emotional": 10
    }
  },
  {
    "id": 45,
    "title": "Big Little Lies",
    "author": "Liane Moriarty",
    "publicationYear": 2014,
    "isbn": "0399587195",
    "googleBooksId": "placeholder45",
    "image": "https://books.google.com/books/content?id=U5ICAwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "Big Little Lies follows three women, each at a crossroads: Madeline is a force to be reckoned with. Celeste is the kind of beautiful woman who makes the world stop and stare. New to town, single mom Jane is so young that another mother mistakes her for a nanny. These three women are about to learn just how easy it is for one little lie to spiral out of control.",
    "rating": 4.31,
    "ratingsCount": 1118868,
    "pageCount": 460,
    "awards": [
      "Davitt Award Best Adult Novel (2015)",
      "Australian Book Industry Award General Fiction (2015)",
      "Goodreads Choice Award Fiction (2014)"
    ],
    "categories": [
      "Mystery",
      "Contemporary Fiction",
      "Thriller"
    ],
    "scores": {
      "mystery": 9,
      "contemporary": 10,
      "thriller": 7,
      "character": 10,
      "fast": 8,
      "dark": 7,
      "plot": 9,
      "standalone": 10,
      "modern": 10,
      "heart": 7,
      "emotional": 8
    }
  },
  {
    "id": 46,
    "title": "The Giver of Stars",
    "author": "Jojo Moyes",
    "publicationYear": 2019,
    "isbn": "0399562486",
    "googleBooksId": "placeholder46",
    "image": "https://books.google.com/books/content?id=lPR4DwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "England, 1937. Alice Wright doesn't love her new American husband. Nor her domineering father-in-law or the judgmental townspeople of Baileyville, Kentucky. Lonely and trapped, she's taken a job delivering books to the isolated residents of the mountains. Though she doesn't know it yet, her life is about to change.",
    "rating": 4.29,
    "ratingsCount": 509925,
    "pageCount": 390,
    "awards": [
      "Goodreads Choice Award Historical Fiction Nominee (2019)"
    ],
    "categories": [
      "Historical Fiction",
      "Romance"
    ],
    "scores": {
      "historical": 10,
      "character": 9,
      "medium": 6,
      "optimistic": 8,
      "atmosphere": 9,
      "standalone": 10,
      "classic": 6,
      "heart": 10,
      "emotional": 9,
      "plot": 5
    }
  },
  {
    "id": 47,
    "title": "Six of Crows",
    "author": "Leigh Bardugo",
    "publicationYear": 2015,
    "series": {
      "name": "Six of Crows",
      "position": 1
    },
    "isbn": "1627792120",
    "googleBooksId": "placeholder47",
    "image": "https://books.google.com/books/content?id=P9ZoCAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "Ketterdam: a bustling hub of international trade where anything can be had for the right price—and no one knows that better than criminal prodigy Kaz Brekker. Kaz is offered a chance at a deadly heist that could make him rich beyond his wildest dreams. But he can't pull it off alone.",
    "rating": 4.46,
    "ratingsCount": 1157164,
    "pageCount": 480,
    "awards": [
      "Goodreads Choice Award Young Adult Fantasy & Science Fiction (2015)"
    ],
    "categories": [
      "Fantasy",
      "Young Adult"
    ],
    "scores": {
      "fantasy": 10,
      "thriller": 8,
      "character": 10,
      "fast": 9,
      "dark": 8,
      "plot": 10,
      "series": 10,
      "modern": 10,
      "mind": 7,
      "emotional": 8
    }
  },
  {
    "id": 48,
    "title": "Shoe Dog",
    "author": "Phil Knight",
    "publicationYear": 2016,
    "isbn": "1501135910",
    "googleBooksId": "placeholder48",
    "image": "https://books.google.com/books/content?id=pCIlCwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "In this candid and riveting memoir, Phil Knight, the creator of Nike, shares the story of the company's early days as an intrepid start-up and its evolution into one of the world's most iconic, game-changing, and profitable brands. A refreshingly honest reminder of what the path to business success really looks like.",
    "rating": 4.46,
    "ratingsCount": 370606,
    "pageCount": 400,
    "awards": [
      "Goodreads Choice Award Memoir & Autobiography Nominee (2016)"
    ],
    "categories": [
      "Memoir",
      "Business",
      "Biography"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "character": 8,
      "medium": 7,
      "optimistic": 8,
      "standalone": 10,
      "modern": 9,
      "mind": 8,
      "heart": 7,
      "emotional": 7
    }
  },
  {
    "id": 49,
    "title": "Little Fires Everywhere",
    "author": "Celeste Ng",
    "publicationYear": 2017,
    "isbn": "0735224293",
    "googleBooksId": "placeholder49",
    "image": "https://books.google.com/books/content?id=JFcyDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "In Shaker Heights, a placid, progressive suburb of Cleveland, everything is planned—from the layout of the winding roads, to the colors of the houses. No one embodies this spirit more than Elena Richardson. But when Mia Warren and her daughter Pearl appear, they introduce art and disorder into Elena's carefully controlled world.",
    "rating": 4.07,
    "ratingsCount": 1316360,
    "pageCount": 338,
    "awards": [
      "Goodreads Choice Award Fiction (2017)",
      "NAACP Image Award Fiction (2018)",
      "Book of the Month Book of the Year Award (2017)"
    ],
    "categories": [
      "Contemporary Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "contemporary": 10,
      "literary": 9,
      "character": 10,
      "medium": 6,
      "dark": 7,
      "atmosphere": 9,
      "standalone": 10,
      "modern": 10,
      "heart": 7,
      "emotional": 9
    }
  },
  {
    "id": 50,
    "title": "Dark Matter",
    "author": "Blake Crouch",
    "publicationYear": 2016,
    "isbn": "1101904224",
    "googleBooksId": "placeholder50",
    "image": "https://books.google.com/books/content?id=hT9gCwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
    "synopsis": "Jason Dessen is walking home when he's abducted and wakes up in a world where his life is completely different. His wife isn't his wife. His son was never born. And somehow, he's become a celebrated genius who has achieved something impossible. Is it this world or the other that's the dream?",
    "rating": 4.13,
    "ratingsCount": 727789,
    "pageCount": 342,
    "awards": [
      "Goodreads Choice Award Nominee Science Fiction (2016)",
      "Book of the Month Book of the Year Award (2016)"
    ],
    "categories": [
      "Science Fiction",
      "Thriller"
    ],
    "scores": {
      "scifi": 10,
      "thriller": 10,
      "character": 8,
      "fast": 10,
      "dark": 7,
      "plot": 10,
      "standalone": 10,
      "modern": 10,
      "mind": 10,
      "emotional": 7
    }
  },
  {
    "id": 51,
    "title": "The Girl on the Train",
    "author": "Paula Hawkins",
    "publicationYear": 2015,
    "isbn": "1594634025",
    "googleBooksId": "placeholder51",
    "image": "https://books.google.com/books/content?id=SLVPEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Rachel takes the same commuter train every morning and night. Every day she rattles down the track, flashes past a stretch of cozy suburban homes, and stops at the signal that allows her to daily watch the same couple breakfasting on their deck. Until she sees something shocking. It's only a minute until the train moves on, but it's enough.",
    "rating": 3.96,
    "ratingsCount": 3297824,
    "pageCount": 336,
    "awards": [
      "Goodreads Choice Award Mystery & Thriller (2015)",
      "Waterstones Book of the Year (2015)"
    ],
    "categories": [
      "Thriller",
      "Mystery",
      "Psychological"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 9,
      "contemporary": 7,
      "character": 8,
      "fast": 9,
      "dark": 8,
      "plot": 10,
      "standalone": 10,
      "modern": 10,
      "mind": 6,
      "emotional": 7
    }
  },
  {
    "id": 52,
    "title": "The Woman in the Window",
    "author": "A.J. Finn",
    "publicationYear": 2018,
    "isbn": "0062678418",
    "googleBooksId": "placeholder52",
    "image": "http://books.google.com/books/content?id=bZpOtAEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Anna Fox lives alone—a recluse in her New York City home, unable to venture outside. She spends her day drinking wine, watching old movies, and spying on her neighbors. Then the Russells move in across the way: a picture-perfect family. But when Anna, sees something she shouldn't, her world begins to crumble.",
    "rating": 3.94,
    "ratingsCount": 888841,
    "pageCount": 455,
    "awards": [
      "Goodreads Choice Award Mystery & Thriller Nominee (2018)",
      "Goodreads Choice Award Debut Author Nominee (2018)",
      "Book of the Month Book of the Year Award Nominee (2018)"
    ],
    "categories": [
      "Thriller",
      "Mystery",
      "Psychological"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 10,
      "contemporary": 8,
      "character": 7,
      "fast": 8,
      "dark": 9,
      "plot": 10,
      "standalone": 10,
      "modern": 10,
      "mind": 7,
      "emotional": 6
    }
  },
  {
    "id": 55,
    "title": "The Couple Next Door",
    "author": "Shari Lapena",
    "publicationYear": 2016,
    "isbn": "0735221081",
    "googleBooksId": "placeholder55",
    "image": "https://books.google.com/books/content?id=669ZjwEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Anne and Marco Conti seem to have it all—a loving relationship, a wonderful home, and their beautiful baby, Cora. But one night when they are at a dinner party next door, a terrible crime is committed. Suspicion immediately focuses on the parents. But the truth is a much more complicated story.",
    "rating": 3.8,
    "ratingsCount": 714463,
    "pageCount": 308,
    "awards": [
      "Goodreads Choice Award Mystery & Thriller Nominee (2016)"
    ],
    "categories": [
      "Thriller",
      "Mystery",
      "Crime"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 9,
      "contemporary": 8,
      "character": 7,
      "fast": 10,
      "dark": 7,
      "plot": 10,
      "standalone": 10,
      "modern": 10,
      "mind": 6,
      "emotional": 7
    }
  },
  {
    "id": 56,
    "title": "The Kind Worth Killing",
    "author": "Peter Swanson",
    "publicationYear": 2015,
    "series": {
      "name": "Henry Kimball/Lily Kintner",
      "position": 1
    },
    "isbn": "0062267523",
    "googleBooksId": "placeholder56",
    "image": "https://books.google.com/books/content?id=uKt2vgEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "On a flight from London to Boston, Ted Severson meets Lily Kintner. Sharing one too many martinis, Ted confesses that he suspects his wife is having an affair. Lily surprises herself by blurting out, 'Maybe you should kill her.' From there, two twisted, damaged people—each of whom has their own dark past—embark on a very twisted affair.",
    "rating": 3.97,
    "ratingsCount": 242929,
    "pageCount": 320,
    "awards": [
      "Goodreads Choice Award Mystery & Thriller Nominee (2015)",
      "New England Society Book Award (2015)",
      "CWA Ian Fleming Steel Dagger Finalist (2015)"
    ],
    "categories": [
      "Thriller",
      "Mystery",
      "Crime"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 8,
      "contemporary": 8,
      "character": 8,
      "fast": 9,
      "dark": 9,
      "plot": 10,
      "standalone": 10,
      "modern": 10,
      "mind": 7,
      "emotional": 6
    }
  },
  {
    "id": 57,
    "title": "Behind Closed Doors",
    "author": "B.A. Paris",
    "publicationYear": 2016,
    "isbn": "1250121000",
    "googleBooksId": "placeholder57",
    "image": "https://books.google.com/books/content?id=lFaTDAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Everyone knows a couple like Jack and Grace: he has looks and wealth, she has charm and elegance. You'd like to be like them. But you'd be wrong. The perfect marriage is a perfect lie. Behind closed doors, all is not as it seems. And no one can help Grace escape.",
    "rating": 3.97,
    "ratingsCount": 757721,
    "pageCount": 293,
    "awards": [
      "Goodreads Choice Award Mystery & Thriller Nominee (2016)",
      "Goodreads Choice Award Debut Author Nominee (2016)"
    ],
    "categories": [
      "Thriller",
      "Psychological",
      "Mystery"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 7,
      "contemporary": 8,
      "character": 7,
      "fast": 9,
      "dark": 10,
      "plot": 9,
      "standalone": 10,
      "modern": 10,
      "mind": 6,
      "emotional": 8
    }
  },
  {
    "id": 59,
    "title": "The Death of Mrs. Westaway",
    "author": "Ruth Ware",
    "publicationYear": 2018,
    "isbn": "150115625X",
    "googleBooksId": "placeholder59",
    "image": "https://books.google.com/books/content?id=qPePDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "On a day that begins like any other, Hal receives a mysterious letter bequeathing her a substantial inheritance. She realizes very quickly that the letter was a mistake—but also that she can use the error to her advantage. Soon, Hal finds herself at the funeral of the deceased, where it dawns on her that there is something very, very wrong.",
    "rating": 3.8,
    "ratingsCount": 200718,
    "pageCount": 368,
    "awards": [
      "Audie Award Thriller/Suspense (2019)",
      "Goodreads Choice Award Mystery & Thriller Nominee (2018)"
    ],
    "categories": [
      "Mystery",
      "Thriller",
      "Gothic"
    ],
    "scores": {
      "mystery": 10,
      "thriller": 7,
      "literary": 7,
      "character": 8,
      "medium": 7,
      "dark": 8,
      "atmosphere": 9,
      "standalone": 10,
      "modern": 10,
      "mind": 7,
      "emotional": 6
    }
  },
  {
    "id": 60,
    "title": "The Turn of the Key",
    "author": "Ruth Ware",
    "publicationYear": 2019,
    "isbn": "150118878X",
    "googleBooksId": "placeholder60",
    "image": "https://books.google.com/books/content?id=icjcDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "When she stumbles across the ad, she's looking for something else completely. But it seems like too good an opportunity to miss—a live-in nannying post, with a staggeringly generous salary. And when she arrives at the house, she can hardly believe her luck. But she has no idea what she's about to face.",
    "rating": 3.9,
    "ratingsCount": 329082,
    "pageCount": 337,
    "awards": [
      "Goodreads Choice Award Mystery & Thriller Nominee (2019)"
    ],
    "categories": [
      "Thriller",
      "Mystery",
      "Gothic"
    ],
    "scores": {
      "thriller": 9,
      "mystery": 9,
      "contemporary": 7,
      "character": 7,
      "fast": 8,
      "dark": 8,
      "atmosphere": 9,
      "standalone": 10,
      "modern": 10,
      "mind": 7,
      "emotional": 6
    }
  },
  {
    "id": 62,
    "title": "Then She Was Gone",
    "author": "Lisa Jewell",
    "publicationYear": 2017,
    "isbn": "1501154656",
    "googleBooksId": "placeholder62",
    "image": "https://books.google.com/books/content?id=yGr2yQEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "She was fifteen, her mother's golden girl. She had her whole life ahead of her. And then, in the blink of an eye, she was gone. It has been ten years since Laurel's daughter disappeared. But when she meets a charming man in a café, something about him reminds her of her missing daughter.",
    "rating": 4.04,
    "ratingsCount": 1004328,
    "pageCount": 359,
    "awards": [
      "Goodreads Choice Award Mystery & Thriller Nominee (2018)"
    ],
    "categories": [
      "Mystery",
      "Thriller"
    ],
    "scores": {
      "mystery": 10,
      "thriller": 8,
      "contemporary": 8,
      "character": 9,
      "fast": 8,
      "dark": 8,
      "plot": 9,
      "standalone": 10,
      "modern": 10,
      "mind": 6,
      "emotional": 9
    }
  },
  {
    "id": 64,
    "title": "The Wife Between Us",
    "author": "Greer Hendricks & Sarah Pekkanen",
    "publicationYear": 2018,
    "isbn": "1250130921",
    "googleBooksId": "placeholder64",
    "image": "https://books.google.com/books/content?id=4yg_DwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "When you read this book, you will make many assumptions. You will assume you are reading about a jealous ex-wife. You will assume she is obsessed with her replacement. You will assume the first wife finally got what she deserved. You will be wrong.",
    "rating": 3.83,
    "ratingsCount": 446456,
    "pageCount": 346,
    "awards": [
      "Goodreads Choice Award Mystery & Thriller Nominee (2018)"
    ],
    "categories": [
      "Thriller",
      "Mystery",
      "Psychological"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 9,
      "contemporary": 8,
      "character": 7,
      "fast": 9,
      "dark": 7,
      "plot": 10,
      "standalone": 10,
      "modern": 10,
      "mind": 7,
      "emotional": 7
    }
  },
  {
    "id": 71,
    "title": "A Man Called Ove",
    "author": "Fredrik Backman",
    "publicationYear": 2012,
    "isbn": "1476738025",
    "googleBooksId": "placeholder71",
    "image": "https://books.google.com/books/content?id=m7S2CAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Meet Ove. He's a curmudgeon—the kind of man who points at people he dislikes as if they were burglars caught outside his bedroom window. He has staunch principles, strict routines, and a short fuse. People call him 'the bitter neighbor from hell.' But behind the cranky exterior there is a story and a sadness.",
    "rating": 4.38,
    "ratingsCount": 1218143,
    "pageCount": 337,
    "awards": [
      "Audie Award Best Male Narrator (2021)"
    ],
    "categories": [
      "Contemporary Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "contemporary": 10,
      "literary": 8,
      "character": 10,
      "medium": 7,
      "optimistic": 8,
      "heart": 10,
      "emotional": 10,
      "standalone": 10,
      "modern": 10,
      "mind": 6
    }
  },
  {
    "id": 73,
    "title": "The Overstory",
    "author": "Richard Powers",
    "publicationYear": 2018,
    "isbn": "039335668X",
    "googleBooksId": "placeholder73",
    "image": "https://books.google.com/books/content?id=AmxFtwEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The Overstory is a sweeping, impassioned work of activism and resistance that is also a stunning evocation of the natural world. From the roots to the crown and back to the seeds, Richard Powers's twelfth novel unfolds in concentric rings of interlocking fables that range from antebellum New York to the late twentieth-century Timber Wars.",
    "rating": 4.11,
    "ratingsCount": 197402,
    "pageCount": 502,
    "awards": [
      "Pulitzer Prize Fiction (2019)",
      "Booker Prize Shortlist (2018)",
      "PEN/Faulkner Award for Fiction (2019)",
      "William Dean Howells Medal (2020)",
      "Goodreads Choice Award Fiction (2018)"
    ],
    "categories": [
      "Literary Fiction",
      "Contemporary Fiction"
    ],
    "scores": {
      "literary": 10,
      "contemporary": 9,
      "character": 9,
      "slow": 8,
      "atmosphere": 10,
      "dark": 5,
      "emotional": 8,
      "standalone": 10,
      "modern": 10,
      "mind": 10,
      "heart": 7
    }
  },
  {
    "id": 74,
    "title": "The Great Alone",
    "author": "Kristin Hannah",
    "publicationYear": 2018,
    "isbn": "0312577230",
    "googleBooksId": "placeholder74",
    "image": "https://books.google.com/books/content?id=v51BDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Alaska, 1974. Ernt Allbright, a former POW, comes home from the Vietnam War a changed and volatile man. When he loses yet another job, he makes an impulsive decision: he will move his family north, to Alaska, where they will live off the grid in America's last true frontier.",
    "rating": 4.46,
    "ratingsCount": 1203365,
    "pageCount": 435,
    "awards": [
      "Audie Award Fiction (2019)",
      "Goodreads Choice Award Historical Fiction (2018)",
      "Book of the Month Book of the Year Award (2018)"
    ],
    "categories": [
      "Historical Fiction",
      "Contemporary Fiction"
    ],
    "scores": {
      "contemporary": 9,
      "historical": 8,
      "literary": 7,
      "character": 10,
      "fast": 7,
      "dark": 10,
      "atmosphere": 10,
      "emotional": 10,
      "standalone": 10,
      "modern": 10,
      "heart": 9,
      "mind": 6
    }
  },
  {
    "id": 76,
    "title": "The Dutch House",
    "author": "Ann Patchett",
    "publicationYear": 2019,
    "isbn": "0062963678",
    "googleBooksId": "placeholder76",
    "image": "https://books.google.com/books/content?id=45B7wwEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "At the end of the Second World War, Cyril Conroy combines luck and a single canny investment to begin an enormous real estate empire, propelling his family from poverty to enormous wealth. His first order of business is to buy the Dutch House, a lavish estate in the suburbs outside of Philadelphia.",
    "rating": 4.1,
    "ratingsCount": 560685,
    "pageCount": 337,
    "awards": [
      "Pulitzer Prize Fiction Finalist (2020)",
      "Women's Prize for Fiction Longlist (2020)",
      "Goodreads Choice Award Historical Fiction (2019)"
    ],
    "categories": [
      "Contemporary Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "contemporary": 9,
      "literary": 9,
      "character": 10,
      "slow": 6,
      "emotional": 9,
      "atmosphere": 8,
      "standalone": 10,
      "modern": 10,
      "heart": 9,
      "mind": 7
    }
  },
  {
    "id": 78,
    "title": "Beach Read",
    "author": "Emily Henry",
    "publicationYear": 2020,
    "isbn": "1984806734",
    "googleBooksId": "placeholder78",
    "image": "https://books.google.com/books/content?id=vDTgDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Augustus Everett is an acclaimed author of literary fiction. January Andrews writes romance. When she pens a happily ever after, he kills off his entire cast. They're polar opposites. In fact, the only thing they have in common is that they're both broke. The challenge: write in the other's genre.",
    "rating": 3.97,
    "ratingsCount": 1644748,
    "pageCount": 358,
    "awards": [
      "Goodreads Choice Award Nominee Romance (2020)"
    ],
    "categories": [
      "Romance",
      "Contemporary Fiction"
    ],
    "scores": {
      "contemporary": 10,
      "literary": 6,
      "character": 9,
      "fast": 7,
      "optimistic": 9,
      "heart": 10,
      "emotional": 9,
      "standalone": 10,
      "modern": 10,
      "mind": 5
    }
  },
  {
    "id": 80,
    "title": "Lessons in Chemistry",
    "author": "Bonnie Garmus",
    "publicationYear": 2022,
    "isbn": "038554734X",
    "googleBooksId": "placeholder80",
    "image": "https://books.google.com/books/content?id=9kGNEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Chemist Elizabeth Zott is not your average woman. In fact, Elizabeth Zott would be the first to point out that there is no such thing as an average woman. But it's the early 1960s and her all-male team at Hastings Research Institute takes a very unscientific view of equality. When Elizabeth finds herself pregnant, alone, and out of a job, she musters her strength and takes a job as a host on a cooking show.",
    "rating": 4.28,
    "ratingsCount": 1792662,
    "pageCount": 390,
    "awards": [
      "British Book Award Début Fiction (2023)",
      "Australian Book Industry Award International Book (2023)",
      "Goodreads Choice Award Debut Novel (2022)",
      "Barnes & Noble Book of the Year Award (2022)"
    ],
    "categories": [
      "Historical Fiction",
      "Contemporary Fiction",
      "Literary"
    ],
    "scores": {
      "contemporary": 10,
      "historical": 8,
      "literary": 8,
      "character": 10,
      "medium": 7,
      "optimistic": 8,
      "heart": 9,
      "emotional": 9,
      "standalone": 10,
      "modern": 10,
      "mind": 7
    }
  },
  {
    "id": 82,
    "title": "The Book of Lost Friends",
    "author": "Lisa Wingate",
    "publicationYear": 2020,
    "isbn": "1984819909",
    "googleBooksId": "placeholder82",
    "image": "https://books.google.com/books/content?id=BtUwEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Louisiana, 1875: In the wake of slavery, three young women search for a safe place to call home. Their journey brings them into a community where the past is never truly gone. Years later, a thirty-year-old teacher finds herself drawn into their search.",
    "rating": 4.15,
    "ratingsCount": 122550,
    "pageCount": 388,
    "awards": [
      "Goodreads Choice Award Historical Fiction Nominee (2020)"
    ],
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "historical": 10,
      "contemporary": 6,
      "literary": 8,
      "character": 9,
      "medium": 7,
      "dark": 7,
      "atmosphere": 9,
      "emotional": 10,
      "standalone": 10,
      "classic": 7,
      "heart": 9,
      "mind": 7
    }
  },
  {
    "id": 83,
    "title": "The Authenticity Project",
    "author": "Clare Pooley",
    "publicationYear": 2020,
    "isbn": "1984878638",
    "googleBooksId": "placeholder83",
    "image": "https://books.google.com/books/content?id=0kCREAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Julian Jessop, an eccentric, lonely artist and septuagenarian, believes that most people aren't really honest with each other. So he writes the truth in a green notebook and leaves it in a café for someone to find. This small act of honesty sparks a chain of events that brings six strangers together.",
    "rating": 3.94,
    "ratingsCount": 104082,
    "pageCount": 400,
    "awards": [
      "Romantic Novel of the Year Award (2021)",
      "Katie Fforde Debut Romantic Novel Award (2021)"
    ],
    "categories": [
      "Contemporary Fiction",
      "Literary"
    ],
    "scores": {
      "contemporary": 10,
      "literary": 7,
      "character": 9,
      "medium": 7,
      "optimistic": 9,
      "heart": 10,
      "emotional": 9,
      "standalone": 10,
      "modern": 10,
      "mind": 6
    }
  },
  {
    "id": 84,
    "title": "Malibu Rising",
    "author": "Taylor Jenkins Reid",
    "publicationYear": 2021,
    "isbn": "1524798657",
    "googleBooksId": "placeholder84",
    "image": "https://books.google.com/books/content?id=5piTEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Malibu: August 1983. It's the day of Nina Riva's annual end-of-summer party, and anticipation is at a fever pitch. Everyone wants to be around the famous Rivas: Nina, the talented surfer and supermodel; brothers Jay and Hud, one a championship surfer, the other a renowned photographer; and their baby sister Kit.",
    "rating": 4.02,
    "ratingsCount": 1294135,
    "pageCount": 369,
    "awards": [
      "Goodreads Choice Award Historical Fiction (2021)",
      "Book of the Month Book of the Year Award (2021)"
    ],
    "categories": [
      "Contemporary Fiction",
      "Historical Fiction"
    ],
    "scores": {
      "contemporary": 10,
      "historical": 6,
      "literary": 7,
      "character": 9,
      "fast": 8,
      "optimistic": 6,
      "heart": 8,
      "emotional": 9,
      "standalone": 10,
      "modern": 10,
      "mind": 5
    }
  },
  {
    "id": 86,
    "title": "The Love Hypothesis",
    "author": "Ali Hazelwood",
    "publicationYear": 2021,
    "isbn": "0593336828",
    "googleBooksId": "placeholder86",
    "image": "https://books.google.com/books/content?id=OuY9EAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "As a third-year Ph.D. candidate, Olive Smith doesn't believe in lasting romantic relationships. When a colleague catches her in a lie, Olive panics and kisses the first man she sees. That man is none other than Adam Carlsen, a young hotshot professor—and well-known ass. But when Adam surprises her by agreeing to be her fake boyfriend, she discovers that he's actually secretly a sweetheart.",
    "rating": 4.1,
    "ratingsCount": 1906759,
    "pageCount": 400,
    "awards": [
      "Goodreads Choice Award Romance (2021)",
      "Book of the Month Book of the Year Award (2022)",
      "Swoon Award Contemporary Romance (2021)"
    ],
    "categories": [
      "Romance",
      "Contemporary Fiction"
    ],
    "scores": {
      "contemporary": 8,
      "character": 8,
      "fast": 8,
      "optimistic": 9,
      "heart": 10,
      "emotional": 9,
      "plot": 7,
      "standalone": 10,
      "modern": 10,
      "mind": 5
    }
  },
  {
    "id": 87,
    "title": "People We Meet on Vacation",
    "author": "Emily Henry",
    "publicationYear": 2021,
    "isbn": "1984806750",
    "googleBooksId": "placeholder87",
    "image": "https://books.google.com/books/content?id=5fooEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Poppy and Alex. Alex and Poppy. They have nothing in common. She's a wild child; he wears khakis. She has insatiable wanderlust; he prefers to stay home. And somehow, ever since a fateful car share home from college, they are the very best of friends. For most of the year they live far apart—until they take one glorious week of vacation together.",
    "rating": 3.85,
    "ratingsCount": 1724020,
    "pageCount": 365,
    "awards": [
      "Goodreads Choice Award Romance (2021)",
      "Book of the Month Book of the Year Award (2021)"
    ],
    "categories": [
      "Romance",
      "Contemporary Fiction"
    ],
    "scores": {
      "contemporary": 9,
      "character": 9,
      "medium": 7,
      "optimistic": 9,
      "heart": 10,
      "emotional": 9,
      "standalone": 10,
      "modern": 10,
      "mind": 5,
      "plot": 5
    }
  },
  {
    "id": 88,
    "title": "Red, White & Royal Blue",
    "author": "Casey McQuiston",
    "publicationYear": 2019,
    "isbn": "1250316774",
    "googleBooksId": "placeholder88",
    "image": "https://books.google.com/books/content?id=_jNwDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "What happens when America's First Son falls in love with the Prince of Wales? When his mother became President, Alex Claremont-Diaz was promptly cast as the American equivalent of a young royal. There's only one problem: Alex has a beef with the actual prince, Henry. When the tabloids get hold of a photo involving an Alex-Henry altercation, damage control requires staging a truce.",
    "rating": 4.05,
    "ratingsCount": 1231220,
    "pageCount": 443,
    "awards": [
      "ALA Alex Award (2020)",
      "Goodreads Choice Award Romance (2019)",
      "Goodreads Choice Award Debut Novel (2019)",
      "Bisexual Book Awards Romance (2019)"
    ],
    "categories": [
      "Romance",
      "LGBTQ+",
      "Contemporary"
    ],
    "scores": {
      "contemporary": 9,
      "character": 8,
      "fast": 8,
      "optimistic": 9,
      "heart": 10,
      "emotional": 9,
      "plot": 7,
      "standalone": 10,
      "modern": 10,
      "mind": 5
    }
  },
  {
    "id": 89,
    "title": "The Hating Game",
    "author": "Sally Thorne",
    "publicationYear": 2016,
    "isbn": "0062439596",
    "googleBooksId": "placeholder89",
    "image": "https://books.google.com/books/content?id=Ap5qjgEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Lucy Hutton and Joshua Templeman hate each other. Not dislike. Not begrudgingly tolerate. Hate. And they have no problem displaying their feelings through a series of ritualistic passive aggressive maneuvers. Lucy can't understand Joshua's joyless, uptight approach to his job. Joshua is clearly baffled by Lucy's overly bright clothes. Now they're up for the same promotion.",
    "rating": 3.86,
    "ratingsCount": 832318,
    "pageCount": 387,
    "awards": [
      "Romantic Times Reviewers' Choice Award Mainstream Fiction (2016)",
      "Goodreads Choice Award Romance Nominee (2016)"
    ],
    "categories": [
      "Romance",
      "Contemporary Fiction"
    ],
    "scores": {
      "contemporary": 9,
      "character": 8,
      "fast": 8,
      "optimistic": 9,
      "heart": 10,
      "emotional": 8,
      "plot": 7,
      "standalone": 10,
      "modern": 10,
      "mind": 4
    }
  },
  {
    "id": 90,
    "title": "It Ends with Us",
    "author": "Colleen Hoover",
    "publicationYear": 2016,
    "series": {
      "name": "It Ends with Us",
      "position": 1
    },
    "isbn": "1501110365",
    "googleBooksId": "placeholder90",
    "image": "https://books.google.com/books/content?id=Eka9DAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Lily hasn't always had it easy, but that's never stopped her from working hard for the life she wants. She's come a long way from the small town where she grew up. When she feels a spark with a gorgeous neurosurgeon named Ryle Kincaid, everything seems perfect. Until she finds herself thinking about her first love, Atlas Corrigan.",
    "rating": 4.08,
    "ratingsCount": 4635801,
    "pageCount": 373,
    "awards": [
      "Goodreads Choice Award Romance (2016)"
    ],
    "categories": [
      "Romance",
      "Contemporary Fiction"
    ],
    "scores": {
      "contemporary": 10,
      "character": 9,
      "fast": 7,
      "dark": 7,
      "heart": 10,
      "emotional": 10,
      "plot": 8,
      "standalone": 10,
      "modern": 10,
      "mind": 5
    }
  },
  {
    "id": 91,
    "title": "The Flatshare",
    "author": "Beth O'Leary",
    "publicationYear": 2019,
    "isbn": "1250295637",
    "googleBooksId": "placeholder91",
    "image": "https://books.google.com/books/content?id=Q59xDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Tiffy and Leon share a flat. Tiffy and Leon have never met. After a bad breakup, Tiffy needs a place to live. She finds the perfect flat: one bedroom, affordable rent. There's just one catch: it's already occupied by Leon. But with Tiffy working days and Leon working nights, they decide to share the bed without ever meeting.",
    "rating": 3.98,
    "ratingsCount": 458841,
    "pageCount": 394,
    "awards": [
      "Goodreads Choice Award Romance Nominee (2019)",
      "RUSA CODES Reading List Romance (2020)"
    ],
    "categories": [
      "Romance",
      "Contemporary Fiction"
    ],
    "scores": {
      "contemporary": 10,
      "character": 9,
      "medium": 7,
      "optimistic": 9,
      "heart": 10,
      "emotional": 8,
      "plot": 7,
      "standalone": 10,
      "modern": 10,
      "mind": 5
    }
  },
  {
    "id": 93,
    "title": "The Kiss Quotient",
    "author": "Helen Hoang",
    "publicationYear": 2018,
    "series": {
      "name": "The Kiss Quotient",
      "position": 1
    },
    "isbn": "0451490800",
    "googleBooksId": "placeholder93",
    "image": "https://books.google.com/books/content?id=oR1aDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Stella Lane thinks math is the only thing that unites the universe. She's so good at algorithms that a firm is paying her to solve their toughest equations. What she hasn't solved is love. When her family makes it clear marriage is all they want for her, Stella decides to hire an escort to teach her how to date.",
    "rating": 3.87,
    "ratingsCount": 498543,
    "pageCount": 333,
    "awards": [
      "Goodreads Choice Award Romance (2018)",
      "Goodreads Choice Award Debut Author Nominee (2018)",
      "Book of the Month Book of the Year Award (2018)"
    ],
    "categories": [
      "Romance",
      "Contemporary Fiction"
    ],
    "scores": {
      "contemporary": 9,
      "character": 9,
      "fast": 8,
      "optimistic": 9,
      "heart": 10,
      "emotional": 9,
      "plot": 7,
      "standalone": 10,
      "modern": 10,
      "mind": 5
    }
  },
  {
    "id": 94,
    "title": "The Unhoneymooners",
    "author": "Christina Lauren",
    "publicationYear": 2019,
    "isbn": "1501128035",
    "googleBooksId": "placeholder94",
    "image": "https://books.google.com/books/content?id=DViYDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Olive is always unlucky. Her identical twin sister Ami has always been luckiest. So Olive is not expecting Ami's wedding to be anything but a disaster. But when everyone at the wedding gets food poisoning except Olive and the best man Ethan, there's an all-expenses-paid honeymoon in Hawaii up for grabs.",
    "rating": 3.89,
    "ratingsCount": 1128415,
    "pageCount": 432,
    "awards": [
      "Goodreads Choice Award Romance Nominee (2019)"
    ],
    "categories": [
      "Romance",
      "Contemporary Fiction"
    ],
    "scores": {
      "contemporary": 9,
      "character": 8,
      "fast": 8,
      "optimistic": 10,
      "heart": 10,
      "emotional": 8,
      "plot": 8,
      "standalone": 10,
      "modern": 10,
      "mind": 4
    }
  },
  {
    "id": 95,
    "title": "One Day in December",
    "author": "Josie Silver",
    "publicationYear": 2018,
    "isbn": "0525574689",
    "googleBooksId": "placeholder95",
    "image": "https://books.google.com/books/content?id=8D9wDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Laurie is pretty sure love at first sight doesn't exist. But then, through a broken-down bus window one snowy December day, she sees a man who she knows instantly is the one. Their eyes meet. Then the bus drives away. They spend years looking for each other. Then Laurie's best friend introduces her new boyfriend...and it's him.",
    "rating": 3.82,
    "ratingsCount": 365110,
    "pageCount": 393,
    "categories": [
      "Romance",
      "Contemporary Fiction"
    ],
    "scores": {
      "contemporary": 9,
      "character": 9,
      "medium": 6,
      "optimistic": 8,
      "heart": 10,
      "emotional": 10,
      "plot": 8,
      "standalone": 10,
      "modern": 10,
      "mind": 5
    }
  },
  {
    "id": 99,
    "title": "Wildfire",
    "author": "Hannah Grace",
    "publicationYear": 2023,
    "isbn": "1668026279",
    "googleBooksId": "placeholder99",
    "image": "https://books.google.com/books/content?id=Txi2EAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "When a hockey player and a figure skater meet at a summer camp, a one-night stand turns complicated when they're both hired as counselors. From the author of Icebreaker.",
    "rating": 3.81,
    "ratingsCount": 471156,
    "pageCount": 387,
    "awards": [
      "Goodreads Choice Award Romance Nominee (2023)"
    ],
    "categories": [
      "Romance",
      "Contemporary",
      "Sports"
    ],
    "scores": {
      "contemporary": 10,
      "character": 9,
      "fast": 8,
      "optimistic": 9,
      "heart": 10,
      "emotional": 8,
      "standalone": 10,
      "series": 8,
      "modern": 10,
      "plot": 5
    }
  },
  {
    "id": 101,
    "title": "All the Light We Cannot See",
    "author": "Anthony Doerr",
    "publicationYear": 2014,
    "isbn": "1501173219",
    "googleBooksId": "placeholder101",
    "image": "https://books.google.com/books/content?id=giaLDgAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Marie-Laure lives in Paris near the Museum of Natural History. Werner grows up in Germany, an orphan obsessed with building radios. When their paths collide in occupied France as Werner tracks the Resistance, Marie-Laure attempts to evade detection with a valuable jewel.",
    "rating": 4.31,
    "ratingsCount": 1983231,
    "pageCount": 531,
    "awards": [
      "Pulitzer Prize Fiction (2015)",
      "Andrew Carnegie Medal Fiction (2015)",
      "Audie Award Fiction (2015)",
      "ALA Alex Award (2015)",
      "Goodreads Choice Award Historical Fiction (2014)"
    ],
    "categories": [
      "Historical Fiction",
      "War"
    ],
    "scores": {
      "historical": 10,
      "literary": 9,
      "character": 10,
      "slow": 7,
      "dark": 7,
      "atmosphere": 10,
      "emotional": 10,
      "standalone": 10,
      "classic": 8,
      "heart": 9,
      "mind": 8
    }
  },
  {
    "id": 102,
    "title": "The Book Thief",
    "author": "Markus Zusak",
    "publicationYear": 2005,
    "isbn": "0375842209",
    "googleBooksId": "placeholder102",
    "image": "https://books.google.com/books/content?id=ExbTCwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "It is 1939. Nazi Germany. Liesel Meminger and her younger brother are being taken by their mother to live with a foster family. Liesel's story is narrated by Death, who tells us that he first met her on a train and becomes haunted by humans. With her foster father Hans, Liesel learns to read and shares her stolen books with her neighbors.",
    "rating": 4.39,
    "ratingsCount": 2887155,
    "pageCount": 592,
    "awards": [
      "Michael L. Printz Award (2007)",
      "National Jewish Book Award Children's Literature (2006)",
      "Margaret A. Edwards Award (2014)",
      "Lincoln Award (2010)"
    ],
    "categories": [
      "Historical Fiction",
      "War",
      "Literary"
    ],
    "scores": {
      "historical": 10,
      "literary": 10,
      "character": 10,
      "medium": 7,
      "dark": 8,
      "atmosphere": 10,
      "emotional": 10,
      "standalone": 10,
      "classic": 9,
      "heart": 10,
      "mind": 8
    }
  },
  {
    "id": 103,
    "title": "The Alice Network",
    "author": "Kate Quinn",
    "publicationYear": 2017,
    "isbn": "0062654195",
    "googleBooksId": "placeholder103",
    "image": "https://books.google.com/books/content?id=upkXvgAACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In an enthralling new historical novel from national bestselling author Kate Quinn, two women—a female spy recruited to the real-life Alice Network in France during World War I and an unconventional American socialite searching for her cousin in 1947—are brought together in a mesmerizing story of courage and redemption.",
    "rating": 4.32,
    "ratingsCount": 631358,
    "pageCount": 503,
    "awards": [
      "Goodreads Choice Award Historical Fiction Nominee (2017)"
    ],
    "categories": [
      "Historical Fiction",
      "War"
    ],
    "scores": {
      "historical": 10,
      "character": 9,
      "medium": 7,
      "dark": 7,
      "plot": 9,
      "atmosphere": 9,
      "emotional": 9,
      "standalone": 10,
      "classic": 7,
      "heart": 8,
      "mind": 7
    }
  },
  {
    "id": 105,
    "title": "The Pillars of the Earth",
    "author": "Ken Follett",
    "publicationYear": 1989,
    "series": {
      "name": "Kingsbridge",
      "position": 1
    },
    "isbn": "0451166892",
    "googleBooksId": "placeholder105",
    "image": "https://books.google.com/books/content?id=iaqAryiqFhUC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Set in 12th-century England, this epic tale of ambition, anarchy, and absolute power revolves around the building of a cathedral in the fictional town of Kingsbridge during a time of great upheaval.",
    "rating": 4.35,
    "ratingsCount": 832770,
    "pageCount": 976,
    "categories": [
      "Historical Fiction",
      "Medieval"
    ],
    "scores": {
      "historical": 10,
      "character": 9,
      "slow": 8,
      "dark": 7,
      "plot": 10,
      "atmosphere": 10,
      "series": 7,
      "classic": 9,
      "mind": 8,
      "emotional": 8
    }
  },
  {
    "id": 106,
    "title": "The Underground Railroad",
    "author": "Colson Whitehead",
    "publicationYear": 2016,
    "isbn": "0385542364",
    "googleBooksId": "placeholder106",
    "image": "https://books.google.com/books/content?id=ZEGNEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Cora is a young slave on a cotton plantation in Georgia. An outcast even among her fellow Africans, she is on the cusp of womanhood. When Caesar, a slave who has recently arrived from Virginia, urges her to join him on the Underground Railroad, she seizes the opportunity and escapes.",
    "rating": 4.06,
    "ratingsCount": 446147,
    "pageCount": 306,
    "awards": [
      "Pulitzer Prize Fiction (2017)",
      "National Book Award Fiction (2016)",
      "Goodreads Choice Award Historical Fiction (2016)",
      "Arthur C. Clarke Award (2017)",
      "Booker Prize Longlist (2017)"
    ],
    "categories": [
      "Historical Fiction",
      "Literary"
    ],
    "scores": {
      "historical": 10,
      "literary": 10,
      "character": 9,
      "medium": 7,
      "dark": 9,
      "atmosphere": 10,
      "emotional": 9,
      "standalone": 10,
      "classic": 8,
      "mind": 10,
      "heart": 7
    }
  },
  {
    "id": 107,
    "title": "Wolf Hall",
    "author": "Hilary Mantel",
    "publicationYear": 2009,
    "series": {
      "name": "Thomas Cromwell",
      "position": 1
    },
    "isbn": "0312429983",
    "googleBooksId": "placeholder107",
    "image": "https://books.google.com/books/content?id=7OgI0AEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "England in the 1520s is a heartbeat from disaster. If the king dies without a male heir, the country could be destroyed by civil war. Henry VIII wants to annul his marriage and marry Anne Boleyn. The pope and most of Europe oppose him. Into this impasse steps Thomas Cromwell.",
    "rating": 3.91,
    "ratingsCount": 233820,
    "pageCount": 653,
    "awards": [
      "Man Booker Prize (2009)",
      "National Book Critics Circle Award Fiction (2009)",
      "Costa Book Award Novel (2009)",
      "Walter Scott Prize (2010)",
      "Golden Man Booker Prize (2018)"
    ],
    "categories": [
      "Historical Fiction",
      "Literary"
    ],
    "scores": {
      "historical": 10,
      "literary": 10,
      "character": 9,
      "slow": 8,
      "dark": 6,
      "atmosphere": 10,
      "series": 8,
      "classic": 9,
      "mind": 10,
      "emotional": 6
    }
  },
  {
    "id": 108,
    "title": "Homegoing",
    "author": "Yaa Gyasi",
    "publicationYear": 2016,
    "isbn": "1101947136",
    "googleBooksId": "placeholder108",
    "image": "https://books.google.com/books/content?id=NmOPEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Two half-sisters, Effia and Esi, are born into different villages in 18th century Ghana. Effia is married off to an Englishman and lives in comfort in the Cape Coast Castle. Esi is imprisoned beneath Effia in the castle's dungeons and sold into slavery in America. Homegoing follows their descendants through eight generations.",
    "rating": 4.47,
    "ratingsCount": 404871,
    "pageCount": 305,
    "awards": [
      "American Book Award (2017)",
      "Audie Award Literary Fiction & Classics (2017)",
      "National Book Critics Circle Award John Leonard Prize (2016)",
      "Andrew Carnegie Medal Fiction (2017)",
      "Goodreads Choice Award Historical Fiction Nominee (2016)"
    ],
    "categories": [
      "Historical Fiction",
      "Literary"
    ],
    "scores": {
      "historical": 10,
      "literary": 9,
      "character": 9,
      "medium": 7,
      "dark": 8,
      "atmosphere": 9,
      "emotional": 10,
      "standalone": 10,
      "modern": 9,
      "mind": 9,
      "heart": 8
    }
  },
  {
    "id": 109,
    "title": "The Help",
    "author": "Kathryn Stockett",
    "publicationYear": 2009,
    "isbn": "0425232204",
    "googleBooksId": "placeholder109",
    "image": "https://books.google.com/books/content?id=QwBQEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In 1960s Mississippi, Skeeter is a southern society girl who returns from college determined to become a writer. She turns her small town on its ear by choosing to interview the black women who have spent their lives taking care of prominent white families.",
    "rating": 4.47,
    "ratingsCount": 3027580,
    "pageCount": 451,
    "awards": [
      "Goodreads Choice Award Fiction (2009)",
      "Orange Prize Fiction Longlist (2010)",
      "Audie Award Fiction (2010)",
      "Indies Choice Book Award Adult Debut (2010)",
      "Townsend Prize for Fiction (2010)",
      "Lincoln Award (2013)"
    ],
    "categories": [
      "Historical Fiction",
      "Literary"
    ],
    "scores": {
      "historical": 10,
      "contemporary": 5,
      "literary": 8,
      "character": 10,
      "medium": 7,
      "dark": 7,
      "emotional": 10,
      "standalone": 10,
      "classic": 7,
      "heart": 9,
      "mind": 8
    }
  },
  {
    "id": 110,
    "title": "Beneath a Scarlet Sky",
    "author": "Mark Sullivan",
    "publicationYear": 2017,
    "isbn": "1503943372",
    "googleBooksId": "placeholder110",
    "image": "https://books.google.com/books/content?id=vKsbvgAACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Based on the true story of a forgotten hero, this is an unforgettable tale of human resilience during the dark days of World War II in Nazi-occupied Italy. Pino Lella wants nothing to do with the war, but soon finds himself driving for a powerful German general.",
    "rating": 4.43,
    "ratingsCount": 389375,
    "pageCount": 509,
    "awards": [
      "Goodreads Choice Award Historical Fiction Nominee (2017)"
    ],
    "categories": [
      "Historical Fiction",
      "War",
      "Biography"
    ],
    "scores": {
      "historical": 10,
      "character": 9,
      "fast": 8,
      "dark": 7,
      "plot": 10,
      "atmosphere": 9,
      "emotional": 9,
      "standalone": 10,
      "classic": 7,
      "heart": 8,
      "mind": 7
    }
  },
  {
    "id": 111,
    "title": "The Invention of Wings",
    "author": "Sue Monk Kidd",
    "publicationYear": 2014,
    "isbn": "0143121707",
    "googleBooksId": "placeholder111",
    "image": "https://books.google.com/books/content?id=rVgBDAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Hetty 'Handful' Grimke is a Charleston slave when Sarah Grimke is given ownership of her on Sarah's eleventh birthday. What follows is a remarkable journey spanning thirty-five years, as both women struggle to find their place in the world and challenge the conventions of their time.",
    "rating": 4.26,
    "ratingsCount": 332956,
    "pageCount": 384,
    "awards": [
      "Florida Book Award Gold Fiction (2014)",
      "Goodreads Choice Award Historical Fiction (2014)",
      "Dublin Literary Award (2016)"
    ],
    "categories": [
      "Historical Fiction",
      "Literary"
    ],
    "scores": {
      "historical": 10,
      "literary": 9,
      "character": 10,
      "medium": 6,
      "dark": 7,
      "emotional": 10,
      "standalone": 10,
      "classic": 8,
      "heart": 9,
      "mind": 8
    }
  },
  {
    "id": 112,
    "title": "Memoirs of a Geisha",
    "author": "Arthur Golden",
    "publicationYear": 1997,
    "isbn": "0679781587",
    "googleBooksId": "placeholder112",
    "image": "https://books.google.com/books/content?id=o9dQAygC_aIC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In this literary tour de force, novelist Arthur Golden enters a remote and shimmer world. For the protagonist of this peerlessly observant first-person tale is Sayuri, one of Japan's most celebrated geisha, a woman who is both performer and courtesan, slave and goddess.",
    "rating": 4.16,
    "ratingsCount": 2113091,
    "pageCount": 503,
    "categories": [
      "Historical Fiction",
      "Literary"
    ],
    "scores": {
      "historical": 10,
      "literary": 9,
      "character": 9,
      "slow": 7,
      "dark": 6,
      "atmosphere": 10,
      "emotional": 9,
      "standalone": 10,
      "classic": 9,
      "heart": 8,
      "mind": 7
    }
  },
  {
    "id": 114,
    "title": "The Power of Now",
    "author": "Eckhart Tolle",
    "publicationYear": 1997,
    "isbn": "1577314808",
    "googleBooksId": "placeholder114",
    "image": "https://books.google.com/books/content?id=NFQ7DwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "To make the journey into the Now we will need to leave our analytical mind and its false created self, the ego, behind. From the very first page of this extraordinary book, we move rapidly into a significantly higher altitude where we breathe a lighter air.",
    "rating": 4.15,
    "ratingsCount": 452548,
    "pageCount": 229,
    "categories": [
      "Self-Help",
      "Spirituality",
      "Nonfiction"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 10,
      "slow": 6,
      "optimistic": 10,
      "standalone": 10,
      "classic": 7,
      "emotional": 7,
      "character": 7,
      "plot": 6,
      "accessible": 7
    }
  },
  {
    "id": 115,
    "title": "How to Win Friends and Influence People",
    "author": "Dale Carnegie",
    "publicationYear": 1936,
    "isbn": "0671027034",
    "googleBooksId": "placeholder115",
    "image": "https://books.google.com/books/content?id=D7TznQEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "You can go after the job you want...and get it! You can take the job you have...and improve it! You can take any situation you're in...and make it work for you! Dale Carnegie's rock-solid, time-tested advice has carried countless people up the ladder of success.",
    "rating": 4.22,
    "ratingsCount": 1153289,
    "pageCount": 288,
    "categories": [
      "Self-Help",
      "Business",
      "Nonfiction"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 8,
      "medium": 7,
      "optimistic": 9,
      "standalone": 10,
      "classic": 10,
      "emotional": 4,
      "character": 7,
      "plot": 6,
      "accessible": 7
    }
  },
  {
    "id": 116,
    "title": "The 7 Habits of Highly Effective People",
    "author": "Stephen R. Covey",
    "publicationYear": 1989,
    "isbn": "1982137274",
    "googleBooksId": "placeholder116",
    "image": "https://books.google.com/books/content?id=4K7eDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "One of the most inspiring and impactful books ever written, The 7 Habits of Highly Effective People has captivated readers for nearly three decades. It has transformed the lives of presidents and CEOs, educators and parents—millions of people of all ages and occupations.",
    "rating": 4.16,
    "ratingsCount": 823865,
    "pageCount": 372,
    "categories": [
      "Self-Help",
      "Business",
      "Nonfiction"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 9,
      "medium": 6,
      "optimistic": 9,
      "standalone": 10,
      "classic": 10,
      "emotional": 4,
      "character": 7,
      "plot": 6,
      "accessible": 7
    }
  },
  {
    "id": 117,
    "title": "Can't Hurt Me",
    "author": "David Goggins",
    "publicationYear": 2018,
    "isbn": "1544512287",
    "googleBooksId": "placeholder117",
    "image": "https://books.google.com/books/content?id=IeYmEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "For David Goggins, childhood was a nightmare - poverty, prejudice, and physical abuse colored his days and haunted his nights. But through self-discipline, mental toughness, and hard work, Goggins transformed himself from a depressed, overweight young man with no future into a U.S. Armed Forces icon.",
    "rating": 4.3,
    "ratingsCount": 315295,
    "pageCount": 366,
    "categories": [
      "Self-Help",
      "Memoir",
      "Nonfiction"
    ],
    "scores": {
      "nonfiction": 9,
      "memoir": 7,
      "mind": 8,
      "fast": 8,
      "dark": 6,
      "optimistic": 9,
      "standalone": 10,
      "modern": 10,
      "emotional": 8,
      "heart": 7
    }
  },
  {
    "id": 119,
    "title": "Mindset: The New Psychology of Success",
    "author": "Carol S. Dweck",
    "publicationYear": 2006,
    "isbn": "0345472322",
    "googleBooksId": "placeholder119",
    "image": "https://books.google.com/books/content?id=bOGHDQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "After decades of research, world-renowned Stanford University psychologist Carol S. Dweck, Ph.D., discovered a simple but groundbreaking idea: the power of mindset. In this brilliant book, she shows how success in school, work, sports, the arts, and almost every area of human endeavor can be dramatically influenced by how we think about our talents and abilities.",
    "rating": 4.09,
    "ratingsCount": 176322,
    "pageCount": 276,
    "categories": [
      "Psychology",
      "Self-Help",
      "Nonfiction"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 9,
      "medium": 7,
      "optimistic": 9,
      "standalone": 10,
      "modern": 10,
      "emotional": 5,
      "character": 7,
      "plot": 6,
      "accessible": 7
    }
  },
  {
    "id": 120,
    "title": "The Body Keeps the Score",
    "author": "Bessel van der Kolk",
    "publicationYear": 2014,
    "isbn": "0143127748",
    "googleBooksId": "placeholder120",
    "image": "https://books.google.com/books/content?id=vHnZCwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Trauma is a fact of life. Veterans and their families deal with the painful aftermath of combat; one in five Americans has been molested; one in four grew up with alcoholics; one in three couples have engaged in physical violence. Dr. van der Kolk offers a bold new paradigm for treating trauma.",
    "rating": 4.35,
    "ratingsCount": 282782,
    "pageCount": 464,
    "categories": [
      "Psychology",
      "Nonfiction",
      "Health"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 10,
      "slow": 7,
      "dark": 7,
      "standalone": 10,
      "modern": 10,
      "emotional": 8,
      "character": 7,
      "plot": 6,
      "accessible": 7
    }
  },
  {
    "id": 121,
    "title": "Daring Greatly",
    "author": "Brené Brown",
    "publicationYear": 2012,
    "isbn": "1592408419",
    "googleBooksId": "placeholder121",
    "image": "https://books.google.com/books/content?id=2JFADwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Every day we experience the uncertainty, risks, and emotional exposure that define what it means to be vulnerable. Based on twelve years of pioneering research, Dr. Brené Brown dispels the cultural myth that vulnerability is weakness and reveals that it is our most accurate measure of courage.",
    "rating": 4.29,
    "ratingsCount": 243408,
    "pageCount": 287,
    "categories": [
      "Self-Help",
      "Psychology",
      "Nonfiction"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 9,
      "medium": 6,
      "optimistic": 8,
      "standalone": 10,
      "modern": 10,
      "emotional": 8,
      "heart": 8,
      "character": 7,
      "plot": 6
    }
  },
  {
    "id": 123,
    "title": "Attached",
    "author": "Amir Levine & Rachel Heller",
    "publicationYear": 2010,
    "isbn": "1585429139",
    "googleBooksId": "placeholder123",
    "image": "https://books.google.com/books/content?id=_O0oDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Is there a science to love? In this groundbreaking book, psychiatrist and neuroscientist Amir Levine and psychologist Rachel S. F. Heller reveal how an understanding of attachment theory can help us find and sustain love.",
    "rating": 4.13,
    "ratingsCount": 123154,
    "pageCount": 304,
    "categories": [
      "Psychology",
      "Self-Help",
      "Nonfiction"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 9,
      "medium": 7,
      "optimistic": 7,
      "standalone": 10,
      "modern": 10,
      "emotional": 7,
      "heart": 7,
      "character": 7,
      "plot": 6
    }
  },
  {
    "id": 124,
    "title": "The Four Agreements",
    "author": "Don Miguel Ruiz",
    "publicationYear": 1997,
    "series": {
      "name": "Toltec Wisdom",
      "position": 1
    },
    "isbn": "1878424319",
    "googleBooksId": "placeholder124",
    "image": "https://books.google.com/books/content?id=t54LEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In The Four Agreements, don Miguel Ruiz reveals the source of self-limiting beliefs that rob us of joy and create needless suffering. Based on ancient Toltec wisdom, The Four Agreements offer a powerful code of conduct that can rapidly transform our lives to a new experience of freedom, true happiness, and love.",
    "rating": 4.19,
    "ratingsCount": 521549,
    "pageCount": 152,
    "categories": [
      "Self-Help",
      "Spirituality",
      "Nonfiction"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 8,
      "fast": 8,
      "optimistic": 10,
      "standalone": 10,
      "classic": 7,
      "emotional": 6,
      "character": 7,
      "plot": 6,
      "accessible": 7
    }
  },
  {
    "id": 126,
    "title": "Mistborn: The Final Empire",
    "author": "Brandon Sanderson",
    "publicationYear": 2006,
    "series": {
      "name": "Mistborn",
      "position": 1
    },
    "isbn": "0765350386",
    "googleBooksId": "placeholder126",
    "image": "https://books.google.com/books/content?id=jZAUqunfcZkC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "For a thousand years the ash fell and no flowers bloomed. For a thousand years the Skaa slaved in misery and lived in fear. For a thousand years the Lord Ruler reigned with absolute power and ultimate terror, divinely invincible. Then came a child of the slums who came to overturn an empire.",
    "rating": 4.49,
    "ratingsCount": 980257,
    "pageCount": 541,
    "awards": [
      "Tähtifantasia Award (2018)"
    ],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "plot": 10,
      "character": 9,
      "fast": 8,
      "dark": 7,
      "atmosphere": 10,
      "series": 10,
      "modern": 10,
      "mind": 8,
      "emotional": 7
    }
  },
  {
    "id": 128,
    "title": "A Court of Thorns and Roses",
    "author": "Sarah J. Maas",
    "publicationYear": 2015,
    "series": {
      "name": "A Court of Thorns and Roses",
      "position": 1
    },
    "isbn": "1619634449",
    "googleBooksId": "placeholder128",
    "image": "https://books.google.com/books/content?id=VswAEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "When nineteen-year-old huntress Feyre kills a wolf in the woods, a terrifying creature arrives to demand retribution. Dragged to a treacherous magical land she knows about only from legends, Feyre discovers that her captor is not truly a beast, but one of the lethal, immortal faeries who once ruled her world.",
    "rating": 4.16,
    "ratingsCount": 4232872,
    "pageCount": 419,
    "awards": [
      "Lincoln Award (2017)",
      "Goodreads Choice Award Nominee Young Adult Fantasy & Science Fiction (2015)"
    ],
    "categories": [
      "Fantasy",
      "Romance",
      "Young Adult"
    ],
    "scores": {
      "fantasy": 10,
      "character": 9,
      "fast": 8,
      "dark": 6,
      "atmosphere": 9,
      "heart": 9,
      "emotional": 9,
      "series": 10,
      "modern": 10,
      "mind": 5
    }
  },
  {
    "id": 129,
    "title": "The Fifth Season",
    "author": "N.K. Jemisin",
    "publicationYear": 2015,
    "series": {
      "name": "The Broken Earth",
      "position": 1
    },
    "isbn": "0316229296",
    "googleBooksId": "placeholder129",
    "image": "https://books.google.com/books/content?id=tNPQnQEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "This is the way the world ends. For the last time. It starts with the great red rift across the heart of the world's sole continent, spewing ash that blots out the sun. It starts with death, with a murdered son and a missing daughter. It starts with betrayal, and long dormant wounds rising up to fester.",
    "rating": 4.29,
    "ratingsCount": 335194,
    "pageCount": 468,
    "awards": [
      "Hugo Award Best Novel (2016)",
      "Nebula Award Best Novel (2015)",
      "Locus Award Best Fantasy Novel (2016)",
      "Goodreads Choice Award Fantasy (2015)"
    ],
    "categories": [
      "Fantasy",
      "Science Fiction"
    ],
    "scores": {
      "fantasy": 9,
      "scifi": 6,
      "literary": 9,
      "character": 10,
      "slow": 6,
      "dark": 9,
      "atmosphere": 10,
      "series": 10,
      "modern": 10,
      "mind": 9,
      "emotional": 8
    }
  },
  {
    "id": 130,
    "title": "The Bear and the Nightingale",
    "author": "Katherine Arden",
    "publicationYear": 2017,
    "series": {
      "name": "The Winternight Trilogy",
      "position": 1
    },
    "isbn": "1101885939",
    "googleBooksId": "placeholder130",
    "image": "https://books.google.com/books/content?id=1pKTEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "At the edge of the Russian wilderness, winter lasts most of the year and the snowdrifts grow taller than houses. But Vasilisa doesn't mind—she spends the winter nights huddled around the embers of a fire with her beloved siblings, listening to her nurse's fairy tales.",
    "rating": 4.08,
    "ratingsCount": 235542,
    "pageCount": 319,
    "awards": [
      "Locus Award Best First Novel (2018)",
      "Goodreads Choice Award Debut Goodreads Author (2017)",
      "BookNest Award Best Debut Novel (2017)"
    ],
    "categories": [
      "Fantasy",
      "Historical Fiction"
    ],
    "scores": {
      "fantasy": 10,
      "historical": 7,
      "literary": 8,
      "character": 9,
      "slow": 6,
      "dark": 6,
      "atmosphere": 10,
      "emotional": 8,
      "series": 8,
      "classic": 7,
      "heart": 8,
      "mind": 6
    }
  },
  {
    "id": 131,
    "title": "The Lies of Locke Lamora",
    "author": "Scott Lynch",
    "publicationYear": 2006,
    "series": {
      "name": "Gentleman Bastard",
      "position": 1
    },
    "isbn": "055358894X",
    "googleBooksId": "placeholder131",
    "image": "https://books.google.com/books/content?id=aWFm1w-nU30C&printsec=frontcover&img=1&zoom=3",
    "synopsis": "An orphan's life is harsh—and often short—in the mysterious island city of Camorr. But young Locke Lamora dodges death and slavery, becoming a thief under the tutelage of a gifted con artist. As leader of the band of light-fingered brothers known as the Gentleman Bastards, Locke is soon infamous.",
    "rating": 4.3,
    "ratingsCount": 342515,
    "pageCount": 499,
    "awards": [
      "Locus Award Best First Novel (2007)",
      "World Fantasy Award Best Novel Nominee (2007)",
      "Compton Crook Award (2007)",
      "British Fantasy Award Best Novel (2007)"
    ],
    "categories": [
      "Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "plot": 10,
      "character": 9,
      "fast": 8,
      "dark": 7,
      "atmosphere": 10,
      "series": 8,
      "modern": 10,
      "mind": 7,
      "emotional": 6
    }
  },
  {
    "id": 132,
    "title": "Priory of the Orange Tree",
    "author": "Samantha Shannon",
    "publicationYear": 2019,
    "series": {
      "name": "The Roots of Chaos",
      "position": 1
    },
    "isbn": "1635570298",
    "googleBooksId": "placeholder132",
    "image": "https://books.google.com/books/content?id=bfmRDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A world divided. A queendom without an heir. An ancient enemy awakens. The House of Berethnet has ruled Inys for a thousand years. Still unwed, Queen Sabran the Ninth must conceive a daughter to protect her realm from destruction—but assassins are getting closer to her door.",
    "rating": 4.17,
    "ratingsCount": 280170,
    "pageCount": 848,
    "awards": [
      "Lambda Literary Award LGBT SF/Fantasy/Horror (2019)",
      "Goodreads Choice Award Fantasy Nominee (2019)"
    ],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "plot": 8,
      "character": 9,
      "slow": 7,
      "dark": 6,
      "atmosphere": 10,
      "standalone": 10,
      "modern": 10,
      "mind": 7,
      "emotional": 7
    }
  },
  {
    "id": 134,
    "title": "Howl's Moving Castle",
    "author": "Diana Wynne Jones",
    "publicationYear": 1986,
    "series": {
      "name": "Howl's Moving Castle",
      "position": 1
    },
    "isbn": "0061478784",
    "googleBooksId": "placeholder134",
    "image": "https://books.google.com/books/content?id=WxPDPOCF2_cC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Sophie has the great misfortune of being the eldest of three daughters, destined to fail miserably should she ever leave home to seek her fate. But when she unwittingly attracts the ire of the Witch of the Waste, Sophie finds herself under a horrid spell that transforms her into an old lady.",
    "rating": 4.28,
    "ratingsCount": 449520,
    "pageCount": 329,
    "awards": [
      "Phoenix Award (2006)",
      "Boston Globe-Horn Book Award (1987)"
    ],
    "categories": [
      "Fantasy",
      "Young Adult"
    ],
    "scores": {
      "fantasy": 10,
      "character": 9,
      "medium": 7,
      "optimistic": 8,
      "atmosphere": 10,
      "heart": 9,
      "emotional": 8,
      "standalone": 10,
      "classic": 8,
      "mind": 6
    }
  },
  {
    "id": 135,
    "title": "Uprooted",
    "author": "Naomi Novik",
    "publicationYear": 2015,
    "isbn": "0804179034",
    "googleBooksId": "placeholder135",
    "image": "https://books.google.com/books/content?id=ITfXoAEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Agnieszka loves her valley home. But the corrupted Wood stands on the border, full of malevolent power, and its shadow lies over her life. Her people rely on the cold, driven wizard known only as the Dragon to keep its powers at bay. But he demands a terrible price for his help: one young woman handed over to serve him for ten years.",
    "rating": 4.02,
    "ratingsCount": 264467,
    "pageCount": 438,
    "awards": [
      "Hugo Award Best Novel (2016)",
      "Nebula Award Best Novel (2015)",
      "Locus Award Best Fantasy Novel (2016)",
      "Goodreads Choice Award YA Fantasy & Science Fiction (2015)"
    ],
    "categories": [
      "Fantasy",
      "Romance"
    ],
    "scores": {
      "fantasy": 10,
      "character": 9,
      "medium": 7,
      "dark": 6,
      "atmosphere": 10,
      "heart": 8,
      "emotional": 9,
      "standalone": 10,
      "modern": 10,
      "mind": 6
    }
  },
  {
    "id": 138,
    "title": "When Breath Becomes Air",
    "author": "Paul Kalanithi",
    "publicationYear": 2016,
    "isbn": "081298840X",
    "googleBooksId": "placeholder138",
    "image": "https://books.google.com/books/content?id=93faCwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "At the age of thirty-six, on the verge of completing a decade's worth of training as a neurosurgeon, Paul Kalanithi was diagnosed with stage IV lung cancer. One day he was a doctor treating the dying, and the next he was a patient struggling to live.",
    "rating": 4.41,
    "ratingsCount": 810501,
    "pageCount": 208,
    "awards": [
      "Pulitzer Prize Biography Finalist (2017)",
      "Wellcome Book Prize (2017)",
      "Goodreads Choice Award Memoir & Autobiography (2016)",
      "Waterstones Book of the Year (2016)"
    ],
    "categories": [
      "Memoir",
      "Nonfiction",
      "Health"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "literary": 8,
      "character": 10,
      "medium": 6,
      "dark": 9,
      "emotional": 10,
      "standalone": 10,
      "modern": 10,
      "mind": 9,
      "heart": 10
    }
  },
  {
    "id": 140,
    "title": "The Glass Castle",
    "author": "Jeannette Walls",
    "publicationYear": 2005,
    "isbn": "074324754X",
    "googleBooksId": "placeholder140",
    "image": "https://books.google.com/books/content?id=C38qswEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A tender, moving tale of unconditional love in a family that, despite its profound flaws, gave the author the fiery determination to carve out a successful life on her own terms. Jeannette Walls grew up with parents whose ideals and stubborn nonconformity were both their curse and their salvation.",
    "rating": 4.33,
    "ratingsCount": 1366196,
    "pageCount": 288,
    "awards": [
      "ALA Alex Award (2006)",
      "Lincoln Award (2008)"
    ],
    "categories": [
      "Memoir",
      "Biography",
      "Nonfiction"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "literary": 8,
      "character": 10,
      "medium": 7,
      "dark": 7,
      "emotional": 10,
      "standalone": 10,
      "classic": 7,
      "mind": 6,
      "heart": 10
    }
  },
  {
    "id": 141,
    "title": "The Immortal Life of Henrietta Lacks",
    "author": "Rebecca Skloot",
    "publicationYear": 2010,
    "isbn": "1400052181",
    "googleBooksId": "placeholder141",
    "image": "https://books.google.com/books/content?id=aOpAx3-czwIC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Her name was Henrietta Lacks, but scientists know her as HeLa. She was a poor Southern tobacco farmer who died in 1951, yet her cells—taken without her knowledge—became one of the most important tools in medicine. The first 'immortal' human cells grown in culture, they are still alive today.",
    "rating": 4.13,
    "ratingsCount": 806514,
    "pageCount": 370,
    "awards": [
      "Wellcome Book Prize (2010)",
      "Audie Award Nonfiction (2011)",
      "Goodreads Choice Award Nonfiction (2010)",
      "Goodreads Choice Award Debut Author (2010)"
    ],
    "categories": [
      "Nonfiction",
      "Biography",
      "Science"
    ],
    "scores": {
      "memoir": 7,
      "nonfiction": 10,
      "literary": 8,
      "character": 9,
      "medium": 6,
      "dark": 7,
      "emotional": 9,
      "standalone": 10,
      "modern": 10,
      "mind": 10,
      "heart": 8
    }
  },
  {
    "id": 142,
    "title": "Know My Name",
    "author": "Chanel Miller",
    "publicationYear": 2019,
    "isbn": "073522370X",
    "googleBooksId": "placeholder142",
    "image": "https://books.google.com/books/content?id=XUCzDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "She was known to the world as Emily Doe when she stunned millions with a letter. Brock Turner had been sentenced to just six months in county jail after he was found sexually assaulting her on Stanford's campus. Her victim impact statement was posted on BuzzFeed, where it instantly went viral—viewed by eleven million people.",
    "rating": 4.68,
    "ratingsCount": 259089,
    "pageCount": 384,
    "awards": [
      "National Book Critics Circle Award Autobiography (2019)",
      "Dayton Literary Peace Prize Nonfiction (2020)",
      "Goodreads Choice Award Memoir & Autobiography (2019)"
    ],
    "categories": [
      "Memoir",
      "Nonfiction"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "literary": 9,
      "character": 10,
      "medium": 6,
      "dark": 8,
      "emotional": 10,
      "standalone": 10,
      "modern": 10,
      "mind": 8,
      "heart": 9
    }
  },
  {
    "id": 143,
    "title": "Wild",
    "author": "Cheryl Strayed",
    "publicationYear": 2012,
    "isbn": "0307476073",
    "googleBooksId": "placeholder143",
    "image": "https://books.google.com/books/content?id=CdtYvZwZUFQC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "At twenty-two, Cheryl Strayed thought she had lost everything. In the wake of her mother's death, her family scattered and her own marriage was soon destroyed. Four years later, with nothing more to lose, she made the most impulsive decision of her life: to hike the Pacific Crest Trail from the Mojave Desert through California and Oregon to Washington State.",
    "rating": 4.07,
    "ratingsCount": 869258,
    "pageCount": 336,
    "awards": [
      "Goodreads Choice Award Memoir & Autobiography (2012)",
      "Indies Choice Book Award Adult Nonfiction (2013)"
    ],
    "categories": [
      "Memoir",
      "Nonfiction",
      "Adventure"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "character": 10,
      "medium": 7,
      "dark": 6,
      "optimistic": 8,
      "emotional": 10,
      "standalone": 10,
      "modern": 10,
      "mind": 6,
      "heart": 9
    }
  },
  {
    "id": 144,
    "title": "Long Walk to Freedom",
    "author": "Nelson Mandela",
    "publicationYear": 1994,
    "isbn": "0316548189",
    "googleBooksId": "placeholder144",
    "image": "https://books.google.com/books/content?id=RHwLqVrnXgIC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Nelson Mandela is one of the great moral and political leaders of our time: an international hero whose lifelong dedication to the fight against racial oppression in South Africa won him the Nobel Peace Prize and the presidency of his country. Since his triumphant release in 1990, Mandela has been at the center of the most compelling drama.",
    "rating": 4.36,
    "ratingsCount": 94454,
    "pageCount": 656,
    "awards": [
      "Alan Paton Award (1995)"
    ],
    "categories": [
      "Biography",
      "Memoir",
      "Nonfiction"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "historical": 9,
      "character": 10,
      "slow": 7,
      "dark": 7,
      "optimistic": 8,
      "emotional": 9,
      "standalone": 10,
      "classic": 9,
      "mind": 9,
      "heart": 9
    }
  },
  {
    "id": 145,
    "title": "Ender's Game",
    "author": "Orson Scott Card",
    "publicationYear": 1985,
    "series": {
      "name": "Ender's Saga",
      "position": 1
    },
    "isbn": "0812550706",
    "googleBooksId": "placeholder145",
    "image": "https://books.google.com/books/content?id=5tCSc9pZPBwC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In order to develop a secure defense against a hostile alien race's next attack, government agencies breed child geniuses and train them as soldiers. A brilliant young boy, Andrew 'Ender' Wiggin lives with his kind but distant parents, his sadistic brother Peter, and the person he loves more than anyone else, his sister Valentine.",
    "rating": 4.31,
    "ratingsCount": 1475870,
    "pageCount": 324,
    "awards": [
      "Hugo Award Best Novel (1986)",
      "Nebula Award Best Novel (1985)",
      "Margaret A. Edwards Award (2008)"
    ],
    "categories": [
      "Science Fiction",
      "Young Adult"
    ],
    "scores": {
      "scifi": 10,
      "character": 9,
      "plot": 10,
      "fast": 8,
      "dark": 7,
      "emotional": 8,
      "series": 8,
      "classic": 9,
      "mind": 9,
      "heart": 7
    }
  },
  {
    "id": 147,
    "title": "Foundation",
    "author": "Isaac Asimov",
    "publicationYear": 1951,
    "isbn": "0553293354",
    "googleBooksId": "placeholder147",
    "image": "https://books.google.com/books/content?id=Gf6NEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "For twelve thousand years the Galactic Empire has ruled supreme. Now it is dying. But only Hari Seldon, creator of the revolutionary science of psychohistory, can see into the future—to a dark age of ignorance, barbarism, and warfare that will last thirty thousand years.",
    "rating": 4.17,
    "ratingsCount": 597885,
    "pageCount": 244,
    "awards": [
      "Hugo Award Best All-Time Series (1966)"
    ],
    "categories": [
      "Science Fiction",
      "Classic"
    ],
    "scores": {
      "scifi": 10,
      "plot": 9,
      "medium": 7,
      "atmosphere": 9,
      "series": 10,
      "classic": 10,
      "mind": 10,
      "emotional": 4,
      "character": 5,
      "accessible": 7
    }
  },
  {
    "id": 148,
    "title": "Neuromancer",
    "author": "William Gibson",
    "publicationYear": 1984,
    "series": {
      "name": "Sprawl",
      "position": 1
    },
    "isbn": "0441569595",
    "googleBooksId": "placeholder148",
    "image": "https://books.google.com/books/content?id=958sAQAAIAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Case was the sharpest data-thief in the matrix—until he crossed the wrong people and they crippled his nervous system, banishing him from cyberspace. Now a mysterious new employer has recruited Case for a last-chance run against an unthinkably powerful artificial intelligence.",
    "rating": 3.89,
    "ratingsCount": 365356,
    "pageCount": 268,
    "awards": [
      "Hugo Award Best Novel (1985)",
      "Nebula Award Best Novel (1984)",
      "Philip K. Dick Award (1985)",
      "Locus Award Best First Novel (1985)"
    ],
    "categories": [
      "Science Fiction",
      "Cyberpunk"
    ],
    "scores": {
      "scifi": 10,
      "literary": 8,
      "character": 7,
      "medium": 6,
      "dark": 8,
      "atmosphere": 10,
      "series": 7,
      "classic": 10,
      "mind": 10,
      "emotional": 5
    }
  },
  {
    "id": 149,
    "title": "The Left Hand of Darkness",
    "author": "Ursula K. Le Guin",
    "publicationYear": 1969,
    "series": {
      "name": "Hainish Cycle",
      "position": 4
    },
    "isbn": "0441478123",
    "googleBooksId": "placeholder149",
    "image": "https://books.google.com/books/content?id=gD9gDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A groundbreaking work of science fiction, The Left Hand of Darkness tells the story of a lone human emissary to Winter, an alien world whose inhabitants can choose—and change—their gender. His goal is to facilitate Winter's inclusion in a growing intergalactic civilization.",
    "rating": 4.1,
    "ratingsCount": 221728,
    "pageCount": 304,
    "awards": [
      "Hugo Award Best Novel (1970)",
      "Nebula Award Best Novel (1969)",
      "James Tiptree Jr. Award Retrospective (1995)"
    ],
    "categories": [
      "Science Fiction",
      "Classic"
    ],
    "scores": {
      "scifi": 10,
      "literary": 10,
      "character": 9,
      "slow": 7,
      "atmosphere": 10,
      "emotional": 7,
      "standalone": 10,
      "classic": 10,
      "mind": 10,
      "heart": 6
    }
  },
  {
    "id": 150,
    "title": "Recursion",
    "author": "Blake Crouch",
    "publicationYear": 2019,
    "isbn": "1524759783",
    "googleBooksId": "placeholder150",
    "image": "https://books.google.com/books/content?id=D6uZDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Memory makes reality. That's what New York City cop Barry Sutton is learning as he investigates the devastating phenomenon the media has dubbed False Memory Syndrome. But is it actually a syndrome—or something far more terrifying?",
    "rating": 4.17,
    "ratingsCount": 318848,
    "pageCount": 329,
    "awards": [
      "Goodreads Choice Award Science Fiction (2019)",
      "Book of the Month Book of the Year Award (2019)"
    ],
    "categories": [
      "Science Fiction",
      "Thriller"
    ],
    "scores": {
      "scifi": 10,
      "thriller": 10,
      "character": 8,
      "plot": 10,
      "fast": 10,
      "dark": 7,
      "standalone": 10,
      "modern": 10,
      "mind": 10,
      "emotional": 7
    }
  },
  {
    "id": 151,
    "title": "Snow Crash",
    "author": "Neal Stephenson",
    "publicationYear": 1992,
    "isbn": "0553380958",
    "googleBooksId": "placeholder151",
    "image": "https://books.google.com/books/content?id=mqpvVydYo-8C&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In reality, Hiro Protagonist delivers pizza for Uncle Enzo's CosoNostra Pizza Inc., but in the Metaverse he's a warrior prince. Plunging headlong into the enigma of a new computer virus that's striking down hackers everywhere, he races along the neon-lit streets on a search-and-destroy mission.",
    "rating": 4.01,
    "ratingsCount": 298328,
    "pageCount": 559,
    "awards": [
      "Arthur C. Clarke Award (1994)",
      "British Science Fiction Association Award (1993)",
      "Prometheus Award Best Novel (1993)"
    ],
    "categories": [
      "Science Fiction",
      "Cyberpunk"
    ],
    "scores": {
      "scifi": 10,
      "plot": 9,
      "fast": 8,
      "dark": 6,
      "atmosphere": 10,
      "standalone": 10,
      "classic": 9,
      "mind": 9,
      "emotional": 5,
      "character": 5
    }
  },
  {
    "id": 152,
    "title": "The Three-Body Problem",
    "author": "Cixin Liu",
    "publicationYear": 2006,
    "series": {
      "name": "Remembrance of Earth's Past",
      "position": 1
    },
    "isbn": "0765382032",
    "googleBooksId": "placeholder152",
    "image": "https://books.google.com/books/content?id=TiZHrgEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Set against the backdrop of China's Cultural Revolution, a secret military project sends signals into space to establish contact with aliens. An alien civilization on the brink of destruction captures the signal and plans to invade Earth. Meanwhile, on Earth, different camps start forming, planning to either welcome the superior beings or fight against the invasion.",
    "rating": 4.08,
    "ratingsCount": 496832,
    "pageCount": 472,
    "awards": [
      "Hugo Award Best Novel (2015)",
      "Locus Award Best Science Fiction Novel (2015)",
      "John W. Campbell Memorial Award (2015)"
    ],
    "categories": [
      "Science Fiction",
      "Hard SF"
    ],
    "scores": {
      "scifi": 10,
      "plot": 9,
      "character": 7,
      "medium": 7,
      "dark": 7,
      "atmosphere": 9,
      "series": 9,
      "modern": 10,
      "mind": 10,
      "emotional": 6
    }
  },
  {
    "id": 153,
    "title": "Pride and Prejudice",
    "author": "Jane Austen",
    "publicationYear": 1813,
    "isbn": "0141439513",
    "googleBooksId": "uY6MEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=uY6MEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Elizabeth Bennet, a spirited young woman navigating the social expectations of provincial England, must overcome her own prejudices and society's rigid class structure when she encounters the enigmatic Mr. Darcy. A timeless exploration of love, pride, and the courage to see beyond first impressions.",
    "rating": 4.3,
    "ratingsCount": 4820341,
    "pageCount": 279,
    "awards": [
      "Audie Award Audiobook of the Year (2026)",
      "Goodreads Choice Award Audiobook (2025)"
    ],
    "categories": [
      "Classic Literature",
      "Romance",
      "Literary Fiction"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 10,
      "slow": 7,
      "heart": 9,
      "emotional": 9,
      "atmosphere": 9,
      "standalone": 10,
      "mind": 7,
      "optimistic": 8
    }
  },
  {
    "id": 154,
    "title": "To Kill a Mockingbird",
    "author": "Harper Lee",
    "publicationYear": 1960,
    "series": {
      "name": "To Kill a Mockingbird",
      "position": 1
    },
    "isbn": "0061120081",
    "googleBooksId": "ncuX8p2xLIUC",
    "image": "https://books.google.com/books/content?id=ncuX8p2xLIUC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Through the eyes of young Scout Finch, witness her father Atticus defend an innocent Black man in Depression-era Alabama. A powerful story of moral courage, compassion, and the loss of innocence that confronts the deep-rooted prejudices of the American South.",
    "rating": 4.26,
    "ratingsCount": 6904539,
    "pageCount": 323,
    "awards": [
      "Pulitzer Prize Fiction (1961)",
      "National Book Award Finalist Fiction (1961)",
      "Audie Award Classic (2007)"
    ],
    "categories": [
      "Classic Literature",
      "Literary Fiction",
      "Historical Fiction"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 10,
      "medium": 6,
      "slow": 6,
      "mind": 10,
      "emotional": 10,
      "dark": 7,
      "standalone": 10,
      "heart": 9,
      "historical": 8
    }
  },
  {
    "id": 155,
    "title": "The Great Gatsby",
    "author": "F. Scott Fitzgerald",
    "publicationYear": 1925,
    "isbn": "0743273567",
    "googleBooksId": "fIlQDwAAQBAJ",
    "image": "https://books.google.com/books/content?id=fIlQDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In the glittering Jazz Age of 1920s New York, the mysterious millionaire Jay Gatsby throws lavish parties, all in pursuit of recapturing his lost love, Daisy Buchanan. A tragic meditation on the American Dream, wealth, and the impossible nature of reclaiming the past.",
    "rating": 3.93,
    "ratingsCount": 5934409,
    "pageCount": 180,
    "awards": [
      "Grammy Award Best Spoken Word Album (2003)"
    ],
    "categories": [
      "Classic Literature",
      "Literary Fiction",
      "Romance"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 9,
      "slow": 6,
      "medium": 7,
      "dark": 8,
      "emotional": 9,
      "atmosphere": 10,
      "standalone": 10,
      "mind": 9,
      "heart": 7
    }
  },
  {
    "id": 156,
    "title": "Jane Eyre",
    "author": "Charlotte Brontë",
    "publicationYear": 1847,
    "isbn": "0141441143",
    "googleBooksId": "S_X3zAEACAAJ",
    "image": "https://books.google.com/books/content?id=S_X3zAEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Orphaned and mistreated as a child, Jane Eyre grows into a fiercely independent woman who becomes governess at Thornfield Hall. There she meets the brooding Mr. Rochester, igniting a passionate romance shadowed by dark secrets. A groundbreaking tale of a woman's search for love, independence, and self-respect.",
    "rating": 4.16,
    "ratingsCount": 2330294,
    "pageCount": 532,
    "categories": [
      "Classic Literature",
      "Romance",
      "Gothic",
      "Literary Fiction"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 10,
      "slow": 7,
      "dark": 7,
      "heart": 10,
      "emotional": 10,
      "atmosphere": 9,
      "standalone": 10,
      "mind": 7,
      "mystery": 5
    }
  },
  {
    "id": 157,
    "title": "1984",
    "author": "George Orwell",
    "publicationYear": 1949,
    "isbn": "0451524934",
    "googleBooksId": "YqvezwEACAAJ",
    "image": "https://books.google.com/books/content?id=uyr8BAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In a totalitarian future where Big Brother watches everything, Winston Smith struggles to maintain his humanity and independent thought. A chilling prophecy of surveillance, propaganda, and the corruption of truth that remains terrifyingly relevant today.",
    "rating": 4.2,
    "ratingsCount": 5485776,
    "pageCount": 368,
    "awards": [
      "Prometheus Hall of Fame Award (1984)"
    ],
    "categories": [
      "Classic Literature",
      "Dystopian",
      "Science Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "classic": 10,
      "scifi": 7,
      "literary": 10,
      "character": 8,
      "medium": 7,
      "slow": 8,
      "dark": 10,
      "mind": 10,
      "emotional": 7,
      "standalone": 10,
      "atmosphere": 9,
      "plot": 8
    }
  },
  {
    "id": 158,
    "title": "1776",
    "author": "David McCullough",
    "publicationYear": 2005,
    "isbn": "0743226720",
    "googleBooksId": "placeholder158",
    "image": "https://books.google.com/books/content?id=R1Jk-A4R5AYC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The year 1776 was pivotal in American history. In this masterful narrative, David McCullough brings to life the momentous year that saw the birth of American independence, from the darkest days of the Revolution to Washington's daring crossing of the Delaware. A vivid account of courage, perseverance, and the extraordinary individuals who fought for freedom.",
    "rating": 4.1,
    "ratingsCount": 248955,
    "pageCount": 386,
    "awards": [
      "Quill Award History/Current Events/Politics (2005)",
      "American Compass Best Book (2005)"
    ],
    "categories": [
      "History",
      "Nonfiction",
      "American History",
      "Biography"
    ],
    "scores": {
      "history": 10,
      "nonfiction": 10,
      "mind": 9,
      "character": 7,
      "medium": 7,
      "standalone": 10,
      "literary": 7,
      "emotional": 6,
      "optimistic": 7,
      "dark": 6
    }
  },
  {
    "id": 159,
    "title": "The Guns of August",
    "author": "Barbara W. Tuchman",
    "publicationYear": 1962,
    "isbn": "0345476093",
    "googleBooksId": "placeholder159",
    "image": "https://books.google.com/books/content?id=XWCPDQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In this Pulitzer Prize-winning classic, Barbara Tuchman meticulously chronicles the dramatic and tragic first month of World War I. With remarkable detail and narrative power, she explores the political and military decisions that led to one of history's deadliest conflicts, revealing how a single month shaped the course of the twentieth century.",
    "rating": 4.18,
    "ratingsCount": 84949,
    "pageCount": 710,
    "awards": [
      "Pulitzer Prize General Nonfiction (1963)"
    ],
    "categories": [
      "History",
      "Nonfiction",
      "Military History",
      "World War I"
    ],
    "scores": {
      "history": 10,
      "nonfiction": 10,
      "mind": 10,
      "literary": 8,
      "slow": 7,
      "dark": 8,
      "standalone": 10,
      "character": 6,
      "medium": 6,
      "emotional": 6
    }
  },
  {
    "id": 160,
    "title": "Unbroken",
    "author": "Laura Hillenbrand",
    "publicationYear": 2010,
    "isbn": "0812974492",
    "googleBooksId": "placeholder160",
    "image": "https://books.google.com/books/content?id=1PeLDQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In 1943, a bomber crashes into the Pacific Ocean. Against all odds, one young lieutenant survives. Louis Zamperini's story of survival at sea and in brutal Japanese POW camps is a testament to the resilience of the human spirit. An unforgettable true story of courage, redemption, and the strength to overcome unimaginable suffering.",
    "rating": 4.39,
    "ratingsCount": 999544,
    "pageCount": 475,
    "awards": [
      "Los Angeles Times Book Prize Biography (2010)",
      "Andrew Carnegie Medal for Nonfiction (2012)",
      "Goodreads Choice Award History & Biography (2010)",
      "Dayton Literary Peace Prize Nonfiction (2011)",
      "Indies Choice Book Award Nonfiction (2011)"
    ],
    "categories": [
      "History",
      "Nonfiction",
      "Biography",
      "World War II"
    ],
    "scores": {
      "history": 9,
      "memoir": 8,
      "nonfiction": 10,
      "mind": 8,
      "character": 10,
      "medium": 7,
      "fast": 6,
      "dark": 9,
      "emotional": 10,
      "optimistic": 7,
      "standalone": 10,
      "plot": 9
    }
  },
  {
    "id": 162,
    "title": "Ready Player One",
    "author": "Ernest Cline",
    "publicationYear": 2011,
    "series": {
      "name": "Ready Player One",
      "position": 1
    },
    "isbn": "0307887448",
    "googleBooksId": "placeholder162",
    "image": "https://books.google.com/books/content?id=rWuODQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In 2045, Wade Watts escapes a grim reality by immersing himself in the OASIS, a sprawling virtual world. When the OASIS creator dies, he leaves behind elaborate puzzles rooted in pop culture nostalgia. The first person to solve them inherits an enormous fortune, triggering a dangerous competition.",
    "rating": 4.23,
    "ratingsCount": 1303581,
    "pageCount": 480,
    "awards": [
      "Locus Award Best First Novel (2012)",
      "Prometheus Award Best Novel (2012)",
      "ALA Alex Award (2012)",
      "Goodreads Choice Award Science Fiction (2011)"
    ],
    "categories": [
      "Science Fiction",
      "Adventure",
      "Pop Culture"
    ],
    "scores": {
      "scifi": 10,
      "plot": 9,
      "fast": 9,
      "mind": 6,
      "character": 7,
      "optimistic": 7,
      "standalone": 10,
      "medium": 7,
      "atmosphere": 7,
      "dark": 5
    }
  },
  {
    "id": 163,
    "title": "The Hobbit",
    "author": "J.R.R. Tolkien",
    "publicationYear": 1937,
    "isbn": "054792822X",
    "googleBooksId": "LLSpngEACAAJ",
    "image": "https://books.google.com/books/content?id=LLSpngEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Bilbo Baggins, a respectable hobbit, is swept into an epic quest to reclaim the lost Dwarf Kingdom of Erebor from the fearsome dragon Smaug. Along the way, he discovers courage he never knew he had and a certain magic ring that will change the fate of Middle-earth forever.",
    "rating": 4.3,
    "ratingsCount": 4466139,
    "pageCount": 366,
    "awards": [
      "Keith Barker Millennium Book Award (2000)"
    ],
    "categories": [
      "Fantasy",
      "Classic",
      "Adventure"
    ],
    "scores": {
      "fantasy": 10,
      "classic": 9,
      "plot": 9,
      "optimistic": 8,
      "character": 8,
      "atmosphere": 9,
      "medium": 7,
      "standalone": 10,
      "literary": 7,
      "mind": 6
    }
  },
  {
    "id": 164,
    "title": "Gone Girl",
    "author": "Gillian Flynn",
    "publicationYear": 2012,
    "isbn": "0307588378",
    "googleBooksId": "placeholder164",
    "image": "https://books.google.com/books/content?id=mmWODQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "On their fifth wedding anniversary, Amy Dunne vanishes. As the police investigation deepens and media attention intensifies, Nick's oddly evasive behavior raises suspicions. Amy's diary reveals a darker picture of their marriage. A twisted psychological thriller that questions everything you think you know.",
    "rating": 4.15,
    "ratingsCount": 3456212,
    "pageCount": 415,
    "awards": [
      "Barry Award Best Novel (2013)",
      "Anthony Award Best Novel (2013)",
      "Edgar Award Best Novel (2013)",
      "Goodreads Choice Award Mystery & Thriller (2012)"
    ],
    "categories": [
      "Thriller",
      "Mystery",
      "Psychological"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 10,
      "plot": 10,
      "fast": 8,
      "dark": 9,
      "character": 9,
      "mind": 8,
      "standalone": 10,
      "medium": 7,
      "emotional": 6,
      "literary": 6
    }
  },
  {
    "id": 165,
    "title": "The Hitchhiker's Guide to the Galaxy",
    "author": "Douglas Adams",
    "publicationYear": 1979,
    "series": {
      "name": "The Hitchhiker's Guide to the Galaxy",
      "position": 1
    },
    "isbn": "0345391802",
    "googleBooksId": "placeholder165",
    "image": "https://books.google.com/books/content?id=ogWNEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Seconds before Earth is demolished for a galactic freeway, Arthur Dent is whisked into space by his friend Ford Prefect. Armed with only a towel and an electronic guidebook, Arthur embarks on the strangest adventure in the universe, discovering that the answer to life, the universe, and everything might not be what anyone expected.",
    "rating": 4.22,
    "ratingsCount": 2020668,
    "pageCount": 216,
    "categories": [
      "Science Fiction",
      "Comedy",
      "Adventure"
    ],
    "scores": {
      "scifi": 10,
      "plot": 9,
      "fast": 8,
      "optimistic": 9,
      "character": 7,
      "mind": 7,
      "standalone": 8,
      "literary": 6,
      "medium": 8,
      "classic": 5,
      "modern": 7
    }
  },
  {
    "id": 166,
    "title": "Hyperion",
    "author": "Dan Simmons",
    "publicationYear": 1989,
    "isbn": "0553283685",
    "googleBooksId": "placeholder166",
    "image": "https://books.google.com/books/content?id=wDVV6y-8YHEC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Seven pilgrims journey to the distant world of Hyperion to confront the Shrike, a legendary creature of pain and death. As they travel, each shares their tale—stories of love, loss, and terror that reveal the interconnected fate of humanity across space and time in this masterwork of science fiction.",
    "rating": 4.27,
    "ratingsCount": 300224,
    "pageCount": 500,
    "awards": [
      "Hugo Award Best Novel (1990)",
      "Locus Award Best Science Fiction Novel (1990)",
      "Arthur C. Clarke Award (1992)",
      "British Science Fiction Association Award Best Novel (1992)"
    ],
    "categories": [
      "Science Fiction",
      "Space Opera",
      "Literary"
    ],
    "scores": {
      "scifi": 10,
      "literary": 9,
      "character": 9,
      "plot": 8,
      "atmosphere": 9,
      "slow": 7,
      "mind": 9,
      "series": 7,
      "medium": 6,
      "emotional": 6,
      "classic": 5,
      "modern": 7
    }
  },
  {
    "id": 167,
    "title": "The Forever War",
    "author": "Joe Haldeman",
    "publicationYear": 1974,
    "series": {
      "name": "The Forever War",
      "position": 1
    },
    "isbn": "0312536631",
    "googleBooksId": "placeholder167",
    "image": "https://books.google.com/books/content?id=DZ_xzQEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Drafted into an interstellar war against the Taurans, soldier William Mandella fights battles across the galaxy. But time dilation means that while mere months pass for him, centuries fly by on Earth. Returning home becomes a journey into an alien future, making this both a gripping war story and a profound meditation on time and change.",
    "rating": 4.14,
    "ratingsCount": 180830,
    "pageCount": 278,
    "awards": [
      "Hugo Award Best Novel (1976)",
      "Nebula Award Best Novel (1975)",
      "Locus Award Best Novel (1976)",
      "Ditmar Award Best International Long Fiction (1976)"
    ],
    "categories": [
      "Science Fiction",
      "Military",
      "Classic"
    ],
    "scores": {
      "scifi": 10,
      "plot": 8,
      "fast": 7,
      "dark": 7,
      "mind": 8,
      "character": 7,
      "standalone": 10,
      "medium": 7,
      "literary": 7,
      "classic": 7
    }
  },
  {
    "id": 168,
    "title": "Ancillary Justice",
    "author": "Ann Leckie",
    "publicationYear": 2013,
    "isbn": "031624662X",
    "googleBooksId": "placeholder168",
    "image": "https://books.google.com/books/content?id=JYQ4lwEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Once a massive warship with thousands of bodies controlled by a single AI consciousness, Breq is now trapped in a single human form. Driven by revenge against the ruler who destroyed her, she embarks on a quest across the galaxy in this Hugo and Nebula Award-winning novel that revolutionized space opera.",
    "rating": 3.99,
    "ratingsCount": 119291,
    "pageCount": 386,
    "awards": [
      "Hugo Award Best Novel (2014)",
      "Nebula Award Best Novel (2013)",
      "Arthur C. Clarke Award (2014)",
      "Locus Award Best First Novel (2014)",
      "Philip K. Dick Award (2014)",
      "British Science Fiction Association Award (2013)",
      "Goodreads Choice Award Science Fiction (2013)"
    ],
    "categories": [
      "Science Fiction",
      "Space Opera"
    ],
    "scores": {
      "scifi": 10,
      "character": 8,
      "plot": 7,
      "mind": 8,
      "atmosphere": 7,
      "medium": 7,
      "series": 7,
      "literary": 7,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 169,
    "title": "Children of Time",
    "author": "Adrian Tchaikovsky",
    "publicationYear": 2015,
    "series": {
      "name": "Children of Time",
      "position": 1
    },
    "isbn": "0316452505",
    "googleBooksId": "placeholder169",
    "image": "https://books.google.com/books/content?id=49T5twEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A terraforming project goes wrong, and a planet intended for monkeys is instead inherited by spiders who evolve intelligence over millennia. When the last remnants of humanity arrive, desperate for a new home, they find a world already claimed. An epic tale spanning generations and species about evolution, survival, and understanding.",
    "rating": 4.3,
    "ratingsCount": 175804,
    "pageCount": 608,
    "awards": [
      "Arthur C. Clarke Award (2016)",
      "Hugo Award Best Series (2023)"
    ],
    "categories": [
      "Science Fiction",
      "Evolution"
    ],
    "scores": {
      "scifi": 10,
      "mind": 9,
      "atmosphere": 9,
      "character": 8,
      "plot": 8,
      "slow": 6,
      "medium": 7,
      "standalone": 8,
      "literary": 7,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 170,
    "title": "A Fire Upon the Deep",
    "author": "Vernor Vinge",
    "publicationYear": 1992,
    "series": {
      "name": "Zones of Thought",
      "position": 1
    },
    "isbn": "0812515285",
    "googleBooksId": "placeholder170",
    "image": "https://books.google.com/books/content?id=UGAKB3r0sZQC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In a universe where the laws of physics vary by location, an ancient evil awakens in the galaxy's center. Two children hold the key to stopping it, marooned on a medieval world where aliens exist as pack minds. A rescue mission races against time as civilizations fall. Hugo Award-winning space opera at its most imaginative.",
    "rating": 4.13,
    "ratingsCount": 66797,
    "pageCount": 613,
    "awards": [
      "Hugo Award Best Novel (1993)",
      "Locus Award Best Science Fiction Novel (1993)",
      "John W. Campbell Memorial Award (1993)"
    ],
    "categories": [
      "Science Fiction",
      "Space Opera"
    ],
    "scores": {
      "scifi": 10,
      "plot": 9,
      "atmosphere": 9,
      "mind": 8,
      "character": 7,
      "medium": 6,
      "slow": 6,
      "standalone": 9,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 171,
    "title": "The Diamond Age",
    "author": "Neal Stephenson",
    "publicationYear": 1995,
    "isbn": "0553380966",
    "googleBooksId": "placeholder171",
    "image": "https://books.google.com/books/content?id=n59TlhNAkSEC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In a future where nanotechnology has transformed society, a young girl named Nell receives an illegal interactive book designed to educate a wealthy man's daughter. This 'Young Lady's Illustrated Primer' becomes her guide through a harsh world, teaching her to think for herself in a society rigidly divided by technology and class.",
    "rating": 4.16,
    "ratingsCount": 93328,
    "pageCount": 499,
    "awards": [
      "Hugo Award Best Novel (1996)",
      "Locus Award Best Science Fiction Novel (1996)"
    ],
    "categories": [
      "Science Fiction",
      "Cyberpunk"
    ],
    "scores": {
      "scifi": 10,
      "mind": 9,
      "literary": 8,
      "atmosphere": 8,
      "character": 7,
      "plot": 7,
      "medium": 6,
      "slow": 6,
      "standalone": 10,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 172,
    "title": "Old Man's War",
    "author": "John Scalzi",
    "publicationYear": 2005,
    "isbn": "0765348276",
    "googleBooksId": "placeholder172",
    "image": "https://books.google.com/books/content?id=frIPmQEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "At 75, John Perry joins the Colonial Defense Forces, trading his elderly body for youth and a chance to fight for humanity among the stars. But the universe is more dangerous than he imagined, filled with hostile aliens competing for the same worlds. A witty, action-packed military SF adventure that asks what we'd sacrifice for a second chance at life.",
    "rating": 4.23,
    "ratingsCount": 225108,
    "pageCount": 318,
    "awards": [
      "Locus Award Best First Novel (2006)"
    ],
    "categories": [
      "Science Fiction",
      "Military"
    ],
    "scores": {
      "scifi": 10,
      "plot": 9,
      "fast": 8,
      "character": 8,
      "optimistic": 6,
      "mind": 6,
      "medium": 8,
      "series": 7,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 173,
    "title": "Rendezvous with Rama",
    "author": "Arthur C. Clarke",
    "publicationYear": 1973,
    "series": {
      "name": "Rama",
      "position": 1
    },
    "isbn": "0553287893",
    "googleBooksId": "placeholder173",
    "image": "https://books.google.com/books/content?id=bjGUYDYaRBQC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A massive cylindrical alien spacecraft enters the solar system, and a hastily assembled crew is sent to explore it before it passes. Inside Rama, they discover a world of wonders—artificial cities, mechanical creatures, and mysteries that challenge everything they thought they knew. Clarke's sense-of-wonder classic earned the Hugo, Nebula, and Campbell awards.",
    "rating": 4.12,
    "ratingsCount": 184691,
    "pageCount": 243,
    "awards": [
      "Hugo Award Best Novel (1974)",
      "Nebula Award Best Novel (1973)",
      "Locus Award Best Novel (1974)",
      "British Science Fiction Association Award Novel (1973)",
      "Jupiter Award Best Novel (1974)",
      "John W. Campbell Memorial Award (1974)"
    ],
    "categories": [
      "Science Fiction",
      "Classic",
      "Hard SF"
    ],
    "scores": {
      "scifi": 10,
      "atmosphere": 9,
      "mind": 9,
      "plot": 7,
      "slow": 7,
      "character": 5,
      "standalone": 8,
      "medium": 7,
      "classic": 8,
      "emotional": 6
    }
  },
  {
    "id": 174,
    "title": "The Dispossessed",
    "author": "Ursula K. Le Guin",
    "publicationYear": 1974,
    "series": {
      "name": "Hainish Cycle",
      "position": 6
    },
    "isbn": "0061054887",
    "googleBooksId": "placeholder174",
    "image": "https://books.google.com/books/content?id=h9ysQgAACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Physicist Shevek travels between two worlds: his anarchist moon home and the capitalist planet it orbits. His revolutionary theory could unite the worlds, but political forces on both sides want to control it. Le Guin's Hugo and Nebula Award winner is a profound exploration of freedom, society, and what it truly means to be free.",
    "rating": 4.26,
    "ratingsCount": 151804,
    "pageCount": 387,
    "awards": [
      "Hugo Award Best Novel (1975)",
      "Nebula Award Best Novel (1974)",
      "Locus Award Best Novel (1975)",
      "Jupiter Award Best Novel (1975)",
      "John W. Campbell Memorial Award (1975)",
      "Prometheus Hall of Fame Award (1993)"
    ],
    "categories": [
      "Science Fiction",
      "Literary",
      "Classic"
    ],
    "scores": {
      "scifi": 10,
      "literary": 10,
      "mind": 10,
      "character": 8,
      "slow": 8,
      "standalone": 10,
      "medium": 5,
      "classic": 8,
      "plot": 5,
      "emotional": 6
    }
  },
  {
    "id": 175,
    "title": "Assassin's Apprentice",
    "author": "Robin Hobb",
    "publicationYear": 1995,
    "isbn": "055357339X",
    "googleBooksId": "placeholder175",
    "image": "https://books.google.com/books/content?id=bbXZCwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Young FitzChivalry Farseer is a royal bastard, raised in the shadows of a king's court. Trained as an assassin to serve his uncle, he must navigate deadly politics, ancient magic, and his own forbidden gifts. Hobb's beloved series opener is an intimate character study wrapped in epic fantasy, where loyalty and love exact brutal costs.",
    "rating": 4.19,
    "ratingsCount": 403418,
    "pageCount": 435,
    "awards": [
      "Locus Award Fantasy (1996)",
      "Compton Crook Award (1996)",
      "British Fantasy Award Best Novel (1997)"
    ],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "character": 10,
      "slow": 7,
      "dark": 6,
      "emotional": 8,
      "series": 9,
      "plot": 7,
      "medium": 6,
      "literary": 7,
      "modern": 8
    }
  },
  {
    "id": 176,
    "title": "The Blade Itself",
    "author": "Joe Abercrombie",
    "publicationYear": 2006,
    "isbn": "0316387312",
    "googleBooksId": "placeholder176",
    "image": "https://books.google.com/books/content?id=wwspvAEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A crippled torturer, a vain barbarian, and a selfish nobleman become unlikely pawns in a war that will reshape their world. Abercrombie's debut revolutionized fantasy with morally gray characters, brutal realism, and razor-sharp wit. This is epic fantasy for those tired of heroes—where the good guys might not exist at all.",
    "rating": 4.22,
    "ratingsCount": 313345,
    "pageCount": 515,
    "awards": [
      "Locus Award Best First Novel (2007)",
      "Compton Crook Award (2008)"
    ],
    "categories": [
      "Fantasy",
      "Grimdark",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "dark": 9,
      "character": 9,
      "plot": 8,
      "literary": 7,
      "medium": 6,
      "series": 8,
      "mind": 6,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 177,
    "title": "Gardens of the Moon",
    "author": "Steven Erikson",
    "publicationYear": 1999,
    "isbn": "0765348780",
    "googleBooksId": "placeholder177",
    "image": "https://books.google.com/books/content?id=817rmAEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The Malazan Empire expands through conquest, but the city of Pale resists. Gods walk among mortals, ancient powers awaken, and soldiers become caught in games far beyond their understanding. The opening of Erikson's ten-book epic throws readers into a rich, complex world where nothing is explained and everything matters.",
    "rating": 3.93,
    "ratingsCount": 137916,
    "pageCount": 666,
    "awards": [
      "Locus Award Best First Novel (2000)",
      "World Fantasy Award Best Novel (2000)"
    ],
    "categories": [
      "Fantasy",
      "Epic Fantasy",
      "Military"
    ],
    "scores": {
      "fantasy": 10,
      "atmosphere": 10,
      "character": 8,
      "slow": 8,
      "dark": 7,
      "mind": 9,
      "series": 10,
      "medium": 4,
      "literary": 8,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 178,
    "title": "The City of Brass",
    "author": "S.A. Chakraborty",
    "publicationYear": 2017,
    "isbn": "0062678108",
    "googleBooksId": "placeholder178",
    "image": "https://books.google.com/books/content?id=QPBbAQAACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In 18th-century Cairo, con artist Nahri accidentally summons a warrior djinn who drags her to Daevabad, the legendary City of Brass. There she discovers she's part of a magical race she never knew existed, caught in centuries-old political intrigue. Rich with Middle Eastern folklore, this is fantasy that feels both fresh and ancient.",
    "rating": 4.14,
    "ratingsCount": 155222,
    "pageCount": 532,
    "awards": [
      "Locus Award Best First Novel (2018)",
      "World Fantasy Award Best Novel (2018)",
      "Compton Crook Award (2019)",
      "British Fantasy Award Best Newcomer (2018)"
    ],
    "categories": [
      "Fantasy",
      "Historical Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "atmosphere": 9,
      "character": 8,
      "plot": 8,
      "emotional": 7,
      "series": 8,
      "medium": 6,
      "literary": 7,
      "historical": 6,
      "modern": 8
    }
  },
  {
    "id": 179,
    "title": "American Gods",
    "author": "Neil Gaiman",
    "publicationYear": 2001,
    "series": {
      "name": "American Gods",
      "position": 1
    },
    "isbn": "0062059882",
    "googleBooksId": "placeholder179",
    "image": "https://books.google.com/books/content?id=fXfJCKXp5-kC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Shadow Moon gets out of prison to find his wife dead and a mysterious stranger offering him a job. Soon he's swept into a hidden war between the old gods brought to America by immigrants and the new gods of technology and media. Gaiman's Hugo and Nebula winner is a dark American road trip through mythology and belief.",
    "rating": 4.1,
    "ratingsCount": 991929,
    "pageCount": 635,
    "awards": [
      "Hugo Award Best Novel (2002)",
      "Nebula Award Best Novel (2002)",
      "Bram Stoker Award Best Novel (2001)",
      "World Fantasy Award Best Novel (2002)",
      "Locus Award Best Fantasy Novel (2002)",
      "British Fantasy Award Best Novel (2002)"
    ],
    "categories": [
      "Fantasy",
      "Contemporary Fantasy",
      "Mythology"
    ],
    "scores": {
      "fantasy": 9,
      "contemporary": 7,
      "literary": 9,
      "character": 9,
      "dark": 7,
      "slow": 7,
      "mind": 8,
      "standalone": 9,
      "medium": 5,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 180,
    "title": "Good Omens",
    "author": "Neil Gaiman & Terry Pratchett",
    "publicationYear": 1990,
    "isbn": "0060853980",
    "googleBooksId": "placeholder180",
    "image": "https://books.google.com/books/content?id=7erEbfDOcgkC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The angel Aziraphale and demon Crowley have grown fond of Earth over 6,000 years. When the apocalypse is scheduled for Saturday, they decide to prevent it—if they can find the misplaced Antichrist. A wickedly funny collaboration between two masters of fantasy, blending biblical prophecy with British humor and genuine friendship.",
    "rating": 4.25,
    "ratingsCount": 826526,
    "pageCount": 491,
    "awards": [
      "Locus Award Best Fantasy Novel (1991)",
      "World Fantasy Award Best Novel (1991)"
    ],
    "categories": [
      "Fantasy",
      "Comedy",
      "Contemporary Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "optimistic": 9,
      "plot": 8,
      "fast": 7,
      "character": 8,
      "medium": 8,
      "standalone": 10,
      "literary": 7,
      "contemporary": 6,
      "modern": 8
    }
  },
  {
    "id": 181,
    "title": "The Once and Future King",
    "author": "T.H. White",
    "publicationYear": 1958,
    "isbn": "0441627404",
    "googleBooksId": "placeholder181",
    "image": "https://books.google.com/books/content?id=kdLT8_tnpmEC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "From Arthur's education by Merlyn through the glory and tragedy of Camelot, White reimagines the Arthurian legend with humor, wisdom, and heartbreak. This beloved classic transforms the familiar tale into a meditation on power, justice, and whether might can ever make right. The definitive retelling that inspired everything from Disney to Broadway.",
    "rating": 4.07,
    "ratingsCount": 119059,
    "pageCount": 639,
    "categories": [
      "Fantasy",
      "Classic",
      "Arthurian"
    ],
    "scores": {
      "fantasy": 10,
      "classic": 9,
      "literary": 9,
      "character": 8,
      "slow": 7,
      "emotional": 7,
      "standalone": 10,
      "medium": 5,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 182,
    "title": "Jonathan Strange & Mr Norrell",
    "author": "Susanna Clarke",
    "publicationYear": 2004,
    "series": {
      "name": "Strange & Norrell",
      "position": 1
    },
    "isbn": "0765356155",
    "googleBooksId": "placeholder182",
    "image": "https://books.google.com/books/content?id=uGHWsBJx6KQC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In an alternate 19th-century England, magic has returned through two very different magicians: the reclusive scholar Mr Norrell and the charismatic Jonathan Strange. Their collaboration and rivalry reshape England during the Napoleonic Wars, but their ambitions awaken something dangerous. A masterwork of literary fantasy, complete with footnotes.",
    "rating": 3.87,
    "ratingsCount": 255676,
    "pageCount": 1006,
    "awards": [
      "Hugo Award Best Novel (2005)",
      "World Fantasy Award Novel (2005)",
      "Locus Award Best First Novel (2005)",
      "British Fantasy Award Best Novel (2005)",
      "Mythopoeic Fantasy Award Adult Literature (2005)"
    ],
    "categories": [
      "Fantasy",
      "Historical Fantasy",
      "Literary"
    ],
    "scores": {
      "fantasy": 10,
      "literary": 10,
      "atmosphere": 9,
      "slow": 9,
      "character": 8,
      "historical": 7,
      "standalone": 10,
      "medium": 3,
      "plot": 5,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 183,
    "title": "The Last Wish",
    "author": "Andrzej Sapkowski",
    "publicationYear": 1993,
    "isbn": "0316029181",
    "googleBooksId": "placeholder183",
    "image": "https://books.google.com/books/content?id=GkqdlwEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Geralt of Rivia is a witcher—a mutant monster hunter for hire. In this collection of interconnected tales, he battles supernatural threats while navigating a world where humans are often more monstrous than the creatures he kills. The book that spawned a phenomenon, blending Slavic folklore with moral complexity and dark humor.",
    "rating": 4.14,
    "ratingsCount": 417935,
    "pageCount": 400,
    "awards": [
      "Premio Ignotus Mejor Antología (2003)"
    ],
    "categories": [
      "Fantasy",
      "Dark Fantasy",
      "Short Stories"
    ],
    "scores": {
      "fantasy": 10,
      "plot": 8,
      "character": 8,
      "dark": 7,
      "fast": 7,
      "series": 7,
      "medium": 8,
      "standalone": 7,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 184,
    "title": "The Darkness That Comes Before",
    "author": "R. Scott Bakker",
    "publicationYear": 2003,
    "isbn": "1590201183",
    "googleBooksId": "placeholder184",
    "image": "https://books.google.com/books/content?id=O1a9jwEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "As holy war erupts across a vast empire, a mysterious prophet, a deadly assassin, and a barbarian warlord converge on an ancient fortress city. Bakker's philosophical epic questions free will, consciousness, and the nature of belief itself. Dense, dark, and deeply challenging—this is fantasy for readers who want their minds as engaged as their imaginations.",
    "rating": 3.84,
    "ratingsCount": 23723,
    "pageCount": 608,
    "categories": [
      "Fantasy",
      "Grimdark",
      "Philosophical"
    ],
    "scores": {
      "fantasy": 10,
      "literary": 9,
      "dark": 9,
      "mind": 9,
      "character": 8,
      "slow": 8,
      "series": 10,
      "medium": 4,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 185,
    "title": "The Da Vinci Code",
    "author": "Dan Brown",
    "publicationYear": 2003,
    "series": {
      "name": "Robert Langdon",
      "position": 2
    },
    "isbn": "0307474275",
    "googleBooksId": "placeholder185",
    "image": "https://books.google.com/books/content?id=YuDl2Wl651AC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "When a curator is murdered at the Louvre, symbologist Robert Langdon discovers a trail of clues hidden in art and symbols. Racing through Paris with the victim's granddaughter, he uncovers a secret society protecting an explosive truth about Christianity. A globe-spanning thriller that became a cultural phenomenon, blending history, conspiracy, and breakneck pacing.",
    "rating": 3.94,
    "ratingsCount": 2528473,
    "pageCount": 489,
    "awards": [
      "British Book Award Book of the Year (2005)",
      "Book Sense Book of the Year Award Adult Fiction (2004)"
    ],
    "categories": [
      "Thriller",
      "Mystery",
      "Historical"
    ],
    "scores": {
      "thriller": 9,
      "mystery": 9,
      "plot": 10,
      "fast": 9,
      "mind": 6,
      "medium": 7,
      "standalone": 9,
      "historical": 5,
      "character": 5,
      "dark": 7,
      "modern": 8
    }
  },
  {
    "id": 186,
    "title": "The Girl with the Dragon Tattoo",
    "author": "Stieg Larsson",
    "publicationYear": 2005,
    "isbn": "0307949486",
    "googleBooksId": "placeholder186",
    "image": "https://books.google.com/books/content?id=o53ilir4yXcC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Disgraced journalist Mikael Blomkvist is hired to solve a forty-year-old disappearance in a wealthy family. Aided by brilliant hacker Lisbeth Salander, he uncovers dark secrets of violence and corruption. The international bestseller that launched a phenomenon, combining mystery, social criticism, and unforgettable characters.",
    "rating": 4.18,
    "ratingsCount": 3454248,
    "pageCount": 480,
    "awards": [
      "Barry Award Mystery/Crime Novel Of the Decade (2010)",
      "Macavity Award Best First Mystery Novel (2009)",
      "Anthony Award Best First Novel (2009)",
      "CWA International Dagger (2008)"
    ],
    "categories": [
      "Thriller",
      "Mystery",
      "Crime"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 10,
      "dark": 8,
      "plot": 9,
      "character": 8,
      "fast": 7,
      "series": 7,
      "medium": 6,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 187,
    "title": "The Big Sleep",
    "author": "Raymond Chandler",
    "publicationYear": 1939,
    "series": {
      "name": "Philip Marlowe",
      "position": 1
    },
    "isbn": "0394758285",
    "googleBooksId": "placeholder187",
    "image": "https://books.google.com/books/content?id=-PnYCwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Private eye Philip Marlowe takes a seemingly simple blackmail case involving a wealthy general's wild daughter. What follows is a descent into Los Angeles's criminal underworld of gambling, pornography, and murder. Chandler's masterpiece defined noir, with razor-sharp prose and a detective who lives by his own code.",
    "rating": 3.94,
    "ratingsCount": 168895,
    "pageCount": 231,
    "awards": [
      "Anthony Award Best Novel of the Century (2000)",
      "CWA Best Ever Crime Novel (2013)"
    ],
    "categories": [
      "Mystery",
      "Noir",
      "Classic"
    ],
    "scores": {
      "mystery": 10,
      "classic": 9,
      "dark": 8,
      "plot": 8,
      "character": 7,
      "fast": 7,
      "standalone": 10,
      "literary": 8,
      "medium": 7,
      "accessible": 7
    }
  },
  {
    "id": 188,
    "title": "And Then There Were None",
    "author": "Agatha Christie",
    "publicationYear": 1939,
    "isbn": "0062073486",
    "googleBooksId": "placeholder188",
    "image": "https://books.google.com/books/content?id=4EBHUjNLuyIC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Ten strangers are invited to a remote island. One by one, they start dying—each death matching a chilling nursery rhyme. With no way to escape and the killer among them, paranoia reigns. Christie's bestselling mystery is a masterclass in suspense, with one of the most brilliant solutions in detective fiction.",
    "rating": 4.27,
    "ratingsCount": 1623015,
    "pageCount": 264,
    "categories": [
      "Mystery",
      "Thriller",
      "Classic"
    ],
    "scores": {
      "mystery": 10,
      "thriller": 8,
      "plot": 10,
      "classic": 9,
      "fast": 8,
      "mind": 8,
      "standalone": 10,
      "medium": 8,
      "character": 5,
      "dark": 7
    }
  },
  {
    "id": 189,
    "title": "The Bourne Identity",
    "author": "Robert Ludlum",
    "publicationYear": 1980,
    "isbn": "0553593544",
    "googleBooksId": "placeholder189",
    "image": "https://books.google.com/books/content?id=_9_G4ZwGegcC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A man is pulled from the Mediterranean with bullet wounds and no memory of who he is. As he pieces together his identity, he discovers he's a deadly assassin with governments hunting him. Ludlum's classic spawned an entire genre, combining amnesia, international intrigue, and relentless action in the birth of Jason Bourne.",
    "rating": 4.05,
    "ratingsCount": 441613,
    "pageCount": 566,
    "categories": [
      "Thriller",
      "Espionage",
      "Action"
    ],
    "scores": {
      "thriller": 10,
      "plot": 10,
      "fast": 9,
      "dark": 6,
      "character": 7,
      "series": 7,
      "medium": 7,
      "classic": 5,
      "modern": 7,
      "accessible": 7
    }
  },
  {
    "id": 190,
    "title": "In Cold Blood",
    "author": "Truman Capote",
    "publicationYear": 1966,
    "isbn": "0679745580",
    "googleBooksId": "placeholder190",
    "image": "https://books.google.com/books/content?id=mYC3yRvvXxMC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In 1959, two ex-convicts murdered a Kansas family for no clear reason. Capote spent years researching the crime and killers, creating something entirely new: the nonfiction novel. A haunting exploration of violence, justice, and the American Dream, written with novelistic power and journalistic precision.",
    "rating": 4.09,
    "ratingsCount": 731570,
    "pageCount": 343,
    "awards": [
      "Edgar Award Best Fact Crime (1966)"
    ],
    "categories": [
      "Nonfiction",
      "True Crime",
      "Classic"
    ],
    "scores": {
      "nonfiction": 10,
      "thriller": 7,
      "dark": 9,
      "literary": 10,
      "mind": 9,
      "character": 8,
      "slow": 6,
      "standalone": 10,
      "medium": 6,
      "classic": 8
    }
  },
  {
    "id": 191,
    "title": "Rebecca",
    "author": "Daphne du Maurier",
    "publicationYear": 1938,
    "isbn": "0380730405",
    "googleBooksId": "placeholder191",
    "image": "https://books.google.com/books/content?id=IB0UbBGiSdsC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A young bride arrives at Manderley, her husband's estate, only to find herself haunted by the memory of Rebecca, his first wife. The housekeeper Mrs. Danvers ensures Rebecca's presence lingers everywhere. Du Maurier's gothic masterpiece is a psychologically complex tale of obsession, mystery, and the secrets that destroy.",
    "rating": 4.25,
    "ratingsCount": 723827,
    "pageCount": 441,
    "awards": [
      "National Book Award Fiction (1938)",
      "Anthony Award Best Novel of the Century (2000)"
    ],
    "categories": [
      "Mystery",
      "Gothic",
      "Classic"
    ],
    "scores": {
      "mystery": 8,
      "thriller": 7,
      "classic": 9,
      "literary": 9,
      "atmosphere": 10,
      "character": 8,
      "emotional": 8,
      "slow": 7,
      "standalone": 10,
      "medium": 5,
      "dark": 7
    }
  },
  {
    "id": 192,
    "title": "Sharp Objects",
    "author": "Gillian Flynn",
    "publicationYear": 2006,
    "isbn": "0307341550",
    "googleBooksId": "placeholder192",
    "image": "https://books.google.com/books/content?id=cAYy9_aV4kMC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Reporter Camille Preaker returns to her hometown to cover the murders of two girls, forced to confront her own damaged past. Living with her hypochondriac mother and strange half-sister, Camille's investigation becomes nightmarishly personal. Flynn's debut is a masterclass in psychological horror, with a twist that sears itself into memory.",
    "rating": 4.01,
    "ratingsCount": 1228111,
    "pageCount": 254,
    "awards": [
      "Barry Award Best First Novel (2007)",
      "CWA New Blood Dagger (2007)",
      "Edgar Award Best First Novel (2007)",
      "CWA Ian Fleming Steel Dagger (2007)"
    ],
    "categories": [
      "Thriller",
      "Mystery",
      "Psychological"
    ],
    "scores": {
      "thriller": 9,
      "mystery": 8,
      "dark": 10,
      "character": 9,
      "fast": 7,
      "standalone": 10,
      "medium": 8,
      "literary": 7,
      "emotional": 7,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 193,
    "title": "The Reversal",
    "author": "Michael Connelly",
    "isbn": "0316069485",
    "googleBooksId": "placeholder193",
    "image": "https://books.google.com/books/content?id=BVLsF93bLOoC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Defense attorney Mickey Haller is recruited by the DA to prosecute a convicted child killer whose conviction is being overturned. Teaming with LAPD detective Harry Bosch, Haller must prove guilt rather than innocence—a reversal that challenges everything he knows. Connelly brings together his two iconic characters in a gripping legal thriller.",
    "rating": 4.23,
    "ratingsCount": 91478,
    "pageCount": 389,
    "awards": [
      "Audie Award Mystery (2011)",
      "Strand Critics Award Best Novel (2010)"
    ],
    "categories": [
      "Thriller",
      "Mystery",
      "Legal"
    ],
    "scores": {
      "thriller": 8,
      "mystery": 9,
      "plot": 9,
      "character": 8,
      "fast": 7,
      "series": 7,
      "medium": 7,
      "dark": 7,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 194,
    "title": "The No. 1 Ladies' Detective Agency",
    "author": "Alexander McCall Smith",
    "isbn": "1400034779",
    "googleBooksId": "placeholder194",
    "image": "https://books.google.com/books/content?id=KvyLDQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Precious Ramotswe opens Botswana's first female-owned detective agency, using her wisdom and intuition to solve cases with kindness and tea. From missing husbands to insurance fraud, she navigates her work with warmth and humor. A gentle, optimistic mystery series that celebrates ordinary life and extraordinary compassion.",
    "rating": 3.81,
    "ratingsCount": 276142,
    "pageCount": 235,
    "awards": [
      "Martin Beck Award (2004)"
    ],
    "categories": [
      "Mystery",
      "Contemporary",
      "Cozy Mystery"
    ],
    "scores": {
      "mystery": 8,
      "character": 9,
      "optimistic": 9,
      "slow": 6,
      "emotional": 7,
      "heart": 8,
      "series": 7,
      "medium": 7,
      "literary": 6,
      "contemporary": 6
    }
  },
  {
    "id": 195,
    "title": "The Kite Runner",
    "author": "Khaled Hosseini",
    "isbn": "159463193X",
    "googleBooksId": "placeholder195",
    "image": "https://books.google.com/books/content?id=ykWQEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Amir and Hassan are childhood friends in Kabul, separated by class but bound by loyalty. When Amir fails Hassan in a moment of crisis, the guilt haunts him across continents and decades. Hosseini's stunning debut is a story of friendship, redemption, and the enduring power of the past to shape who we become.",
    "rating": 4.36,
    "ratingsCount": 3502260,
    "pageCount": 371,
    "awards": [
      "Borders Original Voices Award Fiction (2003)",
      "ALA Alex Award (2004)",
      "Lincoln Award (2006)"
    ],
    "categories": [
      "Contemporary",
      "Literary Fiction",
      "Historical"
    ],
    "scores": {
      "contemporary": 10,
      "literary": 8,
      "emotional": 9,
      "character": 9,
      "dark": 7,
      "heart": 7,
      "mind": 7,
      "standalone": 10,
      "medium": 6,
      "historical": 6
    }
  },
  {
    "id": 196,
    "title": "A Thousand Splendid Suns",
    "author": "Khaled Hosseini",
    "isbn": "159448385X",
    "googleBooksId": "placeholder196",
    "image": "https://books.google.com/books/content?id=oESQEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Two Afghan women from different generations find themselves in the same household, united by shared suffering under Taliban rule. Their unlikely friendship becomes a testament to endurance and hope against devastating odds. Hosseini's heart-wrenching novel is an intimate portrait of a country's turmoil seen through the eyes of women who survive it.",
    "rating": 4.46,
    "ratingsCount": 1741396,
    "pageCount": 372,
    "awards": [
      "British Book Award Best Read of the Year (2008)",
      "Book Sense Book of the Year Award Adult Fiction (2008)",
      "California Book Award Fiction Silver (2007)",
      "Exclusive Books Boeke Prize (2007)",
      "Lincoln Award (2011)"
    ],
    "categories": [
      "Contemporary",
      "Literary Fiction",
      "Historical"
    ],
    "scores": {
      "contemporary": 10,
      "literary": 8,
      "emotional": 10,
      "character": 9,
      "dark": 8,
      "heart": 8,
      "mind": 7,
      "standalone": 10,
      "medium": 6,
      "historical": 6
    }
  },
  {
    "id": 197,
    "title": "Life of Pi",
    "author": "Yann Martel",
    "isbn": "0156027321",
    "googleBooksId": "placeholder197",
    "image": "https://books.google.com/books/content?id=wgHPjx2UPGEC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "After a shipwreck, Indian teenager Pi finds himself on a lifeboat in the Pacific Ocean with an unusual companion: a 450-pound Bengal tiger named Richard Parker. Their 227-day ordeal becomes a profound meditation on faith, survival, and storytelling. Martel's Man Booker winner asks which story you'll choose to believe.",
    "rating": 3.94,
    "ratingsCount": 1756435,
    "pageCount": 460,
    "awards": [
      "Booker Prize (2002)",
      "Governor General's Literary Award Fiction (2001)",
      "Asian/Pacific American Award for Literature (2003)"
    ],
    "categories": [
      "Contemporary",
      "Literary Fiction",
      "Adventure"
    ],
    "scores": {
      "contemporary": 9,
      "literary": 8,
      "mind": 9,
      "character": 8,
      "atmosphere": 8,
      "slow": 6,
      "standalone": 10,
      "medium": 6,
      "optimistic": 6,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 198,
    "title": "The Road",
    "author": "Cormac McCarthy",
    "isbn": "0307387895",
    "googleBooksId": "placeholder198",
    "image": "https://books.google.com/books/content?id=53aMEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A father and son walk through a post-apocalyptic America, pushing a shopping cart toward the coast. They scavenge for food, hide from cannibals, and cling to each other as the last remnant of humanity. McCarthy's Pulitzer Prize winner is a stark, devastating exploration of love enduring in a world stripped of everything else.",
    "rating": 4,
    "ratingsCount": 1040671,
    "pageCount": 241,
    "awards": [
      "Pulitzer Prize Fiction (2007)",
      "James Tait Black Memorial Prize Fiction (2006)",
      "National Book Critics Circle Award Fiction (2006)"
    ],
    "categories": [
      "Contemporary",
      "Literary Fiction",
      "Post-Apocalyptic"
    ],
    "scores": {
      "contemporary": 9,
      "literary": 10,
      "dark": 10,
      "atmosphere": 9,
      "character": 8,
      "emotional": 8,
      "slow": 7,
      "standalone": 10,
      "medium": 5,
      "mind": 8
    }
  },
  {
    "id": 199,
    "title": "Beloved",
    "author": "Toni Morrison",
    "isbn": "1400033411",
    "googleBooksId": "placeholder199",
    "image": "https://books.google.com/books/content?id=bm-KDQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Sethe escaped slavery, but the past haunts her Kentucky home in the form of a vengeful spirit. When a mysterious young woman appears calling herself Beloved, Sethe is consumed by guilt and love for the daughter she killed to save from enslavement. Morrison's Pulitzer Prize winner confronts America's most painful legacy with searing, lyrical power.",
    "rating": 3.98,
    "ratingsCount": 492040,
    "pageCount": 325,
    "awards": [
      "Pulitzer Prize Fiction (1988)",
      "American Book Award (1988)",
      "Anisfield-Wolf Book Award (1988)",
      "National Book Critics Circle Award Fiction (1987)"
    ],
    "categories": [
      "Contemporary",
      "Literary Fiction",
      "Classic"
    ],
    "scores": {
      "contemporary": 8,
      "classic": 9,
      "literary": 10,
      "dark": 9,
      "character": 9,
      "emotional": 9,
      "slow": 8,
      "mind": 9,
      "standalone": 10,
      "medium": 4,
      "historical": 7
    }
  },
  {
    "id": 200,
    "title": "The Remains of the Day",
    "author": "Kazuo Ishiguro",
    "isbn": "0679731725",
    "googleBooksId": "placeholder200",
    "image": "https://books.google.com/books/content?id=g7zlBFpuD0IC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "English butler Stevens reflects on his decades serving Lord Darlington, his devotion to duty, and the housekeeper he may have loved. As he motors through the countryside, he confronts the life choices and political naiveté that shaped his existence. Ishiguro's Booker Prize winner is a masterful study of repression, class, and missed opportunities.",
    "rating": 4.14,
    "ratingsCount": 361696,
    "pageCount": 258,
    "awards": [
      "Man Booker Prize (1989)"
    ],
    "categories": [
      "Contemporary",
      "Literary Fiction",
      "Historical"
    ],
    "scores": {
      "contemporary": 8,
      "literary": 10,
      "character": 10,
      "emotional": 8,
      "slow": 8,
      "mind": 8,
      "standalone": 10,
      "medium": 5,
      "historical": 7,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 201,
    "title": "Never Let Me Go",
    "author": "Kazuo Ishiguro",
    "isbn": "1400078776",
    "googleBooksId": "placeholder201",
    "image": "https://books.google.com/books/content?id=5N4cCOjPjv8C&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Kathy, Tommy, and Ruth grow up at Hailsham, a boarding school with a terrible secret about their purpose in life. As they mature and face their predetermined fate, questions of humanity, love, and mortality take center stage. Ishiguro's haunting novel is science fiction only in premise—at its heart, it's about what makes us human.",
    "rating": 3.85,
    "ratingsCount": 858526,
    "pageCount": 288,
    "awards": [
      "Arthur C. Clarke Award (2006)",
      "Locus Award Best SF Novel (2006)",
      "ALA Alex Award (2006)"
    ],
    "categories": [
      "Contemporary",
      "Literary Fiction",
      "Science Fiction"
    ],
    "scores": {
      "contemporary": 9,
      "literary": 9,
      "scifi": 6,
      "character": 10,
      "emotional": 10,
      "dark": 7,
      "slow": 7,
      "mind": 9,
      "standalone": 10,
      "medium": 6
    }
  },
  {
    "id": 202,
    "title": "Atonement",
    "author": "Ian McEwan",
    "isbn": "038572179X",
    "googleBooksId": "placeholder202",
    "image": "https://books.google.com/books/content?id=vZy0xrEHJRUC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "On a summer day in 1935, thirteen-year-old Briony Tallis witnesses something she doesn't understand and makes an accusation that destroys lives. Decades later, she seeks atonement through writing, but can a story change what happened? McEwan's masterwork explores guilt, perspective, and the unreliable power of narrative itself.",
    "rating": 3.95,
    "ratingsCount": 564555,
    "pageCount": 351,
    "awards": [
      "WH Smith Literary Award (2002)",
      "Los Angeles Times Book Prize Fiction (2002)",
      "National Book Critics Circle Award Fiction (2002)"
    ],
    "categories": [
      "Contemporary",
      "Literary Fiction",
      "Historical"
    ],
    "scores": {
      "contemporary": 8,
      "literary": 10,
      "historical": 7,
      "character": 9,
      "emotional": 9,
      "plot": 8,
      "slow": 7,
      "mind": 8,
      "standalone": 10,
      "medium": 5
    }
  },
  {
    "id": 203,
    "title": "The Secret History",
    "author": "Donna Tartt",
    "isbn": "1400031702",
    "googleBooksId": "placeholder203",
    "image": "https://books.google.com/books/content?id=3w0YEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A group of elite classics students at a New England college fall under the spell of their charismatic professor. Their obsession with ancient Greek ideals leads to murder, and the narrator reveals the crime in the first sentence. Tartt's cult classic is a reverse mystery that explores the why rather than the who, steeped in atmosphere and moral ambiguity.",
    "rating": 4.15,
    "ratingsCount": 1035261,
    "pageCount": 559,
    "categories": [
      "Contemporary",
      "Literary Fiction",
      "Mystery"
    ],
    "scores": {
      "contemporary": 9,
      "literary": 9,
      "dark": 8,
      "character": 9,
      "mystery": 7,
      "mind": 8,
      "slow": 7,
      "standalone": 10,
      "medium": 5,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 204,
    "title": "The Catcher in the Rye",
    "author": "J.D. Salinger",
    "isbn": "0316769487",
    "googleBooksId": "placeholder204",
    "image": "https://books.google.com/books/content?id=ZotvleqZomIC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Expelled from prep school, sixteen-year-old Holden Caulfield wanders New York City for three days, railing against phonies and mourning the loss of innocence. His voice—cynical, vulnerable, unforgettable—captured teenage alienation like never before. Salinger's 1951 classic remains a defining portrait of adolescent rebellion and the painful transition to adulthood.",
    "rating": 3.8,
    "ratingsCount": 3902738,
    "pageCount": 277,
    "awards": [
      "National Book Award Finalist Fiction (1952)",
      "Teen Read Award Best All-Time-Fave (2010)"
    ],
    "categories": [
      "Contemporary",
      "Classic",
      "Coming of Age"
    ],
    "scores": {
      "contemporary": 8,
      "classic": 10,
      "literary": 9,
      "character": 10,
      "emotional": 7,
      "slow": 6,
      "standalone": 10,
      "medium": 7,
      "mind": 7,
      "plot": 5
    }
  },
  {
    "id": 205,
    "title": "The Name of the Rose",
    "author": "Umberto Eco",
    "isbn": "0544176561",
    "googleBooksId": "placeholder205",
    "image": "https://books.google.com/books/content?id=ChlOAwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In 1327, Franciscan friar William of Baskerville arrives at an Italian abbey to investigate mysterious deaths. As more monks die according to a biblical pattern, William and his novice uncover secrets, heresies, and a labyrinthine library hiding forbidden knowledge. Eco's masterpiece is part murder mystery, part philosophical treatise, steeped in medieval atmosphere and intellectual intrigue.",
    "rating": 4.14,
    "ratingsCount": 396349,
    "pageCount": 552,
    "awards": [
      "CWA New Blood Dagger (1983)",
      "Premio Strega (1981)",
      "Los Angeles Times Book Prize Fiction (1983)",
      "Edgar Award Best Novel (1984)",
      "PEN Translation Prize (1984)",
      "Prix Médicis étranger (1982)"
    ],
    "categories": [
      "Historical Fiction",
      "Mystery",
      "Literary"
    ],
    "scores": {
      "historical": 10,
      "mystery": 9,
      "literary": 10,
      "mind": 10,
      "slow": 8,
      "atmosphere": 9,
      "character": 7,
      "standalone": 10,
      "medium": 4,
      "plot": 7,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 206,
    "title": "Shogun",
    "author": "James Clavell",
    "isbn": "1982537523",
    "googleBooksId": "placeholder206",
    "image": "https://books.google.com/books/content?id=YLfbugEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "English navigator John Blackthorne is shipwrecked in feudal Japan in 1600, thrust into a world of samurai, shoguns, and geisha. As he learns Japanese customs and becomes a pawn in political intrigue, he's transformed by a culture utterly foreign to him. Clavell's epic brings 17th-century Japan to vivid life in a tale of honor, survival, and cultural collision.",
    "rating": 4.41,
    "ratingsCount": 213137,
    "pageCount": 1152,
    "categories": [
      "Historical Fiction",
      "Adventure",
      "Epic"
    ],
    "scores": {
      "historical": 10,
      "atmosphere": 10,
      "plot": 9,
      "character": 8,
      "slow": 6,
      "medium": 7,
      "mind": 7,
      "standalone": 10,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 207,
    "title": "The Thorn Birds",
    "author": "Colleen McCullough",
    "isbn": "0380018179",
    "googleBooksId": "placeholder207",
    "image": "https://books.google.com/books/content?id=sUEwE1l8FQIC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "On a sheep station in the Australian Outback, Meggie Cleary loves Father Ralph de Bricassart, a Catholic priest torn between God and the woman he cannot have. Their forbidden love spans decades, shaping three generations of the Cleary family. McCullough's sweeping saga is an epic of passion, ambition, and the impossible choices love demands.",
    "rating": 4.25,
    "ratingsCount": 365215,
    "pageCount": 692,
    "categories": [
      "Historical Fiction",
      "Romance",
      "Family Saga"
    ],
    "scores": {
      "historical": 9,
      "emotional": 10,
      "character": 9,
      "heart": 9,
      "slow": 6,
      "medium": 6,
      "atmosphere": 8,
      "standalone": 10,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 208,
    "title": "Outlander",
    "author": "Diana Gabaldon",
    "isbn": "0440212561",
    "googleBooksId": "placeholder208",
    "image": "http://books.google.com/books/content?id=IM1nVGX7XU0C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "In 1945, Claire Randall touches an ancient stone and is hurled back to 1743 Scotland. Caught in Highland clan warfare, she's forced to marry Jamie Fraser, a young warrior. What begins as survival becomes an epic love story as Claire is torn between two times, two men, and two lives. Time-travel romance that launched a phenomenon.",
    "rating": 4.26,
    "ratingsCount": 1155842,
    "pageCount": 850,
    "awards": [
      "RITA Award Best First Book (1992)",
      "RITA Award Single Title Historical Romance (1992)"
    ],
    "categories": [
      "Historical Fiction",
      "Romance",
      "Time Travel"
    ],
    "scores": {
      "historical": 9,
      "heart": 10,
      "emotional": 9,
      "character": 9,
      "plot": 8,
      "series": 10,
      "medium": 5,
      "atmosphere": 8,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 209,
    "title": "Cold Mountain",
    "author": "Charles Frazier",
    "isbn": "0375700757",
    "googleBooksId": "placeholder209",
    "image": "http://books.google.com/books/content?id=SZh9UHpGUFAC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Wounded Confederate soldier Inman deserts and walks home to Cold Mountain, North Carolina, to find Ada, the woman he loves. As Inman survives his brutal journey, Ada transforms from a city woman into one who can work the land. Their parallel stories of endurance culminate in a reunion both have fought desperately to reach. National Book Award winner.",
    "rating": 3.89,
    "ratingsCount": 250227,
    "pageCount": 449,
    "awards": [
      "National Book Award Fiction (1997)",
      "National Book Critics Circle Award Fiction (1997)",
      "American Booksellers Book of the Year Award (1998)"
    ],
    "categories": [
      "Historical Fiction",
      "Literary Fiction",
      "War"
    ],
    "scores": {
      "historical": 10,
      "literary": 9,
      "character": 9,
      "emotional": 8,
      "slow": 7,
      "atmosphere": 9,
      "standalone": 10,
      "medium": 5,
      "dark": 6,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 210,
    "title": "The Other Boleyn Girl",
    "author": "Philippa Gregory",
    "isbn": "0743227441",
    "googleBooksId": "placeholder210",
    "image": "https://books.google.com/books/content?id=mx8-sy_e6r8C&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Before Anne Boleyn, there was Mary—her sister, King Henry VIII's mistress. Told from Mary's perspective, this is the story of the Boleyn siblings' rivalry for the king's affection, their family's ruthless ambition, and the deadly price of catching a Tudor monarch's eye. Gregory brings the scandal and intrigue of Henry's court vividly to life.",
    "rating": 4.09,
    "ratingsCount": 513943,
    "pageCount": 661,
    "awards": [
      "Romantic Novel of the Year Award (2002)"
    ],
    "categories": [
      "Historical Fiction",
      "Tudor",
      "Romance"
    ],
    "scores": {
      "historical": 10,
      "character": 8,
      "plot": 9,
      "emotional": 7,
      "heart": 7,
      "dark": 6,
      "medium": 7,
      "standalone": 9,
      "series": 6,
      "modern": 8
    }
  },
  {
    "id": 211,
    "title": "The Poisonwood Bible",
    "author": "Barbara Kingsolver",
    "isbn": "0060786507",
    "googleBooksId": "placeholder211",
    "image": "https://books.google.com/books/content?id=FSPI28onxDIC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Evangelical preacher Nathan Price drags his wife and four daughters to the Belgian Congo in 1959 as missionaries. Told through the women's voices, their story becomes one of survival, transformation, and the devastating consequences of cultural arrogance. Kingsolver's powerful novel explores colonialism, faith, and family against Africa's tumultuous independence.",
    "rating": 4.11,
    "ratingsCount": 794988,
    "pageCount": 546,
    "awards": [
      "Book Sense Book of the Year Award (2000)",
      "Exclusive Books Boeke Prize (2000)"
    ],
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "historical": 10,
      "literary": 9,
      "character": 9,
      "mind": 9,
      "emotional": 8,
      "slow": 7,
      "standalone": 10,
      "medium": 5,
      "dark": 7,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 212,
    "title": "The Amazing Adventures of Kavalier & Clay",
    "author": "Michael Chabon",
    "isbn": "0812983580",
    "googleBooksId": "placeholder212",
    "image": "https://books.google.com/books/content?id=XIga7RhvVOIC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Two Jewish cousins create a comic book superhero in 1930s New York, channeling their dreams and fears into the Escapist. As they navigate love, war, and the golden age of comics, their partnership mirrors the American experience. Chabon's Pulitzer Prize winner celebrates art, identity, and the power of storytelling with dazzling prose.",
    "rating": 4.19,
    "ratingsCount": 213129,
    "pageCount": 639,
    "awards": [
      "Pulitzer Prize Fiction (2001)",
      "PEN/Faulkner Award Fiction (2001)",
      "National Book Critics Circle Award Fiction (2000)"
    ],
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "historical": 9,
      "literary": 10,
      "character": 9,
      "plot": 8,
      "mind": 8,
      "emotional": 7,
      "slow": 6,
      "standalone": 10,
      "medium": 6,
      "modern": 8
    }
  },
  {
    "id": 213,
    "title": "The Shadow of the Wind",
    "author": "Carlos Ruiz Zafón",
    "isbn": "0143034901",
    "googleBooksId": "placeholder213",
    "image": "https://books.google.com/books/content?id=9Z2MEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In post-war Barcelona, young Daniel discovers a mysterious book in the Cemetery of Forgotten Books. His quest to learn about its author plunges him into a labyrinth of secrets, a tragic love story, and a dark figure destroying every copy of the author's works. Zafón weaves Gothic mystery with a passionate ode to literature itself.",
    "rating": 4.31,
    "ratingsCount": 722413,
    "pageCount": 487,
    "awards": [
      "Barry Award Best First Novel (2005)",
      "Gumshoe Award Best European Crime Novel (2005)",
      "Borders Original Voices Award Fiction (2004)",
      "Dilys Award (2005)"
    ],
    "categories": [
      "Historical Fiction",
      "Mystery",
      "Gothic"
    ],
    "scores": {
      "historical": 9,
      "mystery": 9,
      "literary": 9,
      "atmosphere": 10,
      "character": 8,
      "plot": 9,
      "medium": 6,
      "standalone": 9,
      "dark": 7,
      "modern": 8
    }
  },
  {
    "id": 214,
    "title": "Birdsong",
    "author": "Sebastian Faulks",
    "isbn": "0679776818",
    "googleBooksId": "placeholder214",
    "image": "https://books.google.com/books/content?id=rWIHTxHGVTcC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Stephen Wraysford's passionate affair in pre-WWI France is shattered when war erupts. In the trenches of the Somme, he endures unimaginable horror while trying to preserve his humanity. Decades later, his granddaughter pieces together his story. Faulks's devastating novel is both a love story and an unflinching portrait of the Great War's brutality.",
    "rating": 4.11,
    "ratingsCount": 84124,
    "pageCount": 483,
    "categories": [
      "Historical Fiction",
      "War",
      "Romance"
    ],
    "scores": {
      "historical": 10,
      "dark": 9,
      "emotional": 9,
      "character": 8,
      "literary": 8,
      "slow": 7,
      "standalone": 10,
      "medium": 5,
      "heart": 7,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 215,
    "title": "A People's History of the United States",
    "author": "Howard Zinn",
    "isbn": "0062397346",
    "googleBooksId": "placeholder215",
    "image": "https://books.google.com/books/content?id=nBgsrgEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Zinn tells American history from the perspective of those often omitted from textbooks: slaves, workers, women, and indigenous peoples. From Columbus to modern times, this groundbreaking work challenges the traditional narrative and asks whose story gets told. A radical reframing of American history that has influenced generations since 1980.",
    "rating": 4.09,
    "ratingsCount": 266769,
    "pageCount": 729,
    "categories": [
      "History",
      "Nonfiction",
      "Politics"
    ],
    "scores": {
      "history": 10,
      "nonfiction": 10,
      "mind": 10,
      "literary": 7,
      "slow": 7,
      "standalone": 10,
      "medium": 5,
      "character": 8,
      "plot": 5,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 216,
    "title": "The Diary of a Young Girl",
    "author": "Anne Frank",
    "isbn": "0553296981",
    "googleBooksId": "placeholder216",
    "image": "http://books.google.com/books/content?id=ZEy6im49l08C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "From 1942 to 1944, Anne Frank documented her family's life hiding from the Nazis in an Amsterdam annex. Her diary captures a teenager's hopes, fears, and observations with remarkable honesty and literary talent. A testament to the human spirit and an indelible reminder of the Holocaust's human cost.",
    "rating": 4.2,
    "ratingsCount": 4203066,
    "pageCount": 283,
    "categories": [
      "History",
      "Memoir",
      "Nonfiction"
    ],
    "scores": {
      "history": 10,
      "nonfiction": 10,
      "memoir": 9,
      "emotional": 10,
      "dark": 9,
      "mind": 8,
      "character": 9,
      "standalone": 10,
      "medium": 7,
      "classic": 9
    }
  },
  {
    "id": 217,
    "title": "Team of Rivals",
    "author": "Doris Kearns Goodwin",
    "isbn": "0743270754",
    "googleBooksId": "placeholder217",
    "image": "https://books.google.com/books/content?id=ONhhui9SRsMC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Lincoln surrounded himself with a cabinet of his political rivals, men who had competed against him for the presidency. Goodwin's masterwork reveals how Lincoln's emotional intelligence and political genius united these opponents to preserve the Union. A profound study of leadership during America's darkest hour.",
    "rating": 4.28,
    "ratingsCount": 200496,
    "pageCount": 916,
    "awards": [
      "Lincoln Prize (2006)",
      "National Book Critics Circle Award Biography (2005)"
    ],
    "categories": [
      "History",
      "Biography",
      "Politics"
    ],
    "scores": {
      "history": 10,
      "nonfiction": 10,
      "memoir": 7,
      "mind": 9,
      "character": 8,
      "slow": 7,
      "standalone": 10,
      "medium": 4,
      "literary": 8,
      "plot": 5,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 218,
    "title": "The Rise and Fall of the Third Reich",
    "author": "William L. Shirer",
    "isbn": "1451651686",
    "googleBooksId": "placeholder218",
    "image": "https://books.google.com/books/content?id=6QngAAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Journalist Shirer witnessed Nazi Germany firsthand and draws on captured documents and testimony to chronicle Hitler's rise to power and the Reich's catastrophic fall. Comprehensive and gripping, this remains the definitive history of Nazi Germany, essential reading for understanding the 20th century's darkest chapter.",
    "rating": 4.23,
    "ratingsCount": 148743,
    "pageCount": 1147,
    "awards": [
      "National Book Award Nonfiction (1961)"
    ],
    "categories": [
      "History",
      "War",
      "Nonfiction"
    ],
    "scores": {
      "history": 10,
      "nonfiction": 10,
      "dark": 9,
      "mind": 10,
      "slow": 7,
      "standalone": 10,
      "medium": 3,
      "literary": 7,
      "character": 8,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 219,
    "title": "Guns, Germs, and Steel",
    "author": "Jared Diamond",
    "isbn": "0393354326",
    "googleBooksId": "placeholder219",
    "image": "https://books.google.com/books/content?id=hFyNEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Why did Eurasian civilizations conquer others rather than the reverse? Diamond argues geography and environment—not racial superiority—determined the fates of societies. This Pulitzer Prize winner reframes 13,000 years of human history through biology, linguistics, and anthropology in a groundbreaking synthesis.",
    "rating": 4.04,
    "ratingsCount": 458859,
    "pageCount": 498,
    "awards": [
      "Pulitzer Prize General Nonfiction (1998)"
    ],
    "categories": [
      "History",
      "Science",
      "Nonfiction"
    ],
    "scores": {
      "history": 10,
      "nonfiction": 10,
      "mind": 10,
      "slow": 6,
      "standalone": 10,
      "medium": 6,
      "literary": 6,
      "character": 7,
      "plot": 6,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 220,
    "title": "The Wright Brothers",
    "author": "David McCullough",
    "isbn": "1476728755",
    "googleBooksId": "placeholder220",
    "image": "https://books.google.com/books/content?id=4SEODAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Two bicycle mechanics from Ohio achieved what scientists said was impossible: human flight. McCullough brings Wilbur and Orville Wright to life, revealing their ingenuity, persistence, and the tight-knit family that supported their dream. An inspiring story of American innovation and the power of determination.",
    "rating": 4.18,
    "ratingsCount": 98881,
    "pageCount": 320,
    "categories": [
      "History",
      "Biography",
      "Science"
    ],
    "scores": {
      "history": 9,
      "nonfiction": 10,
      "memoir": 6,
      "mind": 7,
      "optimistic": 8,
      "character": 7,
      "standalone": 10,
      "medium": 7,
      "plot": 7,
      "modern": 8
    }
  },
  {
    "id": 221,
    "title": "John Adams",
    "author": "David McCullough",
    "isbn": "0743223136",
    "googleBooksId": "placeholder221",
    "image": "https://books.google.com/books/content?id=mtBkcldvD3cC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "America's second president emerges from Washington's shadow in this Pulitzer Prize-winning biography. McCullough reveals Adams as a passionate patriot, devoted husband, and complex leader whose principled stands shaped the nation. Based on extensive letters between John and Abigail Adams, it's an intimate portrait of founding America.",
    "rating": 4.08,
    "ratingsCount": 378331,
    "pageCount": 751,
    "awards": [
      "Pulitzer Prize Biography (2002)"
    ],
    "categories": [
      "History",
      "Biography",
      "Politics"
    ],
    "scores": {
      "history": 10,
      "nonfiction": 10,
      "memoir": 7,
      "character": 8,
      "mind": 8,
      "slow": 7,
      "standalone": 10,
      "medium": 5,
      "literary": 8,
      "plot": 5,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 222,
    "title": "SPQR: A History of Ancient Rome",
    "author": "Mary Beard",
    "isbn": "1631492225",
    "googleBooksId": "placeholder222",
    "image": "https://books.google.com/books/content?id=14aQEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Classical scholar Mary Beard examines Rome's thousand-year history, from its mythical founding to 212 CE citizenship declaration. She explores what made Rome exceptional, how it governed an empire, and what its legacy means today. Accessible yet scholarly, SPQR reimagines ancient Rome for modern readers with wit and insight.",
    "rating": 4.06,
    "ratingsCount": 81964,
    "pageCount": 606,
    "awards": [
      "National Book Critics Circle Award General Nonfiction (2015)",
      "Waterstones Book of the Year (2015)",
      "Cundill History Prize (2016)"
    ],
    "categories": [
      "History",
      "Ancient History",
      "Nonfiction"
    ],
    "scores": {
      "history": 10,
      "nonfiction": 10,
      "mind": 9,
      "slow": 7,
      "literary": 7,
      "standalone": 10,
      "medium": 5,
      "character": 8,
      "plot": 5,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 223,
    "title": "The Devil in the White City",
    "author": "Erik Larson",
    "isbn": "0375725601",
    "googleBooksId": "placeholder223",
    "image": "https://books.google.com/books/content?id=1g2PDQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Two men, two stories, one city: architect Daniel Burnham races to build the 1893 Chicago World's Fair while serial killer H.H. Holmes lures victims to his murder hotel nearby. Larson interweaves these narratives into a spellbinding account of ambition, innovation, and evil during America's Gilded Age.",
    "rating": 4,
    "ratingsCount": 760876,
    "pageCount": 464,
    "awards": [
      "Edgar Award Best Fact Crime (2004)",
      "National Book Award Finalist Nonfiction (2003)",
      "Washington State Book Award (2004)"
    ],
    "categories": [
      "History",
      "True Crime",
      "Nonfiction"
    ],
    "scores": {
      "history": 9,
      "nonfiction": 10,
      "thriller": 7,
      "dark": 8,
      "plot": 9,
      "fast": 7,
      "standalone": 10,
      "medium": 6,
      "mind": 7,
      "character": 5,
      "modern": 8
    }
  },
  {
    "id": 224,
    "title": "Dead Wake",
    "author": "Erik Larson",
    "isbn": "0307408876",
    "googleBooksId": "placeholder224",
    "image": "https://books.google.com/books/content?id=LLvaCwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In 1915, the Lusitania steamed toward England while a German U-boat hunted. Larson reconstructs the passenger ship's final voyage and the submarine attack that killed 1,198 people, helping draw America into WWI. Meticulously researched, this reads like a thriller while illuminating a pivotal moment in history.",
    "rating": 4.13,
    "ratingsCount": 162165,
    "pageCount": 430,
    "awards": [
      "Goodreads Choice Award History & Biography (2015)",
      "Washington State Book Award Nonfiction (2016)"
    ],
    "categories": [
      "History",
      "War",
      "Nonfiction"
    ],
    "scores": {
      "history": 10,
      "nonfiction": 10,
      "plot": 8,
      "fast": 7,
      "dark": 8,
      "mind": 7,
      "standalone": 10,
      "medium": 7,
      "character": 5,
      "modern": 8
    }
  },
  {
    "id": 225,
    "title": "Wuthering Heights",
    "author": "Emily Brontë",
    "isbn": "0141439556",
    "googleBooksId": "placeholder225",
    "image": "https://books.google.com/books/content?id=vQMyEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Heathcliff and Catherine's destructive love haunts two generations on the Yorkshire moors. Adopted as a child, Heathcliff's passion for Catherine curdles into vengeance when she marries another. Brontë's only novel is a Gothic masterpiece of obsession, cruelty, and love that transcends death itself.",
    "rating": 3.9,
    "ratingsCount": 2074216,
    "pageCount": 464,
    "awards": [
      "Audible's Narrator of the Year Award (2017)"
    ],
    "categories": [
      "Classic",
      "Gothic",
      "Romance"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "dark": 9,
      "emotional": 10,
      "character": 9,
      "slow": 7,
      "standalone": 10,
      "medium": 6,
      "atmosphere": 9,
      "plot": 5
    }
  },
  {
    "id": 226,
    "title": "Frankenstein",
    "author": "Mary Shelley",
    "isbn": "0486282112",
    "googleBooksId": "placeholder226",
    "image": "https://books.google.com/books/content?id=31h2CQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Victor Frankenstein creates life from death, then abandons his creature in horror. The monster, intelligent and lonely, seeks revenge on his creator. Shelley's 1818 masterpiece explores the dangers of unchecked ambition, the ethics of creation, and what it means to be human in a novel that birthed science fiction.",
    "rating": 3.91,
    "ratingsCount": 1899338,
    "pageCount": 224,
    "categories": [
      "Classic",
      "Gothic",
      "Science Fiction"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "scifi": 7,
      "dark": 8,
      "mind": 9,
      "character": 7,
      "slow": 7,
      "standalone": 10,
      "medium": 7,
      "atmosphere": 9
    }
  },
  {
    "id": 227,
    "title": "Dracula",
    "author": "Bram Stoker",
    "isbn": "0486411095",
    "googleBooksId": "placeholder227",
    "image": "https://books.google.com/books/content?id=xGPcDAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Count Dracula travels from Transylvania to England, leaving a trail of victims. Through letters and diary entries, Jonathan Harker, Mina Murray, and Professor Van Helsing piece together the vampire's secrets and mount a desperate hunt. Stoker's 1897 novel defined the vampire myth and remains Gothic horror's most influential work.",
    "rating": 4.02,
    "ratingsCount": 1481420,
    "pageCount": 488,
    "awards": [
      "Prêmio Literário Biblioteca Nacional Projeto Gráfico (2024)"
    ],
    "categories": [
      "Classic",
      "Gothic",
      "Horror"
    ],
    "scores": {
      "classic": 10,
      "dark": 9,
      "atmosphere": 10,
      "plot": 8,
      "fast": 7,
      "standalone": 10,
      "medium": 7,
      "literary": 8,
      "thriller": 7,
      "character": 5
    }
  },
  {
    "id": 228,
    "title": "Crime and Punishment",
    "author": "Fyodor Dostoevsky",
    "isbn": "0486415872",
    "googleBooksId": "placeholder228",
    "image": "https://books.google.com/books/content?id=nVGKDgAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Impoverished student Raskolnikov murders a pawnbroker, convinced his superior intellect justifies the act. But guilt consumes him as detective Porfiry closes in. Dostoevsky's psychological masterpiece explores morality, redemption, and whether some are above the law in 19th-century St. Petersburg.",
    "rating": 4.29,
    "ratingsCount": 1086365,
    "pageCount": 671,
    "categories": [
      "Classic",
      "Literary Fiction",
      "Philosophical"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "mind": 10,
      "dark": 9,
      "character": 10,
      "slow": 8,
      "standalone": 10,
      "medium": 4,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 229,
    "title": "The Count of Monte Cristo",
    "author": "Alexandre Dumas",
    "isbn": "0140449264",
    "googleBooksId": "placeholder229",
    "image": "https://books.google.com/books/content?id=5YOMEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Edmond Dantès is imprisoned for a crime he didn't commit. Years later, he escapes with a fortune and reinvents himself as the mysterious Count of Monte Cristo to exact elaborate revenge on those who betrayed him. Dumas's 1844 adventure remains the ultimate tale of vengeance, justice, and redemption.",
    "rating": 4.33,
    "ratingsCount": 1027191,
    "pageCount": 1276,
    "categories": [
      "Classic",
      "Adventure",
      "Historical"
    ],
    "scores": {
      "classic": 10,
      "plot": 10,
      "character": 9,
      "fast": 7,
      "dark": 7,
      "historical": 8,
      "standalone": 10,
      "medium": 4,
      "mind": 7,
      "accessible": 7
    }
  },
  {
    "id": 230,
    "title": "Les Misérables",
    "author": "Victor Hugo",
    "isbn": "0451525264",
    "googleBooksId": "placeholder230",
    "image": "https://books.google.com/books/content?id=wSR50QEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Ex-convict Jean Valjean seeks redemption in 19th-century France while Inspector Javert pursues him relentlessly. Their cat-and-mouse struggle unfolds against revolution, poverty, and the lives Valjean touches with compassion. Hugo's epic examines justice, mercy, and the power of love to transform lives.",
    "rating": 4.21,
    "ratingsCount": 845198,
    "pageCount": 1463,
    "awards": [
      "French-American Foundation Translation Prize Fiction (2015)"
    ],
    "categories": [
      "Classic",
      "Historical",
      "Literary"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "historical": 9,
      "character": 10,
      "emotional": 9,
      "slow": 8,
      "standalone": 10,
      "medium": 3,
      "mind": 8,
      "plot": 5
    }
  },
  {
    "id": 232,
    "title": "The Adventures of Huckleberry Finn",
    "author": "Mark Twain",
    "isbn": "0486280616",
    "googleBooksId": "placeholder232",
    "image": "https://books.google.com/books/content?id=mWHcDAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Huck Finn fakes his death and floats down the Mississippi with escaped slave Jim. Their journey through pre-Civil War America becomes a biting satire of society and a profound exploration of friendship across racial divides. Twain's 1884 masterpiece, told in vernacular voice, helped define American literature.",
    "rating": 3.83,
    "ratingsCount": 1338646,
    "pageCount": 327,
    "categories": [
      "Classic",
      "Adventure",
      "Coming of Age"
    ],
    "scores": {
      "classic": 10,
      "literary": 9,
      "character": 8,
      "plot": 8,
      "fast": 7,
      "mind": 8,
      "standalone": 10,
      "medium": 7,
      "emotional": 6,
      "accessible": 7
    }
  },
  {
    "id": 233,
    "title": "The Picture of Dorian Gray",
    "author": "Oscar Wilde",
    "isbn": "0486278077",
    "googleBooksId": "placeholder233",
    "image": "https://books.google.com/books/content?id=wFp2CQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Beautiful Dorian Gray wishes his portrait would age instead of him. His wish granted, he pursues a life of debauchery while his painted image bears the marks of his sins. Wilde's only novel is a Gothic fable about vanity, corruption, and the price of eternal youth, wrapped in his signature wit.",
    "rating": 4.13,
    "ratingsCount": 1888275,
    "pageCount": 253,
    "categories": [
      "Classic",
      "Gothic",
      "Philosophical"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "dark": 9,
      "mind": 9,
      "character": 8,
      "medium": 7,
      "standalone": 10,
      "atmosphere": 9,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 235,
    "title": "Man's Search for Meaning",
    "author": "Viktor E. Frankl",
    "isbn": "0807014273",
    "googleBooksId": "placeholder235",
    "image": "https://books.google.com/books/content?id=F-Q_xGjWBi8C&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Psychiatrist Frankl survived Nazi death camps and emerged with profound insights: those who found meaning survived. He developed logotherapy, arguing that the search for meaning is humanity's primary drive. This slim volume combines Holocaust memoir with psychological theory, offering timeless wisdom on finding purpose in suffering.",
    "rating": 4.37,
    "ratingsCount": 882594,
    "pageCount": 165,
    "categories": [
      "Nonfiction",
      "Self-Help",
      "Psychology"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 10,
      "memoir": 7,
      "dark": 7,
      "optimistic": 8,
      "standalone": 10,
      "medium": 8,
      "literary": 7,
      "character": 8,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 236,
    "title": "The Gifts of Imperfection",
    "author": "Brené Brown",
    "isbn": "159285849X",
    "googleBooksId": "placeholder236",
    "image": "https://books.google.com/books/content?id=5DT91ar7MwkC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Researcher Brown explores what it takes to live wholeheartedly: embracing vulnerability, letting go of who we think we should be, and cultivating courage, compassion, and connection. Through research and personal stories, she offers practical guideposts for authentic living in a culture demanding perfection.",
    "rating": 4.25,
    "ratingsCount": 222959,
    "pageCount": 137,
    "categories": [
      "Nonfiction",
      "Self-Help",
      "Psychology"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 8,
      "heart": 9,
      "optimistic": 9,
      "fast": 8,
      "standalone": 10,
      "medium": 8,
      "character": 7,
      "plot": 6,
      "modern": 8
    }
  },
  {
    "id": 237,
    "title": "You Are a Badass",
    "author": "Jen Sincero",
    "isbn": "0762447699",
    "googleBooksId": "placeholder237",
    "image": "https://books.google.com/books/content?id=nbEfAQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "With humor and tough love, Sincero helps readers identify self-sabotaging beliefs and create a life they love. Combining spiritual wisdom with practical exercises, she addresses money, relationships, and career with refreshing irreverence. A kick-in-the-pants guide to waking up your inner badass.",
    "rating": 3.95,
    "ratingsCount": 289639,
    "pageCount": 254,
    "awards": [
      "Audie Award Personal Development (2014)"
    ],
    "categories": [
      "Nonfiction",
      "Self-Help",
      "Motivational"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 7,
      "optimistic": 10,
      "fast": 9,
      "standalone": 10,
      "medium": 8,
      "character": 7,
      "plot": 6,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 238,
    "title": "The Untethered Soul",
    "author": "Michael A. Singer",
    "isbn": "1572245379",
    "googleBooksId": "placeholder238",
    "image": "https://books.google.com/books/content?id=fNgA0AEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Singer guides readers beyond their habitual thoughts and emotions to discover the consciousness that observes them. Drawing from yogic philosophy and practical psychology, he offers a path to inner freedom by releasing the mental patterns that limit us. A spiritual journey to the seat of consciousness itself.",
    "rating": 4.2,
    "ratingsCount": 144449,
    "pageCount": 183,
    "categories": [
      "Nonfiction",
      "Spirituality",
      "Self-Help"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 10,
      "slow": 6,
      "optimistic": 9,
      "standalone": 10,
      "medium": 7,
      "character": 7,
      "plot": 6,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 239,
    "title": "Wherever You Go, There You Are",
    "author": "Jon Kabat-Zinn",
    "isbn": "1401307787",
    "googleBooksId": "placeholder239",
    "image": "http://books.google.com/books/content?id=dQ4RAQAAIAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Mindfulness pioneer Kabat-Zinn demystifies meditation, showing how to practice presence in everyday life. Through short, accessible chapters, he explains why and how to pay attention to the present moment. A gentle introduction to mindfulness that has introduced millions to meditation's transformative power.",
    "rating": 4.13,
    "ratingsCount": 54007,
    "pageCount": 304,
    "categories": [
      "Nonfiction",
      "Mindfulness",
      "Self-Help"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 9,
      "slow": 6,
      "optimistic": 8,
      "standalone": 10,
      "medium": 7,
      "character": 7,
      "plot": 6,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 240,
    "title": "The Miracle Morning",
    "author": "Hal Elrod",
    "isbn": "0979019710",
    "googleBooksId": "placeholder240",
    "image": "https://books.google.com/books/content?id=AwUimgEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Elrod presents the SAVERS method (Silence, Affirmations, Visualization, Exercise, Reading, Scribing) for transforming mornings into launching pads for extraordinary days. After his own near-death experience, he developed this routine that helped him achieve success. A practical guide to starting each day with intention.",
    "rating": 3.9,
    "ratingsCount": 86027,
    "pageCount": 172,
    "categories": [
      "Nonfiction",
      "Self-Help",
      "Productivity"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 7,
      "optimistic": 10,
      "fast": 9,
      "standalone": 10,
      "medium": 8,
      "character": 7,
      "plot": 6,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 241,
    "title": "Grit",
    "author": "Angela Duckworth",
    "isbn": "1501111108",
    "googleBooksId": "placeholder241",
    "image": "https://books.google.com/books/content?id=PAMODAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Psychologist Duckworth argues that success comes not from talent but from grit: passion and perseverance for long-term goals. Drawing on research and interviews from West Point to the National Spelling Bee, she shows how grit can be developed. A paradigm shift in how we understand achievement.",
    "rating": 4.08,
    "ratingsCount": 142503,
    "pageCount": 277,
    "awards": [
      "Goodreads Choice Award Nominee Nonfiction (2016)"
    ],
    "categories": [
      "Nonfiction",
      "Psychology",
      "Self-Help"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 9,
      "optimistic": 8,
      "medium": 7,
      "standalone": 10,
      "character": 7,
      "plot": 6,
      "modern": 8,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 242,
    "title": "Start With Why",
    "author": "Simon Sinek",
    "isbn": "1591846447",
    "googleBooksId": "placeholder242",
    "image": "https://books.google.com/books/content?id=fkOKDQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Sinek explores why some organizations and leaders inspire while others don't. His Golden Circle model—start with Why (purpose), then How, then What—explains Apple's success and Martin Luther King Jr.'s influence. A simple but powerful framework for leadership and communication that inspires action.",
    "rating": 4.1,
    "ratingsCount": 270160,
    "pageCount": 256,
    "categories": [
      "Nonfiction",
      "Business",
      "Leadership"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 9,
      "optimistic": 8,
      "fast": 8,
      "standalone": 10,
      "medium": 8,
      "character": 7,
      "plot": 6,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 243,
    "title": "The 5 Love Languages",
    "author": "Gary Chapman",
    "isbn": "080241270X",
    "googleBooksId": "placeholder243",
    "image": "https://books.google.com/books/content?id=PBnqoQEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Chapman identifies five ways people express and receive love: words of affirmation, quality time, gifts, acts of service, and physical touch. Understanding your partner's primary love language transforms relationships. This relationship classic has helped millions communicate love more effectively for over 30 years.",
    "rating": 4.28,
    "ratingsCount": 481722,
    "pageCount": 232,
    "awards": [
      "Audie Award Personal Development/Motivational (2006)"
    ],
    "categories": [
      "Nonfiction",
      "Relationships",
      "Self-Help"
    ],
    "scores": {
      "nonfiction": 10,
      "heart": 9,
      "mind": 7,
      "optimistic": 9,
      "fast": 8,
      "standalone": 10,
      "medium": 8,
      "character": 7,
      "plot": 6,
      "modern": 8
    }
  },
  {
    "id": 244,
    "title": "Rising Strong",
    "author": "Brené Brown",
    "isbn": "081298580X",
    "googleBooksId": "placeholder244",
    "image": "https://books.google.com/books/content?id=GxZDDgAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Brown examines what happens when we fall and how to rise from failure. Through research and storytelling, she presents a process for getting back up: reckoning with emotions, rumbling with stories we tell ourselves, and revolutionizing how we live. A guide to turning setbacks into sources of strength.",
    "rating": 4.25,
    "ratingsCount": 88909,
    "pageCount": 336,
    "awards": [
      "Goodreads Choice Award Nominee Nonfiction (2015)"
    ],
    "categories": [
      "Nonfiction",
      "Self-Help",
      "Psychology"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 9,
      "heart": 8,
      "optimistic": 9,
      "medium": 7,
      "standalone": 10,
      "emotional": 7,
      "character": 7,
      "plot": 6,
      "modern": 8
    }
  },
  {
    "id": 245,
    "title": "Steve Jobs",
    "author": "Walter Isaacson",
    "isbn": "1451648537",
    "googleBooksId": "placeholder245",
    "image": "https://books.google.com/books/content?id=6e4cDvhrKhgC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Based on exclusive interviews with Jobs and those who knew him, Isaacson reveals the driven, perfectionist visionary who revolutionized six industries. From his adoption and early days at Apple to his triumphant return and final innovations, this is the definitive biography of the man who made technology beautiful.",
    "rating": 4.16,
    "ratingsCount": 1362339,
    "pageCount": 630,
    "awards": [
      "Goodreads Choice Award History & Biography (2011)",
      "Financial Times Business Book of the Year Shortlist (2012)"
    ],
    "categories": [
      "Biography",
      "Nonfiction",
      "Business"
    ],
    "scores": {
      "nonfiction": 10,
      "memoir": 9,
      "mind": 8,
      "character": 9,
      "medium": 6,
      "standalone": 10,
      "plot": 5,
      "emotional": 6,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 246,
    "title": "Einstein: His Life and Universe",
    "author": "Walter Isaacson",
    "isbn": "0743264746",
    "googleBooksId": "placeholder246",
    "image": "https://books.google.com/books/content?id=x7vaDgAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Isaacson explores how Einstein's rebellious nature fueled his scientific genius. From patent clerk to world-changing physicist, the biography reveals the man behind relativity: his creativity, pacifism, and complex personal life. A portrait showing how Einstein's imagination and questioning spirit revolutionized our understanding of the universe.",
    "rating": 4.17,
    "ratingsCount": 202866,
    "pageCount": 675,
    "awards": [
      "Audie Award Biography/Memoir (2008)",
      "Quill Award Biography/Memoir (2007)"
    ],
    "categories": [
      "Biography",
      "Science",
      "Nonfiction"
    ],
    "scores": {
      "nonfiction": 10,
      "memoir": 8,
      "mind": 10,
      "character": 8,
      "slow": 7,
      "standalone": 10,
      "medium": 5,
      "plot": 5,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 247,
    "title": "The Autobiography of Malcolm X",
    "author": "Malcolm X & Alex Haley",
    "isbn": "0345350685",
    "googleBooksId": "placeholder247",
    "image": "http://books.google.com/books/content?id=r9MWAQAAIAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "From street hustler to Nation of Islam minister to human rights activist, Malcolm X's life embodied transformation. Told to Alex Haley, this autobiography chronicles his evolution and uncompromising fight for Black liberation. A powerful testament to personal change and one of the most influential memoirs in American history.",
    "rating": 4.37,
    "ratingsCount": 292051,
    "pageCount": 466,
    "awards": [
      "Audie Award Autobiography/Memoir (2021)"
    ],
    "categories": [
      "Memoir",
      "Biography",
      "History"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "history": 8,
      "character": 10,
      "mind": 9,
      "dark": 7,
      "standalone": 10,
      "medium": 6,
      "literary": 8,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 248,
    "title": "Open",
    "author": "Andre Agassi",
    "isbn": "0307388409",
    "googleBooksId": "placeholder248",
    "image": "https://books.google.com/books/content?id=wSzxa9ZaVcUC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Tennis legend Agassi reveals a shocking truth: he hated tennis. Pushed into the sport by his father, he rebelled with addiction and burnout before finding meaning in the game. Brutally honest and beautifully written, this memoir transcends sports to explore identity, pressure, and redemption.",
    "rating": 4.32,
    "ratingsCount": 147468,
    "pageCount": 388,
    "awards": [
      "British Sports Books Award (2010)"
    ],
    "categories": [
      "Memoir",
      "Sports",
      "Biography"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "emotional": 9,
      "character": 9,
      "mind": 7,
      "dark": 6,
      "standalone": 10,
      "medium": 7,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 249,
    "title": "Bad Blood",
    "author": "John Carreyrou",
    "isbn": "152473165X",
    "googleBooksId": "placeholder249",
    "image": "https://books.google.com/books/content?id=zIJcDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Wall Street Journal reporter Carreyrou exposes Theranos, the blood-testing startup that defrauded investors of billions. Founder Elizabeth Holmes promised revolutionary technology that didn't exist, silencing critics through intimidation. A gripping investigation into Silicon Valley hubris, corporate fraud, and the journalists who exposed the truth.",
    "rating": 4.4,
    "ratingsCount": 282446,
    "pageCount": 339,
    "awards": [
      "Los Angeles Times Book Prize Current Interest (2018)",
      "Financial Times Business Book of the Year (2018)",
      "Goodreads Choice Award Nonfiction (2018)"
    ],
    "categories": [
      "Nonfiction",
      "True Crime",
      "Business"
    ],
    "scores": {
      "nonfiction": 10,
      "thriller": 7,
      "plot": 9,
      "fast": 8,
      "dark": 7,
      "mind": 8,
      "standalone": 10,
      "medium": 7,
      "character": 5,
      "modern": 8
    }
  },
  {
    "id": 250,
    "title": "The Innovators",
    "author": "Walter Isaacson",
    "isbn": "1476708703",
    "googleBooksId": "placeholder250",
    "image": "https://books.google.com/books/content?id=H_-hCgAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Isaacson traces the digital revolution from Ada Lovelace to Steve Jobs, showing how collaboration drove innovation. From the computer's invention to the internet's creation, he reveals the teams behind each breakthrough. A celebration of the visionaries and engineers who built our digital age through collective genius.",
    "rating": 4.12,
    "ratingsCount": 39859,
    "pageCount": 542,
    "awards": [
      "National Book Award Nonfiction (2014)",
      "Andrew Carnegie Medal Nonfiction (2015)",
      "Goodreads Choice Award Nonfiction (2014)"
    ],
    "categories": [
      "Nonfiction",
      "Technology",
      "History"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 7,
      "mind": 9,
      "memoir": 6,
      "slow": 7,
      "standalone": 10,
      "medium": 6,
      "character": 7,
      "plot": 6,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 251,
    "title": "Into Thin Air",
    "author": "Jon Krakauer",
    "isbn": "0385494785",
    "googleBooksId": "placeholder251",
    "image": "https://books.google.com/books/content?id=lI_2H3GUulEC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Krakauer joined a 1996 Everest expedition that ended in tragedy when a storm killed eight climbers. His firsthand account examines what went wrong and questions the commercialization of extreme climbing. A harrowing survival story that's also a meditation on risk, responsibility, and the mountain's deadly allure.",
    "rating": 4.26,
    "ratingsCount": 570115,
    "pageCount": 368,
    "awards": [
      "Pulitzer Prize General Nonfiction (1998)",
      "ALA Alex Award (1998)",
      "National Book Critics Circle Award General Nonfiction (1997)",
      "Boardman Tasker Prize Mountain Literature (1997)"
    ],
    "categories": [
      "Memoir",
      "Adventure",
      "Nonfiction"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "dark": 9,
      "plot": 9,
      "fast": 8,
      "mind": 7,
      "character": 7,
      "standalone": 10,
      "medium": 7,
      "modern": 8
    }
  },
  {
    "id": 252,
    "title": "Angela's Ashes",
    "author": "Frank McCourt",
    "isbn": "0684874350",
    "googleBooksId": "placeholder252",
    "image": "https://books.google.com/books/content?id=MIzkBgAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "McCourt recounts his impoverished Irish Catholic childhood in 1930s-40s Limerick. Despite hunger, disease, and his father's alcoholism, he survives through wit and determination. Told with dark humor and lyricism, this Pulitzer Prize winner transforms a miserable childhood into triumphant art.",
    "rating": 4.15,
    "ratingsCount": 659301,
    "pageCount": 452,
    "awards": [
      "Pulitzer Prize Biography or Autobiography (1997)",
      "American Booksellers Book of the Year Award (1997)",
      "Los Angeles Times Book Prize Biography (1996)",
      "National Book Critics Circle Award Biography/Autobiography (1996)"
    ],
    "categories": [
      "Memoir",
      "Biography",
      "Irish"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "dark": 8,
      "emotional": 9,
      "character": 9,
      "literary": 9,
      "slow": 6,
      "standalone": 10,
      "medium": 6,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 253,
    "title": "I Know Why the Caged Bird Sings",
    "author": "Maya Angelou",
    "isbn": "0345514408",
    "googleBooksId": "placeholder253",
    "image": "https://books.google.com/books/content?id=5kWTEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Angelou's childhood in 1930s Arkansas confronts racism, trauma, and finding her voice after years of silence. From her grandmother's store to her first words spoken again, she transforms pain into poetry. The first volume of her autobiography is a landmark of Black literature and female resilience.",
    "rating": 4.3,
    "ratingsCount": 582846,
    "pageCount": 289,
    "awards": [
      "Coretta Scott King Book Award Author Honor (1971)"
    ],
    "categories": [
      "Memoir",
      "Biography",
      "Classic"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "literary": 10,
      "emotional": 9,
      "character": 10,
      "dark": 7,
      "standalone": 9,
      "medium": 7,
      "classic": 8,
      "plot": 5
    }
  },
  {
    "id": 254,
    "title": "Hillbilly Elegy",
    "author": "J.D. Vance",
    "isbn": "0062300547",
    "googleBooksId": "placeholder254",
    "image": "https://books.google.com/books/content?id=-wFtjgEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Vance chronicles his Appalachian family's journey from Kentucky to Ohio's Rust Belt, exploring the social crisis facing America's white working class. From poverty and addiction to Yale Law School, he examines the culture that shaped him. A personal story that sparked national debate about class and opportunity.",
    "rating": 3.84,
    "ratingsCount": 505481,
    "pageCount": 264,
    "awards": [
      "Audie Award Nonfiction (2017)",
      "Dayton Literary Peace Prize Nonfiction (2017)",
      "Kirkus Prize Nonfiction (2016)",
      "Goodreads Choice Award Nominee Memoir (2016)"
    ],
    "categories": [
      "Memoir",
      "Sociology",
      "Nonfiction"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "mind": 8,
      "character": 8,
      "dark": 6,
      "emotional": 7,
      "standalone": 10,
      "medium": 8,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 255,
    "title": "The Time Traveler's Wife",
    "author": "Audrey Niffenegger",
    "isbn": "015602943X",
    "googleBooksId": "placeholder255",
    "image": "https://books.google.com/books/content?id=NdJhtuFMpeUC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Henry suffers from a genetic disorder that causes him to time-travel unpredictably. Clare meets him throughout her childhood before their first 'real' meeting. Their love story unfolds out of sequence, testing whether their relationship can survive when Henry can't stay in one time. An innovative romance about fate and choice.",
    "rating": 4,
    "ratingsCount": 1859290,
    "pageCount": 537,
    "awards": [
      "Arthur C. Clarke Award (2005)",
      "Orange Prize Fiction Longlist (2004)",
      "British Book Award (2006)",
      "John W. Campbell Memorial Award Best Science Fiction Novel (2005)",
      "ALA Alex Award (2004)"
    ],
    "categories": [
      "Romance",
      "Science Fiction",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "emotional": 10,
      "contemporary": 8,
      "scifi": 6,
      "character": 9,
      "literary": 7,
      "medium": 6,
      "standalone": 10,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 256,
    "title": "Me Before You",
    "author": "Jojo Moyes",
    "isbn": "0143124544",
    "googleBooksId": "placeholder256",
    "image": "https://books.google.com/books/content?id=rTYEyWrXLO0C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Quirky Louisa Clark becomes caregiver to Will Traynor, a wealthy quadriplegic who's lost his will to live. As Lou tries to show him life's worth living, they fall in love—but Will has made a decision Lou may not be able to change. A heartbreaking romance about autonomy, love, and impossible choices.",
    "rating": 4.26,
    "ratingsCount": 1805742,
    "pageCount": 369,
    "awards": [
      "Goodreads Choice Award Fiction Nominee (2013)",
      "RUSA CODES Reading List Women's Fiction (2014)"
    ],
    "categories": [
      "Romance",
      "Contemporary",
      "Drama"
    ],
    "scores": {
      "heart": 10,
      "emotional": 10,
      "contemporary": 9,
      "character": 9,
      "dark": 7,
      "fast": 7,
      "standalone": 9,
      "medium": 7,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 257,
    "title": "The Notebook",
    "author": "Nicholas Sparks",
    "isbn": "1455582883",
    "googleBooksId": "placeholder257",
    "image": "https://books.google.com/books/content?id=GskBnwEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "An elderly man reads to a woman in a nursing home—the story of Noah and Allie's summer romance in 1940s North Carolina, torn apart by class and war, then reignited years later. Sparks's debut novel became a modern romance classic, celebrating enduring love through memory and devotion.",
    "rating": 4.16,
    "ratingsCount": 1845092,
    "pageCount": 227,
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "emotional": 10,
      "contemporary": 8,
      "character": 8,
      "optimistic": 8,
      "fast": 8,
      "standalone": 10,
      "medium": 8,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 258,
    "title": "Bridgerton: The Duke and I",
    "author": "Julia Quinn",
    "isbn": "0062353594",
    "googleBooksId": "placeholder258",
    "image": "https://books.google.com/books/content?id=9xPNoQEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Daphne Bridgerton and Simon Basset, the Duke of Hastings, fake a courtship to deter other suitors. But their ruse becomes real as attraction ignites. Set in Regency England, Quinn's witty historical romance launched a phenomenon, blending humor, chemistry, and scandal in high society.",
    "rating": 3.8,
    "ratingsCount": 691440,
    "pageCount": 384,
    "awards": [
      "RITA Award Short Historical Romance (2001)"
    ],
    "categories": [
      "Romance",
      "Historical",
      "Regency"
    ],
    "scores": {
      "heart": 10,
      "historical": 8,
      "character": 8,
      "plot": 8,
      "fast": 8,
      "optimistic": 9,
      "series": 8,
      "medium": 7,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 259,
    "title": "The Rosie Project",
    "author": "Graeme Simsion",
    "isbn": "1476729093",
    "googleBooksId": "placeholder259",
    "image": "https://books.google.com/books/content?id=An6mAwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Genetics professor Don Tillman designs a scientific questionnaire to find the perfect wife. Then he meets Rosie, who fails every criterion but upends his ordered life. Simsion's charming romantic comedy celebrates neurodiversity and proves that love doesn't follow a formula.",
    "rating": 4.01,
    "ratingsCount": 595550,
    "pageCount": 292,
    "awards": [
      "Australian Book Industry Award General Fiction (2014)",
      "Goodreads Choice Award Fiction (2013)"
    ],
    "categories": [
      "Romance",
      "Contemporary",
      "Humor"
    ],
    "scores": {
      "heart": 9,
      "contemporary": 9,
      "character": 9,
      "optimistic": 9,
      "fast": 8,
      "plot": 7,
      "standalone": 9,
      "medium": 8,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 260,
    "title": "Eleanor & Park",
    "author": "Rainbow Rowell",
    "isbn": "1250012570",
    "googleBooksId": "placeholder260",
    "image": "https://books.google.com/books/content?id=DJsyrEuke0cC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In 1986 Omaha, misfit Eleanor and half-Korean Park bond over comic books on the school bus. As their friendship deepens into first love, Eleanor's chaotic home life threatens everything. Rowell's acclaimed YA captures the intensity and heartbreak of teenage romance with authenticity and tenderness.",
    "rating": 3.92,
    "ratingsCount": 1261510,
    "pageCount": 328,
    "awards": [
      "Michael L. Printz Award Honor (2014)",
      "Boston Globe-Horn Book Award (2013)",
      "Goodreads Choice Award Young Adult Fiction (2013)"
    ],
    "categories": [
      "Romance",
      "Young Adult",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "emotional": 9,
      "contemporary": 9,
      "character": 9,
      "dark": 6,
      "fast": 7,
      "standalone": 10,
      "medium": 7,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 261,
    "title": "Anna and the French Kiss",
    "author": "Stephanie Perkins",
    "isbn": "0142419400",
    "googleBooksId": "placeholder261",
    "image": "https://books.google.com/books/content?id=uIjl2YVrV6AC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Anna is sent to boarding school in Paris against her will. There she meets Étienne—charming, perfect, and unavailable. Their friendship blossoms into more as Anna discovers Paris isn't so bad after all. Perkins's swoon-worthy YA romance captures the magic of first love in the City of Light.",
    "rating": 3.96,
    "ratingsCount": 464979,
    "pageCount": 372,
    "awards": [
      "Georgia Peach Book Award Honor (2013)",
      "Pennsylvania Young Readers' Choice Award (2013)",
      "Goodreads Choice Award Nominee (2010)"
    ],
    "categories": [
      "Romance",
      "Young Adult",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 9,
      "optimistic": 9,
      "character": 8,
      "fast": 8,
      "emotional": 8,
      "standalone": 9,
      "medium": 7,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 262,
    "title": "To All the Boys I've Loved Before",
    "author": "Jenny Han",
    "isbn": "1442426713",
    "googleBooksId": "placeholder262",
    "image": "https://books.google.com/books/content?id=AqdpCwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Lara Jean writes secret love letters to her crushes, never intending to send them. When they're accidentally mailed, her quiet life implodes—especially when one recipient suggests a fake relationship. Han's adorable YA launched a cultural phenomenon with its sweet portrayal of teenage romance and family.",
    "rating": 4.04,
    "ratingsCount": 1062165,
    "pageCount": 384,
    "awards": [
      "Pennsylvania Young Readers' Choice Award Young Adults (2016)",
      "Lincoln Award (2018)",
      "Goodreads Choice Award Nominee Young Adult Fiction (2014)"
    ],
    "categories": [
      "Romance",
      "Young Adult",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 9,
      "optimistic": 10,
      "character": 8,
      "fast": 8,
      "plot": 7,
      "series": 8,
      "medium": 8,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 263,
    "title": "The Seven Husbands of Evelyn Hugo",
    "author": "Taylor Jenkins Reid",
    "isbn": "1501139231",
    "googleBooksId": "placeholder263",
    "image": "https://books.google.com/books/content?id=IdAmDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Aging Hollywood icon Evelyn Hugo chooses unknown journalist Monique to write her biography. As Evelyn reveals her seven marriages and true love story, Monique discovers why she was chosen. Reid's novel is a glamorous, heartbreaking tale of ambition, identity, and the price of fame.",
    "rating": 4.39,
    "ratingsCount": 4121820,
    "pageCount": 389,
    "awards": [
      "Goodreads Choice Award Nominee Historical Fiction (2017)",
      "Book of the Month Book of the Year Award (2017)"
    ],
    "categories": [
      "Romance",
      "Contemporary",
      "LGBTQ"
    ],
    "scores": {
      "heart": 10,
      "emotional": 10,
      "contemporary": 9,
      "character": 10,
      "literary": 7,
      "plot": 9,
      "standalone": 10,
      "medium": 7,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 264,
    "title": "November 9",
    "author": "Colleen Hoover",
    "publicationYear": 2015,
    "isbn": "1501110349",
    "googleBooksId": "placeholder264",
    "image": "https://books.google.com/books/content?id=R9_cCgAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Fallon and Ben meet on November 9, the day she's moving across the country. They agree to meet on that date every year, no contact between. As their annual meetings span years, their connection deepens—but Ben harbors a secret that could destroy everything. Hoover's romance twists expectations.",
    "rating": 4.1,
    "ratingsCount": 1331562,
    "pageCount": 310,
    "categories": [
      "Romance",
      "Contemporary",
      "Drama"
    ],
    "scores": {
      "heart": 10,
      "emotional": 9,
      "contemporary": 9,
      "character": 8,
      "plot": 8,
      "fast": 8,
      "dark": 6,
      "standalone": 10,
      "medium": 8,
      "modern": 8
    }
  },
  {
    "id": 269,
    "title": "Piranesi",
    "author": "Susanna Clarke",
    "publicationYear": 2020,
    "isbn": "1526622424",
    "googleBooksId": "placeholder269",
    "image": "https://books.google.com/books/content?id=-xBbEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Piranesi lives in the House. The House is infinite, its rooms filled with thousands upon thousands of statues. There is one other person—the Other—who brings Piranesi scientific instruments. Piranesi records his findings and explores the House, but a mystery lies at the heart of his world. A meditative, dreamlike masterpiece.",
    "rating": 4.21,
    "ratingsCount": 477681,
    "pageCount": 272,
    "awards": [
      "Hugo Award Best Novel (2021)",
      "Nebula Award Best Novel (2020)",
      "Women's Prize for Fiction (2021)",
      "World Fantasy Award Best Novel (2021)",
      "Locus Award Best Fantasy Novel (2021)",
      "Costa Book Award Novel (2020)"
    ],
    "categories": [
      "Fantasy",
      "Literary Fiction",
      "Mystery"
    ],
    "scores": {
      "fantasy": 9,
      "literary": 10,
      "atmosphere": 10,
      "mystery": 8,
      "character": 8,
      "slow": 8,
      "mind": 9,
      "standalone": 10,
      "modern": 10,
      "emotional": 7
    }
  },
  {
    "id": 272,
    "title": "Beartown",
    "author": "Fredrik Backman",
    "authorGender": "male",
    "publicationYear": 2016,
    "series": {
      "name": "Beartown",
      "position": 1
    },
    "isbn": "1501160761",
    "googleBooksId": "hJnkyQEACAAJ",
    "image": "https://books.google.com/books/content?id=SJGxDgAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "People say Beartown is finished. A town in a forest deep in Sweden, where hockey is everything. When a shocking act of violence occurs, the town is torn apart. Backman explores the hopes that bring a community together, the secrets that tear it apart, and the courage it takes to stand up for what you believe in.",
    "rating": 4.29,
    "ratingsCount": 602670,
    "pageCount": 432,
    "awards": [
      "Lincoln Award (2019)",
      "Goodreads Choice Award Fiction (2017)",
      "Dublin Literary Award (2019)"
    ],
    "categories": [
      "Contemporary Fiction",
      "Literary Fiction",
      "Sports"
    ],
    "scores": {
      "contemporary": 9,
      "character": 10,
      "emotional": 10,
      "dark": 8,
      "literary": 8,
      "atmosphere": 9,
      "medium": 7,
      "heart": 9,
      "standalone": 8,
      "modern": 9
    }
  },
  {
    "id": 273,
    "title": "Station Eleven",
    "author": "Emily St. John Mandel",
    "publicationYear": 2014,
    "isbn": "0385353308",
    "googleBooksId": "placeholder273",
    "image": "https://books.google.com/books/content?id=WziNEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "On a snowy night, a famous actor dies on stage during a production of King Lear. Hours later, the world as we know it begins to dissolve. Fifteen years later, a traveling troupe performs Shakespeare and symphony for the scattered survivors. A meditation on art, memory, and what we preserve when civilization crumbles.",
    "rating": 4.07,
    "ratingsCount": 616231,
    "pageCount": 333,
    "awards": [
      "National Book Award Finalist (2014)",
      "PEN/Faulkner Award Fiction (2015)",
      "Arthur C. Clarke Award (2015)",
      "Locus Award Best SF Novel (2015)"
    ],
    "categories": [
      "Science Fiction",
      "Literary Fiction",
      "Dystopian"
    ],
    "scores": {
      "scifi": 7,
      "literary": 10,
      "character": 9,
      "atmosphere": 10,
      "dark": 7,
      "medium": 7,
      "mind": 9,
      "emotional": 8,
      "standalone": 10,
      "modern": 9
    }
  },
  {
    "id": 278,
    "title": "How to Say Babylon",
    "author": "Safiya Sinclair",
    "publicationYear": 2023,
    "isbn": "1982132337",
    "googleBooksId": "placeholder278",
    "image": "https://books.google.com/books/content?id=1TvaEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A stunning memoir about breaking free from a strict Rastafarian upbringing in Jamaica. National Book Critics Circle Award winner Safiya Sinclair traces her journey from her father's repressive control to finding her own voice as a woman and poet.",
    "rating": 4.43,
    "ratingsCount": 31695,
    "pageCount": 352,
    "awards": [
      "National Book Critics Circle Award Autobiography (2023)",
      "Goodreads Choice Award Memoir (2023)",
      "OCM Bocas Prize Caribbean Literature (2024)"
    ],
    "categories": [
      "Memoir",
      "Biography",
      "Nonfiction"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "character": 10,
      "emotional": 10,
      "dark": 8,
      "mind": 8,
      "heart": 9,
      "literary": 9,
      "medium": 7,
      "standalone": 10,
      "modern": 10
    }
  },
  {
    "id": 286,
    "title": "The Color Purple",
    "author": "Alice Walker",
    "publicationYear": 1982,
    "series": {
      "name": "The Color Purple Collection",
      "position": 1
    },
    "isbn": "0156028352",
    "googleBooksId": "placeholder286",
    "image": "https://books.google.com/books/content?id=_lzUlQQv3XAC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Celie is a poor black woman living in the South. Through a series of letters—written to God and to her sister—Walker paints an unforgettable portrait of women joined by love, pain, struggle, and triumph. A classic of American literature that celebrates the strength of the human spirit and the power of resilience.",
    "rating": 4.28,
    "ratingsCount": 753850,
    "pageCount": 287,
    "awards": [
      "Pulitzer Prize Fiction (1983)",
      "National Book Award Fiction (1983)",
      "National Book Critics Circle Award Fiction (1982)"
    ],
    "categories": [
      "Literary Fiction",
      "Historical Fiction",
      "Classic"
    ],
    "scores": {
      "literary": 10,
      "historical": 9,
      "character": 10,
      "emotional": 10,
      "dark": 8,
      "heart": 9,
      "medium": 6,
      "standalone": 10,
      "classic": 10,
      "optimistic": 6
    }
  },
  {
    "id": 295,
    "title": "The Handmaid's Tale",
    "author": "Margaret Atwood",
    "publicationYear": 1985,
    "series": {
      "name": "The Handmaid's Tale",
      "position": 1
    },
    "isbn": "038549081X",
    "googleBooksId": "placeholder295",
    "image": "https://books.google.com/books/content?id=4QXnYRaBUFAC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In the Republic of Gilead, Offred is a Handmaid, one of the caste of women forced into sexual servitude as a last desperate attempt to repopulate a devastated world. Offred can remember a time when she lived with her husband and daughter, but now she's a prisoner. Atwood's dystopian masterpiece is chillingly prescient.",
    "rating": 4.15,
    "ratingsCount": 2433967,
    "pageCount": 311,
    "awards": [
      "Booker Prize (1986)",
      "Nebula Award Best Novel (1986)",
      "Arthur C. Clarke Award (1987)",
      "Locus Award Best SF Novel (1987)",
      "Los Angeles Times Book Prize Fiction (1986)"
    ],
    "categories": [
      "Dystopian",
      "Science Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "scifi": 7,
      "literary": 10,
      "dark": 10,
      "character": 9,
      "emotional": 9,
      "atmosphere": 9,
      "medium": 7,
      "mind": 10,
      "standalone": 9,
      "classic": 10
    }
  },
  {
    "id": 297,
    "title": "Brave New World",
    "author": "Aldous Huxley",
    "publicationYear": 1932,
    "series": {
      "name": "Brave New World",
      "position": 1
    },
    "isbn": "0060850523",
    "googleBooksId": "placeholder297",
    "image": "https://books.google.com/books/content?id=3PabEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In this prophetic dystopian novel, Huxley envisions a future world in which humans are genetically bred and pharmaceutically conditioned to serve in a ruling order. One man, raised in the savage reservation, challenges this so-called utopia. A masterpiece of speculative fiction that asks profound questions about freedom and happiness.",
    "rating": 3.99,
    "ratingsCount": 2083057,
    "pageCount": 288,
    "categories": [
      "Dystopian",
      "Science Fiction",
      "Classic"
    ],
    "scores": {
      "scifi": 8,
      "literary": 10,
      "dark": 8,
      "mind": 10,
      "character": 7,
      "atmosphere": 9,
      "medium": 7,
      "standalone": 10,
      "classic": 10,
      "emotional": 6
    }
  },
  {
    "id": 298,
    "title": "Fahrenheit 451",
    "author": "Ray Bradbury",
    "publicationYear": 1953,
    "isbn": "1451673310",
    "googleBooksId": "placeholder298",
    "image": "https://books.google.com/books/content?id=y3CyRurE7P4C&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Guy Montag is a fireman. His job is to burn books, which are forbidden. After a chance meeting with an eccentric young neighbor, he begins to question everything—his happiness, his marriage, and his occupation. Bradbury's powerful dystopian novel celebrates literature and the importance of free thought. A timeless classic.",
    "rating": 3.97,
    "ratingsCount": 2849382,
    "pageCount": 249,
    "awards": [
      "Prometheus Hall of Fame Award (1984)",
      "Retro Hugo Award Best Novel (2004)",
      "California Book Award Fiction (1953)"
    ],
    "categories": [
      "Dystopian",
      "Science Fiction",
      "Classic"
    ],
    "scores": {
      "scifi": 7,
      "literary": 10,
      "dark": 8,
      "mind": 10,
      "character": 7,
      "atmosphere": 9,
      "medium": 7,
      "standalone": 10,
      "classic": 10,
      "emotional": 7
    }
  },
  {
    "id": 304,
    "title": "Little Women",
    "author": "Louisa May Alcott",
    "publicationYear": 1868,
    "series": {
      "name": "Little Women",
      "position": 1
    },
    "isbn": "0147514010",
    "googleBooksId": "placeholder304",
    "image": "https://books.google.com/books/content?id=He3YCwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The four March sisters—Meg, Jo, Beth, and Amy—each possess a distinct personality. From their childhood in Massachusetts during the Civil War to their passage into womanhood, they share their most cherished moments. Alcott's beloved classic celebrates family, ambition, and the strength of women.",
    "rating": 4.17,
    "ratingsCount": 2467717,
    "pageCount": 449,
    "categories": [
      "Classic",
      "Historical Fiction",
      "Coming of Age"
    ],
    "scores": {
      "literary": 8,
      "historical": 9,
      "character": 10,
      "heart": 10,
      "optimistic": 9,
      "emotional": 9,
      "atmosphere": 8,
      "slow": 6,
      "standalone": 10,
      "classic": 10
    }
  },
  {
    "id": 308,
    "title": "The Fault in Our Stars",
    "author": "John Green",
    "publicationYear": 2012,
    "isbn": "0525478817",
    "googleBooksId": "placeholder308",
    "image": "https://books.google.com/books/content?id=Dc2LDQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Hazel Grace Lancaster is a sixteen-year-old cancer patient forced to attend a support group where she meets Augustus Waters. Their relationship blossoms as they bond over their favorite book. Green's novel about love, loss, and the meaning we find in our brief lives became a cultural phenomenon.",
    "rating": 4.12,
    "ratingsCount": 5737407,
    "pageCount": 313,
    "awards": [
      "Goodreads Choice Award Young Adult Fiction (2012)",
      "Georgia Peach Book Award (2013)",
      "Odyssey Award (2013)",
      "Audie Award Teens (2013)"
    ],
    "categories": [
      "Young Adult",
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "contemporary": 9,
      "character": 10,
      "emotional": 10,
      "heart": 10,
      "dark": 7,
      "fast": 7,
      "medium": 8,
      "standalone": 10,
      "modern": 9,
      "optimistic": 6
    }
  },
  {
    "id": 309,
    "title": "The Perks of Being a Wallflower",
    "author": "Stephen Chbosky",
    "publicationYear": 1999,
    "isbn": "1451696191",
    "googleBooksId": "placeholder309",
    "image": "https://books.google.com/books/content?id=pK0X5FyUs28C&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Charlie is a freshman. And while he's not the biggest geek in the school, he is by no means popular. Shy, introspective, and intelligent, Charlie navigates high school, trying to cope with the realities of growing up. Through a series of letters, Chbosky captures the teenage experience with raw honesty and tenderness.",
    "rating": 4.24,
    "ratingsCount": 2006527,
    "pageCount": 213,
    "categories": [
      "Young Adult",
      "Contemporary",
      "Coming of Age"
    ],
    "scores": {
      "contemporary": 10,
      "character": 9,
      "emotional": 10,
      "dark": 7,
      "heart": 9,
      "fast": 6,
      "medium": 7,
      "standalone": 10,
      "modern": 8,
      "literary": 6
    }
  },
  {
    "id": 310,
    "title": "Looking for Alaska",
    "author": "John Green",
    "publicationYear": 2005,
    "isbn": "0142402516",
    "googleBooksId": "placeholder310",
    "image": "https://books.google.com/books/content?id=4yY_v6dw7ZsC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Miles Halter is done with his safe life at home. He goes to boarding school seeking the Great Perhaps. There he meets Alaska Young—gorgeous, clever, funny, self-destructive. She pulls Miles into her world, but when tragedy strikes, Miles must confront the aftermath. Green's debut is a profound meditation on grief and growing up.",
    "rating": 3.96,
    "ratingsCount": 1751977,
    "pageCount": 221,
    "awards": [
      "Michael L. Printz Award (2006)",
      "Los Angeles Times Book Prize Young Adult Fiction (2005)"
    ],
    "categories": [
      "Young Adult",
      "Contemporary",
      "Coming of Age"
    ],
    "scores": {
      "contemporary": 10,
      "character": 9,
      "emotional": 10,
      "dark": 8,
      "heart": 8,
      "fast": 7,
      "medium": 7,
      "standalone": 10,
      "modern": 8,
      "literary": 7
    }
  },
  {
    "id": 327,
    "title": "The Power of Habit",
    "author": "Charles Duhigg",
    "publicationYear": 2012,
    "isbn": "081298160X",
    "googleBooksId": "placeholder327",
    "image": "https://books.google.com/books/content?id=rrlPEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In The Power of Habit, Pulitzer Prize-winning journalist Charles Duhigg explains why habits exist and how they can be changed. With penetrating intelligence and an ability to distill vast amounts of information, Duhigg brings to life scientific discoveries that explain why habits exist and how they can be transformed.",
    "rating": 4.13,
    "ratingsCount": 563805,
    "pageCount": 375,
    "awards": [
      "Financial Times Business Book of the Year Longlist (2012)",
      "Goodreads Choice Award Nominee Nonfiction (2012)"
    ],
    "categories": [
      "Psychology",
      "Nonfiction",
      "Self-Help"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 9,
      "medium": 7,
      "optimistic": 8,
      "fast": 7,
      "character": 4,
      "plot": 5,
      "standalone": 10,
      "modern": 9,
      "emotional": 4
    }
  },
  {
    "id": 328,
    "title": "Quiet: The Power of Introverts",
    "author": "Susan Cain",
    "publicationYear": 2012,
    "isbn": "0307352153",
    "googleBooksId": "placeholder328",
    "image": "https://books.google.com/books/content?id=uNMjeFMorPgC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "At least one-third of people are introverts. They are the ones who prefer listening to speaking, reading to partying. Yet our culture celebrates the extrovert ideal. Cain argues that we dramatically undervalue introverts and shows how much we lose in doing so. A passionate defense of the quiet ones among us.",
    "rating": 4.08,
    "ratingsCount": 476053,
    "pageCount": 333,
    "awards": [
      "Goodreads Choice Award Nonfiction (2012)",
      "Andrew Carnegie Medal Nonfiction Shortlist (2015)"
    ],
    "categories": [
      "Psychology",
      "Nonfiction",
      "Self-Help"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 9,
      "medium": 7,
      "character": 5,
      "optimistic": 7,
      "slow": 6,
      "literary": 6,
      "standalone": 10,
      "modern": 9,
      "emotional": 6
    }
  },
  {
    "id": 329,
    "title": "Caste",
    "author": "Isabel Wilkerson",
    "publicationYear": 2020,
    "isbn": "0593230256",
    "googleBooksId": "placeholder329",
    "image": "https://books.google.com/books/content?id=_er2DwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Wilkerson examines the unspoken caste system that has shaped America, linking it to caste systems in India and Nazi Germany. A masterful examination of hierarchy and its devastating consequences on society.",
    "rating": 4.52,
    "ratingsCount": 161973,
    "pageCount": 544,
    "awards": [
      "National Book Critics Circle Award Nonfiction (2020)",
      "Kirkus Prize Nonfiction (2020)",
      "Goodreads Choice Award History & Biography (2020)",
      "Los Angeles Times Book Prize Current Interest (2020)"
    ],
    "categories": [
      "Nonfiction",
      "History",
      "Sociology"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 9,
      "mind": 10,
      "dark": 7,
      "emotional": 8,
      "literary": 8,
      "slow": 7,
      "standalone": 10,
      "modern": 10,
      "character": 8,
      "plot": 5
    }
  },
  {
    "id": 330,
    "title": "The Warmth of Other Suns",
    "author": "Isabel Wilkerson",
    "publicationYear": 2010,
    "isbn": "0679763880",
    "googleBooksId": "placeholder330",
    "image": "https://books.google.com/books/content?id=dt6JDQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "An epic narrative following three individuals who made the decision to leave the South during the Great Migration. Wilkerson spent 15 years interviewing more than a thousand people to create this landmark chronicle.",
    "rating": 4.48,
    "ratingsCount": 117315,
    "pageCount": 640,
    "awards": [
      "National Book Critics Circle Award General Nonfiction (2010)",
      "PEN/John Kenneth Galbraith Award Nonfiction (2011)",
      "Anisfield-Wolf Book Award Non-Fiction (2011)",
      "Goodreads Choice Award History and Biography (2010)"
    ],
    "categories": [
      "Nonfiction",
      "History",
      "American History"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 10,
      "character": 9,
      "emotional": 9,
      "literary": 9,
      "slow": 8,
      "atmosphere": 8,
      "standalone": 10,
      "modern": 9,
      "plot": 5
    }
  },
  {
    "id": 331,
    "title": "The Hiding Place",
    "author": "Corrie ten Boom",
    "publicationYear": 1971,
    "isbn": "0800794052",
    "googleBooksId": "placeholder331",
    "image": "https://books.google.com/books/content?id=lZhzBQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The remarkable true story of a Dutch watchmaker and her family who became heroes of the Resistance, saving hundreds of Jews from the Nazis during WWII, only to be captured and sent to concentration camps.",
    "rating": 4.48,
    "ratingsCount": 357725,
    "pageCount": 242,
    "categories": [
      "Memoir",
      "History",
      "World War II"
    ],
    "scores": {
      "memoir": 10,
      "history": 9,
      "nonfiction": 9,
      "emotional": 10,
      "heart": 9,
      "dark": 8,
      "optimistic": 7,
      "character": 9,
      "standalone": 10,
      "classic": 7
    }
  },
  {
    "id": 332,
    "title": "Say Nothing",
    "author": "Patrick Radden Keefe",
    "publicationYear": 2018,
    "isbn": "0385521316",
    "googleBooksId": "placeholder332",
    "image": "https://books.google.com/books/content?id=By4vtwEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A gripping narrative about the Troubles in Northern Ireland, centering on the 1972 abduction of Jean McConville and weaving together the stories of IRA members and their victims.",
    "rating": 4.47,
    "ratingsCount": 168417,
    "pageCount": 441,
    "awards": [
      "National Book Award Nonfiction (2019)",
      "Orwell Prize for Political Writing (2019)",
      "National Book Critics Circle Award Nonfiction (2019)",
      "Kirkus Prize Nonfiction (2019)"
    ],
    "categories": [
      "Nonfiction",
      "History",
      "True Crime"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 9,
      "thriller": 7,
      "dark": 9,
      "plot": 8,
      "character": 9,
      "literary": 8,
      "medium": 7,
      "standalone": 10,
      "modern": 9
    }
  },
  {
    "id": 333,
    "title": "The Boys in the Boat",
    "author": "Daniel James Brown",
    "publicationYear": 2013,
    "isbn": "0143125478",
    "googleBooksId": "placeholder333",
    "image": "https://books.google.com/books/content?id=DrcBDAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The story of nine working-class Americans who stunned the world at the 1936 Berlin Olympics by defeating the elite rowing teams to win gold, defying Hitler himself.",
    "rating": 4.39,
    "ratingsCount": 362519,
    "pageCount": 404,
    "awards": [
      "James Tait Black Memorial Prize Biography (2013)",
      "Goodreads Choice Award History & Biography (2013)",
      "Andrew Carnegie Medal Nonfiction (2014)"
    ],
    "categories": [
      "Nonfiction",
      "History",
      "Sports"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 9,
      "character": 9,
      "optimistic": 9,
      "emotional": 8,
      "plot": 8,
      "atmosphere": 7,
      "medium": 8,
      "standalone": 10,
      "modern": 8
    }
  },
  {
    "id": 334,
    "title": "Night",
    "author": "Elie Wiesel",
    "publicationYear": 1956,
    "series": {
      "name": "The Night Trilogy",
      "position": 1
    },
    "isbn": "0374500010",
    "googleBooksId": "placeholder334",
    "image": "https://books.google.com/books/content?id=3YIGAQAAIAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A devastating memoir of survival in Auschwitz and Buchenwald. Wiesel shares his experiences as a teenager during the Holocaust, witnessing the death of his family and the death of his own innocence.",
    "rating": 4.38,
    "ratingsCount": 1367518,
    "pageCount": 120,
    "awards": [
      "Nobel Peace Prize Author (1986)"
    ],
    "categories": [
      "Memoir",
      "History",
      "Holocaust"
    ],
    "scores": {
      "memoir": 10,
      "history": 10,
      "nonfiction": 9,
      "dark": 10,
      "emotional": 10,
      "literary": 9,
      "fast": 8,
      "character": 9,
      "standalone": 10,
      "classic": 10
    }
  },
  {
    "id": 335,
    "title": "Midnight in Chernobyl",
    "author": "Adam Higginbotham",
    "publicationYear": 2019,
    "isbn": "1501134612",
    "googleBooksId": "placeholder335",
    "image": "https://books.google.com/books/content?id=04v-yQEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The untold story of the world's worst nuclear disaster. Drawing on hundreds of hours of interviews, Higginbotham presents a masterfully reported account of the 1986 catastrophe.",
    "rating": 4.37,
    "ratingsCount": 65299,
    "pageCount": 538,
    "awards": [
      "Colby Award (2020)",
      "Los Angeles Times Book Prize Science & Technology (2019)",
      "Andrew Carnegie Medal Nonfiction (2020)",
      "Goodreads Choice Award History & Biography (2019)"
    ],
    "categories": [
      "Nonfiction",
      "History",
      "Science"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 9,
      "thriller": 7,
      "dark": 8,
      "plot": 9,
      "atmosphere": 8,
      "mind": 8,
      "medium": 7,
      "standalone": 10,
      "modern": 10
    }
  },
  {
    "id": 336,
    "title": "Killers of the Flower Moon",
    "author": "David Grann",
    "publicationYear": 2017,
    "isbn": "0385534248",
    "googleBooksId": "placeholder336",
    "image": "https://books.google.com/books/content?id=EEGNEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The Osage murders of the 1920s and the birth of the FBI. Members of the Osage Nation were being killed one by one after oil was discovered on their land, in one of the most sinister crimes in American history.",
    "rating": 4.14,
    "ratingsCount": 448304,
    "pageCount": 359,
    "awards": [
      "Edgar Award Best Fact Crime (2018)",
      "Andrew Carnegie Medal Nonfiction (2018)",
      "National Book Award Finalist Nonfiction (2017)",
      "Goodreads Choice Award History & Biography (2017)"
    ],
    "categories": [
      "Nonfiction",
      "History",
      "True Crime"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 9,
      "mystery": 8,
      "thriller": 7,
      "dark": 9,
      "plot": 9,
      "character": 7,
      "medium": 8,
      "standalone": 10,
      "modern": 9
    }
  },
  {
    "id": 337,
    "title": "Empire of the Summer Moon",
    "author": "S.C. Gwynne",
    "publicationYear": 2010,
    "isbn": "1416591060",
    "googleBooksId": "placeholder337",
    "image": "https://books.google.com/books/content?id=YBnqAgAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The epic saga of the Comanche tribe and their forty-year battle against white settlers, centered on Quanah Parker, the mixed-race warrior who became the last chief of the Comanches.",
    "rating": 4.25,
    "ratingsCount": 67715,
    "pageCount": 371,
    "awards": [
      "Pulitzer Prize Finalist General Nonfiction (2011)",
      "National Book Critics Circle Award Finalist General Nonfiction (2010)",
      "Goodreads Choice Award History and Biography (2010)"
    ],
    "categories": [
      "Nonfiction",
      "History",
      "American History"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 10,
      "character": 8,
      "dark": 8,
      "plot": 8,
      "atmosphere": 9,
      "medium": 7,
      "standalone": 10,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 338,
    "title": "A Short History of Nearly Everything",
    "author": "Bill Bryson",
    "publicationYear": 2003,
    "isbn": "076790818X",
    "googleBooksId": "placeholder338",
    "image": "https://books.google.com/books/content?id=YjAnfhsAQ8wC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Bryson takes readers on a journey from the Big Bang to civilization, explaining the how and why of everything from the smallest particle to the largest galaxy in his trademark accessible style.",
    "rating": 4.22,
    "ratingsCount": 423644,
    "pageCount": 544,
    "awards": [
      "EU Descartes Prize for Science Communication (2005)",
      "Baillie Gifford Prize for Non-Fiction (2004)"
    ],
    "categories": [
      "Nonfiction",
      "Science",
      "History"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 10,
      "optimistic": 8,
      "literary": 7,
      "medium": 7,
      "standalone": 10,
      "modern": 8,
      "history": 7,
      "character": 8,
      "plot": 5
    }
  },
  {
    "id": 339,
    "title": "The Splendid and the Vile",
    "author": "Erik Larson",
    "publicationYear": 2020,
    "isbn": "0385348711",
    "googleBooksId": "placeholder339",
    "image": "https://books.google.com/books/content?id=v9LMDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Larson brings to life the first year of Churchill's leadership during the Blitz, showing how Churchill taught the British people to be fearless while German bombs rained down on London.",
    "rating": 4.3,
    "ratingsCount": 137845,
    "pageCount": 546,
    "awards": [
      "Goodreads Choice Award Nominee History & Biography (2020)"
    ],
    "categories": [
      "Nonfiction",
      "History",
      "World War II"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 10,
      "character": 9,
      "atmosphere": 9,
      "dark": 7,
      "plot": 7,
      "literary": 8,
      "slow": 7,
      "standalone": 10,
      "modern": 10
    }
  },
  {
    "id": 340,
    "title": "The Color of Law",
    "author": "Richard Rothstein",
    "publicationYear": 2017,
    "isbn": "1631494538",
    "googleBooksId": "placeholder340",
    "image": "https://books.google.com/books/content?id=kYeQEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A groundbreaking history of how federal, state, and local governments systematically imposed residential segregation throughout the US, creating a legacy that persists today.",
    "rating": 4.44,
    "ratingsCount": 46176,
    "pageCount": 368,
    "awards": [
      "National Book Award Nonfiction (2017)",
      "California Book Award Nonfiction Gold (2017)",
      "Los Angeles Times Book Prize History (2017)"
    ],
    "categories": [
      "Nonfiction",
      "History",
      "Politics"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 9,
      "mind": 10,
      "dark": 7,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6,
      "accessible": 7
    }
  },
  {
    "id": 341,
    "title": "I'm Glad My Mom Died",
    "author": "Jennette McCurdy",
    "publicationYear": 2022,
    "isbn": "1982185821",
    "googleBooksId": "placeholder341",
    "image": "https://books.google.com/books/content?id=13mAEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A heartbreaking and hilarious memoir about growing up as a child actor and the complicated relationship with her overbearing mother. McCurdy recounts her struggles with eating disorders, addiction, and finding her own identity.",
    "rating": 4.43,
    "ratingsCount": 1479280,
    "pageCount": 304,
    "awards": [
      "ALA Alex Award (2023)",
      "Goodreads Choice Award Memoir & Autobiography (2022)"
    ],
    "categories": [
      "Memoir",
      "Biography"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 9,
      "emotional": 10,
      "dark": 8,
      "heart": 8,
      "character": 10,
      "literary": 7,
      "fast": 8,
      "standalone": 10,
      "modern": 10
    }
  },
  {
    "id": 342,
    "title": "Crying in H Mart",
    "author": "Michelle Zauner",
    "publicationYear": 2021,
    "isbn": "0525657746",
    "googleBooksId": "placeholder342",
    "image": "https://books.google.com/books/content?id=30UlEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A memoir about growing up Korean American, losing her mother, and forging her own identity through food and music. Zauner explores grief, family, and cultural belonging in this deeply moving account.",
    "rating": 4.23,
    "ratingsCount": 602339,
    "pageCount": 256,
    "awards": [
      "Goodreads Choice Award Memoir & Autobiography (2021)",
      "Barnes & Noble Book of the Year Award (2021)"
    ],
    "categories": [
      "Memoir",
      "Biography"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 9,
      "emotional": 10,
      "heart": 10,
      "character": 9,
      "literary": 8,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "plot": 5
    }
  },
  {
    "id": 343,
    "title": "Tuesdays with Morrie",
    "author": "Mitch Albom",
    "publicationYear": 1997,
    "isbn": "076790592X",
    "googleBooksId": "placeholder343",
    "image": "https://books.google.com/books/content?id=1nSgwQZXQOsC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A journalist reconnects with his dying college professor, visiting him every Tuesday for lessons about life, death, love, and meaning. A meditation on the most important things in life.",
    "rating": 4.21,
    "ratingsCount": 1206413,
    "pageCount": 210,
    "categories": [
      "Memoir",
      "Philosophy"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 9,
      "heart": 10,
      "emotional": 10,
      "optimistic": 8,
      "mind": 8,
      "character": 9,
      "fast": 8,
      "standalone": 10,
      "classic": 7
    }
  },
  {
    "id": 344,
    "title": "I Am Malala",
    "author": "Malala Yousafzai",
    "publicationYear": 2013,
    "isbn": "0316322407",
    "googleBooksId": "placeholder344",
    "image": "https://books.google.com/books/content?id=pGbpnQEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The remarkable tale of a girl who stood up for education and was shot by the Taliban. Malala shares her story of growing up in Pakistan and becoming the youngest Nobel Prize laureate.",
    "rating": 4.16,
    "ratingsCount": 624880,
    "pageCount": 327,
    "awards": [
      "Goodreads Choice Award Memoir (2013)"
    ],
    "categories": [
      "Memoir",
      "Biography"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 9,
      "optimistic": 9,
      "emotional": 8,
      "character": 9,
      "mind": 7,
      "dark": 6,
      "medium": 7,
      "standalone": 10,
      "modern": 10
    }
  },
  {
    "id": 345,
    "title": "Narrative of the Life of Frederick Douglass",
    "author": "Frederick Douglass",
    "publicationYear": 1845,
    "isbn": "0486284999",
    "googleBooksId": "placeholder345",
    "image": "https://books.google.com/books/content?id=uCK1DgAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The most famous of all slave narratives, Douglass recounts his journey from bondage to freedom, becoming one of the most influential voices against slavery in American history.",
    "rating": 4.13,
    "ratingsCount": 135277,
    "pageCount": 158,
    "categories": [
      "Memoir",
      "History",
      "Classic"
    ],
    "scores": {
      "memoir": 10,
      "history": 10,
      "nonfiction": 10,
      "literary": 9,
      "dark": 9,
      "emotional": 9,
      "character": 9,
      "fast": 8,
      "standalone": 10,
      "classic": 10
    }
  },
  {
    "id": 346,
    "title": "Just Mercy",
    "author": "Bryan Stevenson",
    "publicationYear": 2014,
    "isbn": "081298496X",
    "googleBooksId": "placeholder346",
    "image": "https://books.google.com/books/content?id=PnfaCwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A powerful true story of a young lawyer fighting for justice on death row. Stevenson founded the Equal Justice Initiative and has spent his career defending those who need it most.",
    "rating": 4.62,
    "ratingsCount": 262570,
    "pageCount": 336,
    "awards": [
      "Carnegie Medal Nonfiction (2015)"
    ],
    "categories": [
      "Memoir",
      "Nonfiction",
      "Law"
    ],
    "scores": {
      "memoir": 9,
      "nonfiction": 10,
      "emotional": 10,
      "dark": 8,
      "mind": 9,
      "character": 9,
      "heart": 9,
      "medium": 7,
      "standalone": 10,
      "modern": 10
    }
  },
  {
    "id": 347,
    "title": "A Promised Land",
    "author": "Barack Obama",
    "publicationYear": 2020,
    "isbn": "1524763160",
    "googleBooksId": "placeholder347",
    "image": "https://books.google.com/books/content?id=9mUKEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The first volume of Barack Obama's presidential memoirs, covering his early life, political rise, and first term. An intimate account of history in the making from the 44th President.",
    "rating": 4.31,
    "ratingsCount": 276798,
    "pageCount": 768,
    "awards": [
      "Goodreads Choice Award Memoir (2020)"
    ],
    "categories": [
      "Memoir",
      "Biography",
      "Politics"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "history": 8,
      "character": 8,
      "mind": 8,
      "slow": 8,
      "literary": 7,
      "standalone": 8,
      "modern": 10,
      "plot": 5,
      "emotional": 6
    }
  },
  {
    "id": 348,
    "title": "Greenlights",
    "author": "Matthew McConaughey",
    "publicationYear": 2020,
    "isbn": "0593139135",
    "googleBooksId": "placeholder348",
    "image": "https://books.google.com/books/content?id=E9gGEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "An unconventional memoir filled with raucous stories, outlaw wisdom, and lessons learned the hard way about living with greater satisfaction. Part autobiography, part philosophy.",
    "rating": 4.2,
    "ratingsCount": 461529,
    "pageCount": 289,
    "categories": [
      "Memoir",
      "Self-Help"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 8,
      "optimistic": 9,
      "mind": 7,
      "character": 8,
      "heart": 7,
      "fast": 8,
      "standalone": 10,
      "modern": 10,
      "plot": 5
    }
  },
  {
    "id": 349,
    "title": "The Year of Magical Thinking",
    "author": "Joan Didion",
    "publicationYear": 2005,
    "isbn": "1400078431",
    "googleBooksId": "placeholder349",
    "image": "https://books.google.com/books/content?id=MOJZ8ihldbAC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Didion's unflinching account of the year following her husband's sudden death and her daughter's devastating illness. A meditation on grief, memory, and the ways we attempt to make sense of loss.",
    "rating": 3.93,
    "ratingsCount": 302405,
    "pageCount": 227,
    "awards": [
      "National Book Award Nonfiction (2005)"
    ],
    "categories": [
      "Memoir",
      "Nonfiction"
    ],
    "scores": {
      "memoir": 10,
      "literary": 10,
      "emotional": 10,
      "dark": 8,
      "character": 9,
      "slow": 7,
      "mind": 8,
      "standalone": 10,
      "modern": 9,
      "plot": 5
    }
  },
  {
    "id": 350,
    "title": "Kitchen Confidential",
    "author": "Anthony Bourdain",
    "publicationYear": 2000,
    "isbn": "0060899220",
    "googleBooksId": "placeholder350",
    "image": "https://books.google.com/books/content?id=bxLbZ2kGddIC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Bourdain's irreverent look behind the scenes of the restaurant industry, sharing tales of drugs, sex, and rock and roll in professional kitchens. A wild ride through culinary culture.",
    "rating": 4.19,
    "ratingsCount": 379746,
    "pageCount": 312,
    "categories": [
      "Memoir",
      "Food"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 8,
      "dark": 6,
      "character": 9,
      "fast": 8,
      "literary": 7,
      "atmosphere": 7,
      "standalone": 10,
      "modern": 9,
      "plot": 5
    }
  },
  {
    "id": 351,
    "title": "Fourth Wing",
    "author": "Rebecca Yarros",
    "publicationYear": 2023,
    "series": {
      "name": "The Empyrean",
      "position": 1
    },
    "isbn": "1649374046",
    "googleBooksId": "placeholder351",
    "image": "https://books.google.com/books/content?id=6_CLEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Twenty-year-old Violet Sorrengail enters the elite war college to become a dragon rider, where the weak don't survive. A high-stakes fantasy with enemies-to-lovers romance and deadly dragons.",
    "rating": 4.57,
    "ratingsCount": 3562925,
    "pageCount": 517,
    "awards": [
      "British Book Award Pageturner (2024)",
      "ALA Alex Award (2024)",
      "Australian Book Industry Award International Book (2024)",
      "Goodreads Choice Award Romantasy (2023)",
      "Barnes & Noble Book of the Year Award (2023)"
    ],
    "categories": [
      "Fantasy",
      "Romance",
      "New Adult"
    ],
    "scores": {
      "fantasy": 10,
      "heart": 9,
      "plot": 9,
      "fast": 9,
      "atmosphere": 9,
      "character": 8,
      "emotional": 8,
      "dark": 6,
      "series": 10,
      "modern": 10
    }
  },
  {
    "id": 352,
    "title": "A Court of Mist and Fury",
    "author": "Sarah J. Maas",
    "publicationYear": 2016,
    "series": {
      "name": "A Court of Thorns and Roses",
      "position": 2
    },
    "isbn": "1635575583",
    "googleBooksId": "placeholder352",
    "image": "https://books.google.com/books/content?id=N_haEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Feyre returns from Under the Mountain changed, struggling with trauma while discovering new powers. As war looms, she must navigate political intrigue and an unexpected alliance.",
    "rating": 4.63,
    "ratingsCount": 3214697,
    "pageCount": 626,
    "categories": [
      "Fantasy",
      "Romance",
      "New Adult"
    ],
    "scores": {
      "fantasy": 10,
      "heart": 10,
      "emotional": 10,
      "character": 9,
      "plot": 8,
      "atmosphere": 9,
      "dark": 7,
      "series": 10,
      "modern": 10,
      "slow": 6
    }
  },
  {
    "id": 353,
    "title": "The Cruel Prince",
    "author": "Holly Black",
    "authorGender": "female",
    "publicationYear": 2018,
    "isbn": "0316310271",
    "googleBooksId": "2dV3swEACAAJ",
    "image": "https://books.google.com/books/content?id=-RGkDgAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Jude was seven when her parents were murdered and she was stolen away to live in the High Court of Faerie. Now she desperately wants to belong there, despite her mortality and the cruel prince who despises her.",
    "rating": 4.01,
    "ratingsCount": 1741120,
    "pageCount": 370,
    "awards": [
      "Locus Award Young Adult Book (2019)",
      "Goodreads Choice Award Young Adult Fantasy & Science Fiction (2018)",
      "Lodestar Award (2019)"
    ],
    "categories": [
      "Fantasy",
      "Young Adult",
      "Romance"
    ],
    "scores": {
      "fantasy": 10,
      "dark": 8,
      "plot": 9,
      "character": 8,
      "atmosphere": 9,
      "heart": 7,
      "fast": 8,
      "series": 10,
      "modern": 10,
      "accessible": 7
    }
  },
  {
    "id": 354,
    "title": "Ninth House",
    "author": "Leigh Bardugo",
    "publicationYear": 2019,
    "series": {
      "name": "Alex Stern",
      "position": 1
    },
    "isbn": "1250313074",
    "googleBooksId": "placeholder354",
    "image": "https://books.google.com/books/content?id=NebBvwEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Galaxy Alex Stern is given a second chance at Yale, but her scholarship comes with a price: monitoring the secret societies that practice real magic. Dark academia meets supernatural thriller.",
    "rating": 4,
    "ratingsCount": 402641,
    "pageCount": 461,
    "awards": [
      "Goodreads Choice Award Fantasy (2019)"
    ],
    "categories": [
      "Fantasy",
      "Mystery",
      "Dark Academia"
    ],
    "scores": {
      "fantasy": 8,
      "mystery": 8,
      "thriller": 7,
      "dark": 10,
      "atmosphere": 10,
      "plot": 8,
      "character": 8,
      "modern": 10,
      "series": 9,
      "literary": 7
    }
  },
  {
    "id": 355,
    "title": "Spinning Silver",
    "author": "Naomi Novik",
    "publicationYear": 2018,
    "isbn": "0399180990",
    "googleBooksId": "placeholder355",
    "image": "https://books.google.com/books/content?id=1FmTEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A retelling of Rumpelstiltskin set in a fantasy world inspired by Eastern European Jewish communities. Three women must use their wits to save their families from the magical Staryk king.",
    "rating": 4.18,
    "ratingsCount": 152286,
    "pageCount": 465,
    "awards": [
      "Locus Award Best Fantasy Novel (2019)"
    ],
    "categories": [
      "Fantasy",
      "Fairy Tale Retelling"
    ],
    "scores": {
      "fantasy": 10,
      "literary": 9,
      "atmosphere": 10,
      "character": 9,
      "plot": 8,
      "dark": 6,
      "slow": 7,
      "standalone": 10,
      "modern": 10,
      "accessible": 7
    }
  },
  {
    "id": 356,
    "title": "The Starless Sea",
    "author": "Erin Morgenstern",
    "publicationYear": 2019,
    "isbn": "038554121X",
    "googleBooksId": "placeholder356",
    "image": "https://books.google.com/books/content?id=UEGNEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A graduate student discovers a mysterious book that leads him to an underground library, a timeless love story, and a secret world of stories within stories.",
    "rating": 3.84,
    "ratingsCount": 234939,
    "pageCount": 498,
    "categories": [
      "Fantasy",
      "Literary Fiction"
    ],
    "scores": {
      "fantasy": 8,
      "literary": 10,
      "atmosphere": 10,
      "slow": 9,
      "character": 7,
      "plot": 6,
      "mind": 8,
      "standalone": 10,
      "modern": 10,
      "emotional": 6
    }
  },
  {
    "id": 357,
    "title": "An Ember in the Ashes",
    "author": "Sabaa Tahir",
    "publicationYear": 2015,
    "isbn": "1595148035",
    "googleBooksId": "placeholder357",
    "image": "https://books.google.com/books/content?id=4GkBDAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In a brutal empire inspired by ancient Rome, a slave girl fights for her family while a soldier fights for his freedom. Their destinies intertwine in this gripping epic fantasy.",
    "rating": 4.24,
    "ratingsCount": 348630,
    "pageCount": 480,
    "categories": [
      "Fantasy",
      "Young Adult"
    ],
    "scores": {
      "fantasy": 10,
      "plot": 10,
      "fast": 9,
      "dark": 9,
      "character": 8,
      "atmosphere": 9,
      "emotional": 8,
      "series": 10,
      "modern": 10,
      "accessible": 7
    }
  },
  {
    "id": 358,
    "title": "A Deadly Education",
    "author": "Naomi Novik",
    "publicationYear": 2020,
    "isbn": "0593128486",
    "googleBooksId": "placeholder358",
    "image": "https://books.google.com/books/content?id=jmiTEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "El Higgins attends the Scholomance, a school for magically gifted where failure means death. With no allies and a dark reputation, she must survive graduation.",
    "rating": 3.93,
    "ratingsCount": 222459,
    "pageCount": 320,
    "categories": [
      "Fantasy",
      "Dark Academia"
    ],
    "scores": {
      "fantasy": 10,
      "dark": 8,
      "character": 9,
      "plot": 8,
      "fast": 8,
      "atmosphere": 8,
      "modern": 10,
      "series": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 359,
    "title": "Legendborn",
    "author": "Tracy Deonn",
    "publicationYear": 2020,
    "isbn": "1534441603",
    "googleBooksId": "placeholder359",
    "image": "https://books.google.com/books/content?id=gU_4DwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "After her mother's death, Bree Matthews discovers a secret society of Arthurian magic at UNC Chapel Hill. An Afrofuturist retelling weaving together Southern Black experience and legend.",
    "rating": 4.3,
    "ratingsCount": 190325,
    "pageCount": 502,
    "awards": [
      "Coretta Scott King Award Honor (2021)"
    ],
    "categories": [
      "Fantasy",
      "Young Adult",
      "Arthurian"
    ],
    "scores": {
      "fantasy": 10,
      "mystery": 7,
      "character": 9,
      "plot": 9,
      "atmosphere": 8,
      "emotional": 8,
      "dark": 7,
      "series": 10,
      "modern": 10,
      "medium": 7
    }
  },
  {
    "id": 360,
    "title": "Sorcery of Thorns",
    "author": "Margaret Rogerson",
    "publicationYear": 2019,
    "isbn": "1481497618",
    "googleBooksId": "placeholder360",
    "image": "https://books.google.com/books/content?id=3EQVygEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Elisabeth has spent her life protecting magical grimoires. When she is implicated in the murder of the Director, she must ally with a sorcerer she was raised to despise.",
    "rating": 4.04,
    "ratingsCount": 160089,
    "pageCount": 456,
    "categories": [
      "Fantasy",
      "Young Adult",
      "Romance"
    ],
    "scores": {
      "fantasy": 10,
      "heart": 8,
      "plot": 8,
      "atmosphere": 9,
      "character": 8,
      "medium": 8,
      "standalone": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 361,
    "title": "The Long Way to a Small, Angry Planet",
    "author": "Becky Chambers",
    "publicationYear": 2014,
    "isbn": "0062444131",
    "googleBooksId": "placeholder361",
    "image": "https://books.google.com/books/content?id=7YxjjgEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A ragtag crew aboard a tunneling ship forms an unlikely family as they journey across the galaxy. A character-driven space opera about found family and belonging.",
    "rating": 4.17,
    "ratingsCount": 185927,
    "pageCount": 518,
    "awards": [
      "Arthur C. Clarke Award (2016)",
      "The Kitschies Golden Tentacle (2014)"
    ],
    "categories": [
      "Science Fiction",
      "Space Opera"
    ],
    "scores": {
      "scifi": 10,
      "character": 10,
      "heart": 10,
      "optimistic": 10,
      "atmosphere": 9,
      "slow": 7,
      "emotional": 8,
      "series": 8,
      "modern": 10,
      "plot": 5
    }
  },
  {
    "id": 362,
    "title": "All Systems Red",
    "author": "Martha Wells",
    "publicationYear": 2017,
    "isbn": "0765397536",
    "googleBooksId": "placeholder362",
    "image": "https://books.google.com/books/content?id=6NhzswEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A self-aware security android who calls itself Murderbot has hacked its own governor module and just wants to watch soap operas. But when a client mission goes wrong, it must choose between its freedom and saving humans.",
    "rating": 4.12,
    "ratingsCount": 372515,
    "pageCount": 144,
    "awards": [
      "Hugo Award Best Novella (2018)",
      "Nebula Award Best Novella (2017)",
      "Locus Award Best Novella (2018)"
    ],
    "categories": [
      "Science Fiction"
    ],
    "scores": {
      "scifi": 10,
      "character": 10,
      "plot": 8,
      "fast": 9,
      "optimistic": 7,
      "mind": 7,
      "series": 9,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 363,
    "title": "Leviathan Wakes",
    "author": "James S.A. Corey",
    "publicationYear": 2011,
    "isbn": "0316129089",
    "googleBooksId": "placeholder363",
    "image": "https://books.google.com/books/content?id=1VdJlwEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Humanity has colonized the solar system, and when a derelict ship is found with a deadly secret, a hardened detective and an idealistic officer must race to uncover the truth before war erupts.",
    "rating": 4.31,
    "ratingsCount": 320367,
    "pageCount": 561,
    "awards": [
      "Hugo Award Nominee Best Novel (2012)",
      "Locus Award Nominee Best SF Novel (2012)"
    ],
    "categories": [
      "Science Fiction",
      "Space Opera"
    ],
    "scores": {
      "scifi": 10,
      "thriller": 8,
      "plot": 10,
      "fast": 9,
      "dark": 7,
      "atmosphere": 9,
      "character": 8,
      "series": 10,
      "modern": 10,
      "accessible": 7
    }
  },
  {
    "id": 364,
    "title": "Red Mars",
    "author": "Kim Stanley Robinson",
    "publicationYear": 1992,
    "isbn": "0553560735",
    "googleBooksId": "placeholder364",
    "image": "https://books.google.com/books/content?id=R8OTfyIAmdEC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The first colonists land on Mars to begin the terraforming process. Over decades, they build a new society while struggling with political pressures from Earth and their own competing visions.",
    "rating": 3.86,
    "ratingsCount": 88831,
    "pageCount": 572,
    "awards": [
      "Nebula Award Best Novel (1993)",
      "Hugo Award Nominee Best Novel (1993)",
      "British Science Fiction Association Award (1992)"
    ],
    "categories": [
      "Science Fiction",
      "Hard SF"
    ],
    "scores": {
      "scifi": 10,
      "atmosphere": 10,
      "mind": 10,
      "slow": 9,
      "literary": 8,
      "character": 7,
      "plot": 6,
      "series": 10,
      "classic": 7,
      "emotional": 6
    }
  },
  {
    "id": 365,
    "title": "Seveneves",
    "author": "Neal Stephenson",
    "publicationYear": 2015,
    "isbn": "0062190377",
    "googleBooksId": "placeholder365",
    "image": "https://books.google.com/books/content?id=wlLZoAEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "When the moon explodes, humanity has two years to send a remnant into space before Earth's surface becomes uninhabitable. An epic tale of survival spanning five thousand years.",
    "rating": 4,
    "ratingsCount": 125254,
    "pageCount": 872,
    "awards": [
      "Goodreads Choice Award Nominee Science Fiction (2015)"
    ],
    "categories": [
      "Science Fiction",
      "Hard SF"
    ],
    "scores": {
      "scifi": 10,
      "mind": 10,
      "plot": 8,
      "atmosphere": 9,
      "slow": 8,
      "dark": 8,
      "standalone": 10,
      "modern": 10,
      "character": 5,
      "accessible": 7
    }
  },
  {
    "id": 366,
    "title": "A Memory Called Empire",
    "author": "Arkady Martine",
    "publicationYear": 2019,
    "isbn": "1250186439",
    "googleBooksId": "placeholder366",
    "image": "https://books.google.com/books/content?id=qnhnDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Ambassador Mahit Dzmare arrives at the Teixcalaanli Empire to find her predecessor dead and her space station potentially next. A political thriller wrapped in space opera.",
    "rating": 4.11,
    "ratingsCount": 72495,
    "pageCount": 448,
    "awards": [
      "Hugo Award Best Novel (2020)",
      "Nebula Award Best Novel (2019)",
      "Locus Award Best First Novel (2020)"
    ],
    "categories": [
      "Science Fiction",
      "Space Opera"
    ],
    "scores": {
      "scifi": 10,
      "literary": 9,
      "atmosphere": 9,
      "plot": 8,
      "character": 9,
      "mind": 9,
      "medium": 7,
      "series": 9,
      "modern": 10,
      "emotional": 6
    }
  },
  {
    "id": 367,
    "title": "Exhalation",
    "author": "Ted Chiang",
    "publicationYear": 2019,
    "isbn": "1101947888",
    "googleBooksId": "placeholder367",
    "image": "https://books.google.com/books/content?id=SGOPEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Nine stories exploring the nature of the universe, what it means to be human, and the transformative power of technology. From the author of Story of Your Life.",
    "rating": 4.27,
    "ratingsCount": 113356,
    "pageCount": 368,
    "awards": [
      "Bram Stoker Award Best Collection (2019)",
      "Hugo Award Best Novelette (2020)"
    ],
    "categories": [
      "Science Fiction",
      "Short Stories"
    ],
    "scores": {
      "scifi": 9,
      "literary": 10,
      "mind": 10,
      "slow": 7,
      "character": 8,
      "emotional": 8,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 368,
    "title": "We Are Legion (We Are Bob)",
    "author": "Dennis E. Taylor",
    "publicationYear": 2016,
    "isbn": "1680680587",
    "googleBooksId": "placeholder368",
    "image": "https://books.google.com/books/content?id=S0t2tAEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Bob dies and wakes up a century later as an AI probe. Now replicated across the galaxy, the Bobs explore the universe, save humanity, and try not to go crazy in the process.",
    "rating": 4.26,
    "ratingsCount": 125388,
    "pageCount": 383,
    "awards": [
      "Seiun Award Best Translated Novel (2019)"
    ],
    "categories": [
      "Science Fiction",
      "Humor"
    ],
    "scores": {
      "scifi": 10,
      "plot": 8,
      "fast": 8,
      "optimistic": 9,
      "mind": 8,
      "character": 7,
      "series": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 369,
    "title": "The Light Brigade",
    "author": "Kameron Hurley",
    "publicationYear": 2019,
    "isbn": "1481447963",
    "googleBooksId": "placeholder369",
    "image": "https://books.google.com/books/content?id=vUHtyQEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Soldiers are broken down into light and beamed to distant battlefields. But one soldier experiences the drops out of order, revealing a conspiracy that threatens everything she believes.",
    "rating": 3.88,
    "ratingsCount": 11393,
    "pageCount": 356,
    "awards": [
      "Hugo Award Nominee Best Novel (2020)",
      "Locus Award Nominee Best SF Novel (2020)"
    ],
    "categories": [
      "Science Fiction",
      "Military SF"
    ],
    "scores": {
      "scifi": 10,
      "thriller": 8,
      "dark": 9,
      "plot": 9,
      "fast": 8,
      "mind": 8,
      "character": 7,
      "standalone": 10,
      "modern": 10,
      "accessible": 7
    }
  },
  {
    "id": 370,
    "title": "Sea of Rust",
    "author": "C. Robert Cargill",
    "publicationYear": 2017,
    "series": {
      "name": "Sea of Rust",
      "position": 1
    },
    "isbn": "0062405853",
    "googleBooksId": "placeholder370",
    "image": "https://books.google.com/books/content?id=45OyDQAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "In a robot-only world after the extinction of humanity, a scavenger bot fights for survival against bigger bots that want to absorb her into their collective consciousness.",
    "rating": 4.05,
    "ratingsCount": 15201,
    "pageCount": 365,
    "awards": [
      "Arthur C. Clarke Award (2018)"
    ],
    "categories": [
      "Science Fiction",
      "Post-Apocalyptic"
    ],
    "scores": {
      "scifi": 10,
      "dark": 9,
      "plot": 8,
      "fast": 8,
      "character": 8,
      "atmosphere": 8,
      "mind": 7,
      "standalone": 10,
      "modern": 10,
      "accessible": 7
    }
  },
  {
    "id": 371,
    "title": "Funny Story",
    "author": "Emily Henry",
    "publicationYear": 2024,
    "isbn": "0593441281",
    "googleBooksId": "placeholder371",
    "image": "https://books.google.com/books/content?id=wcHMEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A heartbroken librarian moves in with her ex's friend in a northern Michigan vacation town. What starts as a fake relationship for social media becomes something neither expected.",
    "rating": 4.19,
    "ratingsCount": 1289341,
    "pageCount": 395,
    "awards": [
      "Goodreads Choice Award Romance (2024)"
    ],
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 10,
      "character": 9,
      "optimistic": 9,
      "plot": 8,
      "fast": 8,
      "emotional": 7,
      "standalone": 10,
      "modern": 10,
      "accessible": 7
    }
  },
  {
    "id": 372,
    "title": "Just for the Summer",
    "author": "Abby Jimenez",
    "publicationYear": 2024,
    "series": {
      "name": "Part of Your World",
      "position": 3
    },
    "isbn": "1538704439",
    "googleBooksId": "placeholder372",
    "image": "https://books.google.com/books/content?id=CvIX0AEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Two people cursed with the ability to help their exes find true love decide to date each other to break the curse. A funny, emotional rom-com about timing and fate.",
    "rating": 4.35,
    "ratingsCount": 1079324,
    "pageCount": 432,
    "awards": [
      "She Reads Best of Award Romance (2024)"
    ],
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 10,
      "character": 9,
      "optimistic": 9,
      "emotional": 9,
      "plot": 8,
      "fast": 8,
      "standalone": 10,
      "modern": 10,
      "accessible": 7
    }
  },
  {
    "id": 373,
    "title": "Happy Place",
    "author": "Emily Henry",
    "publicationYear": 2023,
    "isbn": "0593441273",
    "googleBooksId": "placeholder373",
    "image": "https://books.google.com/books/content?id=ci6TEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Harriet and Wyn have been broken up for six months but must pretend they're still together for one last week at their friends' annual vacation. A second-chance romance.",
    "rating": 3.94,
    "ratingsCount": 1431615,
    "pageCount": 400,
    "awards": [
      "Goodreads Choice Award Romance (2023)",
      "She Reads Best of Award Romance (2023)"
    ],
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 10,
      "emotional": 9,
      "character": 9,
      "optimistic": 7,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 375,
    "title": "Better Than the Movies",
    "author": "Lynn Painter",
    "publicationYear": 2021,
    "series": {
      "name": "Better Than the Movies",
      "position": 1
    },
    "isbn": "1534467637",
    "googleBooksId": "placeholder375",
    "image": "https://books.google.com/books/content?id=pep9EAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Liz Buxbaum has spent her life wanting a rom-com worthy romance. When her childhood crush returns, she teams up with her annoying neighbor to win him over.",
    "rating": 4.26,
    "ratingsCount": 778740,
    "pageCount": 356,
    "awards": [
      "Rhode Island Teen Book Award (2024)"
    ],
    "categories": [
      "Romance",
      "Young Adult"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 9,
      "optimistic": 10,
      "emotional": 8,
      "character": 8,
      "fast": 8,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 376,
    "title": "Book Lovers",
    "author": "Emily Henry",
    "publicationYear": 2022,
    "isbn": "0593334833",
    "googleBooksId": "placeholder376",
    "image": "https://books.google.com/books/content?id=Ju5nEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A cutthroat literary agent agrees to a month in a small town with her sister. She keeps running into a brooding book editor, forcing her to reconsider her carefully planned life.",
    "rating": 4.09,
    "ratingsCount": 1563445,
    "pageCount": 377,
    "awards": [
      "Goodreads Choice Award Romance (2022)",
      "Swoon Award Contemporary Romance (2022)"
    ],
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 10,
      "character": 9,
      "optimistic": 8,
      "literary": 6,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 377,
    "title": "Part of Your World",
    "author": "Abby Jimenez",
    "publicationYear": 2022,
    "isbn": "1538704374",
    "googleBooksId": "placeholder377",
    "image": "https://books.google.com/books/content?id=mfiSzgEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A successful ER doctor falls for a carpenter in a tiny Minnesota town. But their vastly different worlds threaten to tear them apart.",
    "rating": 4.25,
    "ratingsCount": 854858,
    "pageCount": 389,
    "awards": [
      "Goodreads Choice Award Nominee Romance (2022)"
    ],
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 10,
      "emotional": 9,
      "character": 9,
      "optimistic": 8,
      "medium": 7,
      "series": 8,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 378,
    "title": "Things We Never Got Over",
    "author": "Lucy Score",
    "publicationYear": 2022,
    "isbn": "194563183X",
    "googleBooksId": "placeholder378",
    "image": "https://books.google.com/books/content?id=LbG_zgEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Naomi comes to a small town to rescue her twin sister and ends up stranded with a baby and a grumpy barber who might be exactly what she needs.",
    "rating": 4.12,
    "ratingsCount": 1073937,
    "pageCount": 572,
    "awards": [
      "Goodreads Choice Award Nominee Romance (2022)"
    ],
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 10,
      "character": 9,
      "emotional": 8,
      "optimistic": 8,
      "medium": 7,
      "series": 9,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 380,
    "title": "You Deserve Each Other",
    "author": "Sarah Hogle",
    "publicationYear": 2020,
    "series": {
      "name": "You Deserve Each Other",
      "position": 1
    },
    "isbn": "0593085426",
    "googleBooksId": "placeholder380",
    "image": "https://books.google.com/books/content?id=EQfWDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "An engaged couple who have fallen out of love start sabotaging each other to make the other call off the wedding. But their schemes might just reignite their spark.",
    "rating": 3.86,
    "ratingsCount": 141379,
    "pageCount": 368,
    "awards": [
      "Goodreads Choice Award Nominee Romance (2020)"
    ],
    "categories": [
      "Romance",
      "Contemporary",
      "Comedy"
    ],
    "scores": {
      "heart": 9,
      "contemporary": 10,
      "optimistic": 8,
      "character": 8,
      "fast": 8,
      "emotional": 7,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 381,
    "title": "Maybe You Should Talk to Someone",
    "author": "Lori Gottlieb",
    "publicationYear": 2019,
    "isbn": "1328662055",
    "googleBooksId": "placeholder381",
    "image": "https://books.google.com/books/content?id=ATKQDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A therapist and her therapist. Gottlieb shares stories of her patients and her own journey to self-discovery, revealing the truths that connect us all.",
    "rating": 4.37,
    "ratingsCount": 406048,
    "pageCount": 415,
    "awards": [
      "Goodreads Choice Award Nominee for Nonfiction (2019)"
    ],
    "categories": [
      "Psychology",
      "Memoir",
      "Self-Help"
    ],
    "scores": {
      "nonfiction": 9,
      "memoir": 8,
      "mind": 10,
      "emotional": 9,
      "heart": 9,
      "character": 9,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "plot": 5
    }
  },
  {
    "id": 382,
    "title": "Why We Sleep",
    "author": "Matthew Walker",
    "publicationYear": 2017,
    "isbn": "1501144316",
    "googleBooksId": "placeholder382",
    "image": "https://books.google.com/books/content?id=ZlU3DwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A neuroscientist explores the purpose of sleep and the catastrophic consequences of sleep deprivation. A revolutionary examination of sleep that will transform how you view rest.",
    "rating": 4.37,
    "ratingsCount": 227526,
    "pageCount": 368,
    "awards": [
      "Los Angeles Times Book Prize Science & Technology (2017)"
    ],
    "categories": [
      "Science",
      "Psychology",
      "Health"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 10,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6,
      "emotional": 6,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 383,
    "title": "Deep Work",
    "author": "Cal Newport",
    "publicationYear": 2016,
    "isbn": "1455586692",
    "googleBooksId": "placeholder383",
    "image": "https://books.google.com/books/content?id=foeNrgEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Rules for focused success in a distracted world. Newport argues that the ability to perform deep work is becoming rare and valuable in our economy.",
    "rating": 4.16,
    "ratingsCount": 189965,
    "pageCount": 296,
    "awards": [
      "Goodreads Choice Award Nominee Nonfiction (2016)"
    ],
    "categories": [
      "Productivity",
      "Self-Help",
      "Business"
    ],
    "scores": {
      "nonfiction": 10,
      "selfhelp": 9,
      "mind": 10,
      "optimistic": 7,
      "fast": 7,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6,
      "accessible": 7
    }
  },
  {
    "id": 384,
    "title": "Four Thousand Weeks",
    "author": "Oliver Burkeman",
    "publicationYear": 2021,
    "isbn": "0374159122",
    "googleBooksId": "placeholder384",
    "image": "https://books.google.com/books/content?id=5my-zQEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Time management for mortals. Burkeman argues that the average human life is absurdly short and offers a radical approach to living with our limitations.",
    "rating": 4.17,
    "ratingsCount": 127978,
    "pageCount": 245,
    "categories": [
      "Philosophy",
      "Self-Help",
      "Productivity"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 10,
      "selfhelp": 8,
      "literary": 7,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "character": 8,
      "plot": 5,
      "emotional": 6
    }
  },
  {
    "id": 385,
    "title": "Emotional Intelligence",
    "author": "Daniel Goleman",
    "publicationYear": 1995,
    "isbn": "055338371X",
    "googleBooksId": "placeholder385",
    "image": "https://books.google.com/books/content?id=t8GGDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The groundbreaking book that redefined what it means to be smart. Goleman argues that emotional intelligence can matter more than IQ for success.",
    "rating": 4.06,
    "ratingsCount": 136092,
    "pageCount": 352,
    "categories": [
      "Psychology",
      "Self-Help"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 10,
      "selfhelp": 9,
      "medium": 7,
      "standalone": 10,
      "classic": 7,
      "character": 7,
      "plot": 6,
      "emotional": 6,
      "accessible": 7
    }
  },
  {
    "id": 386,
    "title": "The Mountain Is You",
    "author": "Brianna Wiest",
    "publicationYear": 2020,
    "isbn": "1949759229",
    "googleBooksId": "placeholder386",
    "image": "https://books.google.com/books/content?id=xCgA0AEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Transforming self-sabotage into self-mastery. Wiest explores why we get in our own way and how to turn our greatest obstacles into growth.",
    "rating": 4.04,
    "ratingsCount": 119916,
    "pageCount": 250,
    "categories": [
      "Self-Help",
      "Psychology"
    ],
    "scores": {
      "selfhelp": 10,
      "nonfiction": 9,
      "mind": 9,
      "optimistic": 8,
      "emotional": 7,
      "fast": 8,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6
    }
  },
  {
    "id": 387,
    "title": "Outliers",
    "author": "Malcolm Gladwell",
    "publicationYear": 2008,
    "isbn": "0316017930",
    "googleBooksId": "placeholder387",
    "image": "https://books.google.com/books/content?id=ialrgIT41OAC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Gladwell examines what makes high-achievers different, challenging the notion of the self-made man. Success is not just about individual talent and hard work.",
    "rating": 4.19,
    "ratingsCount": 868983,
    "pageCount": 309,
    "categories": [
      "Psychology",
      "Sociology",
      "Nonfiction"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 10,
      "optimistic": 7,
      "fast": 8,
      "standalone": 10,
      "modern": 9,
      "character": 7,
      "plot": 6,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 388,
    "title": "Essentialism",
    "author": "Greg McKeown",
    "publicationYear": 2014,
    "isbn": "0804137382",
    "googleBooksId": "placeholder388",
    "image": "https://books.google.com/books/content?id=CleNDQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The disciplined pursuit of less. McKeown shows how to cut out the trivial many to focus on the vital few and get the right things done.",
    "rating": 4.06,
    "ratingsCount": 131675,
    "pageCount": 260,
    "awards": [
      "Goodreads Choice Award Nominee Business (2014)"
    ],
    "categories": [
      "Self-Help",
      "Business",
      "Productivity"
    ],
    "scores": {
      "selfhelp": 10,
      "nonfiction": 9,
      "mind": 9,
      "optimistic": 8,
      "fast": 8,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6,
      "accessible": 7
    }
  },
  {
    "id": 389,
    "title": "The Housemaid",
    "author": "Freida McFadden",
    "publicationYear": 2022,
    "series": {
      "name": "The Housemaid",
      "position": 1
    },
    "isbn": "1538742578",
    "googleBooksId": "placeholder389",
    "image": "https://books.google.com/books/content?id=SUft0AEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Millie takes a job as a housemaid for a wealthy family. But as she gets closer to the family's dark secrets, she realizes the job is more dangerous than she imagined.",
    "rating": 4.27,
    "ratingsCount": 3437293,
    "pageCount": 329,
    "awards": [
      "ITW Thriller Award Best Paperback Original (2023)",
      "Goodreads Choice Award Nominee Mystery & Thriller (2022)"
    ],
    "categories": [
      "Thriller",
      "Mystery"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 9,
      "plot": 10,
      "fast": 10,
      "dark": 8,
      "character": 7,
      "standalone": 8,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 390,
    "title": "A Good Girl's Guide to Murder",
    "author": "Holly Jackson",
    "publicationYear": 2019,
    "isbn": "1984896393",
    "googleBooksId": "placeholder390",
    "image": "https://books.google.com/books/content?id=wrUlEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "For her senior capstone project, Pip investigates a closed murder case from five years ago. As she digs deeper, she uncovers secrets that someone will kill to keep buried.",
    "rating": 4.28,
    "ratingsCount": 1783271,
    "pageCount": 433,
    "awards": [
      "Goodreads Choice Award Young Adult Fiction (2020)"
    ],
    "categories": [
      "Mystery",
      "Thriller",
      "Young Adult"
    ],
    "scores": {
      "mystery": 10,
      "thriller": 9,
      "plot": 10,
      "fast": 9,
      "character": 8,
      "dark": 7,
      "series": 9,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 392,
    "title": "The Last Thing He Told Me",
    "author": "Laura Dave",
    "publicationYear": 2021,
    "series": {
      "name": "Hannah Hall",
      "position": 1
    },
    "isbn": "1501171348",
    "googleBooksId": "placeholder392",
    "image": "https://books.google.com/books/content?id=JqcsEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Before her husband disappears, he leaves a note: Protect her. Hannah must discover the truth about the man she married and the stepdaughter he left behind.",
    "rating": 3.83,
    "ratingsCount": 1150262,
    "pageCount": 307,
    "awards": [
      "Goodreads Choice Award Mystery & Thriller (2021)"
    ],
    "categories": [
      "Mystery",
      "Thriller"
    ],
    "scores": {
      "mystery": 9,
      "thriller": 8,
      "plot": 9,
      "fast": 9,
      "emotional": 7,
      "character": 8,
      "standalone": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 393,
    "title": "Rock Paper Scissors",
    "author": "Alice Feeney",
    "publicationYear": 2021,
    "isbn": "1250266106",
    "googleBooksId": "placeholder393",
    "image": "https://books.google.com/books/content?id=m90czgEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A couple win a weekend away to Scotland. Cut off from the outside world, they face their darkest secrets and the cracks in their marriage.",
    "rating": 3.88,
    "ratingsCount": 715430,
    "pageCount": 294,
    "awards": [
      "ITW Thriller Award Hardcover Novel (2022)",
      "Goodreads Choice Award Nominee Mystery & Thriller (2021)"
    ],
    "categories": [
      "Thriller",
      "Mystery"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 8,
      "plot": 9,
      "fast": 9,
      "dark": 9,
      "character": 7,
      "standalone": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 394,
    "title": "Before We Were Yours",
    "author": "Lisa Wingate",
    "publicationYear": 2017,
    "isbn": "0425284689",
    "googleBooksId": "placeholder394",
    "image": "https://books.google.com/books/content?id=ecrPDgAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Based on the real Tennessee Children's Home Society scandal, this novel follows children torn from their family and a modern-day woman uncovering family secrets.",
    "rating": 4.4,
    "ratingsCount": 729058,
    "pageCount": 342,
    "awards": [
      "Goodreads Choice Award Historical Fiction (2017)"
    ],
    "categories": [
      "Historical Fiction"
    ],
    "scores": {
      "historical": 10,
      "emotional": 10,
      "heart": 10,
      "character": 9,
      "dark": 8,
      "plot": 8,
      "medium": 7,
      "standalone": 10,
      "modern": 9,
      "accessible": 7
    }
  },
  {
    "id": 395,
    "title": "Daisy Jones and The Six",
    "author": "Taylor Jenkins Reid",
    "publicationYear": 2019,
    "isbn": "1524798622",
    "googleBooksId": "placeholder395",
    "image": "https://books.google.com/books/content?id=TuqPEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "An iconic 1970s rock band breaks up at the height of their fame. Told in oral history format, this is the story of their rise and fall and the secrets that tore them apart.",
    "rating": 4.2,
    "ratingsCount": 1859013,
    "pageCount": 368,
    "awards": [
      "Goodreads Choice Award Historical Fiction (2019)",
      "Book of the Month Book of the Year (2019)"
    ],
    "categories": [
      "Historical Fiction",
      "Music"
    ],
    "scores": {
      "historical": 8,
      "character": 10,
      "emotional": 9,
      "atmosphere": 9,
      "plot": 8,
      "fast": 8,
      "heart": 8,
      "standalone": 10,
      "modern": 10,
      "accessible": 7
    }
  },
  {
    "id": 396,
    "title": "The Paris Wife",
    "author": "Paula McLain",
    "publicationYear": 2011,
    "isbn": "0345521315",
    "googleBooksId": "placeholder396",
    "image": "https://books.google.com/books/content?id=vBONEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Hadley Richardson is swept up by Ernest Hemingway in 1920s Paris. Their marriage becomes a casualty of his ambition and the glamorous expat scene.",
    "rating": 3.82,
    "ratingsCount": 305311,
    "pageCount": 336,
    "awards": [
      "Ohioana Book Award Fiction (2012)",
      "Goodreads Choice Award Historical Fiction (2011)",
      "Society of Midland Authors Award Adult Fiction (2012)"
    ],
    "categories": [
      "Historical Fiction",
      "Biography"
    ],
    "scores": {
      "historical": 10,
      "character": 9,
      "literary": 8,
      "emotional": 9,
      "atmosphere": 9,
      "heart": 8,
      "medium": 7,
      "standalone": 10,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 397,
    "title": "The Book Woman of Troublesome Creek",
    "author": "Kim Michele Richardson",
    "publicationYear": 2019,
    "isbn": "1492671525",
    "googleBooksId": "placeholder397",
    "image": "https://books.google.com/books/content?id=FEZduQEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A young packhorse librarian brings books to remote Appalachian communities during the Great Depression, fighting for her place in a world that fears her blue-tinged skin.",
    "rating": 4.22,
    "ratingsCount": 264538,
    "pageCount": 309,
    "awards": [
      "Goodreads Choice Award Nominee Historical Fiction (2019)"
    ],
    "categories": [
      "Historical Fiction"
    ],
    "scores": {
      "historical": 10,
      "character": 10,
      "heart": 9,
      "emotional": 8,
      "atmosphere": 9,
      "literary": 7,
      "medium": 7,
      "series": 8,
      "modern": 9,
      "plot": 5
    }
  },
  {
    "id": 398,
    "title": "Where the Forest Meets the Stars",
    "author": "Glendy Vanderah",
    "publicationYear": 2019,
    "isbn": "1503904911",
    "googleBooksId": "placeholder398",
    "image": "https://books.google.com/books/content?id=UqJduwEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A biologist recovering from tragedy finds a mysterious child who claims to be from the stars. Together with a reclusive neighbor, they form an unlikely family.",
    "rating": 4.13,
    "ratingsCount": 234945,
    "pageCount": 332,
    "awards": [
      "Goodreads Choice Award Nominee Fiction (2019)"
    ],
    "categories": [
      "Contemporary Fiction",
      "Mystery"
    ],
    "scores": {
      "contemporary": 9,
      "emotional": 10,
      "heart": 10,
      "character": 9,
      "mystery": 6,
      "atmosphere": 8,
      "optimistic": 8,
      "standalone": 10,
      "modern": 10,
      "medium": 7,
      "plot": 5
    }
  },
  {
    "id": 399,
    "title": "East of Eden",
    "author": "John Steinbeck",
    "publicationYear": 1952,
    "isbn": "0142004235",
    "googleBooksId": "placeholder399",
    "image": "https://books.google.com/books/content?id=PI1PEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "An epic family saga spanning three generations in California's Salinas Valley. Steinbeck's masterpiece explores themes of good and evil, free will, and the nature of human existence.",
    "rating": 4.44,
    "ratingsCount": 643054,
    "pageCount": 601,
    "awards": [
      "National Book Award Finalist Fiction (1953)"
    ],
    "categories": [
      "Classic",
      "Literary Fiction"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 10,
      "emotional": 9,
      "atmosphere": 9,
      "dark": 7,
      "slow": 8,
      "standalone": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 400,
    "title": "The Brothers Karamazov",
    "author": "Fyodor Dostoevsky",
    "publicationYear": 1880,
    "isbn": "0374528373",
    "googleBooksId": "placeholder400",
    "image": "https://books.google.com/books/content?id=z1k_AxXUvmEC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A philosophical novel exploring faith, doubt, and morality through the story of three brothers and their father's murder. Considered one of the greatest novels ever written.",
    "rating": 4.39,
    "ratingsCount": 388275,
    "pageCount": 796,
    "categories": [
      "Classic",
      "Literary Fiction",
      "Philosophy"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 10,
      "mind": 10,
      "dark": 8,
      "slow": 10,
      "emotional": 9,
      "standalone": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 401,
    "title": "One Hundred Years of Solitude",
    "author": "Gabriel Garcia Marquez",
    "publicationYear": 1967,
    "isbn": "0060883286",
    "googleBooksId": "placeholder401",
    "image": "https://books.google.com/books/content?id=Rtk8PgAACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The multi-generational story of the Buendia family in the fictional town of Macondo. A landmark of magical realism that chronicles a century of Latin American history.",
    "rating": 4.12,
    "ratingsCount": 1108269,
    "pageCount": 417,
    "awards": [
      "Premio Internacional de Novela Rómulo Gallegos (1972)",
      "Prix du Meilleur Livre Étranger Roman (1969)"
    ],
    "categories": [
      "Classic",
      "Literary Fiction",
      "Magical Realism"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "fantasy": 6,
      "atmosphere": 10,
      "character": 9,
      "slow": 9,
      "emotional": 8,
      "standalone": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 402,
    "title": "Tomorrow, and Tomorrow, and Tomorrow",
    "author": "Gabrielle Zevin",
    "publicationYear": 2022,
    "isbn": "0593321200",
    "googleBooksId": "placeholder402",
    "image": "https://books.google.com/books/content?id=jzSOEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Two friends unite over their love of video games to create an artistic and economic empire. A story of creativity, love, and identity spanning decades.",
    "rating": 4.12,
    "ratingsCount": 1363427,
    "pageCount": 399,
    "awards": [
      "British Book Award Pageturner (2024)",
      "ALA Alex Award (2023)",
      "Goodreads Choice Award Fiction (2022)",
      "Book of the Month Book of the Year Award (2022)",
      "Barnes & Noble Book of the Year Award (2022)"
    ],
    "categories": [
      "Literary Fiction",
      "Contemporary"
    ],
    "scores": {
      "contemporary": 10,
      "literary": 9,
      "character": 10,
      "emotional": 10,
      "heart": 8,
      "plot": 8,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "accessible": 7
    }
  },
  {
    "id": 403,
    "title": "A Little Life",
    "author": "Hanya Yanagihara",
    "publicationYear": 2015,
    "isbn": "0804172706",
    "googleBooksId": "placeholder403",
    "image": "https://books.google.com/books/content?id=sL_ZCwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Four college friends navigate life in New York City over three decades. At its center is Jude, whose past slowly reveals itself as his friendships deepen.",
    "rating": 4.28,
    "ratingsCount": 933699,
    "pageCount": 720,
    "awards": [
      "Booker Prize Shortlist (2015)",
      "Dayton Literary Peace Prize Fiction (2016)",
      "Women's Prize for Fiction Shortlist (2016)",
      "National Book Award Finalist Fiction (2015)",
      "Kirkus Prize Fiction (2015)",
      "Goodreads Choice Award Fiction (2015)",
      "Waterstones Book of the Year (2015)"
    ],
    "categories": [
      "Literary Fiction",
      "Contemporary"
    ],
    "scores": {
      "literary": 10,
      "contemporary": 10,
      "character": 10,
      "emotional": 10,
      "dark": 10,
      "slow": 8,
      "heart": 9,
      "standalone": 10,
      "modern": 10,
      "plot": 5
    }
  },
  {
    "id": 404,
    "title": "The Radium Girls",
    "author": "Kate Moore",
    "publicationYear": 2016,
    "isbn": "1492650951",
    "googleBooksId": "placeholder404",
    "image": "https://books.google.com/books/content?id=XUXwtAEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The incredible true story of the women who fought America's Undark danger. In the 1920s, young women painted watch dials with luminous radium paint, licking their brushes to keep them sharp. When they began dying, they fought back.",
    "rating": 4.16,
    "ratingsCount": 186958,
    "pageCount": 479,
    "awards": [
      "Goodreads Choice Award History & Biography (2017)",
      "Lincoln Award (2019)"
    ],
    "categories": [
      "Nonfiction",
      "History"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 10,
      "dark": 9,
      "emotional": 9,
      "character": 8,
      "plot": 8,
      "medium": 7,
      "standalone": 10,
      "modern": 9,
      "accessible": 7
    }
  },
  {
    "id": 405,
    "title": "Bury My Heart at Wounded Knee",
    "author": "Dee Brown",
    "publicationYear": 1970,
    "isbn": "0805086846",
    "googleBooksId": "placeholder405",
    "image": "https://books.google.com/books/content?id=02nyRlY4rMUC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A revelatory account of the systematic destruction of American Indians during the second half of the nineteenth century. Told from the Native American perspective.",
    "rating": 4.26,
    "ratingsCount": 102678,
    "pageCount": 509,
    "categories": [
      "Nonfiction",
      "History",
      "American History"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 10,
      "dark": 10,
      "emotional": 10,
      "literary": 8,
      "slow": 7,
      "standalone": 10,
      "classic": 9,
      "character": 8,
      "plot": 5
    }
  },
  {
    "id": 406,
    "title": "The Sixth Extinction",
    "author": "Elizabeth Kolbert",
    "publicationYear": 2014,
    "isbn": "1250062187",
    "googleBooksId": "placeholder406",
    "image": "https://books.google.com/books/content?id=vi-loAEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "An exploration of how human activity is causing the sixth mass extinction. Kolbert travels the world to show the devastation we are causing to our planet's biodiversity.",
    "rating": 4.15,
    "ratingsCount": 79554,
    "pageCount": 336,
    "awards": [
      "Pulitzer Prize General Nonfiction (2015)",
      "Goodreads Choice Award Nonfiction (2014)"
    ],
    "categories": [
      "Nonfiction",
      "Science",
      "History"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 10,
      "dark": 8,
      "history": 7,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6,
      "accessible": 7
    }
  },
  {
    "id": 407,
    "title": "Band of Brothers",
    "author": "Stephen E. Ambrose",
    "publicationYear": 1992,
    "isbn": "1501179403",
    "googleBooksId": "placeholder407",
    "image": "https://books.google.com/books/content?id=NiszDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The story of Easy Company, 506th Parachute Infantry Regiment, from D-Day to the capture of Hitler's Eagle's Nest. The soldiers themselves tell their extraordinary story.",
    "rating": 4.44,
    "ratingsCount": 139295,
    "pageCount": 432,
    "categories": [
      "Nonfiction",
      "History",
      "World War II"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 10,
      "character": 9,
      "emotional": 9,
      "plot": 8,
      "dark": 7,
      "fast": 7,
      "standalone": 10,
      "classic": 7,
      "accessible": 7
    }
  },
  {
    "id": 408,
    "title": "The Emperor of All Maladies",
    "author": "Siddhartha Mukherjee",
    "publicationYear": 2010,
    "isbn": "1439170916",
    "googleBooksId": "placeholder408",
    "image": "https://books.google.com/books/content?id=hgx0sJvphNkC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A biography of cancer from its first documented appearances thousands of years ago to the epic battles to cure, control, and conquer it. Pulitzer Prize winner.",
    "rating": 4.34,
    "ratingsCount": 114685,
    "pageCount": 472,
    "awards": [
      "Pulitzer Prize General Nonfiction (2011)",
      "Guardian First Book Award (2011)"
    ],
    "categories": [
      "Nonfiction",
      "Science",
      "History"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 8,
      "mind": 10,
      "dark": 8,
      "literary": 8,
      "slow": 7,
      "standalone": 10,
      "modern": 9,
      "character": 8,
      "plot": 5
    }
  },
  {
    "id": 409,
    "title": "Alexander Hamilton",
    "author": "Ron Chernow",
    "publicationYear": 2004,
    "isbn": "0143034758",
    "googleBooksId": "placeholder409",
    "image": "https://books.google.com/books/content?id=4PeiDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The biography that inspired the hit musical. Chernow presents an unforgettable portrait of a founding father who galvanized and scandalized the young republic.",
    "rating": 4.22,
    "ratingsCount": 200756,
    "pageCount": 818,
    "awards": [
      "George Washington Book Prize (2005)",
      "National Book Critics Circle Award Biography (2004)"
    ],
    "categories": [
      "Biography",
      "History",
      "Nonfiction"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 10,
      "character": 10,
      "literary": 8,
      "slow": 8,
      "mind": 7,
      "standalone": 10,
      "modern": 8,
      "plot": 5,
      "emotional": 6
    }
  },
  {
    "id": 410,
    "title": "Stamped from the Beginning",
    "author": "Ibram X. Kendi",
    "publicationYear": 2016,
    "isbn": "1568585985",
    "googleBooksId": "placeholder410",
    "image": "https://books.google.com/books/content?id=APjXnAAACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The definitive history of racist ideas in America, from their origins in 15th century Europe to their present-day influence. National Book Award winner.",
    "rating": 4.53,
    "ratingsCount": 38491,
    "pageCount": 592,
    "awards": [
      "National Book Award Nonfiction (2016)",
      "NAACP Image Award Nonfiction (2017)"
    ],
    "categories": [
      "Nonfiction",
      "History"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 10,
      "mind": 10,
      "dark": 8,
      "literary": 8,
      "slow": 8,
      "standalone": 10,
      "modern": 10,
      "character": 8,
      "plot": 5
    }
  },
  {
    "id": 411,
    "title": "In the Garden of Beasts",
    "author": "Erik Larson",
    "publicationYear": 2011,
    "isbn": "030740885X",
    "googleBooksId": "placeholder411",
    "image": "https://books.google.com/books/content?id=mzxw7lio-RwC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The American ambassador to Nazi Germany and his daughter witness Hitler's rise. A portrait of Berlin in the early years of Hitler's rise to power.",
    "rating": 3.9,
    "ratingsCount": 220571,
    "pageCount": 448,
    "awards": [
      "Goodreads Choice Award History & Biography (2011)"
    ],
    "categories": [
      "Nonfiction",
      "History",
      "World War II"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 10,
      "dark": 9,
      "atmosphere": 9,
      "character": 8,
      "slow": 7,
      "standalone": 10,
      "modern": 9,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 413,
    "title": "Spare",
    "author": "Prince Harry",
    "publicationYear": 2023,
    "isbn": "0593593804",
    "googleBooksId": "placeholder413",
    "image": "https://books.google.com/books/content?id=wvqXEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Prince Harry's memoir recounting his life as a royal, from his mother's death to his departure from the royal family. A raw, unflinching account.",
    "rating": 3.83,
    "ratingsCount": 430666,
    "pageCount": 410,
    "awards": [
      "Goodreads Choice Award Memoir & Autobiography (2023)",
      "British Book Award Nonfiction (2024)"
    ],
    "categories": [
      "Memoir",
      "Biography"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 9,
      "emotional": 8,
      "character": 8,
      "dark": 6,
      "fast": 8,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 414,
    "title": "The Light We Carry",
    "author": "Michelle Obama",
    "publicationYear": 2022,
    "isbn": "0593237463",
    "googleBooksId": "placeholder414",
    "image": "https://books.google.com/books/content?id=tyyOEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Michelle Obama shares practical wisdom and strategies for staying hopeful and balanced in uncertain times. A follow-up to Becoming.",
    "rating": 4.27,
    "ratingsCount": 98399,
    "pageCount": 319,
    "awards": [
      "Grammy Award Best Audio Book (2024)",
      "NAACP Image Award Biography (2023)"
    ],
    "categories": [
      "Memoir",
      "Self-Help"
    ],
    "scores": {
      "memoir": 8,
      "selfhelp": 8,
      "nonfiction": 9,
      "optimistic": 9,
      "mind": 8,
      "heart": 8,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "character": 8,
      "plot": 5
    }
  },
  {
    "id": 415,
    "title": "The Wager",
    "author": "David Grann",
    "publicationYear": 2023,
    "isbn": "0385534264",
    "googleBooksId": "placeholder415",
    "image": "https://books.google.com/books/content?id=GEGNEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A shipwreck, mutiny, and murder in the 18th century. The true story of a British ship that went down in a storm, and the desperate men who survived.",
    "rating": 4.17,
    "ratingsCount": 211160,
    "pageCount": 352,
    "awards": [
      "Goodreads Choice Award History & Biography (2023)",
      "Barnes & Noble Book of the Year (2023)"
    ],
    "categories": [
      "Nonfiction",
      "History"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 10,
      "thriller": 7,
      "dark": 8,
      "plot": 9,
      "atmosphere": 9,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "character": 5
    }
  },
  {
    "id": 416,
    "title": "All About Love",
    "author": "bell hooks",
    "publicationYear": 1999,
    "series": {
      "name": "Love Trilogy",
      "position": 1
    },
    "isbn": "0060959479",
    "googleBooksId": "placeholder416",
    "image": "https://books.google.com/books/content?id=MYim_gaQC2gC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A visionary exploration of love in all its forms - romantic, familial, and platonic. Hooks challenges our assumptions about what love really means.",
    "rating": 4.01,
    "ratingsCount": 137374,
    "pageCount": 240,
    "categories": [
      "Nonfiction",
      "Philosophy",
      "Self-Help"
    ],
    "scores": {
      "nonfiction": 9,
      "selfhelp": 8,
      "mind": 9,
      "heart": 10,
      "emotional": 8,
      "literary": 7,
      "medium": 7,
      "standalone": 10,
      "modern": 9,
      "character": 8,
      "plot": 5
    }
  },
  {
    "id": 417,
    "title": "The 48 Laws of Power",
    "author": "Robert Greene",
    "publicationYear": 1999,
    "isbn": "0140280197",
    "googleBooksId": "placeholder417",
    "image": "https://books.google.com/books/content?id=tmmOvqV4MboC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Drawing on 3,000 years of history, Greene distills the essence of power into 48 laws. Amoral, cunning, and instructive.",
    "rating": 4.09,
    "ratingsCount": 227350,
    "pageCount": 452,
    "categories": [
      "Nonfiction",
      "Psychology",
      "Self-Help"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 10,
      "dark": 7,
      "slow": 7,
      "standalone": 10,
      "classic": 7,
      "character": 7,
      "plot": 6,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 418,
    "title": "Hold Me Tight",
    "author": "Sue Johnson",
    "publicationYear": 2008,
    "isbn": "031611300X",
    "googleBooksId": "placeholder418",
    "image": "https://books.google.com/books/content?id=6UspngEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A revolutionary approach to couples therapy based on attachment theory. Seven conversations that can transform your relationship.",
    "rating": 4.12,
    "ratingsCount": 22554,
    "pageCount": 300,
    "categories": [
      "Psychology",
      "Relationships",
      "Self-Help"
    ],
    "scores": {
      "nonfiction": 10,
      "selfhelp": 10,
      "mind": 9,
      "heart": 9,
      "emotional": 8,
      "medium": 7,
      "standalone": 10,
      "modern": 9,
      "character": 7,
      "plot": 6
    }
  },
  {
    "id": 419,
    "title": "The Anxious Generation",
    "author": "Jonathan Haidt",
    "publicationYear": 2024,
    "isbn": "0593655036",
    "googleBooksId": "placeholder419",
    "image": "https://books.google.com/books/content?id=n9fDEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "An investigation into the collapse of youth mental health and how smartphones and social media are rewiring childhood.",
    "rating": 4.31,
    "ratingsCount": 182087,
    "pageCount": 400,
    "awards": [
      "Goodreads Choice Award Nonfiction (2024)"
    ],
    "categories": [
      "Nonfiction",
      "Psychology"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 10,
      "dark": 7,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 421,
    "title": "Divine Rivals",
    "author": "Rebecca Ross",
    "publicationYear": 2023,
    "isbn": "1250857430",
    "googleBooksId": "placeholder421",
    "image": "https://books.google.com/books/content?id=c0d9EAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Two young rival journalists find themselves writing letters to each other through a magical typewriter while war looms. A romantic fantasy.",
    "rating": 4.15,
    "ratingsCount": 741478,
    "pageCount": 368,
    "awards": [
      "Goodreads Choice Award Young Adult Fantasy (2023)",
      "Locus Award Young Adult (2024)"
    ],
    "categories": [
      "Fantasy",
      "Romance",
      "Young Adult"
    ],
    "scores": {
      "fantasy": 9,
      "heart": 10,
      "emotional": 9,
      "plot": 8,
      "atmosphere": 9,
      "character": 8,
      "series": 9,
      "modern": 10,
      "medium": 7,
      "accessible": 7
    }
  },
  {
    "id": 422,
    "title": "House of Flame and Shadow",
    "author": "Sarah J. Maas",
    "publicationYear": 2024,
    "isbn": "1635574102",
    "googleBooksId": "placeholder422",
    "image": "https://books.google.com/books/content?id=s3H2EAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Bryce Quinlan finds herself in a strange new world. The third book in the Crescent City series continues the epic fantasy saga.",
    "rating": 4.23,
    "ratingsCount": 688192,
    "pageCount": 835,
    "awards": [
      "Goodreads Choice Award Romantasy (2024)"
    ],
    "categories": [
      "Fantasy",
      "Romance"
    ],
    "scores": {
      "fantasy": 10,
      "heart": 9,
      "plot": 9,
      "dark": 8,
      "atmosphere": 10,
      "series": 10,
      "modern": 10,
      "slow": 7,
      "character": 5,
      "accessible": 7
    }
  },
  {
    "id": 423,
    "title": "The Serpent and the Wings of Night",
    "author": "Carissa Broadbent",
    "publicationYear": 2022,
    "isbn": "1957779004",
    "googleBooksId": "placeholder423",
    "image": "https://books.google.com/books/content?id=8EA8zwEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A human girl raised by the vampire king must compete in a tournament to become his heir. Enemies-to-lovers fantasy romance.",
    "rating": 4.26,
    "ratingsCount": 752051,
    "pageCount": 504,
    "awards": [
      "Swoon Award Fantasy Romance (2022)"
    ],
    "categories": [
      "Fantasy",
      "Romance"
    ],
    "scores": {
      "fantasy": 10,
      "heart": 10,
      "dark": 9,
      "plot": 9,
      "character": 8,
      "fast": 8,
      "series": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 424,
    "title": "One Dark Window",
    "author": "Rachel Gillig",
    "publicationYear": 2022,
    "isbn": "0316312487",
    "googleBooksId": "placeholder424",
    "image": "https://books.google.com/books/content?id=Wdd_zgEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Elspeth must hide her forbidden magic by sharing her head with a monster. Dark fantasy with romance and intrigue.",
    "rating": 4.26,
    "ratingsCount": 661249,
    "pageCount": 432,
    "categories": [
      "Fantasy",
      "Romance"
    ],
    "scores": {
      "fantasy": 10,
      "dark": 9,
      "heart": 8,
      "atmosphere": 10,
      "plot": 8,
      "character": 8,
      "series": 10,
      "modern": 10,
      "medium": 7,
      "accessible": 7
    }
  },
  {
    "id": 425,
    "title": "Powerless",
    "author": "Lauren Roberts",
    "publicationYear": 2023,
    "isbn": "1665954884",
    "googleBooksId": "placeholder425",
    "image": "https://books.google.com/books/content?id=QkTAEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In a kingdom where everyone has powers, Paedyn is powerless. When she saves the prince, she's thrust into the brutal Purging Trials.",
    "rating": 4.16,
    "ratingsCount": 951288,
    "pageCount": 526,
    "awards": [
      "British Book Award Children's Fiction (2024)"
    ],
    "categories": [
      "Fantasy",
      "Romance",
      "Young Adult"
    ],
    "scores": {
      "fantasy": 10,
      "heart": 9,
      "plot": 9,
      "dark": 7,
      "fast": 9,
      "character": 8,
      "series": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 426,
    "title": "Once Upon a Broken Heart",
    "author": "Stephanie Garber",
    "publicationYear": 2021,
    "isbn": "1250268397",
    "googleBooksId": "placeholder426",
    "image": "https://books.google.com/books/content?id=7_8iEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Evangeline makes a deal with the Prince of Hearts to stop her true love from marrying another. A magical fairy tale romance.",
    "rating": 4.06,
    "ratingsCount": 669640,
    "pageCount": 408,
    "awards": [
      "Goodreads Choice Award Nominee Young Adult Fantasy (2021)"
    ],
    "categories": [
      "Fantasy",
      "Romance",
      "Young Adult"
    ],
    "scores": {
      "fantasy": 10,
      "heart": 10,
      "atmosphere": 9,
      "plot": 8,
      "character": 7,
      "medium": 7,
      "series": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 427,
    "title": "Jade City",
    "author": "Fonda Lee",
    "publicationYear": 2017,
    "isbn": "0316440868",
    "googleBooksId": "placeholder427",
    "image": "https://books.google.com/books/content?id=N7XYAQAACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A Hong Kong-inspired fantasy where two families vie for control of jade, a magical resource that grants superhuman abilities. Asian-inspired epic fantasy.",
    "rating": 4.06,
    "ratingsCount": 110516,
    "pageCount": 540,
    "awards": [
      "Nebula Award Best Novel (2017)",
      "World Fantasy Award Novel (2018)",
      "Locus Award Best Fantasy Novel (2018)"
    ],
    "categories": [
      "Fantasy",
      "Epic"
    ],
    "scores": {
      "fantasy": 10,
      "plot": 10,
      "dark": 8,
      "character": 9,
      "atmosphere": 10,
      "medium": 7,
      "series": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 429,
    "title": "Emily Wilde's Encyclopaedia of Faeries",
    "author": "Heather Fawcett",
    "publicationYear": 2023,
    "isbn": "059350013X",
    "googleBooksId": "placeholder429",
    "image": "https://books.google.com/books/content?id=1ZWOEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A curmudgeonly professor of dryadology seeks to complete her encyclopaedia of faerie folk in a remote village. Cozy fantasy romance.",
    "rating": 3.96,
    "ratingsCount": 213385,
    "pageCount": 317,
    "awards": [
      "Goodreads Choice Award Nominee Fantasy (2023)"
    ],
    "categories": [
      "Fantasy",
      "Romance"
    ],
    "scores": {
      "fantasy": 10,
      "heart": 8,
      "character": 9,
      "atmosphere": 9,
      "optimistic": 8,
      "slow": 7,
      "series": 8,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 430,
    "title": "The Sparrow",
    "author": "Mary Doria Russell",
    "publicationYear": 1996,
    "isbn": "0449912558",
    "googleBooksId": "placeholder430",
    "image": "https://books.google.com/books/content?id=dKK0DAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Jesuits travel to a distant planet to make first contact with an alien civilization. What they find challenges everything they believe.",
    "rating": 4.14,
    "ratingsCount": 82139,
    "pageCount": 419,
    "awards": [
      "Arthur C. Clarke Award (1998)",
      "James Tiptree Jr. Award (1997)"
    ],
    "categories": [
      "Science Fiction"
    ],
    "scores": {
      "scifi": 10,
      "character": 10,
      "emotional": 10,
      "mind": 10,
      "dark": 9,
      "slow": 8,
      "literary": 9,
      "series": 8,
      "classic": 7,
      "plot": 5
    }
  },
  {
    "id": 431,
    "title": "The Martian Chronicles",
    "author": "Ray Bradbury",
    "publicationYear": 1950,
    "isbn": "1451678193",
    "googleBooksId": "placeholder431",
    "image": "https://books.google.com/books/content?id=HzQXlPS48PQC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A collection of interlinked stories about humanity's colonization of Mars. Poetic science fiction from a master of the form.",
    "rating": 4.16,
    "ratingsCount": 286483,
    "pageCount": 182,
    "categories": [
      "Science Fiction",
      "Classic"
    ],
    "scores": {
      "scifi": 10,
      "literary": 10,
      "atmosphere": 10,
      "classic": 10,
      "slow": 7,
      "emotional": 7,
      "standalone": 10,
      "character": 8,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 432,
    "title": "Blindsight",
    "author": "Peter Watts",
    "publicationYear": 2006,
    "series": {
      "name": "Firefall",
      "position": 1
    },
    "isbn": "0765319640",
    "googleBooksId": "placeholder432",
    "image": "https://books.google.com/books/content?id=sX1GmAEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A crew of post-humans investigates an alien artifact at the edge of the solar system. Hard science fiction that questions consciousness itself.",
    "rating": 4,
    "ratingsCount": 54446,
    "pageCount": 384,
    "categories": [
      "Science Fiction",
      "Hard SF"
    ],
    "scores": {
      "scifi": 10,
      "mind": 10,
      "dark": 9,
      "atmosphere": 8,
      "plot": 8,
      "slow": 7,
      "standalone": 9,
      "modern": 9,
      "character": 5,
      "accessible": 7
    }
  },
  {
    "id": 433,
    "title": "Speaker for the Dead",
    "author": "Orson Scott Card",
    "publicationYear": 1986,
    "isbn": "0812550757",
    "googleBooksId": "placeholder433",
    "image": "https://books.google.com/books/content?id=5q6IPwAACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Ender Wiggin is called to a distant planet to speak for the dead and encounters a new alien species. The sequel to Ender's Game.",
    "rating": 4.11,
    "ratingsCount": 271507,
    "pageCount": 382,
    "awards": [
      "Nebula Award Best Novel (1986)",
      "Hugo Award Best Novel (1987)"
    ],
    "categories": [
      "Science Fiction"
    ],
    "scores": {
      "scifi": 10,
      "character": 10,
      "mind": 10,
      "emotional": 9,
      "slow": 7,
      "series": 9,
      "classic": 8,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 434,
    "title": "Flowers for Algernon",
    "author": "Daniel Keyes",
    "publicationYear": 1966,
    "isbn": "0156030306",
    "googleBooksId": "placeholder434",
    "image": "https://books.google.com/books/content?id=NRWlitmahXkC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Charlie Gordon, with an IQ of 68, undergoes an experimental surgery to increase his intelligence. Told through his progress reports.",
    "rating": 4.24,
    "ratingsCount": 798391,
    "pageCount": 311,
    "awards": [
      "Hugo Award Best Novel (1967)",
      "Nebula Award Best Novel (1966)"
    ],
    "categories": [
      "Science Fiction",
      "Classic"
    ],
    "scores": {
      "scifi": 8,
      "character": 10,
      "emotional": 10,
      "literary": 9,
      "mind": 9,
      "dark": 8,
      "standalone": 10,
      "classic": 10,
      "medium": 7,
      "slow": 5,
      "plot": 5
    }
  },
  {
    "id": 435,
    "title": "Slaughterhouse-Five",
    "author": "Kurt Vonnegut",
    "publicationYear": 1969,
    "isbn": "0385333846",
    "googleBooksId": "placeholder435",
    "image": "https://books.google.com/books/content?id=XlD9DwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Billy Pilgrim becomes unstuck in time after the firebombing of Dresden. An anti-war science fiction classic.",
    "rating": 4.1,
    "ratingsCount": 1486695,
    "pageCount": 275,
    "awards": [
      "Hugo Award Nominee Best Novel (1970)",
      "Nebula Award Nominee Best Novel (1969)"
    ],
    "categories": [
      "Science Fiction",
      "Classic",
      "Literary Fiction"
    ],
    "scores": {
      "scifi": 7,
      "literary": 10,
      "dark": 9,
      "emotional": 9,
      "mind": 9,
      "classic": 10,
      "standalone": 10,
      "medium": 7,
      "slow": 5,
      "character": 8,
      "plot": 5
    }
  },
  {
    "id": 436,
    "title": "The Player of Games",
    "author": "Iain M. Banks",
    "publicationYear": 1988,
    "isbn": "0316005401",
    "googleBooksId": "placeholder436",
    "image": "https://books.google.com/books/content?id=8l28HAAACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Jernau Gurgeh is the greatest game player in the Culture. When he's challenged to play for the fate of an empire, he cannot refuse.",
    "rating": 4.28,
    "ratingsCount": 80923,
    "pageCount": 293,
    "categories": [
      "Science Fiction",
      "Space Opera"
    ],
    "scores": {
      "scifi": 10,
      "mind": 10,
      "plot": 9,
      "atmosphere": 8,
      "character": 8,
      "medium": 7,
      "series": 8,
      "classic": 7,
      "emotional": 6,
      "accessible": 7
    }
  },
  {
    "id": 437,
    "title": "Parable of the Sower",
    "author": "Octavia E. Butler",
    "publicationYear": 1993,
    "isbn": "1538732181",
    "googleBooksId": "placeholder437",
    "image": "https://books.google.com/books/content?id=F9giugEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In a climate-ravaged California, a young woman with hyper-empathy leads a group north. Dystopian science fiction that feels more relevant each year.",
    "rating": 4.19,
    "ratingsCount": 265602,
    "pageCount": 345,
    "awards": [
      "Nebula Award Nominee Best Novel (1994)"
    ],
    "categories": [
      "Science Fiction",
      "Dystopian"
    ],
    "scores": {
      "scifi": 9,
      "dark": 10,
      "character": 10,
      "emotional": 9,
      "atmosphere": 9,
      "literary": 8,
      "series": 8,
      "classic": 7,
      "medium": 7,
      "slow": 5,
      "plot": 5
    }
  },
  {
    "id": 438,
    "title": "Wild Love",
    "author": "Elsie Silver",
    "publicationYear": 2024,
    "isbn": "1464220816",
    "googleBooksId": "placeholder438",
    "image": "https://books.google.com/books/content?id=kCY60AEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A grumpy single dad and a woman escaping scandal end up stuck together in a small town. Steamy contemporary romance.",
    "rating": 4,
    "ratingsCount": 434884,
    "pageCount": 400,
    "awards": [
      "Goodreads Choice Award Nominee Romance (2024)"
    ],
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 10,
      "emotional": 8,
      "character": 8,
      "optimistic": 8,
      "fast": 8,
      "series": 8,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 439,
    "title": "Flawless",
    "author": "Elsie Silver",
    "publicationYear": 2022,
    "isbn": "1728297001",
    "googleBooksId": "placeholder439",
    "image": "https://books.google.com/books/content?id=buLYzwEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A professional bull rider and an uptight city girl are forced together on a ranch. Enemies-to-lovers western romance.",
    "rating": 4.01,
    "ratingsCount": 670704,
    "pageCount": 424,
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 9,
      "character": 8,
      "emotional": 8,
      "optimistic": 8,
      "fast": 8,
      "series": 9,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 440,
    "title": "Love on the Brain",
    "author": "Ali Hazelwood",
    "publicationYear": 2022,
    "isbn": "0593336844",
    "googleBooksId": "placeholder440",
    "image": "https://books.google.com/books/content?id=TnB9EAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A neuroscientist is forced to work with her nemesis on a NASA project. STEM romance with slow-burn chemistry.",
    "rating": 3.9,
    "ratingsCount": 639875,
    "pageCount": 368,
    "awards": [
      "Audie Award Romance (2023)",
      "Swoon Award Contemporary Romance (2022)"
    ],
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 10,
      "character": 8,
      "optimistic": 9,
      "fast": 8,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 441,
    "title": "Bride",
    "author": "Ali Hazelwood",
    "publicationYear": 2024,
    "series": {
      "name": "Bride",
      "position": 1
    },
    "isbn": "0593550404",
    "googleBooksId": "placeholder441",
    "image": "https://books.google.com/books/content?id=2FTHEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A vampire and a werewolf are forced into a political marriage. Paranormal romance with Hazelwood's signature humor.",
    "rating": 4,
    "ratingsCount": 700606,
    "pageCount": 410,
    "awards": [
      "Goodreads Choice Award Nominee Romance (2024)"
    ],
    "categories": [
      "Romance",
      "Paranormal"
    ],
    "scores": {
      "heart": 9,
      "fantasy": 7,
      "contemporary": 8,
      "character": 8,
      "fast": 8,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 444,
    "title": "The Housemaid's Secret",
    "author": "Freida McFadden",
    "publicationYear": 2023,
    "isbn": "0349132615",
    "googleBooksId": "placeholder444",
    "image": "https://books.google.com/books/content?id=PIHXzwEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Millie takes a new housemaid job with another wealthy family. But this family has secrets too. Sequel to The Housemaid.",
    "rating": 4.19,
    "ratingsCount": 1696801,
    "pageCount": 329,
    "awards": [
      "Goodreads Choice Award Nominee Mystery & Thriller (2023)"
    ],
    "categories": [
      "Thriller",
      "Mystery"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 9,
      "plot": 10,
      "fast": 10,
      "dark": 8,
      "character": 7,
      "series": 9,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 445,
    "title": "Never Lie",
    "author": "Freida McFadden",
    "publicationYear": 2022,
    "isbn": "1728296161",
    "googleBooksId": "placeholder445",
    "image": "https://books.google.com/books/content?id=dLuvEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "A newlywed couple gets trapped in a remote mansion during a snowstorm. They find tapes from the psychiatrist who used to live there.",
    "rating": 4.08,
    "ratingsCount": 1387035,
    "pageCount": 286,
    "categories": [
      "Thriller",
      "Mystery"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 9,
      "plot": 10,
      "fast": 10,
      "dark": 9,
      "atmosphere": 8,
      "standalone": 10,
      "modern": 10,
      "character": 5,
      "accessible": 7
    }
  },
  {
    "id": 446,
    "title": "The Silent Sister",
    "author": "Diane Chamberlain",
    "publicationYear": 2014,
    "isbn": "1250010713",
    "googleBooksId": "placeholder446",
    "image": "https://books.google.com/books/content?id=QEhnBAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Riley discovers her sister, who supposedly died years ago, might still be alive. Family secrets unravel in this domestic thriller.",
    "rating": 3.99,
    "ratingsCount": 93394,
    "pageCount": 352,
    "categories": [
      "Thriller",
      "Mystery"
    ],
    "scores": {
      "thriller": 8,
      "mystery": 9,
      "plot": 9,
      "fast": 8,
      "emotional": 8,
      "character": 8,
      "standalone": 10,
      "modern": 9,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 447,
    "title": "The Family Upstairs",
    "author": "Lisa Jewell",
    "publicationYear": 2019,
    "isbn": "1501190105",
    "googleBooksId": "placeholder447",
    "image": "https://books.google.com/books/content?id=Hd20DwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Libby inherits a house where three people were found dead years ago. Dark family secrets emerge in this twisted thriller.",
    "rating": 3.95,
    "ratingsCount": 563419,
    "pageCount": 342,
    "awards": [
      "Goodreads Choice Award Nominee Mystery & Thriller (2019)"
    ],
    "categories": [
      "Thriller",
      "Mystery"
    ],
    "scores": {
      "thriller": 9,
      "mystery": 9,
      "plot": 9,
      "dark": 9,
      "atmosphere": 8,
      "fast": 8,
      "series": 8,
      "modern": 10,
      "character": 5,
      "accessible": 7
    }
  },
  {
    "id": 448,
    "title": "The It Girl",
    "author": "Ruth Ware",
    "publicationYear": 2022,
    "isbn": "1982155272",
    "googleBooksId": "placeholder448",
    "image": "https://books.google.com/books/content?id=XuCwEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A man was convicted of killing Hannah's glamorous roommate. Now he's dead, and his innocence might be proven.",
    "rating": 3.81,
    "ratingsCount": 209605,
    "pageCount": 423,
    "categories": [
      "Thriller",
      "Mystery"
    ],
    "scores": {
      "thriller": 8,
      "mystery": 10,
      "plot": 9,
      "dark": 7,
      "atmosphere": 8,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "character": 5,
      "accessible": 7
    }
  },
  {
    "id": 449,
    "title": "The Only One Left",
    "author": "Riley Sager",
    "publicationYear": 2023,
    "isbn": "0593183223",
    "googleBooksId": "placeholder449",
    "image": "https://books.google.com/books/content?id=wZGKEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A caregiver is hired to work at a crumbling mansion where a massacre occurred. Gothic thriller with twists.",
    "rating": 4.12,
    "ratingsCount": 492357,
    "pageCount": 383,
    "awards": [
      "Goodreads Choice Award Nominee Mystery & Thriller (2023)"
    ],
    "categories": [
      "Thriller",
      "Mystery",
      "Gothic"
    ],
    "scores": {
      "thriller": 9,
      "mystery": 8,
      "dark": 9,
      "atmosphere": 10,
      "plot": 9,
      "fast": 8,
      "standalone": 10,
      "modern": 10,
      "character": 5,
      "accessible": 7
    }
  },
  {
    "id": 450,
    "title": "The Rose Code",
    "author": "Kate Quinn",
    "publicationYear": 2021,
    "isbn": "0062943472",
    "googleBooksId": "placeholder450",
    "image": "https://books.google.com/books/content?id=U6WUzQEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Three women at Bletchley Park decipher codes during WWII. Years later, a traitor's secret threatens to destroy them.",
    "rating": 4.44,
    "ratingsCount": 372867,
    "pageCount": 624,
    "awards": [
      "Goodreads Choice Award Nominee Historical Fiction (2021)"
    ],
    "categories": [
      "Historical Fiction",
      "Mystery"
    ],
    "scores": {
      "historical": 10,
      "mystery": 8,
      "character": 9,
      "plot": 9,
      "emotional": 8,
      "atmosphere": 8,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "accessible": 7
    }
  },
  {
    "id": 451,
    "title": "The Personal Librarian",
    "author": "Marie Benedict and Victoria Christopher Murray",
    "publicationYear": 2021,
    "isbn": "0593101537",
    "googleBooksId": "placeholder451",
    "image": "https://books.google.com/books/content?id=ZtgwEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Belle da Costa Greene becomes J.P. Morgan's personal librarian while hiding her true identity as a Black woman passing as white.",
    "rating": 3.98,
    "ratingsCount": 136237,
    "pageCount": 341,
    "awards": [
      "Goodreads Choice Award Nominee Historical Fiction (2021)"
    ],
    "categories": [
      "Historical Fiction",
      "Biography"
    ],
    "scores": {
      "historical": 10,
      "character": 10,
      "emotional": 9,
      "dark": 7,
      "literary": 7,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 452,
    "title": "The Huntress",
    "author": "Kate Quinn",
    "publicationYear": 2019,
    "isbn": "0062740377",
    "googleBooksId": "placeholder452",
    "image": "https://books.google.com/books/content?id=zIn2twEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A war correspondent and a Russian pilot hunt a Nazi war criminal who escaped justice. Post-WWII thriller.",
    "rating": 4.3,
    "ratingsCount": 213654,
    "pageCount": 560,
    "awards": [
      "Goodreads Choice Award Historical Fiction Nominee (2019)"
    ],
    "categories": [
      "Historical Fiction",
      "Thriller"
    ],
    "scores": {
      "historical": 10,
      "thriller": 8,
      "character": 9,
      "plot": 9,
      "dark": 8,
      "emotional": 8,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "accessible": 7
    }
  },
  {
    "id": 453,
    "title": "The Covenant of Water",
    "author": "Abraham Verghese",
    "publicationYear": 2023,
    "isbn": "0802162177",
    "googleBooksId": "placeholder453",
    "image": "https://books.google.com/books/content?id=CmlIzwEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A family saga spanning three generations in Kerala, India, marked by a mysterious affliction that causes death by drowning.",
    "rating": 4.33,
    "ratingsCount": 173726,
    "pageCount": 736,
    "awards": [
      "Goodreads Choice Award Nominee Fiction (2023)",
      "Oprah's Book Club Selection"
    ],
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "historical": 9,
      "literary": 10,
      "character": 10,
      "emotional": 10,
      "atmosphere": 10,
      "slow": 9,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 455,
    "title": "The Women",
    "author": "Kristin Hannah",
    "publicationYear": 2024,
    "isbn": "1250178630",
    "googleBooksId": "placeholder455",
    "image": "https://books.google.com/books/content?id=ALG9EAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A young nurse joins the Army in 1966 and serves in Vietnam. A powerful story of war, trauma, and healing.",
    "rating": 4.57,
    "ratingsCount": 1205631,
    "pageCount": 480,
    "awards": [
      "Goodreads Choice Award Historical Fiction (2024)"
    ],
    "categories": [
      "Historical Fiction"
    ],
    "scores": {
      "historical": 10,
      "emotional": 10,
      "character": 10,
      "dark": 9,
      "heart": 9,
      "plot": 8,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "accessible": 7
    }
  },
  {
    "id": 457,
    "title": "Anna Karenina",
    "author": "Leo Tolstoy",
    "publicationYear": 1878,
    "isbn": "0143035002",
    "googleBooksId": "placeholder457",
    "image": "https://books.google.com/books/content?id=fkf1AwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Anna's passionate affair with Count Vronsky leads to her downfall. A sweeping novel of love, family, and Russian society.",
    "rating": 4.1,
    "ratingsCount": 934295,
    "pageCount": 964,
    "awards": [
      "Premio literatura rusa en España (2012)",
      "Read Russia Prize Classic Russian Literature (2012)"
    ],
    "categories": [
      "Classic",
      "Literary Fiction"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 10,
      "emotional": 10,
      "slow": 10,
      "dark": 8,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 458,
    "title": "A Tale of Two Cities",
    "author": "Charles Dickens",
    "publicationYear": 1859,
    "isbn": "0141439602",
    "googleBooksId": "placeholder458",
    "image": "https://books.google.com/books/content?id=4GIrEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "London and Paris during the French Revolution. Love, sacrifice, and redemption against the backdrop of history's greatest upheaval.",
    "rating": 3.88,
    "ratingsCount": 1014304,
    "pageCount": 489,
    "awards": [
      "Audie Award Classics (2006)"
    ],
    "categories": [
      "Classic",
      "Historical Fiction"
    ],
    "scores": {
      "classic": 10,
      "literary": 9,
      "historical": 10,
      "emotional": 9,
      "dark": 8,
      "slow": 7,
      "standalone": 10,
      "character": 8,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 459,
    "title": "Catch-22",
    "author": "Joseph Heller",
    "publicationYear": 1961,
    "series": {
      "name": "Catch-22",
      "position": 1
    },
    "isbn": "1451626657",
    "googleBooksId": "placeholder459",
    "image": "https://books.google.com/books/content?id=SPlHAAAAMAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Yossarian is a WWII bombardier who believes everyone is trying to kill him. The classic satirical novel about the insanity of war.",
    "rating": 3.99,
    "ratingsCount": 887788,
    "pageCount": 453,
    "awards": [
      "National Book Award Finalist (1962)"
    ],
    "categories": [
      "Classic",
      "Literary Fiction",
      "War"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "dark": 8,
      "mind": 9,
      "character": 8,
      "medium": 7,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 460,
    "title": "Holly",
    "author": "Stephen King",
    "publicationYear": 2023,
    "isbn": "1668016133",
    "googleBooksId": "placeholder460",
    "image": "https://books.google.com/books/content?id=cuPPEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Holly Gibney investigates a missing person case that leads to a sinister old couple with a dark secret.",
    "rating": 4.07,
    "ratingsCount": 189387,
    "pageCount": 449,
    "awards": [
      "Goodreads Choice Award Nominee Horror (2023)"
    ],
    "categories": [
      "Horror",
      "Thriller",
      "Mystery"
    ],
    "scores": {
      "thriller": 9,
      "mystery": 8,
      "dark": 9,
      "character": 9,
      "atmosphere": 8,
      "plot": 8,
      "series": 8,
      "modern": 10,
      "fast": 7,
      "medium": 5
    }
  },
  {
    "id": 461,
    "title": "Demon Copperhead",
    "author": "Barbara Kingsolver",
    "publicationYear": 2022,
    "isbn": "0063251922",
    "googleBooksId": "placeholder461",
    "image": "https://books.google.com/books/content?id=w7ntzgEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A modern retelling of David Copperfield set in Appalachian Virginia. A boy navigates the foster care system amid the opioid crisis.",
    "rating": 4.45,
    "ratingsCount": 594336,
    "pageCount": 560,
    "awards": [
      "Pulitzer Prize Fiction (2023)",
      "Women's Prize for Fiction (2023)",
      "Goodreads Choice Award Fiction (2022)"
    ],
    "categories": [
      "Literary Fiction",
      "Contemporary"
    ],
    "scores": {
      "literary": 10,
      "contemporary": 10,
      "character": 10,
      "emotional": 10,
      "dark": 9,
      "slow": 7,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 462,
    "title": "Remarkably Bright Creatures",
    "author": "Shelby Van Pelt",
    "publicationYear": 2022,
    "isbn": "0063204150",
    "googleBooksId": "placeholder462",
    "image": "https://books.google.com/books/content?id=rKqWzgEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A widow working the night shift at an aquarium forms an unlikely friendship with a giant Pacific octopus.",
    "rating": 4.36,
    "ratingsCount": 1191186,
    "pageCount": 368,
    "awards": [
      "Goodreads Choice Award Nominee Fiction (2022)"
    ],
    "categories": [
      "Contemporary Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "contemporary": 10,
      "character": 10,
      "heart": 10,
      "emotional": 9,
      "optimistic": 9,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 464,
    "title": "Frederick Douglass: Prophet of Freedom",
    "author": "David W. Blight",
    "publicationYear": 2018,
    "isbn": "1416590323",
    "googleBooksId": "placeholder464",
    "image": "https://books.google.com/books/content?id=ylTDDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The definitive biography of Frederick Douglass, the escaped slave who became one of the most important voices for civil rights in American history. Pulitzer Prize winner.",
    "rating": 4.14,
    "ratingsCount": 11155,
    "pageCount": 912,
    "awards": [
      "Pulitzer Prize Biography (2019)",
      "Lincoln Prize (2019)"
    ],
    "categories": [
      "Biography",
      "History",
      "Nonfiction"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 10,
      "character": 10,
      "literary": 8,
      "slow": 8,
      "emotional": 8,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 466,
    "title": "Iron Flame",
    "author": "Rebecca Yarros",
    "publicationYear": 2023,
    "isbn": "1649374178",
    "googleBooksId": "placeholder466",
    "image": "https://books.google.com/books/content?id=EY69EAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The sequel to Fourth Wing. Violet Sorrengail's next year at Basgiath War College brings new dangers and deeper secrets about the dragons.",
    "rating": 4.36,
    "ratingsCount": 2610894,
    "pageCount": 640,
    "awards": [
      "British Book Award Fiction (2024)",
      "Australian Book Industry Award International Book (2024)",
      "Libby Award Best Romantasy (2024)"
    ],
    "categories": [
      "Fantasy",
      "Romance"
    ],
    "scores": {
      "fantasy": 10,
      "heart": 9,
      "plot": 10,
      "dark": 8,
      "atmosphere": 9,
      "series": 10,
      "fast": 9,
      "modern": 10,
      "character": 5,
      "accessible": 7
    }
  },
  {
    "id": 467,
    "title": "Hell Bent",
    "author": "Leigh Bardugo",
    "publicationYear": 2023,
    "isbn": "1250313104",
    "googleBooksId": "placeholder467",
    "image": "https://books.google.com/books/content?id=eidlEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Galaxy Alex Stern continues her dark journey through Yale's secret societies. Sequel to Ninth House.",
    "rating": 4.08,
    "ratingsCount": 123726,
    "pageCount": 496,
    "awards": [
      "Goodreads Choice Award Fantasy (2023)"
    ],
    "categories": [
      "Fantasy",
      "Dark Academia"
    ],
    "scores": {
      "fantasy": 8,
      "mystery": 8,
      "dark": 10,
      "atmosphere": 10,
      "plot": 9,
      "series": 10,
      "modern": 10,
      "medium": 7,
      "character": 5,
      "accessible": 7
    }
  },
  {
    "id": 468,
    "title": "Heir",
    "author": "Sabaa Tahir",
    "publicationYear": 2024,
    "isbn": "0593859855",
    "googleBooksId": "placeholder468",
    "image": "https://books.google.com/books/content?id=9AzyEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Return to the world of An Ember in the Ashes with a new generation. A prince and a warrior must unite against ancient evil.",
    "rating": 4.21,
    "ratingsCount": 16869,
    "pageCount": 503,
    "awards": [
      "Ignyte Award YA Novel (2025)"
    ],
    "categories": [
      "Fantasy",
      "Young Adult"
    ],
    "scores": {
      "fantasy": 10,
      "plot": 9,
      "dark": 8,
      "character": 8,
      "atmosphere": 9,
      "series": 10,
      "fast": 8,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 469,
    "title": "Chasing the Boogeyman",
    "author": "Richard Chizmar",
    "publicationYear": 2021,
    "series": {
      "name": "The Boogeyman",
      "position": 1
    },
    "isbn": "1982175176",
    "googleBooksId": "placeholder469",
    "image": "https://books.google.com/books/content?id=Lxx1EAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A blend of memoir and fiction as the author returns to his hometown during a series of murders. True crime meets horror.",
    "rating": 3.92,
    "ratingsCount": 36466,
    "pageCount": 304,
    "awards": [
      "Goodreads Choice Award Nominee Horror (2021)"
    ],
    "categories": [
      "Horror",
      "Thriller",
      "Mystery"
    ],
    "scores": {
      "thriller": 9,
      "mystery": 9,
      "dark": 9,
      "atmosphere": 9,
      "plot": 8,
      "fast": 8,
      "standalone": 10,
      "modern": 10,
      "character": 5,
      "accessible": 7
    }
  },
  {
    "id": 470,
    "title": "Hamnet",
    "author": "Maggie O'Farrell",
    "publicationYear": 2020,
    "isbn": "0525657606",
    "googleBooksId": "placeholder470",
    "image": "https://books.google.com/books/content?id=LGKTEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A reimagining of the life of Shakespeare's son, who died at age 11. A meditation on grief, love, and art.",
    "rating": 4.2,
    "ratingsCount": 369092,
    "pageCount": 372,
    "awards": [
      "Women's Prize for Fiction (2020)",
      "National Book Critics Circle Award Nominee Fiction (2020)"
    ],
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "historical": 10,
      "literary": 10,
      "emotional": 10,
      "character": 9,
      "atmosphere": 9,
      "slow": 8,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 471,
    "title": "The Paris Library",
    "author": "Janet Skeslien Charles",
    "publicationYear": 2021,
    "isbn": "1982134208",
    "googleBooksId": "placeholder471",
    "image": "https://books.google.com/books/content?id=HTNcEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The true story of the heroic librarians at the American Library in Paris during WWII. Dual timeline historical fiction.",
    "rating": 4,
    "ratingsCount": 95089,
    "pageCount": 352,
    "categories": [
      "Historical Fiction"
    ],
    "scores": {
      "historical": 10,
      "character": 9,
      "heart": 8,
      "emotional": 8,
      "atmosphere": 8,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 472,
    "title": "Of Mice and Men",
    "author": "John Steinbeck",
    "publicationYear": 1937,
    "isbn": "0140177396",
    "googleBooksId": "placeholder472",
    "image": "https://books.google.com/books/content?id=F0EwEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Two displaced migrant ranch workers during the Great Depression in California dream of owning their own land. A tragedy of friendship.",
    "rating": 3.89,
    "ratingsCount": 2672500,
    "pageCount": 107,
    "categories": [
      "Classic",
      "Literary Fiction"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 10,
      "emotional": 10,
      "dark": 9,
      "fast": 9,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 473,
    "title": "North and South",
    "author": "Elizabeth Gaskell",
    "publicationYear": 1854,
    "isbn": "0140434240",
    "googleBooksId": "placeholder473",
    "image": "https://books.google.com/books/content?id=QhiOn426BZAC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A southern English woman moves to an industrial northern town and clashes with a mill owner. Victorian social novel with romance.",
    "rating": 4.15,
    "ratingsCount": 182160,
    "pageCount": 480,
    "categories": [
      "Classic",
      "Romance"
    ],
    "scores": {
      "classic": 10,
      "literary": 9,
      "character": 10,
      "heart": 9,
      "emotional": 8,
      "slow": 7,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 474,
    "title": "Annihilation",
    "author": "Jeff VanderMeer",
    "publicationYear": 2014,
    "isbn": "0374104093",
    "googleBooksId": "placeholder474",
    "image": "https://books.google.com/books/content?id=2cl7AgAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A team of four women enter Area X, a mysterious zone where previous expeditions have met disastrous ends. Eerie and atmospheric sci-fi horror.",
    "rating": 3.8,
    "ratingsCount": 305387,
    "pageCount": 195,
    "awards": [
      "Nebula Award Best Novel (2014)",
      "Shirley Jackson Award Best Novel (2014)"
    ],
    "categories": [
      "Science Fiction",
      "Horror"
    ],
    "scores": {
      "scifi": 9,
      "dark": 10,
      "atmosphere": 10,
      "mystery": 8,
      "literary": 8,
      "slow": 7,
      "series": 8,
      "modern": 10,
      "character": 8,
      "plot": 5
    }
  },
  {
    "id": 475,
    "title": "A Court of Silver Flames",
    "author": "Sarah J. Maas",
    "publicationYear": 2021,
    "isbn": "1635577993",
    "googleBooksId": "placeholder475",
    "image": "https://books.google.com/books/content?id=goBOEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Nesta Archeron's journey of healing and self-discovery. She must confront her inner demons while training as a warrior alongside Cassian.",
    "rating": 4.45,
    "ratingsCount": 2092861,
    "pageCount": 757,
    "awards": [
      "Goodreads Choice Award Nominee Fantasy (2021)"
    ],
    "categories": [
      "Fantasy",
      "Romance"
    ],
    "scores": {
      "fantasy": 10,
      "heart": 10,
      "dark": 8,
      "character": 10,
      "emotional": 10,
      "slow": 7,
      "series": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 476,
    "title": "The Push",
    "author": "Ashley Audrain",
    "publicationYear": 2021,
    "isbn": "1984881663",
    "googleBooksId": "placeholder476",
    "image": "https://books.google.com/books/content?id=4LZPEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A mother questions whether there is something wrong with her daughter. A psychological thriller about motherhood, instinct, and doubt.",
    "rating": 4.04,
    "ratingsCount": 439537,
    "pageCount": 307,
    "awards": [
      "Goodreads Choice Award Nominee Debut Novel (2021)"
    ],
    "categories": [
      "Thriller",
      "Psychological"
    ],
    "scores": {
      "thriller": 10,
      "dark": 10,
      "emotional": 9,
      "character": 9,
      "plot": 8,
      "fast": 8,
      "standalone": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 477,
    "title": "War and Peace",
    "author": "Leo Tolstoy",
    "publicationYear": 1869,
    "isbn": "1400079985",
    "googleBooksId": "placeholder477",
    "image": "https://books.google.com/books/content?id=bL3VlijouIwC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "An epic novel set during the Napoleonic Wars, following aristocratic Russian families through love, loss, and the search for meaning.",
    "rating": 4.17,
    "ratingsCount": 366738,
    "pageCount": 1392,
    "awards": [
      "Audie Award Literary Fiction & Classics (2023)"
    ],
    "categories": [
      "Classic Literature",
      "Historical Fiction",
      "Russian Literature"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "historical": 9,
      "character": 10,
      "slow": 10,
      "emotional": 9,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 478,
    "title": "Don Quixote",
    "author": "Miguel de Cervantes",
    "publicationYear": 1605,
    "series": {
      "name": "Don Quijote de la Mancha",
      "position": 1
    },
    "isbn": "0142437239",
    "googleBooksId": "placeholder478",
    "image": "https://books.google.com/books/content?id=sI_UG8lLey0C&printsec=frontcover&img=1&zoom=3",
    "synopsis": "An aging gentleman, driven mad by reading too many chivalric romances, sets out with his squire Sancho Panza to revive knight-errantry. Considered the first modern novel.",
    "rating": 3.91,
    "ratingsCount": 306058,
    "pageCount": 1023,
    "awards": [
      "Will Eisner Comic Industry Award Best Adaptation from Another Medium (2014)",
      "Premio Valle-Inclán (2002)"
    ],
    "categories": [
      "Classic Literature",
      "Satire",
      "Adventure"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 9,
      "slow": 8,
      "optimistic": 7,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7,
      "atmosphere": 6
    }
  },
  {
    "id": 479,
    "title": "The Odyssey",
    "author": "Homer",
    "publicationYear": -800,
    "isbn": "0140268863",
    "googleBooksId": "placeholder479",
    "image": "https://books.google.com/books/content?id=vIVPEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The ancient Greek epic following Odysseus's ten-year journey home after the Trojan War, facing mythical creatures and divine intervention.",
    "rating": 3.81,
    "ratingsCount": 1075928,
    "pageCount": 541,
    "categories": [
      "Classic Literature",
      "Poetry",
      "Mythology"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "atmosphere": 10,
      "plot": 9,
      "fantasy": 8,
      "standalone": 10,
      "medium": 7,
      "slow": 5,
      "character": 5,
      "emotional": 6
    }
  },
  {
    "id": 480,
    "title": "Middlemarch",
    "author": "George Eliot",
    "publicationYear": 1871,
    "isbn": "0141439548",
    "googleBooksId": "placeholder480",
    "image": "https://books.google.com/books/content?id=s46MEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A sweeping portrait of English provincial life set in the fictitious Midlands town during 1829-1832. Virginia Woolf called it one of the few English novels written for grown-up people.",
    "rating": 4.01,
    "ratingsCount": 149189,
    "pageCount": 880,
    "categories": [
      "Classic Literature",
      "Historical Fiction",
      "Victorian"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 10,
      "slow": 9,
      "emotional": 8,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7,
      "atmosphere": 6
    }
  },
  {
    "id": 482,
    "title": "The Iliad",
    "author": "Homer",
    "publicationYear": -750,
    "isbn": "0140275363",
    "googleBooksId": "placeholder482",
    "image": "https://books.google.com/books/content?id=8IVPEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The ancient Greek epic poem about the Trojan War, focusing on the rage of Achilles and the devastating consequences of pride and honor in warfare.",
    "rating": 3.93,
    "ratingsCount": 510746,
    "pageCount": 704,
    "categories": [
      "Classic Literature",
      "Poetry",
      "Mythology"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "atmosphere": 10,
      "dark": 9,
      "emotional": 8,
      "standalone": 10,
      "medium": 7,
      "slow": 5,
      "character": 8,
      "plot": 5
    }
  },
  {
    "id": 483,
    "title": "The Stranger",
    "author": "Albert Camus",
    "publicationYear": 1942,
    "isbn": "0679720200",
    "googleBooksId": "placeholder483",
    "image": "https://books.google.com/books/content?id=iVV7bKVUNBAC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Meursault commits a senseless murder and faces trial where society's judgment of his character proves more damning than the crime itself. A classic of existentialist literature.",
    "rating": 4.04,
    "ratingsCount": 1101065,
    "pageCount": 123,
    "categories": [
      "Classic Literature",
      "Philosophy",
      "French Literature"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "mind": 10,
      "dark": 9,
      "fast": 8,
      "character": 9,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 484,
    "title": "The Master and Margarita",
    "author": "Mikhail Bulgakov",
    "publicationYear": 1967,
    "isbn": "0679760806",
    "googleBooksId": "placeholder484",
    "image": "http://books.google.com/books/content?id=m1ON7vRyeOUC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Satan arrives in Soviet Moscow accompanied by a giant cat, a fanged assassin, and a beautiful naked witch. A satirical masterpiece weaving contemporary plot with the Passion of Christ.",
    "rating": 4.28,
    "ratingsCount": 421120,
    "pageCount": 384,
    "categories": [
      "Classic Literature",
      "Fantasy",
      "Satire"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "fantasy": 9,
      "atmosphere": 10,
      "mind": 9,
      "standalone": 10,
      "medium": 7,
      "slow": 5,
      "character": 8,
      "plot": 5,
      "emotional": 6
    }
  },
  {
    "id": 485,
    "title": "The Grapes of Wrath",
    "author": "John Steinbeck",
    "publicationYear": 1939,
    "isbn": "0143039431",
    "googleBooksId": "placeholder485",
    "image": "https://books.google.com/books/content?id=bhJgd3hGdxQC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The Joad family, driven from their Oklahoma home during the Dust Bowl, journey to California seeking work and dignity. A powerful portrayal of American poverty and resilience.",
    "rating": 4.03,
    "ratingsCount": 986763,
    "pageCount": 464,
    "awards": [
      "Pulitzer Prize Fiction (1940)",
      "National Book Award Fiction (1939)"
    ],
    "categories": [
      "Classic Literature",
      "Historical Fiction",
      "American Literature"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "historical": 9,
      "emotional": 10,
      "dark": 9,
      "character": 10,
      "standalone": 10,
      "medium": 7,
      "slow": 5,
      "plot": 5
    }
  },
  {
    "id": 486,
    "title": "Lolita",
    "author": "Vladimir Nabokov",
    "publicationYear": 1955,
    "isbn": "0679723161",
    "googleBooksId": "placeholder486",
    "image": "https://books.google.com/books/content?id=WfCKDQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A controversial literary masterpiece narrated by Humbert Humbert, obsessed with a twelve-year-old girl. A complex exploration of obsession and unreliable narration.",
    "rating": 3.87,
    "ratingsCount": 943708,
    "pageCount": 336,
    "categories": [
      "Classic Literature",
      "Literary Fiction",
      "Controversial"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 10,
      "dark": 10,
      "mind": 9,
      "standalone": 10,
      "medium": 7,
      "slow": 5,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 487,
    "title": "The Bell Jar",
    "author": "Sylvia Plath",
    "publicationYear": 1963,
    "isbn": "0060837020",
    "googleBooksId": "placeholder487",
    "image": "https://books.google.com/books/content?id=cZpR_0kN9gEC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Esther Greenwood descends into depression and mental breakdown. A semi-autobiographical exploration of identity, creativity, and mental illness.",
    "rating": 4.05,
    "ratingsCount": 1220575,
    "pageCount": 288,
    "categories": [
      "Classic Literature",
      "Literary Fiction",
      "Mental Health"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 10,
      "emotional": 10,
      "dark": 9,
      "standalone": 10,
      "medium": 7,
      "slow": 5,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 489,
    "title": "IT",
    "author": "Stephen King",
    "publicationYear": 1986,
    "isbn": "1501142976",
    "googleBooksId": "placeholder489",
    "image": "https://books.google.com/books/content?id=S85NCwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Seven childhood friends reunite to confront a shape-shifting entity that preys on children in Derry, Maine. A terrifying exploration of childhood fears and the power of friendship.",
    "rating": 4.24,
    "ratingsCount": 1264726,
    "pageCount": 1168,
    "categories": [
      "Horror",
      "Thriller",
      "Supernatural"
    ],
    "scores": {
      "thriller": 9,
      "dark": 10,
      "atmosphere": 10,
      "character": 9,
      "plot": 9,
      "slow": 8,
      "series": 7,
      "modern": 8,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 490,
    "title": "The Shining",
    "author": "Stephen King",
    "publicationYear": 1977,
    "isbn": "0307743659",
    "googleBooksId": "placeholder490",
    "image": "https://books.google.com/books/content?id=c2VHVEWUFoQC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Jack Torrance takes a winter caretaker job at the isolated Overlook Hotel, where supernatural forces prey on his son's psychic abilities and his own demons.",
    "rating": 4.28,
    "ratingsCount": 1712371,
    "pageCount": 497,
    "awards": [
      "Locus Award Best Fantasy Novel (1978)",
      "Gandalf Award (1978)"
    ],
    "categories": [
      "Horror",
      "Thriller",
      "Supernatural"
    ],
    "scores": {
      "thriller": 10,
      "dark": 10,
      "atmosphere": 10,
      "character": 9,
      "plot": 9,
      "medium": 8,
      "series": 8,
      "classic": 7,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 491,
    "title": "Pet Sematary",
    "author": "Stephen King",
    "publicationYear": 1983,
    "isbn": "198211598X",
    "googleBooksId": "placeholder491",
    "image": "https://books.google.com/books/content?id=RvPjyQEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The Creed family discovers a mysterious burial ground with the power to resurrect the dead. Stephen King's most personally frightening novel explores grief and its consequences.",
    "rating": 4.08,
    "ratingsCount": 702280,
    "pageCount": 580,
    "awards": [
      "Locus Award Best Fantasy Novel Nominee (1984)",
      "World Fantasy Award Best Novel Nominee (1984)"
    ],
    "categories": [
      "Horror",
      "Thriller",
      "Supernatural"
    ],
    "scores": {
      "thriller": 9,
      "dark": 10,
      "atmosphere": 9,
      "emotional": 9,
      "plot": 8,
      "medium": 8,
      "standalone": 10,
      "classic": 7,
      "character": 5,
      "accessible": 7
    }
  },
  {
    "id": 492,
    "title": "House of Leaves",
    "author": "Mark Z. Danielewski",
    "publicationYear": 2000,
    "isbn": "0375703764",
    "googleBooksId": "placeholder492",
    "image": "https://books.google.com/books/content?id=o6NzGNODRjkC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A family moves into a house impossibly larger on the inside than outside, with a labyrinth that shifts and grows. A groundbreaking experimental horror novel.",
    "rating": 4.11,
    "ratingsCount": 166582,
    "pageCount": 709,
    "categories": [
      "Horror",
      "Experimental",
      "Psychological"
    ],
    "scores": {
      "thriller": 8,
      "dark": 10,
      "atmosphere": 10,
      "literary": 9,
      "mind": 10,
      "slow": 8,
      "standalone": 10,
      "modern": 10,
      "character": 8,
      "plot": 5
    }
  },
  {
    "id": 493,
    "title": "The Haunting of Hill House",
    "author": "Shirley Jackson",
    "publicationYear": 1959,
    "isbn": "0143039989",
    "googleBooksId": "placeholder493",
    "image": "https://books.google.com/books/content?id=5EuovAEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Four people seeking supernatural phenomena converge on Hill House, where the architecture itself seems malevolent. Stephen King called it one of the finest horror novels.",
    "rating": 4.1,
    "ratingsCount": 395681,
    "pageCount": 246,
    "awards": [
      "National Book Award Finalist (1960)"
    ],
    "categories": [
      "Horror",
      "Gothic",
      "Supernatural"
    ],
    "scores": {
      "thriller": 8,
      "dark": 9,
      "atmosphere": 10,
      "literary": 9,
      "character": 8,
      "fast": 8,
      "standalone": 10,
      "classic": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 494,
    "title": "The Exorcist",
    "author": "William Peter Blatty",
    "publicationYear": 1971,
    "series": {
      "name": "The Exorcist",
      "position": 1
    },
    "isbn": "006209436X",
    "googleBooksId": "placeholder494",
    "image": "https://books.google.com/books/content?id=vtAYk1rR3uMC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "When a young girl exhibits terrifying supernatural symptoms, her desperate mother turns to two priests for help. Based on a true story, spawned one of cinema's most terrifying films.",
    "rating": 4.21,
    "ratingsCount": 271393,
    "pageCount": 385,
    "categories": [
      "Horror",
      "Supernatural",
      "Religious"
    ],
    "scores": {
      "thriller": 10,
      "dark": 10,
      "atmosphere": 9,
      "plot": 9,
      "emotional": 8,
      "medium": 7,
      "standalone": 10,
      "classic": 8,
      "character": 5,
      "accessible": 7
    }
  },
  {
    "id": 495,
    "title": "Salem's Lot",
    "author": "Stephen King",
    "publicationYear": 1975,
    "isbn": "0307743675",
    "googleBooksId": "placeholder495",
    "image": "https://books.google.com/books/content?id=6OxSHEbM1isC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A writer returns to the small Maine town of Jerusalem's Lot, only to discover that the townspeople are being turned into vampires. King's modern reimagining of the vampire tale.",
    "rating": 4.1,
    "ratingsCount": 660741,
    "pageCount": 439,
    "awards": [
      "World Fantasy Award Nominee Best Novel (1976)"
    ],
    "categories": [
      "Horror",
      "Vampires",
      "Supernatural"
    ],
    "scores": {
      "thriller": 9,
      "dark": 10,
      "atmosphere": 10,
      "plot": 9,
      "medium": 7,
      "standalone": 10,
      "classic": 8,
      "character": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 496,
    "title": "The Stand",
    "author": "Stephen King",
    "publicationYear": 1978,
    "isbn": "0307947300",
    "googleBooksId": "placeholder496",
    "image": "https://books.google.com/books/content?id=1xhLQ7F1_CsC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "After a plague wipes out most of humanity, survivors divide into two camps for a final confrontation between good and evil. King's epic post-apocalyptic masterpiece.",
    "rating": 4.35,
    "ratingsCount": 837277,
    "pageCount": 1152,
    "awards": [
      "Locus Award Best SF Novel (1979)",
      "World Fantasy Award Best Novel Nominee (1979)",
      "Gandalf Award (1979)"
    ],
    "categories": [
      "Horror",
      "Post-Apocalyptic",
      "Fantasy"
    ],
    "scores": {
      "thriller": 8,
      "dark": 9,
      "atmosphere": 10,
      "character": 10,
      "plot": 10,
      "slow": 9,
      "standalone": 10,
      "classic": 8,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 497,
    "title": "Carrie",
    "author": "Stephen King",
    "publicationYear": 1974,
    "isbn": "0307743667",
    "googleBooksId": "placeholder497",
    "image": "https://books.google.com/books/content?id=TA5X7-sC54AC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Carrie White, a bullied high school outcast with telekinetic powers, seeks revenge on her tormentors at the prom. Stephen King's debut novel that launched his legendary career.",
    "rating": 3.99,
    "ratingsCount": 849375,
    "pageCount": 272,
    "categories": [
      "Horror",
      "Supernatural",
      "Coming-of-Age"
    ],
    "scores": {
      "thriller": 9,
      "dark": 10,
      "emotional": 9,
      "character": 9,
      "plot": 9,
      "fast": 8,
      "standalone": 10,
      "classic": 8,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 498,
    "title": "Misery",
    "author": "Stephen King",
    "publicationYear": 1987,
    "isbn": "1501143107",
    "googleBooksId": "placeholder498",
    "image": "https://books.google.com/books/content?id=cc5NCwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A famous author is rescued from a car crash by his number one fan, who holds him captive and forces him to write a novel just for her. A terrifying psychological thriller.",
    "rating": 4.23,
    "ratingsCount": 852782,
    "pageCount": 370,
    "awards": [
      "Bram Stoker Award Best Novel (1987)",
      "World Fantasy Award Best Novel Nominee (1988)"
    ],
    "categories": [
      "Horror",
      "Thriller",
      "Psychological"
    ],
    "scores": {
      "thriller": 10,
      "dark": 10,
      "character": 10,
      "plot": 10,
      "atmosphere": 9,
      "fast": 9,
      "standalone": 10,
      "modern": 8,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 499,
    "title": "Meditations",
    "author": "Marcus Aurelius",
    "publicationYear": 180,
    "isbn": "0812968255",
    "googleBooksId": "placeholder499",
    "image": "https://books.google.com/books/content?id=brSidvTKfcQC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The private philosophical writings of the Roman Emperor offering timeless wisdom on virtue, resilience, and living according to nature. A foundational text of Stoic philosophy.",
    "rating": 4.29,
    "ratingsCount": 263731,
    "pageCount": 256,
    "categories": [
      "Self-Help",
      "Philosophy",
      "Stoicism"
    ],
    "scores": {
      "selfhelp": 10,
      "nonfiction": 10,
      "mind": 10,
      "classic": 10,
      "slow": 7,
      "standalone": 10,
      "character": 7,
      "plot": 6,
      "emotional": 6,
      "accessible": 7
    }
  },
  {
    "id": 500,
    "title": "Think and Grow Rich",
    "author": "Napoleon Hill",
    "publicationYear": 1937,
    "isbn": "1585424331",
    "googleBooksId": "placeholder500",
    "image": "https://books.google.com/books/content?id=HO-cnF0abjgC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Based on interviews with over 500 of America's most successful people, this classic outlines 13 principles for achieving wealth. One of the best-selling self-help books of all time.",
    "rating": 4.18,
    "ratingsCount": 244661,
    "pageCount": 233,
    "categories": [
      "Self-Help",
      "Business",
      "Personal Finance"
    ],
    "scores": {
      "selfhelp": 10,
      "nonfiction": 10,
      "mind": 9,
      "optimistic": 8,
      "classic": 8,
      "standalone": 10,
      "medium": 7,
      "character": 7,
      "plot": 6,
      "accessible": 7
    }
  },
  {
    "id": 501,
    "title": "Rich Dad Poor Dad",
    "author": "Robert T. Kiyosaki",
    "publicationYear": 1997,
    "series": {
      "name": "Rich Dad",
      "position": 1
    },
    "isbn": "1612680011",
    "googleBooksId": "placeholder501",
    "image": "https://books.google.com/books/content?id=TelFYgEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Contrasting the financial philosophies of his two fathers, Kiyosaki reveals the mindset differences between the rich and poor. An influential guide to financial literacy.",
    "rating": 4.09,
    "ratingsCount": 852001,
    "pageCount": 336,
    "categories": [
      "Self-Help",
      "Personal Finance",
      "Business"
    ],
    "scores": {
      "selfhelp": 10,
      "nonfiction": 10,
      "mind": 9,
      "fast": 8,
      "standalone": 10,
      "modern": 9,
      "character": 7,
      "plot": 6,
      "emotional": 6,
      "accessible": 7
    }
  },
  {
    "id": 502,
    "title": "12 Rules for Life",
    "author": "Jordan B. Peterson",
    "publicationYear": 2018,
    "isbn": "0345816021",
    "googleBooksId": "placeholder502",
    "image": "https://books.google.com/books/content?id=sxVHDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A clinical psychologist offers practical advice for living a meaningful life, drawing from psychology, mythology, religion, and personal anecdotes.",
    "rating": 3.9,
    "ratingsCount": 226162,
    "pageCount": 448,
    "categories": [
      "Self-Help",
      "Psychology",
      "Philosophy"
    ],
    "scores": {
      "selfhelp": 10,
      "nonfiction": 10,
      "mind": 10,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6,
      "emotional": 6,
      "accessible": 7
    }
  },
  {
    "id": 503,
    "title": "On Writing",
    "author": "Stephen King",
    "publicationYear": 2000,
    "isbn": "1439156816",
    "googleBooksId": "placeholder503",
    "image": "https://books.google.com/books/content?id=qSZmQgAACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Part memoir, part master class, Stephen King shares his experiences and advice for aspiring writers. Named one of TIME's Top 100 Nonfiction Books of All Time.",
    "rating": 4.34,
    "ratingsCount": 318877,
    "pageCount": 320,
    "categories": [
      "Self-Help",
      "Writing",
      "Memoir"
    ],
    "scores": {
      "selfhelp": 8,
      "memoir": 8,
      "nonfiction": 10,
      "mind": 8,
      "character": 8,
      "fast": 8,
      "standalone": 10,
      "modern": 9,
      "plot": 5,
      "emotional": 6
    }
  },
  {
    "id": 505,
    "title": "The Art of War",
    "author": "Sun Tzu",
    "publicationYear": -500,
    "isbn": "1590302257",
    "googleBooksId": "placeholder505",
    "image": "https://books.google.com/books/content?id=Lt9OEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The ancient Chinese military treatise that has influenced not only military strategy but also business, law, and sports. Timeless wisdom on strategy and conflict.",
    "rating": 3.94,
    "ratingsCount": 573664,
    "pageCount": 273,
    "categories": [
      "Philosophy",
      "Strategy",
      "Classic"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 10,
      "classic": 10,
      "fast": 9,
      "standalone": 10,
      "character": 7,
      "plot": 6,
      "emotional": 6,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 506,
    "title": "The Demon of Unrest",
    "author": "Erik Larson",
    "publicationYear": 2024,
    "isbn": "0385348746",
    "googleBooksId": "placeholder506",
    "image": "https://books.google.com/books/content?id=HybPEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A narrative history of the five months between Lincoln's election and the bombardment of Fort Sumter, capturing the tension and drama that led America into Civil War.",
    "rating": 4.17,
    "ratingsCount": 56409,
    "pageCount": 565,
    "categories": [
      "History",
      "Non-Fiction",
      "American History"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 10,
      "atmosphere": 9,
      "plot": 8,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "character": 5,
      "emotional": 6,
      "accessible": 7
    }
  },
  {
    "id": 507,
    "title": "Into the Wild",
    "author": "Jon Krakauer",
    "publicationYear": 1996,
    "isbn": "0385486804",
    "googleBooksId": "placeholder507",
    "image": "https://books.google.com/books/content?id=Xk_YAAAAMAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The true story of Chris McCandless, who gave up everything to walk alone into the Alaskan wilderness. A meditation on idealism, nature, and the search for meaning.",
    "rating": 4.02,
    "ratingsCount": 1193474,
    "pageCount": 207,
    "categories": [
      "Non-Fiction",
      "Adventure",
      "Biography"
    ],
    "scores": {
      "nonfiction": 10,
      "memoir": 8,
      "character": 9,
      "emotional": 9,
      "mind": 8,
      "fast": 8,
      "standalone": 10,
      "modern": 9,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 508,
    "title": "The Silk Roads",
    "author": "Peter Frankopan",
    "publicationYear": 2015,
    "isbn": "1101912375",
    "googleBooksId": "placeholder508",
    "image": "https://books.google.com/books/content?id=juKXDgAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A new history of the world that reorients our understanding of civilization around the ancient trade routes between East and West.",
    "rating": 4.15,
    "ratingsCount": 37492,
    "pageCount": 636,
    "categories": [
      "History",
      "Non-Fiction",
      "World History"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 10,
      "mind": 10,
      "slow": 8,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6,
      "emotional": 6,
      "accessible": 7
    }
  },
  {
    "id": 509,
    "title": "Genghis Khan and the Making of the Modern World",
    "author": "Jack Weatherford",
    "publicationYear": 2004,
    "isbn": "0609809644",
    "googleBooksId": "placeholder509",
    "image": "https://books.google.com/books/content?id=56_DNcoTnSAC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A revelatory look at the Mongol emperor who conquered more territory than any other leader in history and revolutionized trade, communication, and religious tolerance.",
    "rating": 4.06,
    "ratingsCount": 83018,
    "pageCount": 312,
    "categories": [
      "History",
      "Biography",
      "Non-Fiction"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 10,
      "character": 9,
      "mind": 9,
      "medium": 7,
      "standalone": 10,
      "modern": 9,
      "plot": 5,
      "emotional": 6,
      "accessible": 7
    }
  },
  {
    "id": 511,
    "title": "The Fellowship of the Ring",
    "author": "J.R.R. Tolkien",
    "publicationYear": 1954,
    "isbn": "0547928211",
    "googleBooksId": "placeholder511",
    "image": "https://books.google.com/books/content?id=pVRUswEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Frodo Baggins inherits a mysterious ring and must journey to Mount Doom to destroy it before the Dark Lord Sauron can reclaim it. The beginning of the greatest fantasy epic.",
    "rating": 4.41,
    "ratingsCount": 3159749,
    "pageCount": 527,
    "awards": [
      "British Book Award Audiobook Fiction (2022)",
      "Publieksprijs voor het Nederlandse Boek (2002)"
    ],
    "categories": [
      "Fantasy",
      "Epic Fantasy",
      "Classic"
    ],
    "scores": {
      "fantasy": 10,
      "atmosphere": 10,
      "plot": 9,
      "character": 9,
      "slow": 8,
      "series": 10,
      "classic": 10,
      "emotional": 6,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 512,
    "title": "The Two Towers",
    "author": "J.R.R. Tolkien",
    "publicationYear": 1954,
    "isbn": "0547928203",
    "googleBooksId": "placeholder512",
    "image": "https://books.google.com/books/content?id=12e8PJ2T7sQC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The Fellowship is broken as Frodo and Sam continue toward Mordor while Aragorn, Legolas, and Gimli pursue the orcs. The epic journey continues.",
    "rating": 4.5,
    "ratingsCount": 1129406,
    "pageCount": 448,
    "categories": [
      "Fantasy",
      "Epic Fantasy",
      "Classic"
    ],
    "scores": {
      "fantasy": 10,
      "atmosphere": 10,
      "plot": 10,
      "character": 9,
      "medium": 8,
      "series": 10,
      "classic": 10,
      "emotional": 6,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 513,
    "title": "The Return of the King",
    "author": "J.R.R. Tolkien",
    "publicationYear": 1955,
    "isbn": "054792819X",
    "googleBooksId": "placeholder513",
    "image": "https://books.google.com/books/content?id=WZ0f_yUgc0UC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The final volume brings the War of the Ring to its epic conclusion as Frodo and Sam approach Mount Doom and Aragorn claims his birthright.",
    "rating": 4.58,
    "ratingsCount": 1044560,
    "pageCount": 432,
    "categories": [
      "Fantasy",
      "Epic Fantasy",
      "Classic"
    ],
    "scores": {
      "fantasy": 10,
      "atmosphere": 10,
      "plot": 10,
      "emotional": 10,
      "medium": 8,
      "series": 10,
      "classic": 10,
      "character": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 514,
    "title": "A Game of Thrones",
    "author": "George R.R. Martin",
    "publicationYear": 1996,
    "isbn": "0553588486",
    "googleBooksId": "placeholder514",
    "image": "https://books.google.com/books/content?id=WMyhtAEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Noble families vie for control of the Iron Throne while an ancient evil stirs in the north. The first book in the epic fantasy series that inspired HBO's phenomenon.",
    "rating": 4.45,
    "ratingsCount": 2740330,
    "pageCount": 835,
    "awards": [
      "Nebula Award Best Novel Nominee (1997)",
      "Locus Award Best Fantasy Novel (1997)",
      "World Fantasy Award Best Novel Nominee (1997)"
    ],
    "categories": [
      "Fantasy",
      "Epic Fantasy",
      "Political"
    ],
    "scores": {
      "fantasy": 10,
      "plot": 10,
      "dark": 9,
      "character": 10,
      "atmosphere": 10,
      "slow": 8,
      "series": 10,
      "modern": 9,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 515,
    "title": "Harry Potter and the Sorcerer's Stone",
    "author": "J.K. Rowling",
    "publicationYear": 1997,
    "isbn": "059035342X",
    "googleBooksId": "placeholder515",
    "image": "https://books.google.com/books/content?id=fo4rzdaHDAwC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "An orphan boy discovers he's a wizard on his eleventh birthday and enters the magical world of Hogwarts School. The book that launched a global phenomenon.",
    "rating": 4.47,
    "ratingsCount": 11446164,
    "pageCount": 333,
    "awards": [
      "British Book Award Children's Book of the Year (1998)",
      "Carnegie Medal (1997)",
      "Nestlé Smarties Book Prize (1997)",
      "Mythopoeic Fantasy Award Children's Literature (2008)"
    ],
    "categories": [
      "Fantasy",
      "Young Adult",
      "Magic"
    ],
    "scores": {
      "fantasy": 10,
      "plot": 9,
      "character": 9,
      "atmosphere": 10,
      "optimistic": 9,
      "fast": 8,
      "series": 10,
      "modern": 9,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 516,
    "title": "The Hunger Games",
    "author": "Suzanne Collins",
    "publicationYear": 2008,
    "isbn": "0439023483",
    "googleBooksId": "placeholder516",
    "image": "https://books.google.com/books/content?id=sJdUAzLUNyAC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In a dystopian future, Katniss Everdeen volunteers to take her sister's place in a televised fight to the death. A gripping tale of survival and revolution.",
    "rating": 4.35,
    "ratingsCount": 9941186,
    "pageCount": 374,
    "awards": [
      "Locus Award Best Young Adult Book (2009)",
      "Georgia Peach Book Award (2009)",
      "Golden Duck Award Young Adult (2009)"
    ],
    "categories": [
      "Fantasy",
      "Dystopian",
      "Young Adult"
    ],
    "scores": {
      "fantasy": 8,
      "scifi": 7,
      "plot": 10,
      "dark": 8,
      "character": 9,
      "fast": 10,
      "series": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 517,
    "title": "The Silence of the Lambs",
    "author": "Thomas Harris",
    "publicationYear": 1988,
    "isbn": "0312924585",
    "googleBooksId": "placeholder517",
    "image": "https://books.google.com/books/content?id=BnsEIfHd0W8C&printsec=frontcover&img=1&zoom=3",
    "synopsis": "FBI trainee Clarice Starling seeks help from imprisoned cannibal psychiatrist Hannibal Lecter to catch a serial killer. The psychological thriller that defined a generation.",
    "rating": 4.25,
    "ratingsCount": 586987,
    "pageCount": 338,
    "awards": [
      "Bram Stoker Award Best Novel (1988)"
    ],
    "categories": [
      "Thriller",
      "Mystery",
      "Psychological"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 9,
      "dark": 10,
      "character": 10,
      "plot": 10,
      "fast": 9,
      "series": 8,
      "classic": 8,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 518,
    "title": "The Girl Who Played with Fire",
    "author": "Stieg Larsson",
    "publicationYear": 2006,
    "isbn": "0307949508",
    "googleBooksId": "placeholder518",
    "image": "https://books.google.com/books/content?id=qf-MEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Lisbeth Salander is accused of murder and goes underground while Mikael Blomkvist investigates to clear her name. The explosive sequel to The Girl with the Dragon Tattoo.",
    "rating": 4.26,
    "ratingsCount": 987156,
    "pageCount": 503,
    "awards": [
      "Goodreads Choice Award Mystery & Thriller (2009)",
      "Anthony Award Nominee Best Novel (2010)"
    ],
    "categories": [
      "Thriller",
      "Mystery",
      "Crime"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 10,
      "dark": 9,
      "plot": 10,
      "character": 9,
      "medium": 7,
      "series": 10,
      "modern": 9,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 519,
    "title": "The Girl Who Kicked the Hornet's Nest",
    "author": "Stieg Larsson",
    "publicationYear": 2007,
    "isbn": "0307454568",
    "googleBooksId": "placeholder519",
    "image": "https://books.google.com/books/content?id=AZ5J6B1-4BoC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Lisbeth Salander fights to prove her innocence while exposing corruption at the highest levels of Swedish society. The stunning conclusion to the Millennium trilogy.",
    "rating": 4.23,
    "ratingsCount": 637535,
    "pageCount": 563,
    "awards": [
      "Goodreads Choice Award Nominee Mystery & Thriller (2010)"
    ],
    "categories": [
      "Thriller",
      "Mystery",
      "Crime"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 10,
      "dark": 9,
      "plot": 10,
      "character": 9,
      "medium": 7,
      "series": 10,
      "modern": 9,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 520,
    "title": "Angels & Demons",
    "author": "Dan Brown",
    "publicationYear": 2000,
    "isbn": "1416524797",
    "googleBooksId": "placeholder520",
    "image": "https://books.google.com/books/content?id=ENlhNnYhQEMC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Harvard symbologist Robert Langdon races against time to prevent a bomb from destroying Vatican City while uncovering secrets of the ancient Illuminati.",
    "rating": 3.95,
    "ratingsCount": 3393408,
    "pageCount": 736,
    "categories": [
      "Thriller",
      "Mystery",
      "Conspiracy"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 9,
      "plot": 10,
      "atmosphere": 8,
      "fast": 10,
      "series": 9,
      "modern": 9,
      "character": 5,
      "dark": 7,
      "accessible": 7
    }
  },
  {
    "id": 521,
    "title": "The Lovely Bones",
    "author": "Alice Sebold",
    "publicationYear": 2002,
    "isbn": "0316166685",
    "googleBooksId": "placeholder521",
    "image": "https://books.google.com/books/content?id=FpKGPwAACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A murdered teenager watches from her personal heaven as her family and friends struggle to move on. A unique perspective on grief, loss, and bonds that persist beyond death.",
    "rating": 3.86,
    "ratingsCount": 2464475,
    "pageCount": 372,
    "awards": [
      "Bram Stoker Award Best First Novel (2002)",
      "Orange Prize Fiction Longlist (2003)",
      "British Book Award Best Read of the Year (2004)",
      "Book Sense Book of the Year Award Adult Fiction (2003)",
      "California Book Award First Fiction Silver (2002)",
      "Chicago Tribune Heartland Prize Fiction (2002)"
    ],
    "categories": [
      "Thriller",
      "Literary Fiction",
      "Supernatural"
    ],
    "scores": {
      "thriller": 7,
      "literary": 9,
      "emotional": 10,
      "character": 9,
      "dark": 8,
      "medium": 7,
      "standalone": 10,
      "modern": 9,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 522,
    "title": "We Need to Talk About Kevin",
    "author": "Lionel Shriver",
    "publicationYear": 2003,
    "isbn": "0062119044",
    "googleBooksId": "placeholder522",
    "image": "https://books.google.com/books/content?id=mOaEZwEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A mother writes letters exploring her son's development and the events leading to his committing a school massacre. A devastating exploration of motherhood and evil.",
    "rating": 4.08,
    "ratingsCount": 207761,
    "pageCount": 400,
    "awards": [
      "Orange Prize for Fiction (2005)"
    ],
    "categories": [
      "Thriller",
      "Psychological",
      "Literary Fiction"
    ],
    "scores": {
      "thriller": 9,
      "literary": 10,
      "character": 10,
      "emotional": 10,
      "dark": 10,
      "slow": 7,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 523,
    "title": "World War Z",
    "author": "Max Brooks",
    "publicationYear": 2006,
    "isbn": "0307346617",
    "googleBooksId": "placeholder523",
    "image": "https://books.google.com/books/content?id=QefeRjRpXbAC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "An oral history of the global zombie apocalypse, told through interviews with survivors from around the world. A genre-defining work that reinvented zombie fiction.",
    "rating": 4.02,
    "ratingsCount": 567783,
    "pageCount": 342,
    "categories": [
      "Horror",
      "Science Fiction",
      "Apocalyptic"
    ],
    "scores": {
      "thriller": 8,
      "scifi": 7,
      "dark": 9,
      "plot": 9,
      "atmosphere": 9,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "character": 5,
      "accessible": 7
    }
  },
  {
    "id": 524,
    "title": "Gone with the Wind",
    "author": "Margaret Mitchell",
    "publicationYear": 1936,
    "isbn": "068483068X",
    "googleBooksId": "placeholder524",
    "image": "https://books.google.com/books/content?id=01KdDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Scarlett O'Hara navigates survival through the Civil War and Reconstruction, pursuing Ashley Wilkes while rejecting Rhett Butler. An epic of the American South.",
    "rating": 4.31,
    "ratingsCount": 1257932,
    "pageCount": 1037,
    "awards": [
      "Pulitzer Prize for Novel (1937)",
      "National Book Award for Novel (1936)"
    ],
    "categories": [
      "Historical Fiction",
      "Classic",
      "Romance"
    ],
    "scores": {
      "historical": 10,
      "classic": 10,
      "character": 10,
      "emotional": 10,
      "heart": 9,
      "slow": 8,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 525,
    "title": "Shantaram",
    "author": "Gregory David Roberts",
    "publicationYear": 2003,
    "series": {
      "name": "Shantaram",
      "position": 1
    },
    "isbn": "0312330537",
    "googleBooksId": "placeholder525",
    "image": "https://books.google.com/books/content?id=VdMFmq92Fa8C&printsec=frontcover&img=1&zoom=3",
    "synopsis": "An escaped convict flees to Bombay where he lives in a slum, works for the mafia, and fights for the mujahideen. Based on the author's extraordinary life.",
    "rating": 4.28,
    "ratingsCount": 240218,
    "pageCount": 936,
    "awards": [
      "Commonwealth Writers' Prize Best First Book Pacific Region (2004)"
    ],
    "categories": [
      "Historical Fiction",
      "Adventure",
      "Autobiography"
    ],
    "scores": {
      "historical": 7,
      "character": 10,
      "atmosphere": 10,
      "plot": 9,
      "emotional": 9,
      "slow": 8,
      "standalone": 10,
      "modern": 9,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 526,
    "title": "The Bronze Horseman",
    "author": "Paullina Simons",
    "publicationYear": 2000,
    "isbn": "006185414X",
    "googleBooksId": "placeholder526",
    "image": "https://books.google.com/books/content?id=SH7sligOwkkC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In WWII Leningrad, Tatiana falls in love with a Red Army officer during the brutal siege. An epic love story set against devastating historical events.",
    "rating": 4.29,
    "ratingsCount": 94773,
    "pageCount": 637,
    "categories": [
      "Historical Fiction",
      "Romance",
      "World War II"
    ],
    "scores": {
      "historical": 10,
      "heart": 10,
      "emotional": 10,
      "character": 10,
      "dark": 9,
      "slow": 8,
      "series": 10,
      "modern": 9,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 527,
    "title": "Fall of Giants",
    "author": "Ken Follett",
    "publicationYear": 2010,
    "isbn": "0451232852",
    "googleBooksId": "placeholder527",
    "image": "https://books.google.com/books/content?id=PWQBDAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Five families from different nations are swept up in World War I, the Russian Revolution, and the struggle for women's rights. The first in the Century Trilogy.",
    "rating": 4.33,
    "ratingsCount": 348076,
    "pageCount": 985,
    "categories": [
      "Historical Fiction",
      "World War I",
      "Epic"
    ],
    "scores": {
      "historical": 10,
      "plot": 10,
      "character": 9,
      "atmosphere": 9,
      "slow": 8,
      "series": 10,
      "modern": 10,
      "emotional": 6,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 529,
    "title": "2001: A Space Odyssey",
    "author": "Arthur C. Clarke",
    "publicationYear": 1968,
    "isbn": "0451457994",
    "googleBooksId": "placeholder529",
    "image": "https://books.google.com/books/content?id=Zb2NEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "When a mysterious monolith is discovered on the Moon, astronauts are sent to Saturn where HAL 9000 begins to malfunction. A landmark of science fiction.",
    "rating": 4.18,
    "ratingsCount": 336708,
    "pageCount": 297,
    "awards": [
      "Hugo Award Nominee Best Novel (1969)"
    ],
    "categories": [
      "Science Fiction",
      "Classic",
      "Space"
    ],
    "scores": {
      "scifi": 10,
      "mind": 10,
      "atmosphere": 9,
      "plot": 9,
      "slow": 7,
      "series": 8,
      "classic": 10,
      "character": 5,
      "emotional": 6,
      "accessible": 7
    }
  },
  {
    "id": 530,
    "title": "Do Androids Dream of Electric Sheep?",
    "author": "Philip K. Dick",
    "publicationYear": 1968,
    "isbn": "0345404475",
    "googleBooksId": "placeholder530",
    "image": "https://books.google.com/books/content?id=3vExWrUnJB0C&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In a post-apocalyptic future, bounty hunter Rick Deckard must retire six escaped androids while questioning what makes us human. The inspiration for Blade Runner.",
    "rating": 4.08,
    "ratingsCount": 255386,
    "pageCount": 210,
    "awards": [
      "Nebula Award Nominee Best Novel (1968)"
    ],
    "categories": [
      "Science Fiction",
      "Dystopian",
      "Philosophy"
    ],
    "scores": {
      "scifi": 10,
      "mind": 10,
      "dark": 8,
      "atmosphere": 9,
      "character": 8,
      "medium": 7,
      "standalone": 10,
      "classic": 9,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 531,
    "title": "I, Robot",
    "author": "Isaac Asimov",
    "publicationYear": 1950,
    "series": {
      "name": "Robot",
      "position": 0.1
    },
    "isbn": "0553294385",
    "googleBooksId": "placeholder531",
    "image": "https://books.google.com/books/content?id=Lf6NEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Nine interconnected stories explore the relationship between humans and robots, introducing the famous Three Laws of Robotics that influenced the genre for decades.",
    "rating": 4.21,
    "ratingsCount": 379989,
    "pageCount": 224,
    "categories": [
      "Science Fiction",
      "Classic",
      "Robots"
    ],
    "scores": {
      "scifi": 10,
      "mind": 10,
      "plot": 9,
      "medium": 7,
      "standalone": 10,
      "classic": 10,
      "character": 5,
      "emotional": 6,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 532,
    "title": "Dune Messiah",
    "author": "Frank Herbert",
    "publicationYear": 1969,
    "isbn": "0593098234",
    "googleBooksId": "placeholder532",
    "image": "https://books.google.com/books/content?id=uryWDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Paul Atreides has become Muad'Dib, but the price of prescience and power threatens everything he loves. The complex sequel to the original masterpiece.",
    "rating": 3.89,
    "ratingsCount": 405768,
    "pageCount": 329,
    "categories": [
      "Science Fiction",
      "Epic",
      "Philosophy"
    ],
    "scores": {
      "scifi": 10,
      "mind": 10,
      "plot": 8,
      "atmosphere": 9,
      "character": 9,
      "medium": 7,
      "series": 10,
      "classic": 9,
      "emotional": 6,
      "accessible": 7
    }
  },
  {
    "id": 533,
    "title": "The Time Machine",
    "author": "H.G. Wells",
    "publicationYear": 1895,
    "isbn": "0486284727",
    "googleBooksId": "placeholder533",
    "image": "https://books.google.com/books/content?id=51aMCgAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A scientist builds a time machine and travels to the year 802,701 AD, where humanity has evolved into two distinct species. The novella that invented modern time travel fiction.",
    "rating": 3.9,
    "ratingsCount": 486520,
    "pageCount": 118,
    "categories": [
      "Science Fiction",
      "Classic",
      "Novella"
    ],
    "scores": {
      "scifi": 10,
      "mind": 9,
      "plot": 9,
      "atmosphere": 8,
      "fast": 9,
      "standalone": 10,
      "classic": 10,
      "character": 5,
      "emotional": 6,
      "accessible": 7
    }
  },
  {
    "id": 534,
    "title": "The War of the Worlds",
    "author": "H.G. Wells",
    "publicationYear": 1898,
    "isbn": "0486295060",
    "googleBooksId": "placeholder534",
    "image": "https://books.google.com/books/content?id=1HoBYmku9uQC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Martians invade Victorian England with devastating heat-rays and tripod fighting machines. A pioneering work of science fiction that remains thrillingly relevant.",
    "rating": 3.84,
    "ratingsCount": 282578,
    "pageCount": 192,
    "categories": [
      "Science Fiction",
      "Classic",
      "Invasion"
    ],
    "scores": {
      "scifi": 10,
      "plot": 10,
      "atmosphere": 9,
      "dark": 8,
      "fast": 8,
      "standalone": 10,
      "classic": 10,
      "character": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 536,
    "title": "Bossypants",
    "author": "Tina Fey",
    "publicationYear": 2011,
    "isbn": "0316056863",
    "googleBooksId": "placeholder536",
    "image": "https://books.google.com/books/content?id=7HY4ngEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "From her childhood in Pennsylvania to SNL and 30 Rock, Tina Fey shares hilarious stories and hard-won wisdom about life as a woman in comedy.",
    "rating": 3.97,
    "ratingsCount": 911794,
    "pageCount": 277,
    "awards": [
      "Goodreads Choice Award Humor (2011)",
      "Audie Award Audiobook of the Year (2012)"
    ],
    "categories": [
      "Memoir",
      "Comedy",
      "Biography"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 9,
      "character": 9,
      "optimistic": 9,
      "fast": 9,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 537,
    "title": "Year of Yes",
    "author": "Shonda Rhimes",
    "publicationYear": 2015,
    "isbn": "1476777128",
    "googleBooksId": "placeholder537",
    "image": "https://books.google.com/books/content?id=_l79DAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The creator of Grey's Anatomy and Scandal chronicles her year of saying yes to everything that scared her. A story of transformation and embracing vulnerability.",
    "rating": 4.04,
    "ratingsCount": 80339,
    "pageCount": 336,
    "categories": [
      "Memoir",
      "Self-Help",
      "Inspiration"
    ],
    "scores": {
      "memoir": 10,
      "selfhelp": 8,
      "nonfiction": 9,
      "optimistic": 9,
      "character": 8,
      "fast": 8,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 538,
    "title": "Between the World and Me",
    "author": "Ta-Nehisi Coates",
    "publicationYear": 2015,
    "isbn": "0812993543",
    "googleBooksId": "placeholder538",
    "image": "https://books.google.com/books/content?id=YoGJDQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Written as a letter to his son, Coates explores what it means to inhabit a Black body in America. Winner of the National Book Award, a powerful meditation on race.",
    "rating": 4.4,
    "ratingsCount": 363589,
    "pageCount": 176,
    "awards": [
      "National Book Award Nonfiction (2015)",
      "Kirkus Prize Nonfiction (2015)"
    ],
    "categories": [
      "Memoir",
      "Non-Fiction",
      "Social Issues"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "mind": 10,
      "emotional": 10,
      "literary": 9,
      "fast": 9,
      "standalone": 10,
      "modern": 10,
      "character": 8,
      "plot": 5
    }
  },
  {
    "id": 540,
    "title": "Mythology: Timeless Tales of Gods and Heroes",
    "author": "Edith Hamilton",
    "publicationYear": 1942,
    "isbn": "0446574759",
    "googleBooksId": "placeholder540",
    "image": "https://books.google.com/books/content?id=LcduswEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The classic encyclopedia of Greek, Roman, and Norse mythology. Hamilton brings ancient gods and heroes to life in this beloved guide that has inspired readers for decades.",
    "rating": 4.03,
    "ratingsCount": 46299,
    "pageCount": 497,
    "categories": [
      "Mythology",
      "Classic",
      "Nonfiction"
    ],
    "scores": {
      "classic": 10,
      "nonfiction": 9,
      "mind": 9,
      "atmosphere": 8,
      "literary": 8,
      "standalone": 10,
      "medium": 7,
      "slow": 5,
      "character": 8,
      "plot": 5,
      "emotional": 6
    }
  },
  {
    "id": 541,
    "title": "The Prophet",
    "author": "Kahlil Gibran",
    "publicationYear": 1923,
    "isbn": "0394404289",
    "googleBooksId": "placeholder541",
    "image": "https://books.google.com/books/content?id=wmWNEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A wise man shares profound observations on love, marriage, children, work, joy, and sorrow. A spiritual classic that has sold millions worldwide.",
    "rating": 4.23,
    "ratingsCount": 329792,
    "pageCount": 107,
    "categories": [
      "Philosophy",
      "Poetry",
      "Spirituality"
    ],
    "scores": {
      "literary": 10,
      "mind": 10,
      "emotional": 9,
      "optimistic": 9,
      "fast": 9,
      "classic": 10,
      "standalone": 10,
      "character": 8,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 542,
    "title": "Persuasion",
    "author": "Jane Austen",
    "publicationYear": 1817,
    "isbn": "0141439688",
    "googleBooksId": "placeholder542",
    "image": "https://books.google.com/books/content?id=feYi2K3hpZ0C&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Anne Elliot, at 27 considered a spinster, is reunited with Captain Wentworth whom she rejected years ago. Austen's last completed novel explores second chances at love.",
    "rating": 4.15,
    "ratingsCount": 772268,
    "pageCount": 249,
    "categories": [
      "Classic Literature",
      "Romance",
      "Regency"
    ],
    "scores": {
      "classic": 10,
      "literary": 9,
      "heart": 10,
      "character": 10,
      "emotional": 9,
      "medium": 7,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 543,
    "title": "Sense and Sensibility",
    "author": "Jane Austen",
    "publicationYear": 1811,
    "isbn": "0141439661",
    "googleBooksId": "placeholder543",
    "image": "https://books.google.com/books/content?id=P2h8CtM-pFEC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Sisters Elinor and Marianne Dashwood represent sense and sensibility as they navigate love, loss, and society after their father's death.",
    "rating": 4.09,
    "ratingsCount": 1290067,
    "pageCount": 409,
    "categories": [
      "Classic Literature",
      "Romance",
      "Regency"
    ],
    "scores": {
      "classic": 10,
      "literary": 9,
      "heart": 10,
      "character": 10,
      "emotional": 8,
      "medium": 7,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 544,
    "title": "Emma",
    "author": "Jane Austen",
    "publicationYear": 1815,
    "isbn": "0141439580",
    "googleBooksId": "placeholder544",
    "image": "https://books.google.com/books/content?id=v2XRDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Emma Woodhouse, handsome, clever, and rich, amuses herself by matchmaking while remaining blind to matters of her own heart.",
    "rating": 4.05,
    "ratingsCount": 986019,
    "pageCount": 474,
    "categories": [
      "Classic Literature",
      "Romance",
      "Comedy"
    ],
    "scores": {
      "classic": 10,
      "literary": 9,
      "heart": 9,
      "character": 10,
      "optimistic": 8,
      "medium": 7,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 545,
    "title": "The Age of Innocence",
    "author": "Edith Wharton",
    "publicationYear": 1920,
    "isbn": "0553214500",
    "googleBooksId": "placeholder545",
    "image": "https://books.google.com/books/content?id=6fdvDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Newland Archer is engaged to the perfect society wife when her scandalous cousin awakens his passions. A Pulitzer Prize-winning portrait of Gilded Age New York.",
    "rating": 4.02,
    "ratingsCount": 159666,
    "pageCount": 305,
    "awards": [
      "Pulitzer Prize Fiction (1921)"
    ],
    "categories": [
      "Classic Literature",
      "Historical Fiction",
      "Romance"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "historical": 9,
      "heart": 9,
      "character": 10,
      "slow": 7,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 546,
    "title": "The House of Mirth",
    "author": "Edith Wharton",
    "publicationYear": 1905,
    "isbn": "0451527569",
    "googleBooksId": "placeholder546",
    "image": "https://books.google.com/books/content?id=-T3mzQEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Lily Bart navigates New York high society seeking a wealthy husband while her beauty fades. A devastating critique of wealth, class, and women's limited choices.",
    "rating": 3.98,
    "ratingsCount": 105429,
    "pageCount": 329,
    "categories": [
      "Classic Literature",
      "Literary Fiction",
      "Social Commentary"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 10,
      "emotional": 10,
      "dark": 9,
      "slow": 7,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 549,
    "title": "A Farewell to Arms",
    "author": "Ernest Hemingway",
    "publicationYear": 1929,
    "isbn": "0684801469",
    "googleBooksId": "placeholder549",
    "image": "https://books.google.com/books/content?id=288OEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "An American ambulance driver in WWI Italy falls in love with a British nurse. Hemingway's semi-autobiographical novel is a devastating portrait of love and war.",
    "rating": 3.82,
    "ratingsCount": 354027,
    "pageCount": 332,
    "categories": [
      "Classic Literature",
      "War Fiction",
      "Romance"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "historical": 9,
      "heart": 9,
      "emotional": 10,
      "dark": 9,
      "medium": 7,
      "standalone": 10,
      "character": 8,
      "plot": 5
    }
  },
  {
    "id": 550,
    "title": "For Whom the Bell Tolls",
    "author": "Ernest Hemingway",
    "publicationYear": 1940,
    "isbn": "0684803356",
    "googleBooksId": "placeholder550",
    "image": "https://books.google.com/books/content?id=uXZjEQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "An American volunteer joins a guerrilla band in the Spanish Civil War with orders to blow up a bridge. An epic tale of love, death, and the nobility of sacrifice.",
    "rating": 3.99,
    "ratingsCount": 318865,
    "pageCount": 471,
    "awards": [
      "Pulitzer Prize Finalist Fiction (1941)"
    ],
    "categories": [
      "Classic Literature",
      "War Fiction",
      "Historical Fiction"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "historical": 10,
      "emotional": 10,
      "dark": 9,
      "slow": 8,
      "standalone": 10,
      "character": 8,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 551,
    "title": "The Old Man and the Sea",
    "author": "Ernest Hemingway",
    "publicationYear": 1952,
    "isbn": "0684801221",
    "googleBooksId": "placeholder551",
    "image": "http://books.google.com/books/content?id=0rUwAQAAMAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "An aging Cuban fisherman's epic struggle with a giant marlin far out in the Gulf Stream. Hemingway's Nobel Prize-winning novella about courage and defeat.",
    "rating": 3.81,
    "ratingsCount": 1317527,
    "pageCount": 127,
    "awards": [
      "Pulitzer Prize Fiction (1953)",
      "Nobel Prize in Literature (1954)"
    ],
    "categories": [
      "Classic Literature",
      "Novella",
      "Adventure"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 9,
      "emotional": 9,
      "atmosphere": 9,
      "fast": 8,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 552,
    "title": "Invisible Man",
    "author": "Ralph Ellison",
    "publicationYear": 1952,
    "isbn": "0679732764",
    "googleBooksId": "placeholder552",
    "image": "https://books.google.com/books/content?id=foSLDQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "An unnamed Black narrator recounts his journey from the South to Harlem, invisible to those who refuse to see him. A landmark of American literature on race and identity.",
    "rating": 3.92,
    "ratingsCount": 187844,
    "pageCount": 581,
    "awards": [
      "National Book Award Fiction (1953)"
    ],
    "categories": [
      "Classic Literature",
      "Literary Fiction",
      "African American"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 10,
      "mind": 10,
      "emotional": 9,
      "slow": 8,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 553,
    "title": "Their Eyes Were Watching God",
    "author": "Zora Neale Hurston",
    "publicationYear": 1937,
    "isbn": "0061120065",
    "googleBooksId": "placeholder553",
    "image": "https://books.google.com/books/content?id=Gz-d8SIFAcgC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Janie Crawford tells her friend about her life and three marriages in the rural South. A luminous celebration of Black womanhood, self-discovery, and love.",
    "rating": 3.99,
    "ratingsCount": 387077,
    "pageCount": 219,
    "categories": [
      "Classic Literature",
      "Literary Fiction",
      "Harlem Renaissance"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 10,
      "heart": 10,
      "emotional": 10,
      "medium": 7,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 554,
    "title": "Stoner",
    "author": "John Williams",
    "publicationYear": 1965,
    "isbn": "1590171993",
    "googleBooksId": "placeholder554",
    "image": "https://books.google.com/books/content?id=fvlHAgAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The unremarkable life of a Missouri farm boy who becomes a university professor, told with quiet devastation. A rediscovered masterpiece about the dignity of ordinary life.",
    "rating": 4.36,
    "ratingsCount": 193482,
    "pageCount": 278,
    "categories": [
      "Literary Fiction",
      "Classic",
      "Academic"
    ],
    "scores": {
      "literary": 10,
      "character": 10,
      "emotional": 10,
      "slow": 8,
      "dark": 7,
      "classic": 9,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 555,
    "title": "Butcher's Crossing",
    "author": "John Williams",
    "publicationYear": 1960,
    "isbn": "1590171985",
    "googleBooksId": "placeholder555",
    "image": "https://books.google.com/books/content?id=D_lHAgAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A Harvard dropout heads west seeking nature, joining a buffalo hunting expedition that turns into a harrowing ordeal. An anti-Western that dismantles frontier mythology.",
    "rating": 4.18,
    "ratingsCount": 27357,
    "pageCount": 274,
    "categories": [
      "Literary Fiction",
      "Western",
      "Historical Fiction"
    ],
    "scores": {
      "literary": 10,
      "historical": 8,
      "dark": 9,
      "atmosphere": 10,
      "character": 9,
      "medium": 7,
      "standalone": 10,
      "plot": 5,
      "classic": 8,
      "modern": 3
    }
  },
  {
    "id": 556,
    "title": "Augustus",
    "author": "John Williams",
    "publicationYear": 1972,
    "isbn": "1590178211",
    "googleBooksId": "placeholder556",
    "image": "https://books.google.com/books/content?id=7VmJDQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The life of Rome's first emperor told through letters, memoirs, and dispatches. Winner of the National Book Award, an intimate portrait of absolute power.",
    "rating": 4.25,
    "ratingsCount": 19187,
    "pageCount": 305,
    "awards": [
      "National Book Award Fiction (1973)"
    ],
    "categories": [
      "Historical Fiction",
      "Literary Fiction",
      "Roman History"
    ],
    "scores": {
      "historical": 10,
      "literary": 10,
      "character": 10,
      "mind": 9,
      "slow": 7,
      "standalone": 10,
      "classic": 8,
      "plot": 5,
      "emotional": 6,
      "accessible": 7
    }
  },
  {
    "id": 557,
    "title": "The Rules of Civility",
    "author": "Amor Towles",
    "publicationYear": 2011,
    "series": {
      "name": "Rules of Civility",
      "position": 1
    },
    "isbn": "0143121162",
    "googleBooksId": "placeholder557",
    "image": "https://books.google.com/books/content?id=gUACDAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In 1938 New York, a chance encounter changes the life of Katey Kontent as she navigates love, friendship, and ambition in the city that never sleeps.",
    "rating": 4.09,
    "ratingsCount": 265979,
    "pageCount": 335,
    "categories": [
      "Historical Fiction",
      "Literary Fiction",
      "Romance"
    ],
    "scores": {
      "historical": 9,
      "literary": 9,
      "character": 10,
      "heart": 8,
      "atmosphere": 9,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 558,
    "title": "The Talisman",
    "author": "Stephen King and Peter Straub",
    "publicationYear": 1984,
    "isbn": "1501192272",
    "googleBooksId": "placeholder558",
    "image": "https://books.google.com/books/content?id=61H6yQEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A twelve-year-old boy travels across America and its dark fantasy parallel world to find a magical talisman that can save his dying mother.",
    "rating": 4.11,
    "ratingsCount": 141516,
    "pageCount": 646,
    "awards": [
      "Locus Award Nominee Fantasy Novel (1985)"
    ],
    "categories": [
      "Fantasy",
      "Horror",
      "Adventure"
    ],
    "scores": {
      "fantasy": 10,
      "dark": 8,
      "plot": 9,
      "atmosphere": 10,
      "character": 9,
      "slow": 7,
      "series": 8,
      "classic": 7,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 559,
    "title": "A Prayer for Owen Meany",
    "author": "John Irving",
    "publicationYear": 1989,
    "isbn": "0062204092",
    "googleBooksId": "placeholder559",
    "image": "https://books.google.com/books/content?id=qzuRvgEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A boy with a wrecked voice believes he is God's instrument and knows the exact date and circumstances of his death. A novel of faith, friendship, and fate.",
    "rating": 4.24,
    "ratingsCount": 327007,
    "pageCount": 617,
    "categories": [
      "Literary Fiction",
      "Coming-of-Age"
    ],
    "scores": {
      "literary": 10,
      "character": 10,
      "emotional": 10,
      "heart": 10,
      "slow": 8,
      "mind": 8,
      "standalone": 10,
      "plot": 5,
      "classic": 5,
      "modern": 7
    }
  },
  {
    "id": 560,
    "title": "The World According to Garp",
    "author": "John Irving",
    "publicationYear": 1978,
    "isbn": "0345418018",
    "googleBooksId": "placeholder560",
    "image": "https://books.google.com/books/content?id=9biC_GdHAaoC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The life and times of T.S. Garp, novelist and son of an unmarried feminist icon. A wildly inventive and darkly comic exploration of violence, sexuality, and art.",
    "rating": 4.11,
    "ratingsCount": 237616,
    "pageCount": 609,
    "awards": [
      "National Book Award Fiction (1980)"
    ],
    "categories": [
      "Literary Fiction",
      "Satire",
      "Coming-of-Age"
    ],
    "scores": {
      "literary": 10,
      "character": 10,
      "dark": 8,
      "emotional": 9,
      "mind": 8,
      "slow": 7,
      "standalone": 10,
      "classic": 8,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 561,
    "title": "American Psycho",
    "author": "Bret Easton Ellis",
    "publicationYear": 1991,
    "isbn": "0679735771",
    "googleBooksId": "placeholder561",
    "image": "https://books.google.com/books/content?id=utyJDQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Patrick Bateman is a wealthy Manhattan investment banker hiding his violent psychopathic alter ego. A controversial satire of yuppie greed and superficiality.",
    "rating": 3.81,
    "ratingsCount": 340344,
    "pageCount": 399,
    "categories": [
      "Horror",
      "Thriller",
      "Satire"
    ],
    "scores": {
      "thriller": 10,
      "dark": 10,
      "literary": 9,
      "character": 9,
      "contemporary": 9,
      "fast": 8,
      "standalone": 10,
      "modern": 9,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 562,
    "title": "The Passage",
    "author": "Justin Cronin",
    "publicationYear": 2010,
    "isbn": "0345528174",
    "googleBooksId": "placeholder562",
    "image": "https://books.google.com/books/content?id=hkWTEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A government experiment with a virus creates vampire-like creatures that devastate civilization. A sweeping post-apocalyptic epic spanning a century.",
    "rating": 4.05,
    "ratingsCount": 223427,
    "pageCount": 766,
    "categories": [
      "Horror",
      "Science Fiction",
      "Post-Apocalyptic"
    ],
    "scores": {
      "scifi": 8,
      "thriller": 9,
      "dark": 10,
      "plot": 10,
      "atmosphere": 10,
      "slow": 8,
      "series": 10,
      "modern": 10,
      "character": 5,
      "accessible": 7
    }
  },
  {
    "id": 563,
    "title": "Bird Box",
    "author": "Josh Malerman",
    "publicationYear": 2014,
    "series": {
      "name": "Bird Box",
      "position": 1
    },
    "isbn": "0062259660",
    "googleBooksId": "placeholder563",
    "image": "https://books.google.com/books/content?id=gRnjoAEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A mother and two children must make a journey blindfolded through a post-apocalyptic world where seeing means death. A tense and terrifying survival story.",
    "rating": 4.05,
    "ratingsCount": 210845,
    "pageCount": 262,
    "categories": [
      "Horror",
      "Thriller",
      "Post-Apocalyptic"
    ],
    "scores": {
      "thriller": 10,
      "dark": 10,
      "atmosphere": 10,
      "plot": 9,
      "fast": 9,
      "standalone": 10,
      "modern": 10,
      "character": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 564,
    "title": "The Road to Serfdom",
    "author": "Friedrich Hayek",
    "publicationYear": 1944,
    "isbn": "0226320553",
    "googleBooksId": "placeholder564",
    "image": "https://books.google.com/books/content?id=Sz6GAQAACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A classic warning against the dangers of central planning and the erosion of individual freedom. One of the most influential political books of the 20th century.",
    "rating": 4.14,
    "ratingsCount": 19560,
    "pageCount": 274,
    "categories": [
      "Non-Fiction",
      "Economics",
      "Political Philosophy"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 10,
      "classic": 9,
      "slow": 7,
      "standalone": 10,
      "character": 7,
      "plot": 6,
      "emotional": 6,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 566,
    "title": "A Clockwork Orange",
    "author": "Anthony Burgess",
    "publicationYear": 1962,
    "isbn": "0393312836",
    "googleBooksId": "placeholder566",
    "image": "https://books.google.com/books/content?id=SKp0BqzoaP8C&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In a dystopian future, violent teenager Alex undergoes experimental rehabilitation. A darkly satirical exploration of free will, violence, and the nature of evil.",
    "rating": 4,
    "ratingsCount": 771585,
    "pageCount": 192,
    "categories": [
      "Classic Literature",
      "Dystopian",
      "Science Fiction"
    ],
    "scores": {
      "classic": 10,
      "scifi": 8,
      "literary": 10,
      "dark": 10,
      "mind": 10,
      "fast": 8,
      "standalone": 10,
      "character": 8,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 567,
    "title": "One Flew Over the Cuckoo's Nest",
    "author": "Ken Kesey",
    "publicationYear": 1962,
    "isbn": "0451163966",
    "googleBooksId": "placeholder567",
    "image": "https://books.google.com/books/content?id=ZWhgAN9pHBgC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A charming rogue challenges the authoritarian Nurse Ratched in a mental institution. A powerful exploration of individuality versus institutional control.",
    "rating": 4.2,
    "ratingsCount": 780760,
    "pageCount": 325,
    "categories": [
      "Classic Literature",
      "Literary Fiction",
      "Psychological"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 10,
      "emotional": 10,
      "dark": 9,
      "medium": 7,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 568,
    "title": "Lonesome Dove",
    "author": "Larry McMurtry",
    "publicationYear": 1985,
    "isbn": "1439195269",
    "googleBooksId": "placeholder568",
    "image": "https://books.google.com/books/content?id=GXYH1C_esq0C&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Two former Texas Rangers drive a cattle herd from Texas to Montana. A Pulitzer Prize-winning epic of the American West and enduring friendship.",
    "rating": 4.58,
    "ratingsCount": 243305,
    "pageCount": 843,
    "awards": [
      "Pulitzer Prize Fiction (1986)"
    ],
    "categories": [
      "Historical Fiction",
      "Western",
      "Literary Fiction"
    ],
    "scores": {
      "historical": 10,
      "literary": 10,
      "character": 10,
      "atmosphere": 10,
      "emotional": 10,
      "slow": 9,
      "series": 9,
      "classic": 9,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 569,
    "title": "The Corrections",
    "author": "Jonathan Franzen",
    "publicationYear": 2001,
    "isbn": "0312421273",
    "googleBooksId": "placeholder569",
    "image": "https://books.google.com/books/content?id=3SETVDEO45AC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The Lambert family faces dysfunction, ambition, and the weight of expectations as they prepare for one final Christmas together. A sweeping American family saga.",
    "rating": 3.84,
    "ratingsCount": 186418,
    "pageCount": 568,
    "awards": [
      "National Book Award Fiction (2001)",
      "James Tait Black Memorial Prize Fiction (2002)"
    ],
    "categories": [
      "Literary Fiction",
      "Family Saga",
      "Contemporary"
    ],
    "scores": {
      "literary": 10,
      "character": 10,
      "emotional": 9,
      "dark": 7,
      "contemporary": 10,
      "slow": 8,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 570,
    "title": "Norwegian Wood",
    "author": "Haruki Murakami",
    "publicationYear": 1987,
    "isbn": "0375704027",
    "googleBooksId": "placeholder570",
    "image": "https://books.google.com/books/content?id=6QePDQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In 1960s Tokyo, Toru Watanabe navigates the loss of his best friend and his feelings for two very different women. A nostalgic story of love and melancholy.",
    "rating": 3.99,
    "ratingsCount": 732546,
    "pageCount": 296,
    "categories": [
      "Literary Fiction",
      "Japanese Literature",
      "Romance"
    ],
    "scores": {
      "literary": 10,
      "character": 10,
      "emotional": 10,
      "heart": 9,
      "atmosphere": 9,
      "slow": 8,
      "standalone": 10,
      "modern": 9,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 571,
    "title": "Blood Meridian",
    "author": "Cormac McCarthy",
    "publicationYear": 1985,
    "isbn": "0679728759",
    "googleBooksId": "placeholder571",
    "image": "https://books.google.com/books/content?id=_2KKDQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A teenage runaway joins a gang of scalp hunters in the Mexican-American borderlands. McCarthy's most violent and philosophical work explores the nature of evil.",
    "rating": 4.17,
    "ratingsCount": 187527,
    "pageCount": 351,
    "categories": [
      "Literary Fiction",
      "Western",
      "Historical Fiction"
    ],
    "scores": {
      "literary": 10,
      "historical": 9,
      "dark": 10,
      "atmosphere": 10,
      "mind": 10,
      "slow": 8,
      "standalone": 10,
      "classic": 9,
      "character": 8,
      "plot": 5
    }
  },
  {
    "id": 572,
    "title": "White Teeth",
    "author": "Zadie Smith",
    "publicationYear": 2000,
    "isbn": "0375703861",
    "googleBooksId": "placeholder572",
    "image": "http://books.google.com/books/content?id=BJtud-Wbt9YC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Two London families navigate race, identity, and faith across generations. A dazzling debut exploring multicultural Britain with wit and compassion.",
    "rating": 3.8,
    "ratingsCount": 147982,
    "pageCount": 448,
    "awards": [
      "James Tait Black Memorial Prize Fiction (2000)",
      "Whitbread First Novel Award (2000)",
      "Guardian First Book Award (2000)"
    ],
    "categories": [
      "Literary Fiction",
      "Contemporary",
      "Multicultural"
    ],
    "scores": {
      "literary": 10,
      "character": 10,
      "contemporary": 10,
      "emotional": 8,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 573,
    "title": "Infinite Jest",
    "author": "David Foster Wallace",
    "publicationYear": 1996,
    "isbn": "0316066524",
    "googleBooksId": "placeholder573",
    "image": "https://books.google.com/books/content?id=G1mXngEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Set in a near-future America, this massive novel interweaves tennis, addiction, entertainment, and despair. A challenging but rewarding literary landmark.",
    "rating": 4.25,
    "ratingsCount": 101487,
    "pageCount": 1088,
    "categories": [
      "Literary Fiction",
      "Postmodern",
      "Science Fiction"
    ],
    "scores": {
      "literary": 10,
      "scifi": 6,
      "mind": 10,
      "character": 10,
      "dark": 8,
      "slow": 10,
      "standalone": 10,
      "modern": 9,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 574,
    "title": "The Wind-Up Bird Chronicle",
    "author": "Haruki Murakami",
    "publicationYear": 1994,
    "isbn": "0679775439",
    "googleBooksId": "placeholder574",
    "image": "https://books.google.com/books/content?id=iTt3WN2U8wwC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Toru Okada's search for his missing cat leads him into a surreal underworld of memory, history, and the unconscious. Murakami's most acclaimed work.",
    "rating": 4.16,
    "ratingsCount": 247913,
    "pageCount": 607,
    "awards": [
      "Yomiuri Literary Award (1995)"
    ],
    "categories": [
      "Literary Fiction",
      "Magical Realism",
      "Japanese Literature"
    ],
    "scores": {
      "literary": 10,
      "fantasy": 7,
      "atmosphere": 10,
      "mind": 10,
      "character": 9,
      "slow": 9,
      "standalone": 10,
      "modern": 9,
      "plot": 5,
      "emotional": 6
    }
  },
  {
    "id": 575,
    "title": "The Sound and the Fury",
    "author": "William Faulkner",
    "publicationYear": 1929,
    "isbn": "0679732241",
    "googleBooksId": "placeholder575",
    "image": "https://books.google.com/books/content?id=_luMDQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The decline of a Southern aristocratic family told through four distinct perspectives. Faulkner's masterpiece of stream-of-consciousness narrative.",
    "rating": 3.86,
    "ratingsCount": 196413,
    "pageCount": 326,
    "categories": [
      "Classic Literature",
      "Literary Fiction",
      "Southern Gothic"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 10,
      "emotional": 10,
      "dark": 9,
      "slow": 9,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 576,
    "title": "The Color of Magic",
    "author": "Terry Pratchett",
    "publicationYear": 1983,
    "isbn": "0062225677",
    "googleBooksId": "placeholder576",
    "image": "https://books.google.com/books/content?id=f7VsAQAACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The first adventure on Discworld, a flat world balanced on the backs of four elephants standing on a giant turtle. A hilarious parody of fantasy conventions.",
    "rating": 3.99,
    "ratingsCount": 419210,
    "pageCount": 288,
    "categories": [
      "Fantasy",
      "Comedy",
      "Satire"
    ],
    "scores": {
      "fantasy": 10,
      "optimistic": 9,
      "plot": 8,
      "atmosphere": 9,
      "fast": 8,
      "series": 10,
      "modern": 8,
      "character": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 577,
    "title": "The Mercy of Gods",
    "author": "James S. A. Corey",
    "publicationYear": 2024,
    "isbn": "031652557X",
    "googleBooksId": "placeholder577",
    "image": "https://books.google.com/books/content?id=hWRV0AEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "When the all-powerful alien Carryx conquer a human-settled world, research scientist Dafyd Alkhor must navigate life under alien rule.",
    "rating": 4.16,
    "ratingsCount": 36477,
    "pageCount": 432,
    "categories": [
      "Science Fiction",
      "Space Opera"
    ],
    "scores": {
      "scifi": 10,
      "thriller": 7,
      "character": 8,
      "fast": 8,
      "dark": 7,
      "plot": 9,
      "series": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 578,
    "title": "Some Desperate Glory",
    "author": "Emily Tesh",
    "publicationYear": 2023,
    "isbn": "1250834988",
    "googleBooksId": "placeholder578",
    "image": "https://books.google.com/books/content?id=nHBpEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Seventeen-year-old Kyr has trained her whole life on a hidden space station to avenge Earth's destruction.",
    "rating": 4.05,
    "ratingsCount": 19253,
    "pageCount": 439,
    "awards": [
      "Hugo Award Best Novel (2024)"
    ],
    "categories": [
      "Science Fiction",
      "Space Opera"
    ],
    "scores": {
      "scifi": 10,
      "thriller": 8,
      "character": 9,
      "fast": 9,
      "dark": 8,
      "plot": 9,
      "standalone": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 579,
    "title": "Shards of Earth",
    "author": "Adrian Tchaikovsky",
    "publicationYear": 2021,
    "isbn": "0316705845",
    "googleBooksId": "placeholder579",
    "image": "https://books.google.com/books/content?id=l--LzgEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Eighty years ago, Earth was destroyed by godlike alien Architects. Humanity created Intermediaries who could communicate with the enemy.",
    "rating": 4.18,
    "ratingsCount": 33859,
    "pageCount": 557,
    "awards": [
      "British Science Fiction Association Award Best Novel (2021)"
    ],
    "categories": [
      "Science Fiction",
      "Space Opera"
    ],
    "scores": {
      "scifi": 10,
      "thriller": 8,
      "character": 8,
      "medium": 7,
      "dark": 7,
      "plot": 9,
      "series": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 581,
    "title": "A Canticle for Leibowitz",
    "author": "Walter M. Miller Jr.",
    "publicationYear": 1959,
    "series": {
      "name": "St. Leibowitz",
      "position": 1
    },
    "isbn": "0060892994",
    "googleBooksId": "placeholder581",
    "image": "https://books.google.com/books/content?id=qGL3zAEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "After a nuclear apocalypse, monks work to preserve the remnants of scientific knowledge spanning thousands of years.",
    "rating": 3.99,
    "ratingsCount": 119577,
    "pageCount": 334,
    "awards": [
      "Hugo Award Best Novel (1961)"
    ],
    "categories": [
      "Science Fiction",
      "Post-Apocalyptic"
    ],
    "scores": {
      "scifi": 10,
      "literary": 9,
      "character": 7,
      "slow": 7,
      "dark": 8,
      "atmosphere": 10,
      "standalone": 10,
      "classic": 10,
      "plot": 7,
      "accessible": 7
    }
  },
  {
    "id": 582,
    "title": "The Stars My Destination",
    "author": "Alfred Bester",
    "publicationYear": 1956,
    "isbn": "0679767800",
    "googleBooksId": "placeholder582",
    "image": "http://books.google.com/books/content?id=IsCwAAAAIAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Gully Foyle transforms himself from an illiterate mechanic into a refined man driven by an all-consuming need for vengeance.",
    "rating": 4.07,
    "ratingsCount": 44728,
    "pageCount": 258,
    "awards": [
      "Hugo Award Nominee Best Novel (1957)"
    ],
    "categories": [
      "Science Fiction",
      "Space Opera"
    ],
    "scores": {
      "scifi": 10,
      "thriller": 9,
      "character": 9,
      "fast": 9,
      "dark": 8,
      "plot": 10,
      "standalone": 10,
      "classic": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 584,
    "title": "Ringworld",
    "author": "Larry Niven",
    "publicationYear": 1970,
    "isbn": "0345333926",
    "googleBooksId": "placeholder584",
    "image": "https://books.google.com/books/content?id=uv4vqKYsyawC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Louis Wu joins a motley crew of aliens to explore the Ringworld, an artificial ring encircling a distant star.",
    "rating": 3.94,
    "ratingsCount": 128748,
    "pageCount": 342,
    "awards": [
      "Hugo Award Best Novel (1971)",
      "Nebula Award Best Novel (1970)",
      "Locus Award Best Novel (1971)"
    ],
    "categories": [
      "Science Fiction",
      "Hard Science Fiction"
    ],
    "scores": {
      "scifi": 10,
      "thriller": 6,
      "character": 6,
      "medium": 7,
      "optimistic": 7,
      "plot": 8,
      "series": 9,
      "classic": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 585,
    "title": "Gateway",
    "author": "Frederik Pohl",
    "publicationYear": 1977,
    "isbn": "0345475836",
    "googleBooksId": "placeholder585",
    "image": "http://books.google.com/books/content?id=FVYrAQAAIAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Prospectors travel through mysterious alien vessels to unknown destinations, risking death for unimaginable riches.",
    "rating": 4.05,
    "ratingsCount": 47552,
    "pageCount": 313,
    "awards": [
      "Hugo Award Best Novel (1978)",
      "Nebula Award Best Novel (1977)",
      "Locus Award Best SF Novel (1978)"
    ],
    "categories": [
      "Science Fiction",
      "Space Opera"
    ],
    "scores": {
      "scifi": 10,
      "thriller": 8,
      "character": 9,
      "medium": 7,
      "dark": 8,
      "plot": 9,
      "series": 9,
      "classic": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 586,
    "title": "The Demolished Man",
    "author": "Alfred Bester",
    "publicationYear": 1953,
    "isbn": "0679767819",
    "googleBooksId": "placeholder586",
    "image": "http://books.google.com/books/content?id=ncZSfTcP65gC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "In a world where telepathic police can detect criminal intent, a wealthy industrialist attempts to commit the perfect murder.",
    "rating": 3.96,
    "ratingsCount": 33626,
    "pageCount": 243,
    "awards": [
      "Hugo Award Best Novel (1953)"
    ],
    "categories": [
      "Science Fiction",
      "Noir"
    ],
    "scores": {
      "scifi": 10,
      "thriller": 10,
      "mystery": 9,
      "character": 8,
      "fast": 9,
      "dark": 7,
      "plot": 10,
      "standalone": 10,
      "classic": 10,
      "accessible": 7
    }
  },
  {
    "id": 589,
    "title": "The Tainted Cup",
    "author": "Robert Jackson Bennett",
    "publicationYear": 2024,
    "isbn": "1984820710",
    "googleBooksId": "placeholder589",
    "image": "https://books.google.com/books/content?id=v84YEQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A junior investigator and his eccentric mentor must solve a murder where the victim died when a tree burst from his body.",
    "rating": 4.3,
    "ratingsCount": 78751,
    "pageCount": 432,
    "awards": [
      "Hugo Award Best Novel (2025)",
      "World Fantasy Award (2025)"
    ],
    "categories": [
      "Fantasy",
      "Mystery"
    ],
    "scores": {
      "fantasy": 9,
      "mystery": 10,
      "character": 9,
      "fast": 8,
      "dark": 6,
      "plot": 10,
      "series": 9,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 590,
    "title": "The Bone Shard Daughter",
    "author": "Andrea Stewart",
    "publicationYear": 2020,
    "isbn": "0316541435",
    "googleBooksId": "placeholder590",
    "image": "https://books.google.com/books/content?id=af2-zQEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In an empire controlled by bone shard magic, the Emperor's daughter secretly studies forbidden arts to prove her worth.",
    "rating": 3.98,
    "ratingsCount": 36543,
    "pageCount": 435,
    "awards": [
      "Goodreads Choice Award Nominee Fantasy (2020)"
    ],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "thriller": 8,
      "character": 9,
      "medium": 7,
      "dark": 7,
      "plot": 9,
      "series": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 591,
    "title": "The Traitor Baru Cormorant",
    "author": "Seth Dickinson",
    "publicationYear": 2015,
    "isbn": "0765380722",
    "googleBooksId": "placeholder591",
    "image": "https://books.google.com/books/content?id=ve5ICgAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Baru Cormorant watches her homeland conquered by the Empire of Masks. Determined to destroy it from within, she rises through its ranks.",
    "rating": 4.04,
    "ratingsCount": 25182,
    "pageCount": 399,
    "categories": [
      "Fantasy",
      "Political Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "thriller": 9,
      "character": 10,
      "slow": 7,
      "dark": 10,
      "plot": 10,
      "series": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 592,
    "title": "The Rage of Dragons",
    "author": "Evan Winter",
    "publicationYear": 2019,
    "isbn": "031648976X",
    "googleBooksId": "placeholder592",
    "image": "https://books.google.com/books/content?id=UxfUtwEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Tau Tafari swears revenge on those who killed his father. He must become the greatest swordsman his people have ever known.",
    "rating": 4.31,
    "ratingsCount": 46869,
    "pageCount": 544,
    "awards": [
      "Reddit Fantasy Best Debut Novel (2019)"
    ],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "thriller": 9,
      "character": 9,
      "fast": 10,
      "dark": 8,
      "plot": 9,
      "series": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 593,
    "title": "The Goblin Emperor",
    "author": "Katherine Addison",
    "publicationYear": 2014,
    "series": {
      "name": "The Chronicles of Osreth",
      "position": 1
    },
    "isbn": "076532699X",
    "googleBooksId": "placeholder593",
    "image": "https://books.google.com/books/content?id=Il_bAgAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "When his father and brothers die, Maia—the half-goblin, exiled youngest son—unexpectedly becomes emperor.",
    "rating": 4.07,
    "ratingsCount": 53296,
    "pageCount": 448,
    "awards": [
      "Locus Award Best Fantasy Novel (2015)",
      "Hugo Award Nominee Best Novel (2015)",
      "Nebula Award Nominee Best Novel (2015)"
    ],
    "categories": [
      "Fantasy",
      "Political Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "literary": 8,
      "character": 10,
      "slow": 7,
      "optimistic": 9,
      "atmosphere": 9,
      "standalone": 10,
      "modern": 10,
      "heart": 10,
      "plot": 5
    }
  },
  {
    "id": 594,
    "title": "Strange the Dreamer",
    "author": "Laini Taylor",
    "publicationYear": 2017,
    "series": {
      "name": "Strange the Dreamer",
      "position": 1
    },
    "isbn": "0316341681",
    "googleBooksId": "placeholder594",
    "image": "https://books.google.com/books/content?id=tbZWjwEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Lazlo Strange is a war orphan and junior librarian obsessed with the lost city of Weep.",
    "rating": 4.28,
    "ratingsCount": 135537,
    "pageCount": 532,
    "awards": [
      "Michael L. Printz Award Nominee (2018)"
    ],
    "categories": [
      "Fantasy",
      "Young Adult"
    ],
    "scores": {
      "fantasy": 10,
      "literary": 9,
      "character": 10,
      "slow": 7,
      "optimistic": 7,
      "atmosphere": 10,
      "series": 9,
      "modern": 10,
      "heart": 10,
      "emotional": 10
    }
  },
  {
    "id": 595,
    "title": "Empire of the Damned",
    "author": "Jay Kristoff",
    "publicationYear": 2024,
    "isbn": "1250245338",
    "googleBooksId": "placeholder595",
    "image": "https://books.google.com/books/content?id=QEe4EAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Gabriel de Leon continues his tale of the vampire apocalypse, recounting his quest to find the Holy Grail.",
    "rating": 4.56,
    "ratingsCount": 32356,
    "pageCount": 654,
    "categories": [
      "Fantasy",
      "Dark Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "thriller": 9,
      "character": 9,
      "medium": 7,
      "dark": 10,
      "atmosphere": 10,
      "series": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 596,
    "title": "First Lie Wins",
    "author": "Ashley Elston",
    "publicationYear": 2024,
    "isbn": "0593492919",
    "googleBooksId": "placeholder596",
    "image": "https://books.google.com/books/content?id=zyq4EAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Evie Porter is a skilled con artist working for a mysterious boss, infiltrating the life of Ryan Sumner.",
    "rating": 3.96,
    "ratingsCount": 611435,
    "pageCount": 336,
    "awards": [
      "Reese's Book Club Selection (2024)",
      "Goodreads Choice Award Nominee Mystery Thriller (2024)"
    ],
    "categories": [
      "Thriller",
      "Mystery"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 9,
      "character": 9,
      "fast": 10,
      "dark": 7,
      "plot": 10,
      "standalone": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 597,
    "title": "Listen for the Lie",
    "author": "Amy Tintera",
    "publicationYear": 2024,
    "isbn": "1250880319",
    "googleBooksId": "placeholder597",
    "image": "https://books.google.com/books/content?id=XMHQEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Lucy Chase can't remember if she murdered her best friend Savvy five years ago.",
    "rating": 4.04,
    "ratingsCount": 405941,
    "pageCount": 320,
    "awards": [
      "Audie Award Best Mystery Audiobook (2025)",
      "Edgar Award Finalist Best Novel (2025)",
      "Goodreads Choice Award Finalist (2024)"
    ],
    "categories": [
      "Thriller",
      "Mystery"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 10,
      "character": 8,
      "fast": 9,
      "dark": 8,
      "plot": 10,
      "standalone": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 598,
    "title": "The Hunter",
    "author": "Tana French",
    "publicationYear": 2024,
    "isbn": "0593493435",
    "googleBooksId": "placeholder598",
    "image": "https://books.google.com/books/content?id=817DEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In a remote Irish village, ex-cop Cal Hooper has found peace until Trey's estranged father returns with dangerous men.",
    "rating": 4.07,
    "ratingsCount": 68181,
    "pageCount": 467,
    "categories": [
      "Thriller",
      "Literary Fiction"
    ],
    "scores": {
      "thriller": 9,
      "mystery": 8,
      "literary": 9,
      "character": 10,
      "slow": 7,
      "dark": 7,
      "atmosphere": 10,
      "series": 9,
      "modern": 10,
      "plot": 5
    }
  },
  {
    "id": 600,
    "title": "The God of the Woods",
    "author": "Liz Moore",
    "publicationYear": 2024,
    "isbn": "0593418913",
    "googleBooksId": "placeholder600",
    "image": "https://books.google.com/books/content?id=H9XcEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In the Adirondacks, a girl vanishes from a summer camp run by a wealthy family. Fourteen years earlier, her brother also disappeared.",
    "rating": 4.12,
    "ratingsCount": 701165,
    "pageCount": 480,
    "awards": [
      "Goodreads Choice Award Best Mystery (2024)"
    ],
    "categories": [
      "Thriller",
      "Literary Fiction"
    ],
    "scores": {
      "thriller": 9,
      "mystery": 10,
      "literary": 9,
      "character": 9,
      "medium": 7,
      "dark": 7,
      "atmosphere": 10,
      "standalone": 10,
      "modern": 10,
      "plot": 5
    }
  },
  {
    "id": 601,
    "title": "The Last Devil to Die",
    "author": "Richard Osman",
    "publicationYear": 2023,
    "isbn": "0593299426",
    "googleBooksId": "placeholder601",
    "image": "https://books.google.com/books/content?id=hPiiEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "When an old friend of the Thursday Murder Club dies, the four septuagenarian sleuths investigate heroin smugglers.",
    "rating": 4.47,
    "ratingsCount": 232194,
    "pageCount": 421,
    "categories": [
      "Mystery",
      "Cozy Mystery"
    ],
    "scores": {
      "mystery": 10,
      "contemporary": 9,
      "character": 10,
      "medium": 7,
      "optimistic": 8,
      "plot": 9,
      "series": 10,
      "modern": 10,
      "heart": 9,
      "accessible": 7
    }
  },
  {
    "id": 606,
    "title": "James",
    "author": "Percival Everett",
    "publicationYear": 2024,
    "isbn": "0385550367",
    "googleBooksId": "placeholder606",
    "image": "https://books.google.com/books/content?id=PeQE0AEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A brilliant reimagining of Huckleberry Finn told from the enslaved Jim's perspective.",
    "rating": 4.41,
    "ratingsCount": 357851,
    "pageCount": 320,
    "awards": [
      "Pulitzer Prize Fiction (2025)",
      "National Book Award Fiction (2024)",
      "Kirkus Prize (2024)",
      "Booker Prize Shortlist (2024)"
    ],
    "categories": [
      "Contemporary Fiction",
      "Historical Fiction"
    ],
    "scores": {
      "contemporary": 9,
      "literary": 10,
      "historical": 9,
      "character": 10,
      "medium": 7,
      "dark": 7,
      "atmosphere": 9,
      "standalone": 10,
      "modern": 10,
      "plot": 5
    }
  },
  {
    "id": 611,
    "title": "North Woods",
    "author": "Daniel Mason",
    "publicationYear": 2023,
    "isbn": "0593597036",
    "googleBooksId": "placeholder611",
    "image": "https://books.google.com/books/content?id=LRS4EAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A single house in the New England woods across centuries, witnessed by the land and creatures who inhabit it.",
    "rating": 4.1,
    "ratingsCount": 88615,
    "pageCount": 372,
    "awards": [
      "Goodreads Choice Award Nominee Historical Fiction (2023)",
      "PEN Oakland Josephine Miles Award (2024)"
    ],
    "categories": [
      "Contemporary Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "contemporary": 9,
      "literary": 10,
      "historical": 8,
      "character": 9,
      "slow": 7,
      "atmosphere": 10,
      "standalone": 10,
      "modern": 10,
      "heart": 8,
      "plot": 5
    }
  },
  {
    "id": 612,
    "title": "Birnam Wood",
    "author": "Eleanor Catton",
    "publicationYear": 2023,
    "isbn": "0374110336",
    "googleBooksId": "placeholder612",
    "image": "https://books.google.com/books/content?id=t21xEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A guerrilla gardening collective in New Zealand crosses paths with a charismatic American billionaire.",
    "rating": 3.8,
    "ratingsCount": 52333,
    "pageCount": 432,
    "categories": [
      "Contemporary Fiction",
      "Thriller"
    ],
    "scores": {
      "contemporary": 10,
      "literary": 9,
      "thriller": 8,
      "character": 9,
      "medium": 7,
      "dark": 8,
      "plot": 9,
      "standalone": 10,
      "modern": 10,
      "accessible": 7
    }
  },
  {
    "id": 613,
    "title": "Trust",
    "author": "Hernan Diaz",
    "publicationYear": 2022,
    "isbn": "0593420322",
    "googleBooksId": "placeholder613",
    "image": "https://books.google.com/books/content?id=QyiwEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A wealthy financier's wife is rumored to have gone mad. Four narratives circle the truth of their marriage.",
    "rating": 3.84,
    "ratingsCount": 197130,
    "pageCount": 416,
    "awards": [
      "Pulitzer Prize Fiction (2023)",
      "Kirkus Prize (2022)",
      "Booker Prize Longlist (2022)"
    ],
    "categories": [
      "Contemporary Fiction",
      "Historical Fiction"
    ],
    "scores": {
      "contemporary": 9,
      "literary": 10,
      "historical": 8,
      "character": 9,
      "slow": 7,
      "dark": 6,
      "atmosphere": 8,
      "standalone": 10,
      "modern": 10,
      "plot": 5
    }
  },
  {
    "id": 614,
    "title": "The Bee Sting",
    "author": "Paul Murray",
    "publicationYear": 2023,
    "isbn": "0374600309",
    "googleBooksId": "placeholder614",
    "image": "https://books.google.com/books/content?id=j8moEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The Barnes family—once wealthy, now struggling—spirals toward crisis in rural Ireland.",
    "rating": 3.91,
    "ratingsCount": 90598,
    "pageCount": 656,
    "awards": [
      "Nero Book Award Fiction (2023)",
      "Booker Prize Shortlist (2023)"
    ],
    "categories": [
      "Contemporary Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "contemporary": 10,
      "literary": 10,
      "character": 10,
      "slow": 7,
      "dark": 8,
      "atmosphere": 9,
      "standalone": 10,
      "modern": 10,
      "heart": 8,
      "plot": 5
    }
  },
  {
    "id": 615,
    "title": "The Sympathizer",
    "author": "Viet Thanh Nguyen",
    "publicationYear": 2015,
    "series": {
      "name": "The Sympathizer",
      "position": 1
    },
    "isbn": "0802124941",
    "googleBooksId": "placeholder615",
    "image": "https://books.google.com/books/content?id=7D4IxwEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A communist spy infiltrates the South Vietnamese army and follows a general to America after the Fall of Saigon.",
    "rating": 4.01,
    "ratingsCount": 137984,
    "pageCount": 371,
    "awards": [
      "Pulitzer Prize Fiction (2016)",
      "Edgar Award Best First Novel (2016)",
      "Andrew Carnegie Medal (2016)"
    ],
    "categories": [
      "Contemporary Fiction",
      "Historical Fiction"
    ],
    "scores": {
      "contemporary": 9,
      "literary": 10,
      "historical": 10,
      "character": 9,
      "medium": 7,
      "dark": 8,
      "atmosphere": 9,
      "standalone": 8,
      "modern": 10,
      "plot": 5
    }
  },
  {
    "id": 616,
    "title": "The Berry Pickers",
    "author": "Amanda Peters",
    "publicationYear": 2023,
    "isbn": "1646221958",
    "googleBooksId": "placeholder616",
    "image": "https://books.google.com/books/content?id=vverEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In 1962 Maine, a Mi'kmaq family picks blueberries when four-year-old Ruthie vanishes.",
    "rating": 4.02,
    "ratingsCount": 209663,
    "pageCount": 307,
    "awards": [
      "Andrew Carnegie Medal for Excellence in Fiction (2024)",
      "Barnes & Noble Discover Prize (2023)"
    ],
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "historical": 10,
      "literary": 10,
      "contemporary": 8,
      "character": 10,
      "slow": 7,
      "dark": 8,
      "atmosphere": 10,
      "standalone": 10,
      "modern": 10,
      "heart": 10,
      "emotional": 10
    }
  },
  {
    "id": 617,
    "title": "The Heaven & Earth Grocery Store",
    "author": "James McBride",
    "publicationYear": 2023,
    "isbn": "0593422945",
    "googleBooksId": "placeholder617",
    "image": "https://books.google.com/books/content?id=ieOgEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In 1972 Pottstown, a skeleton is found in a well, revealing intertwined histories of Black and Jewish communities.",
    "rating": 3.82,
    "ratingsCount": 235317,
    "pageCount": 385,
    "awards": [
      "Kirkus Prize (2023)",
      "Barnes & Noble Book of the Year (2023)"
    ],
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "historical": 10,
      "literary": 10,
      "contemporary": 8,
      "character": 10,
      "medium": 7,
      "optimistic": 7,
      "atmosphere": 9,
      "standalone": 10,
      "modern": 10,
      "heart": 9
    }
  },
  {
    "id": 618,
    "title": "Tom Lake",
    "author": "Ann Patchett",
    "publicationYear": 2023,
    "isbn": "0063327538",
    "googleBooksId": "placeholder618",
    "image": "https://books.google.com/books/content?id=CvGxEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "During the pandemic, Lara picks cherries with her daughters and tells them about Peter Duke, a famous actor she once loved.",
    "rating": 3.91,
    "ratingsCount": 415682,
    "pageCount": 320,
    "awards": [
      "Goodreads Choice Award Nominee Fiction (2023)"
    ],
    "categories": [
      "Historical Fiction",
      "Contemporary Fiction"
    ],
    "scores": {
      "historical": 8,
      "contemporary": 10,
      "literary": 9,
      "character": 10,
      "slow": 7,
      "optimistic": 8,
      "atmosphere": 10,
      "standalone": 10,
      "modern": 10,
      "heart": 10
    }
  },
  {
    "id": 619,
    "title": "Table for Two",
    "author": "Amor Towles",
    "publicationYear": 2024,
    "isbn": "0593296370",
    "googleBooksId": "placeholder619",
    "image": "https://books.google.com/books/content?id=a1XOEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Six stories set in turn-of-the-millennium New York City plus a novella set in 1938 Hollywood.",
    "rating": 4.15,
    "ratingsCount": 37389,
    "pageCount": 451,
    "categories": [
      "Historical Fiction",
      "Short Stories"
    ],
    "scores": {
      "historical": 9,
      "literary": 10,
      "contemporary": 8,
      "character": 9,
      "medium": 7,
      "optimistic": 8,
      "atmosphere": 9,
      "standalone": 10,
      "modern": 10,
      "heart": 8
    }
  },
  {
    "id": 621,
    "title": "Horse",
    "author": "Geraldine Brooks",
    "publicationYear": 2022,
    "isbn": "0399562966",
    "googleBooksId": "placeholder621",
    "image": "https://books.google.com/books/content?id=2JxPEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Inspired by the true story of Lexington, the greatest racehorse in American history.",
    "rating": 4.15,
    "ratingsCount": 146704,
    "pageCount": 401,
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "historical": 10,
      "literary": 9,
      "contemporary": 7,
      "character": 9,
      "medium": 7,
      "dark": 7,
      "atmosphere": 9,
      "standalone": 10,
      "modern": 10,
      "heart": 8
    }
  },
  {
    "id": 623,
    "title": "American Prometheus",
    "author": "Kai Bird and Martin J. Sherwin",
    "publicationYear": 2005,
    "isbn": "0375726268",
    "googleBooksId": "placeholder623",
    "image": "https://books.google.com/books/content?id=mXSPDQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The definitive biography of J. Robert Oppenheimer, the brilliant physicist who led the Manhattan Project.",
    "rating": 4.3,
    "ratingsCount": 162847,
    "pageCount": 721,
    "awards": [
      "Pulitzer Prize Biography (2006)",
      "National Book Critics Circle Award (2006)",
      "Duff Cooper Prize (2006)"
    ],
    "categories": [
      "History",
      "Biography"
    ],
    "scores": {
      "history": 10,
      "nonfiction": 10,
      "memoir": 9,
      "character": 9,
      "slow": 6,
      "dark": 8,
      "atmosphere": 8,
      "standalone": 10,
      "modern": 10,
      "plot": 5
    }
  },
  {
    "id": 624,
    "title": "The Bomber Mafia",
    "author": "Malcolm Gladwell",
    "publicationYear": 2021,
    "isbn": "0316296619",
    "googleBooksId": "placeholder624",
    "image": "https://books.google.com/books/content?id=6owozgEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A group of idealistic pilots believed precision bombing could win wars without bloodshed.",
    "rating": 3.98,
    "ratingsCount": 40809,
    "pageCount": 256,
    "awards": [
      "Goodreads Choice Award Nominee History Biography (2021)"
    ],
    "categories": [
      "History",
      "Military History"
    ],
    "scores": {
      "history": 10,
      "nonfiction": 10,
      "character": 7,
      "fast": 8,
      "dark": 7,
      "atmosphere": 8,
      "standalone": 10,
      "modern": 10,
      "plot": 7,
      "accessible": 7
    }
  },
  {
    "id": 625,
    "title": "Master Slave Husband Wife",
    "author": "Ilyon Woo",
    "publicationYear": 2023,
    "isbn": "1501191063",
    "googleBooksId": "placeholder625",
    "image": "https://books.google.com/books/content?id=LMZ0EAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Ellen and William Craft escaped slavery in 1848 by posing as master and slave—with light-skinned Ellen disguised as a white man.",
    "rating": 3.98,
    "ratingsCount": 17450,
    "pageCount": 464,
    "awards": [
      "Pulitzer Prize Biography (2024)"
    ],
    "categories": [
      "History",
      "Biography"
    ],
    "scores": {
      "history": 10,
      "nonfiction": 10,
      "memoir": 9,
      "character": 10,
      "fast": 8,
      "dark": 8,
      "atmosphere": 9,
      "standalone": 10,
      "modern": 10,
      "heart": 9
    }
  },
  {
    "id": 626,
    "title": "King: A Life",
    "author": "Jonathan Eig",
    "publicationYear": 2023,
    "isbn": "0374279292",
    "googleBooksId": "placeholder626",
    "image": "https://books.google.com/books/content?id=vXSaEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The first major biography of Martin Luther King Jr. in decades draws on declassified FBI files.",
    "rating": 4.38,
    "ratingsCount": 18500,
    "pageCount": 672,
    "awards": [
      "Pulitzer Prize Biography (2024)"
    ],
    "categories": [
      "History",
      "Biography"
    ],
    "scores": {
      "history": 10,
      "nonfiction": 10,
      "memoir": 10,
      "character": 10,
      "medium": 7,
      "dark": 7,
      "atmosphere": 9,
      "standalone": 10,
      "modern": 10,
      "heart": 9
    }
  },
  {
    "id": 627,
    "title": "Endurance: Shackleton's Incredible Voyage",
    "author": "Alfred Lansing",
    "publicationYear": 1959,
    "isbn": "0465062881",
    "googleBooksId": "placeholder627",
    "image": "https://books.google.com/books/content?id=_YxttAEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In 1914, Shackleton's ship became trapped in Antarctic ice. For nearly two years, his crew survived on ice floes.",
    "rating": 4.43,
    "ratingsCount": 140714,
    "pageCount": 282,
    "categories": [
      "History",
      "Adventure"
    ],
    "scores": {
      "history": 10,
      "nonfiction": 10,
      "character": 9,
      "fast": 8,
      "dark": 7,
      "atmosphere": 10,
      "standalone": 10,
      "classic": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 631,
    "title": "The Coming of the Third Reich",
    "author": "Richard J. Evans",
    "publicationYear": 2003,
    "isbn": "0143034693",
    "googleBooksId": "placeholder631",
    "image": "https://books.google.com/books/content?id=hx62NyAzEu8C&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The first volume of a definitive trilogy, tracing Nazi Germany from the end of World War I through Hitler's consolidation of power.",
    "rating": 4.31,
    "ratingsCount": 12442,
    "pageCount": 622,
    "categories": [
      "History",
      "World War II"
    ],
    "scores": {
      "history": 10,
      "nonfiction": 10,
      "character": 7,
      "slow": 6,
      "dark": 10,
      "atmosphere": 8,
      "series": 10,
      "classic": 9,
      "plot": 7,
      "accessible": 7
    }
  },
  {
    "id": 632,
    "title": "The Metamorphosis",
    "author": "Franz Kafka",
    "publicationYear": 1915,
    "isbn": "1557427666",
    "googleBooksId": "placeholder632",
    "image": "https://books.google.com/books/content?id=6EMYnQEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Gregor Samsa wakes one morning transformed into a giant insect.",
    "rating": 3.9,
    "ratingsCount": 1428766,
    "pageCount": 55,
    "categories": [
      "Classic Literature",
      "Absurdist Fiction"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 8,
      "fast": 9,
      "dark": 8,
      "atmosphere": 10,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 633,
    "title": "Native Son",
    "author": "Richard Wright",
    "publicationYear": 1940,
    "isbn": "0061148504",
    "googleBooksId": "placeholder633",
    "image": "https://books.google.com/books/content?id=BHQciEOsIxoC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Bigger Thomas, a young Black man in 1930s Chicago, accidentally kills a white woman and descends into violence.",
    "rating": 4.04,
    "ratingsCount": 96221,
    "pageCount": 504,
    "categories": [
      "Classic Literature",
      "African American Literature"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 9,
      "medium": 7,
      "dark": 10,
      "atmosphere": 10,
      "standalone": 10,
      "historical": 9,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 634,
    "title": "The Trial",
    "author": "Franz Kafka",
    "publicationYear": 1925,
    "isbn": "0805209999",
    "googleBooksId": "placeholder634",
    "image": "https://books.google.com/books/content?id=eenXRYAzQRsC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Josef K. is arrested one morning for an unknown crime by an inaccessible authority.",
    "rating": 3.94,
    "ratingsCount": 397336,
    "pageCount": 255,
    "categories": [
      "Classic Literature",
      "Absurdist Fiction"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 8,
      "medium": 7,
      "dark": 9,
      "atmosphere": 10,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 635,
    "title": "Siddhartha",
    "author": "Hermann Hesse",
    "publicationYear": 1922,
    "isbn": "0553208845",
    "googleBooksId": "placeholder635",
    "image": "https://books.google.com/books/content?id=x62l0QEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A young Brahmin's spiritual journey through ancient India seeking enlightenment.",
    "rating": 4.08,
    "ratingsCount": 879909,
    "pageCount": 152,
    "categories": [
      "Classic Literature",
      "Philosophical Fiction"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 9,
      "fast": 8,
      "optimistic": 9,
      "atmosphere": 10,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 636,
    "title": "Tess of the d'Urbervilles",
    "author": "Thomas Hardy",
    "publicationYear": 1891,
    "isbn": "0141439599",
    "googleBooksId": "placeholder636",
    "image": "https://books.google.com/books/content?id=P74zEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Tess Durbeyfield discovers her family's noble ancestry and suffers the consequences of society's cruelty.",
    "rating": 3.83,
    "ratingsCount": 266517,
    "pageCount": 518,
    "categories": [
      "Classic Literature",
      "Tragedy"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 10,
      "slow": 7,
      "dark": 9,
      "atmosphere": 10,
      "standalone": 10,
      "historical": 10,
      "heart": 9,
      "emotional": 10
    }
  },
  {
    "id": 637,
    "title": "Dubliners",
    "author": "James Joyce",
    "publicationYear": 1914,
    "isbn": "0140186476",
    "googleBooksId": "placeholder637",
    "image": "https://books.google.com/books/content?id=Qoi2aHzcGq8C&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Fifteen interconnected stories capture the paralysis and epiphanies of Dublin's citizens.",
    "rating": 3.86,
    "ratingsCount": 130733,
    "pageCount": 152,
    "categories": [
      "Classic Literature",
      "Short Stories"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 9,
      "slow": 7,
      "dark": 7,
      "atmosphere": 10,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 639,
    "title": "To the Lighthouse",
    "author": "Virginia Woolf",
    "publicationYear": 1927,
    "isbn": "0156907399",
    "googleBooksId": "placeholder639",
    "image": "https://books.google.com/books/content?id=ng0Tg0FhRggC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The Ramsay family visits their summer home in Scotland over a decade, with a trip to the lighthouse as the symbolic center.",
    "rating": 3.81,
    "ratingsCount": 215183,
    "pageCount": 209,
    "categories": [
      "Classic Literature",
      "Modernist"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 10,
      "slow": 9,
      "dark": 6,
      "atmosphere": 10,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 640,
    "title": "The Razor's Edge",
    "author": "W. Somerset Maugham",
    "publicationYear": 1944,
    "isbn": "1400034205",
    "googleBooksId": "placeholder640",
    "image": "https://books.google.com/books/content?id=8W-PEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Larry Darrell returns from WWI seeking spiritual fulfillment rather than wealth or success.",
    "rating": 4.2,
    "ratingsCount": 41594,
    "pageCount": 314,
    "categories": [
      "Classic Literature",
      "Philosophical Fiction"
    ],
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 10,
      "slow": 7,
      "optimistic": 8,
      "atmosphere": 9,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 641,
    "title": "Feel-Good Productivity",
    "author": "Ali Abdaal",
    "publicationYear": 2024,
    "isbn": "1250865042",
    "googleBooksId": "placeholder641",
    "image": "https://books.google.com/books/content?id=es2iEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "What if the secret to productivity is not discipline but feeling good?",
    "rating": 3.98,
    "ratingsCount": 18538,
    "pageCount": 270,
    "categories": [
      "Self-Help",
      "Productivity"
    ],
    "scores": {
      "nonfiction": 10,
      "selfhelp": 10,
      "fast": 9,
      "optimistic": 10,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 642,
    "title": "Supercommunicators",
    "author": "Charles Duhigg",
    "publicationYear": 2024,
    "isbn": "0593243919",
    "googleBooksId": "placeholder642",
    "image": "https://books.google.com/books/content?id=ZLbNEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "An exploration of what makes some people exceptional at connecting with others.",
    "rating": 3.98,
    "ratingsCount": 36673,
    "pageCount": 320,
    "awards": [
      "Goodreads Choice Award Nominee Nonfiction (2024)"
    ],
    "categories": [
      "Self-Help",
      "Communication"
    ],
    "scores": {
      "nonfiction": 10,
      "selfhelp": 10,
      "fast": 8,
      "optimistic": 9,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 643,
    "title": "Build the Life You Want",
    "author": "Arthur C. Brooks and Oprah Winfrey",
    "publicationYear": 2023,
    "isbn": "0593545400",
    "googleBooksId": "placeholder643",
    "image": "https://books.google.com/books/content?id=Ve26EAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Harvard professor Arthur Brooks and Oprah Winfrey combine science and wisdom to offer a practical guide to happiness.",
    "rating": 3.82,
    "ratingsCount": 28500,
    "pageCount": 256,
    "categories": [
      "Self-Help",
      "Wellness"
    ],
    "scores": {
      "nonfiction": 10,
      "selfhelp": 10,
      "fast": 8,
      "optimistic": 10,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 644,
    "title": "The Happiness Hypothesis",
    "author": "Jonathan Haidt",
    "publicationYear": 2006,
    "isbn": "0465028020",
    "googleBooksId": "placeholder644",
    "image": "https://books.google.com/books/content?id=cg-ptAEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Jonathan Haidt examines ancient wisdom through the lens of modern psychology.",
    "rating": 4.07,
    "ratingsCount": 39016,
    "pageCount": 320,
    "categories": [
      "Self-Help",
      "Psychology"
    ],
    "scores": {
      "nonfiction": 10,
      "selfhelp": 9,
      "medium": 7,
      "optimistic": 8,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 645,
    "title": "Stolen Focus",
    "author": "Johann Hari",
    "publicationYear": 2022,
    "isbn": "0593138511",
    "googleBooksId": "placeholder645",
    "image": "https://books.google.com/books/content?id=tb9WEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Our ability to focus is collapsing. Johann Hari traveled the world to discover why.",
    "rating": 4.21,
    "ratingsCount": 59619,
    "pageCount": 368,
    "categories": [
      "Self-Help",
      "Psychology"
    ],
    "scores": {
      "nonfiction": 10,
      "selfhelp": 9,
      "fast": 8,
      "dark": 6,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 646,
    "title": "The Daily Stoic",
    "author": "Ryan Holiday",
    "publicationYear": 2016,
    "isbn": "0735211736",
    "googleBooksId": "placeholder646",
    "image": "https://books.google.com/books/content?id=JxNvDQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "366 meditations on wisdom, perseverance, and the art of living.",
    "rating": 4.37,
    "ratingsCount": 49919,
    "pageCount": 416,
    "categories": [
      "Self-Help",
      "Philosophy"
    ],
    "scores": {
      "nonfiction": 10,
      "selfhelp": 10,
      "fast": 9,
      "optimistic": 8,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 647,
    "title": "Flow",
    "author": "Mihaly Csikszentmihalyi",
    "publicationYear": 1990,
    "isbn": "0061339202",
    "googleBooksId": "placeholder647",
    "image": "https://books.google.com/books/content?id=nVA53NEAx64C&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The pioneering psychologist introduces the concept of flow—a state of optimal experience.",
    "rating": 4.11,
    "ratingsCount": 88834,
    "pageCount": 303,
    "categories": [
      "Self-Help",
      "Psychology"
    ],
    "scores": {
      "nonfiction": 10,
      "selfhelp": 10,
      "medium": 6,
      "optimistic": 9,
      "standalone": 10,
      "classic": 8,
      "character": 7,
      "plot": 6,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 648,
    "title": "Burnout",
    "author": "Emily Nagoski and Amelia Nagoski",
    "publicationYear": 2019,
    "isbn": "1984818325",
    "googleBooksId": "placeholder648",
    "image": "https://books.google.com/books/content?id=DlnDDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Sisters Emily and Amelia Nagoski explain why women experience burnout differently and how to complete the stress cycle.",
    "rating": 3.93,
    "ratingsCount": 61687,
    "pageCount": 305,
    "categories": [
      "Self-Help",
      "Wellness"
    ],
    "scores": {
      "nonfiction": 10,
      "selfhelp": 10,
      "fast": 8,
      "optimistic": 9,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 650,
    "title": "Good Inside",
    "author": "Dr. Becky Kennedy",
    "publicationYear": 2022,
    "isbn": "0063159481",
    "googleBooksId": "placeholder650",
    "image": "https://books.google.com/books/content?id=0-K7zgEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A clinical psychologist and parenting expert offers a new framework for raising resilient children.",
    "rating": 4.53,
    "ratingsCount": 29797,
    "pageCount": 336,
    "categories": [
      "Self-Help",
      "Parenting"
    ],
    "scores": {
      "nonfiction": 10,
      "selfhelp": 10,
      "fast": 8,
      "optimistic": 10,
      "heart": 9,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6,
      "accessible": 7
    }
  },
  {
    "id": 651,
    "title": "The Third Gilmore Girl",
    "author": "Kelly Bishop",
    "publicationYear": 2024,
    "isbn": "1668023776",
    "googleBooksId": "placeholder651",
    "image": "https://books.google.com/books/content?id=fvkhEQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Kelly Bishop—Emily Gilmore herself—tells her extraordinary story from Broadway dancer to TV icon.",
    "rating": 4.31,
    "ratingsCount": 109942,
    "pageCount": 244,
    "awards": [
      "Goodreads Choice Award Memoir (2024)"
    ],
    "categories": [
      "Memoir",
      "Entertainment"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "character": 10,
      "fast": 8,
      "optimistic": 8,
      "standalone": 10,
      "modern": 10,
      "heart": 9,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 652,
    "title": "Be Ready When the Luck Happens",
    "author": "Ina Garten",
    "publicationYear": 2024,
    "isbn": "0593799895",
    "googleBooksId": "placeholder652",
    "image": "https://books.google.com/books/content?id=lF8AEQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The Barefoot Contessa shares her journey from White House nuclear policy analyst to beloved cookbook author.",
    "rating": 4.23,
    "ratingsCount": 120564,
    "pageCount": 320,
    "awards": [
      "Goodreads Choice Award Nominee Memoir (2024)"
    ],
    "categories": [
      "Memoir",
      "Cooking"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "character": 10,
      "medium": 7,
      "optimistic": 10,
      "standalone": 10,
      "modern": 10,
      "heart": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 653,
    "title": "Patriot: A Memoir",
    "author": "Alexei Navalny",
    "publicationYear": 2024,
    "isbn": "0593320964",
    "googleBooksId": "placeholder653",
    "image": "https://books.google.com/books/content?id=vXr_EAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "The late Russian opposition leader's autobiography, completed in prison.",
    "rating": 4.51,
    "ratingsCount": 13843,
    "pageCount": 480,
    "awards": [
      "National Book Critics Circle Award (2024)"
    ],
    "categories": [
      "Memoir",
      "Political"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "character": 10,
      "medium": 7,
      "dark": 9,
      "atmosphere": 9,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 654,
    "title": "From Strength to Strength",
    "author": "Arthur C. Brooks",
    "publicationYear": 2022,
    "isbn": "059319148X",
    "googleBooksId": "placeholder654",
    "image": "https://books.google.com/books/content?id=BKZPEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Harvard professor Arthur Brooks explores the second half of life and how to make it meaningful.",
    "rating": 3.94,
    "ratingsCount": 16653,
    "pageCount": 256,
    "categories": [
      "Memoir",
      "Self-Help"
    ],
    "scores": {
      "memoir": 8,
      "nonfiction": 10,
      "selfhelp": 9,
      "character": 7,
      "medium": 7,
      "optimistic": 10,
      "standalone": 10,
      "modern": 10,
      "plot": 7,
      "accessible": 7
    }
  },
  {
    "id": 655,
    "title": "All About Me!",
    "author": "Mel Brooks",
    "publicationYear": 2021,
    "isbn": "0593159136",
    "googleBooksId": "placeholder655",
    "image": "https://books.google.com/books/content?id=4h6OEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "At 95, comedy legend Mel Brooks tells his life story with the wit and irreverence fans expect.",
    "rating": 4.25,
    "ratingsCount": 18103,
    "pageCount": 480,
    "categories": [
      "Memoir",
      "Entertainment"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "character": 10,
      "fast": 8,
      "optimistic": 10,
      "standalone": 10,
      "modern": 10,
      "heart": 9,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 657,
    "title": "The Creative Act",
    "author": "Rick Rubin",
    "publicationYear": 2023,
    "isbn": "0593652886",
    "googleBooksId": "placeholder657",
    "image": "https://books.google.com/books/content?id=l3dtEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Legendary music producer Rick Rubin offers a meditation on creativity.",
    "rating": 3.95,
    "ratingsCount": 77440,
    "pageCount": 406,
    "awards": [
      "Goodreads Choice Award Nominee Nonfiction (2023)"
    ],
    "categories": [
      "Memoir",
      "Self-Help"
    ],
    "scores": {
      "memoir": 8,
      "nonfiction": 10,
      "selfhelp": 9,
      "character": 6,
      "medium": 7,
      "optimistic": 9,
      "standalone": 10,
      "modern": 10,
      "plot": 7,
      "accessible": 7
    }
  },
  {
    "id": 660,
    "title": "The Paradise Problem",
    "author": "Christina Lauren",
    "publicationYear": 2024,
    "isbn": "1668017725",
    "googleBooksId": "placeholder660",
    "image": "https://books.google.com/books/content?id=po4CEQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Anna and West entered a marriage of convenience in college. Now his family demands he bring his wife to Indonesia.",
    "rating": 4.05,
    "ratingsCount": 315012,
    "pageCount": 352,
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 10,
      "character": 9,
      "fast": 9,
      "optimistic": 10,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 661,
    "title": "This Summer Will Be Different",
    "author": "Carley Fortune",
    "publicationYear": 2024,
    "isbn": "0593638883",
    "googleBooksId": "placeholder661",
    "image": "https://books.google.com/books/content?id=XnbSEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Lucy visits Prince Edward Island every summer. Her rule: never kiss Felix, the off-limits younger brother.",
    "rating": 3.94,
    "ratingsCount": 229145,
    "pageCount": 368,
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 10,
      "character": 9,
      "fast": 8,
      "optimistic": 9,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 665,
    "title": "Practice Makes Perfect",
    "author": "Sarah Adams",
    "publicationYear": 2023,
    "series": {
      "name": "When in Rome",
      "position": 2
    },
    "isbn": "0593500806",
    "googleBooksId": "placeholder665",
    "image": "https://books.google.com/books/content?id=XnaTEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Annie Walker has had a crush on her best friend's brother for years.",
    "rating": 4.12,
    "ratingsCount": 32300,
    "pageCount": 320,
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 10,
      "character": 9,
      "fast": 9,
      "optimistic": 10,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 666,
    "title": "A Court This Cruel and Lovely",
    "author": "Stacia Stark",
    "publicationYear": 2023,
    "isbn": "1959293206",
    "googleBooksId": "placeholder666",
    "image": "https://books.google.com/books/content?id=cNYo0AEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In a kingdom where magic is forbidden, Prisca has hidden her power her whole life.",
    "rating": 4.08,
    "ratingsCount": 99346,
    "pageCount": 532,
    "awards": [
      "Goodreads Choice Award Nominee Romance (2023)"
    ],
    "categories": [
      "Romance",
      "Fantasy"
    ],
    "scores": {
      "heart": 10,
      "fantasy": 10,
      "character": 9,
      "medium": 7,
      "dark": 7,
      "series": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 668,
    "title": "Yours Truly",
    "author": "Abby Jimenez",
    "publicationYear": 2023,
    "isbn": "1538704390",
    "googleBooksId": "placeholder668",
    "image": "https://books.google.com/books/content?id=2URTzwEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Dr. Briana Ortiz and her rival for a coveted promotion start exchanging letters.",
    "rating": 4.29,
    "ratingsCount": 832886,
    "pageCount": 398,
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 10,
      "character": 10,
      "fast": 8,
      "optimistic": 9,
      "series": 9,
      "modern": 10,
      "emotional": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 672,
    "title": "The Soulmate Equation",
    "author": "Christina Lauren",
    "publicationYear": 2021,
    "series": {
      "name": "DNA Duo",
      "position": 1
    },
    "isbn": "1982123966",
    "googleBooksId": "placeholder672",
    "image": "https://books.google.com/books/content?id=pywEEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A statistician discovers she's a 98% match with a grumpy geneticist through a revolutionary dating app.",
    "rating": 3.99,
    "ratingsCount": 300987,
    "pageCount": 352,
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 10,
      "character": 9,
      "fast": 8,
      "optimistic": 9,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 673,
    "title": "The God of Small Things",
    "author": "Arundhati Roy",
    "publicationYear": 1997,
    "isbn": "0812979656",
    "googleBooksId": "placeholder673",
    "image": "https://books.google.com/books/content?id=1yePEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In Kerala, India, twins navigate caste, forbidden love, and a terrible family secret.",
    "rating": 3.96,
    "ratingsCount": 325935,
    "pageCount": 340,
    "awards": [
      "Booker Prize (1997)"
    ],
    "categories": [
      "Literary Fiction",
      "Historical Fiction"
    ],
    "scores": {
      "literary": 10,
      "historical": 9,
      "character": 10,
      "slow": 8,
      "emotional": 10,
      "atmosphere": 10,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 674,
    "title": "Ducks: Two Years in the Oil Sands",
    "author": "Kate Beaton",
    "publicationYear": 2022,
    "isbn": "1770462899",
    "googleBooksId": "placeholder674",
    "image": "https://books.google.com/books/content?id=JYxVEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A graphic memoir about working in the Alberta oil sands to pay off student debt.",
    "rating": 4.41,
    "ratingsCount": 30214,
    "pageCount": 436,
    "awards": [
      "Canada Reads Winner (2023)",
      "Eisner Award Best Graphic Memoir (2023)"
    ],
    "categories": [
      "Memoir",
      "Graphic Novel"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "character": 10,
      "dark": 8,
      "emotional": 10,
      "standalone": 10,
      "modern": 10,
      "medium": 7,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 676,
    "title": "Things We Do in the Dark",
    "author": "Jennifer Hillier",
    "publicationYear": 2022,
    "isbn": "1250763169",
    "googleBooksId": "placeholder676",
    "image": "https://books.google.com/books/content?id=5ew-EAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A woman's famous comedian husband is found dead in the bathtub—and she's the only suspect.",
    "rating": 3.93,
    "ratingsCount": 92076,
    "pageCount": 368,
    "awards": [
      "ITW Thriller Award Best Audiobook (2023)"
    ],
    "categories": [
      "Thriller",
      "Mystery"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 9,
      "plot": 10,
      "fast": 9,
      "dark": 9,
      "character": 8,
      "standalone": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 681,
    "title": "Fugitive Telemetry",
    "author": "Martha Wells",
    "publicationYear": 2021,
    "isbn": "1250765374",
    "googleBooksId": "placeholder681",
    "image": "https://books.google.com/books/content?id=tNoDEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Murderbot investigates a murder on Preservation Station.",
    "rating": 4.29,
    "ratingsCount": 104472,
    "pageCount": 168,
    "categories": [
      "Science Fiction",
      "Mystery"
    ],
    "scores": {
      "scifi": 10,
      "mystery": 8,
      "character": 10,
      "fast": 9,
      "optimistic": 7,
      "series": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 682,
    "title": "The Kaiju Preservation Society",
    "author": "John Scalzi",
    "publicationYear": 2022,
    "isbn": "0765389126",
    "googleBooksId": "placeholder682",
    "image": "https://books.google.com/books/content?id=q5pCEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Jamie loses their job and stumbles into a secret organization that protects giant monsters in an alternate dimension.",
    "rating": 3.92,
    "ratingsCount": 48549,
    "pageCount": 264,
    "categories": [
      "Science Fiction",
      "Humor"
    ],
    "scores": {
      "scifi": 9,
      "comedy": 9,
      "character": 8,
      "fast": 10,
      "optimistic": 10,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 684,
    "title": "Translation State",
    "author": "Ann Leckie",
    "publicationYear": 2023,
    "isbn": "031628971X",
    "googleBooksId": "placeholder684",
    "image": "https://books.google.com/books/content?id=g3SOEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Three characters navigate identity, politics, and alien biology in the Imperial Radch universe.",
    "rating": 4.07,
    "ratingsCount": 13235,
    "pageCount": 422,
    "categories": [
      "Science Fiction",
      "Space Opera"
    ],
    "scores": {
      "scifi": 10,
      "literary": 8,
      "character": 10,
      "medium": 7,
      "atmosphere": 9,
      "series": 7,
      "modern": 10,
      "mind": 8,
      "plot": 5,
      "emotional": 6
    }
  },
  {
    "id": 685,
    "title": "Starter Villain",
    "author": "John Scalzi",
    "publicationYear": 2023,
    "isbn": "0765389223",
    "googleBooksId": "placeholder685",
    "image": "https://books.google.com/books/content?id=KVOSEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Charlie inherits his uncle's supervillain business, complete with intelligent cats and dolphin minions.",
    "rating": 4.08,
    "ratingsCount": 71328,
    "pageCount": 272,
    "awards": [
      "Dragon Award Best Science Fiction Novel (2024)",
      "Hugo Award Finalist (2024)"
    ],
    "categories": [
      "Science Fiction",
      "Humor"
    ],
    "scores": {
      "scifi": 7,
      "comedy": 10,
      "character": 8,
      "fast": 10,
      "optimistic": 9,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 686,
    "title": "Light From Uncommon Stars",
    "author": "Ryka Aoki",
    "publicationYear": 2021,
    "isbn": "1250789079",
    "googleBooksId": "placeholder686",
    "image": "https://books.google.com/books/content?id=YEYMEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A violin teacher who sold her soul to hell, an alien refugee, and a trans runaway violinist find redemption.",
    "rating": 4.02,
    "ratingsCount": 30923,
    "pageCount": 384,
    "awards": [
      "Otherwise Award (2021)",
      "Alex Award (2022)",
      "Stonewall Book Award (2022)",
      "Hugo Award Finalist (2022)"
    ],
    "categories": [
      "Science Fiction",
      "Fantasy",
      "LGBTQ+"
    ],
    "scores": {
      "scifi": 8,
      "fantasy": 7,
      "literary": 8,
      "character": 10,
      "medium": 7,
      "optimistic": 8,
      "heart": 10,
      "emotional": 10,
      "standalone": 10,
      "modern": 10
    }
  },
  {
    "id": 688,
    "title": "A Psalm for the Wild-Built",
    "author": "Becky Chambers",
    "publicationYear": 2021,
    "isbn": "1250236215",
    "googleBooksId": "placeholder688",
    "image": "https://books.google.com/books/content?id=Z5V7EAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A tea monk in a post-industrial world meets a robot emerging from the wilderness.",
    "rating": 4.22,
    "ratingsCount": 155065,
    "pageCount": 160,
    "awards": [
      "Hugo Award Best Novella (2022)"
    ],
    "categories": [
      "Science Fiction",
      "Novella"
    ],
    "scores": {
      "scifi": 8,
      "literary": 9,
      "character": 10,
      "slow": 8,
      "optimistic": 10,
      "heart": 10,
      "series": 8,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 689,
    "title": "The Mountain in the Sea",
    "author": "Ray Nayler",
    "publicationYear": 2022,
    "isbn": "0374605955",
    "googleBooksId": "placeholder689",
    "image": "https://books.google.com/books/content?id=oLBTEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A marine biologist is recruited to study a species of octopus that may have developed its own civilization.",
    "rating": 3.86,
    "ratingsCount": 24056,
    "pageCount": 464,
    "awards": [
      "Locus Award Best First Novel (2023)"
    ],
    "categories": [
      "Science Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "scifi": 10,
      "literary": 9,
      "character": 8,
      "slow": 7,
      "atmosphere": 9,
      "mind": 10,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "emotional": 6
    }
  },
  {
    "id": 690,
    "title": "Elder Race",
    "author": "Adrian Tchaikovsky",
    "publicationYear": 2021,
    "series": {
      "name": "Elder Race",
      "position": 1
    },
    "isbn": "1250768721",
    "googleBooksId": "placeholder690",
    "image": "https://books.google.com/books/content?id=kHoQEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A anthropologist left behind on a primitive world is seen as a wizard by a princess who needs his help.",
    "rating": 4.09,
    "ratingsCount": 24845,
    "pageCount": 199,
    "awards": [
      "Hugo Award Finalist Best Novella (2022)"
    ],
    "categories": [
      "Science Fiction",
      "Fantasy"
    ],
    "scores": {
      "scifi": 9,
      "fantasy": 8,
      "literary": 7,
      "character": 9,
      "fast": 8,
      "optimistic": 7,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 691,
    "title": "System Collapse",
    "author": "Martha Wells",
    "publicationYear": 2023,
    "isbn": "1250826977",
    "googleBooksId": "placeholder691",
    "image": "https://books.google.com/books/content?id=YrOQEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Murderbot must help a colony resist corporate takeover while dealing with the aftermath of past trauma.",
    "rating": 4.2,
    "ratingsCount": 53506,
    "pageCount": 245,
    "awards": [
      "Libby Award (2024)"
    ],
    "categories": [
      "Science Fiction",
      "Space Opera"
    ],
    "scores": {
      "scifi": 10,
      "thriller": 7,
      "character": 10,
      "fast": 9,
      "optimistic": 7,
      "series": 10,
      "modern": 10,
      "heart": 8,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 692,
    "title": "The Ten Thousand Doors of January",
    "author": "Alix E. Harrow",
    "publicationYear": 2019,
    "isbn": "0316421995",
    "googleBooksId": "placeholder692",
    "image": "https://books.google.com/books/content?id=Kdo9EAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A girl discovers doorways to other worlds in early 1900s America.",
    "rating": 4.23,
    "ratingsCount": 150842,
    "pageCount": 384,
    "awards": [
      "Hugo Award Finalist (2020)",
      "Nebula Award Finalist (2020)",
      "Locus Award Finalist (2020)",
      "World Fantasy Award Finalist (2020)"
    ],
    "categories": [
      "Fantasy",
      "Historical Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "historical": 8,
      "character": 10,
      "medium": 7,
      "optimistic": 8,
      "atmosphere": 10,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 693,
    "title": "Legends & Lattes",
    "author": "Travis Baldree",
    "publicationYear": 2022,
    "series": {
      "name": "Legends & Lattes",
      "position": 1
    },
    "isbn": "1250886082",
    "googleBooksId": "placeholder693",
    "image": "https://books.google.com/books/content?id=N3RkEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A retired orc barbarian hangs up her sword to open a coffee shop in a city that has never heard of coffee.",
    "rating": 4.04,
    "ratingsCount": 332209,
    "pageCount": 296,
    "awards": [
      "Goodreads Choice Award Finalist Fantasy (2022)",
      "Nebula Award Finalist (2023)",
      "Hugo Award Finalist (2023)"
    ],
    "categories": [
      "Fantasy",
      "LGBTQ+"
    ],
    "scores": {
      "fantasy": 9,
      "contemporary": 7,
      "character": 9,
      "fast": 8,
      "optimistic": 10,
      "heart": 10,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 695,
    "title": "The Jasmine Throne",
    "author": "Tasha Suri",
    "publicationYear": 2021,
    "isbn": "0316538523",
    "googleBooksId": "placeholder695",
    "image": "https://books.google.com/books/content?id=hR0AEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A captive princess and a maidservant with forbidden magic forge an alliance to bring down an empire.",
    "rating": 4.1,
    "ratingsCount": 37971,
    "pageCount": 578,
    "awards": [
      "World Fantasy Award Finalist (2022)"
    ],
    "categories": [
      "Fantasy",
      "Epic Fantasy",
      "LGBTQ+"
    ],
    "scores": {
      "fantasy": 10,
      "dark": 8,
      "character": 10,
      "slow": 7,
      "atmosphere": 10,
      "series": 9,
      "modern": 10,
      "emotional": 8,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 696,
    "title": "She Who Became the Sun",
    "author": "Shelley Parker-Chan",
    "publicationYear": 2021,
    "isbn": "1250621801",
    "googleBooksId": "placeholder696",
    "image": "https://books.google.com/books/content?id=V0YREAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A peasant girl steals her dead brother's identity and destiny to rise to power in 14th-century China.",
    "rating": 3.84,
    "ratingsCount": 94019,
    "pageCount": 416,
    "awards": [
      "British Fantasy Award Best Novel (2022)",
      "British Fantasy Award Best Newcomer (2022)",
      "Hugo Award Finalist (2022)",
      "Lambda Literary Award Finalist (2022)"
    ],
    "categories": [
      "Fantasy",
      "Historical Fantasy",
      "LGBTQ+"
    ],
    "scores": {
      "fantasy": 9,
      "historical": 10,
      "dark": 8,
      "character": 10,
      "medium": 7,
      "atmosphere": 9,
      "series": 8,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 697,
    "title": "The Sword of Kaigen",
    "author": "M.L. Wang",
    "publicationYear": 2019,
    "isbn": "172019386X",
    "googleBooksId": "placeholder697",
    "image": "https://books.google.com/books/content?id=X1GPywEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A mother hiding her warrior past must defend her family when war comes to their remote mountain village.",
    "rating": 4.44,
    "ratingsCount": 84501,
    "pageCount": 651,
    "awards": [
      "SPFBO Winner (2019)"
    ],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "dark": 8,
      "character": 10,
      "medium": 7,
      "emotional": 10,
      "atmosphere": 9,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 699,
    "title": "The Blacktongue Thief",
    "author": "Christopher Buehlman",
    "publicationYear": 2021,
    "isbn": "1250621194",
    "googleBooksId": "placeholder699",
    "image": "https://books.google.com/books/content?id=lEMEEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A thief in debt to his guild joins a dangerous quest with a warrior seeking vengeance.",
    "rating": 4.16,
    "ratingsCount": 32376,
    "pageCount": 416,
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "dark": 7,
      "character": 9,
      "medium": 7,
      "atmosphere": 9,
      "series": 8,
      "modern": 10,
      "comedy": 7,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 700,
    "title": "The Winter King",
    "author": "Bernard Cornwell",
    "publicationYear": 1995,
    "isbn": "0312156960",
    "googleBooksId": "placeholder700",
    "image": "https://books.google.com/books/content?id=qzCLAwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Arthur's story retold as realistic historical fiction in Dark Ages Britain.",
    "rating": 4.26,
    "ratingsCount": 55241,
    "pageCount": 431,
    "categories": [
      "Fantasy",
      "Historical Fiction",
      "Arthurian"
    ],
    "scores": {
      "fantasy": 8,
      "historical": 10,
      "character": 10,
      "medium": 7,
      "dark": 8,
      "series": 10,
      "plot": 5,
      "modern": 8,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 701,
    "title": "Nettle & Bone",
    "author": "T. Kingfisher",
    "publicationYear": 2022,
    "isbn": "1250244048",
    "googleBooksId": "placeholder701",
    "image": "https://books.google.com/books/content?id=Lr4yEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A princess builds a dog from bones and bargains with a demon to save her sister from an abusive marriage.",
    "rating": 4.05,
    "ratingsCount": 102230,
    "pageCount": 243,
    "awards": [
      "Hugo Award Best Novel (2023)",
      "Nebula Award Finalist (2022)",
      "Locus Award Finalist (2023)",
      "Goodreads Choice Award Nominee Fantasy (2022)"
    ],
    "categories": [
      "Fantasy",
      "Fairy Tale Retelling"
    ],
    "scores": {
      "fantasy": 10,
      "dark": 7,
      "character": 9,
      "fast": 8,
      "atmosphere": 9,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 702,
    "title": "Babel",
    "author": "R.F. Kuang",
    "publicationYear": 2022,
    "isbn": "0063021420",
    "googleBooksId": "placeholder702",
    "image": "https://books.google.com/books/content?id=V3VOEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "An orphan from Canton becomes a translator at Oxford, where silver-working magic powers the British Empire.",
    "rating": 4.35,
    "ratingsCount": 312547,
    "pageCount": 545,
    "awards": [
      "Nebula Award Best Novel (2022)",
      "Locus Award Best Fantasy Novel (2023)"
    ],
    "categories": [
      "Fantasy",
      "Historical Fantasy",
      "Dark Academia"
    ],
    "scores": {
      "fantasy": 9,
      "historical": 10,
      "literary": 9,
      "character": 9,
      "slow": 7,
      "dark": 9,
      "atmosphere": 10,
      "standalone": 10,
      "modern": 10,
      "plot": 5
    }
  },
  {
    "id": 703,
    "title": "A Master of Djinn",
    "author": "P. Djèlí Clark",
    "publicationYear": 2021,
    "series": {
      "name": "Dead Djinn Universe",
      "position": 1
    },
    "isbn": "1250267684",
    "googleBooksId": "placeholder703",
    "image": "https://books.google.com/books/content?id=l66OEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Cairo, 1912: Agent Fatma el-Sha'arawi investigates a mysterious man who claims to be the reincarnation of al-Jahiz, the legendary inventor who opened the gates between worlds.",
    "rating": 4,
    "ratingsCount": 35606,
    "pageCount": 392,
    "awards": [
      "Nebula Award Best Novel (2021)",
      "Ignyte Award Best Novel (2022)",
      "Locus Award Best First Novel (2022)"
    ],
    "categories": [
      "Fantasy",
      "Mystery"
    ],
    "scores": {
      "fantasy": 9,
      "mystery": 8,
      "character": 9,
      "fast": 8,
      "plot": 9,
      "standalone": 10,
      "modern": 10,
      "historical": 7,
      "emotional": 6,
      "accessible": 7
    }
  },
  {
    "id": 704,
    "title": "The Last Graduate",
    "author": "Naomi Novik",
    "publicationYear": 2021,
    "isbn": "0593128869",
    "googleBooksId": "placeholder704",
    "image": "https://books.google.com/books/content?id=4kYHEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "El prepares for graduation from a deadly magical school while trying to save as many students as possible.",
    "rating": 4.22,
    "ratingsCount": 132076,
    "pageCount": 388,
    "awards": [
      "Lodestar Award (2022)",
      "Hugo Award Finalist (2022)",
      "Locus Award Finalist (2022)"
    ],
    "categories": [
      "Fantasy",
      "Dark Academia",
      "Young Adult"
    ],
    "scores": {
      "fantasy": 10,
      "dark": 8,
      "character": 9,
      "fast": 8,
      "atmosphere": 9,
      "series": 9,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 705,
    "title": "Daughter of the Moon Goddess",
    "author": "Sue Lynn Tan",
    "publicationYear": 2022,
    "isbn": "0063031302",
    "googleBooksId": "placeholder705",
    "image": "https://books.google.com/books/content?id=P_YUEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The daughter of the banished moon goddess must free her mother from an immortal prison.",
    "rating": 4.06,
    "ratingsCount": 127729,
    "pageCount": 512,
    "awards": [
      "Goodreads Choice Award Finalist Fantasy (2022)",
      "Goodreads Choice Award Finalist Debut Novel (2022)"
    ],
    "categories": [
      "Fantasy",
      "Mythology"
    ],
    "scores": {
      "fantasy": 10,
      "character": 9,
      "medium": 7,
      "optimistic": 7,
      "atmosphere": 9,
      "series": 9,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 706,
    "title": "The Night Circus",
    "author": "Erin Morgenstern",
    "publicationYear": 2011,
    "isbn": "0385534639",
    "googleBooksId": "placeholder706",
    "image": "https://books.google.com/books/content?id=cZJ4EAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Two magicians compete in a mysterious circus that appears without warning.",
    "rating": 4,
    "ratingsCount": 929646,
    "pageCount": 506,
    "awards": [
      "Locus Award Finalist (2012)"
    ],
    "categories": [
      "Fantasy",
      "Romance"
    ],
    "scores": {
      "fantasy": 10,
      "heart": 9,
      "atmosphere": 10,
      "character": 9,
      "slow": 8,
      "standalone": 10,
      "plot": 5,
      "modern": 8,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 709,
    "title": "Upgrade",
    "author": "Blake Crouch",
    "publicationYear": 2022,
    "isbn": "0593157524",
    "googleBooksId": "placeholder709",
    "image": "https://books.google.com/books/content?id=1KgCEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Logan Ramsay is an agent for a task force that prevents illegal genetic engineering. When he's infected with a virus that upgrades his genome, he becomes something more than human.",
    "rating": 3.81,
    "ratingsCount": 120923,
    "pageCount": 352,
    "categories": [
      "Science Fiction",
      "Thriller"
    ],
    "scores": {
      "scifi": 10,
      "thriller": 9,
      "character": 8,
      "fast": 9,
      "optimistic": 5,
      "plot": 9,
      "standalone": 10,
      "modern": 10,
      "mind": 9,
      "emotional": 6
    }
  },
  {
    "id": 710,
    "title": "The Last Mrs. Parrish",
    "author": "Liv Constantine",
    "publicationYear": 2017,
    "series": {
      "name": "Mrs. Parrish",
      "position": 1
    },
    "isbn": "0062667572",
    "googleBooksId": "placeholder710",
    "image": "https://books.google.com/books/content?id=T-ZNEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A woman befriends a wealthy socialite with plans to steal her husband and her life.",
    "rating": 3.95,
    "ratingsCount": 465699,
    "pageCount": 390,
    "awards": [
      "Reese Witherspoon Book Club Pick"
    ],
    "categories": [
      "Thriller",
      "Psychological"
    ],
    "scores": {
      "thriller": 10,
      "plot": 10,
      "fast": 9,
      "dark": 9,
      "character": 8,
      "standalone": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7,
      "atmosphere": 6
    }
  },
  {
    "id": 711,
    "title": "Run Rose Run",
    "author": "Dolly Parton, James Patterson",
    "publicationYear": 2022,
    "isbn": "1538723972",
    "googleBooksId": "placeholder711",
    "image": "https://books.google.com/books/content?id=WGY3EAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A young singer-songwriter running from her past arrives in Nashville to chase her dreams.",
    "rating": 3.87,
    "ratingsCount": 98543,
    "pageCount": 448,
    "categories": [
      "Thriller",
      "Contemporary Fiction"
    ],
    "scores": {
      "thriller": 8,
      "contemporary": 9,
      "character": 8,
      "fast": 9,
      "dark": 6,
      "plot": 8,
      "standalone": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 714,
    "title": "Olga Dies Dreaming",
    "author": "Xochitl Gonzalez",
    "publicationYear": 2022,
    "isbn": "1250786177",
    "googleBooksId": "placeholder714",
    "image": "https://books.google.com/books/content?id=m2YWEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Olga is a successful wedding planner in Brooklyn. Her brother is a rising congressman. But their mother is a Puerto Rican revolutionary who abandoned them decades ago. A novel about family, identity, and gentrification.",
    "rating": 3.97,
    "ratingsCount": 71120,
    "pageCount": 369,
    "awards": [
      "Brooklyn Public Library Book Prize (2022)",
      "New York City Book Awards (2022)"
    ],
    "categories": [
      "Contemporary Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "literary": 8,
      "character": 9,
      "fast": 7,
      "optimistic": 6,
      "plot": 8,
      "standalone": 10,
      "modern": 10,
      "emotional": 9,
      "romance": 6,
      "accessible": 7
    }
  },
  {
    "id": 715,
    "title": "None of This Is True",
    "author": "Lisa Jewell",
    "publicationYear": 2023,
    "isbn": "1982179007",
    "googleBooksId": "placeholder715",
    "image": "https://books.google.com/books/content?id=OkCOEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A podcaster meets a woman who shares her birthday and becomes obsessed with telling her story.",
    "rating": 4.08,
    "ratingsCount": 1034955,
    "pageCount": 390,
    "categories": [
      "Thriller",
      "Psychological"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 8,
      "plot": 9,
      "fast": 8,
      "dark": 9,
      "character": 8,
      "standalone": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 717,
    "title": "The Lies I Tell",
    "author": "Julie Clark",
    "publicationYear": 2022,
    "isbn": "1728247594",
    "googleBooksId": "placeholder717",
    "image": "https://books.google.com/books/content?id=IyxNEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A con artist and a journalist play a dangerous game of cat and mouse.",
    "rating": 4.04,
    "ratingsCount": 69796,
    "pageCount": 302,
    "categories": [
      "Thriller",
      "Mystery"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 8,
      "plot": 9,
      "fast": 9,
      "dark": 7,
      "character": 8,
      "standalone": 10,
      "modern": 10,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 718,
    "title": "Local Woman Missing",
    "author": "Mary Kubica",
    "publicationYear": 2021,
    "isbn": "077831166X",
    "googleBooksId": "placeholder718",
    "image": "https://books.google.com/books/content?id=lnL7DwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A woman and a child vanish, then eleven years later the girl returns with no memory.",
    "rating": 4.12,
    "ratingsCount": 271894,
    "pageCount": 356,
    "categories": [
      "Thriller",
      "Mystery"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 9,
      "plot": 9,
      "fast": 9,
      "dark": 9,
      "standalone": 10,
      "modern": 10,
      "character": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 720,
    "title": "22 Seconds",
    "author": "James Patterson, Maxine Paetro",
    "publicationYear": 2022,
    "isbn": "0316499374",
    "googleBooksId": "placeholder720",
    "image": "https://books.google.com/books/content?id=6-ZIEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Detective Lindsay Boxer faces stolen weapons, a rogue cop, and threats to homeland security.",
    "rating": 4.1,
    "ratingsCount": 34505,
    "pageCount": 355,
    "categories": [
      "Thriller",
      "Mystery",
      "Crime"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 8,
      "crime": 9,
      "plot": 9,
      "fast": 10,
      "dark": 7,
      "series": 10,
      "modern": 10,
      "character": 5,
      "accessible": 7
    }
  },
  {
    "id": 721,
    "title": "The Last House on the Street",
    "author": "Diane Chamberlain",
    "publicationYear": 2022,
    "isbn": "1250267986",
    "googleBooksId": "placeholder721",
    "image": "https://books.google.com/books/content?id=aO4wEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A woman moving into a new neighborhood discovers her house has a dark connection to civil rights era secrets.",
    "rating": 4.02,
    "ratingsCount": 52847,
    "pageCount": 352,
    "categories": [
      "Mystery",
      "Historical Fiction"
    ],
    "scores": {
      "mystery": 9,
      "historical": 9,
      "character": 9,
      "medium": 7,
      "dark": 7,
      "emotional": 9,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 722,
    "title": "The Bromance Book Club",
    "author": "Lyssa Kay Adams",
    "publicationYear": 2019,
    "isbn": "1984806092",
    "googleBooksId": "placeholder722",
    "image": "https://books.google.com/books/content?id=JdRCEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A baseball player joins a secret book club to win back his wife.",
    "rating": 3.86,
    "ratingsCount": 134901,
    "pageCount": 352,
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 10,
      "character": 9,
      "fast": 8,
      "optimistic": 10,
      "comedy": 8,
      "series": 9,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 723,
    "title": "One Last Stop",
    "author": "Casey McQuiston",
    "publicationYear": 2021,
    "isbn": "1250244498",
    "googleBooksId": "placeholder723",
    "image": "https://books.google.com/books/content?id=OyEWEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A woman falls for a time-displaced girl stuck on the subway.",
    "rating": 3.91,
    "ratingsCount": 259293,
    "pageCount": 377,
    "awards": [
      "Goodreads Choice Award Nominee Romance (2021)"
    ],
    "categories": [
      "Romance",
      "LGBTQ+",
      "Fantasy"
    ],
    "scores": {
      "heart": 10,
      "fantasy": 7,
      "contemporary": 10,
      "character": 10,
      "optimistic": 10,
      "standalone": 10,
      "modern": 10,
      "medium": 7,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 724,
    "title": "Act Your Age, Eve Brown",
    "author": "Talia Hibbert",
    "publicationYear": 2021,
    "isbn": "0062941275",
    "googleBooksId": "placeholder724",
    "image": "https://books.google.com/books/content?id=QN-czgEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A chaotic woman takes a job at a B&B run by a control freak.",
    "rating": 4.06,
    "ratingsCount": 77107,
    "pageCount": 400,
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 10,
      "character": 10,
      "fast": 8,
      "optimistic": 10,
      "comedy": 8,
      "series": 9,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 726,
    "title": "Reminders of Him",
    "author": "Colleen Hoover",
    "publicationYear": 2022,
    "isbn": "1542025605",
    "googleBooksId": "placeholder726",
    "image": "https://books.google.com/books/content?id=oAk5EAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "After years in prison, Kenna Rowan returns to fight for a relationship with her daughter.",
    "rating": 4.31,
    "ratingsCount": 1330416,
    "pageCount": 320,
    "awards": [
      "Goodreads Choice Award Nominee Romance (2022)"
    ],
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 10,
      "character": 10,
      "fast": 8,
      "emotional": 10,
      "dark": 7,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 730,
    "title": "From Blood and Ash",
    "author": "Jennifer L. Armentrout",
    "publicationYear": 2020,
    "isbn": "1952457009",
    "googleBooksId": "placeholder730",
    "image": "https://books.google.com/books/content?id=0fhxBQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A maiden chosen by the gods is forbidden to be touched but falls for her guard.",
    "rating": 4.21,
    "ratingsCount": 852574,
    "pageCount": 622,
    "awards": [
      "Goodreads Choice Award Best Romance (2020)"
    ],
    "categories": [
      "Fantasy",
      "Romance"
    ],
    "scores": {
      "fantasy": 10,
      "heart": 10,
      "dark": 8,
      "character": 9,
      "fast": 8,
      "series": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 731,
    "title": "The Fine Print",
    "author": "Lauren Asher",
    "publicationYear": 2021,
    "isbn": "1737507706",
    "googleBooksId": "placeholder731",
    "image": "https://books.google.com/books/content?id=UbxpzgEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A theme park heir must save Dreamland while falling for an employee with big ideas.",
    "rating": 3.8,
    "ratingsCount": 664707,
    "pageCount": 448,
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 10,
      "character": 8,
      "fast": 8,
      "optimistic": 9,
      "series": 9,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 732,
    "title": "Love and Other Words",
    "author": "Christina Lauren",
    "publicationYear": 2018,
    "isbn": "1501128019",
    "googleBooksId": "placeholder732",
    "image": "https://books.google.com/books/content?id=0rg2DwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Macy runs into Elliot, her first love, eleven years after tragedy drove them apart.",
    "rating": 4.21,
    "ratingsCount": 808725,
    "pageCount": 432,
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 10,
      "character": 10,
      "medium": 7,
      "emotional": 10,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 733,
    "title": "Hook, Line, and Sinker",
    "author": "Tessa Bailey",
    "publicationYear": 2022,
    "isbn": "0063045699",
    "googleBooksId": "placeholder733",
    "image": "https://books.google.com/books/content?id=vvUkEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A Hollywood production assistant befriends a small-town fisherman everyone thinks is just a player.",
    "rating": 3.87,
    "ratingsCount": 355306,
    "pageCount": 353,
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 10,
      "character": 10,
      "fast": 8,
      "optimistic": 9,
      "series": 8,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 734,
    "title": "Serpent & Dove",
    "author": "Shelby Mahurin",
    "publicationYear": 2019,
    "isbn": "0062878034",
    "googleBooksId": "placeholder734",
    "image": "https://books.google.com/books/content?id=hxsLEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A witch hiding in plain sight is forced to marry a witch hunter.",
    "rating": 3.97,
    "ratingsCount": 345654,
    "pageCount": 513,
    "categories": [
      "Fantasy",
      "Romance"
    ],
    "scores": {
      "fantasy": 10,
      "heart": 9,
      "dark": 7,
      "character": 9,
      "fast": 8,
      "series": 9,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 736,
    "title": "The Deal",
    "author": "Elle Kennedy",
    "publicationYear": 2015,
    "isbn": "1775293939",
    "googleBooksId": "placeholder736",
    "image": "https://books.google.com/books/content?id=SaWqsgEACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A hockey star offers to tutor a music major in exchange for her pretending to date him.",
    "rating": 4.2,
    "ratingsCount": 1045969,
    "pageCount": 360,
    "awards": [
      "Goodreads Choice Award Nominee Romance (2015)"
    ],
    "categories": [
      "Romance",
      "New Adult",
      "Sports"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 10,
      "character": 9,
      "fast": 9,
      "optimistic": 9,
      "series": 9,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 737,
    "title": "The Marriage Portrait",
    "author": "Maggie O'Farrell",
    "publicationYear": 2022,
    "isbn": "0593320662",
    "googleBooksId": "placeholder737",
    "image": "https://books.google.com/books/content?id=JuLhBAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Lucrezia de' Medici is fifteen when she marries the Duke of Ferrara. But as she realizes her husband may want her dead, she must use her wits and artistic talents to survive Renaissance Italy's deadliest court.",
    "rating": 3.96,
    "ratingsCount": 138318,
    "pageCount": 355,
    "awards": [
      "Reese's Book Club Pick",
      "Carnegie Medal for Excellence Nominee (2023)"
    ],
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "historical": 10,
      "literary": 10,
      "character": 9,
      "slow": 7,
      "optimistic": 4,
      "plot": 9,
      "standalone": 10,
      "emotional": 9,
      "thriller": 7,
      "modern": 8
    }
  },
  {
    "id": 738,
    "title": "Empire of the Vampire",
    "author": "Jay Kristoff",
    "publicationYear": 2021,
    "series": {
      "name": "Empire of the Vampire",
      "position": 1
    },
    "isbn": "1250245281",
    "googleBooksId": "placeholder738",
    "image": "https://books.google.com/books/content?id=Wk88DwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Gabriel de León, half-vampire silversaint, tells his story to a historian while imprisoned. Once he was the order's greatest warrior. Now he may be humanity's last hope.",
    "rating": 4.33,
    "ratingsCount": 182456,
    "pageCount": 725,
    "categories": [
      "Fantasy",
      "Horror"
    ],
    "scores": {
      "fantasy": 10,
      "horror": 8,
      "character": 9,
      "slow": 7,
      "plot": 9,
      "standalone": 8,
      "modern": 10,
      "adventure": 8,
      "dark": 7,
      "accessible": 7
    }
  },
  {
    "id": 739,
    "title": "Empire of Pain",
    "author": "Patrick Radden Keefe",
    "publicationYear": 2021,
    "isbn": "0385545681",
    "googleBooksId": "placeholder739",
    "image": "https://books.google.com/books/content?id=2tkEEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The Sackler family and the opioid crisis they helped create.",
    "rating": 4.54,
    "ratingsCount": 121190,
    "pageCount": 535,
    "awards": [
      "Baillie Gifford Prize for Non-fiction (2021)",
      "Goodreads Choice Award History & Biography (2021)"
    ],
    "categories": [
      "Nonfiction",
      "History"
    ],
    "scores": {
      "nonfiction": 10,
      "history": 10,
      "dark": 9,
      "character": 9,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 741,
    "title": "Shōgun",
    "author": "James Clavell",
    "publicationYear": 1975,
    "isbn": "1982537523",
    "googleBooksId": "placeholder741",
    "image": "https://books.google.com/books/content?id=MH3tDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "An English navigator becomes embroiled in feudal Japanese politics.",
    "rating": 4.41,
    "ratingsCount": 213108,
    "pageCount": 1152,
    "categories": [
      "Historical Fiction",
      "Adventure"
    ],
    "scores": {
      "historical": 10,
      "adventure": 9,
      "character": 10,
      "slow": 8,
      "dark": 7,
      "atmosphere": 10,
      "series": 9,
      "classic": 9,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 742,
    "title": "The Tea Girl of Hummingbird Lane",
    "author": "Lisa See",
    "publicationYear": 2017,
    "isbn": "1501154834",
    "googleBooksId": "placeholder742",
    "image": "https://books.google.com/books/content?id=aTqGDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A mother and daughter separated by adoption are connected by ancient tea traditions.",
    "rating": 4.29,
    "ratingsCount": 108560,
    "pageCount": 384,
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "historical": 9,
      "literary": 9,
      "character": 10,
      "medium": 7,
      "emotional": 10,
      "heart": 9,
      "standalone": 10,
      "plot": 5,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 743,
    "title": "A Town Like Alice",
    "author": "Nevil Shute",
    "publicationYear": 1950,
    "isbn": "0307474003",
    "googleBooksId": "placeholder743",
    "image": "https://books.google.com/books/content?id=rjf2DwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A woman prisoner in WWII Malaya later seeks to transform an Australian town.",
    "rating": 4.13,
    "ratingsCount": 49243,
    "pageCount": 351,
    "categories": [
      "Historical Fiction",
      "Classic"
    ],
    "scores": {
      "historical": 10,
      "classic": 9,
      "character": 10,
      "slow": 7,
      "heart": 9,
      "standalone": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7,
      "atmosphere": 6
    }
  },
  {
    "id": 744,
    "title": "The Last Letter from Your Lover",
    "author": "Jojo Moyes",
    "publicationYear": 2011,
    "isbn": "0143121103",
    "googleBooksId": "placeholder744",
    "image": "https://books.google.com/books/content?id=s-bXL-LmD2MC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A journalist discovers love letters from the 1960s and becomes obsessed with learning the story behind them.",
    "rating": 4,
    "ratingsCount": 139551,
    "pageCount": 390,
    "categories": [
      "Historical Fiction",
      "Romance"
    ],
    "scores": {
      "historical": 9,
      "heart": 10,
      "character": 9,
      "medium": 7,
      "emotional": 9,
      "standalone": 10,
      "plot": 5,
      "modern": 8,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 746,
    "title": "The House of the Spirits",
    "author": "Isabel Allende",
    "publicationYear": 1982,
    "isbn": "1501117017",
    "googleBooksId": "placeholder746",
    "image": "https://books.google.com/books/content?id=k8nItJbwXv8C&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Four generations of a Chilean family through political upheaval.",
    "rating": 4.26,
    "ratingsCount": 209398,
    "pageCount": 448,
    "categories": [
      "Literary Fiction",
      "Magical Realism"
    ],
    "scores": {
      "literary": 10,
      "historical": 9,
      "character": 10,
      "slow": 7,
      "dark": 8,
      "emotional": 10,
      "standalone": 10,
      "plot": 5,
      "classic": 5,
      "modern": 7
    }
  },
  {
    "id": 747,
    "title": "The Girl with the Louding Voice",
    "author": "Abi Dare",
    "publicationYear": 2020,
    "isbn": "0525510117",
    "googleBooksId": "placeholder747",
    "image": "https://books.google.com/books/content?id=i0WUDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A teenage Nigerian girl fights for her education and freedom against impossible odds.",
    "rating": 4.42,
    "ratingsCount": 171544,
    "pageCount": 371,
    "awards": [
      "Bath Novel Award (2018)",
      "Read with Jenna Pick"
    ],
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "historical": 8,
      "literary": 9,
      "character": 10,
      "medium": 7,
      "dark": 8,
      "emotional": 10,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 748,
    "title": "The Girl from the Channel Islands",
    "author": "Jenny Lecoat",
    "publicationYear": 2021,
    "isbn": "1525806416",
    "googleBooksId": "placeholder748",
    "image": "https://books.google.com/books/content?id=I_AFEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Based on the true story of a young woman who shelters a slave laborer during the Nazi occupation.",
    "rating": 3.9,
    "ratingsCount": 11638,
    "pageCount": 304,
    "categories": [
      "Historical Fiction",
      "World War II"
    ],
    "scores": {
      "historical": 10,
      "heart": 9,
      "character": 10,
      "medium": 7,
      "dark": 8,
      "emotional": 9,
      "standalone": 10,
      "plot": 5,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 749,
    "title": "Cutting for Stone",
    "author": "Abraham Verghese",
    "publicationYear": 2009,
    "isbn": "0375714367",
    "googleBooksId": "placeholder749",
    "image": "https://books.google.com/books/content?id=cxteDAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Twin brothers born to a secret affair in Ethiopia become surgeons.",
    "rating": 4.32,
    "ratingsCount": 369783,
    "pageCount": 560,
    "categories": [
      "Literary Fiction",
      "Historical Fiction"
    ],
    "scores": {
      "literary": 10,
      "historical": 9,
      "character": 10,
      "slow": 8,
      "emotional": 10,
      "heart": 9,
      "standalone": 10,
      "plot": 5,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 750,
    "title": "The Island of Sea Women",
    "author": "Lisa See",
    "publicationYear": 2019,
    "isbn": "1501154869",
    "googleBooksId": "placeholder750",
    "image": "https://books.google.com/books/content?id=2cVjDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Two female divers on a Korean island form a friendship tested by WWII and its aftermath.",
    "rating": 4.3,
    "ratingsCount": 125578,
    "pageCount": 374,
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "historical": 10,
      "literary": 9,
      "character": 10,
      "medium": 7,
      "dark": 8,
      "emotional": 10,
      "atmosphere": 9,
      "standalone": 10,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 753,
    "title": "Sea of Tranquility",
    "author": "Emily St. John Mandel",
    "publicationYear": 2022,
    "isbn": "0593321448",
    "googleBooksId": "placeholder753",
    "image": "https://books.google.com/books/content?id=nVhIEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A novel that spans centuries and planets, from the Canadian wilderness in 1912 to a lunar colony 500 years from now. Are we living in a simulation? What makes a moment real?",
    "rating": 4,
    "ratingsCount": 215843,
    "pageCount": 255,
    "awards": [
      "Goodreads Choice Award Best Science Fiction (2022)"
    ],
    "categories": [
      "Science Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "scifi": 8,
      "literary": 10,
      "character": 8,
      "slow": 7,
      "optimistic": 7,
      "plot": 9,
      "standalone": 10,
      "modern": 10,
      "mind": 10,
      "emotional": 7
    }
  },
  {
    "id": 754,
    "title": "Shuggie Bain",
    "author": "Douglas Stuart",
    "publicationYear": 2020,
    "isbn": "0802148042",
    "googleBooksId": "placeholder754",
    "image": "https://books.google.com/books/content?id=5NgCEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A boy in 1980s Glasgow tries to save his alcoholic mother.",
    "rating": 4.3,
    "ratingsCount": 192104,
    "pageCount": 430,
    "awards": [
      "Booker Prize (2020)",
      "British Book Award Book of the Year (2021)",
      "Los Angeles Times Book Prize First Fiction (2020)",
      "Lambda Literary Award Gay Fiction (2020)",
      "Dayton Literary Peace Prize Fiction (2021)",
      "National Book Award Finalist Fiction (2020)",
      "Kirkus Prize Fiction (2020)",
      "Goodreads Choice Award Historical Fiction and Debut Novel (2020)"
    ],
    "categories": [
      "Literary Fiction",
      "Historical Fiction"
    ],
    "scores": {
      "literary": 10,
      "historical": 8,
      "character": 10,
      "slow": 7,
      "dark": 10,
      "emotional": 10,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 756,
    "title": "Cloud Atlas",
    "author": "David Mitchell",
    "publicationYear": 2004,
    "isbn": "0375507256",
    "googleBooksId": "placeholder756",
    "image": "https://books.google.com/books/content?id=-Fs0DwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Six interconnected stories span from the Pacific in 1850 to a post-apocalyptic future.",
    "rating": 4.01,
    "ratingsCount": 268301,
    "pageCount": 509,
    "awards": [
      "British Book Awards Literary Fiction Award",
      "Booker Prize Shortlist (2004)",
      "Nebula Award Nominee (2005)"
    ],
    "categories": [
      "Literary Fiction",
      "Science Fiction"
    ],
    "scores": {
      "literary": 10,
      "scifi": 8,
      "character": 9,
      "slow": 7,
      "mind": 10,
      "atmosphere": 10,
      "standalone": 10,
      "plot": 5,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 759,
    "title": "White Oleander",
    "author": "Janet Fitch",
    "publicationYear": 1999,
    "isbn": "0316569321",
    "googleBooksId": "placeholder759",
    "image": "https://books.google.com/books/content?id=Fqd4EAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A girl moves through foster homes after her mother commits murder.",
    "rating": 3.98,
    "ratingsCount": 349562,
    "pageCount": 480,
    "awards": [
      "Oprah Book Club Pick"
    ],
    "categories": [
      "Literary Fiction",
      "Coming of Age"
    ],
    "scores": {
      "literary": 10,
      "character": 10,
      "dark": 9,
      "emotional": 10,
      "standalone": 10,
      "medium": 7,
      "slow": 5,
      "plot": 5,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 763,
    "title": "Hello Beautiful",
    "author": "Ann Napolitano",
    "publicationYear": 2023,
    "isbn": "0593243730",
    "googleBooksId": "placeholder763",
    "image": "https://books.google.com/books/content?id=gFVaEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Four sisters in 1960s Chicago find their bond tested when one of them makes a choice that will ripple through their family for decades. A multigenerational saga of love and loyalty.",
    "rating": 4.13,
    "ratingsCount": 473609,
    "pageCount": 416,
    "awards": [
      "Oprah Book Club Pick"
    ],
    "categories": [
      "Literary Fiction",
      "Historical Fiction"
    ],
    "scores": {
      "literary": 9,
      "historical": 7,
      "character": 10,
      "slow": 7,
      "optimistic": 7,
      "plot": 8,
      "standalone": 10,
      "emotional": 10,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 766,
    "title": "Great Circle",
    "author": "Maggie Shipstead",
    "publicationYear": 2021,
    "isbn": "0525656979",
    "googleBooksId": "placeholder766",
    "image": "https://books.google.com/books/content?id=J0P2DwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Two women a century apart—a female pilot and a Hollywood actress playing her in a film—search for freedom.",
    "rating": 4.05,
    "ratingsCount": 53210,
    "pageCount": 608,
    "awards": [
      "Booker Prize Shortlist (2021)"
    ],
    "categories": [
      "Literary Fiction",
      "Historical Fiction"
    ],
    "scores": {
      "literary": 10,
      "historical": 9,
      "character": 10,
      "slow": 8,
      "atmosphere": 9,
      "emotional": 8,
      "standalone": 10,
      "plot": 5,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 767,
    "title": "Think Again",
    "author": "Adam Grant",
    "publicationYear": 2021,
    "isbn": "1984878107",
    "googleBooksId": "placeholder767",
    "image": "https://books.google.com/books/content?id=--o0EAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "An examination of how to embrace the unknown and rethink our most deeply held beliefs.",
    "rating": 4.11,
    "ratingsCount": 132603,
    "pageCount": 307,
    "categories": [
      "Nonfiction",
      "Psychology",
      "Self-Help"
    ],
    "scores": {
      "nonfiction": 10,
      "selfhelp": 9,
      "mind": 10,
      "fast": 8,
      "optimistic": 8,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6,
      "accessible": 7
    }
  },
  {
    "id": 768,
    "title": "Humankind: A Hopeful History",
    "author": "Rutger Bregman",
    "publicationYear": 2020,
    "isbn": "0316418536",
    "googleBooksId": "placeholder768",
    "image": "https://books.google.com/books/content?id=rTsGEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A new perspective on the past 200,000 years of human history. Humans evolved to cooperate, not compete—and rethinking this changes everything about how we see ourselves.",
    "rating": 4.37,
    "ratingsCount": 30021,
    "pageCount": 462,
    "categories": [
      "Nonfiction",
      "History"
    ],
    "scores": {
      "nonfiction": 10,
      "historical": 8,
      "character": 6,
      "slow": 7,
      "optimistic": 10,
      "mind": 10,
      "standalone": 10,
      "modern": 10,
      "plot": 7,
      "accessible": 7
    }
  },
  {
    "id": 769,
    "title": "How Minds Change",
    "author": "David McRaney",
    "publicationYear": 2022,
    "isbn": "0593190297",
    "googleBooksId": "placeholder769",
    "image": "https://books.google.com/books/content?id=QLjPEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Why is it so hard to change someone's mind? Science journalist David McRaney explores the surprising science of belief, persuasion, and how people actually update their views.",
    "rating": 4.01,
    "ratingsCount": 14853,
    "pageCount": 300,
    "categories": [
      "Nonfiction",
      "Psychology"
    ],
    "scores": {
      "nonfiction": 10,
      "mind": 10,
      "character": 7,
      "slow": 7,
      "optimistic": 8,
      "standalone": 10,
      "modern": 10,
      "plot": 7,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 770,
    "title": "Hidden Potential",
    "author": "Adam Grant",
    "publicationYear": 2023,
    "isbn": "0593653149",
    "googleBooksId": "placeholder770",
    "image": "https://books.google.com/books/content?id=a1CwEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The science of achieving greater things, focusing on how to unlock your potential and that of others.",
    "rating": 4.08,
    "ratingsCount": 42031,
    "pageCount": 304,
    "categories": [
      "Nonfiction",
      "Self-Help",
      "Psychology"
    ],
    "scores": {
      "nonfiction": 10,
      "selfhelp": 10,
      "mind": 9,
      "fast": 8,
      "optimistic": 10,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6,
      "accessible": 7
    }
  },
  {
    "id": 771,
    "title": "Outlive",
    "author": "Peter Attia",
    "publicationYear": 2023,
    "isbn": "0593236599",
    "googleBooksId": "placeholder771",
    "image": "https://books.google.com/books/content?id=7R9bEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The science and art of longevity, offering a blueprint for living longer and better.",
    "rating": 4.33,
    "ratingsCount": 95156,
    "pageCount": 496,
    "categories": [
      "Nonfiction",
      "Health",
      "Science"
    ],
    "scores": {
      "nonfiction": 10,
      "science": 9,
      "selfhelp": 8,
      "mind": 9,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6,
      "emotional": 6
    }
  },
  {
    "id": 773,
    "title": "What My Bones Know",
    "author": "Stephanie Foo",
    "publicationYear": 2022,
    "isbn": "0593238125",
    "googleBooksId": "placeholder773",
    "image": "https://books.google.com/books/content?id=XFvQDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A journalist discovers she has Complex PTSD from childhood abuse. Her journey to understand her diagnosis leads her to the cutting edge of trauma research and to healing.",
    "rating": 4.49,
    "ratingsCount": 76365,
    "pageCount": 352,
    "awards": [
      "Goodreads Choice Award Finalist Nonfiction (2022)"
    ],
    "categories": [
      "Memoir",
      "Nonfiction"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 9,
      "character": 9,
      "slow": 6,
      "optimistic": 7,
      "emotional": 10,
      "modern": 10,
      "mind": 9,
      "plot": 5,
      "standalone": 8
    }
  },
  {
    "id": 774,
    "title": "The Anthropocene Reviewed",
    "author": "John Green",
    "publicationYear": 2021,
    "isbn": "0525555218",
    "googleBooksId": "placeholder774",
    "image": "https://books.google.com/books/content?id=YTUGEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Essays reviewing different facets of the human-centered planet on a five-star scale.",
    "rating": 4.24,
    "ratingsCount": 128547,
    "pageCount": 293,
    "awards": [
      "Goodreads Choice Award Best Nonfiction (2021)"
    ],
    "categories": [
      "Nonfiction",
      "Essays",
      "Memoir"
    ],
    "scores": {
      "nonfiction": 10,
      "memoir": 8,
      "literary": 8,
      "mind": 9,
      "medium": 7,
      "heart": 9,
      "emotional": 8,
      "standalone": 10,
      "modern": 10,
      "character": 8,
      "plot": 5
    }
  },
  {
    "id": 775,
    "title": "The Reformatory",
    "author": "Tananarive Due",
    "publicationYear": 2023,
    "isbn": "1982188286",
    "googleBooksId": "placeholder775",
    "image": "https://books.google.com/books/content?id=lp1gDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In Jim Crow Florida, 12-year-old Robert is sent to a brutal reform school. But the ghosts of boys who died there have unfinished business—and Robert can see them.",
    "rating": 4.42,
    "ratingsCount": 55435,
    "pageCount": 576,
    "categories": [
      "Horror",
      "Historical Fiction"
    ],
    "scores": {
      "horror": 9,
      "historical": 9,
      "character": 9,
      "fast": 7,
      "optimistic": 4,
      "plot": 9,
      "standalone": 10,
      "modern": 10,
      "emotional": 9,
      "accessible": 7
    }
  },
  {
    "id": 776,
    "title": "Chain-Gang All-Stars",
    "author": "Nana Kwame Adjei-Brenyah",
    "publicationYear": 2023,
    "isbn": "0593317335",
    "googleBooksId": "placeholder776",
    "image": "https://books.google.com/books/content?id=3zH2DwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In a dystopian America, prisoners fight to the death in a televised gladiator program. Two women in love fight for survival in this searing critique of mass incarceration.",
    "rating": 4.12,
    "ratingsCount": 74366,
    "pageCount": 384,
    "awards": [
      "National Book Award Finalist (2023)"
    ],
    "categories": [
      "Science Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "scifi": 8,
      "literary": 9,
      "character": 9,
      "fast": 8,
      "optimistic": 3,
      "plot": 9,
      "standalone": 10,
      "modern": 10,
      "emotional": 9,
      "accessible": 7
    }
  },
  {
    "id": 778,
    "title": "What Happened to You?",
    "author": "Bruce D. Perry, Oprah Winfrey",
    "publicationYear": 2021,
    "isbn": "1250223180",
    "googleBooksId": "placeholder778",
    "image": "https://books.google.com/books/content?id=1v4MEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A conversation about trauma, resilience, and healing, shifting the question from 'What's wrong?' to 'What happened?'",
    "rating": 4.52,
    "ratingsCount": 98745,
    "pageCount": 262,
    "categories": [
      "Nonfiction",
      "Psychology",
      "Self-Help"
    ],
    "scores": {
      "nonfiction": 10,
      "selfhelp": 9,
      "psychology": 10,
      "mind": 9,
      "medium": 7,
      "emotional": 9,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6
    }
  },
  {
    "id": 779,
    "title": "Breath",
    "author": "James Nestor",
    "publicationYear": 2020,
    "isbn": "0735213615",
    "googleBooksId": "placeholder779",
    "image": "https://books.google.com/books/content?id=4xitDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "The lost art and science of breathing, and how it can transform your health.",
    "rating": 4.14,
    "ratingsCount": 115754,
    "pageCount": 280,
    "categories": [
      "Nonfiction",
      "Health",
      "Science"
    ],
    "scores": {
      "nonfiction": 10,
      "science": 8,
      "selfhelp": 9,
      "mind": 8,
      "fast": 8,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6,
      "emotional": 6
    }
  },
  {
    "id": 780,
    "title": "Will",
    "author": "Will Smith",
    "publicationYear": 2021,
    "isbn": "1984877925",
    "googleBooksId": "placeholder780",
    "image": "https://books.google.com/books/content?id=sQYqRCIhFAMC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Will Smith's journey from West Philadelphia to Hollywood stardom. An honest memoir about fear, discipline, family, and the difference between achievement and happiness.",
    "rating": 4.12,
    "ratingsCount": 48956,
    "pageCount": 413,
    "categories": [
      "Memoir",
      "Nonfiction"
    ],
    "scores": {
      "memoir": 10,
      "nonfiction": 8,
      "character": 9,
      "fast": 7,
      "optimistic": 8,
      "emotional": 8,
      "modern": 10,
      "plot": 5,
      "standalone": 8,
      "accessible": 7
    }
  },
  {
    "id": 781,
    "title": "Dopamine Nation",
    "author": "Anna Lembke",
    "publicationYear": 2021,
    "isbn": "152474672X",
    "googleBooksId": "placeholder781",
    "image": "https://books.google.com/books/content?id=rLQQEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A psychiatrist explores how to find balance in an age of addiction and overindulgence.",
    "rating": 3.86,
    "ratingsCount": 68791,
    "pageCount": 304,
    "categories": [
      "Nonfiction",
      "Psychology",
      "Health"
    ],
    "scores": {
      "nonfiction": 10,
      "psychology": 10,
      "selfhelp": 8,
      "mind": 10,
      "medium": 7,
      "standalone": 10,
      "modern": 10,
      "character": 7,
      "plot": 6,
      "emotional": 6
    }
  },
  {
    "id": 782,
    "title": "Maame",
    "author": "Jessica George",
    "publicationYear": 2023,
    "isbn": "1250282527",
    "googleBooksId": "placeholder782",
    "image": "https://books.google.com/books/content?id=bj3dCQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Maddie is caught between her Ghanaian parents' expectations and her own desires. When her father dies, she must navigate grief, identity, and finally living for herself.",
    "rating": 4.03,
    "ratingsCount": 96387,
    "pageCount": 320,
    "awards": [
      "Read with Jenna Book Club Pick"
    ],
    "categories": [
      "Contemporary Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "literary": 8,
      "character": 10,
      "fast": 7,
      "optimistic": 7,
      "plot": 7,
      "standalone": 10,
      "modern": 10,
      "emotional": 9,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 784,
    "title": "The Fragile Threads of Power",
    "author": "V.E. Schwab",
    "publicationYear": 2023,
    "series": {
      "name": "Threads of Power",
      "position": 1
    },
    "isbn": "0765387492",
    "googleBooksId": "placeholder784",
    "image": "https://books.google.com/books/content?id=G_uwWAGG9v4C&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Seven years after the Londons were sealed, a new force threatens the balance of magic. Three outcasts must work together to save their worlds in this epic fantasy.",
    "rating": 4.26,
    "ratingsCount": 46490,
    "pageCount": 648,
    "categories": [
      "Fantasy",
      "Adventure"
    ],
    "scores": {
      "fantasy": 10,
      "adventure": 9,
      "character": 9,
      "fast": 8,
      "optimistic": 6,
      "plot": 9,
      "standalone": 8,
      "modern": 10,
      "emotional": 8,
      "accessible": 7
    }
  },
  {
    "id": 785,
    "title": "A Day of Fallen Night",
    "author": "Samantha Shannon",
    "publicationYear": 2023,
    "series": {
      "name": "The Roots of Chaos",
      "position": 1
    },
    "isbn": "1639731075",
    "googleBooksId": "placeholder785",
    "image": "https://books.google.com/books/content?id=TnlcPgAACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A sweeping prequel set in the world of The Priory of the Orange Tree. As a great evil awakens, queens, dragonriders, and warriors must unite across continents.",
    "rating": 4.32,
    "ratingsCount": 45873,
    "pageCount": 868,
    "categories": [
      "Fantasy",
      "Adventure"
    ],
    "scores": {
      "fantasy": 10,
      "adventure": 9,
      "character": 9,
      "slow": 7,
      "optimistic": 6,
      "plot": 9,
      "standalone": 8,
      "modern": 10,
      "emotional": 8,
      "accessible": 7
    }
  },
  {
    "id": 787,
    "title": "In Memoriam",
    "author": "Alice Winn",
    "publicationYear": 2023,
    "isbn": "0593534565",
    "googleBooksId": "placeholder787",
    "image": "https://books.google.com/books/content?id=pO67DAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "At an English boarding school, Gaunt and Ellwood are rivals. Then WWI begins. In the trenches of France, their relationship becomes something neither expected.",
    "rating": 4.5,
    "ratingsCount": 74868,
    "pageCount": 382,
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "historical": 10,
      "literary": 9,
      "character": 10,
      "slow": 7,
      "optimistic": 3,
      "plot": 8,
      "standalone": 10,
      "emotional": 10,
      "romance": 8,
      "modern": 8
    }
  },
  {
    "id": 788,
    "title": "The World We Make",
    "author": "N.K. Jemisin",
    "publicationYear": 2022,
    "series": {
      "name": "Great Cities",
      "position": 2
    },
    "isbn": "0316509906",
    "googleBooksId": "placeholder788",
    "image": "https://books.google.com/books/content?id=M2t1H8BEI2sC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "New York's avatar cities continue their fight against an ancient evil that threatens to consume them. The sequel to The City We Became.",
    "rating": 4.04,
    "ratingsCount": 13899,
    "pageCount": 357,
    "categories": [
      "Fantasy",
      "Science Fiction"
    ],
    "scores": {
      "fantasy": 9,
      "scifi": 8,
      "character": 9,
      "fast": 8,
      "optimistic": 6,
      "plot": 9,
      "standalone": 8,
      "modern": 10,
      "mind": 8,
      "accessible": 7
    }
  },
  {
    "id": 789,
    "title": "Someone Else's Shoes",
    "author": "Jojo Moyes",
    "publicationYear": 2023,
    "isbn": "1984879294",
    "googleBooksId": "placeholder789",
    "image": "https://books.google.com/books/content?id=IWwwD_VVipcC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Two women's lives collide when they accidentally swap gym bags. One loses everything; the other gains unexpected opportunities. A story of reinvention.",
    "rating": 3.96,
    "ratingsCount": 241028,
    "pageCount": 438,
    "categories": [
      "Contemporary Fiction",
      "Romance"
    ],
    "scores": {
      "character": 9,
      "fast": 8,
      "optimistic": 9,
      "plot": 8,
      "standalone": 10,
      "modern": 10,
      "emotional": 8,
      "romance": 7,
      "comedy": 7,
      "accessible": 7
    }
  },
  {
    "id": 793,
    "title": "We Have Always Lived in the Castle",
    "author": "Shirley Jackson",
    "publicationYear": 1962,
    "isbn": "0143039970",
    "googleBooksId": "placeholder793",
    "image": "https://books.google.com/books/content?id=_wd6twAACAAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Two sisters live isolated after most of their family was poisoned.",
    "rating": 3.92,
    "ratingsCount": 228452,
    "pageCount": 214,
    "categories": [
      "Horror",
      "Gothic",
      "Classic"
    ],
    "scores": {
      "horror": 9,
      "gothic": 10,
      "classic": 9,
      "atmosphere": 10,
      "character": 10,
      "slow": 7,
      "dark": 9,
      "standalone": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 798,
    "title": "The Troop",
    "author": "Nick Cutter",
    "publicationYear": 2014,
    "isbn": "1476717729",
    "googleBooksId": "placeholder798",
    "image": "https://books.google.com/books/content?id=FUdEAgAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A Boy Scout troop on a remote island encounters a stranger carrying a horrifying contagion.",
    "rating": 3.83,
    "ratingsCount": 94900,
    "pageCount": 358,
    "awards": [
      "James Herbert Award for Horror Writing (2015)"
    ],
    "categories": [
      "Horror",
      "Thriller"
    ],
    "scores": {
      "horror": 10,
      "thriller": 10,
      "plot": 9,
      "fast": 9,
      "dark": 10,
      "standalone": 10,
      "modern": 10,
      "character": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 801,
    "title": "What Moves the Dead",
    "author": "T. Kingfisher",
    "publicationYear": 2022,
    "series": {
      "name": "Sworn Soldier",
      "position": 1
    },
    "isbn": "1250830753",
    "googleBooksId": "placeholder801",
    "image": "https://books.google.com/books/content?id=cplTEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A retelling of 'The Fall of the House of Usher' about a soldier visiting their ailing friend.",
    "rating": 3.84,
    "ratingsCount": 141060,
    "pageCount": 165,
    "awards": [
      "Locus Award Best Horror Novel (2023)",
      "Hugo Award Finalist (2023)"
    ],
    "categories": [
      "Horror",
      "Gothic",
      "Novella"
    ],
    "scores": {
      "horror": 10,
      "gothic": 10,
      "atmosphere": 10,
      "character": 8,
      "fast": 9,
      "dark": 9,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 802,
    "title": "Writers & Lovers",
    "author": "Lily King",
    "publicationYear": 2020,
    "isbn": "0802148530",
    "googleBooksId": "placeholder802",
    "image": "https://books.google.com/books/content?id=dRQGEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A grieving woman juggles writing and two potential relationships.",
    "rating": 3.99,
    "ratingsCount": 181116,
    "pageCount": 320,
    "categories": [
      "Contemporary Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "contemporary": 10,
      "literary": 9,
      "character": 10,
      "fast": 8,
      "heart": 9,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 805,
    "title": "Every Summer After",
    "author": "Carley Fortune",
    "publicationYear": 2022,
    "isbn": "0593438531",
    "googleBooksId": "placeholder805",
    "image": "https://books.google.com/books/content?id=1g1KEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A woman returns to her childhood lake house and the boy next door she pushed away years ago.",
    "rating": 4.16,
    "ratingsCount": 679418,
    "pageCount": 320,
    "categories": [
      "Contemporary Fiction",
      "Romance"
    ],
    "scores": {
      "contemporary": 10,
      "heart": 10,
      "character": 10,
      "fast": 8,
      "emotional": 10,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 806,
    "title": "The Flatmate",
    "author": "Rosie Walsh",
    "publicationYear": 2019,
    "isbn": "1529099714",
    "googleBooksId": "placeholder806",
    "image": "https://books.google.com/books/content?id=_RytDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A woman discovers unsettling truths about her new flatmate.",
    "rating": 3.96,
    "ratingsCount": 287130,
    "pageCount": 329,
    "categories": [
      "Contemporary Fiction",
      "Mystery"
    ],
    "scores": {
      "contemporary": 10,
      "mystery": 8,
      "character": 9,
      "fast": 8,
      "dark": 6,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 809,
    "title": "The Storied Life of A.J. Fikry",
    "author": "Gabrielle Zevin",
    "publicationYear": 2014,
    "isbn": "1616203218",
    "googleBooksId": "placeholder809",
    "image": "https://books.google.com/books/content?id=S4-iDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A widowed bookstore owner's life changes when a rare book is stolen.",
    "rating": 4.01,
    "ratingsCount": 258633,
    "pageCount": 260,
    "categories": [
      "Contemporary Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "contemporary": 10,
      "literary": 8,
      "character": 10,
      "fast": 8,
      "optimistic": 9,
      "heart": 10,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 810,
    "title": "The Ferryman",
    "author": "Justin Cronin",
    "publicationYear": 2023,
    "isbn": "0525619496",
    "googleBooksId": "placeholder810",
    "image": "https://books.google.com/books/content?id=igoNEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "On a utopian island, people's memories are erased when they reach a certain age and they're sent to the Nursery to be reborn. But one ferryman begins to question everything.",
    "rating": 3.86,
    "ratingsCount": 28153,
    "pageCount": 538,
    "awards": [
      "Goodreads Choice Award Nominee for Best Science Fiction (2023)"
    ],
    "categories": [
      "Science Fiction",
      "Thriller"
    ],
    "scores": {
      "scifi": 10,
      "thriller": 8,
      "character": 8,
      "fast": 7,
      "optimistic": 5,
      "plot": 10,
      "standalone": 10,
      "modern": 10,
      "mind": 10,
      "emotional": 7
    }
  },
  {
    "id": 811,
    "title": "The Seven Moons of Maali Almeida",
    "author": "Shehan Karunatilaka",
    "publicationYear": 2022,
    "isbn": "132406482X",
    "googleBooksId": "placeholder811",
    "image": "https://books.google.com/books/content?id=7P1bDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Maali Almeida, war photographer, wakes up dead in 1990 Sri Lanka. He has seven moons to contact the living and lead them to the photos that could end the civil war.",
    "rating": 3.88,
    "ratingsCount": 44884,
    "pageCount": 386,
    "awards": [
      "Booker Prize Winner (2022)"
    ],
    "categories": [
      "Literary Fiction",
      "Fantasy"
    ],
    "scores": {
      "literary": 10,
      "fantasy": 7,
      "character": 9,
      "fast": 7,
      "plot": 9,
      "standalone": 10,
      "modern": 10,
      "emotional": 8,
      "historical": 8,
      "accessible": 7
    }
  },
  {
    "id": 812,
    "title": "Carrie Soto Is Back",
    "author": "Taylor Jenkins Reid",
    "publicationYear": 2022,
    "isbn": "0593158687",
    "googleBooksId": "placeholder812",
    "image": "https://books.google.com/books/content?id=XYxREAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A legendary tennis player comes out of retirement at 37 to reclaim her record.",
    "rating": 4.2,
    "ratingsCount": 718603,
    "pageCount": 384,
    "awards": [
      "Goodreads Choice Award Best Historical Fiction (2022)"
    ],
    "categories": [
      "Contemporary Fiction",
      "Sports"
    ],
    "scores": {
      "contemporary": 10,
      "character": 10,
      "fast": 8,
      "emotional": 9,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7,
      "atmosphere": 6
    }
  },
  {
    "id": 813,
    "title": "Vision in White",
    "author": "Nora Roberts",
    "publicationYear": 2009,
    "isbn": "0515150649",
    "googleBooksId": "placeholder813",
    "image": "https://books.google.com/books/content?id=5fIHEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A wedding photographer finds love while planning weddings.",
    "rating": 4.12,
    "ratingsCount": 143726,
    "pageCount": 343,
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 10,
      "character": 9,
      "fast": 8,
      "optimistic": 10,
      "series": 9,
      "plot": 5,
      "modern": 8,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 815,
    "title": "Ugly Love",
    "author": "Colleen Hoover",
    "publicationYear": 2014,
    "isbn": "1476753180",
    "googleBooksId": "placeholder815",
    "image": "https://books.google.com/books/content?id=u0J5DwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A woman agrees to a no-strings relationship with a damaged pilot.",
    "rating": 3.99,
    "ratingsCount": 2159260,
    "pageCount": 352,
    "categories": [
      "Romance",
      "Contemporary"
    ],
    "scores": {
      "heart": 10,
      "contemporary": 10,
      "character": 9,
      "fast": 9,
      "dark": 7,
      "emotional": 10,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 817,
    "title": "Skyward",
    "author": "Brandon Sanderson",
    "publicationYear": 2018,
    "isbn": "0399555773",
    "googleBooksId": "placeholder817",
    "image": "https://books.google.com/books/content?id=9pYtDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A girl dreams of becoming a pilot to fight aliens attacking her world.",
    "rating": 4.46,
    "ratingsCount": 166852,
    "pageCount": 510,
    "categories": [
      "Young Adult",
      "Science Fiction"
    ],
    "scores": {
      "scifi": 10,
      "character": 10,
      "fast": 9,
      "optimistic": 9,
      "series": 9,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7,
      "atmosphere": 6
    }
  },
  {
    "id": 818,
    "title": "Red Queen",
    "author": "Victoria Aveyard",
    "publicationYear": 2015,
    "isbn": "0062310631",
    "googleBooksId": "placeholder818",
    "image": "https://books.google.com/books/content?id=OoQ2BQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A girl with rare powers infiltrates a world divided by blood color.",
    "rating": 3.98,
    "ratingsCount": 1174759,
    "pageCount": 383,
    "awards": [
      "Goodreads Choice Award for Debut Goodreads Author (2015)"
    ],
    "categories": [
      "Young Adult",
      "Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "dark": 7,
      "character": 9,
      "fast": 9,
      "series": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7,
      "atmosphere": 6
    }
  },
  {
    "id": 819,
    "title": "Children of Blood and Bone",
    "author": "Tomi Adeyemi",
    "publicationYear": 2018,
    "isbn": "1250170974",
    "googleBooksId": "placeholder819",
    "image": "https://books.google.com/books/content?id=x2IoDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A young woman must restore magic to her oppressed people in a West African-inspired fantasy.",
    "rating": 4.11,
    "ratingsCount": 251413,
    "pageCount": 544,
    "awards": [
      "TIME's Top 100 Fantasy Books of All Time",
      "Kirkus Prize Finalist (2018)"
    ],
    "categories": [
      "Young Adult",
      "Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "adventure": 9,
      "character": 9,
      "fast": 8,
      "dark": 7,
      "series": 9,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 820,
    "title": "The Hate U Give",
    "author": "Angie Thomas",
    "publicationYear": 2017,
    "series": {
      "name": "The Hate U Give",
      "position": 1
    },
    "isbn": "0062498533",
    "googleBooksId": "placeholder820",
    "image": "https://books.google.com/books/content?id=l_fWDQAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Starr witnesses her best friend's fatal shooting by a police officer and must find her voice.",
    "rating": 4.45,
    "ratingsCount": 1014032,
    "pageCount": 454,
    "awards": [
      "National Book Award Young People's Literature (2017)",
      "William C. Morris YA Debut Award (2018)",
      "Carnegie Medal (2018)",
      "Goodreads Choice Award Young Adult Fiction (2017)",
      "Kirkus Prize Young Readers' Literature (2017)"
    ],
    "categories": [
      "Young Adult",
      "Contemporary",
      "Social Issues"
    ],
    "scores": {
      "contemporary": 10,
      "character": 10,
      "fast": 8,
      "dark": 8,
      "emotional": 10,
      "standalone": 10,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 823,
    "title": "I'll Give You the Sun",
    "author": "Jandy Nelson",
    "publicationYear": 2014,
    "isbn": "0803734964",
    "googleBooksId": "placeholder823",
    "image": "https://books.google.com/books/content?id=YaQq0JJMADUC&printsec=frontcover&img=1&zoom=3",
    "synopsis": "Twins drift apart and reunite through art and tragedy.",
    "rating": 4.14,
    "ratingsCount": 312820,
    "pageCount": 371,
    "awards": [
      "Printz Award (2015)",
      "Stonewall Honor Book (2015)",
      "TIME's 100 Best YA Books of All Time"
    ],
    "categories": [
      "Young Adult",
      "Contemporary"
    ],
    "scores": {
      "contemporary": 10,
      "character": 10,
      "emotional": 10,
      "heart": 10,
      "standalone": 10,
      "modern": 10,
      "medium": 7,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 824,
    "title": "Iron Widow",
    "author": "Xiran Jay Zhao",
    "publicationYear": 2021,
    "isbn": "0735269939",
    "googleBooksId": "placeholder824",
    "image": "https://books.google.com/books/content?id=iuIbEAAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A girl becomes a pilot of giant mechs to avenge her sister's death in this reimagining of Chinese history.",
    "rating": 4.02,
    "ratingsCount": 109832,
    "pageCount": 394,
    "categories": [
      "Young Adult",
      "Science Fiction",
      "Fantasy"
    ],
    "scores": {
      "scifi": 9,
      "fantasy": 8,
      "character": 9,
      "fast": 9,
      "dark": 8,
      "series": 9,
      "modern": 10,
      "plot": 5,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 825,
    "title": "Turtles All the Way Down",
    "author": "John Green",
    "publicationYear": 2017,
    "isbn": "0525555366",
    "googleBooksId": "placeholder825",
    "image": "https://books.google.com/books/content?id=l7PMDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "A girl with OCD investigates a billionaire's disappearance.",
    "rating": 3.87,
    "ratingsCount": 536395,
    "pageCount": 304,
    "categories": [
      "Young Adult",
      "Contemporary"
    ],
    "scores": {
      "contemporary": 10,
      "character": 10,
      "dark": 7,
      "emotional": 10,
      "mind": 9,
      "standalone": 10,
      "modern": 10,
      "medium": 7,
      "plot": 5,
      "accessible": 7
    }
  },
  {
    "id": 826,
    "title": "Divergent",
    "author": "Veronica Roth",
    "publicationYear": 2011,
    "isbn": "0062024035",
    "googleBooksId": "placeholder826",
    "image": "https://books.google.com/books/content?id=wm6MDwAAQBAJ&printsec=frontcover&img=1&zoom=3",
    "synopsis": "In a divided society, a girl discovers she doesn't fit into any faction.",
    "rating": 4.19,
    "ratingsCount": 3751296,
    "pageCount": 487,
    "awards": [
      "Goodreads Choice Award Favorite Book (2011)",
      "Young Reader's Choice Award (2014)"
    ],
    "categories": [
      "Young Adult",
      "Dystopian"
    ],
    "scores": {
      "dystopian": 10,
      "thriller": 8,
      "character": 9,
      "fast": 9,
      "dark": 7,
      "series": 10,
      "plot": 5,
      "modern": 8,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 827,
    "title": "The Blind Assassin",
    "author": "Margaret Atwood",
    "authorGender": "female",
    "publicationYear": 2000,
    "isbn": "0385720955",
    "googleBooksId": "Gczi3UtXqJQC",
    "image": "https://books.google.com/books/content?id=Gczi3UtXqJQC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Iris Chase Griffen recalls her tumultuous life, including her sister Laura's mysterious death and the novel Laura left behind. Weaving together pulp science fiction, forbidden romance, and family secrets spanning decades, this Booker Prize winner explores memory, betrayal, and the stories we tell to survive.",
    "rating": 3.92,
    "ratingsCount": 116448,
    "pageCount": 521,
    "awards": [
      "Booker Prize (2000)",
      "Hammett Prize (2001)"
    ],
    "categories": [
      "Literary Fiction",
      "Historical Fiction"
    ],
    "scores": {
      "literary": 10,
      "mystery": 7,
      "dark": 7,
      "character": 10,
      "plot": 9,
      "atmosphere": 9,
      "slow": 8,
      "standalone": 10,
      "historical": 8,
      "lyrical": 9,
      "introspection": 8,
      "nonlinear": 9,
      "family": 9,
      "grief": 8,
      "bittersweet": 9,
      "tragic": 8,
      "ironic": 7,
      "intimate": 8,
      "rereadable": 8
    }
  },
  {
    "id": 828,
    "title": "Alias Grace",
    "author": "Margaret Atwood",
    "authorGender": "female",
    "publicationYear": 1996,
    "isbn": "0385490445",
    "googleBooksId": "kN51uejmHDUC",
    "image": "https://books.google.com/books/content?id=kN51uejmHDUC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Based on a true story, Grace Marks is a young Irish immigrant and domestic servant who was convicted of murder in 1843 Canada. As a doctor attempts to unlock her memories through hypnosis, the truth of what happened remains tantalizingly elusive in this exploration of memory, identity, and perception.",
    "rating": 3.92,
    "ratingsCount": 128519,
    "pageCount": 560,
    "awards": [
      "Giller Prize (1996)"
    ],
    "categories": [
      "Historical Fiction",
      "Literary Fiction",
      "Mystery"
    ],
    "scores": {
      "literary": 10,
      "historical": 9,
      "mystery": 8,
      "psychological": 10,
      "character": 10,
      "atmosphere": 9,
      "slow": 7,
      "standalone": 10,
      "unreliable": 10,
      "introspection": 9,
      "epistolary": 6,
      "moral": 8,
      "identity": 9,
      "trauma": 7,
      "challenging": 7,
      "immersive": 8,
      "lyrical": 8
    }
  },
  {
    "id": 829,
    "title": "Oryx and Crake",
    "author": "Margaret Atwood",
    "authorGender": "female",
    "publicationYear": 2003,
    "series": {
      "name": "MaddAddam",
      "position": 1
    },
    "isbn": "0385721676",
    "googleBooksId": "AUuNEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=AUuNEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Snowman may be the last human alive, living in a tree and watching over the Crakers—genetically modified humanoids. Through flashbacks, we learn of his friendship with the brilliant Crake and their shared love for the mysterious Oryx, and how their world ended in a bioengineered apocalypse.",
    "rating": 4,
    "ratingsCount": 287957,
    "pageCount": 389,
    "awards": [
      "Booker Prize Shortlist (2003)",
      "Orange Prize Shortlist (2004)"
    ],
    "categories": [
      "Science Fiction",
      "Dystopian",
      "Literary Fiction"
    ],
    "scores": {
      "scifi": 10,
      "literary": 9,
      "dark": 9,
      "character": 9,
      "atmosphere": 10,
      "plot": 9,
      "series": 8,
      "satirical": 9,
      "humor": 6,
      "worldbuilding": 9,
      "philosophical": 8,
      "social": 9,
      "disturbing": 8,
      "tragic": 8,
      "introspection": 8,
      "cerebral": 8,
      "medium": 6
    }
  },
  {
    "id": 830,
    "title": "Cat's Eye",
    "author": "Margaret Atwood",
    "authorGender": "female",
    "publicationYear": 1988,
    "isbn": "0385491026",
    "googleBooksId": "hLFvpcVzmMAC",
    "image": "https://books.google.com/books/content?id=hLFvpcVzmMAC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Painter Elaine Risley returns to Toronto for a retrospective of her work and is flooded with memories of her childhood—particularly her toxic friendship with the cruel and manipulative Cordelia. A powerful exploration of female friendship, bullying, memory, and artistic identity.",
    "rating": 3.95,
    "ratingsCount": 62922,
    "pageCount": 440,
    "awards": [
      "Booker Prize Finalist (1989)",
      "Governor General's Award Finalist (1988)"
    ],
    "categories": [
      "Literary Fiction",
      "Coming-of-Age"
    ],
    "scores": {
      "literary": 10,
      "psychological": 10,
      "character": 10,
      "emotional": 9,
      "atmosphere": 8,
      "slow": 7,
      "standalone": 10,
      "introspection": 10,
      "friendship": 9,
      "trauma": 9,
      "identity": 9,
      "comingofage": 8,
      "bittersweet": 8,
      "lyrical": 8,
      "nonlinear": 7,
      "modern": 8
    }
  },
  {
    "id": 834,
    "title": "White Noise",
    "author": "Don DeLillo",
    "authorGender": "male",
    "publicationYear": 1985,
    "isbn": "0140077022",
    "googleBooksId": "HHqMEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=HHqMEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Jack Gladney, professor of Hitler Studies at a Midwestern college, navigates modern American life with his blended family until an 'Airborne Toxic Event' forces an evacuation. A darkly comic meditation on death, consumerism, media saturation, and the white noise of contemporary existence.",
    "rating": 3.83,
    "ratingsCount": 125487,
    "pageCount": 310,
    "awards": [
      "National Book Award for Fiction (1985)"
    ],
    "categories": [
      "Literary Fiction",
      "Satire",
      "Postmodern"
    ],
    "scores": {
      "literary": 10,
      "satirical": 10,
      "dark": 7,
      "mind": 9,
      "character": 8,
      "atmosphere": 9,
      "medium": 7,
      "standalone": 10,
      "humor": 8,
      "philosophical": 8,
      "social": 9,
      "cerebral": 9,
      "ironic": 8,
      "accessible": 7,
      "modern": 8
    }
  },
  {
    "id": 835,
    "title": "Underworld",
    "author": "Don DeLillo",
    "authorGender": "male",
    "publicationYear": 1997,
    "isbn": "0684848155",
    "googleBooksId": "m0oRCgAAQBAJ",
    "image": "https://books.google.com/books/content?id=m0oRCgAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Beginning with the famous 1951 Giants-Dodgers playoff game, this epic follows the baseball hit into the stands through decades of Cold War America. Nick Shay, the ball's eventual owner, anchors a sprawling narrative connecting artists, mobsters, nuns, and bomb designers in an exploration of waste, memory, and American identity.",
    "rating": 3.95,
    "ratingsCount": 27253,
    "pageCount": 827,
    "awards": [
      "National Book Award Finalist (1997)",
      "Pulitzer Prize Finalist (1998)"
    ],
    "categories": [
      "Literary Fiction",
      "Historical Fiction",
      "Postmodern"
    ],
    "scores": {
      "literary": 10,
      "historical": 9,
      "epic": 10,
      "character": 9,
      "atmosphere": 10,
      "slow": 9,
      "standalone": 10,
      "mind": 9,
      "nonlinear": 9,
      "challenging": 9,
      "political": 8,
      "philosophical": 8,
      "dense": 9,
      "cerebral": 9
    }
  },
  {
    "id": 836,
    "title": "The Cider House Rules",
    "author": "John Irving",
    "authorGender": "male",
    "publicationYear": 1985,
    "isbn": "0345417941",
    "googleBooksId": "v9g9UIxhL7YC",
    "image": "https://books.google.com/books/content?id=v9g9UIxhL7YC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Homer Wells grows up in a Maine orphanage under the care of Dr. Wilbur Larch, who teaches him medicine and performs illegal abortions. When Homer leaves to work at an apple orchard, he must confront his own beliefs about abortion, love, and what it means to be useful in the world.",
    "rating": 4.16,
    "ratingsCount": 174183,
    "pageCount": 640,
    "awards": [
      "Academy Award for Best Adapted Screenplay (2000)"
    ],
    "categories": [
      "Literary Fiction",
      "Historical Fiction",
      "Coming-of-Age"
    ],
    "scores": {
      "literary": 10,
      "emotional": 10,
      "character": 10,
      "historical": 8,
      "slow": 8,
      "atmosphere": 8,
      "standalone": 10,
      "comingofage": 9,
      "moral": 9,
      "family": 8,
      "identity": 8,
      "heart": 9,
      "hopeful": 7,
      "introspection": 8,
      "social": 8
    }
  },
  {
    "id": 837,
    "title": "Hotel New Hampshire",
    "author": "John Irving",
    "authorGender": "male",
    "publicationYear": 1981,
    "isbn": "0345417968",
    "googleBooksId": "-C-NDwAAQBAJ",
    "image": "https://books.google.com/books/content?id=-C-NDwAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "The Berry family's saga unfolds across decades and continents, from New Hampshire to Vienna, as they run a series of hotels while coping with bears, rape, terrorism, and incest. A tragicomic family epic about surviving grief and finding love in the most unconventional circumstances.",
    "rating": 3.93,
    "ratingsCount": 61124,
    "pageCount": 409,
    "categories": [
      "Literary Fiction",
      "Dark Comedy"
    ],
    "scores": {
      "literary": 9,
      "dark": 9,
      "humor": 8,
      "character": 10,
      "emotional": 9,
      "plot": 8,
      "standalone": 10,
      "family": 10,
      "trauma": 8,
      "bittersweet": 8,
      "whimsical": 7,
      "satirical": 6,
      "ironic": 7
    }
  },
  {
    "id": 839,
    "title": "The English Patient",
    "author": "Michael Ondaatje",
    "authorGender": "male",
    "publicationYear": 1992,
    "isbn": "0679745203",
    "googleBooksId": "9Mr2ySPG8osC",
    "image": "https://books.google.com/books/content?id=9Mr2ySPG8osC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "In a bombed Italian villa at the end of WWII, four damaged souls converge: a burned, dying patient whose identity is mysterious; his devoted nurse Hana; a Sikh sapper named Kip; and a thief named Caravaggio. Their intertwined stories reveal love, betrayal, and the devastation of war.",
    "rating": 3.84,
    "ratingsCount": 127456,
    "pageCount": 302,
    "awards": [
      "Booker Prize (1992)",
      "Governor General's Award (1992)",
      "Golden Man Booker (2018)"
    ],
    "categories": [
      "Literary Fiction",
      "Historical Fiction",
      "Romance"
    ],
    "scores": {
      "literary": 10,
      "historical": 9,
      "emotional": 10,
      "atmosphere": 10,
      "character": 10,
      "slow": 8,
      "standalone": 10,
      "lyrical": 10,
      "immersive": 9,
      "bittersweet": 9,
      "tragic": 8,
      "romance": 8,
      "challenging": 7,
      "rereadable": 8
    }
  },
  {
    "id": 841,
    "title": "In the Skin of a Lion",
    "author": "Michael Ondaatje",
    "authorGender": "male",
    "publicationYear": 1987,
    "isbn": "0679772669",
    "googleBooksId": "1rKOEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=1rKOEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Patrick Lewis arrives in 1920s Toronto and finds work among immigrants building the city's infrastructure—the Bloor Street Viaduct, the waterworks. A lyrical portrait of the laborers who built a city but were written out of its history, and of Patrick's loves and losses along the way.",
    "rating": 3.87,
    "ratingsCount": 16489,
    "pageCount": 256,
    "awards": [
      "Governor General's Award Nominee (1987)"
    ],
    "categories": [
      "Literary Fiction",
      "Historical Fiction"
    ],
    "scores": {
      "literary": 10,
      "historical": 9,
      "atmosphere": 10,
      "character": 9,
      "emotional": 8,
      "slow": 8,
      "standalone": 10,
      "lyrical": 9,
      "social": 7,
      "immersive": 8,
      "intimate": 7
    }
  },
  {
    "id": 842,
    "title": "The Shipping News",
    "author": "Annie Proulx",
    "authorGender": "female",
    "publicationYear": 1993,
    "isbn": "0684857901",
    "googleBooksId": "k8L0u82qt68C",
    "image": "https://books.google.com/books/content?id=k8L0u82qt68C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "After his worthless wife dies, Quoyle takes his two daughters to his ancestral home in Newfoundland, where he works for the local newspaper covering the shipping news. In this harsh, beautiful land, Quoyle slowly rebuilds his life and finds unexpected love.",
    "rating": 3.87,
    "ratingsCount": 72483,
    "pageCount": 337,
    "awards": [
      "Pulitzer Prize for Fiction (1994)",
      "National Book Award (1993)"
    ],
    "categories": [
      "Literary Fiction"
    ],
    "scores": {
      "literary": 10,
      "character": 10,
      "atmosphere": 10,
      "emotional": 9,
      "slow": 8,
      "standalone": 10,
      "heart": 8,
      "hopeful": 7,
      "sparse": 8,
      "immersive": 9,
      "descriptive": 9
    }
  },
  {
    "id": 843,
    "title": "Brokeback Mountain",
    "author": "Annie Proulx",
    "authorGender": "female",
    "publicationYear": 1997,
    "isbn": "0743271327",
    "googleBooksId": "tO5UnwEACAAJ",
    "image": "https://books.google.com/books/content?id=tO5UnwEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "In 1963 Wyoming, ranch hands Ennis del Mar and Jack Twist begin a passionate affair while herding sheep on Brokeback Mountain. Over twenty years of secret meetings, marriages to women, and societal constraints, their love persists and ultimately destroys them in this devastating portrait of forbidden desire.",
    "rating": 4.03,
    "ratingsCount": 43587,
    "pageCount": 55,
    "awards": [
      "National Magazine Award for Fiction (1998)"
    ],
    "categories": [
      "Literary Fiction",
      "Romance",
      "LGBTQ"
    ],
    "scores": {
      "literary": 10,
      "emotional": 10,
      "romance": 9,
      "character": 10,
      "atmosphere": 9,
      "dark": 8,
      "standalone": 10,
      "tragic": 10,
      "intimate": 9,
      "sparse": 8,
      "bittersweet": 9,
      "identity": 8
    }
  },
  {
    "id": 844,
    "title": "The Bone Clocks",
    "author": "David Mitchell",
    "authorGender": "male",
    "publicationYear": 2014,
    "isbn": "0812976827",
    "googleBooksId": "fLlPEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=fLlPEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Holly Sykes runs away from home in 1984 and unknowingly becomes entangled in a hidden war between two immortal factions. Spanning six decades across multiple narrators, this genre-defying epic weaves literary fiction with fantasy as Holly's life intersects with psychic battles that will determine humanity's fate.",
    "rating": 3.82,
    "ratingsCount": 77944,
    "pageCount": 624,
    "awards": [
      "Man Booker Prize Longlist (2014)"
    ],
    "categories": [
      "Literary Fiction",
      "Fantasy",
      "Science Fiction"
    ],
    "scores": {
      "literary": 9,
      "fantasy": 8,
      "scifi": 7,
      "plot": 9,
      "character": 9,
      "epic": 9,
      "atmosphere": 8,
      "standalone": 10,
      "multipov": 9,
      "nonlinear": 7,
      "accessible": 8,
      "immersive": 8,
      "dark": 6
    }
  },
  {
    "id": 845,
    "title": "The Thousand Autumns of Jacob de Zoet",
    "author": "David Mitchell",
    "authorGender": "male",
    "publicationYear": 2010,
    "isbn": "0812976363",
    "googleBooksId": "RO6R2t0eP4sC",
    "image": "https://books.google.com/books/content?id=RO6R2t0eP4sC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "In 1799, Dutch clerk Jacob de Zoet arrives at Dejima, Japan's tiny trading post with the West. He falls for a disfigured Japanese midwife, Orito, and uncovers a sinister cult. Historical epic exploring East-West collision, forbidden love, and the price of honor.",
    "rating": 4.01,
    "ratingsCount": 55128,
    "pageCount": 479,
    "awards": [
      "Man Booker Prize Longlist (2010)"
    ],
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "literary": 10,
      "historical": 10,
      "atmosphere": 10,
      "character": 9,
      "plot": 9,
      "slow": 8,
      "romance": 7,
      "standalone": 10,
      "immersive": 10,
      "worldbuilding": 9,
      "descriptive": 8,
      "moral": 7
    }
  },
  {
    "id": 846,
    "title": "Number9Dream",
    "author": "David Mitchell",
    "authorGender": "male",
    "publicationYear": 2001,
    "isbn": "0812966929",
    "googleBooksId": "g3rbqDUs_jkC",
    "image": "https://books.google.com/books/content?id=g3rbqDUs_jkC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Twenty-year-old Eiji Miyake comes to Tokyo to find the father who abandoned him. His search leads through yakuza encounters, video game-like fantasy sequences, and a labyrinth of coincidences in this hallucinatory blend of reality and imagination that captures modern Japan's surreal energy.",
    "rating": 3.87,
    "ratingsCount": 26460,
    "pageCount": 401,
    "awards": [
      "Booker Prize Shortlist (2001)",
      "James Tait Black Memorial Prize Shortlist (2001)"
    ],
    "categories": [
      "Literary Fiction",
      "Magical Realism"
    ],
    "scores": {
      "literary": 9,
      "mystery": 7,
      "atmosphere": 9,
      "character": 8,
      "plot": 8,
      "mind": 9,
      "standalone": 10,
      "experimental": 8,
      "nonlinear": 7,
      "modern": 9,
      "immersive": 7
    }
  },
  {
    "id": 847,
    "title": "House of Sand and Fog",
    "author": "Andre Dubus III",
    "authorGender": "male",
    "publicationYear": 1999,
    "isbn": "0375727345",
    "googleBooksId": "cl2NEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=cl2NEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "When recovering addict Kathy Nicolo loses her father's house over a bureaucratic error, it's purchased at auction by Massoud Behrani, an Iranian colonel rebuilding his family's American Dream. The collision between these desperate people spirals toward inevitable tragedy.",
    "rating": 3.97,
    "ratingsCount": 130320,
    "pageCount": 384,
    "awards": [
      "National Book Award Finalist (1999)",
      "Oprah's Book Club (2000)"
    ],
    "categories": [
      "Literary Fiction",
      "Drama"
    ],
    "scores": {
      "literary": 10,
      "emotional": 10,
      "dark": 9,
      "character": 10,
      "plot": 9,
      "atmosphere": 8,
      "standalone": 10,
      "tragic": 10,
      "multipov": 8,
      "moral": 9,
      "contemporary": 8,
      "identity": 7,
      "disturbing": 7
    }
  },
  {
    "id": 849,
    "title": "Angle of Repose",
    "author": "Wallace Stegner",
    "authorGender": "male",
    "publicationYear": 1971,
    "isbn": "0141185473",
    "googleBooksId": "5Wk6ngEACAAJ",
    "image": "https://books.google.com/books/content?id=5Wk6ngEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Wheelchair-bound historian Lyman Ward researches his grandmother Susan's life on the Western frontier through her letters and papers. As he reconstructs her marriage to mining engineer Oliver Ward, parallels emerge with his own failed marriage in this Pulitzer Prize-winning exploration of the American West.",
    "rating": 4.2,
    "ratingsCount": 62417,
    "pageCount": 569,
    "awards": [
      "Pulitzer Prize for Fiction (1972)"
    ],
    "categories": [
      "Literary Fiction",
      "Historical Fiction",
      "Western"
    ],
    "scores": {
      "literary": 10,
      "historical": 10,
      "character": 10,
      "atmosphere": 9,
      "slow": 8,
      "emotional": 8,
      "standalone": 10,
      "nonlinear": 8,
      "epic": 7,
      "introspection": 9,
      "family": 8,
      "bittersweet": 8,
      "classic": 8
    }
  },
  {
    "id": 850,
    "title": "Crossing to Safety",
    "author": "Wallace Stegner",
    "authorGender": "male",
    "publicationYear": 1987,
    "isbn": "0141185236",
    "googleBooksId": "cxGPDQAAQBAJ",
    "image": "https://books.google.com/books/content?id=cxGPDQAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "The lifelong friendship between two couples—the ambitious Morgans and the wealthy Langs—forms the heart of this quiet masterpiece. Through summers in Vermont and decades of shared joy and sorrow, Stegner examines the complexities of friendship, marriage, and the American Dream.",
    "rating": 4.21,
    "ratingsCount": 47682,
    "pageCount": 341,
    "categories": [
      "Literary Fiction"
    ],
    "scores": {
      "literary": 10,
      "character": 10,
      "emotional": 10,
      "slow": 9,
      "atmosphere": 8,
      "heart": 9,
      "standalone": 10,
      "friendship": 10,
      "intimate": 9,
      "bittersweet": 8,
      "hopeful": 7,
      "classic": 7
    }
  },
  {
    "id": 851,
    "title": "The Robber Bride",
    "author": "Margaret Atwood",
    "authorGender": "female",
    "publicationYear": 1993,
    "isbn": "0385491034",
    "googleBooksId": "BHW5fAY2-RUC",
    "image": "https://books.google.com/books/content?id=BHW5fAY2-RUC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Three Toronto women—Tony, Charis, and Roz—share one enemy: the demonic Zenia, who has seduced and destroyed each of their partners. When the supposedly dead Zenia reappears, they must confront their pasts and the woman who embodies female treachery and power.",
    "rating": 3.83,
    "ratingsCount": 43547,
    "pageCount": 528,
    "awards": [
      "Trillium Book Award (1993)",
      "Governor General's Award Shortlist (1993)"
    ],
    "categories": [
      "Literary Fiction",
      "Psychological"
    ],
    "scores": {
      "literary": 10,
      "psychological": 9,
      "character": 10,
      "dark": 8,
      "plot": 8,
      "atmosphere": 8,
      "standalone": 10,
      "multipov": 9,
      "friendship": 7,
      "ironic": 7,
      "contemporary": 8,
      "social": 6
    }
  },
  {
    "id": 852,
    "title": "The Devotion of Suspect X",
    "author": "Keigo Higashino",
    "authorGender": "male",
    "publicationYear": 2005,
    "series": {
      "name": "Detective Galileo",
      "position": 1
    },
    "isbn": "1250002699",
    "googleBooksId": "NLaWDAEACAAJ",
    "image": "https://books.google.com/books/content?id=NLaWDAEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "When Yasuko kills her abusive ex-husband, her neighbor Ishigami—a mathematical genius who secretly loves her—offers to cover up the crime with an elaborate plan. But his former classmate, physicist Manabu Yukawa, is helping the police. A chess match of intellects ensues.",
    "rating": 4.16,
    "ratingsCount": 50604,
    "pageCount": 298,
    "awards": [
      "Naoki Prize (2006)",
      "Honkaku Mystery Award (2006)",
      "Edgar Award Nominee (2012)"
    ],
    "categories": [
      "Mystery",
      "Thriller",
      "Crime"
    ],
    "scores": {
      "mystery": 10,
      "thriller": 8,
      "plot": 10,
      "character": 9,
      "mind": 10,
      "atmosphere": 7,
      "standalone": 10,
      "twist": 9,
      "psychological": 9,
      "medium": 7,
      "emotional": 8,
      "accessible": 8,
      "modern": 9
    }
  },
  {
    "id": 853,
    "title": "Malice",
    "author": "Keigo Higashino",
    "authorGender": "male",
    "publicationYear": 1996,
    "series": {
      "name": "Detective Kaga",
      "position": 1
    },
    "isbn": "1250035600",
    "googleBooksId": "ZGBnBAAAQBAJ",
    "image": "https://books.google.com/books/content?id=ZGBnBAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "When bestselling author Kunihiko Hidaka is murdered, the prime suspect is his best friend Osamu Nonoguchi. Detective Kaga must unravel layers of testimony and manuscript evidence to discover a motive rooted in decades of hidden malice. A masterful exploration of envy and revenge.",
    "rating": 4.06,
    "ratingsCount": 34921,
    "pageCount": 288,
    "categories": [
      "Mystery",
      "Thriller",
      "Crime"
    ],
    "scores": {
      "mystery": 10,
      "psychological": 10,
      "plot": 10,
      "character": 9,
      "dark": 8,
      "mind": 9,
      "standalone": 10,
      "twist": 10,
      "accessible": 8,
      "medium": 7,
      "modern": 9
    }
  },
  {
    "id": 854,
    "title": "Salvation of a Saint",
    "author": "Keigo Higashino",
    "authorGender": "male",
    "publicationYear": 2008,
    "series": {
      "name": "Detective Galileo",
      "position": 2
    },
    "isbn": "1250002699",
    "googleBooksId": "bn81wgEACAAJ",
    "image": "https://books.google.com/books/content?id=bn81wgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Yoshitaka Mashiba is poisoned with arsenic in his coffee—but his wife Ayane has an airtight alibi. She was hundreds of miles away. Detective Kusanagi falls for Ayane while physicist Yukawa works to solve an 'impossible' crime. The solution hinges on devotion taken to deadly extremes.",
    "rating": 4,
    "ratingsCount": 14367,
    "pageCount": 330,
    "categories": [
      "Mystery",
      "Thriller"
    ],
    "scores": {
      "mystery": 10,
      "thriller": 7,
      "plot": 10,
      "character": 8,
      "mind": 10,
      "atmosphere": 7,
      "standalone": 10,
      "medium": 7,
      "dark": 7,
      "modern": 8
    }
  },
  {
    "id": 856,
    "title": "Newcomer",
    "author": "Keigo Higashino",
    "authorGender": "male",
    "publicationYear": 2009,
    "series": {
      "name": "Detective Kaga",
      "position": 2
    },
    "isbn": "1250192897",
    "googleBooksId": "S6xvDwAAQBAJ",
    "image": "https://books.google.com/books/content?id=S6xvDwAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Mineko Mitsui is strangled in her new Tokyo apartment. Detective Kyochiro Kaga investigates by speaking to the shopkeepers and residents of Nihonbashi, each revealing pieces of Mineko's secret past. A poignant mystery about community, regret, and the lives of ordinary people.",
    "rating": 4.09,
    "ratingsCount": 15962,
    "pageCount": 352,
    "categories": [
      "Mystery"
    ],
    "scores": {
      "mystery": 9,
      "character": 10,
      "emotional": 9,
      "atmosphere": 9,
      "plot": 8,
      "slow": 7,
      "standalone": 10,
      "modern": 8,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 858,
    "title": "Kitchen",
    "author": "Banana Yoshimoto",
    "authorGender": "female",
    "publicationYear": 1988,
    "isbn": "0802142443",
    "googleBooksId": "rMCB9a2OqpcC",
    "image": "https://books.google.com/books/content?id=rMCB9a2OqpcC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "After her grandmother's death, Mikage finds solace with the Tanabe family—a son and his transgender mother—and their kitchen. This gentle novella about grief, chosen family, and the healing power of food and cooking became a sensation in Japan and internationally.",
    "rating": 3.91,
    "ratingsCount": 100165,
    "pageCount": 160,
    "awards": [
      "Kaien New Writer Prize (1987)"
    ],
    "categories": [
      "Literary Fiction",
      "Contemporary"
    ],
    "scores": {
      "literary": 9,
      "emotional": 10,
      "character": 9,
      "heart": 9,
      "atmosphere": 8,
      "medium": 7,
      "standalone": 10,
      "grief": 9,
      "hopeful": 8,
      "intimate": 9,
      "accessible": 8,
      "contemporary": 8
    }
  },
  {
    "id": 859,
    "title": "Out",
    "author": "Natsuo Kirino",
    "authorGender": "female",
    "publicationYear": 1997,
    "isbn": "1400078377",
    "googleBooksId": "PacdaTizG54C",
    "image": "https://books.google.com/books/content?id=PacdaTizG54C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Four women working the night shift at a Tokyo boxed-lunch factory become unlikely partners in crime when one kills her abusive husband. Masako's meticulous disposal of the body draws them into the criminal underworld and a dangerous game with a psychopathic gambler.",
    "rating": 3.94,
    "ratingsCount": 47223,
    "pageCount": 400,
    "awards": [
      "Edgar Award Nominee for Best Novel (2004)"
    ],
    "categories": [
      "Thriller",
      "Mystery",
      "Crime"
    ],
    "scores": {
      "thriller": 10,
      "dark": 10,
      "mystery": 8,
      "character": 10,
      "plot": 9,
      "atmosphere": 9,
      "psychological": 9,
      "standalone": 10,
      "disturbing": 9,
      "social": 8,
      "medium": 7,
      "modern": 9
    }
  },
  {
    "id": 861,
    "title": "The Likeness",
    "author": "Tana French",
    "authorGender": "female",
    "publicationYear": 2008,
    "series": {
      "name": "Dublin Murder Squad",
      "position": 2
    },
    "isbn": "0143115626",
    "googleBooksId": "faeMEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=faeMEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Detective Cassie Maddox discovers a murder victim who looks exactly like her and carries ID matching her old undercover alias. Going undercover to infiltrate the victim's household of graduate students, she finds herself seduced by their utopian lifestyle while hunting a killer among them.",
    "rating": 4.06,
    "ratingsCount": 180856,
    "pageCount": 466,
    "categories": [
      "Mystery",
      "Thriller",
      "Psychological"
    ],
    "scores": {
      "mystery": 10,
      "thriller": 8,
      "psychological": 9,
      "character": 10,
      "atmosphere": 10,
      "plot": 9,
      "series": 9,
      "friendship": 8,
      "slow": 7,
      "literary": 8,
      "dark": 7,
      "immersive": 9,
      "introspection": 8
    }
  },
  {
    "id": 862,
    "title": "Faithful Place",
    "author": "Tana French",
    "authorGender": "female",
    "publicationYear": 2010,
    "series": {
      "name": "Dublin Murder Squad",
      "position": 3
    },
    "isbn": "0143119494",
    "googleBooksId": "EJZPEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=EJZPEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Frank Mackey thought his first love Rosie stood him up twenty years ago when they planned to elope. When her suitcase is found hidden in a derelict house, he returns to the Dublin family he escaped—and confronts old wounds, family dysfunction, and a killer still at large.",
    "rating": 3.98,
    "ratingsCount": 102725,
    "pageCount": 400,
    "categories": [
      "Mystery",
      "Thriller"
    ],
    "scores": {
      "mystery": 10,
      "character": 10,
      "emotional": 10,
      "atmosphere": 10,
      "plot": 9,
      "dark": 8,
      "series": 9,
      "family": 9,
      "psychological": 8,
      "introspection": 8,
      "literary": 7
    }
  },
  {
    "id": 863,
    "title": "Broken Harbor",
    "author": "Tana French",
    "authorGender": "female",
    "publicationYear": 2012,
    "isbn": "0143123505",
    "googleBooksId": "QsqNh5SViQ0C",
    "image": "https://books.google.com/books/content?id=QsqNh5SViQ0C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Detective Mick Kennedy investigates a family attacked in their half-built ghost estate home. The father is dead, the mother critical, and two children missing. As Kennedy excavates the family's secrets and financial ruin, his own traumatic history with the area resurfaces.",
    "rating": 3.95,
    "ratingsCount": 109159,
    "pageCount": 456,
    "categories": [
      "Mystery",
      "Thriller",
      "Psychological"
    ],
    "scores": {
      "mystery": 10,
      "thriller": 9,
      "dark": 10,
      "psychological": 9,
      "atmosphere": 10,
      "plot": 9,
      "emotional": 9,
      "series": 9,
      "fast": 7,
      "medium": 5,
      "character": 5,
      "modern": 8
    }
  },
  {
    "id": 864,
    "title": "The Secret Place",
    "author": "Tana French",
    "authorGender": "female",
    "publicationYear": 2014,
    "isbn": "0143127519",
    "googleBooksId": "IVhqDwAAQBAJ",
    "image": "https://books.google.com/books/content?id=IVhqDwAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "A year after a boy was murdered at a girls' boarding school, a student brings Detective Stephen Moran a new clue. Partnering with Antoinette Conway, he navigates the intense friendships, rivalries, and secrets of teenage girls who may have supernatural abilities—or murderous intentions.",
    "rating": 3.82,
    "ratingsCount": 65276,
    "pageCount": 452,
    "categories": [
      "Mystery",
      "Thriller",
      "Young Adult"
    ],
    "scores": {
      "mystery": 10,
      "psychological": 9,
      "atmosphere": 10,
      "character": 9,
      "plot": 9,
      "dark": 7,
      "series": 9,
      "medium": 7,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 865,
    "title": "The Trespasser",
    "author": "Tana French",
    "authorGender": "female",
    "publicationYear": 2016,
    "isbn": "0670026336",
    "googleBooksId": "g9_4DAAAQBAJ",
    "image": "https://books.google.com/books/content?id=g9_4DAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Detective Antoinette Conway catches what looks like a routine domestic violence case—until it isn't. As her investigation is subtly sabotaged and paranoia sets in, Conway must determine who she can trust on the Murder Squad where she's never been welcome.",
    "rating": 3.97,
    "ratingsCount": 88999,
    "pageCount": 464,
    "categories": [
      "Mystery",
      "Thriller"
    ],
    "scores": {
      "mystery": 10,
      "thriller": 8,
      "psychological": 9,
      "character": 10,
      "plot": 9,
      "atmosphere": 8,
      "series": 9,
      "fast": 7,
      "medium": 5,
      "dark": 7,
      "modern": 8
    }
  },
  {
    "id": 866,
    "title": "The Searcher",
    "author": "Tana French",
    "authorGender": "female",
    "publicationYear": 2020,
    "series": {
      "name": "Cal Hooper",
      "position": 1
    },
    "isbn": "0735224641",
    "googleBooksId": "lzzYDwAAQBAJ",
    "image": "https://books.google.com/books/content?id=lzzYDwAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Cal Hooper, a retired Chicago cop, moves to rural Ireland seeking peace. But when a local boy asks him to find his missing brother—a case the local police have dismissed—Cal is pulled into a close-knit community harboring dangerous secrets. A slow-burn mystery in a richly drawn landscape.",
    "rating": 3.8,
    "ratingsCount": 162208,
    "pageCount": 451,
    "categories": [
      "Mystery",
      "Literary Fiction"
    ],
    "scores": {
      "mystery": 9,
      "character": 10,
      "atmosphere": 10,
      "slow": 8,
      "plot": 8,
      "emotional": 8,
      "standalone": 10,
      "modern": 8,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 867,
    "title": "Still Life",
    "author": "Louise Penny",
    "authorGender": "female",
    "publicationYear": 2005,
    "series": {
      "name": "Chief Inspector Armand Gamache",
      "position": 1
    },
    "isbn": "0312541538",
    "googleBooksId": "Q5bax9LSanIC",
    "image": "https://books.google.com/books/content?id=Q5bax9LSanIC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Chief Inspector Armand Gamache arrives in the quirky Quebec village of Three Pines to investigate the death of local artist Jane Neal, hit by a hunting arrow. In this cozy mystery, Gamache's humane detective work reveals a community full of eccentric characters and old grievances.",
    "rating": 4,
    "ratingsCount": 149287,
    "pageCount": 312,
    "awards": [
      "Anthony Award for Best First Novel (2007)",
      "New Blood Dagger (2007)",
      "Arthur Ellis Award (2007)"
    ],
    "categories": [
      "Mystery",
      "Cozy Mystery"
    ],
    "scores": {
      "mystery": 9,
      "cozy": 10,
      "character": 10,
      "atmosphere": 10,
      "plot": 8,
      "heart": 8,
      "series": 10,
      "accessible": 9,
      "hopeful": 7,
      "medium": 7
    }
  },
  {
    "id": 868,
    "title": "A Fatal Grace",
    "author": "Louise Penny",
    "authorGender": "female",
    "publicationYear": 2007,
    "isbn": "0312541538",
    "googleBooksId": "hbRVhxybxK0C",
    "image": "https://books.google.com/books/content?id=hbRVhxybxK0C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "CC de Poitiers, a self-help guru despised by the villagers of Three Pines, is electrocuted at a curling match. Inspector Gamache investigates a community where everyone had reason to want CC dead, while a brutal cold spell isolates the village.",
    "rating": 4.03,
    "ratingsCount": 97945,
    "pageCount": 311,
    "awards": [
      "Agatha Award for Best Mystery Novel (2007)"
    ],
    "categories": [
      "Mystery",
      "Cozy Mystery"
    ],
    "scores": {
      "mystery": 9,
      "cozy": 10,
      "character": 10,
      "atmosphere": 10,
      "plot": 8,
      "series": 10,
      "medium": 7,
      "emotional": 6,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 869,
    "title": "The Cruelest Month",
    "author": "Louise Penny",
    "authorGender": "female",
    "publicationYear": 2008,
    "isbn": "0312573502",
    "googleBooksId": "p-12cgAACAAJ",
    "image": "https://books.google.com/books/content?id=p-12cgAACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "When a séance goes wrong at the old Hadley house—reputed to be haunted—one of the participants dies of fright. Gamache returns to Three Pines to investigate a death that may have been murder, while confronting his own fears and the village's darkest secrets.",
    "rating": 4.1,
    "ratingsCount": 75460,
    "pageCount": 311,
    "awards": [
      "Agatha Award for Best Mystery Novel (2008)"
    ],
    "categories": [
      "Mystery"
    ],
    "scores": {
      "mystery": 9,
      "cozy": 9,
      "gothic": 7,
      "atmosphere": 10,
      "character": 10,
      "plot": 8,
      "series": 10,
      "medium": 7,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 870,
    "title": "A Rule Against Murder",
    "author": "Louise Penny",
    "authorGender": "female",
    "publicationYear": 2009,
    "isbn": "0312377037",
    "googleBooksId": "hQGY0bitqK8C",
    "image": "https://books.google.com/books/content?id=hQGY0bitqK8C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Gamache and his wife Reine-Marie vacation at a lakeside inn where a family reunion of the wealthy Finneys turns deadly. Isolated with the suspects, Gamache must navigate family dysfunction spanning generations to find a killer among the privileged guests.",
    "rating": 4.21,
    "ratingsCount": 102689,
    "pageCount": 322,
    "categories": [
      "Mystery"
    ],
    "scores": {
      "mystery": 9,
      "cozy": 9,
      "character": 10,
      "atmosphere": 9,
      "plot": 8,
      "series": 10,
      "medium": 7,
      "emotional": 6,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 871,
    "title": "The Brutal Telling",
    "author": "Louise Penny",
    "authorGender": "female",
    "publicationYear": 2009,
    "isbn": "0312661681",
    "googleBooksId": "QXMNM1l8HuIC",
    "image": "https://books.google.com/books/content?id=QXMNM1l8HuIC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "A stranger's body is found in the bistro of Three Pines, and no one knows who he is. As Gamache investigates, the case leads to the nearby forest and a hermit who lived there for decades—and a treasure trove of stolen art that changes everything.",
    "rating": 4.19,
    "ratingsCount": 64692,
    "pageCount": 372,
    "categories": [
      "Mystery"
    ],
    "scores": {
      "mystery": 9,
      "cozy": 9,
      "character": 10,
      "atmosphere": 10,
      "plot": 9,
      "series": 10,
      "medium": 7,
      "emotional": 6,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 872,
    "title": "Bury Your Dead",
    "author": "Louise Penny",
    "authorGender": "female",
    "publicationYear": 2010,
    "isbn": "0312377045",
    "googleBooksId": "l-v_zwEACAAJ",
    "image": "https://books.google.com/books/content?id=l-v_zwEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "While recovering from a traumatic operation gone wrong, Gamache investigates a murder in Quebec City during Winter Carnival—a case connected to the search for Samuel de Champlain's burial site. Intercut with the devastating events that nearly killed him.",
    "rating": 4.31,
    "ratingsCount": 64448,
    "pageCount": 371,
    "categories": [
      "Mystery",
      "Historical Fiction"
    ],
    "scores": {
      "mystery": 10,
      "historical": 8,
      "character": 10,
      "emotional": 10,
      "atmosphere": 10,
      "plot": 9,
      "dark": 8,
      "series": 10,
      "medium": 7,
      "slow": 5,
      "modern": 8
    }
  },
  {
    "id": 873,
    "title": "A Trick of the Light",
    "author": "Louise Penny",
    "authorGender": "female",
    "publicationYear": 2011,
    "isbn": "0312655460",
    "googleBooksId": "1K1U45rarGAC",
    "image": "https://books.google.com/books/content?id=1K1U45rarGAC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "At the celebration following artist Clara Morrow's triumphant gallery show, a woman is found dead in Clara's garden—a figure from Clara's past. Gamache investigates while dealing with the aftermath of the previous book's tragedy and a traitor in his ranks.",
    "rating": 4.32,
    "ratingsCount": 87347,
    "pageCount": 339,
    "awards": [
      "New York Times Notable Crime Book (2011)"
    ],
    "categories": [
      "Mystery"
    ],
    "scores": {
      "mystery": 9,
      "character": 10,
      "emotional": 9,
      "atmosphere": 10,
      "plot": 9,
      "series": 10,
      "medium": 7,
      "modern": 8,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 874,
    "title": "The Beautiful Mystery",
    "author": "Louise Penny",
    "authorGender": "female",
    "publicationYear": 2012,
    "isbn": "0312655479",
    "googleBooksId": "2pxuNQEACAAJ",
    "image": "https://books.google.com/books/content?id=2pxuNQEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "In a remote monastery where two dozen monks live in silence and raise their voices only to sing Gregorian chant, the choir director is murdered. Gamache and Inspector Jean-Guy Beauvoir investigate this locked-room mystery while their own relationship is tested to breaking point.",
    "rating": 4.15,
    "ratingsCount": 48450,
    "pageCount": 373,
    "categories": [
      "Mystery"
    ],
    "scores": {
      "mystery": 10,
      "atmosphere": 10,
      "character": 10,
      "plot": 9,
      "emotional": 9,
      "series": 10,
      "medium": 7,
      "modern": 8,
      "accessible": 7,
      "immersive": 7
    }
  },
  {
    "id": 875,
    "title": "The Lathe of Heaven",
    "author": "Ursula K. Le Guin",
    "authorGender": "female",
    "publicationYear": 1971,
    "isbn": "1416556966",
    "googleBooksId": "sZZ7xHC3-JIC",
    "image": "https://books.google.com/books/content?id=sZZ7xHC3-JIC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "George Orr discovers his dreams alter reality—a change only he remembers. Seeking help from Dr. Haber, who begins exploiting George's ability to 'improve' the world, each change creates unforeseen consequences. A profound meditation on power, reality, and the dangers of utopian thinking.",
    "rating": 4.12,
    "ratingsCount": 67668,
    "pageCount": 176,
    "awards": [
      "Locus Award for Best Novel (1972)",
      "Hugo Award Finalist (1972)",
      "Nebula Award Finalist (1971)"
    ],
    "categories": [
      "Science Fiction"
    ],
    "scores": {
      "scifi": 10,
      "philosophical": 10,
      "mind": 10,
      "character": 8,
      "plot": 9,
      "atmosphere": 8,
      "standalone": 10,
      "cerebral": 9,
      "accessible": 8,
      "literary": 8,
      "medium": 7,
      "psychological": 7
    }
  },
  {
    "id": 876,
    "title": "The Word for World is Forest",
    "author": "Ursula K. Le Guin",
    "authorGender": "female",
    "publicationYear": 1972,
    "series": {
      "name": "Hainish Cycle",
      "position": 6
    },
    "isbn": "0765324644",
    "googleBooksId": "RMD6mAEACAAJ",
    "image": "https://books.google.com/books/content?id=RMD6mAEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Human colonizers brutally exploit the peaceful Athsheans—small, green-furred people who live in harmony with their forest world. When Selver, driven to violence by atrocities against his people, teaches them to kill, the consequences reshape both species forever. A searing anti-colonial allegory.",
    "rating": 4.07,
    "ratingsCount": 44085,
    "pageCount": 128,
    "awards": [
      "Hugo Award for Best Novella (1973)"
    ],
    "categories": [
      "Science Fiction"
    ],
    "scores": {
      "scifi": 10,
      "literary": 9,
      "dark": 8,
      "political": 9,
      "character": 8,
      "atmosphere": 9,
      "standalone": 10,
      "medium": 7,
      "slow": 5,
      "plot": 5,
      "classic": 5,
      "modern": 7
    }
  },
  {
    "id": 877,
    "title": "Tehanu",
    "author": "Ursula K. Le Guin",
    "authorGender": "female",
    "publicationYear": 1990,
    "isbn": "1442459964",
    "googleBooksId": "NJ8AVsov4dEC",
    "image": "https://books.google.com/books/content?id=NJ8AVsov4dEC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Years after the great deeds of Ged and Tenar, both live quietly—Ged stripped of his power, Tenar a widow raising a burned, abused child named Therru. As old enemies threaten and new kings rise, Tehanu's true nature slowly reveals itself in this feminist reimagining of fantasy heroism.",
    "rating": 4.06,
    "ratingsCount": 59612,
    "pageCount": 281,
    "awards": [
      "Nebula Award for Best Novel (1990)",
      "Locus Award for Best Fantasy Novel (1991)"
    ],
    "categories": [
      "Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "literary": 10,
      "feminist": 9,
      "character": 10,
      "slow": 8,
      "emotional": 9,
      "series": 10,
      "plot": 5,
      "modern": 8,
      "accessible": 7
    }
  },
  {
    "id": 878,
    "title": "The Other Wind",
    "author": "Ursula K. Le Guin",
    "authorGender": "female",
    "publicationYear": 2001,
    "isbn": "0441011241",
    "googleBooksId": "g1dNpEZf5YgC",
    "image": "https://books.google.com/books/content?id=g1dNpEZf5YgC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Sorcerer Alder is haunted by the dead who beg to be freed from the dry land where no wind blows. His journey to Roke and beyond reveals that the wall between life and death was built by ancient wrong, and only Tehanu can help set things right. The culmination of the Earthsea cycle.",
    "rating": 4.09,
    "ratingsCount": 32192,
    "pageCount": 211,
    "awards": [
      "World Fantasy Award for Best Novel (2002)"
    ],
    "categories": [
      "Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "literary": 10,
      "philosophical": 9,
      "character": 9,
      "atmosphere": 9,
      "emotional": 9,
      "series": 10,
      "medium": 7,
      "slow": 5,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 879,
    "title": "Grass",
    "author": "Sheri S. Tepper",
    "authorGender": "female",
    "publicationYear": 1989,
    "series": {
      "name": "Arbai",
      "position": 1
    },
    "isbn": "0553762613",
    "googleBooksId": "5XivpKF9tTcC",
    "image": "https://books.google.com/books/content?id=5XivpKF9tTcC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "On the planet Grass, the aristocratic Bons hunt the mysterious Hippae across endless prairies while humanity faces a plague that kills billions. Diplomat Marjorie Westriding discovers the horrifying truth about the Hippae and the 'foxen' they hunt—and why Grass alone is immune to the plague.",
    "rating": 4.02,
    "ratingsCount": 11173,
    "pageCount": 480,
    "awards": [
      "Hugo Award Nominee (1990)",
      "Locus Award Nominee (1990)"
    ],
    "categories": [
      "Science Fiction",
      "Fantasy"
    ],
    "scores": {
      "scifi": 10,
      "mystery": 8,
      "horror": 7,
      "atmosphere": 10,
      "plot": 9,
      "character": 9,
      "standalone": 10,
      "medium": 7,
      "dark": 7,
      "classic": 5,
      "modern": 7
    }
  },
  {
    "id": 880,
    "title": "The Gate to Women's Country",
    "author": "Sheri S. Tepper",
    "authorGender": "female",
    "publicationYear": 1988,
    "isbn": "0553280643",
    "googleBooksId": "gq73zsI0lSAC",
    "image": "https://books.google.com/books/content?id=gq73zsI0lSAC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Three hundred years after nuclear war, women live in walled cities while men serve as warriors outside. Young Stavia discovers the terrible secrets that maintain this society—including the truth about the 'servitors' who chose to live with women. A feminist SF classic exploring gender and violence.",
    "rating": 4.06,
    "ratingsCount": 14047,
    "pageCount": 315,
    "awards": [
      "Locus Award Nominee (1989)"
    ],
    "categories": [
      "Science Fiction",
      "Dystopian"
    ],
    "scores": {
      "scifi": 10,
      "feminist": 10,
      "dystopian": 9,
      "political": 9,
      "character": 8,
      "plot": 9,
      "standalone": 10,
      "medium": 7,
      "emotional": 6,
      "classic": 5,
      "modern": 7
    }
  },
  {
    "id": 882,
    "title": "Lilith's Brood",
    "author": "Octavia E. Butler",
    "authorGender": "female",
    "publicationYear": 2000,
    "series": {
      "name": "Xenogenesis",
      "position": 1
    },
    "isbn": "0446676101",
    "googleBooksId": "Rr_dYgEACAAJ",
    "image": "https://books.google.com/books/content?id=Rr_dYgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "After nuclear war devastates Earth, alien Oankali save humanity—but demand a price: genetic trade that will merge both species. Lilith Iyapo must lead humans back to Earth while navigating her own transformation and her children's alien nature. An epic trilogy about identity, consent, and evolution.",
    "rating": 4.25,
    "ratingsCount": 30247,
    "pageCount": 752,
    "categories": [
      "Science Fiction"
    ],
    "scores": {
      "scifi": 10,
      "literary": 9,
      "philosophical": 10,
      "character": 10,
      "dark": 8,
      "atmosphere": 9,
      "series": 10,
      "psychological": 10,
      "political": 8,
      "slow": 8,
      "challenging": 9,
      "introspection": 10,
      "social": 9,
      "moral": 9,
      "dense": 8,
      "identity": 9,
      "intimate": 8
    }
  },
  {
    "id": 883,
    "title": "Wild Seed",
    "author": "Octavia E. Butler",
    "authorGender": "female",
    "publicationYear": 1980,
    "series": {
      "name": "Patternist",
      "position": 1
    },
    "isbn": "0446676977",
    "googleBooksId": "iidJPgAACAAJ",
    "image": "https://books.google.com/books/content?id=iidJPgAACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Immortal Doro breeds humans for psychic powers, killing body after body for four thousand years. When he encounters Anyanwu—a shapeshifter as old as he is—their centuries-long relationship becomes a battle of wills between a predator seeking control and a healer seeking freedom.",
    "rating": 4.2,
    "ratingsCount": 39624,
    "pageCount": 320,
    "categories": [
      "Science Fiction",
      "Fantasy",
      "Historical Fiction"
    ],
    "scores": {
      "scifi": 10,
      "fantasy": 8,
      "historical": 8,
      "character": 10,
      "dark": 9,
      "emotional": 9,
      "series": 9,
      "psychological": 9,
      "introspection": 9,
      "slow": 7,
      "intimate": 9,
      "social": 8,
      "identity": 9,
      "literary": 8,
      "atmosphere": 8
    }
  },
  {
    "id": 884,
    "title": "Mind of My Mind",
    "author": "Octavia E. Butler",
    "authorGender": "female",
    "publicationYear": 1977,
    "series": {
      "name": "Patternist",
      "position": 2
    },
    "isbn": "0446361887",
    "googleBooksId": "mH2pQgAACAAJ",
    "image": "https://books.google.com/books/content?id=mH2pQgAACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Mary is Doro's most successful experiment—a telepath who can link other psychics into a Pattern of shared minds. But the Pattern's power threatens Doro himself, and Mary must choose between submission to her creator-father and liberation through patricide.",
    "rating": 4.19,
    "ratingsCount": 15539,
    "pageCount": 224,
    "categories": [
      "Science Fiction"
    ],
    "scores": {
      "scifi": 10,
      "psychological": 9,
      "character": 9,
      "plot": 9,
      "dark": 8,
      "series": 9,
      "introspection": 8,
      "social": 8,
      "identity": 8,
      "literary": 7,
      "atmosphere": 8,
      "medium": 8
    }
  },
  {
    "id": 885,
    "title": "Clay's Ark",
    "author": "Octavia E. Butler",
    "authorGender": "female",
    "publicationYear": 1984,
    "series": {
      "name": "Patternist",
      "position": 3
    },
    "isbn": "0446603708",
    "googleBooksId": "rfkiGwAACAAJ",
    "image": "https://books.google.com/books/content?id=rfkiGwAACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Geologist Blake Maslin and his daughters are captured by a strange community infected with an alien microorganism. The compulsion to spread the infection wars with their humanity as Blake faces an impossible choice: escape and unleash a plague, or stay and become something no longer human.",
    "rating": 3.84,
    "ratingsCount": 12280,
    "pageCount": 213,
    "categories": [
      "Science Fiction",
      "Horror"
    ],
    "scores": {
      "scifi": 10,
      "horror": 9,
      "dark": 10,
      "thriller": 8,
      "character": 8,
      "atmosphere": 9,
      "series": 8,
      "survival": 9,
      "psychological": 8,
      "fast": 7,
      "disturbing": 8,
      "action": 6,
      "intimate": 7
    }
  },
  {
    "id": 886,
    "title": "Fledgling",
    "author": "Octavia E. Butler",
    "authorGender": "female",
    "publicationYear": 2005,
    "isbn": "0446696161",
    "googleBooksId": "RGxn0QEACAAJ",
    "image": "https://books.google.com/books/content?id=RGxn0QEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Shori awakens amnesiac in a cave, discovers she's a genetically modified Ina—a vampire symbiont species—and must find who destroyed her family. As she rebuilds her life with human symbionts, she faces a community divided over her brown skin and genetic enhancements.",
    "rating": 3.8,
    "ratingsCount": 31149,
    "pageCount": 310,
    "categories": [
      "Science Fiction",
      "Horror",
      "Vampire"
    ],
    "scores": {
      "scifi": 9,
      "horror": 7,
      "mystery": 8,
      "character": 10,
      "social": 9,
      "dark": 7,
      "standalone": 10,
      "identity": 9,
      "psychological": 8,
      "introspection": 8,
      "medium": 7,
      "literary": 7,
      "intimate": 8
    }
  },
  {
    "id": 887,
    "title": "Downbelow Station",
    "author": "C.J. Cherryh",
    "authorGender": "female",
    "publicationYear": 1981,
    "series": {
      "name": "The Company Wars",
      "position": 1
    },
    "isbn": "0886773520",
    "googleBooksId": "h1uJEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=h1uJEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Earth's Company Wars reach their climax at Pell Station, orbiting the alien Downer homeworld. As refugees flood in and military factions clash, a small group of individuals—stationers, ship captains, and Downer aliens—navigate impossible choices that will determine humanity's future among the stars.",
    "rating": 3.92,
    "ratingsCount": 15487,
    "pageCount": 432,
    "awards": [
      "Hugo Award for Best Novel (1982)",
      "Locus Award Shortlist (1982)"
    ],
    "categories": [
      "Science Fiction",
      "Space Opera"
    ],
    "scores": {
      "scifi": 10,
      "political": 9,
      "epic": 9,
      "character": 9,
      "plot": 9,
      "atmosphere": 9,
      "series": 9,
      "worldbuilding": 9,
      "dense": 8,
      "challenging": 8,
      "slow": 7,
      "multipov": 8,
      "dark": 7
    }
  },
  {
    "id": 888,
    "title": "Cyteen",
    "author": "C.J. Cherryh",
    "authorGender": "female",
    "publicationYear": 1988,
    "series": {
      "name": "Cyteen",
      "position": 1
    },
    "isbn": "0446671274",
    "googleBooksId": "FpqxJAAACAAJ",
    "image": "https://books.google.com/books/content?id=FpqxJAAACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Ariane Emory is the genius behind Union's azi—psychologically conditioned clones. When she's murdered, her clone is raised to recreate her—but young Ari must discover whether she can transcend her predecessor's cruelties while a political conspiracy threatens to destroy everything she builds.",
    "rating": 4,
    "ratingsCount": 10614,
    "pageCount": 680,
    "awards": [
      "Hugo Award for Best Novel (1989)",
      "Locus Award for Best Novel (1989)"
    ],
    "categories": [
      "Science Fiction"
    ],
    "scores": {
      "scifi": 10,
      "psychological": 10,
      "political": 9,
      "character": 10,
      "plot": 9,
      "slow": 8,
      "series": 9,
      "cerebral": 10,
      "dense": 9,
      "challenging": 9,
      "introspection": 9,
      "philosophical": 8,
      "intimate": 8,
      "literary": 8
    }
  },
  {
    "id": 889,
    "title": "Foreigner",
    "author": "C.J. Cherryh",
    "authorGender": "female",
    "publicationYear": 1994,
    "series": {
      "name": "Foreigner",
      "position": 1
    },
    "isbn": "0886776376",
    "googleBooksId": "C1EIAAAACAAJ",
    "image": "https://books.google.com/books/content?id=C1EIAAAACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Bren Cameron is the sole human diplomat on an alien world where humans survive only by maintaining perfect protocol with the atevi—a species that doesn't feel friendship but does feel loyalty. When a political assassination attempt targets him, Bren must navigate deadly intrigue to survive.",
    "rating": 3.92,
    "ratingsCount": 10925,
    "pageCount": 384,
    "categories": [
      "Science Fiction"
    ],
    "scores": {
      "scifi": 10,
      "political": 10,
      "character": 10,
      "worldbuilding": 10,
      "slow": 8,
      "series": 10,
      "introspection": 8,
      "dense": 8,
      "challenging": 7,
      "cerebral": 8,
      "intimate": 8,
      "atmospheric": 7
    }
  },
  {
    "id": 890,
    "title": "Startide Rising",
    "author": "David Brin",
    "authorGender": "male",
    "publicationYear": 1983,
    "series": {
      "name": "The Uplift Saga",
      "position": 2
    },
    "isbn": "0553269828",
    "googleBooksId": "IKoFX1gqU6wC",
    "image": "https://books.google.com/books/content?id=IKoFX1gqU6wC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "The dolphin-crewed starship Streaker has discovered a fleet of ancient derelict ships—and now every species in the Five Galaxies wants it. Stranded on a water world while battles rage above, the uplifted dolphin crew must survive long enough to transmit their discovery to Earth.",
    "rating": 4.06,
    "ratingsCount": 33217,
    "pageCount": 400,
    "awards": [
      "Hugo Award for Best Novel (1984)",
      "Nebula Award for Best Novel (1983)",
      "Locus Award for Best SF Novel (1984)"
    ],
    "categories": [
      "Science Fiction",
      "Space Opera"
    ],
    "scores": {
      "scifi": 10,
      "adventure": 10,
      "plot": 10,
      "worldbuilding": 10,
      "character": 9,
      "series": 10,
      "action": 8,
      "fast": 7,
      "accessible": 8,
      "immersive": 9,
      "humor": 6,
      "epic": 9,
      "optimistic": 7
    }
  },
  {
    "id": 891,
    "title": "The Uplift War",
    "author": "David Brin",
    "authorGender": "male",
    "publicationYear": 1987,
    "series": {
      "name": "The Uplift Saga",
      "position": 3
    },
    "isbn": "0553279718",
    "googleBooksId": "sejpsuYr4g4C",
    "image": "https://books.google.com/books/content?id=sejpsuYr4g4C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "When the Gubru invade the planet Garth, humanity's chimpanzee allies must lead the resistance. Robert Oneagle and atypical chimp Fiben Bolger navigate guerrilla warfare, alien politics, and the ancient mystery of uplift while the fate of Earth's client species hangs in the balance.",
    "rating": 4.07,
    "ratingsCount": 27435,
    "pageCount": 638,
    "awards": [
      "Hugo Award for Best Novel (1988)",
      "Locus Award for Best Novel (1988)"
    ],
    "categories": [
      "Science Fiction",
      "Space Opera"
    ],
    "scores": {
      "scifi": 10,
      "adventure": 10,
      "political": 9,
      "character": 9,
      "plot": 10,
      "series": 10,
      "worldbuilding": 10,
      "humor": 7,
      "medium": 7,
      "accessible": 7,
      "immersive": 8,
      "epic": 8,
      "action": 7
    }
  },
  {
    "id": 894,
    "title": "A Deepness in the Sky",
    "author": "Vernor Vinge",
    "authorGender": "male",
    "publicationYear": 1999,
    "series": {
      "name": "Zones of Thought",
      "position": 2
    },
    "isbn": "0812536355",
    "googleBooksId": "C1AhmQEACAAJ",
    "image": "https://books.google.com/books/content?id=C1AhmQEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Two human cultures arrive at an alien star where spider-like aliens are emerging from hibernation. The Qeng Ho traders and totalitarian Emergents compete to exploit the aliens, while a rebellion brews among the conquered Qeng Ho and the spiders develop their own agenda.",
    "rating": 4.2,
    "ratingsCount": 25487,
    "pageCount": 606,
    "awards": [
      "Hugo Award for Best Novel (2000)",
      "John W. Campbell Memorial Award (2000)",
      "Prometheus Award (2000)"
    ],
    "categories": [
      "Science Fiction",
      "Space Opera"
    ],
    "scores": {
      "scifi": 10,
      "epic": 10,
      "character": 10,
      "worldbuilding": 10,
      "plot": 10,
      "slow": 8,
      "standalone": 9,
      "dense": 8,
      "challenging": 8,
      "cerebral": 9,
      "psychological": 8,
      "literary": 7,
      "immersive": 9
    }
  },
  {
    "id": 895,
    "title": "Rainbows End",
    "author": "Vernor Vinge",
    "authorGender": "male",
    "publicationYear": 2006,
    "isbn": "0812536363",
    "googleBooksId": "WT-OXLZE2m8C",
    "image": "https://books.google.com/books/content?id=WT-OXLZE2m8C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "In 2025, Robert Gu awakens from Alzheimer's cured but obsolete—his poetry forgotten, replaced by augmented reality overlays he can barely navigate. His granddaughter's school project and a terrorist conspiracy converge in a story about aging, technology, and the price of staying relevant.",
    "rating": 3.8,
    "ratingsCount": 12478,
    "pageCount": 364,
    "awards": [
      "Hugo Award for Best Novel (2007)",
      "Locus Award for Best SF Novel (2007)"
    ],
    "categories": [
      "Science Fiction"
    ],
    "scores": {
      "scifi": 10,
      "character": 9,
      "plot": 8,
      "worldbuilding": 10,
      "standalone": 10,
      "contemporary": 7,
      "cerebral": 8,
      "social": 8,
      "accessible": 7,
      "medium": 7,
      "philosophical": 7
    }
  },
  {
    "id": 899,
    "title": "Tigana",
    "author": "Guy Gavriel Kay",
    "authorGender": "male",
    "publicationYear": 1990,
    "isbn": "0451457765",
    "googleBooksId": "-8zYDwAAQBAJ",
    "image": "https://books.google.com/books/content?id=-8zYDwAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "The sorcerer Brandin conquered Tigana and erased even its name—only those born there can hear it. A group of survivors plots vengeance against two sorcerer-tyrants who have divided their land between them. An epic fantasy exploring memory, identity, and the price of liberation.",
    "rating": 4.29,
    "ratingsCount": 56815,
    "pageCount": 676,
    "awards": [
      "World Fantasy Award Nominee (1991)"
    ],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "literary": 9,
      "emotional": 10,
      "character": 10,
      "plot": 10,
      "atmosphere": 10,
      "standalone": 10,
      "lyrical": 9,
      "identity": 9,
      "political": 8,
      "worldbuilding": 9,
      "bittersweet": 8,
      "medium": 7,
      "dark": 7,
      "introspection": 8
    }
  },
  {
    "id": 900,
    "title": "The Lions of Al-Rassan",
    "author": "Guy Gavriel Kay",
    "authorGender": "male",
    "publicationYear": 1995,
    "isbn": "0060733497",
    "googleBooksId": "YSrqohctt8AC",
    "image": "https://books.google.com/books/content?id=YSrqohctt8AC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "In a land inspired by medieval Spain, the great Moorish culture of Al-Rassan crumbles as Christian kingdoms advance. Rodrigo Belmonte, the greatest warrior of his time, and Ammar ibn Khairan, poet and assassin, forge an unlikely friendship across enemy lines in this tale of honor, love, and civilizations in collision.",
    "rating": 4.32,
    "ratingsCount": 36813,
    "pageCount": 522,
    "categories": [
      "Fantasy",
      "Historical Fiction"
    ],
    "scores": {
      "fantasy": 10,
      "historical": 10,
      "literary": 10,
      "emotional": 10,
      "character": 10,
      "atmosphere": 10,
      "plot": 9,
      "standalone": 10,
      "lyrical": 9,
      "bittersweet": 8,
      "political": 8,
      "medium": 7,
      "tragic": 7
    }
  },
  {
    "id": 901,
    "title": "A Song for Arbonne",
    "author": "Guy Gavriel Kay",
    "authorGender": "male",
    "publicationYear": 1992,
    "isbn": "0451458974",
    "googleBooksId": "j72NEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=j72NEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "In sun-drenched Arbonne, a culture of poetry and courtly love faces destruction from the god-driven warriors of Gorhaut. Blaise of Gorhaut, a mercenary fleeing his homeland, becomes entangled in the conflict that will determine whether beauty or brutality prevails in this troubadour-inspired fantasy.",
    "rating": 4.1,
    "ratingsCount": 20845,
    "pageCount": 515,
    "categories": [
      "Fantasy",
      "Historical Fiction"
    ],
    "scores": {
      "fantasy": 10,
      "historical": 9,
      "literary": 9,
      "emotional": 9,
      "character": 10,
      "atmosphere": 10,
      "standalone": 10,
      "lyrical": 8,
      "political": 7,
      "heart": 8,
      "medium": 7
    }
  },
  {
    "id": 903,
    "title": "Under Heaven",
    "author": "Guy Gavriel Kay",
    "authorGender": "male",
    "publicationYear": 2010,
    "series": {
      "name": "Under Heaven",
      "position": 1
    },
    "isbn": "0451463692",
    "googleBooksId": "KNXtndVMtfsC",
    "image": "https://books.google.com/books/content?id=KNXtndVMtfsC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Shen Tai spends two years burying the dead of a great battle, and the grateful Princess of a neighboring kingdom gifts him 250 Sardian horses—a fortune that paints a target on his back. Set in an analog of Tang Dynasty China, this is a sweeping tale of honor, love, and political intrigue.",
    "rating": 4.07,
    "ratingsCount": 19378,
    "pageCount": 567,
    "awards": [
      "World Fantasy Award Nominee (2011)"
    ],
    "categories": [
      "Fantasy",
      "Historical Fiction"
    ],
    "scores": {
      "fantasy": 9,
      "historical": 10,
      "literary": 10,
      "character": 10,
      "atmosphere": 10,
      "plot": 9,
      "political": 9,
      "standalone": 10,
      "lyrical": 9,
      "medium": 7,
      "emotional": 8,
      "introspection": 7
    }
  },
  {
    "id": 906,
    "title": "The Memory Police",
    "author": "Yoko Ogawa",
    "authorGender": "female",
    "publicationYear": 1994,
    "isbn": "1101911964",
    "googleBooksId": "t1dADwAAQBAJ",
    "image": "https://books.google.com/books/content?id=t1dADwAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "On a nameless island, things disappear: roses, photographs, birds. The Memory Police ensure no one remembers what's lost. When novels are disappeared, a young writer hides her editor in a secret room as she feels her own memories slipping away in this haunting allegorical novel about loss and resistance.",
    "rating": 3.85,
    "ratingsCount": 144618,
    "pageCount": 274,
    "awards": [
      "International Booker Prize Shortlist (2020)",
      "National Book Award Finalist (2019)"
    ],
    "categories": [
      "Literary Fiction",
      "Dystopian",
      "Science Fiction"
    ],
    "scores": {
      "literary": 10,
      "scifi": 7,
      "emotional": 10,
      "slow": 8,
      "standalone": 10,
      "atmosphere": 10,
      "dark": 8,
      "philosophical": 9,
      "introspection": 9,
      "experimental": 8,
      "intimate": 8
    }
  },
  {
    "id": 908,
    "title": "Human Acts",
    "author": "Han Kang",
    "authorGender": "female",
    "publicationYear": 2014,
    "isbn": "0553448129",
    "googleBooksId": "mLpPEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=mLpPEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "In 1980 Gwangju, South Korean soldiers massacred pro-democracy protesters. Through seven interconnected stories spanning decades—a dead boy's ghost, a survivor who assembles bodies, an editor fighting censorship—Han Kang memorializes the violence and asks what remains of humanity in the face of atrocity.",
    "rating": 4.22,
    "ratingsCount": 103584,
    "pageCount": 223,
    "awards": [
      "Premio Malaparte (2017)",
      "Manhae Prize for Literature"
    ],
    "categories": [
      "Literary Fiction",
      "Historical Fiction"
    ],
    "scores": {
      "literary": 10,
      "historical": 10,
      "dark": 10,
      "emotional": 10,
      "political": 9,
      "atmosphere": 9,
      "standalone": 10,
      "multipov": 9,
      "tragic": 9,
      "social": 8,
      "philosophical": 7
    }
  },
  {
    "id": 912,
    "title": "Vita Nostra",
    "author": "Marina Dyachenko",
    "authorGender": "female",
    "publicationYear": 2007,
    "series": {
      "name": "Vita Nostra",
      "position": 1
    },
    "isbn": "0062694596",
    "googleBooksId": "jpTrtAEACAAJ",
    "image": "https://books.google.com/books/content?id=jpTrtAEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Sasha is coerced into attending the Institute of Special Technologies, where studying the impossible 'textbooks' physically transforms students. As she loses her humanity piece by piece, she discovers she's becoming something far stranger than human—a word, a concept, a grammatical structure. Dark academia meets Kafkaesque horror.",
    "rating": 4.06,
    "ratingsCount": 33589,
    "pageCount": 414,
    "categories": [
      "Fantasy",
      "Dark Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "horror": 8,
      "literary": 9,
      "dark": 9,
      "psychological": 9,
      "standalone": 10,
      "experimental": 9,
      "atmosphere": 9,
      "challenging": 8,
      "identity": 8,
      "introspection": 8
    }
  },
  {
    "id": 913,
    "title": "Daughter of the Empire",
    "author": "Raymond E. Feist",
    "authorGender": "male",
    "publicationYear": 1987,
    "series": {
      "name": "The Empire Trilogy",
      "position": 1
    },
    "isbn": "055327211X",
    "googleBooksId": "UiIP_51N2rEC",
    "image": "https://books.google.com/books/content?id=UiIP_51N2rEC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Mara, young Ruling Lady of House Acoma, inherits a house on the brink of destruction by powerful enemies. Through political cunning, unconventional alliances, and forbidden innovation, she fights to save her family in a Tsurani society where honor demands death before compromise. Epic fantasy inspired by Asian culture.",
    "rating": 4.21,
    "ratingsCount": 37865,
    "pageCount": 394,
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "political": 10,
      "character": 10,
      "plot": 10,
      "worldbuilding": 10,
      "series": 10,
      "introspection": 8,
      "medium": 8,
      "accessible": 8,
      "immersive": 9
    }
  },
  {
    "id": 914,
    "title": "Servant of the Empire",
    "author": "Raymond E. Feist",
    "authorGender": "male",
    "publicationYear": 1990,
    "series": {
      "name": "The Empire Trilogy",
      "position": 2
    },
    "isbn": "0553292455",
    "googleBooksId": "zLC_9qLzKvEC",
    "image": "https://books.google.com/books/content?id=zLC_9qLzKvEC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Mara captures Kevin, a barbarian slave from the Riftwar, whose alien ideas challenge everything she believes about honor and tradition. As she navigates deadly political games and falls in love against her will, Mara must choose between duty to tradition and revolutionary change.",
    "rating": 4.28,
    "ratingsCount": 23481,
    "pageCount": 738,
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "political": 10,
      "romance": 8,
      "character": 10,
      "plot": 10,
      "series": 10,
      "worldbuilding": 9,
      "emotional": 8,
      "medium": 8,
      "immersive": 9
    }
  },
  {
    "id": 915,
    "title": "Mistress of the Empire",
    "author": "Raymond E. Feist",
    "authorGender": "male",
    "publicationYear": 1992,
    "series": {
      "name": "The Empire Trilogy",
      "position": 3
    },
    "isbn": "0553561189",
    "googleBooksId": "krgxBmNAxWcC",
    "image": "https://books.google.com/books/content?id=krgxBmNAxWcC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Mara's son is assassinated by the Assembly of Magicians, whose power is absolute and untouchable. To avenge him, she must accomplish the impossible: challenge the magicians themselves while uniting factions that have warred for centuries. The epic conclusion to one of fantasy's great political trilogies.",
    "rating": 4.36,
    "ratingsCount": 21284,
    "pageCount": 693,
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "political": 10,
      "epic": 10,
      "character": 10,
      "plot": 10,
      "series": 10,
      "worldbuilding": 10,
      "cathartic": 8,
      "emotional": 9,
      "immersive": 9
    }
  },
  {
    "id": 916,
    "title": "Magician: Apprentice",
    "author": "Raymond E. Feist",
    "authorGender": "male",
    "publicationYear": 1982,
    "series": {
      "name": "The Riftwar Saga",
      "position": 1
    },
    "isbn": "0553564943",
    "googleBooksId": "vAiOEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=vAiOEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "On the world of Midkemia, orphan Pug becomes apprentice to the magician Kulgan. When invaders from another world pour through a rift, Pug is captured and transported to the Tsurani Empire. The beginning of an epic fantasy saga spanning worlds and generations.",
    "rating": 4.13,
    "ratingsCount": 92175,
    "pageCount": 341,
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "adventure": 10,
      "epic": 9,
      "character": 9,
      "worldbuilding": 10,
      "series": 10,
      "accessible": 8,
      "immersive": 9,
      "medium": 8,
      "plot": 9,
      "comingofage": 8
    }
  },
  {
    "id": 917,
    "title": "Magician: Master",
    "author": "Raymond E. Feist",
    "authorGender": "male",
    "publicationYear": 1982,
    "series": {
      "name": "The Riftwar Saga",
      "position": 2
    },
    "isbn": "0553564943",
    "googleBooksId": "jaUrDwAAQBAJ",
    "image": "https://books.google.com/books/content?id=jaUrDwAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Pug returns from Kelewan as Milamber, one of the most powerful magicians alive. But the Riftwar continues, and Pug must choose between his two worlds while discovering the truth about the Enemy that threatens both. The epic conclusion to the original Riftwar duology.",
    "rating": 4.26,
    "ratingsCount": 46837,
    "pageCount": 468,
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "adventure": 10,
      "epic": 10,
      "character": 9,
      "plot": 10,
      "series": 10,
      "worldbuilding": 9,
      "accessible": 8,
      "immersive": 9,
      "medium": 8
    }
  },
  {
    "id": 918,
    "title": "Silverthorn",
    "author": "Raymond E. Feist",
    "authorGender": "male",
    "publicationYear": 1985,
    "series": {
      "name": "The Riftwar Saga",
      "position": 3
    },
    "isbn": "0553270540",
    "googleBooksId": "H_JK_G_wza4C",
    "image": "https://books.google.com/books/content?id=H_JK_G_wza4C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Prince Arutha's bride is poisoned with silverthorn on their wedding day. To save her, he must lead a desperate quest to Moraelin, where the dark elves guard the antidote. A quest fantasy that deepens the Riftwar world while introducing new threats.",
    "rating": 4.19,
    "ratingsCount": 36729,
    "pageCount": 345,
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "adventure": 10,
      "plot": 9,
      "character": 8,
      "series": 10,
      "fast": 7,
      "accessible": 8,
      "immersive": 8,
      "medium": 7,
      "action": 7
    }
  },
  {
    "id": 919,
    "title": "A Darkness at Sethanon",
    "author": "Raymond E. Feist",
    "authorGender": "male",
    "publicationYear": 1986,
    "series": {
      "name": "The Riftwar Saga",
      "position": 4
    },
    "isbn": "0553263285",
    "googleBooksId": "2mKTEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=2mKTEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "The moredhel leader Murmandamus masses his armies to assault Sethanon, where a sleeping dragon guards a rift to other worlds. Pug and his companions must stop an ancient evil from breaking through—a climactic battle that reveals the cosmic stakes of the Riftwar world.",
    "rating": 4.28,
    "ratingsCount": 35186,
    "pageCount": 527,
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "adventure": 10,
      "plot": 10,
      "action": 10,
      "series": 10,
      "fast": 8,
      "accessible": 8,
      "immersive": 9,
      "worldbuilding": 9
    }
  },
  {
    "id": 920,
    "title": "Prince of the Blood",
    "author": "Raymond E. Feist",
    "authorGender": "male",
    "publicationYear": 1989,
    "isbn": "0553285246",
    "googleBooksId": "SP2ONYT4Es8C",
    "image": "https://books.google.com/books/content?id=SP2ONYT4Es8C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Princes Borric and Erland travel to the desert empire of Kesh on a diplomatic mission. But court intrigue, assassination attempts, and a beautiful princess embroil them in a plot that could destroy the peace between nations. A new generation faces its own trials.",
    "rating": 4.04,
    "ratingsCount": 24851,
    "pageCount": 397,
    "categories": [
      "Fantasy",
      "Adventure"
    ],
    "scores": {
      "fantasy": 10,
      "adventure": 9,
      "political": 9,
      "character": 8,
      "plot": 9,
      "series": 9,
      "medium": 7,
      "accessible": 7,
      "worldbuilding": 8,
      "emotional": 6,
      "classic": 5,
      "modern": 7
    }
  },
  {
    "id": 921,
    "title": "The King's Buccaneer",
    "author": "Raymond E. Feist",
    "authorGender": "male",
    "publicationYear": 1992,
    "isbn": "0553563734",
    "googleBooksId": "gmarmq1kzG0C",
    "image": "https://books.google.com/books/content?id=gmarmq1kzG0C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "When pirates raid Crydee and kidnap the Duke's children, young Prince Nicholas must lead a rescue mission across uncharted seas. His journey reveals a conspiracy involving the Pantathian serpent priests and an ancient evil stirring once again.",
    "rating": 4.08,
    "ratingsCount": 22107,
    "pageCount": 500,
    "categories": [
      "Fantasy",
      "Adventure"
    ],
    "scores": {
      "fantasy": 10,
      "adventure": 10,
      "plot": 9,
      "character": 8,
      "series": 9,
      "action": 8,
      "fast": 7,
      "accessible": 8,
      "immersive": 8,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 922,
    "title": "Shadow of a Dark Queen",
    "author": "Raymond E. Feist",
    "authorGender": "male",
    "publicationYear": 1994,
    "series": {
      "name": "The Serpentwar Saga",
      "position": 1
    },
    "isbn": "0380720868",
    "googleBooksId": "j5YylwEACAAJ",
    "image": "https://books.google.com/books/content?id=j5YylwEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Erik von Darkmoor and Roo Avery escape execution by joining a suicide mission into enemy territory. There they discover an army of demons preparing to invade—the beginning of a new war that will span worlds. The Serpentwar Saga begins.",
    "rating": 4.08,
    "ratingsCount": 30725,
    "pageCount": 497,
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "adventure": 10,
      "plot": 9,
      "series": 10,
      "action": 9,
      "dark": 7,
      "worldbuilding": 9,
      "fast": 8,
      "accessible": 8
    }
  },
  {
    "id": 926,
    "title": "A Simple Plan",
    "author": "Scott Smith",
    "authorGender": "male",
    "publicationYear": 1993,
    "isbn": "0307947378",
    "googleBooksId": "dZxu8YSGEekC",
    "image": "https://books.google.com/books/content?id=dZxu8YSGEekC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Three men find $4 million in a crashed plane. Their simple plan to keep it unravels into lies, paranoia, and murder as each 'necessary' cover-up demands another. A moral noir about ordinary people whose greed destroys everything they love. Devastating and unforgettable.",
    "rating": 3.92,
    "ratingsCount": 38914,
    "pageCount": 335,
    "categories": [
      "Thriller",
      "Crime",
      "Literary Fiction"
    ],
    "scores": {
      "thriller": 10,
      "dark": 10,
      "psychological": 10,
      "plot": 10,
      "character": 9,
      "mystery": 8,
      "standalone": 10,
      "moral": 9,
      "medium": 8,
      "literary": 8,
      "tragic": 9
    }
  },
  {
    "id": 927,
    "title": "Let the Right One In",
    "author": "John Ajvide Lindqvist",
    "authorGender": "male",
    "publicationYear": 2004,
    "isbn": "0312355297",
    "googleBooksId": "M-8nngEACAAJ",
    "image": "https://books.google.com/books/content?id=M-8nngEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Twelve-year-old Oskar, bullied and lonely in 1980s Stockholm, befriends his new neighbor Eli—a strange child who only comes out at night and smells of death. Their beautiful, terrible friendship unfolds as bodies pile up and Oskar learns what Eli really is. Vampires reimagined as tragic, feral children.",
    "rating": 4.02,
    "ratingsCount": 110247,
    "pageCount": 480,
    "categories": [
      "Horror",
      "Vampire",
      "Coming-of-Age"
    ],
    "scores": {
      "horror": 10,
      "literary": 9,
      "dark": 10,
      "emotional": 10,
      "character": 10,
      "atmosphere": 10,
      "standalone": 10,
      "slow": 7,
      "intimate": 9,
      "comingofage": 9,
      "tragic": 8,
      "introspection": 8
    }
  },
  {
    "id": 934,
    "title": "NOS4A2",
    "author": "Joe Hill",
    "authorGender": "male",
    "publicationYear": 2013,
    "isbn": "0062200577",
    "googleBooksId": "Zq1SOIMn08QC",
    "image": "https://books.google.com/books/content?id=Zq1SOIMn08QC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Victoria McQueen can find lost things by riding her bike across a covered bridge that shouldn't exist. Charlie Manx kidnaps children in his 1938 Rolls Royce Wraith and takes them to Christmasland, where unhappiness is against the law. When their paths cross, Vic begins a decades-long war to save the children.",
    "rating": 4.07,
    "ratingsCount": 102185,
    "pageCount": 704,
    "categories": [
      "Horror",
      "Fantasy"
    ],
    "scores": {
      "horror": 10,
      "fantasy": 8,
      "dark": 10,
      "epic": 9,
      "character": 10,
      "atmosphere": 10,
      "plot": 10,
      "standalone": 10,
      "medium": 8,
      "accessible": 8,
      "immersive": 9
    }
  },
  {
    "id": 940,
    "title": "I Am Legend",
    "author": "Richard Matheson",
    "authorGender": "male",
    "publicationYear": 1954,
    "isbn": "0765357151",
    "googleBooksId": "D9JAYgEACAAJ",
    "image": "https://books.google.com/books/content?id=D9JAYgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Robert Neville may be the last living man on Earth, surviving alone in a world of vampires. By day he hunts them; by night he barricades himself against their siege. This seminal work inspired modern zombie fiction and explores isolation, survival, and what makes a monster.",
    "rating": 4.04,
    "ratingsCount": 52821,
    "pageCount": 160,
    "awards": [
      "Horror Writers Association Award (1999)"
    ],
    "categories": [
      "Horror",
      "Science Fiction",
      "Post-Apocalyptic"
    ],
    "scores": {
      "horror": 10,
      "scifi": 9,
      "dark": 10,
      "character": 9,
      "atmosphere": 10,
      "standalone": 10,
      "psychological": 9,
      "survival": 9,
      "introspection": 9,
      "philosophical": 8,
      "slow": 7
    }
  },
  {
    "id": 942,
    "title": "The Shrinking Man",
    "author": "Richard Matheson",
    "authorGender": "male",
    "publicationYear": 1956,
    "isbn": "0765361175",
    "googleBooksId": "14SQEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=14SQEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Scott Carey is shrinking—an inch a week after exposure to a radioactive cloud. As he dwindles from husband to doll-sized survivor battling a spider in his own basement, he confronts questions of identity, meaning, and whether size determines one's worth in the universe.",
    "rating": 4,
    "ratingsCount": 14853,
    "pageCount": 192,
    "categories": [
      "Science Fiction",
      "Horror"
    ],
    "scores": {
      "scifi": 10,
      "horror": 7,
      "philosophical": 9,
      "character": 10,
      "atmosphere": 9,
      "standalone": 10,
      "introspection": 9,
      "identity": 9,
      "survival": 8,
      "literary": 8
    }
  },
  {
    "id": 943,
    "title": "A Stir of Echoes",
    "author": "Richard Matheson",
    "authorGender": "male",
    "publicationYear": 1958,
    "isbn": "0765308711",
    "googleBooksId": "S7vmmAEACAAJ",
    "image": "https://books.google.com/books/content?id=S7vmmAEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "After being hypnotized at a party, Tom Wallace begins seeing things—a woman, a presence, something wrong in his ordinary suburban house. His newfound psychic abilities reveal a murder cover-up and unleash forces that threaten his family. Domestic horror at its finest.",
    "rating": 3.87,
    "ratingsCount": 12458,
    "pageCount": 224,
    "categories": [
      "Horror",
      "Supernatural"
    ],
    "scores": {
      "horror": 9,
      "thriller": 8,
      "psychological": 9,
      "atmosphere": 9,
      "plot": 9,
      "standalone": 10,
      "family": 8,
      "accessible": 8,
      "medium": 8,
      "character": 5,
      "dark": 7,
      "classic": 8,
      "modern": 3
    }
  },
  {
    "id": 944,
    "title": "What Dreams May Come",
    "author": "Richard Matheson",
    "authorGender": "male",
    "publicationYear": 1978,
    "isbn": "0765308703",
    "googleBooksId": "3psmmAEACAAJ",
    "image": "https://books.google.com/books/content?id=3psmmAEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "After dying in an accident, Chris Nielsen explores a Heaven shaped by imagination and love. When he learns his wife committed suicide and is trapped in Hell, he undertakes the impossible journey to find her. A profound exploration of love, death, and the afterlife.",
    "rating": 4.09,
    "ratingsCount": 38647,
    "pageCount": 278,
    "categories": [
      "Fantasy",
      "Romance"
    ],
    "scores": {
      "fantasy": 10,
      "literary": 9,
      "emotional": 10,
      "romance": 9,
      "philosophical": 9,
      "atmosphere": 10,
      "standalone": 10,
      "heart": 9,
      "hopeful": 7,
      "immersive": 8
    }
  },
  {
    "id": 945,
    "title": "Somewhere in Time",
    "author": "Richard Matheson",
    "authorGender": "male",
    "publicationYear": 1975,
    "isbn": "0765361396",
    "googleBooksId": "rSrP9s8DbSsC",
    "image": "https://books.google.com/books/content?id=rSrP9s8DbSsC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Richard Collier becomes obsessed with an 1896 photograph of actress Elise McKenna. Using self-hypnosis, he travels back in time to find her—but their love is threatened by forces trying to pull him back to his own time. A heartbreaking time-travel romance.",
    "rating": 4.05,
    "ratingsCount": 16214,
    "pageCount": 278,
    "categories": [
      "Romance",
      "Fantasy",
      "Science Fiction"
    ],
    "scores": {
      "romance": 10,
      "fantasy": 8,
      "emotional": 10,
      "literary": 8,
      "atmosphere": 9,
      "standalone": 10,
      "bittersweet": 9,
      "heart": 9,
      "tragic": 8,
      "medium": 7,
      "slow": 5,
      "character": 8,
      "plot": 5,
      "classic": 5,
      "modern": 7
    }
  },
  {
    "id": 946,
    "title": "The Year of the Flood",
    "author": "Margaret Atwood",
    "authorGender": "female",
    "publicationYear": 2009,
    "series": {
      "name": "MaddAddam",
      "position": 2
    },
    "isbn": "0307455475",
    "googleBooksId": "pHMp5FKqCncC",
    "image": "https://books.google.com/books/content?id=pHMp5FKqCncC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "After the Waterless Flood devastates humanity, two women survive: Toby, holed up in a spa, and Ren, trapped in a sex club. Both were Gardeners, members of a green religion that predicted the plague. Parallel stories from the MaddAddam trilogy's apocalypse.",
    "rating": 3.92,
    "ratingsCount": 78247,
    "pageCount": 431,
    "categories": [
      "Science Fiction",
      "Dystopian",
      "Literary Fiction"
    ],
    "scores": {
      "scifi": 10,
      "literary": 9,
      "character": 9,
      "atmosphere": 10,
      "dark": 8,
      "series": 9,
      "philosophical": 8,
      "social": 8,
      "multipov": 8,
      "slow": 7
    }
  },
  {
    "id": 951,
    "title": "Possession",
    "author": "A.S. Byatt",
    "authorGender": "female",
    "publicationYear": 1990,
    "isbn": "0679735909",
    "googleBooksId": "4mUrVvGTeewC",
    "image": "https://books.google.com/books/content?id=4mUrVvGTeewC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Two scholars discover a correspondence between Victorian poets Randolph Henry Ash and Christabel LaMotte, revealing a secret affair. As they research, Roland and Maud become entangled in their subjects' passion—and in each other. A literary detective story and romance spanning centuries.",
    "rating": 3.89,
    "ratingsCount": 79212,
    "pageCount": 555,
    "awards": [
      "Booker Prize (1990)"
    ],
    "categories": [
      "Literary Fiction",
      "Romance",
      "Mystery"
    ],
    "scores": {
      "literary": 10,
      "romance": 9,
      "historical": 9,
      "mystery": 8,
      "character": 10,
      "atmosphere": 10,
      "standalone": 10,
      "lyrical": 9,
      "slow": 7,
      "introspection": 8,
      "dense": 8
    }
  },
  {
    "id": 954,
    "title": "Ragtime",
    "author": "E.L. Doctorow",
    "authorGender": "male",
    "publicationYear": 1975,
    "isbn": "0812978188",
    "googleBooksId": "yd9mAAAAMAAJ",
    "image": "https://books.google.com/books/content?id=yd9mAAAAMAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "In early 1900s New York, three families' stories interweave: a WASP family in New Rochelle, a Jewish immigrant and his daughter, and Coalhouse Walker, a Black musician whose injustice-fueled rage will change them all. Historical figures walk through a kaleidoscope of American promise and prejudice.",
    "rating": 3.89,
    "ratingsCount": 65284,
    "pageCount": 320,
    "awards": [
      "National Book Critics Circle Award (1976)"
    ],
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "scores": {
      "literary": 10,
      "historical": 10,
      "character": 10,
      "political": 9,
      "atmosphere": 10,
      "plot": 9,
      "standalone": 10,
      "multipov": 8,
      "social": 9,
      "medium": 7,
      "lyrical": 8
    }
  },
  {
    "id": 955,
    "title": "Billy Bathgate",
    "author": "E.L. Doctorow",
    "authorGender": "male",
    "publicationYear": 1989,
    "isbn": "0812978196",
    "googleBooksId": "Rf7F5BotqCMC",
    "image": "https://books.google.com/books/content?id=Rf7F5BotqCMC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Fifteen-year-old Billy Bathgate ingratiates himself with Dutch Schultz's gang in 1930s New York. As he rises from street kid to trusted insider, he witnesses the brutal end of Prohibition-era organized crime and falls for Dutch's doomed mistress. A Depression-era Bildungsroman.",
    "rating": 3.8,
    "ratingsCount": 15846,
    "pageCount": 323,
    "awards": [
      "PEN/Faulkner Award (1990)",
      "National Book Award Nominee (1989)"
    ],
    "categories": [
      "Historical Fiction",
      "Crime"
    ],
    "scores": {
      "literary": 10,
      "historical": 10,
      "mystery": 8,
      "character": 10,
      "atmosphere": 10,
      "comingofage": 9,
      "standalone": 10,
      "dark": 7,
      "immersive": 8,
      "medium": 7,
      "slow": 5,
      "plot": 5,
      "classic": 5,
      "modern": 7
    }
  },
  {
    "id": 958,
    "title": "The March",
    "author": "E.L. Doctorow",
    "authorGender": "male",
    "publicationYear": 2005,
    "isbn": "0812976150",
    "googleBooksId": "bKC5iVZwk5cC",
    "image": "https://books.google.com/books/content?id=bKC5iVZwk5cC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "General Sherman's devastating march through Georgia and the Carolinas reshapes everyone in its path: former slaves, Confederate deserters, Union soldiers, and Southern civilians. A kaleidoscopic historical epic about the chaos and transformation of total war.",
    "rating": 3.94,
    "ratingsCount": 18437,
    "pageCount": 363,
    "awards": [
      "National Book Critics Circle Award (2005)",
      "PEN/Faulkner Award (2006)",
      "Pulitzer Prize Finalist (2006)"
    ],
    "categories": [
      "Historical Fiction",
      "War"
    ],
    "scores": {
      "literary": 10,
      "historical": 10,
      "epic": 10,
      "character": 10,
      "atmosphere": 10,
      "dark": 8,
      "standalone": 10,
      "multipov": 9,
      "plot": 9,
      "political": 8
    }
  },
  {
    "id": 963,
    "title": "City of Thieves",
    "author": "David Benioff",
    "authorGender": "male",
    "publicationYear": 2008,
    "isbn": "0452295297",
    "googleBooksId": "uFbvtwEACAAJ",
    "image": "https://books.google.com/books/content?id=uFbvtwEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "During the Nazi siege of Leningrad, teenager Lev and deserter Kolya are given an impossible mission: find a dozen eggs for a Soviet colonel's daughter's wedding cake, or die. Their odyssey through the starving city and behind enemy lines is darkly funny, violent, and profound.",
    "rating": 4.24,
    "ratingsCount": 239489,
    "pageCount": 258,
    "categories": [
      "Historical Fiction",
      "War",
      "Adventure"
    ],
    "scores": {
      "literary": 10,
      "historical": 10,
      "adventure": 10,
      "character": 10,
      "dark": 9,
      "emotional": 9,
      "standalone": 10,
      "humor": 8,
      "fast": 8,
      "friendship": 9,
      "immersive": 9
    }
  },
  {
    "id": 971,
    "title": "Watership Down",
    "author": "Richard Adams",
    "authorGender": "male",
    "publicationYear": 1972,
    "series": {
      "name": "Watership Down",
      "position": 1
    },
    "isbn": "0743277708",
    "googleBooksId": "E4WUxwEACAAJ",
    "image": "https://books.google.com/books/content?id=E4WUxwEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "When young rabbit Fiver has visions of their warren's destruction, he and his brother Hazel lead a band of rabbits across the English countryside seeking a new home. Their odyssey brings encounters with tyrannical warrens, natural predators, and the militant General Woundwort.",
    "rating": 4.08,
    "ratingsCount": 499478,
    "pageCount": 478,
    "awards": [
      "Carnegie Medal (1972)",
      "Guardian Children's Fiction Prize (1972)"
    ],
    "categories": [
      "Fantasy",
      "Classic",
      "Adventure"
    ],
    "scores": {
      "fantasy": 10,
      "adventure": 10,
      "literary": 9,
      "character": 10,
      "emotional": 10,
      "standalone": 10,
      "epic": 9,
      "worldbuilding": 9,
      "accessible": 9,
      "immersive": 10
    }
  },
  {
    "id": 972,
    "title": "The Phantom Tollbooth",
    "author": "Norton Juster",
    "authorGender": "male",
    "publicationYear": 1961,
    "isbn": "0394820371",
    "googleBooksId": "87UWNi83IrIC",
    "image": "https://books.google.com/books/content?id=87UWNi83IrIC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Bored Milo drives through a mysterious tollbooth into the Lands Beyond, where he must rescue the princesses Rhyme and Reason from the Castle in the Air. With his companions Tock (a watchdog who ticks) and the Humbug, he discovers that learning is the greatest adventure.",
    "rating": 4.13,
    "ratingsCount": 255631,
    "pageCount": 256,
    "categories": [
      "Fantasy",
      "Classic",
      "Children's"
    ],
    "scores": {
      "fantasy": 10,
      "literary": 9,
      "adventure": 9,
      "standalone": 10,
      "humor": 9,
      "accessible": 10,
      "whimsical": 10,
      "cozy": 8,
      "medium": 7,
      "slow": 5,
      "character": 8,
      "plot": 5,
      "classic": 8,
      "modern": 3
    }
  },
  {
    "id": 973,
    "title": "The Secret Garden",
    "author": "Frances Hodgson Burnett",
    "authorGender": "female",
    "publicationYear": 1911,
    "isbn": "0142437050",
    "googleBooksId": "_WlHPgAACAAJ",
    "image": "https://books.google.com/books/content?id=_WlHPgAACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Orphaned Mary Lennox arrives at her uncle's gloomy Yorkshire manor, where she discovers a locked garden and a sickly cousin kept hidden. As she brings the garden back to life, she transforms herself and the household in this classic about the healing power of nature and friendship.",
    "rating": 4.14,
    "ratingsCount": 749285,
    "pageCount": 331,
    "categories": [
      "Classic",
      "Children's",
      "Literary Fiction"
    ],
    "scores": {
      "literary": 9,
      "emotional": 10,
      "character": 10,
      "heart": 10,
      "atmosphere": 10,
      "standalone": 10,
      "comingofage": 9,
      "hopeful": 9,
      "accessible": 10,
      "medium": 7,
      "slow": 5,
      "plot": 5,
      "classic": 8,
      "modern": 3
    }
  },
  {
    "id": 974,
    "title": "Charlotte's Web",
    "author": "E.B. White",
    "authorGender": "male",
    "publicationYear": 1952,
    "isbn": "0064400557",
    "googleBooksId": "7NEul8arWTMC",
    "image": "https://books.google.com/books/content?id=7NEul8arWTMC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "When Fern saves piglet Wilbur from slaughter, he's sent to her uncle's farm, where he befriends Charlotte, a wise spider. Charlotte's plan to save Wilbur from the smokehouse—weaving words into her web—creates a miracle and a meditation on friendship, mortality, and the cycle of life.",
    "rating": 4.19,
    "ratingsCount": 1844653,
    "pageCount": 184,
    "awards": [
      "Newbery Honor (1953)"
    ],
    "categories": [
      "Classic",
      "Children's",
      "Fantasy"
    ],
    "scores": {
      "literary": 10,
      "emotional": 10,
      "character": 10,
      "heart": 10,
      "standalone": 10,
      "friendship": 10,
      "bittersweet": 8,
      "accessible": 10,
      "medium": 7,
      "slow": 5,
      "plot": 5,
      "classic": 8,
      "modern": 3
    }
  },
  {
    "id": 975,
    "title": "The Lottery and Other Stories",
    "author": "Shirley Jackson",
    "authorGender": "female",
    "publicationYear": 1949,
    "isbn": "0374529531",
    "googleBooksId": "B9hEAwAAQBAJ",
    "image": "https://books.google.com/books/content?id=B9hEAwAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "The title story shocked readers in 1948: a sunny small town conducts an annual lottery with a horrifying prize. The collection explores the darkness beneath ordinary life: repressed women, menacing children, and communities that enforce conformity through violence.",
    "rating": 4.11,
    "ratingsCount": 100842,
    "pageCount": 302,
    "categories": [
      "Short Stories",
      "Horror",
      "Classic"
    ],
    "scores": {
      "literary": 10,
      "horror": 9,
      "dark": 10,
      "psychological": 9,
      "standalone": 10,
      "social": 9,
      "atmosphere": 9,
      "twist": 9,
      "fast": 7,
      "medium": 5,
      "character": 8,
      "plot": 5,
      "classic": 8,
      "modern": 3
    }
  },
  {
    "id": 976,
    "title": "The Call of the Wild",
    "author": "Jack London",
    "authorGender": "male",
    "publicationYear": 1903,
    "isbn": "0486264726",
    "googleBooksId": "v1WMCgAAQBAJ",
    "image": "https://books.google.com/books/content?id=v1WMCgAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Buck, a powerful St. Bernard mix, is stolen from California and sold as a sled dog in the Klondike Gold Rush. Through brutal treatment and savage fights, he transforms from pet to primitive beast, hearing the call of his wolf ancestors and finally answering it.",
    "rating": 3.88,
    "ratingsCount": 442289,
    "pageCount": 128,
    "categories": [
      "Classic",
      "Adventure",
      "Literary Fiction"
    ],
    "scores": {
      "adventure": 10,
      "literary": 9,
      "character": 10,
      "atmosphere": 10,
      "standalone": 10,
      "survival": 10,
      "dark": 7,
      "fast": 8,
      "accessible": 9,
      "plot": 5,
      "classic": 8,
      "modern": 3
    }
  },
  {
    "id": 977,
    "title": "White Fang",
    "author": "Jack London",
    "authorGender": "male",
    "publicationYear": 1906,
    "isbn": "0486269698",
    "googleBooksId": "JJK8DwAAQBAJ",
    "image": "https://books.google.com/books/content?id=JJK8DwAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "A wolf-dog survives the brutal Yukon wilderness, cruel owners, and fighting pits before finding redemption with a kind master. The companion to The Call of the Wild, told from the animal's perspective as he moves from savagery toward civilization and love.",
    "rating": 3.9,
    "ratingsCount": 230845,
    "pageCount": 246,
    "categories": [
      "Classic",
      "Adventure",
      "Literary Fiction"
    ],
    "scores": {
      "adventure": 10,
      "literary": 9,
      "character": 10,
      "atmosphere": 10,
      "emotional": 9,
      "standalone": 10,
      "survival": 9,
      "dark": 7,
      "accessible": 9,
      "hopeful": 8
    }
  },
  {
    "id": 978,
    "title": "Where the Red Fern Grows",
    "author": "Wilson Rawls",
    "authorGender": "male",
    "publicationYear": 1961,
    "isbn": "0440412676",
    "googleBooksId": "bGE9DwAAQBAJ",
    "image": "https://books.google.com/books/content?id=bGE9DwAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "In the Ozark Mountains, young Billy saves for two years to buy two coonhound pups, Old Dan and Little Ann. Together they become legendary hunters, but their devotion to each other will be tested by tragedy. A heartbreaking classic about a boy, his dogs, and unconditional love.",
    "rating": 4.09,
    "ratingsCount": 335762,
    "pageCount": 212,
    "categories": [
      "Classic",
      "Coming-of-Age",
      "Literary Fiction"
    ],
    "scores": {
      "emotional": 10,
      "comingofage": 10,
      "character": 10,
      "heart": 10,
      "standalone": 10,
      "accessible": 10,
      "atmosphere": 9,
      "tragic": 8,
      "contemporary": 7,
      "literary": 6,
      "medium": 7,
      "plot": 5,
      "classic": 8,
      "modern": 3
    }
  },
  {
    "id": 979,
    "title": "A Wrinkle in Time",
    "author": "Madeleine L'Engle",
    "authorGender": "female",
    "publicationYear": 1962,
    "isbn": "0374386137",
    "googleBooksId": "8_RSsjTZj5MC",
    "image": "https://books.google.com/books/content?id=8_RSsjTZj5MC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Meg Murry, her brilliant brother Charles Wallace, and friend Calvin O'Keefe travel through space and time to rescue Meg's father from the evil IT. Guided by three mysterious beings—Mrs. Whatsit, Mrs. Who, and Mrs. Which—they tesseract across the universe in this classic about love conquering darkness.",
    "rating": 3.97,
    "ratingsCount": 1128956,
    "pageCount": 211,
    "awards": [
      "Newbery Medal (1963)",
      "Sequoyah Book Award",
      "Lewis Carroll Shelf Award"
    ],
    "categories": [
      "Science Fiction",
      "Fantasy",
      "Young Adult"
    ],
    "scores": {
      "scifi": 9,
      "fantasy": 9,
      "adventure": 10,
      "emotional": 9,
      "series": 8,
      "family": 9,
      "accessible": 10,
      "hopeful": 8,
      "comingofage": 8,
      "medium": 7,
      "plot": 8,
      "character": 6,
      "classic": 8,
      "modern": 3
    }
  },
  {
    "id": 980,
    "title": "Dandelion Wine",
    "author": "Ray Bradbury",
    "authorGender": "male",
    "publicationYear": 1957,
    "series": {
      "name": "Green Town",
      "position": 1
    },
    "isbn": "0380977265",
    "googleBooksId": "IrgUzwEACAAJ",
    "image": "https://books.google.com/books/content?id=IrgUzwEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Twelve-year-old Douglas Spaulding experiences the summer of 1928 in Green Town, Illinois—bottling the essence of dandelions and of life itself. Through vignettes of magic, terror, and wonder, Bradbury captures the intensity of childhood summers and the bittersweet knowledge that they must end.",
    "rating": 4.12,
    "ratingsCount": 58647,
    "pageCount": 239,
    "categories": [
      "Literary Fiction",
      "Classic",
      "Coming-of-Age"
    ],
    "scores": {
      "literary": 10,
      "atmosphere": 10,
      "character": 9,
      "comingofage": 9,
      "standalone": 10,
      "lyrical": 9,
      "emotional": 9,
      "hopeful": 8,
      "intimate": 9,
      "medium": 7,
      "slow": 5,
      "plot": 5,
      "classic": 8,
      "modern": 3
    }
  },
  {
    "id": 981,
    "title": "The October Country",
    "author": "Ray Bradbury",
    "authorGender": "male",
    "publicationYear": 1955,
    "isbn": "0380973871",
    "googleBooksId": "6zk3f4_78I4C",
    "image": "https://books.google.com/books/content?id=6zk3f4_78I4C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Nineteen stories set in a land of autumn and shadow: a man discovers the skeleton inside him wants out; a child is born with a peculiar hunger; an old woman knits a shroud. Bradbury's dark carnival of the macabre and melancholy.",
    "rating": 4.12,
    "ratingsCount": 21478,
    "pageCount": 276,
    "categories": [
      "Horror",
      "Short Stories",
      "Classic"
    ],
    "scores": {
      "horror": 9,
      "literary": 10,
      "dark": 9,
      "atmosphere": 10,
      "standalone": 10,
      "lyrical": 8,
      "psychological": 8,
      "accessible": 8,
      "fast": 7,
      "medium": 5,
      "character": 8,
      "plot": 5,
      "classic": 8,
      "modern": 3
    }
  },
  {
    "id": 982,
    "title": "Killing Floor",
    "author": "Lee Child",
    "authorGender": "male",
    "publicationYear": 1997,
    "isbn": "0515153651",
    "googleBooksId": "ADiMDQAAQBAJ",
    "image": "https://books.google.com/books/content?id=ADiMDQAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Jack Reacher steps off a bus in tiny Margrave, Georgia, and is immediately arrested for murder. The conspiracy he uncovers reaches into counterfeiting, corrupt officials, and his own brother's death. The explosive debut of the iconic drifter hero.",
    "rating": 4.09,
    "ratingsCount": 285124,
    "pageCount": 531,
    "awards": [
      "Anthony Award for Best First Mystery (1998)"
    ],
    "categories": [
      "Thriller",
      "Mystery",
      "Crime"
    ],
    "scores": {
      "thriller": 10,
      "action": 10,
      "mystery": 8,
      "plot": 10,
      "character": 9,
      "fast": 10,
      "series": 10,
      "accessible": 9,
      "immersive": 9,
      "dark": 7,
      "modern": 8
    }
  },
  {
    "id": 983,
    "title": "The Spy Who Came in from the Cold",
    "author": "John le Carré",
    "authorGender": "male",
    "publicationYear": 1963,
    "series": {
      "name": "George Smiley",
      "position": 3
    },
    "isbn": "0143124757",
    "googleBooksId": "aJdPEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=aJdPEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "British agent Alec Leamas pretends to defect to East Germany to destroy the head of their intelligence. But the operation's true purpose is far more cynical, and Leamas must confront the moral cost of the spy game. The cold classic that redefined espionage fiction.",
    "rating": 3.93,
    "ratingsCount": 127844,
    "pageCount": 256,
    "awards": [
      "Gold Dagger Award (1963)"
    ],
    "categories": [
      "Thriller",
      "Espionage",
      "Classic"
    ],
    "scores": {
      "thriller": 10,
      "literary": 10,
      "dark": 10,
      "plot": 10,
      "character": 10,
      "standalone": 10,
      "psychological": 9,
      "atmosphere": 9,
      "moral": 9,
      "slow": 7
    }
  },
  {
    "id": 984,
    "title": "Tinker Tailor Soldier Spy",
    "author": "John le Carré",
    "authorGender": "male",
    "publicationYear": 1974,
    "series": {
      "name": "George Smiley",
      "position": 5
    },
    "isbn": "0143119788",
    "googleBooksId": "U-N8qZt8GgkC",
    "image": "https://books.google.com/books/content?id=U-N8qZt8GgkC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Retired spymaster George Smiley is called back to find a Soviet mole at the highest levels of British intelligence. The suspects are his former colleagues—any of whom could be the traitor called 'Gerald.' A masterwork of paranoia, tradecraft, and moral ambiguity.",
    "rating": 4.01,
    "ratingsCount": 101487,
    "pageCount": 355,
    "categories": [
      "Thriller",
      "Espionage",
      "Classic"
    ],
    "scores": {
      "thriller": 10,
      "literary": 10,
      "mystery": 10,
      "character": 10,
      "plot": 10,
      "slow": 8,
      "series": 10,
      "psychological": 9,
      "atmosphere": 9,
      "cerebral": 8
    }
  },
  {
    "id": 985,
    "title": "The Day of the Jackal",
    "author": "Frederick Forsyth",
    "authorGender": "male",
    "publicationYear": 1971,
    "isbn": "0451239377",
    "googleBooksId": "Op9PEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=Op9PEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "The OAS hires an assassin known only as the Jackal to kill Charles de Gaulle. French detective Claude Lebel must stop him before the August date when the Jackal will strike. A procedural masterpiece of meticulous planning and methodical pursuit.",
    "rating": 4.19,
    "ratingsCount": 113284,
    "pageCount": 380,
    "awards": [
      "Edgar Award for Best Novel (1972)"
    ],
    "categories": [
      "Thriller",
      "Espionage",
      "Classic"
    ],
    "scores": {
      "thriller": 10,
      "plot": 10,
      "fast": 9,
      "standalone": 10,
      "action": 8,
      "accessible": 9,
      "immersive": 9,
      "character": 5,
      "dark": 7,
      "classic": 5,
      "modern": 7
    }
  },
  {
    "id": 986,
    "title": "The Hunt for Red October",
    "author": "Tom Clancy",
    "authorGender": "male",
    "publicationYear": 1984,
    "isbn": "0425240339",
    "googleBooksId": "H-KXDgAAQBAJ",
    "image": "https://books.google.com/books/content?id=H-KXDgAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Soviet submarine captain Marko Ramius takes his new typhoon-class submarine Red October and heads for America—to defect or to attack? CIA analyst Jack Ryan must convince the Navy that Ramius isn't starting World War III. The techno-thriller that launched a genre.",
    "rating": 4.11,
    "ratingsCount": 364578,
    "pageCount": 432,
    "categories": [
      "Thriller",
      "Military",
      "Espionage"
    ],
    "scores": {
      "thriller": 10,
      "plot": 10,
      "action": 9,
      "series": 10,
      "political": 8,
      "fast": 8,
      "accessible": 9,
      "immersive": 9,
      "character": 5,
      "dark": 7,
      "classic": 5,
      "modern": 7
    }
  },
  {
    "id": 987,
    "title": "The Firm",
    "author": "John Grisham",
    "authorGender": "male",
    "publicationYear": 1991,
    "isbn": "0440245923",
    "googleBooksId": "a86JDQAAQBAJ",
    "image": "https://books.google.com/books/content?id=a86JDQAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Young lawyer Mitch McDeere joins a small Memphis tax firm with unbelievable perks—and discovers it's a front for the mob. With the FBI pressuring him to inform and the firm killing associates who try to leave, Mitch must find a third option to survive.",
    "rating": 4.03,
    "ratingsCount": 559847,
    "pageCount": 421,
    "categories": [
      "Legal Thriller",
      "Crime"
    ],
    "scores": {
      "thriller": 10,
      "plot": 10,
      "fast": 10,
      "standalone": 10,
      "mystery": 8,
      "accessible": 9,
      "immersive": 9,
      "character": 5,
      "dark": 7,
      "modern": 8
    }
  },
  {
    "id": 988,
    "title": "A Time to Kill",
    "author": "John Grisham",
    "authorGender": "male",
    "publicationYear": 1989,
    "series": {
      "name": "Jake Brigance",
      "position": 1
    },
    "isbn": "0440245915",
    "googleBooksId": "DLXmJRys8b0C",
    "image": "https://books.google.com/books/content?id=DLXmJRys8b0C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "In Mississippi, Carl Lee Hailey shoots the two men who raped his ten-year-old daughter. Young lawyer Jake Brigance defends him against murder charges in a trial that exposes the town's racial tensions. Grisham's debut asks when vigilante justice is justified.",
    "rating": 4.19,
    "ratingsCount": 319564,
    "pageCount": 515,
    "categories": [
      "Legal Thriller",
      "Drama"
    ],
    "scores": {
      "thriller": 9,
      "emotional": 10,
      "character": 10,
      "plot": 9,
      "social": 10,
      "standalone": 10,
      "moral": 9,
      "accessible": 9,
      "dark": 8,
      "fast": 7,
      "medium": 5,
      "classic": 5,
      "modern": 7
    }
  },
  {
    "id": 989,
    "title": "The Pelican Brief",
    "author": "John Grisham",
    "authorGender": "male",
    "publicationYear": 1992,
    "isbn": "0440245931",
    "googleBooksId": "rQFlTZeetcoC",
    "image": "https://books.google.com/books/content?id=rQFlTZeetcoC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Law student Darby Shaw writes a brief theorizing who murdered two Supreme Court justices—and suddenly everyone wants her dead. With reporter Gray Grantham, she uncovers a conspiracy reaching the White House. A taut political thriller.",
    "rating": 4.01,
    "ratingsCount": 262198,
    "pageCount": 389,
    "categories": [
      "Legal Thriller",
      "Political Thriller"
    ],
    "scores": {
      "thriller": 10,
      "political": 10,
      "plot": 10,
      "fast": 10,
      "standalone": 10,
      "action": 8,
      "accessible": 9,
      "character": 5,
      "dark": 7,
      "modern": 8
    }
  },
  {
    "id": 990,
    "title": "The Client",
    "author": "John Grisham",
    "authorGender": "male",
    "publicationYear": 1993,
    "isbn": "044021352X",
    "googleBooksId": "xrgrFkmYNdQC",
    "image": "https://books.google.com/books/content?id=xrgrFkmYNdQC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Eleven-year-old Mark Sway witnesses a mob lawyer's suicide and learns where a body is buried. Now the FBI wants him to talk, and the mob wants him dead. Only attorney Reggie Love stands between Mark and the forces hunting him.",
    "rating": 3.97,
    "ratingsCount": 292175,
    "pageCount": 422,
    "categories": [
      "Legal Thriller"
    ],
    "scores": {
      "thriller": 10,
      "plot": 10,
      "character": 9,
      "fast": 9,
      "standalone": 10,
      "accessible": 9,
      "immersive": 9,
      "dark": 7,
      "modern": 8,
      "atmosphere": 6
    }
  },
  {
    "id": 991,
    "title": "The Chamber",
    "author": "John Grisham",
    "authorGender": "male",
    "publicationYear": 1994,
    "isbn": "0440220483",
    "googleBooksId": "B_ejY3GLhYoC",
    "image": "https://books.google.com/books/content?id=B_ejY3GLhYoC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Adam Hall's grandfather is on death row in Mississippi for bombing a Jewish lawyer's office. With weeks until execution, Adam must confront a family legacy of racism, violence, and secrets while fighting to save a man who may not deserve saving.",
    "rating": 3.86,
    "ratingsCount": 89461,
    "pageCount": 676,
    "categories": [
      "Legal Thriller",
      "Drama"
    ],
    "scores": {
      "thriller": 8,
      "emotional": 10,
      "character": 10,
      "social": 10,
      "dark": 9,
      "standalone": 10,
      "family": 8,
      "moral": 9,
      "accessible": 8,
      "fast": 7,
      "medium": 5,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 992,
    "title": "The Rainmaker",
    "author": "John Grisham",
    "authorGender": "male",
    "publicationYear": 1995,
    "isbn": "0440221838",
    "googleBooksId": "m_xxptf-qo0C",
    "image": "https://books.google.com/books/content?id=m_xxptf-qo0C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Fresh out of law school, Rudy Baylor takes on Great Benefit insurance company, which denied a leukemia patient's claim. His first case puts him against high-powered lawyers as he fights for the dying Donny Ray Black and discovers the insurance industry's deadly secrets.",
    "rating": 4.02,
    "ratingsCount": 218765,
    "pageCount": 597,
    "categories": [
      "Legal Thriller",
      "Drama"
    ],
    "scores": {
      "thriller": 8,
      "emotional": 10,
      "character": 10,
      "social": 9,
      "plot": 9,
      "standalone": 10,
      "moral": 8,
      "accessible": 9,
      "fast": 7,
      "medium": 5,
      "modern": 8
    }
  },
  {
    "id": 994,
    "title": "Anne of Green Gables",
    "author": "L.M. Montgomery",
    "authorGender": "female",
    "publicationYear": 1908,
    "isbn": "0141321598",
    "googleBooksId": "b-wtcmjMCY0C",
    "image": "https://books.google.com/books/content?id=b-wtcmjMCY0C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "When Matthew and Marilla Cuthbert request an orphan boy to help on their farm, they get red-haired, imaginative Anne Shirley instead. Anne's dramatic spirit, romantic notions, and knack for mishaps transform Green Gables and the hearts of everyone in Avonlea.",
    "rating": 4.3,
    "ratingsCount": 1024598,
    "pageCount": 320,
    "categories": [
      "Classic",
      "Coming-of-Age",
      "Children's"
    ],
    "scores": {
      "literary": 9,
      "character": 10,
      "heart": 10,
      "comingofage": 10,
      "atmosphere": 9,
      "series": 10,
      "hopeful": 9,
      "accessible": 10,
      "humor": 8,
      "medium": 7,
      "slow": 5,
      "plot": 5,
      "classic": 8,
      "modern": 3
    }
  },
  {
    "id": 995,
    "title": "Peter Pan",
    "author": "J.M. Barrie",
    "authorGender": "male",
    "publicationYear": 1911,
    "isbn": "0141331011",
    "googleBooksId": "ogjljqn1R2kC",
    "image": "https://books.google.com/books/content?id=ogjljqn1R2kC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Wendy, John, and Michael Darling fly to Neverland with the boy who won't grow up, where they meet the Lost Boys, befriend Indians, and battle the villainous Captain Hook. A bittersweet fantasy about childhood, motherhood, and the tragedy of never aging.",
    "rating": 4.08,
    "ratingsCount": 335876,
    "pageCount": 200,
    "categories": [
      "Fantasy",
      "Classic",
      "Children's"
    ],
    "scores": {
      "fantasy": 10,
      "adventure": 10,
      "atmosphere": 9,
      "emotional": 8,
      "standalone": 10,
      "whimsical": 9,
      "bittersweet": 8,
      "accessible": 9,
      "medium": 7,
      "character": 7,
      "plot": 6,
      "classic": 8,
      "modern": 3
    }
  },
  {
    "id": 999,
    "title": "The Snowman",
    "author": "Jo Nesbø",
    "authorGender": "male",
    "publicationYear": 2007,
    "isbn": "0307742997",
    "googleBooksId": "9BEjX1U7Op4C",
    "image": "https://books.google.com/books/content?id=9BEjX1U7Op4C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Norway's first serial killer builds snowmen at his crime scenes—and Inspector Harry Hole realizes he's been sending taunting letters for years. As winter descends on Oslo, Harry races to catch a methodical predator before the snowman appears outside another victim's home.",
    "rating": 4.08,
    "ratingsCount": 128742,
    "pageCount": 384,
    "categories": [
      "Thriller",
      "Mystery",
      "Crime"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 10,
      "dark": 10,
      "plot": 10,
      "atmosphere": 10,
      "character": 9,
      "series": 10,
      "psychological": 8,
      "fast": 8,
      "modern": 8
    }
  },
  {
    "id": 1000,
    "title": "The Leopard",
    "author": "Jo Nesbø",
    "authorGender": "male",
    "publicationYear": 2009,
    "isbn": "0307742989",
    "googleBooksId": "qJrJMQsy6TcC",
    "image": "https://books.google.com/books/content?id=qJrJMQsy6TcC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Harry Hole is in Hong Kong, trying to drink himself to death, when a Norwegian politician is murdered. Called home to catch a killer who fills victims' mouths with a mysterious substance, Harry uncovers connections to an infamous unsolved case—and to his own past.",
    "rating": 4.07,
    "ratingsCount": 65287,
    "pageCount": 608,
    "categories": [
      "Thriller",
      "Mystery",
      "Crime"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 10,
      "dark": 10,
      "plot": 10,
      "character": 10,
      "atmosphere": 10,
      "series": 10,
      "psychological": 9,
      "medium": 7,
      "modern": 8
    }
  },
  {
    "id": 1001,
    "title": "Phantom",
    "author": "Jo Nesbø",
    "authorGender": "male",
    "publicationYear": 2012,
    "isbn": "0307960471",
    "googleBooksId": "WewU0QEACAAJ",
    "image": "https://books.google.com/books/content?id=WewU0QEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Harry Hole's former girlfriend's son is found dead of an apparent overdose. Oleg Fauke was like a son to Harry, and the official story doesn't add up. Harry returns to Oslo's drug underworld and takes on both dealers and his own department to find the truth.",
    "rating": 4.08,
    "ratingsCount": 38475,
    "pageCount": 480,
    "categories": [
      "Thriller",
      "Mystery"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 9,
      "dark": 10,
      "emotional": 10,
      "character": 10,
      "plot": 9,
      "series": 10,
      "psychological": 8,
      "medium": 7,
      "modern": 8
    }
  },
  {
    "id": 1003,
    "title": "The Thirst",
    "author": "Jo Nesbø",
    "authorGender": "male",
    "publicationYear": 2017,
    "isbn": "0385352166",
    "googleBooksId": "MGM2vgAACAAJ",
    "image": "https://books.google.com/books/content?id=MGM2vgAACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "A serial killer called 'the vampirist' is drinking his victims' blood in Oslo. Harry Hole, now teaching at the police academy, is drawn back into investigation by his old boss. The killer is cunning, connected, and seems to know Harry personally.",
    "rating": 4.07,
    "ratingsCount": 49187,
    "pageCount": 512,
    "categories": [
      "Thriller",
      "Mystery"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 10,
      "dark": 10,
      "horror": 8,
      "plot": 10,
      "character": 9,
      "series": 10,
      "fast": 8,
      "psychological": 8,
      "modern": 8
    }
  },
  {
    "id": 1005,
    "title": "The Redbreast",
    "author": "Jo Nesbø",
    "authorGender": "male",
    "publicationYear": 2000,
    "isbn": "0061134007",
    "googleBooksId": "hUL0mQEACAAJ",
    "image": "https://books.google.com/books/content?id=hUL0mQEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "A Nazi-era rifle surfaces in modern Oslo, and inspector Harry Hole's investigation connects neo-Nazis, Norwegian collaborators, and a sniper from WWII's Eastern Front. Past and present interweave as Harry hunts a killer with a seventy-year grudge.",
    "rating": 4.11,
    "ratingsCount": 41287,
    "pageCount": 521,
    "awards": [
      "Glass Key Award (2005)",
      "Riverton Prize (2000)"
    ],
    "categories": [
      "Thriller",
      "Mystery",
      "Historical Fiction"
    ],
    "scores": {
      "thriller": 10,
      "mystery": 10,
      "historical": 9,
      "dark": 9,
      "plot": 10,
      "atmosphere": 9,
      "series": 10,
      "medium": 7,
      "political": 7,
      "character": 5,
      "modern": 8
    }
  },
  {
    "id": 1014,
    "title": "Kafka on the Shore",
    "author": "Haruki Murakami",
    "authorGender": "male",
    "publicationYear": 2002,
    "isbn": "1400079276",
    "googleBooksId": "A08c2Ep7QbYC",
    "image": "https://books.google.com/books/content?id=A08c2Ep7QbYC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Fifteen-year-old Kafka runs away to escape an Oedipal prophecy. Meanwhile, elderly Nakata—simple-minded after a childhood incident—can talk to cats and begins a journey that will intersect with Kafka's. Dreams and reality merge in this haunting exploration of fate and identity.",
    "rating": 4.12,
    "ratingsCount": 393287,
    "pageCount": 505,
    "awards": [
      "World Fantasy Award Nominee (2006)"
    ],
    "categories": [
      "Literary Fiction",
      "Magical Realism",
      "Fantasy"
    ],
    "scores": {
      "literary": 10,
      "fantasy": 8,
      "character": 10,
      "atmosphere": 10,
      "philosophical": 9,
      "standalone": 10,
      "experimental": 9,
      "psychological": 9,
      "slow": 7,
      "immersive": 9
    }
  },
  {
    "id": 1015,
    "title": "1Q84",
    "author": "Haruki Murakami",
    "authorGender": "male",
    "publicationYear": 2009,
    "series": {
      "name": "1Q84",
      "position": 1
    },
    "isbn": "0307476464",
    "googleBooksId": "tj6TEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=tj6TEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Aomame climbs down an emergency stairway and enters a world where the sky holds two moons—1Q84. Meanwhile, ghostwriter Tengo rewrites a strange novel that becomes a sensation. Their parallel stories converge around a mysterious cult and a love that transcends time and reality.",
    "rating": 3.95,
    "ratingsCount": 340143,
    "pageCount": 944,
    "awards": [
      "Goodreads Choice Award Best Fiction (2011)"
    ],
    "categories": [
      "Literary Fiction",
      "Science Fiction",
      "Mystery"
    ],
    "scores": {
      "literary": 10,
      "mystery": 9,
      "romance": 8,
      "epic": 10,
      "atmosphere": 10,
      "plot": 9,
      "standalone": 10,
      "experimental": 9,
      "slow": 8,
      "dense": 9
    }
  },
  {
    "id": 1018,
    "title": "Hard-Boiled Wonderland and the End of the World",
    "author": "Haruki Murakami",
    "authorGender": "male",
    "publicationYear": 1985,
    "isbn": "0679743464",
    "googleBooksId": "4CRGU-KwXG8C",
    "image": "https://books.google.com/books/content?id=4CRGU-KwXG8C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "In alternate chapters: a data processor whose consciousness is being weaponized, and a newcomer to a walled Town where shadows are removed and unicorns live. The two narratives converge in Murakami's mind-bending meditation on consciousness, memory, and the self.",
    "rating": 4.09,
    "ratingsCount": 75425,
    "pageCount": 400,
    "awards": [
      "Tanizaki Prize (1985)"
    ],
    "categories": [
      "Literary Fiction",
      "Science Fiction",
      "Fantasy"
    ],
    "scores": {
      "literary": 10,
      "scifi": 9,
      "philosophical": 10,
      "atmosphere": 10,
      "mind": 10,
      "standalone": 10,
      "experimental": 10,
      "cerebral": 10,
      "slow": 8,
      "character": 8,
      "plot": 5,
      "emotional": 6,
      "classic": 5,
      "modern": 7
    }
  },
  {
    "id": 1019,
    "title": "South of the Border, West of the Sun",
    "author": "Haruki Murakami",
    "authorGender": "male",
    "publicationYear": 1992,
    "isbn": "0679767398",
    "googleBooksId": "m96JDQAAQBAJ",
    "image": "https://books.google.com/books/content?id=m96JDQAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Hajime owns a successful jazz bar in Tokyo and has a loving wife and daughters. But he's haunted by two women: Shimamoto, his childhood soulmate who reappears mysteriously, and Izumi, whom he betrayed in his youth. A melancholy romance about desire and dissatisfaction.",
    "rating": 3.92,
    "ratingsCount": 78694,
    "pageCount": 192,
    "categories": [
      "Literary Fiction",
      "Romance"
    ],
    "scores": {
      "literary": 10,
      "romance": 9,
      "character": 10,
      "atmosphere": 10,
      "emotional": 9,
      "standalone": 10,
      "bittersweet": 10,
      "introspection": 9,
      "slow": 8,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 1021,
    "title": "Dance Dance Dance",
    "author": "Haruki Murakami",
    "authorGender": "male",
    "publicationYear": 1988,
    "isbn": "0679753796",
    "googleBooksId": "ue6LDQAAQBAJ",
    "image": "https://books.google.com/books/content?id=ue6LDQAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "The nameless narrator from A Wild Sheep Chase searches for a call girl who vanished from the Dolphin Hotel. His quest leads through Tokyo's consumer culture, celebrity connections, and a supernatural otherworld, as he tries to maintain his humanity in a spiritually bankrupt age.",
    "rating": 3.97,
    "ratingsCount": 51287,
    "pageCount": 393,
    "categories": [
      "Literary Fiction",
      "Mystery"
    ],
    "scores": {
      "literary": 10,
      "mystery": 8,
      "satirical": 8,
      "character": 9,
      "atmosphere": 10,
      "series": 9,
      "experimental": 9,
      "social": 8,
      "medium": 7,
      "plot": 5,
      "emotional": 6,
      "classic": 5,
      "modern": 7
    }
  },
  {
    "id": 1022,
    "title": "A Wild Sheep Chase",
    "author": "Haruki Murakami",
    "authorGender": "male",
    "publicationYear": 1982,
    "isbn": "037571894X",
    "googleBooksId": "lnOPDQAAQBAJ",
    "image": "https://books.google.com/books/content?id=lnOPDQAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "An advertising copywriter is forced by a sinister right-wing organization to find a sheep with a star on its back—a sheep that may not exist or may be supernatural. His search takes him from Tokyo to a remote Hokkaido town and into questions of identity and meaning.",
    "rating": 3.91,
    "ratingsCount": 79654,
    "pageCount": 320,
    "categories": [
      "Literary Fiction",
      "Mystery",
      "Fantasy"
    ],
    "scores": {
      "literary": 10,
      "mystery": 9,
      "adventure": 8,
      "atmosphere": 10,
      "character": 9,
      "series": 9,
      "experimental": 9,
      "philosophical": 8,
      "medium": 7,
      "plot": 5,
      "emotional": 6,
      "classic": 5,
      "modern": 7
    }
  },
  {
    "id": 1023,
    "title": "The Magus",
    "author": "John Fowles",
    "authorGender": "male",
    "publicationYear": 1965,
    "isbn": "0316296198",
    "googleBooksId": "W6G5bwAACAAJ",
    "image": "https://books.google.com/books/content?id=W6G5bwAACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Nicholas Urfe takes a teaching job on a Greek island to escape his life and is drawn into the 'godgame' of wealthy Maurice Conchis, who stages elaborate psychological scenarios involving twins, Nazis, and ancient myths. Nothing is real; everything is a test.",
    "rating": 3.91,
    "ratingsCount": 48527,
    "pageCount": 656,
    "categories": [
      "Literary Fiction",
      "Psychological",
      "Mystery"
    ],
    "scores": {
      "literary": 10,
      "psychological": 10,
      "mystery": 9,
      "atmosphere": 10,
      "mind": 10,
      "plot": 9,
      "standalone": 10,
      "experimental": 9,
      "cerebral": 9,
      "slow": 7
    }
  },
  {
    "id": 1025,
    "title": "The Collector",
    "author": "John Fowles",
    "authorGender": "male",
    "publicationYear": 1963,
    "isbn": "0316290238",
    "googleBooksId": "UETmEs-5vLkC",
    "image": "https://books.google.com/books/content?id=UETmEs-5vLkC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Lonely clerk Frederick Clegg wins the lottery and kidnaps art student Miranda Grey, keeping her in his cellar, certain she'll come to love him. Alternating between their perspectives, this psychological horror explores obsession, class, and the death of beauty.",
    "rating": 3.99,
    "ratingsCount": 92745,
    "pageCount": 305,
    "categories": [
      "Literary Fiction",
      "Thriller",
      "Psychological"
    ],
    "scores": {
      "literary": 10,
      "psychological": 10,
      "horror": 9,
      "dark": 10,
      "character": 10,
      "thriller": 9,
      "standalone": 10,
      "intimate": 9,
      "disturbing": 10,
      "fast": 7,
      "medium": 5,
      "plot": 5,
      "classic": 8,
      "modern": 3
    }
  },
  {
    "id": 1028,
    "title": "The Eye of the World",
    "author": "Robert Jordan",
    "authorGender": "male",
    "publicationYear": 1990,
    "isbn": "0812511816",
    "googleBooksId": "1PgKPuFIz1kC",
    "image": "https://books.google.com/books/content?id=1PgKPuFIz1kC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Rand al'Thor and his friends flee their village when monsters attack on Winternight. Guided by an Aes Sedai and her Warder, they're hunted across a world where the Dark One stirs in his prison. The epic Wheel of Time begins.",
    "rating": 4.19,
    "ratingsCount": 682547,
    "pageCount": 753,
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "adventure": 10,
      "worldbuilding": 10,
      "plot": 10,
      "series": 10,
      "accessible": 9,
      "immersive": 10,
      "medium": 7,
      "character": 5,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 1029,
    "title": "The Great Hunt",
    "author": "Robert Jordan",
    "authorGender": "male",
    "publicationYear": 1990,
    "isbn": "0812517725",
    "googleBooksId": "tuspQELrwhIC",
    "image": "https://books.google.com/books/content?id=tuspQELrwhIC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Rand accepts he may be the Dragon Reborn as the Horn of Valere is stolen. The hunt leads to the Seanchan invasion and Rand's confrontation with the Dark One's champion. The world of the Wheel of Time expands dramatically.",
    "rating": 4.23,
    "ratingsCount": 364287,
    "pageCount": 681,
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "adventure": 10,
      "plot": 10,
      "series": 10,
      "worldbuilding": 9,
      "accessible": 9,
      "immersive": 9,
      "medium": 7,
      "character": 5,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 1030,
    "title": "The Dragon Reborn",
    "author": "Robert Jordan",
    "authorGender": "male",
    "publicationYear": 1991,
    "isbn": "0812513711",
    "googleBooksId": "4nWghD8QV0IC",
    "image": "https://books.google.com/books/content?id=4nWghD8QV0IC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Rand flees his destiny while Mat, Perrin, and Egwene pursue or search for him. The Dragon's actions destabilize nations, and Rand must claim Callandor from the Stone of Tear to prove himself. Prophecies begin to fulfill themselves.",
    "rating": 4.22,
    "ratingsCount": 288475,
    "pageCount": 673,
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "adventure": 10,
      "plot": 10,
      "series": 10,
      "worldbuilding": 9,
      "character": 9,
      "immersive": 9,
      "medium": 7,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 1031,
    "title": "The Shadow Rising",
    "author": "Robert Jordan",
    "authorGender": "male",
    "publicationYear": 1992,
    "isbn": "0812513738",
    "googleBooksId": "7-JfDlNcvhEC",
    "image": "https://books.google.com/books/content?id=7-JfDlNcvhEC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Rand enters the Aiel Waste to prove himself to the warrior people while the Forsaken move openly. Perrin returns to the Two Rivers under attack, and Matt gains memories not his own. The Wheel turns, and shadows lengthen.",
    "rating": 4.28,
    "ratingsCount": 242384,
    "pageCount": 1007,
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "plot": 10,
      "character": 10,
      "worldbuilding": 10,
      "series": 10,
      "multipov": 9,
      "medium": 7,
      "immersive": 9,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 1032,
    "title": "The Fires of Heaven",
    "author": "Robert Jordan",
    "authorGender": "male",
    "publicationYear": 1993,
    "isbn": "0812550307",
    "googleBooksId": "177iwQEACAAJ",
    "image": "https://books.google.com/books/content?id=177iwQEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Rand leads the Aiel to reclaim Cairhien while one of the Forsaken pursues him. Nynaeve and Elayne hunt the Black Ajah in a traveling circus. Mat becomes a general despite himself. Tragedy strikes at the end.",
    "rating": 4.21,
    "ratingsCount": 212547,
    "pageCount": 912,
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "plot": 10,
      "series": 10,
      "worldbuilding": 9,
      "adventure": 9,
      "immersive": 9,
      "medium": 7,
      "character": 5,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 1033,
    "title": "Lord of Chaos",
    "author": "Robert Jordan",
    "authorGender": "male",
    "publicationYear": 1994,
    "isbn": "0812513754",
    "googleBooksId": "owkKhVCq6f0C",
    "image": "https://books.google.com/books/content?id=owkKhVCq6f0C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Rand rules multiple nations while mad male channelers flock to him and Aes Sedai scheme. When the Tower embassy springs its trap, Rand's faithful must mount a desperate rescue. The war between Light and Shadow escalates.",
    "rating": 4.17,
    "ratingsCount": 188547,
    "pageCount": 987,
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "political": 9,
      "plot": 10,
      "series": 10,
      "worldbuilding": 9,
      "multipov": 9,
      "medium": 7,
      "character": 5,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 1034,
    "title": "A Crown of Swords",
    "author": "Robert Jordan",
    "authorGender": "male",
    "publicationYear": 1996,
    "isbn": "0812550285",
    "googleBooksId": "d0lWqpVm9YkC",
    "image": "https://books.google.com/books/content?id=d0lWqpVm9YkC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Rand hunts for the renegade Aes Sedai who kidnapped him while dealing with a cursed dagger's victim and mad gods' minions. Mat must rescue the Daughter of the Nine Moons. Egwene consolidates power over the rebel Aes Sedai.",
    "rating": 4.13,
    "ratingsCount": 163284,
    "pageCount": 856,
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "political": 9,
      "plot": 9,
      "series": 10,
      "worldbuilding": 9,
      "character": 8,
      "medium": 7,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 1035,
    "title": "The Path of Daggers",
    "author": "Robert Jordan",
    "authorGender": "male",
    "publicationYear": 1998,
    "isbn": "0812550293",
    "googleBooksId": "WP4la4JFZXsC",
    "image": "https://books.google.com/books/content?id=WP4la4JFZXsC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Rand uses a powerful ter'angreal to drive the Seanchan from Illian while struggling with the madness of saidin. The rebel Aes Sedai march on Tar Valon. Perrin leads a desperate mission to save his wife from the Shaido.",
    "rating": 4,
    "ratingsCount": 145897,
    "pageCount": 591,
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "plot": 8,
      "series": 10,
      "worldbuilding": 9,
      "slow": 8,
      "multipov": 9,
      "character": 5,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 1036,
    "title": "Winter's Heart",
    "author": "Robert Jordan",
    "authorGender": "male",
    "publicationYear": 2000,
    "isbn": "0812575717",
    "googleBooksId": "u9vGo30fXuEC",
    "image": "https://books.google.com/books/content?id=u9vGo30fXuEC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Rand undertakes the most dangerous task yet: cleansing saidin of the Dark One's taint. With Nynaeve, he must survive an assault by every Forsaken while channeling power that could destroy the world. Everything changes.",
    "rating": 4.06,
    "ratingsCount": 132547,
    "pageCount": 655,
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "plot": 10,
      "series": 10,
      "action": 9,
      "cathartic": 9,
      "immersive": 9,
      "medium": 7,
      "character": 5,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 1038,
    "title": "The Illustrated Man",
    "author": "Ray Bradbury",
    "authorGender": "male",
    "publicationYear": 1951,
    "isbn": "1451678185",
    "googleBooksId": "-QC3TyfN3zoC",
    "image": "https://books.google.com/books/content?id=-QC3TyfN3zoC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "A drifter's tattoos tell stories: children create deadly virtual worlds, African veldt devours parents, astronauts await death on Venus. Eighteen tales framed by the illustrated man whose skin prophecies doom. Bradbury's visionary short fiction at its finest.",
    "rating": 4.13,
    "ratingsCount": 105731,
    "pageCount": 186,
    "categories": [
      "Science Fiction",
      "Short Stories",
      "Classic"
    ],
    "scores": {
      "scifi": 10,
      "dark": 9,
      "atmosphere": 10,
      "literary": 9,
      "standalone": 10,
      "lyrical": 9,
      "psychological": 8,
      "accessible": 8,
      "medium": 7,
      "slow": 5,
      "character": 8,
      "plot": 5,
      "classic": 8,
      "modern": 3
    }
  },
  {
    "id": 1045,
    "title": "Duma Key",
    "author": "Stephen King",
    "authorGender": "male",
    "publicationYear": 2008,
    "isbn": "1501141236",
    "googleBooksId": "NMGTgD9j3scC",
    "image": "https://books.google.com/books/content?id=NMGTgD9j3scC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "After a construction accident costs Edgar Freemantle his arm and nearly his mind, he retreats to Duma Key, Florida, where he begins painting—compulsively, brilliantly. His art connects to something ancient and hungry on the island. Creativity as possession and redemption.",
    "rating": 3.94,
    "ratingsCount": 115478,
    "pageCount": 611,
    "categories": [
      "Horror",
      "Thriller",
      "Supernatural"
    ],
    "scores": {
      "horror": 10,
      "character": 10,
      "atmosphere": 10,
      "plot": 9,
      "psychological": 8,
      "standalone": 10,
      "fantasy": 8,
      "emotional": 8,
      "slow": 7,
      "modern": 8
    }
  },
  {
    "id": 1049,
    "title": "The Girl Next Door",
    "author": "Jack Ketchum",
    "authorGender": "male",
    "publicationYear": 1989,
    "isbn": "0843961163",
    "googleBooksId": "Go8aAQAAMAAJ",
    "image": "https://books.google.com/books/content?id=Go8aAQAAMAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Based on a true crime, a teenage girl is tortured to death by her aunt and neighborhood children in 1950s suburban Indiana. One boy watches, paralyzed between morality and belonging. The most disturbing horror novel many have ever read. Not for the faint of heart.",
    "rating": 3.88,
    "ratingsCount": 32658,
    "pageCount": 336,
    "categories": [
      "Horror",
      "Crime",
      "Psychological"
    ],
    "scores": {
      "horror": 10,
      "dark": 10,
      "psychological": 10,
      "emotional": 10,
      "standalone": 10,
      "disturbing": 10,
      "social": 9,
      "moral": 9,
      "literary": 8,
      "fast": 7,
      "medium": 5,
      "character": 8,
      "plot": 5,
      "classic": 5,
      "modern": 7
    }
  },
  {
    "id": 1050,
    "title": "A Walk to Remember",
    "author": "Nicholas Sparks",
    "authorGender": "male",
    "publicationYear": 1999,
    "isbn": "0446693804",
    "googleBooksId": "ypidPwAACAAJ",
    "image": "https://books.google.com/books/content?id=ypidPwAACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "In 1958 North Carolina, popular Landon Carter is forced to spend time with minister's daughter Jamie Sullivan, who wears the same sweater daily and carries a Bible everywhere. Their unlikely romance changes both of them in ways neither expected.",
    "rating": 4.15,
    "ratingsCount": 624785,
    "pageCount": 215,
    "categories": [
      "Romance",
      "Young Adult"
    ],
    "scores": {
      "romance": 10,
      "emotional": 10,
      "heart": 9,
      "standalone": 10,
      "accessible": 10,
      "comingofage": 8,
      "bittersweet": 9,
      "tragic": 9,
      "medium": 7,
      "character": 7,
      "plot": 6,
      "modern": 8
    }
  },
  {
    "id": 1051,
    "title": "Message in a Bottle",
    "author": "Nicholas Sparks",
    "authorGender": "male",
    "publicationYear": 1998,
    "isbn": "0446606812",
    "googleBooksId": "hBWgTzCtjAwC",
    "image": "https://books.google.com/books/content?id=hBWgTzCtjAwC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Journalist Theresa Osborne finds a bottle on Cape Cod containing a love letter. Tracing it to widower Garrett Blake, she must decide whether to reveal her discovery as she falls for a man still grieving his wife. A story of second chances and letting go.",
    "rating": 3.99,
    "ratingsCount": 346287,
    "pageCount": 322,
    "categories": [
      "Romance"
    ],
    "scores": {
      "romance": 10,
      "emotional": 10,
      "character": 9,
      "atmosphere": 8,
      "standalone": 10,
      "accessible": 9,
      "bittersweet": 9,
      "medium": 7,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 1052,
    "title": "The Rescue",
    "author": "Nicholas Sparks",
    "authorGender": "male",
    "publicationYear": 2000,
    "isbn": "0446696129",
    "googleBooksId": "CH6fPwAACAAJ",
    "image": "https://books.google.com/books/content?id=CH6fPwAACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Volunteer firefighter Taylor McAden saves single mother Denise Holton's autistic son during a storm. Though Taylor fears commitment and Denise fears trusting again, they're drawn together—until Taylor's issues threaten to destroy what they've built.",
    "rating": 3.98,
    "ratingsCount": 246287,
    "pageCount": 352,
    "categories": [
      "Romance"
    ],
    "scores": {
      "romance": 10,
      "emotional": 10,
      "character": 9,
      "heart": 9,
      "standalone": 10,
      "accessible": 9,
      "hopeful": 8,
      "medium": 7,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 1053,
    "title": "Nights in Rodanthe",
    "author": "Nicholas Sparks",
    "authorGender": "male",
    "publicationYear": 2002,
    "isbn": "0446531332",
    "googleBooksId": "LWevXkVOTBgC",
    "image": "https://books.google.com/books/content?id=LWevXkVOTBgC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Adrienne Willis, separated and confused, agrees to watch a friend's inn on North Carolina's Outer Banks. Her only guest is Paul Flanner, a surgeon facing his own crisis. A hurricane traps them together, and one weekend changes everything.",
    "rating": 3.92,
    "ratingsCount": 236185,
    "pageCount": 212,
    "categories": [
      "Romance"
    ],
    "scores": {
      "romance": 10,
      "emotional": 10,
      "atmosphere": 9,
      "standalone": 10,
      "accessible": 9,
      "bittersweet": 10,
      "tragic": 8,
      "medium": 7,
      "character": 7,
      "plot": 6,
      "modern": 8
    }
  },
  {
    "id": 1054,
    "title": "Dear John",
    "author": "Nicholas Sparks",
    "authorGender": "male",
    "publicationYear": 2006,
    "isbn": "0446618314",
    "googleBooksId": "vJ4L75X8OUwC",
    "image": "https://books.google.com/books/content?id=vJ4L75X8OUwC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Army sergeant John Tyree and college student Savannah Curtis fall in love during his leave. They promise to wait—but 9/11 changes everything. Years of letters can't bridge the distance, and both must make heartbreaking choices about love and duty.",
    "rating": 4.02,
    "ratingsCount": 525847,
    "pageCount": 276,
    "categories": [
      "Romance",
      "Military"
    ],
    "scores": {
      "romance": 10,
      "emotional": 10,
      "character": 9,
      "standalone": 10,
      "accessible": 9,
      "bittersweet": 10,
      "historical": 6,
      "medium": 7,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 1055,
    "title": "The Lucky One",
    "author": "Nicholas Sparks",
    "authorGender": "male",
    "publicationYear": 2008,
    "isbn": "0446698180",
    "googleBooksId": "MUvbLFS8Av8C",
    "image": "https://books.google.com/books/content?id=MUvbLFS8Av8C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Marine Logan Thibault survives three Iraq tours thanks to a photograph of a woman he finds. Tracking her to North Carolina, he falls for Beth Clayton—but her ex-husband, a manipulative sheriff's deputy, refuses to let her go.",
    "rating": 4.03,
    "ratingsCount": 348278,
    "pageCount": 306,
    "categories": [
      "Romance",
      "Military"
    ],
    "scores": {
      "romance": 10,
      "thriller": 6,
      "emotional": 9,
      "character": 9,
      "standalone": 10,
      "accessible": 9,
      "heart": 8,
      "medium": 7,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 1056,
    "title": "Safe Haven",
    "author": "Nicholas Sparks",
    "authorGender": "male",
    "publicationYear": 2010,
    "isbn": "0446547573",
    "googleBooksId": "En_Zu3fHGf4C",
    "image": "https://books.google.com/books/content?id=En_Zu3fHGf4C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Katie mysteriously appears in Southport, North Carolina, determined to remain anonymous. She befriends her neighbor and falls for widower Alex—but a dark secret from her past is hunting her. Romantic suspense about escaping abuse and finding refuge.",
    "rating": 4.01,
    "ratingsCount": 346284,
    "pageCount": 344,
    "categories": [
      "Romance",
      "Thriller"
    ],
    "scores": {
      "romance": 9,
      "thriller": 8,
      "emotional": 10,
      "standalone": 10,
      "dark": 7,
      "accessible": 9,
      "plot": 9,
      "fast": 7,
      "medium": 5,
      "character": 5,
      "modern": 8
    }
  },
  {
    "id": 1057,
    "title": "The Best of Me",
    "author": "Nicholas Sparks",
    "authorGender": "male",
    "publicationYear": 2011,
    "isbn": "0446547581",
    "googleBooksId": "ISsOIrR44MkC",
    "image": "https://books.google.com/books/content?id=ISsOIrR44MkC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "First loves Amanda and Dawson reunite in their small Louisiana hometown after twenty-five years when a mentor's funeral brings them together. The passion remains—but so do the class differences and family feuds that separated them.",
    "rating": 3.97,
    "ratingsCount": 205487,
    "pageCount": 291,
    "categories": [
      "Romance"
    ],
    "scores": {
      "romance": 10,
      "emotional": 10,
      "character": 9,
      "standalone": 10,
      "accessible": 9,
      "bittersweet": 10,
      "tragic": 8,
      "medium": 7,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 1058,
    "title": "The Longest Ride",
    "author": "Nicholas Sparks",
    "authorGender": "male",
    "publicationYear": 2013,
    "isbn": "1455520659",
    "googleBooksId": "4PpLngEACAAJ",
    "image": "https://books.google.com/books/content?id=4PpLngEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Two love stories interweave: college senior Sophia falls for bull rider Luke, while elderly Ira, trapped in a wreck, recalls his life with wife Ruth. Past and present connect through art, sacrifice, and what we do for love.",
    "rating": 4.07,
    "ratingsCount": 218754,
    "pageCount": 405,
    "categories": [
      "Romance"
    ],
    "scores": {
      "romance": 10,
      "emotional": 10,
      "character": 10,
      "standalone": 10,
      "bittersweet": 9,
      "nonlinear": 9,
      "accessible": 9,
      "medium": 7,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 1059,
    "title": "Interpreter of Maladies",
    "author": "Jhumpa Lahiri",
    "authorGender": "female",
    "publicationYear": 1999,
    "isbn": "039592720X",
    "googleBooksId": "w4bZtp8Azw8C",
    "image": "https://books.google.com/books/content?id=w4bZtp8Azw8C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Nine stories of Indians and Indian Americans navigating culture, marriage, and displacement: a tour guide who interprets maladies for a doctor, newlyweds who share nothing, a woman who sweeps another family's house for healing. Pulitzer Prize-winning debut collection.",
    "rating": 3.94,
    "ratingsCount": 242547,
    "pageCount": 198,
    "awards": [
      "Pulitzer Prize for Fiction (2000)",
      "PEN/Hemingway Award (2000)"
    ],
    "categories": [
      "Literary Fiction",
      "Short Stories"
    ],
    "scores": {
      "literary": 10,
      "emotional": 10,
      "character": 10,
      "standalone": 10,
      "intimate": 9,
      "identity": 9,
      "family": 8,
      "medium": 7,
      "slow": 5,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 1060,
    "title": "The Namesake",
    "author": "Jhumpa Lahiri",
    "authorGender": "female",
    "publicationYear": 2003,
    "isbn": "0618485228",
    "googleBooksId": "Nx-vY7ac1OcC",
    "image": "https://books.google.com/books/content?id=Nx-vY7ac1OcC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Gogol Ganguli's name, given for a Russian writer who saved his father's life, haunts him through adolescence and young adulthood. His journey from embarrassment to acceptance mirrors his Bengali-American family's negotiation of two cultures.",
    "rating": 4,
    "ratingsCount": 206847,
    "pageCount": 291,
    "categories": [
      "Literary Fiction",
      "Family Saga"
    ],
    "scores": {
      "literary": 10,
      "emotional": 10,
      "character": 10,
      "comingofage": 10,
      "standalone": 10,
      "identity": 9,
      "family": 9,
      "intimate": 8,
      "medium": 7,
      "slow": 5,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 1061,
    "title": "Unaccustomed Earth",
    "author": "Jhumpa Lahiri",
    "authorGender": "female",
    "publicationYear": 2008,
    "isbn": "0307278255",
    "googleBooksId": "2DqTEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=2DqTEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Eight stories following Bengali Americans across generations: a widow building a new life, siblings caring for their father, teenagers navigating their parents' expectations. Lahiri captures the quiet devastations and small triumphs of immigrant family life.",
    "rating": 4.03,
    "ratingsCount": 45287,
    "pageCount": 333,
    "categories": [
      "Literary Fiction",
      "Short Stories"
    ],
    "scores": {
      "literary": 10,
      "emotional": 10,
      "character": 10,
      "standalone": 10,
      "family": 9,
      "identity": 9,
      "intimate": 8,
      "medium": 7,
      "slow": 5,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 1062,
    "title": "The Lowland",
    "author": "Jhumpa Lahiri",
    "authorGender": "female",
    "publicationYear": 2013,
    "isbn": "030726574X",
    "googleBooksId": "ZfJdAAAAQBAJ",
    "image": "https://books.google.com/books/content?id=ZfJdAAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "In 1960s Calcutta, brothers Subhash and Udayan take different paths: one emigrates to America, the other joins a Naxalite uprising that leads to his death. Subhash marries his brother's pregnant widow, beginning decades of guilt, secrets, and muted grief.",
    "rating": 3.86,
    "ratingsCount": 82375,
    "pageCount": 340,
    "awards": [
      "Man Booker Prize Shortlist (2013)",
      "National Book Award Finalist (2013)"
    ],
    "categories": [
      "Literary Fiction",
      "Historical Fiction"
    ],
    "scores": {
      "literary": 10,
      "historical": 9,
      "emotional": 10,
      "character": 10,
      "epic": 8,
      "standalone": 10,
      "family": 9,
      "slow": 7,
      "bittersweet": 8,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 1065,
    "title": "Tears of the Giraffe",
    "author": "Alexander McCall Smith",
    "authorGender": "male",
    "publicationYear": 2000,
    "isbn": "1400031354",
    "googleBooksId": "hVuNDQAAQBAJ",
    "image": "https://books.google.com/books/content?id=hVuNDQAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Precious Ramotswe, Botswana's only female detective, searches for an American boy who disappeared in the bush years ago while navigating her engagement to mechanic J.L.B. Matekoni. Gentle mysteries in a world of tea, compassion, and traditional values.",
    "rating": 3.8,
    "ratingsCount": 49287,
    "pageCount": 240,
    "categories": [
      "Mystery",
      "Cozy Mystery"
    ],
    "scores": {
      "mystery": 8,
      "cozy": 10,
      "character": 10,
      "heart": 10,
      "atmosphere": 10,
      "series": 10,
      "accessible": 10,
      "hopeful": 9,
      "medium": 7,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 1067,
    "title": "The Kalahari Typing School for Men",
    "author": "Alexander McCall Smith",
    "authorGender": "male",
    "publicationYear": 2002,
    "isbn": "1400031389",
    "googleBooksId": "WmWRdEhb0b4C",
    "image": "https://books.google.com/books/content?id=WmWRdEhb0b4C&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "A rival detective agency opens in Gaborone—run by a man. While Mma Ramotswe handles a blackmailer and a paternity case, her assistant Mma Makutsi opens a typing school that attracts troubled students. The agency perseveres with grace and humor.",
    "rating": 3.83,
    "ratingsCount": 34287,
    "pageCount": 229,
    "categories": [
      "Mystery",
      "Cozy Mystery"
    ],
    "scores": {
      "mystery": 7,
      "cozy": 10,
      "character": 10,
      "heart": 10,
      "humor": 9,
      "series": 10,
      "accessible": 10,
      "medium": 7,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 1068,
    "title": "The Full Cupboard of Life",
    "author": "Alexander McCall Smith",
    "authorGender": "male",
    "publicationYear": 2003,
    "isbn": "1400031397",
    "googleBooksId": "yqs3TGN-PqMC",
    "image": "https://books.google.com/books/content?id=yqs3TGN-PqMC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Mma Ramotswe finally sets a wedding date while investigating a wealthy woman's suspicious suitors and a parachute club's missing funds. Her cupboard is full of life's blessings, even as she faces difficulties with characteristic optimism.",
    "rating": 3.84,
    "ratingsCount": 29475,
    "pageCount": 226,
    "categories": [
      "Mystery",
      "Cozy Mystery"
    ],
    "scores": {
      "mystery": 7,
      "cozy": 10,
      "character": 10,
      "heart": 10,
      "series": 10,
      "accessible": 10,
      "hopeful": 9,
      "medium": 7,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 1069,
    "title": "World Without End",
    "author": "Ken Follett",
    "authorGender": "male",
    "publicationYear": 2007,
    "isbn": "0451228375",
    "googleBooksId": "zbWNEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=zbWNEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Two centuries after Pillars of the Earth, Kingsbridge faces the Black Death. Builder Merthin, nun Caris, and their rivals love, scheme, and survive as plague transforms medieval England. An epic sequel about rebirth from catastrophe.",
    "rating": 4.28,
    "ratingsCount": 204287,
    "pageCount": 1014,
    "categories": [
      "Historical Fiction",
      "Epic"
    ],
    "scores": {
      "historical": 10,
      "epic": 10,
      "character": 10,
      "plot": 10,
      "atmosphere": 10,
      "romance": 8,
      "series": 9,
      "immersive": 10,
      "accessible": 9,
      "medium": 7,
      "slow": 5,
      "emotional": 7,
      "heart": 6,
      "modern": 8
    }
  },
  {
    "id": 1070,
    "title": "A Column of Fire",
    "author": "Ken Follett",
    "authorGender": "male",
    "publicationYear": 2017,
    "isbn": "052595497X",
    "googleBooksId": "XKEwDwAAQBAJ",
    "image": "https://books.google.com/books/content?id=XKEwDwAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "As Elizabeth I takes the English throne, Ned Willard serves her Protestant cause while loving a Catholic woman. From Paris to Seville, religious warfare threatens to consume Europe. The Kingsbridge series spans the tumultuous sixteenth century.",
    "rating": 4.19,
    "ratingsCount": 87654,
    "pageCount": 912,
    "categories": [
      "Historical Fiction",
      "Epic"
    ],
    "scores": {
      "historical": 10,
      "epic": 10,
      "political": 10,
      "plot": 10,
      "romance": 8,
      "series": 9,
      "immersive": 9,
      "accessible": 9,
      "medium": 7,
      "slow": 5,
      "character": 5,
      "emotional": 7,
      "heart": 6,
      "modern": 8
    }
  },
  {
    "id": 1071,
    "title": "The Evening and the Morning",
    "author": "Ken Follett",
    "authorGender": "male",
    "publicationYear": 2020,
    "isbn": "0525954988",
    "googleBooksId": "ZVX4DwAAQBAJ",
    "image": "https://books.google.com/books/content?id=ZVX4DwAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "A prequel set in 997 AD: builder Edgar, noblewoman Ragna, and monk Aldred's lives intertwine as Vikings raid, lords betray, and the cathedral that will become Kingsbridge begins. How civilization rises from the Dark Ages' ashes.",
    "rating": 4.33,
    "ratingsCount": 52487,
    "pageCount": 832,
    "categories": [
      "Historical Fiction",
      "Epic"
    ],
    "scores": {
      "historical": 10,
      "epic": 10,
      "character": 10,
      "plot": 10,
      "atmosphere": 10,
      "series": 9,
      "immersive": 10,
      "accessible": 9,
      "medium": 7,
      "slow": 5,
      "emotional": 6,
      "modern": 8
    }
  },
  {
    "id": 1072,
    "title": "Fall on Your Knees",
    "author": "Ann-Marie MacDonald",
    "authorGender": "female",
    "publicationYear": 1996,
    "isbn": "0684856263",
    "googleBooksId": "VYqOPRlgpUEC",
    "image": "https://books.google.com/books/content?id=VYqOPRlgpUEC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "In early twentieth-century Cape Breton, James Piper's obsessive love for his Lebanese wife Materia marks their daughters: brilliant Kathleen, devoted Frances, haunted Mercedes, mixed-race Lily. A multi-generational saga of secrets, incest, and redemption through love's corruption.",
    "rating": 4.04,
    "ratingsCount": 35287,
    "pageCount": 566,
    "awards": [
      "Commonwealth Writers' Prize (1997)"
    ],
    "categories": [
      "Literary Fiction",
      "Family Saga"
    ],
    "scores": {
      "literary": 10,
      "epic": 10,
      "dark": 10,
      "emotional": 10,
      "character": 10,
      "standalone": 10,
      "family": 10,
      "atmosphere": 9,
      "tragic": 9,
      "medium": 7,
      "slow": 5,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 1073,
    "title": "The Way the Crow Flies",
    "author": "Ann-Marie MacDonald",
    "authorGender": "female",
    "publicationYear": 2003,
    "isbn": "0060579064",
    "googleBooksId": "enLBTNKB3AsC",
    "image": "https://books.google.com/books/content?id=enLBTNKB3AsC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "In 1960s Ontario, the McCarthy family lives near an air force base. Eight-year-old Madeleine witnesses something terrible, and a murder conviction may be wrong. Cold War paranoia, childhood innocence, and terrible secrets interweave across decades.",
    "rating": 3.89,
    "ratingsCount": 23475,
    "pageCount": 722,
    "categories": [
      "Literary Fiction",
      "Mystery"
    ],
    "scores": {
      "literary": 10,
      "mystery": 9,
      "historical": 9,
      "emotional": 10,
      "character": 10,
      "dark": 9,
      "standalone": 10,
      "family": 9,
      "slow": 7,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 1075,
    "title": "The Stone Diaries",
    "author": "Carol Shields",
    "authorGender": "female",
    "publicationYear": 1993,
    "isbn": "0140233148",
    "googleBooksId": "Ro6c5FN7bPsC",
    "image": "https://books.google.com/books/content?id=Ro6c5FN7bPsC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Daisy Goodwill's life unfolds from her birth in 1905 Manitoba (which kills her mother) through marriage, widowhood, and old age in Florida. Photos, letters, and unreliable narration piece together an ordinary woman's extraordinary inner life. Pulitzer Prize winner.",
    "rating": 3.9,
    "ratingsCount": 38247,
    "pageCount": 368,
    "awards": [
      "Pulitzer Prize for Fiction (1995)",
      "Governor General's Award (1993)",
      "National Book Critics Circle Award (1995)"
    ],
    "categories": [
      "Literary Fiction"
    ],
    "scores": {
      "literary": 10,
      "character": 10,
      "emotional": 10,
      "experimental": 8,
      "standalone": 10,
      "family": 9,
      "introspection": 8,
      "medium": 7,
      "slow": 5,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 1079,
    "title": "The Cellist of Sarajevo",
    "author": "Steven Galloway",
    "authorGender": "male",
    "publicationYear": 2008,
    "isbn": "1594483655",
    "googleBooksId": "7ESQEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=7ESQEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "During the siege of Sarajevo, a cellist plays Albinoni's Adagio for 22 days to honor 22 bread-line victims. Three citizens—a sniper protector, a father crossing deadly territory, a woman walking to a water source—navigate survival and morality in a city under fire.",
    "rating": 3.84,
    "ratingsCount": 57284,
    "pageCount": 235,
    "categories": [
      "Historical Fiction",
      "War"
    ],
    "scores": {
      "literary": 10,
      "historical": 10,
      "emotional": 10,
      "atmosphere": 10,
      "character": 10,
      "standalone": 10,
      "multipov": 9,
      "dark": 8,
      "moral": 9,
      "medium": 7,
      "slow": 5,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 1080,
    "title": "Barney's Version",
    "author": "Mordecai Richler",
    "authorGender": "male",
    "publicationYear": 1997,
    "isbn": "0307277550",
    "googleBooksId": "osEys8wlYRkC",
    "image": "https://books.google.com/books/content?id=osEys8wlYRkC&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Barney Panofsky, irascible Canadian TV producer, writes his memoirs to refute a book accusing him of murder. Three marriages, Montreal Jewish life, and his great love Miriam unfold as Alzheimer's clouds his narrative. Funny, profane, and ultimately heartbreaking.",
    "rating": 3.96,
    "ratingsCount": 17487,
    "pageCount": 417,
    "awards": [
      "Giller Prize (1997)"
    ],
    "categories": [
      "Literary Fiction",
      "Comedy"
    ],
    "scores": {
      "literary": 10,
      "humor": 10,
      "character": 10,
      "emotional": 10,
      "unreliable": 10,
      "standalone": 10,
      "ironic": 8,
      "bittersweet": 9,
      "medium": 7,
      "slow": 5,
      "plot": 5,
      "modern": 8
    }
  },
  {
    "id": 1082,
    "title": "Girl, Woman, Other",
    "author": "Bernardine Evaristo",
    "authorGender": "unknown",
    "publicationYear": 2019,
    "isbn": "0241984998",
    "googleBooksId": "75dKyAEACAAJ",
    "image": "https://books.google.com/books/content?id=75dKyAEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "THE SUNDAY TIMES 1# BESTSELLER & BOOKER PRIZE WINNER  This is Britain as you've never read it.  This is Britain as it has never been told.   From Newcastle to Cornwall, from the birth of the twentieth century to the teens of the twenty-first, Girl, Woman, Other follows a cast of twelve characters on their personal journeys through this country and the last hundred years.  They're each looking for something - a shared past, an unexpected future, a place to call home, somewhere to fit in, a lover, a missed mother, a lost father, even just a touch of hope .  .  .   'The most absorbing book I read all year' Roxane Gay  '[Bernardine Evaristo] is one of the very best that we have' Nikesh Shukla  'Beautifully interwoven stories of identity, race, womanhood, and the realities of modern Britain.  The characters are so vivid, the writing is beautiful and it brims with humanity' Nicola Sturgeon  'A choral love song to black womanhood in modern Great Britain' Elle  'Bernardine Evaristo can take any story from any time and turn it into something vibrating with life' Ali Smith  'Exceptional.",
    "rating": 3.94,
    "ratingsCount": 118547,
    "pageCount": 452,
    "awards": [
      "Booker Prize (2019)"
    ],
    "categories": [
      "Literary Fiction",
      "Contemporary"
    ],
    "scores": {
      "literary": 9,
      "character": 8,
      "contemporary": 8,
      "plot": 7,
      "standalone": 9,
      "modern": 9,
      "accessible": 7,
      "medium": 7,
      "emotional": 7
    }
  },
  {
    "id": 1083,
    "title": "The Testaments",
    "author": "Margaret Atwood",
    "authorGender": "unknown",
    "publicationYear": 2019,
    "series": {
      "name": "The Handmaid's Tale",
      "position": 2
    },
    "isbn": "0385543786",
    "googleBooksId": "ekGNEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=ekGNEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "NEW YORK TIMES BEST SELLER • WINNER OF THE BOOKER PRIZE • The Testaments is a modern masterpiece, a powerful novel that can be read on its own or as a companion to Margaret Atwood’s classic, The Handmaid’s Tale.   More than fifteen years after the events of The Handmaid's Tale, the theocratic regime of the Republic of Gilead maintains its grip on power, but there are signs it is beginning to rot from within.  At this crucial moment, the lives of three radically different women converge, with potentially explosive results.   Two have grown up as part of the first generation to come of age in the new order.  The testimonies of these two young women are joined by a third: Aunt Lydia.   Her complex past and uncertain future unfold in surprising and pivotal ways.    With The Testaments, Margaret Atwood opens up the innermost workings of Gilead, as each woman is forced to come to terms with who she is, and how far she will go for what she believes.",
    "rating": 4.2,
    "ratingsCount": 425910,
    "pageCount": 422,
    "awards": [
      "Booker Prize (2019)",
      "Locus Award Best SF Novel (2020)",
      "Audie Award Audiobook of the Year (2020)",
      "Prometheus Award Best Novel (2020)",
      "Goodreads Choice Award Fiction (2019)",
      "Barnes & Noble Book of the Year Award (2019)"
    ],
    "categories": [
      "Literary Fiction",
      "Dystopian"
    ],
    "scores": {
      "literary": 9,
      "character": 8,
      "dark": 8,
      "atmosphere": 8,
      "plot": 7,
      "standalone": 9,
      "modern": 9,
      "accessible": 7,
      "medium": 7
    }
  },
  {
    "id": 1084,
    "title": "Prophet Song",
    "author": "Paul Lynch",
    "authorGender": "unknown",
    "publicationYear": 2023,
    "isbn": "0861546865",
    "googleBooksId": "n8WszwEACAAJ",
    "image": "https://books.google.com/books/content?id=n8WszwEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "\"On a dark, wet evening in Dublin, scientist and mother-of-four Eilish Stack answers her front door to find the GNSB on her doorstep.  Two officers from Ireland's newly formed secret police want to speak with her husband, Larry, a trade unionist for the Teachers' Union of Ireland.  Things are falling apart.  Ireland is in the grip of a government that is taking a turn towards tyranny.  And as the blood-dimmed tide is loosed, Eilish finds herself caught within the nightmare logic of a collapsing society assailed by unpredictable forces beyond her control and forced to do whatever it takes to keep her family together.  Exhilarating, terrifying, propulsive and confrontational, 'Prophet song' is a work of breathtaking originality and devastating insight, a novel that can be read as a parable of the present, the future and the past.",
    "rating": 3.91,
    "ratingsCount": 42875,
    "pageCount": 320,
    "awards": [
      "Booker Prize (2023)"
    ],
    "categories": [
      "Literary Fiction",
      "Dystopian"
    ],
    "scores": {
      "literary": 9,
      "character": 8,
      "dark": 8,
      "atmosphere": 8,
      "plot": 7,
      "standalone": 9,
      "modern": 9,
      "accessible": 7,
      "medium": 7
    }
  },
  {
    "id": 1086,
    "title": "The Nickel Boys",
    "author": "Colson Whitehead",
    "authorGender": "unknown",
    "publicationYear": 2019,
    "isbn": "0385537077",
    "googleBooksId": "JkGNEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=JkGNEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "NATIONAL BESTSELLER • In this Pulitzer Prize-winning follow-up to The Underground Railroad, Colson Whitehead brilliantly dramatizes another strand of American history through the story of two boys unjustly sentenced to a hellish reform school in Jim Crow-era Florida. When Elwood Curtis, a black boy growing up in 1960s Tallahassee, is unfairly sentenced to a juvenile reformatory called the Nickel Academy, he finds himself trapped in a grotesque chamber of horrors. Elwood’s only salvation is his friendship with fellow “delinquent” Turner, which deepens despite Turner’s conviction that Elwood is hopelessly naive, that the world is crooked, and that the only way to survive is to scheme and avoid trouble. As life at the Academy becomes ever more perilous, the tension between Elwood’s ideals and Turner’s skepticism leads to a decision whose repercussions will echo down the decades. Based on the real story of a reform school that operated for 111 years and warped the lives of thousands of children, The Nickel Boys is a devastating, driven narrative that showcases a great American novelist writing at the height of his powers and “should further cement Whitehead as one of his generation's best\" (Entertainment Weekly). Look for Colson Whitehead’s bestselling new novel, Harlem...",
    "rating": 4.18,
    "ratingsCount": 183475,
    "pageCount": 224,
    "awards": [
      "Pulitzer Prize for Fiction (2020)"
    ],
    "categories": [
      "Literary Fiction",
      "Historical Fiction"
    ],
    "scores": {
      "literary": 9,
      "character": 8,
      "historical": 8,
      "atmosphere": 7,
      "plot": 7,
      "standalone": 9,
      "modern": 9,
      "accessible": 7,
      "medium": 7,
      "emotional": 7
    }
  },
  {
    "id": 1087,
    "title": "Network Effect",
    "author": "Martha Wells",
    "authorGender": "unknown",
    "publicationYear": 2020,
    "series": {
      "name": "The Murderbot Diaries",
      "position": 5
    },
    "isbn": "1250229863",
    "googleBooksId": "Vwf60AEACAAJ",
    "image": "https://books.google.com/books/content?id=Vwf60AEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "WINNER of the Hugo, Nebula and Locus Awards!   The first full-length novel in Martha Wells' New York Times and USA Today bestselling Murderbot Diaries series.    Named a Best of the Year by NPR | Book Riot | Polygon   “I caught myself rereading my favorite parts...  and I can’t recommend it enough. ” —The New York Times  You know that feeling when you’re at work, and you’ve had enough of people, and then the boss walks in with yet another job that needs to be done right this second or the world will end, but all you want to do is go home and binge your favorite shows?  And you're a sentient murder machine programmed for destruction?  Congratulations, you're Murderbot.   Come for the pew-pew space battles, stay for the most relatable A. I.  you’ll read this century.",
    "rating": 4.33,
    "ratingsCount": 67254,
    "pageCount": 352,
    "awards": [
      "Hugo Award for Best Novel (2021)",
      "Nebula Award for Best Novel (2020)"
    ],
    "categories": [
      "Science Fiction"
    ],
    "scores": {
      "scifi": 9,
      "plot": 8,
      "character": 7,
      "standalone": 9,
      "modern": 9,
      "accessible": 7,
      "medium": 7,
      "emotional": 7
    }
  },
  {
    "id": 1088,
    "title": "A Desolation Called Peace",
    "author": "Arkady Martine",
    "authorGender": "unknown",
    "publicationYear": 2021,
    "series": {
      "name": "Teixcalaan",
      "position": 2
    },
    "isbn": "1250186463",
    "googleBooksId": "Zhh6xAEACAAJ",
    "image": "https://books.google.com/books/content?id=Zhh6xAEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "WINNER OF THE 2022 HUGO AWARD FOR BEST NOVEL  \"[An] all around brilliant space opera, I absolutely love it. \"—Ann Leckie, on A Memory Called Empire  A Desolation Called Peace is the spectacular space opera sequel to Arkady Martine's genre-reinventing, Hugo Award-winning debut, A Memory Called Empire.   An alien armada lurks on the edges of Teixcalaanli space.  No one can communicate with it, no one can destroy it, and Fleet Captain Nine Hibiscus is running out of options.    In a desperate attempt at diplomacy with the mysterious invaders, the fleet captain has sent for a diplomatic envoy.  Now Mahit Dzmare and Three Seagrass—still reeling from the recent upheaval in the Empire—face the impossible task of trying to communicate with a hostile entity.    Their failure will guarantee millions of deaths in an endless war.  Their success might prevent Teixcalaan’s destruction—and allow the empire to continue its rapacious expansion.    Or it might create something far stranger .  .",
    "rating": 4.04,
    "ratingsCount": 38475,
    "pageCount": 496,
    "awards": [
      "Hugo Award for Best Novel (2022)"
    ],
    "categories": [
      "Science Fiction",
      "Space Opera"
    ],
    "scores": {
      "scifi": 9,
      "plot": 8,
      "epic": 8,
      "adventure": 8,
      "character": 7,
      "standalone": 9,
      "modern": 9,
      "accessible": 7,
      "medium": 7,
      "emotional": 7
    }
  },
  {
    "id": 1089,
    "title": "The Calculating Stars",
    "author": "Mary Robinette Kowal",
    "authorGender": "unknown",
    "publicationYear": 2018,
    "series": {
      "name": "Lady Astronaut",
      "position": 1
    },
    "isbn": "0765378388",
    "googleBooksId": "9lhdDwAAQBAJ",
    "image": "https://books.google.com/books/content?id=9lhdDwAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Mary Robinette Kowal's science fiction debut, 2019 Winner of the Hugo and Nebula Award for best novel, The Calculating Stars, explores the premise behind her award-winning \"Lady Astronaut of Mars. \" Winner 2018 Nebula Award for Best Novel Winner 2019 Locus Award for Best Novel Winner 2019 Hugo Award for Best Novel Finalist 2019 Campbell Memorial Award Finalist 2021 Hugo Award for Best Series Named one of Esquire's 75 Best Sci-Fi Books of All Time Locus Trade Paperback Bestseller List Publishers Weekly Best Books of 2018—Science Fiction/Fantasy Winner 2019 RUSA Reading List for Science Fiction—American Library Association Locus 2018 Recommended Reading List Buzzfeed—17 Science-Fiction Novels By Women That Are Out Of This World Locus Bestseller List Chicago Review of Books—Top 10 Science Fiction Books of 2018 Goodreads—Most Popular Books Published in July 2018 (#66) The Verge—12 fantastic science fiction and fantasy novels for July 2018 Unbound Worlds—Best SciFi and Fantasy Books of July 2018 Den of Geek—Best Science Fiction Books of June 2018 Publishers Weekly—Best SFF Books of 2018 Omnivoracious—15 Highly Anticipated SFF Reads for Summer 2018 Past Magazine—Best Novels of 2018 Bookriot—Best Science Fiction Books of 2018 The Library Thing—Top Five Books of 2018 On a cold spring night...",
    "rating": 4.03,
    "ratingsCount": 37284,
    "pageCount": 431,
    "awards": [
      "Hugo Award for Best Novel (2019)",
      "Nebula Award for Best Novel (2018)"
    ],
    "categories": [
      "Science Fiction",
      "Historical Fiction"
    ],
    "scores": {
      "scifi": 9,
      "plot": 8,
      "historical": 8,
      "atmosphere": 7,
      "character": 7,
      "standalone": 9,
      "modern": 9,
      "accessible": 7,
      "medium": 7,
      "emotional": 7
    }
  },
  {
    "id": 1091,
    "title": "Ring Shout",
    "author": "P. Djeli Clark",
    "authorGender": "unknown",
    "publicationYear": 2020,
    "isbn": "1250767024",
    "googleBooksId": "YZqbzAEACAAJ",
    "image": "https://books.google.com/books/content?id=YZqbzAEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Nebula, Locus, and Alex Award-winner P. Djèlí Clark returns with Ring Shout, a dark fantasy historical novella that gives a supernatural twist to the Ku Klux Klan's reign of terror “A fantastical, brutal and thrilling triumph of the imagination... Clark’s combination of historical and political reimagining is cathartic, exhilarating and fresh. ” —The New York Times A 2021 Nebula Award Winner A 2021 Locus Award Winner A New York Times Editor's Choice Pick! A Booklist Editor's Choice Pick! A 2021 Hugo Award Finalist A 2021 World Fantasy Award Finalist A 2021 Ignyte Award Finalist A 2021 Shirley Jackson Award Finalist A 2021 AAMBC Literary Award Finalist A 2021 British Fantasy Award Finalist A 2021 Hurston/Wright Foundation Legacy Award Nominee A 2020 SIBA Award Finalist A Goodreads Choice Award Finalist Named a Best of 2020 Pick for NPR | Library Journal | Book Riot | LitReactor | Bustle | Polygon | Washington Post IN AMERICA, DEMONS WEAR WHITE HOODS. In 1915, The Birth of a Nation cast a spell across America, swelling the Klan's ranks and drinking deep from the darkest thoughts of white folk. All across the nation they ride, spreading fear and violence among the vulnerable. They plan to...",
    "rating": 3.89,
    "ratingsCount": 13854,
    "pageCount": 185,
    "awards": [
      "Nebula Award for Best Novella (2020)",
      "Locus Award for Best Novella (2021)"
    ],
    "categories": [
      "Fantasy",
      "Horror",
      "Historical Fiction"
    ],
    "scores": {
      "fantasy": 9,
      "worldbuilding": 8,
      "horror": 9,
      "dark": 8,
      "atmosphere": 7,
      "historical": 8,
      "character": 7,
      "plot": 7,
      "standalone": 9,
      "modern": 9,
      "accessible": 7,
      "fast": 7
    }
  },
  {
    "id": 1094,
    "title": "At Night All Blood Is Black",
    "author": "David Diop",
    "authorGender": "unknown",
    "publicationYear": 2018,
    "isbn": "1782277536",
    "googleBooksId": "Q4pnzgEACAAJ",
    "image": "https://books.google.com/books/content?id=Q4pnzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Alfa Ndiaye is a Senegalese man who, never before having left his village, finds himself fighting as a so-called \"Chocolat\" soldier with the French army during World War I. When his friend Mademba Diop, in the same regiment, is seriously injured in battle, Diop begs Alfa to kill him and spare him the pain of a long and agonizing death in No Man's Land. Unable to commit this mercy killing, madness creeps into Alfa's mind as he comes to see this refusal as a cruel moment of cowardice. Anxious to avenge the death of his friend and find forgiveness for himself, he begins a macabre ritual: every night he sneaks across enemy lines to find and murder a blue-eyed German soldier, and every night he returns to base, unharmed, with the German's severed hand. At first his comrades look at Alfa's deeds with admiration, but soon rumors begin to circulate that this super soldier isn't a hero, but a sorcerer, a soul-eater. Plans are hatched to get Alfa away from the front, and to separate him from his growing collection of hands, but how does one reason with a demon, and how far will Alfa go to make amends to...",
    "rating": 3.95,
    "ratingsCount": 18745,
    "pageCount": 160,
    "awards": [
      "International Booker Prize (2021)"
    ],
    "categories": [
      "Literary Fiction",
      "Historical Fiction",
      "War"
    ],
    "scores": {
      "literary": 9,
      "character": 8,
      "historical": 8,
      "atmosphere": 7,
      "dark": 8,
      "emotional": 8,
      "plot": 7,
      "standalone": 9,
      "modern": 9,
      "accessible": 7,
      "medium": 7
    }
  },
  {
    "id": 1097,
    "title": "An American Marriage",
    "author": "Tayari Jones",
    "authorGender": "unknown",
    "publicationYear": 2018,
    "isbn": "1616208686",
    "googleBooksId": "eWGYtAEACAAJ",
    "image": "https://books.google.com/books/content?id=eWGYtAEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "A NEW YORK TIMES AND WASHINGTON POST NOTABLE BOOK   A 2018 BEST OF THE YEAR SELECTION OF NPR  * TIME  * BUSTLE  * O, THE OPRAH MAGAZINE  * THE DALLAS MORNING NEWS  * AMAZON. COM   OPRAH’S BOOK CLUB 2018 SELECTION  WINNER OF THE 2019 NAACP IMAGE AWARD FOR OUTSTANDING LITERARY WORK—FICTION  LONGLISTED FOR THE 2018 NATIONAL BOOK AWARD FOR FICTION  “A moving portrayal of the effects of a wrongful conviction on a young African-American couple. ” —Barack Obama   “Haunting .  .  .  Beautifully written. ” —The New York Times Book Review   “Brilliant and heartbreaking .  .  .  Unforgettable.",
    "rating": 3.93,
    "ratingsCount": 386131,
    "pageCount": 308,
    "awards": [
      "Women's Prize for Fiction (2019)",
      "National Book Award Fiction Longlist (2018)",
      "Los Angeles Times Book Prize Fiction (2018)",
      "Goodreads Choice Award Fiction (2018)",
      "NAACP Image Award Fiction (2019)",
      "Audie Award Audiobook of the Year (2019)",
      "Dublin Literary Award (2020)"
    ],
    "categories": [
      "Literary Fiction",
      "Contemporary"
    ],
    "scores": {
      "literary": 9,
      "character": 8,
      "contemporary": 8,
      "plot": 7,
      "standalone": 9,
      "modern": 9,
      "accessible": 7,
      "medium": 7,
      "emotional": 7
    }
  },
  {
    "id": 1098,
    "title": "The Book of Form and Emptiness",
    "author": "Ruth Ozeki",
    "authorGender": "unknown",
    "publicationYear": 2021,
    "isbn": "1838855238",
    "googleBooksId": "0A1HzgEACAAJ",
    "image": "https://books.google.com/books/content?id=0A1HzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "WINNER OF THE WOMEN'S PRIZE FOR FICTION 2022One year after the death of his beloved musician father, thirteen-year-old Benny Oh begins to hear voices. The voices belong to the things in his house - a sneaker, a broken Christmas ornament, a piece of wilted lettuce. Although Benny doesn't understand what these things are saying, he can sense their emotional tone; some are pleasant, a gentle hum or coo, but others are snide, angry and full of pain. When his mother develops a hoarding problem, the voices grow more clamorous. At first Benny tries to ignore them, but soon the voices follow him outside the house, onto the street and at school, driving him at last to seek refuge in the silence of a large public library, where objects are well-behaved and know to speak in whispers. There, he falls in love with a mesmerising street artist with a smug pet ferret, who uses the library as her performance space. He meets a homeless philosopher-poet, who encourages him to ask important questions and find his own voice amongst the many. And he meets his very own Book - a talking thing - who narrates Benny's life and teaches him to listen...",
    "rating": 3.85,
    "ratingsCount": 14875,
    "pageCount": 546,
    "awards": [
      "Women's Prize for Fiction (2022)"
    ],
    "categories": [
      "Literary Fiction",
      "Contemporary"
    ],
    "scores": {
      "literary": 9,
      "character": 8,
      "contemporary": 8,
      "plot": 7,
      "standalone": 9,
      "modern": 9,
      "accessible": 7,
      "medium": 7,
      "emotional": 7
    }
  },
  {
    "id": 1106,
    "title": "Incidents Around the House",
    "author": "Josh Malerman",
    "authorGender": "unknown",
    "publicationYear": 2024,
    "isbn": "0593723120",
    "googleBooksId": "CE3sEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=CE3sEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "A young girl’s troubled family is haunted by an entity she calls “Other Mommy” in this chilling tale from the New York Times bestselling author of Bird Box.   “Deeply discomfiting, imaginatively ripe, yet ruthlessly efficient [with] claustrophobic terror that almost transcends articulation .  .  .  Simply put—and I do not say this lightly—Incidents Around the House is the most purely effective horror novel I have ever read. ”—Neil McRobert, Esquire  “This book is the monster that lives inside your closet. ”—Grady Hendrix, New York Times bestselling author of How to Sell a Haunted House  COMING SOON AS THE MAJOR MOTION PICTURE OTHER MOMMY, STARRING JESSICA CHASTAIN • LOCUS AWARD FINALIST • BRAM STOKER AWARD NOMINEE  To eight-year-old Bela, her family is her world.  There’s Mommy, Daddo, and Grandma Ruth.  But there is also Other Mommy, a malevolent entity who asks her every day: “Can I go inside your heart? ”   When horrifying incidents around the house signal that Other Mommy is growing tired of asking Bela the question over and over, Bela understands that unless she says yes, her family will soon pay.",
    "rating": 3.98,
    "ratingsCount": 12475,
    "pageCount": 240,
    "categories": [
      "Horror"
    ],
    "scores": {
      "horror": 9,
      "dark": 8,
      "atmosphere": 8,
      "character": 7,
      "plot": 7,
      "standalone": 9,
      "modern": 9,
      "accessible": 7,
      "fast": 7
    }
  },
  {
    "id": 1110,
    "title": "Black Cake",
    "author": "Charmaine Wilkerson",
    "authorGender": "unknown",
    "publicationYear": 2022,
    "isbn": "059335835X",
    "googleBooksId": "nm-TEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=nm-TEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "NOW A HULU STREAMING SERIES • NEW YORK TIMES BESTSELLER • READ WITH JENNA BOOK CLUB PICK AS FEATURED ON TODAY • Two estranged siblings delve into their mother’s hidden past—and how it all connects to her traditional Caribbean black cake—in this immersive family saga, “a character-driven, multigenerational story that’s meant to be savored” (Time). “Wilkerson transports you across the decades and around the globe accompanied by complex, wonderfully drawn characters. ”—Taylor Jenkins Reid, New York Times bestselling author of The Seven Husbands of Evelyn Hugo, Daisy Jones & The Six, and Malibu Rising ONE OF THE BEST BOOKS OF THE YEAR: Oprah Daily, NPR, BuzzFeed, Glamour, PopSugar, Book Riot, She Reads We can’t choose what we inherit. But can we choose who we become? In present-day California, Eleanor Bennett’s death leaves behind a puzzling inheritance for her two children, Byron and Benny: a black cake, made from a family recipe with a long history, and a voice recording. In her message, Eleanor shares a tumultuous story about a headstrong young swimmer who escapes her island home under suspicion of murder. The heartbreaking tale Eleanor unfolds, the secrets she still holds back, and the mystery of a long-lost child challenge...",
    "rating": 3.85,
    "ratingsCount": 87454,
    "pageCount": 400,
    "categories": [
      "Literary Fiction",
      "Contemporary"
    ],
    "scores": {
      "literary": 9,
      "character": 8,
      "contemporary": 8,
      "plot": 7,
      "standalone": 9,
      "modern": 9,
      "accessible": 7,
      "medium": 7,
      "emotional": 7
    }
  },
  {
    "id": 1116,
    "title": "The Prophets",
    "author": "Robert Jones Jr.",
    "authorGender": "unknown",
    "publicationYear": 2021,
    "isbn": "059308568X",
    "googleBooksId": "FLUlEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=FLUlEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "Best Book of the Year NPR • The Washington Post • Boston Globe • TIME • USA Today • Entertainment Weekly • Real Simple • Parade • Buzzfeed • Electric Literature • LitHub • BookRiot • PopSugar • Goop • Library Journal • BookBub • KCRW • Finalist for the National Book Award • One of the New York Times Notable Books of the Year • One of the New York Times Best Historical Fiction of the Year • Instant New York Times Bestseller A singular and stunning debut novel about the forbidden union between two enslaved young men on a Deep South plantation, the refuge they find in each other, and a betrayal that threatens their existence. Isaiah was Samuel's and Samuel was Isaiah's. That was the way it was since the beginning, and the way it was to be until the end. In the barn they tended to the animals, but also to each other, transforming the hollowed-out shed into a place of human refuge, a source of intimacy and hope in a world ruled by vicious masters. But when an older man—a fellow slave—seeks to gain favor by preaching the master's gospel on the plantation, the enslaved...",
    "rating": 4.24,
    "ratingsCount": 32847,
    "pageCount": 400,
    "categories": [
      "Literary Fiction",
      "Historical Fiction",
      "LGBTQ+"
    ],
    "scores": {
      "literary": 9,
      "character": 8,
      "historical": 8,
      "atmosphere": 7,
      "emotional": 8,
      "plot": 7,
      "standalone": 9,
      "modern": 9,
      "accessible": 7,
      "medium": 7
    }
  },
  {
    "id": 1117,
    "title": "Cloud Cuckoo Land",
    "author": "Anthony Doerr",
    "authorGender": "unknown",
    "publicationYear": 2021,
    "isbn": "1982168439",
    "googleBooksId": "blRFEAAAQBAJ",
    "image": "https://books.google.com/books/content?id=blRFEAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "\"From the Pulitzer Prize-winning author of perhaps the most bestselling and beloved literary fiction of our time comes a triumph of imagination and compassion, a soaring novel about children on the cusp of adulthood in a broken world, who find resilience, hope, and story. The heroes of Cloud Cuckoo Land are children trying to figure out the world around them, and to survive. In the besieged city of Constantinople in 1453, in a public library in Lakeport, Idaho, today, and on a spaceship bound for a distant exoplanet decades from now, an ancient text provides solace and the most profound human connection to characters in peril. They all learn the story of Aethon, who longs to be turned into a bird so that he can fly to the paradise of Cloud Cuckoo Land, a better world. Twelve-year-old Anna lives in a convent where women toil all day embroidering the robes of priests. She learns to read from an old Greek tutor she encounters on her errands in the city. In an abandoned priory, she finds a stash of old books. One is Aethon's story, which she reads to her sister as the walls of Constantinople are bombarded by armies of...",
    "rating": 4.14,
    "ratingsCount": 186475,
    "pageCount": 640,
    "categories": [
      "Literary Fiction",
      "Historical Fiction"
    ],
    "scores": {
      "literary": 9,
      "character": 8,
      "historical": 8,
      "atmosphere": 7,
      "plot": 7,
      "standalone": 9,
      "modern": 9,
      "accessible": 7,
      "medium": 7,
      "emotional": 7
    }
  },
  {
    "id": 1120,
    "title": "The Secret Lives of Church Ladies",
    "author": "Deesha Philyaw",
    "authorGender": "unknown",
    "publicationYear": 2020,
    "isbn": "1949199738",
    "googleBooksId": "RalczQEACAAJ",
    "image": "https://books.google.com/books/content?id=RalczQEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "*FINALIST for the 2020 National Book Award for Fiction*   *WINNER of the 2021 PEN/Faulkner Award*   *WINNER of the 2020 Story Prize*   *WINNER of the 2020 L. A.  Times Book Prize, Art Seidenbaum Award for First Fiction*   \"Beguiling. \" --The New Yorker   \"Tender, fierce, proudly black and beautiful, these stories will sneak inside you and take root. \" --Kirkus Reviews (starred review)   \"Triumphant. \" --Publishers Weekly   \"Cheeky, insightful, and irresistible. \" --​​​​​​​Ms.  Magazine   \"This collection marks the emergence of a bona fide literary treasure. \" --Minneapolis Star Tribune   \"Full of lived-in humanity, warmth, and compassion. \" --Pittsburgh Current   The Secret Lives of Church Ladies explores the raw and tender places where Black women and girls dare to follow their desires and pursue a momentary reprieve from being good.",
    "rating": 4.09,
    "ratingsCount": 31475,
    "pageCount": 208,
    "awards": [
      "Los Angeles Times Book Prize (2020)",
      "PEN/Faulkner Finalist (2021)"
    ],
    "categories": [
      "Literary Fiction",
      "Short Stories"
    ],
    "scores": {
      "literary": 9,
      "character": 8,
      "plot": 7,
      "standalone": 9,
      "modern": 9,
      "accessible": 7,
      "medium": 7,
      "emotional": 7
    }
  },
  {
    "id": 1123,
    "title": "What Strange Paradise",
    "author": "Omar El Akkad",
    "authorGender": "unknown",
    "publicationYear": 2021,
    "isbn": "0525657908",
    "googleBooksId": "952LzQEACAAJ",
    "image": "https://books.google.com/books/content?id=952LzQEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "synopsis": "A NEW YORK TIMES NOTABLE BOOK OF THE YEAR - From the widely acclaimed, bestselling author of American War--a beautifully written, unrelentingly dramatic, and profoundly moving novel that looks at the global refugee crisis through the eyes of a child. Told from the point of view of two children, on the ground and at sea, the story so astutely unpacks the us-versus-them dynamics of our divided world that it deserves to be an instant classic. --The New York Times Book Review More bodies have washed up on the shores of a small island. Another overfilled, ill-equipped, dilapidated ship has sunk under the weight of its too many passengers: Syrians, Ethiopians, Egyptians, Lebanese, Palestinians, all of them desperate to escape untenable lives back in their homelands. But miraculously, someone has survived the passage: nine-year-old Amir, a Syrian boy who is soon rescued by Vänna. Vänna is a teenage girl, who, despite being native to the island, experiences her own sense of homelessness in a place and among people she has come to disdain. And though Vänna and Amir are complete strangers, though they don't speak a common language, Vänna is determined to do whatever it takes to save the boy. In...",
    "rating": 3.89,
    "ratingsCount": 12875,
    "pageCount": 256,
    "awards": [
      "Giller Prize (2021)"
    ],
    "categories": [
      "Literary Fiction"
    ],
    "scores": {
      "literary": 9,
      "character": 8,
      "plot": 7,
      "standalone": 9,
      "modern": 9,
      "accessible": 7,
      "medium": 7,
      "emotional": 7
    }
  },
  {
    "id": 1124,
    "title": "Wind and Truth",
    "author": "Brandon Sanderson",
    "publicationYear": 2024,
    "pageCount": 1344,
    "rating": 4.37,
    "ratingsCount": 134168,
    "series": {
      "name": "The Stormlight Archive",
      "position": 5
    },
    "awards": [
      "Goodreads Choice Award Nominee Fantasy (2025)"
    ],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "synopsis": "The epic conclusion to the first arc of the Stormlight Archive. As war rages across Roshar, Dalinar Kholin must confront his past and his destiny while the fate of all humanity hangs in the balance.",
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "series": 10,
      "character": 9,
      "worldbuilding": 10,
      "complex": 9,
      "slow": 7,
      "long": 10,
      "magic": 10,
      "emotional": 8
    }
  },
  {
    "id": 1125,
    "title": "Martyr!",
    "author": "Kaveh Akbar",
    "publicationYear": 2024,
    "pageCount": 331,
    "rating": 4.16,
    "ratingsCount": 167692,
    "awards": [
      "Dayton Literary Peace Prize Fiction (2025)",
      "National Book Award Finalist Fiction (2024)",
      "Dublin Literary Award (2025)"
    ],
    "categories": [
      "Literary Fiction",
      "Contemporary"
    ],
    "synopsis": "Cyrus Shams is a young Iranian-American man grappling with addiction, loss, and the weight of history. Obsessed with the concept of martyrdom, he embarks on a journey of self-discovery that leads him to an unexpected encounter with a dying artist.",
    "scores": {
      "literary": 10,
      "character": 9,
      "poetic": 9,
      "identity": 8,
      "medium": 7,
      "philosophical": 8,
      "emotional": 9,
      "contemporary": 8,
      "debut": 8,
      "diverse": 8
    }
  },
  {
    "id": 1126,
    "title": "You Like It Darker",
    "author": "Stephen King",
    "publicationYear": 2024,
    "pageCount": 512,
    "rating": 4.18,
    "ratingsCount": 88634,
    "awards": [
      "Locus Award Collection (2025)",
      "Goodreads Choice Award Horror (2024)"
    ],
    "categories": [
      "Horror",
      "Short Stories"
    ],
    "synopsis": "A masterful collection of twelve short stories from the King of Horror. From the mundane to the supernatural, these tales explore the darkness that lurks in everyday life and the terrors that await in the shadows.",
    "scores": {
      "horror": 10,
      "short_stories": 10,
      "dark": 9,
      "suspense": 8,
      "medium": 7,
      "character": 8,
      "atmospheric": 8,
      "standalone": 10,
      "varied": 8,
      "supernatural": 8
    }
  },
  {
    "id": 1127,
    "title": "Onyx Storm",
    "author": "Rebecca Yarros",
    "publicationYear": 2025,
    "pageCount": 544,
    "rating": 4.21,
    "ratingsCount": 1678038,
    "series": {
      "name": "The Empyrean",
      "position": 3
    },
    "awards": [
      "Goodreads Choice Award Romantasy (2025)",
      "Goodreads Choice Award Audiobook (2025)"
    ],
    "categories": [
      "Fantasy",
      "Romantasy",
      "Romance"
    ],
    "synopsis": "The highly anticipated third installment in The Empyrean series. Violet Sorrengail faces her greatest challenges yet as secrets unravel, alliances shift, and the war against the venin reaches a critical turning point.",
    "scores": {
      "romantasy": 10,
      "fantasy": 9,
      "romance": 9,
      "dragons": 10,
      "series": 9,
      "fast": 8,
      "emotional": 9,
      "action": 8,
      "ya_crossover": 7,
      "spicy": 8
    }
  },
  {
    "id": 1128,
    "title": "Never Flinch",
    "author": "Stephen King",
    "publicationYear": 2025,
    "pageCount": 448,
    "rating": 3.82,
    "ratingsCount": 63719,
    "series": {
      "name": "Holly Gibney",
      "position": 4
    },
    "awards": [
      "Goodreads Choice Award Nominee Horror (2025)"
    ],
    "categories": [
      "Horror",
      "Thriller",
      "Mystery"
    ],
    "synopsis": "Holly Gibney returns in a gripping new thriller. When a series of disturbing events leads Holly to investigate a seemingly ordinary suburban neighborhood, she uncovers a darkness that threatens everything she holds dear.",
    "scores": {
      "horror": 9,
      "thriller": 9,
      "mystery": 8,
      "crime": 8,
      "series": 8,
      "medium": 7,
      "character": 8,
      "suspense": 8,
      "dark": 8,
      "procedural": 7
    }
  },
  {
    "id": 1129,
    "title": "The Briar Club",
    "author": "Kate Quinn",
    "publicationYear": 2024,
    "pageCount": 432,
    "rating": 4.29,
    "ratingsCount": 261689,
    "awards": [
      "Goodreads Choice Award Nominee Historical Fiction (2024)"
    ],
    "categories": [
      "Historical Fiction",
      "Mystery",
      "Thriller"
    ],
    "synopsis": "Washington D.C., 1950. In a boardinghouse full of women with secrets, a murder upends everything. As the McCarthy era casts its shadow, the residents must navigate loyalty, betrayal, and the dangerous game of who can be trusted.",
    "scores": {
      "historical": 10,
      "mystery": 8,
      "book_club": 9,
      "women": 9,
      "medium": 7,
      "character": 9,
      "atmospheric": 8,
      "midcentury": 8,
      "ensemble": 8,
      "suspense": 7
    }
  },
  {
    "id": 1130,
    "title": "The Little Liar",
    "author": "Mitch Albom",
    "publicationYear": 2023,
    "pageCount": 333,
    "rating": 4.56,
    "ratingsCount": 100951,
    "awards": [],
    "categories": [
      "Historical Fiction",
      "World War II"
    ],
    "synopsis": "A powerful fable set during the Holocaust. When eleven-year-old Nico is forced to lie to save himself, his words set off a chain of events spanning decades and continents, revealing how one small deception can alter the course of many lives.",
    "scores": {
      "historical": 10,
      "emotional": 10,
      "wwii": 9,
      "fable": 8,
      "character": 9,
      "medium": 7,
      "inspirational": 8,
      "literary": 8,
      "standalone": 10,
      "thought_provoking": 9
    }
  },
  {
    "id": 1131,
    "title": "Here One Moment",
    "author": "Liane Moriarty",
    "publicationYear": 2024,
    "pageCount": 512,
    "rating": 3.98,
    "ratingsCount": 292630,
    "awards": [
      "Australian Book Industry Award Audiobook of the Year (2025)"
    ],
    "categories": [
      "Fiction",
      "Mystery",
      "Contemporary"
    ],
    "synopsis": "On a delayed flight, an elderly woman walks the aisle making startling predictions about when passengers will die. Dismissed as crazy, her words prove eerily accurate, forcing strangers to confront mortality and the choices that define their lives.",
    "scores": {
      "contemporary": 9,
      "mystery": 8,
      "book_club": 10,
      "character": 9,
      "ensemble": 9,
      "medium": 7,
      "thought_provoking": 8,
      "emotional": 8,
      "australia": 7,
      "literary": 7
    }
  },
  {
    "id": 1132,
    "title": "Wild Eyes",
    "author": "Elsie Silver",
    "publicationYear": 2024,
    "pageCount": 464,
    "rating": 4.25,
    "ratingsCount": 294069,
    "series": {
      "name": "Rose Hill",
      "position": 2
    },
    "awards": [],
    "categories": [
      "Romance",
      "Contemporary Romance",
      "Western"
    ],
    "synopsis": "A country music star hiding from her chaotic life finds refuge in a small town, where a grumpy single dad challenges everything she thought she wanted. Forced proximity and small-town charm ignite an unexpected romance.",
    "scores": {
      "romance": 10,
      "contemporary": 9,
      "small_town": 9,
      "western": 8,
      "series": 8,
      "fast": 8,
      "emotional": 8,
      "spicy": 8,
      "forced_proximity": 8,
      "single_dad": 7
    }
  },
  {
    "id": 1133,
    "title": "The Wedding People",
    "author": "Alison Espach",
    "publicationYear": 2024,
    "pageCount": 367,
    "rating": 4.08,
    "ratingsCount": 1060536,
    "awards": [
      "Goodreads Choice Award Fiction (2024)"
    ],
    "categories": [
      "Fiction",
      "Contemporary",
      "Romance"
    ],
    "synopsis": "Phoebe checks into a lavish hotel in Newport, Rhode Island, planning to end her life. Instead, she becomes unexpectedly entangled in a destination wedding, finding connection, purpose, and reasons to live among the eccentric wedding guests.",
    "scores": {
      "contemporary": 10,
      "book_club": 10,
      "romance": 8,
      "emotional": 9,
      "character": 9,
      "medium": 7,
      "humor": 8,
      "hopeful": 8,
      "women": 8,
      "literary": 7
    }
  },
  {
    "id": 1134,
    "title": "Bright Young Women",
    "author": "Jessica Knoll",
    "publicationYear": 2023,
    "pageCount": 384,
    "rating": 3.98,
    "ratingsCount": 227749,
    "awards": [
      "Edgar Award Best Novel (2024)"
    ],
    "categories": [
      "Thriller",
      "Historical Fiction",
      "True Crime"
    ],
    "synopsis": "Inspired by real events, this novel reimagines the 1978 Chi Omega sorority murders from the perspective of the women affected. Pamela Schumacher refuses to let a serial killer define her sisters, fighting for justice and reclaiming their stories.",
    "scores": {
      "thriller": 10,
      "historical": 8,
      "true_crime": 9,
      "feminist": 9,
      "character": 9,
      "medium": 7,
      "dark": 8,
      "mystery": 8,
      "women": 9,
      "literary": 8
    }
  },
  {
    "id": 1135,
    "title": "Weyward",
    "author": "Emilia Hart",
    "publicationYear": 2023,
    "pageCount": 392,
    "rating": 4.05,
    "ratingsCount": 404633,
    "awards": [
      "Goodreads Choice Award Historical Fiction (2023)",
      "Goodreads Choice Award Debut Novel (2023)",
      "Book of the Month Book of the Year (2023)"
    ],
    "categories": [
      "Historical Fiction",
      "Fantasy",
      "Magical Realism"
    ],
    "synopsis": "Across centuries, three women in the English countryside discover they share a mysterious gift—a connection to the natural world that others call witchcraft. As their stories intertwine, they must embrace their power to survive.",
    "scores": {
      "historical": 10,
      "fantasy": 8,
      "magical_realism": 8,
      "women": 10,
      "witches": 9,
      "multi_timeline": 8,
      "atmospheric": 9,
      "medium": 7,
      "debut": 8,
      "nature": 8
    }
  },
  {
    "id": 1136,
    "title": "My Brilliant Friend",
    "author": "Elena Ferrante",
    "publicationYear": 2011,
    "pageCount": 331,
    "rating": 4.05,
    "ratingsCount": 471862,
    "series": {
      "name": "Neapolitan Novels",
      "position": 1
    },
    "awards": [
      "Waterstones Book of the Year (2015)"
    ],
    "categories": [
      "Literary Fiction",
      "Historical Fiction",
      "Italy"
    ],
    "synopsis": "In 1950s Naples, two girls from a poor neighborhood forge a complex friendship that will span decades. Elena and Lila navigate poverty, violence, and ambition in a story of female friendship, identity, and the pursuit of self-determination.",
    "scores": {
      "literary": 10,
      "historical": 8,
      "character": 10,
      "women": 10,
      "friendship": 10,
      "italy": 9,
      "series": 9,
      "slow": 7,
      "emotional": 9,
      "coming_of_age": 8
    }
  },
  {
    "id": 1137,
    "title": "The Rachel Incident",
    "author": "Caroline O'Donoghue",
    "publicationYear": 2023,
    "pageCount": 304,
    "rating": 4.06,
    "ratingsCount": 140622,
    "awards": [
      "Bollinger Everyman Wodehouse Prize (2024)"
    ],
    "categories": [
      "Fiction",
      "Contemporary",
      "Romance"
    ],
    "synopsis": "In early-2000s Cork, Ireland, Rachel and her charismatic coworker James become inseparable best friends. When Rachel falls for her married professor and James pursues a complicated relationship, their choices set off a chain of events with lasting consequences.",
    "scores": {
      "contemporary": 10,
      "ireland": 9,
      "friendship": 9,
      "romance": 8,
      "lgbtq": 8,
      "coming_of_age": 8,
      "medium": 7,
      "character": 9,
      "humor": 7,
      "literary": 7
    }
  },
  {
    "id": 1138,
    "title": "The Lost Bookshop",
    "author": "Evie Woods",
    "publicationYear": 2023,
    "pageCount": 444,
    "rating": 3.99,
    "ratingsCount": 351103,
    "awards": [
      "British Book Award Pageturner (2024)"
    ],
    "categories": [
      "Fantasy",
      "Historical Fiction",
      "Magical Realism"
    ],
    "synopsis": "A mysterious bookshop in Dublin that appears and disappears connects three women across time. As they uncover the shop's secrets, they discover its magical ability to provide exactly the book each person needs.",
    "scores": {
      "fantasy": 8,
      "historical": 8,
      "magical_realism": 9,
      "books_about_books": 10,
      "women": 9,
      "multi_timeline": 8,
      "medium": 7,
      "cozy": 8,
      "ireland": 8,
      "romantic": 7
    }
  },
  {
    "id": 1139,
    "title": "The House Is on Fire",
    "author": "Rachel Beanland",
    "publicationYear": 2023,
    "pageCount": 376,
    "rating": 4.09,
    "ratingsCount": 24004,
    "awards": [
      "Library of Virginia Literary Award Fiction (2024)"
    ],
    "categories": [
      "Historical Fiction",
      "Mystery"
    ],
    "synopsis": "Richmond, 1811. During a theatrical performance, fire breaks out in the crowded theater, killing dozens. Through four different perspectives—a stagehand, an actress, a slave, and a socialite—this gripping novel explores the tragedy and its aftermath.",
    "scores": {
      "historical": 10,
      "mystery": 8,
      "ensemble": 9,
      "american_history": 9,
      "disaster": 8,
      "character": 9,
      "medium": 7,
      "atmospheric": 8,
      "book_club": 8,
      "women": 8
    }
  },
  {
    "id": 1140,
    "title": "The Boyfriend",
    "author": "Freida McFadden",
    "publicationYear": 2024,
    "pageCount": 368,
    "rating": 4.03,
    "ratingsCount": 956557,
    "awards": [
      "Goodreads Choice Award Nominee Mystery & Thriller (2024)"
    ],
    "categories": [
      "Thriller",
      "Mystery",
      "Psychological Thriller"
    ],
    "synopsis": "Sydney thinks she's found the perfect boyfriend in Tom. But when strange things start happening and she discovers disturbing secrets about his past, she realizes the man she loves might be more dangerous than she ever imagined.",
    "scores": {
      "thriller": 10,
      "mystery": 9,
      "psychological": 9,
      "suspense": 9,
      "romance": 7,
      "fast": 9,
      "twists": 9,
      "dark": 8,
      "domestic": 8,
      "standalone": 10
    }
  },
  {
    "id": 1141,
    "title": "The Woman in Me",
    "author": "Britney Spears",
    "publicationYear": 2023,
    "pageCount": 288,
    "rating": 3.83,
    "ratingsCount": 577845,
    "awards": [
      "British Book Award Non-Fiction (2024)",
      "Goodreads Choice Award Memoir (2023)"
    ],
    "categories": [
      "Memoir",
      "Nonfiction",
      "Biography"
    ],
    "synopsis": "The groundbreaking memoir from one of the most iconic pop stars of our generation. Britney Spears tells her own story for the first time, revealing the truth about her conservatorship, her family, and her journey to freedom.",
    "scores": {
      "memoir": 10,
      "nonfiction": 10,
      "celebrity": 9,
      "emotional": 9,
      "music": 8,
      "fast": 8,
      "inspiring": 8,
      "women": 8,
      "controversial": 8,
      "candid": 9
    }
  },
  {
    "id": 1142,
    "title": "The Frozen River",
    "author": "Ariel Lawhon",
    "publicationYear": 2023,
    "pageCount": 448,
    "rating": 4.38,
    "ratingsCount": 562677,
    "awards": [
      "Goodreads Choice Award Nominee Historical Fiction (2024)"
    ],
    "categories": [
      "Historical Fiction",
      "Mystery",
      "Thriller"
    ],
    "synopsis": "Maine, 1789. Martha Ballard is a midwife who has delivered over a thousand babies. When a body is found beneath the frozen Kennebec River, Martha becomes embroiled in the investigation, using her keen observation and medical knowledge to uncover the truth.",
    "scores": {
      "historical": 10,
      "mystery": 9,
      "thriller": 8,
      "women": 9,
      "american_history": 9,
      "book_club": 9,
      "medium": 7,
      "atmospheric": 9,
      "character": 9,
      "based_on_true_story": 8
    }
  },
  {
    "id": 1143,
    "title": "Words of Radiance",
    "author": "Brandon Sanderson",
    "publicationYear": 2014,
    "pageCount": 1087,
    "rating": 4.76,
    "ratingsCount": 372071,
    "series": {
      "name": "The Stormlight Archive",
      "position": 2
    },
    "awards": [
      "Goodreads Choice Award Fantasy (2014)"
    ],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "synopsis": "The war with the Parshendi continues as Kaladin trains the bridgemen and Shallan seeks to become a Knight Radiant. Ancient secrets emerge that could change everything.",
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "series": 10,
      "worldbuilding": 10,
      "character": 10,
      "complex": 9,
      "slow": 7,
      "long": 10,
      "magic": 10,
      "emotional": 9
    }
  },
  {
    "id": 1144,
    "title": "Harry Potter and the Deathly Hallows",
    "author": "J.K. Rowling",
    "publicationYear": 2007,
    "pageCount": 759,
    "rating": 4.62,
    "ratingsCount": 4120209,
    "series": {
      "name": "Harry Potter",
      "position": 7
    },
    "awards": [
      "Locus Award for Best Young Adult Book (2008)"
    ],
    "categories": [
      "Fantasy",
      "Young Adult",
      "Magic"
    ],
    "synopsis": "Harry, Ron, and Hermione set out on a dangerous quest to find and destroy Voldemort's Horcruxes. The final battle between good and evil approaches.",
    "scores": {
      "fantasy": 10,
      "ya": 9,
      "series": 10,
      "magic": 10,
      "adventure": 10,
      "character": 10,
      "fast": 8,
      "emotional": 10,
      "friendship": 10,
      "dark": 8
    }
  },
  {
    "id": 1145,
    "title": "Crooked Kingdom",
    "author": "Leigh Bardugo",
    "publicationYear": 2016,
    "pageCount": 536,
    "rating": 4.57,
    "ratingsCount": 772391,
    "series": {
      "name": "Six of Crows",
      "position": 2
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Young Adult"
    ],
    "synopsis": "Kaz Brekker and his crew must pull off an impossible heist in the heart of a city that wants them dead. War is coming and they're the only ones who can stop it.",
    "scores": {
      "fantasy": 10,
      "ya": 9,
      "heist": 10,
      "series": 10,
      "character": 10,
      "ensemble": 10,
      "fast": 9,
      "dark": 8,
      "romance": 7,
      "twists": 9
    }
  },
  {
    "id": 1146,
    "title": "Kingdom of Ash",
    "author": "Sarah J. Maas",
    "publicationYear": 2018,
    "pageCount": 984,
    "rating": 4.71,
    "ratingsCount": 1098202,
    "series": {
      "name": "Throne of Glass",
      "position": 7
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Young Adult",
      "Romance"
    ],
    "synopsis": "Aelin Galathynius has fought her way to the throne. But the final battle against darkness will demand everything she has—and more.",
    "scores": {
      "fantasy": 10,
      "ya": 9,
      "romance": 8,
      "series": 10,
      "action": 10,
      "emotional": 10,
      "epic": 10,
      "long": 10,
      "character": 9,
      "dark": 8
    }
  },
  {
    "id": 1147,
    "title": "Light Bringer",
    "author": "Pierce Brown",
    "publicationYear": 2023,
    "pageCount": 672,
    "rating": 4.77,
    "ratingsCount": 104048,
    "series": {
      "name": "Red Rising Saga",
      "position": 6
    },
    "awards": [
      "Goodreads Choice Award Nominee Science Fiction (2023)"
    ],
    "categories": [
      "Science Fiction",
      "Dystopia"
    ],
    "synopsis": "The sixth installment in the Red Rising Saga. Darrow and his allies face impossible odds as the Solar Republic crumbles and enemies close in from all sides.",
    "scores": {
      "scifi": 10,
      "dystopia": 9,
      "series": 10,
      "action": 10,
      "epic": 10,
      "character": 9,
      "dark": 9,
      "fast": 9,
      "political": 8,
      "war": 9
    }
  },
  {
    "id": 1148,
    "title": "The Will of the Many",
    "author": "James Islington",
    "publicationYear": 2023,
    "pageCount": 606,
    "rating": 4.59,
    "ratingsCount": 207764,
    "series": {
      "name": "Hierarchy",
      "position": 1
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Science Fiction"
    ],
    "synopsis": "In a world where power is extracted from citizens, Vis must infiltrate an academy and survive its deadly trials while hiding his true identity and abilities.",
    "scores": {
      "fantasy": 10,
      "scifi": 8,
      "academy": 9,
      "intrigue": 9,
      "character": 9,
      "worldbuilding": 9,
      "medium": 7,
      "mystery": 8,
      "political": 8,
      "debut": 8
    }
  },
  {
    "id": 1149,
    "title": "The Complete Maus",
    "author": "Art Spiegelman",
    "publicationYear": 1996,
    "pageCount": 296,
    "rating": 4.58,
    "ratingsCount": 254606,
    "awards": [
      "Pulitzer Prize Special Award (1992)"
    ],
    "categories": [
      "Graphic Novel",
      "Nonfiction",
      "Holocaust"
    ],
    "synopsis": "A groundbreaking graphic novel depicting the author's father's experiences as a Polish Jew and Holocaust survivor, using animals to represent different groups.",
    "scores": {
      "graphic_novel": 10,
      "nonfiction": 10,
      "holocaust": 10,
      "memoir": 9,
      "historical": 10,
      "emotional": 10,
      "medium": 7,
      "literary": 10,
      "family": 9,
      "dark": 9
    }
  },
  {
    "id": 1150,
    "title": "Somewhere Beyond the Sea",
    "author": "T.J. Klune",
    "publicationYear": 2024,
    "pageCount": 396,
    "rating": 4.13,
    "ratingsCount": 174285,
    "series": {
      "name": "Cerulean Chronicles",
      "position": 2
    },
    "awards": [
      "Goodreads Choice Award Fantasy (2024)"
    ],
    "categories": [
      "Fantasy",
      "LGBTQ+",
      "Romance"
    ],
    "synopsis": "Arthur and Linus return as they navigate parenthood, prejudice, and the fight to protect their magical orphanage from those who fear it.",
    "scores": {
      "fantasy": 9,
      "lgbtq": 10,
      "found_family": 10,
      "cozy": 10,
      "romance": 8,
      "medium": 7,
      "hopeful": 10,
      "series": 8,
      "emotional": 9,
      "magical": 8
    }
  },
  {
    "id": 1151,
    "title": "A Court of Wings and Ruin",
    "author": "Sarah J. Maas",
    "publicationYear": 2017,
    "pageCount": 699,
    "rating": 4.46,
    "ratingsCount": 2716909,
    "series": {
      "name": "A Court of Thorns and Roses",
      "position": 3
    },
    "awards": [
      "Goodreads Choice Award Fantasy (2017)"
    ],
    "categories": [
      "Fantasy",
      "Romance",
      "New Adult"
    ],
    "synopsis": "Feyre returns to the Spring Court to spy for the Night Court, gathering information to help win the war against the immortal king threatening to destroy both mortal and faerie lands.",
    "scores": {
      "fantasy": 10,
      "romance": 10,
      "series": 10,
      "fast": 8,
      "dark": 7,
      "plot": 9,
      "character": 9,
      "emotional": 9,
      "magical": 9,
      "epic": 8
    }
  },
  {
    "id": 1152,
    "title": "A Wise Man's Fear",
    "author": "Patrick Rothfuss",
    "publicationYear": 2011,
    "pageCount": 994,
    "rating": 4.55,
    "ratingsCount": 622422,
    "series": {
      "name": "The Kingkiller Chronicle",
      "position": 2
    },
    "awards": [
      "Goodreads Choice Award Fantasy (2011)",
      "David Gemmell Legend Award (2012)"
    ],
    "categories": [
      "Fantasy",
      "Epic"
    ],
    "synopsis": "Kvothe continues his story, detailing his time at the University, his adventures in Vintas, and his training with the legendary Adem mercenaries, all while searching for the Chandrian who murdered his family.",
    "scores": {
      "fantasy": 10,
      "literary": 10,
      "character": 10,
      "slow": 8,
      "dark": 6,
      "atmosphere": 10,
      "series": 10,
      "worldbuilding": 10,
      "mind": 8,
      "emotional": 8
    }
  },
  {
    "id": 1153,
    "title": "Oathbringer",
    "author": "Brandon Sanderson",
    "publicationYear": 2017,
    "pageCount": 1248,
    "rating": 4.6,
    "ratingsCount": 359484,
    "series": {
      "name": "The Stormlight Archive",
      "position": 3
    },
    "awards": [
      "Goodreads Choice Award Fantasy (2017)"
    ],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "synopsis": "Dalinar Kholin's memories of his past reveal the terrible truth of his blood-soaked rise to power, even as he tries to unite the kingdoms against the coming Desolation and the return of the ancient Voidbringers.",
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "series": 10,
      "worldbuilding": 10,
      "character": 9,
      "slow": 8,
      "plot": 10,
      "emotional": 9,
      "dark": 7,
      "atmosphere": 9
    }
  },
  {
    "id": 1154,
    "title": "Harry Potter and the Prisoner of Azkaban",
    "author": "J.K. Rowling",
    "publicationYear": 1999,
    "pageCount": 435,
    "rating": 4.58,
    "ratingsCount": 4860615,
    "series": {
      "name": "Harry Potter",
      "position": 3
    },
    "awards": [
      "Whitbread Children's Book of the Year (1999)",
      "Bram Stoker Award Nominee (1999)",
      "Locus Award Best Fantasy Novel (2000)"
    ],
    "categories": [
      "Fantasy",
      "Young Adult",
      "Classic"
    ],
    "synopsis": "Harry learns that an escaped prisoner, Sirius Black, is hunting him. As truths about his parents' deaths emerge, Harry must face the darkest corners of the wizarding world's past.",
    "scores": {
      "fantasy": 10,
      "ya": 10,
      "series": 10,
      "fast": 9,
      "optimistic": 8,
      "plot": 10,
      "character": 9,
      "magical": 10,
      "classic": 10,
      "emotional": 8
    }
  },
  {
    "id": 1155,
    "title": "Harry Potter and the Goblet of Fire",
    "author": "J.K. Rowling",
    "publicationYear": 2000,
    "pageCount": 734,
    "rating": 4.57,
    "ratingsCount": 4207062,
    "series": {
      "name": "Harry Potter",
      "position": 4
    },
    "awards": [
      "Hugo Award for Best Novel (2001)",
      "Locus Award Best Fantasy Novel (2001)"
    ],
    "categories": [
      "Fantasy",
      "Young Adult",
      "Classic"
    ],
    "synopsis": "Harry is unexpectedly entered into the dangerous Triwizard Tournament, a magical competition between three wizarding schools. But dark forces are at work, and Voldemort's return draws ever closer.",
    "scores": {
      "fantasy": 10,
      "ya": 10,
      "series": 10,
      "fast": 8,
      "dark": 7,
      "plot": 10,
      "character": 9,
      "magical": 10,
      "classic": 10,
      "emotional": 9
    }
  },
  {
    "id": 1156,
    "title": "Harry Potter and the Half-Blood Prince",
    "author": "J.K. Rowling",
    "publicationYear": 2005,
    "pageCount": 652,
    "rating": 4.58,
    "ratingsCount": 3667066,
    "series": {
      "name": "Harry Potter",
      "position": 6
    },
    "awards": [
      "British Book Award (2006)",
      "Quill Award (2005)"
    ],
    "categories": [
      "Fantasy",
      "Young Adult",
      "Classic"
    ],
    "synopsis": "As Voldemort's power grows, Harry discovers an old potions textbook belonging to the mysterious Half-Blood Prince. Dumbledore prepares Harry for his final confrontation with the Dark Lord by revealing Voldemort's past.",
    "scores": {
      "fantasy": 10,
      "ya": 10,
      "series": 10,
      "medium": 8,
      "dark": 8,
      "plot": 10,
      "character": 9,
      "magical": 10,
      "classic": 10,
      "emotional": 10
    }
  },
  {
    "id": 1157,
    "title": "The Final Empire",
    "author": "Brandon Sanderson",
    "publicationYear": 2006,
    "pageCount": 541,
    "rating": 4.49,
    "ratingsCount": 981376,
    "series": {
      "name": "Mistborn",
      "position": 1
    },
    "awards": [
      "Romantic Times Reviewers' Choice Award (2006)"
    ],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "synopsis": "In a world where ash falls from the sky and mists dominate the night, a street thief discovers she has extraordinary powers and joins a crew of rebels planning the impossible: to overthrow the immortal Lord Ruler.",
    "scores": {
      "fantasy": 10,
      "epic": 9,
      "series": 10,
      "worldbuilding": 10,
      "character": 9,
      "medium": 8,
      "plot": 10,
      "dark": 7,
      "atmosphere": 9,
      "magical": 10
    }
  },
  {
    "id": 1158,
    "title": "Harry Potter and the Order of the Phoenix",
    "author": "J.K. Rowling",
    "publicationYear": 2003,
    "pageCount": 870,
    "rating": 4.5,
    "ratingsCount": 3806234,
    "series": {
      "name": "Harry Potter",
      "position": 5
    },
    "awards": [
      "British Book Award (2004)"
    ],
    "categories": [
      "Fantasy",
      "Young Adult",
      "Classic"
    ],
    "synopsis": "Harry must confront a corrupt Ministry of Magic that refuses to believe Voldemort has returned. As Dumbledore's Army forms in secret, Harry discovers a mysterious connection to the Dark Lord's mind.",
    "scores": {
      "fantasy": 10,
      "ya": 10,
      "series": 10,
      "slow": 7,
      "dark": 8,
      "plot": 10,
      "character": 9,
      "magical": 10,
      "classic": 10,
      "emotional": 9
    }
  },
  {
    "id": 1159,
    "title": "Rhythm of War",
    "author": "Brandon Sanderson",
    "publicationYear": 2020,
    "pageCount": 1232,
    "rating": 4.58,
    "ratingsCount": 241186,
    "series": {
      "name": "The Stormlight Archive",
      "position": 4
    },
    "awards": [
      "Audie Award Best Fantasy (2022)",
      "Goodreads Choice Award Fantasy (2020)"
    ],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "synopsis": "The war between humans and singers escalates as Kaladin struggles with his mental health, Shallan faces her dark past, and Navani races to understand ancient fabrials while her husband remains trapped in a nightmare.",
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "series": 10,
      "worldbuilding": 10,
      "character": 10,
      "slow": 8,
      "plot": 10,
      "emotional": 10,
      "dark": 8,
      "atmosphere": 9
    }
  },
  {
    "id": 1160,
    "title": "A Storm of Swords",
    "author": "George R.R. Martin",
    "publicationYear": 2000,
    "pageCount": 1177,
    "rating": 4.55,
    "ratingsCount": 847937,
    "series": {
      "name": "A Song of Ice and Fire",
      "position": 3
    },
    "awards": [
      "Locus Award Best Fantasy Novel (2001)",
      "Geffen Award Best Translated Fantasy Book (2002)"
    ],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "synopsis": "The Seven Kingdoms are torn apart as multiple kings vie for the Iron Throne. Wedding bells ring, but treachery lurks beneath every alliance, and winter is still coming.",
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "series": 10,
      "worldbuilding": 10,
      "character": 10,
      "slow": 8,
      "plot": 10,
      "dark": 10,
      "atmosphere": 10,
      "emotional": 9
    }
  },
  {
    "id": 1161,
    "title": "A Clash of Kings",
    "author": "George R.R. Martin",
    "publicationYear": 1998,
    "pageCount": 969,
    "rating": 4.42,
    "ratingsCount": 1022589,
    "series": {
      "name": "A Song of Ice and Fire",
      "position": 2
    },
    "awards": [
      "Locus Award Best Fantasy Novel (1999)"
    ],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "synopsis": "War erupts across Westeros as five kings claim the Iron Throne. Magic awakens in the world as a comet blazes overhead, dragons are born, and shadows come to kill.",
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "series": 10,
      "worldbuilding": 10,
      "character": 10,
      "slow": 8,
      "plot": 10,
      "dark": 10,
      "atmosphere": 10,
      "emotional": 8
    }
  },
  {
    "id": 1162,
    "title": "A Feast for Crows",
    "author": "George R.R. Martin",
    "publicationYear": 2005,
    "pageCount": 1060,
    "rating": 4.17,
    "ratingsCount": 793635,
    "series": {
      "name": "A Song of Ice and Fire",
      "position": 4
    },
    "awards": [
      "Locus Award Nominee Best Fantasy Novel (2006)"
    ],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "synopsis": "In the aftermath of devastating war, the survivors scramble to fill the power vacuum. Cersei struggles to maintain control in King's Landing while new threats emerge from every corner of the realm.",
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "series": 10,
      "worldbuilding": 10,
      "character": 9,
      "slow": 9,
      "plot": 8,
      "dark": 9,
      "atmosphere": 10,
      "emotional": 7
    }
  },
  {
    "id": 1163,
    "title": "A Dance with Dragons",
    "author": "George R.R. Martin",
    "publicationYear": 2011,
    "pageCount": 1136,
    "rating": 4.34,
    "ratingsCount": 739751,
    "series": {
      "name": "A Song of Ice and Fire",
      "position": 5
    },
    "awards": [
      "Locus Award Best Fantasy Novel (2012)"
    ],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "synopsis": "Jon Snow faces difficult choices as Lord Commander. Daenerys struggles to rule Meereen. Tyrion travels across Essos. And in the North, ancient powers stir as winter finally comes.",
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "series": 10,
      "worldbuilding": 10,
      "character": 10,
      "slow": 9,
      "plot": 9,
      "dark": 10,
      "atmosphere": 10,
      "emotional": 8
    }
  },
  {
    "id": 1164,
    "title": "The Well of Ascension",
    "author": "Brandon Sanderson",
    "publicationYear": 2007,
    "pageCount": 763,
    "rating": 4.38,
    "ratingsCount": 503337,
    "series": {
      "name": "Mistborn",
      "position": 2
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "synopsis": "With the Lord Ruler dead, Vin and Elend must build a new government while facing threats from multiple armies converging on Luthadel. But something far more dangerous lurks in the mists.",
    "scores": {
      "fantasy": 10,
      "epic": 9,
      "series": 10,
      "worldbuilding": 10,
      "character": 9,
      "medium": 8,
      "plot": 10,
      "dark": 7,
      "atmosphere": 9,
      "magical": 10
    }
  },
  {
    "id": 1165,
    "title": "The Hero of Ages",
    "author": "Brandon Sanderson",
    "publicationYear": 2008,
    "pageCount": 572,
    "rating": 4.56,
    "ratingsCount": 570618,
    "series": {
      "name": "Mistborn",
      "position": 3
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "synopsis": "The final battle approaches as Vin and Elend race to discover the secrets of the Lord Ruler's empire before the world is destroyed by the very forces they unleashed in their quest for freedom.",
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "series": 10,
      "worldbuilding": 10,
      "character": 10,
      "fast": 8,
      "plot": 10,
      "dark": 8,
      "atmosphere": 9,
      "magical": 10,
      "emotional": 10
    }
  },
  {
    "id": 1166,
    "title": "A Memory of Light",
    "author": "Robert Jordan, Brandon Sanderson",
    "publicationYear": 2013,
    "pageCount": 912,
    "rating": 4.55,
    "ratingsCount": 162119,
    "series": {
      "name": "The Wheel of Time",
      "position": 14
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "synopsis": "The Last Battle has come. The seals on the Dark One's prison have crumbled. The Light's forces stand ready as Rand al'Thor prepares to confront the Dark One in a battle that will determine the fate of all existence.",
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "series": 10,
      "worldbuilding": 10,
      "character": 10,
      "fast": 9,
      "plot": 10,
      "dark": 8,
      "atmosphere": 10,
      "emotional": 10
    }
  },
  {
    "id": 1167,
    "title": "Warbreaker",
    "author": "Brandon Sanderson",
    "publicationYear": 2009,
    "pageCount": 592,
    "rating": 4.29,
    "ratingsCount": 278741,
    "awards": [],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "synopsis": "Two princesses, one a god, one a rebel, become entangled in political intrigue and forbidden magic in a world where breath is currency and color is power.",
    "scores": {
      "fantasy": 10,
      "standalone": 10,
      "worldbuilding": 10,
      "character": 9,
      "medium": 8,
      "plot": 9,
      "atmosphere": 9,
      "magical": 10,
      "emotional": 8
    }
  },
  {
    "id": 1168,
    "title": "Elantris",
    "author": "Brandon Sanderson",
    "publicationYear": 2005,
    "pageCount": 638,
    "rating": 4.17,
    "ratingsCount": 349784,
    "awards": [],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "synopsis": "Once the city of the gods, Elantris now stands as a monument to fallen glory. When Prince Raoden is transformed and cast into the ruined city, he must find a way to restore it while his bride fights to save their kingdom.",
    "scores": {
      "fantasy": 10,
      "standalone": 10,
      "worldbuilding": 10,
      "character": 8,
      "medium": 8,
      "plot": 9,
      "atmosphere": 9,
      "magical": 9,
      "emotional": 8
    }
  },
  {
    "id": 1169,
    "title": "Tress of the Emerald Sea",
    "author": "Brandon Sanderson",
    "publicationYear": 2023,
    "pageCount": 384,
    "rating": 4.32,
    "ratingsCount": 288320,
    "awards": [
      "Goodreads Choice Award Fantasy (2023)"
    ],
    "categories": [
      "Fantasy",
      "Adventure"
    ],
    "synopsis": "A humble window washer sets sail across spore-filled seas to rescue her best friend from a witch, in this whimsical fairy tale narrated by a mysterious storyteller from Sanderson's Cosmere.",
    "scores": {
      "fantasy": 10,
      "standalone": 10,
      "character": 9,
      "fast": 8,
      "optimistic": 9,
      "plot": 9,
      "cozy": 9,
      "magical": 10,
      "emotional": 8,
      "romance": 7
    }
  },
  {
    "id": 1170,
    "title": "The Alloy of Law",
    "author": "Brandon Sanderson",
    "publicationYear": 2011,
    "pageCount": 336,
    "rating": 4.19,
    "ratingsCount": 285627,
    "series": {
      "name": "Mistborn Era 2",
      "position": 1
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Western"
    ],
    "synopsis": "Three hundred years after the events of the original Mistborn trilogy, a lawman from the Roughs returns to the city to find it plagued by mysterious kidnappings and a new threat to the world.",
    "scores": {
      "fantasy": 10,
      "series": 10,
      "worldbuilding": 9,
      "character": 9,
      "fast": 9,
      "plot": 9,
      "atmosphere": 8,
      "magical": 10,
      "action": 9
    }
  },
  {
    "id": 1171,
    "title": "Yumi and the Nightmare Painter",
    "author": "Brandon Sanderson",
    "publicationYear": 2023,
    "pageCount": 480,
    "rating": 4.44,
    "ratingsCount": 112807,
    "awards": [],
    "categories": [
      "Fantasy",
      "Romance"
    ],
    "synopsis": "Two people from different worlds suddenly swap lives: a girl who summons spirits and a boy who paints nightmares into oblivion. They must work together to discover why their souls have become intertwined.",
    "scores": {
      "fantasy": 10,
      "standalone": 10,
      "character": 10,
      "medium": 8,
      "optimistic": 8,
      "plot": 10,
      "romance": 9,
      "magical": 10,
      "emotional": 10,
      "cozy": 8
    }
  },
  {
    "id": 1172,
    "title": "House of Earth and Blood",
    "author": "Sarah J. Maas",
    "publicationYear": 2020,
    "pageCount": 803,
    "rating": 4.45,
    "ratingsCount": 1142937,
    "series": {
      "name": "Crescent City",
      "position": 1
    },
    "awards": [
      "Goodreads Choice Award Fantasy (2020)"
    ],
    "categories": [
      "Fantasy",
      "Romance",
      "Urban Fantasy"
    ],
    "synopsis": "Half-Fae, half-human Bryce Quinlan seeks revenge for her best friend's murder in a world where humans and magical creatures coexist. Her investigation pulls her into a dangerous partnership with a notorious Fallen angel.",
    "scores": {
      "fantasy": 10,
      "romance": 9,
      "series": 10,
      "character": 9,
      "slow": 8,
      "dark": 8,
      "plot": 10,
      "emotional": 10,
      "magical": 9,
      "urban": 10
    }
  },
  {
    "id": 1173,
    "title": "House of Sky and Breath",
    "author": "Sarah J. Maas",
    "publicationYear": 2022,
    "pageCount": 768,
    "rating": 4.42,
    "ratingsCount": 824486,
    "series": {
      "name": "Crescent City",
      "position": 2
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Romance",
      "Urban Fantasy"
    ],
    "synopsis": "Bryce and Hunt navigate their new relationship while uncovering a rebel network fighting against the Asteri overlords. The secrets they uncover could change everything they know about their world.",
    "scores": {
      "fantasy": 10,
      "romance": 10,
      "series": 10,
      "character": 9,
      "medium": 8,
      "dark": 8,
      "plot": 10,
      "emotional": 9,
      "magical": 9,
      "urban": 10
    }
  },
  {
    "id": 1174,
    "title": "Empire of Storms",
    "author": "Sarah J. Maas",
    "publicationYear": 2016,
    "pageCount": 693,
    "rating": 4.63,
    "ratingsCount": 1211011,
    "series": {
      "name": "Throne of Glass",
      "position": 5
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Romance",
      "Young Adult"
    ],
    "synopsis": "Aelin Galathynius returns to her homeland to reclaim her throne, forging alliances and facing impossible choices as war erupts across the continent and ancient evils awaken.",
    "scores": {
      "fantasy": 10,
      "romance": 9,
      "series": 10,
      "character": 10,
      "fast": 9,
      "dark": 8,
      "plot": 10,
      "emotional": 10,
      "magical": 9,
      "epic": 10
    }
  },
  {
    "id": 1175,
    "title": "Tower of Dawn",
    "author": "Sarah J. Maas",
    "publicationYear": 2017,
    "pageCount": 660,
    "rating": 4.28,
    "ratingsCount": 1073579,
    "series": {
      "name": "Throne of Glass",
      "position": 6
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Romance",
      "Young Adult"
    ],
    "synopsis": "Chaol Westfall travels to a distant land to seek healing and military aid, discovering a new world of magic and a healer whose powers might save his body and soul.",
    "scores": {
      "fantasy": 10,
      "romance": 9,
      "series": 10,
      "character": 10,
      "medium": 8,
      "dark": 6,
      "plot": 9,
      "emotional": 10,
      "magical": 9,
      "worldbuilding": 9
    }
  },
  {
    "id": 1176,
    "title": "King of Scars",
    "author": "Leigh Bardugo",
    "publicationYear": 2019,
    "pageCount": 517,
    "rating": 4.16,
    "ratingsCount": 190724,
    "series": {
      "name": "King of Scars",
      "position": 1
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Young Adult"
    ],
    "synopsis": "Nikolai Lantsov must find a way to vanquish the darkness within him while unifying his country. But enemies are gathering, and a dangerous new threat emerges from the Fold.",
    "scores": {
      "fantasy": 10,
      "series": 10,
      "character": 10,
      "medium": 8,
      "dark": 8,
      "plot": 9,
      "emotional": 8,
      "magical": 9,
      "political": 8
    }
  },
  {
    "id": 1177,
    "title": "Before They Are Hanged",
    "author": "Joe Abercrombie",
    "publicationYear": 2007,
    "pageCount": 543,
    "rating": 4.36,
    "ratingsCount": 218478,
    "series": {
      "name": "The First Law",
      "position": 2
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Grimdark"
    ],
    "synopsis": "Three unlikely companions journey to the edge of the world seeking an ancient artifact, while war erupts across the Union and a torturer confronts his violent past.",
    "scores": {
      "fantasy": 10,
      "grimdark": 10,
      "series": 10,
      "character": 10,
      "medium": 8,
      "dark": 10,
      "plot": 9,
      "atmosphere": 10,
      "cynical": 10
    }
  },
  {
    "id": 1178,
    "title": "Last Argument of Kings",
    "author": "Joe Abercrombie",
    "publicationYear": 2008,
    "pageCount": 639,
    "rating": 4.36,
    "ratingsCount": 161428,
    "series": {
      "name": "The First Law",
      "position": 3
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Grimdark"
    ],
    "synopsis": "The war reaches its bloody conclusion as all threads converge. Heroes fall, villains rise, and nothing ends the way anyone expects in this explosive finale.",
    "scores": {
      "fantasy": 10,
      "grimdark": 10,
      "series": 10,
      "character": 10,
      "fast": 9,
      "dark": 10,
      "plot": 10,
      "atmosphere": 10,
      "cynical": 10,
      "emotional": 9
    }
  },
  {
    "id": 1179,
    "title": "Best Served Cold",
    "author": "Joe Abercrombie",
    "publicationYear": 2009,
    "pageCount": 640,
    "rating": 4.24,
    "ratingsCount": 109839,
    "awards": [],
    "categories": [
      "Fantasy",
      "Grimdark"
    ],
    "synopsis": "A mercenary general left for dead crawls from a mass grave with one purpose: revenge against the seven men who betrayed her. A tale of vengeance served with gleeful brutality.",
    "scores": {
      "fantasy": 10,
      "grimdark": 10,
      "standalone": 10,
      "character": 9,
      "fast": 9,
      "dark": 10,
      "plot": 9,
      "atmosphere": 9,
      "cynical": 9
    }
  },
  {
    "id": 1180,
    "title": "The Heroes",
    "author": "Joe Abercrombie",
    "publicationYear": 2011,
    "pageCount": 528,
    "rating": 4.34,
    "ratingsCount": 60634,
    "awards": [],
    "categories": [
      "Fantasy",
      "Grimdark"
    ],
    "synopsis": "Three days of battle for a worthless patch of land. Told from multiple perspectives on both sides, this unflinching war novel shows the futility and horror of combat.",
    "scores": {
      "fantasy": 10,
      "grimdark": 10,
      "standalone": 10,
      "character": 10,
      "fast": 9,
      "dark": 10,
      "plot": 9,
      "atmosphere": 10,
      "cynical": 10
    }
  },
  {
    "id": 1181,
    "title": "A Little Hatred",
    "author": "Joe Abercrombie",
    "publicationYear": 2019,
    "pageCount": 480,
    "rating": 4.45,
    "ratingsCount": 60670,
    "series": {
      "name": "The Age of Madness",
      "position": 1
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Grimdark"
    ],
    "synopsis": "A new generation inherits the sins of their parents as the industrial revolution transforms the First Law world. Revolution brews while old hatreds die hard.",
    "scores": {
      "fantasy": 10,
      "grimdark": 10,
      "series": 10,
      "character": 10,
      "medium": 8,
      "dark": 10,
      "plot": 10,
      "atmosphere": 10,
      "political": 9
    }
  },
  {
    "id": 1182,
    "title": "The Wisdom of Crowds",
    "author": "Joe Abercrombie",
    "publicationYear": 2021,
    "pageCount": 528,
    "rating": 4.6,
    "ratingsCount": 38812,
    "series": {
      "name": "The Age of Madness",
      "position": 3
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Grimdark"
    ],
    "synopsis": "Revolution has swept the Union. As chaos consumes the Circle of the World, every character must face the ultimate consequences of their choices in this devastating finale.",
    "scores": {
      "fantasy": 10,
      "grimdark": 10,
      "series": 10,
      "character": 10,
      "fast": 9,
      "dark": 10,
      "plot": 10,
      "atmosphere": 10,
      "political": 10,
      "emotional": 10
    }
  },
  {
    "id": 1183,
    "title": "Red Seas Under Red Skies",
    "author": "Scott Lynch",
    "publicationYear": 2007,
    "pageCount": 558,
    "rating": 4.25,
    "ratingsCount": 160410,
    "series": {
      "name": "Gentleman Bastard",
      "position": 2
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Heist"
    ],
    "synopsis": "Locke and Jean scheme to rob the greatest gambling house in the world, only to be conscripted into piracy on the high seas. Betrayals multiply as their carefully laid plans unravel.",
    "scores": {
      "fantasy": 10,
      "heist": 10,
      "series": 10,
      "character": 10,
      "medium": 8,
      "dark": 7,
      "plot": 9,
      "atmosphere": 9,
      "witty": 10
    }
  },
  {
    "id": 1184,
    "title": "Knife of Dreams",
    "author": "Robert Jordan",
    "publicationYear": 2005,
    "pageCount": 837,
    "rating": 4.2,
    "ratingsCount": 147736,
    "series": {
      "name": "The Wheel of Time",
      "position": 11
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "synopsis": "The threads begin to converge as long-delayed plot lines advance. Mat's rescue of Tuon continues, Perrin finally closes in on Faile, and Rand prepares for the Last Battle.",
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "series": 10,
      "worldbuilding": 10,
      "character": 9,
      "medium": 8,
      "plot": 9,
      "atmosphere": 9,
      "emotional": 8
    }
  },
  {
    "id": 1185,
    "title": "The Gathering Storm",
    "author": "Robert Jordan, Brandon Sanderson",
    "publicationYear": 2009,
    "pageCount": 766,
    "rating": 4.41,
    "ratingsCount": 148916,
    "series": {
      "name": "The Wheel of Time",
      "position": 12
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "synopsis": "Rand al'Thor teeters on the edge of madness as Tarmon Gai'don approaches. Egwene wages war to unite the White Tower while darkness spreads across the land.",
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "series": 10,
      "worldbuilding": 10,
      "character": 10,
      "medium": 8,
      "plot": 10,
      "atmosphere": 9,
      "emotional": 10,
      "dark": 8
    }
  },
  {
    "id": 1186,
    "title": "Towers of Midnight",
    "author": "Robert Jordan, Brandon Sanderson",
    "publicationYear": 2010,
    "pageCount": 843,
    "rating": 4.48,
    "ratingsCount": 175295,
    "series": {
      "name": "The Wheel of Time",
      "position": 13
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "synopsis": "Perrin must choose between hammer and axe as the world prepares for the Last Battle. Mat finally breaks free of prophecy, and Rand comes to terms with his destiny.",
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "series": 10,
      "worldbuilding": 10,
      "character": 10,
      "fast": 8,
      "plot": 10,
      "atmosphere": 9,
      "emotional": 10
    }
  },
  {
    "id": 1187,
    "title": "The Princess Bride",
    "author": "William Goldman",
    "publicationYear": 1973,
    "pageCount": 456,
    "rating": 4.27,
    "ratingsCount": 949498,
    "awards": [],
    "categories": [
      "Fantasy",
      "Romance",
      "Classic"
    ],
    "synopsis": "A tale of true love and high adventure featuring fencing, fighting, torture, revenge, giants, monsters, chases, escapes, miracles, and a love story that transcends time.",
    "scores": {
      "fantasy": 9,
      "romance": 9,
      "classic": 10,
      "character": 10,
      "fast": 9,
      "optimistic": 9,
      "plot": 10,
      "witty": 10,
      "emotional": 8
    }
  },
  {
    "id": 1188,
    "title": "Eragon",
    "author": "Christopher Paolini",
    "publicationYear": 2003,
    "pageCount": 544,
    "rating": 3.97,
    "ratingsCount": 1945681,
    "series": {
      "name": "The Inheritance Cycle",
      "position": 1
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Young Adult",
      "Dragons"
    ],
    "synopsis": "When a farm boy named Eragon discovers a mysterious blue stone that hatches into a dragon, he becomes the first in a new generation of Dragon Riders destined to battle an evil king.",
    "scores": {
      "fantasy": 10,
      "ya": 10,
      "series": 10,
      "character": 8,
      "fast": 9,
      "optimistic": 8,
      "plot": 9,
      "magical": 10,
      "adventure": 10
    }
  },
  {
    "id": 1189,
    "title": "The Golden Compass",
    "author": "Philip Pullman",
    "publicationYear": 1995,
    "pageCount": 399,
    "rating": 4.03,
    "ratingsCount": 1610968,
    "series": {
      "name": "His Dark Materials",
      "position": 1
    },
    "awards": [
      "Carnegie Medal (1995)"
    ],
    "categories": [
      "Fantasy",
      "Young Adult",
      "Classic"
    ],
    "synopsis": "In a world where people's souls take the form of animal companions, Lyra embarks on a dangerous journey to the frozen North to rescue kidnapped children and uncover a sinister conspiracy.",
    "scores": {
      "fantasy": 10,
      "ya": 10,
      "series": 10,
      "character": 9,
      "medium": 8,
      "dark": 7,
      "plot": 10,
      "worldbuilding": 10,
      "philosophical": 9
    }
  },
  {
    "id": 1190,
    "title": "Royal Assassin",
    "author": "Robin Hobb",
    "publicationYear": 1996,
    "pageCount": 675,
    "rating": 4.29,
    "ratingsCount": 244037,
    "series": {
      "name": "The Farseer Trilogy",
      "position": 2
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "synopsis": "FitzChivalry Farseer continues his training as a royal assassin while political intrigue threatens to tear apart the Six Duchies from within as the Red Ships attack from without.",
    "scores": {
      "fantasy": 10,
      "epic": 9,
      "series": 10,
      "character": 10,
      "slow": 8,
      "dark": 8,
      "plot": 9,
      "emotional": 10,
      "atmosphere": 10
    }
  },
  {
    "id": 1191,
    "title": "The Gunslinger",
    "author": "Stephen King",
    "publicationYear": 1982,
    "pageCount": 224,
    "rating": 3.91,
    "ratingsCount": 665022,
    "series": {
      "name": "The Dark Tower",
      "position": 1
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Horror",
      "Western"
    ],
    "synopsis": "The man in black fled across the desert, and the gunslinger followed. Roland's quest for the Dark Tower begins in this haunting blend of fantasy, horror, and western mythology.",
    "scores": {
      "fantasy": 9,
      "horror": 7,
      "series": 10,
      "character": 9,
      "slow": 8,
      "dark": 9,
      "atmosphere": 10,
      "literary": 9,
      "mysterious": 10
    }
  },
  {
    "id": 1193,
    "title": "Animal Farm",
    "author": "George Orwell",
    "publicationYear": 1945,
    "pageCount": 112,
    "rating": 4.02,
    "ratingsCount": 4579807,
    "awards": [
      "Prometheus Hall of Fame Award (2011)"
    ],
    "categories": [
      "Classic",
      "Literary Fiction",
      "Political"
    ],
    "synopsis": "A farm is taken over by its overworked, mistreated animals in this allegorical tale about power, corruption, and the betrayal of revolutionary ideals.",
    "scores": {
      "classic": 10,
      "literary": 10,
      "political": 10,
      "character": 8,
      "fast": 10,
      "dark": 9,
      "allegory": 10,
      "mind": 10,
      "emotional": 7
    }
  },
  {
    "id": 1194,
    "title": "Jurassic Park",
    "author": "Michael Crichton",
    "publicationYear": 1990,
    "pageCount": 448,
    "rating": 4.13,
    "ratingsCount": 1065244,
    "awards": [],
    "categories": [
      "Science Fiction",
      "Thriller"
    ],
    "synopsis": "A billionaire creates a theme park populated with genetically engineered dinosaurs. When the park's security systems fail, the prehistoric predators are unleashed on the unsuspecting visitors.",
    "scores": {
      "scifi": 10,
      "thriller": 10,
      "character": 8,
      "fast": 10,
      "dark": 7,
      "plot": 10,
      "action": 10,
      "mind": 8
    }
  },
  {
    "id": 1195,
    "title": "Starship Troopers",
    "author": "Robert A. Heinlein",
    "publicationYear": 1959,
    "pageCount": 263,
    "rating": 4.01,
    "ratingsCount": 246955,
    "awards": [
      "Hugo Award for Best Novel (1960)"
    ],
    "categories": [
      "Science Fiction",
      "Military",
      "Classic"
    ],
    "synopsis": "A young soldier in the Mobile Infantry fights against alien bugs across the galaxy in this controversial classic that examines war, citizenship, and military service.",
    "scores": {
      "scifi": 10,
      "military": 10,
      "classic": 10,
      "character": 8,
      "fast": 8,
      "dark": 6,
      "plot": 8,
      "action": 9,
      "philosophical": 9
    }
  },
  {
    "id": 1196,
    "title": "Ender's Shadow",
    "author": "Orson Scott Card",
    "publicationYear": 1999,
    "pageCount": 469,
    "rating": 4.32,
    "ratingsCount": 180229,
    "series": {
      "name": "The Shadow Series",
      "position": 1
    },
    "awards": [],
    "categories": [
      "Science Fiction",
      "Young Adult"
    ],
    "synopsis": "The events of Ender's Game retold from the perspective of Bean, a brilliant street urchin who becomes one of Ender's closest allies at Battle School.",
    "scores": {
      "scifi": 10,
      "ya": 9,
      "series": 10,
      "character": 10,
      "fast": 8,
      "dark": 7,
      "plot": 10,
      "mind": 10,
      "emotional": 9
    }
  },
  {
    "id": 1197,
    "title": "Cat's Cradle",
    "author": "Kurt Vonnegut Jr.",
    "publicationYear": 1963,
    "pageCount": 287,
    "rating": 4.15,
    "ratingsCount": 438310,
    "awards": [],
    "categories": [
      "Science Fiction",
      "Literary Fiction",
      "Satire"
    ],
    "synopsis": "A journalist researching the atomic bomb discovers ice-nine, a substance that could freeze all water on Earth, in this satirical exploration of science, religion, and the absurdity of life.",
    "scores": {
      "scifi": 9,
      "literary": 10,
      "satire": 10,
      "character": 8,
      "fast": 8,
      "dark": 8,
      "plot": 8,
      "mind": 10,
      "witty": 10
    }
  },
  {
    "id": 1198,
    "title": "Childhood's End",
    "author": "Arthur C. Clarke",
    "publicationYear": 1953,
    "pageCount": 212,
    "rating": 4.12,
    "ratingsCount": 174068,
    "awards": [],
    "categories": [
      "Science Fiction",
      "Classic"
    ],
    "synopsis": "Benevolent alien Overlords bring peace and prosperity to Earth, but at what cost? Humanity must confront its own evolution and ultimate destiny.",
    "scores": {
      "scifi": 10,
      "classic": 10,
      "character": 7,
      "slow": 7,
      "dark": 7,
      "plot": 9,
      "mind": 10,
      "philosophical": 10,
      "atmospheric": 9
    }
  },
  {
    "id": 1201,
    "title": "Dragonflight",
    "author": "Anne McCaffrey",
    "publicationYear": 1968,
    "pageCount": 303,
    "rating": 4.08,
    "ratingsCount": 143995,
    "series": {
      "name": "Pern",
      "position": 1
    },
    "awards": [
      "Hugo Award for Best Novella (1968)"
    ],
    "categories": [
      "Fantasy",
      "Science Fiction",
      "Dragons"
    ],
    "synopsis": "On the planet Pern, telepathic dragons and their riders are humanity's only defense against the deadly Thread that falls from the sky.",
    "scores": {
      "fantasy": 10,
      "scifi": 8,
      "series": 10,
      "character": 9,
      "medium": 8,
      "dark": 5,
      "plot": 9,
      "dragons": 10,
      "romantic": 7
    }
  },
  {
    "id": 1202,
    "title": "Contact",
    "author": "Carl Sagan",
    "publicationYear": 1985,
    "pageCount": 432,
    "rating": 4.15,
    "ratingsCount": 152876,
    "awards": [],
    "categories": [
      "Science Fiction",
      "Literary Fiction"
    ],
    "synopsis": "When scientist Ellie Arroway receives a message from the star Vega, humanity must confront its beliefs about science, faith, and our place in the universe.",
    "scores": {
      "scifi": 10,
      "literary": 9,
      "character": 9,
      "slow": 7,
      "optimistic": 8,
      "plot": 9,
      "mind": 10,
      "philosophical": 10,
      "emotional": 8
    }
  },
  {
    "id": 1203,
    "title": "The Godfather",
    "author": "Mario Puzo",
    "publicationYear": 1969,
    "pageCount": 448,
    "rating": 4.4,
    "ratingsCount": 466153,
    "awards": [],
    "categories": [
      "Crime",
      "Classic",
      "Thriller"
    ],
    "synopsis": "The epic story of the Corleone family, Italian-American immigrants who build a criminal empire in post-war America. A tale of power, loyalty, and the cost of the American Dream.",
    "scores": {
      "crime": 10,
      "classic": 10,
      "character": 10,
      "medium": 8,
      "dark": 9,
      "plot": 10,
      "family": 10,
      "emotional": 9
    }
  },
  {
    "id": 1204,
    "title": "Mystic River",
    "author": "Dennis Lehane",
    "publicationYear": 2001,
    "pageCount": 401,
    "rating": 4.18,
    "ratingsCount": 166126,
    "awards": [],
    "categories": [
      "Mystery",
      "Thriller",
      "Literary Fiction"
    ],
    "synopsis": "When a murder brings three childhood friends back together, the dark secrets of their past threaten to destroy their lives and the families they've built.",
    "scores": {
      "mystery": 10,
      "thriller": 9,
      "literary": 10,
      "character": 10,
      "slow": 7,
      "dark": 10,
      "plot": 10,
      "emotional": 10
    }
  },
  {
    "id": 1205,
    "title": "Shutter Island",
    "author": "Dennis Lehane",
    "publicationYear": 2003,
    "pageCount": 369,
    "rating": 4.14,
    "ratingsCount": 227283,
    "awards": [],
    "categories": [
      "Thriller",
      "Mystery",
      "Psychological"
    ],
    "synopsis": "U.S. Marshal Teddy Daniels investigates the disappearance of a patient from a hospital for the criminally insane on a remote island, but nothing is what it seems.",
    "scores": {
      "thriller": 10,
      "mystery": 10,
      "psychological": 10,
      "character": 9,
      "medium": 8,
      "dark": 9,
      "plot": 10,
      "mind": 10
    }
  },
  {
    "id": 1206,
    "title": "Red Dragon",
    "author": "Thomas Harris",
    "publicationYear": 1981,
    "pageCount": 348,
    "rating": 4.07,
    "ratingsCount": 374461,
    "series": {
      "name": "Hannibal Lecter",
      "position": 1
    },
    "awards": [],
    "categories": [
      "Thriller",
      "Horror",
      "Crime"
    ],
    "synopsis": "FBI profiler Will Graham must seek help from the brilliant, cannibalistic psychiatrist Hannibal Lecter to catch a serial killer known as the Tooth Fairy.",
    "scores": {
      "thriller": 10,
      "horror": 9,
      "series": 10,
      "character": 10,
      "medium": 8,
      "dark": 10,
      "plot": 10,
      "psychological": 10
    }
  },
  {
    "id": 1207,
    "title": "The Alienist",
    "author": "Caleb Carr",
    "publicationYear": 1994,
    "pageCount": 496,
    "rating": 4.06,
    "ratingsCount": 181743,
    "series": {
      "name": "Dr. Laszlo Kreizler",
      "position": 1
    },
    "awards": [],
    "categories": [
      "Historical Fiction",
      "Mystery",
      "Thriller"
    ],
    "synopsis": "In 1896 New York, a criminal psychologist and a newspaper reporter team up to track a serial killer using revolutionary psychological profiling techniques.",
    "scores": {
      "historical": 10,
      "mystery": 10,
      "thriller": 9,
      "character": 9,
      "slow": 7,
      "dark": 9,
      "plot": 9,
      "atmosphere": 10
    }
  },
  {
    "id": 1208,
    "title": "The Bone Collector",
    "author": "Jeffery Deaver",
    "publicationYear": 1997,
    "pageCount": 432,
    "rating": 4.2,
    "ratingsCount": 196129,
    "series": {
      "name": "Lincoln Rhyme",
      "position": 1
    },
    "awards": [],
    "categories": [
      "Thriller",
      "Mystery",
      "Crime"
    ],
    "synopsis": "Quadriplegic forensics expert Lincoln Rhyme teams up with patrol cop Amelia Sachs to catch a serial killer who leaves cryptic clues at each crime scene.",
    "scores": {
      "thriller": 10,
      "mystery": 10,
      "series": 9,
      "character": 9,
      "fast": 9,
      "dark": 8,
      "plot": 10,
      "procedural": 10
    }
  },
  {
    "id": 1209,
    "title": "Murder on the Orient Express",
    "author": "Agatha Christie",
    "publicationYear": 1934,
    "pageCount": 256,
    "rating": 4.2,
    "ratingsCount": 736433,
    "series": {
      "name": "Hercule Poirot",
      "position": 10
    },
    "awards": [],
    "categories": [
      "Mystery",
      "Classic",
      "Crime"
    ],
    "synopsis": "Detective Hercule Poirot must solve a murder on a snowbound train where everyone has both an alibi and a motive in Christie's most famous mystery.",
    "scores": {
      "mystery": 10,
      "classic": 10,
      "character": 9,
      "fast": 9,
      "plot": 10,
      "witty": 8,
      "clever": 10
    }
  },
  {
    "id": 1210,
    "title": "Hidden Pictures",
    "author": "Jason Rekulak",
    "publicationYear": 2022,
    "pageCount": 368,
    "rating": 4.14,
    "ratingsCount": 602965,
    "awards": [],
    "categories": [
      "Thriller",
      "Horror",
      "Mystery"
    ],
    "synopsis": "A recovering addict working as a nanny discovers the child she cares for is drawing disturbing pictures that seem to depict a decades-old murder.",
    "scores": {
      "thriller": 10,
      "horror": 8,
      "mystery": 9,
      "character": 9,
      "fast": 9,
      "dark": 8,
      "plot": 10,
      "creepy": 9
    }
  },
  {
    "id": 1211,
    "title": "Perfume: The Story of a Murderer",
    "author": "Patrick Süskind",
    "publicationYear": 1985,
    "pageCount": 263,
    "rating": 4.04,
    "ratingsCount": 557084,
    "awards": [],
    "categories": [
      "Horror",
      "Literary Fiction",
      "Historical Fiction"
    ],
    "synopsis": "In 18th century France, a man born with no personal scent but an extraordinary sense of smell becomes obsessed with creating the perfect perfume, no matter the cost.",
    "scores": {
      "horror": 9,
      "literary": 10,
      "historical": 9,
      "character": 8,
      "slow": 7,
      "dark": 10,
      "atmosphere": 10,
      "sensory": 10
    }
  },
  {
    "id": 1212,
    "title": "Great Expectations",
    "author": "Charles Dickens",
    "publicationYear": 1861,
    "pageCount": 544,
    "rating": 3.8,
    "ratingsCount": 876629,
    "awards": [],
    "categories": [
      "Classic",
      "Literary Fiction"
    ],
    "synopsis": "Orphan Pip's life is transformed when a mysterious benefactor funds his transformation into a gentleman, but the source of his fortune proves devastating.",
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 10,
      "slow": 8,
      "dark": 6,
      "plot": 9,
      "emotional": 9,
      "atmospheric": 9
    }
  },
  {
    "id": 1213,
    "title": "A Christmas Carol",
    "author": "Charles Dickens",
    "publicationYear": 1843,
    "pageCount": 104,
    "rating": 4.09,
    "ratingsCount": 942851,
    "awards": [],
    "categories": [
      "Classic",
      "Fantasy",
      "Holiday"
    ],
    "synopsis": "Miserly Ebenezer Scrooge is visited by three spirits on Christmas Eve who show him the error of his ways in this timeless tale of redemption.",
    "scores": {
      "classic": 10,
      "fantasy": 7,
      "character": 10,
      "fast": 10,
      "optimistic": 10,
      "plot": 9,
      "emotional": 10,
      "heartwarming": 10
    }
  },
  {
    "id": 1214,
    "title": "The Importance of Being Earnest",
    "author": "Oscar Wilde",
    "publicationYear": 1895,
    "pageCount": 76,
    "rating": 4.17,
    "ratingsCount": 406892,
    "awards": [],
    "categories": [
      "Classic",
      "Comedy",
      "Play"
    ],
    "synopsis": "Two men lead double lives to escape social obligations, leading to comic chaos when their deceptions collide in this sparkling satire of Victorian society.",
    "scores": {
      "classic": 10,
      "comedy": 10,
      "character": 9,
      "fast": 10,
      "optimistic": 9,
      "witty": 10,
      "satirical": 10
    }
  },
  {
    "id": 1215,
    "title": "Treasure Island",
    "author": "Robert Louis Stevenson",
    "publicationYear": 1883,
    "pageCount": 311,
    "rating": 3.85,
    "ratingsCount": 542335,
    "awards": [],
    "categories": [
      "Classic",
      "Adventure",
      "Young Adult"
    ],
    "synopsis": "Young Jim Hawkins discovers a treasure map and embarks on a perilous voyage with Long John Silver and a crew of pirates in this quintessential adventure tale.",
    "scores": {
      "classic": 10,
      "adventure": 10,
      "ya": 9,
      "character": 9,
      "fast": 9,
      "optimistic": 7,
      "plot": 10,
      "pirates": 10
    }
  },
  {
    "id": 1216,
    "title": "The Three Musketeers",
    "author": "Alexandre Dumas",
    "publicationYear": 1844,
    "pageCount": 720,
    "rating": 4.1,
    "ratingsCount": 347653,
    "series": {
      "name": "The D'Artagnan Romances",
      "position": 1
    },
    "awards": [],
    "categories": [
      "Classic",
      "Adventure",
      "Historical Fiction"
    ],
    "synopsis": "Young d'Artagnan journeys to Paris to join the Musketeers and becomes embroiled in political intrigue alongside his new friends Athos, Porthos, and Aramis.",
    "scores": {
      "classic": 10,
      "adventure": 10,
      "historical": 9,
      "character": 10,
      "medium": 8,
      "optimistic": 8,
      "plot": 10,
      "swashbuckling": 10
    }
  },
  {
    "id": 1217,
    "title": "Alice's Adventures in Wonderland",
    "author": "Lewis Carroll",
    "publicationYear": 1865,
    "pageCount": 96,
    "rating": 4.06,
    "ratingsCount": 610975,
    "awards": [],
    "categories": [
      "Classic",
      "Fantasy",
      "Children's"
    ],
    "synopsis": "Alice falls down a rabbit hole into a world of nonsense and wonder, encountering the Cheshire Cat, Mad Hatter, and Queen of Hearts.",
    "scores": {
      "classic": 10,
      "fantasy": 10,
      "character": 9,
      "fast": 9,
      "whimsical": 10,
      "surreal": 10,
      "imaginative": 10
    }
  },
  {
    "id": 1218,
    "title": "The Red Tent",
    "author": "Anita Diamant",
    "publicationYear": 1997,
    "pageCount": 321,
    "rating": 4.21,
    "ratingsCount": 633060,
    "awards": [],
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "synopsis": "The biblical story of Dinah, daughter of Jacob, retold from her perspective, exploring the lives, loves, and traditions of the women of the Old Testament.",
    "scores": {
      "historical": 10,
      "literary": 9,
      "character": 10,
      "slow": 7,
      "emotional": 10,
      "family": 10,
      "feminist": 9
    }
  },
  {
    "id": 1219,
    "title": "The Clan of the Cave Bear",
    "author": "Jean M. Auel",
    "publicationYear": 1980,
    "pageCount": 468,
    "rating": 4.1,
    "ratingsCount": 283388,
    "series": {
      "name": "Earth's Children",
      "position": 1
    },
    "awards": [],
    "categories": [
      "Historical Fiction",
      "Adventure"
    ],
    "synopsis": "A young Cro-Magnon girl is adopted by a clan of Neanderthals and struggles to find her place between two worlds in prehistoric Europe.",
    "scores": {
      "historical": 10,
      "adventure": 9,
      "series": 9,
      "character": 10,
      "slow": 8,
      "educational": 9,
      "survival": 10
    }
  },
  {
    "id": 1220,
    "title": "Dragonfly in Amber",
    "author": "Diana Gabaldon",
    "publicationYear": 1992,
    "pageCount": 743,
    "rating": 4.34,
    "ratingsCount": 386214,
    "series": {
      "name": "Outlander",
      "position": 2
    },
    "awards": [],
    "categories": [
      "Historical Fiction",
      "Romance",
      "Fantasy"
    ],
    "synopsis": "Claire returns to the 20th century and reveals to her daughter the truth about her time-traveling adventures with Jamie Fraser in 18th century Scotland.",
    "scores": {
      "historical": 10,
      "romance": 10,
      "fantasy": 8,
      "series": 10,
      "character": 10,
      "slow": 8,
      "emotional": 10,
      "epic": 9
    }
  },
  {
    "id": 1221,
    "title": "The Guernsey Literary and Potato Peel Pie Society",
    "author": "Mary Ann Shaffer, Annie Barrows",
    "publicationYear": 2008,
    "pageCount": 277,
    "rating": 4.19,
    "ratingsCount": 813144,
    "awards": [],
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "synopsis": "Through letters, a London writer discovers the remarkable story of a book club formed during the Nazi occupation of Guernsey during World War II.",
    "scores": {
      "historical": 10,
      "literary": 9,
      "character": 10,
      "medium": 8,
      "optimistic": 9,
      "heartwarming": 10,
      "epistolary": 10
    }
  },
  {
    "id": 1222,
    "title": "Roots: The Saga of an American Family",
    "author": "Alex Haley",
    "publicationYear": 1976,
    "pageCount": 729,
    "rating": 4.45,
    "ratingsCount": 164985,
    "awards": [
      "Pulitzer Prize Special Award (1977)"
    ],
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "synopsis": "The epic story of Kunta Kinte, an African captured into slavery, and seven generations of his descendants in America.",
    "scores": {
      "historical": 10,
      "literary": 10,
      "character": 10,
      "slow": 8,
      "dark": 9,
      "emotional": 10,
      "epic": 10,
      "family": 10
    }
  },
  {
    "id": 1223,
    "title": "I, Claudius",
    "author": "Robert Graves",
    "publicationYear": 1934,
    "pageCount": 468,
    "rating": 4.24,
    "ratingsCount": 73363,
    "series": {
      "name": "Claudius",
      "position": 1
    },
    "awards": [],
    "categories": [
      "Historical Fiction",
      "Classic"
    ],
    "synopsis": "The autobiography of the Roman Emperor Claudius, dismissed as a fool, who survived the reigns of Augustus, Tiberius, and Caligula through seeming insignificance.",
    "scores": {
      "historical": 10,
      "classic": 10,
      "character": 10,
      "slow": 7,
      "dark": 8,
      "plot": 10,
      "political": 10
    }
  },
  {
    "id": 1224,
    "title": "Year of Wonders",
    "author": "Geraldine Brooks",
    "publicationYear": 2001,
    "pageCount": 327,
    "rating": 4.01,
    "ratingsCount": 175895,
    "awards": [],
    "categories": [
      "Historical Fiction",
      "Literary Fiction"
    ],
    "synopsis": "In 1666, a plague-stricken English village chooses to quarantine itself. A young housemaid emerges as an unlikely leader as death claims her neighbors.",
    "scores": {
      "historical": 10,
      "literary": 9,
      "character": 10,
      "slow": 7,
      "dark": 9,
      "emotional": 10,
      "atmospheric": 10
    }
  },
  {
    "id": 1225,
    "title": "The Little Prince",
    "author": "Antoine de Saint-Exupéry",
    "publicationYear": 1943,
    "pageCount": 96,
    "rating": 4.33,
    "ratingsCount": 2493293,
    "awards": [],
    "categories": [
      "Classic",
      "Fantasy",
      "Children's"
    ],
    "synopsis": "A pilot stranded in the desert meets a young prince from a tiny asteroid who shares wisdom about love, loss, and what truly matters in life.",
    "scores": {
      "classic": 10,
      "fantasy": 8,
      "character": 10,
      "fast": 10,
      "optimistic": 9,
      "philosophical": 10,
      "emotional": 10,
      "whimsical": 10
    }
  },
  {
    "id": 1226,
    "title": "Hamlet",
    "author": "William Shakespeare",
    "publicationYear": 1603,
    "pageCount": 342,
    "rating": 4.03,
    "ratingsCount": 1055980,
    "awards": [],
    "categories": [
      "Classic",
      "Play",
      "Tragedy"
    ],
    "synopsis": "The Prince of Denmark struggles with grief, betrayal, and the moral weight of revenge after his father's ghost reveals he was murdered by his own brother.",
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 10,
      "slow": 7,
      "dark": 10,
      "plot": 10,
      "emotional": 10,
      "philosophical": 10
    }
  },
  {
    "id": 1227,
    "title": "The Lion, the Witch and the Wardrobe",
    "author": "C.S. Lewis",
    "publicationYear": 1950,
    "pageCount": 206,
    "rating": 4.24,
    "ratingsCount": 3161537,
    "series": {
      "name": "The Chronicles of Narnia",
      "position": 1
    },
    "awards": [
      "Carnegie Medal (1956)"
    ],
    "categories": [
      "Fantasy",
      "Children's",
      "Classic"
    ],
    "synopsis": "Four siblings discover a magical world through a wardrobe and join the lion Aslan in his fight against the White Witch who has cursed Narnia to eternal winter.",
    "scores": {
      "fantasy": 10,
      "classic": 10,
      "series": 10,
      "character": 9,
      "fast": 9,
      "optimistic": 10,
      "magical": 10,
      "allegorical": 9
    }
  },
  {
    "id": 1228,
    "title": "A Tree Grows in Brooklyn",
    "author": "Betty Smith",
    "publicationYear": 1943,
    "pageCount": 493,
    "rating": 4.3,
    "ratingsCount": 514524,
    "awards": [],
    "categories": [
      "Classic",
      "Literary Fiction",
      "Coming of Age"
    ],
    "synopsis": "Francie Nolan grows up in poverty in early 20th-century Brooklyn, finding solace in education and the public library as she dreams of a better life.",
    "scores": {
      "classic": 10,
      "literary": 10,
      "character": 10,
      "slow": 8,
      "optimistic": 8,
      "emotional": 10,
      "coming_of_age": 10
    }
  },
  {
    "id": 1229,
    "title": "Love in the Time of Cholera",
    "author": "Gabriel García Márquez",
    "publicationYear": 1985,
    "pageCount": 368,
    "rating": 3.94,
    "ratingsCount": 548587,
    "awards": [],
    "categories": [
      "Literary Fiction",
      "Romance",
      "Classic"
    ],
    "synopsis": "Florentino Ariza waits fifty years for his true love, Fermina Daza, in this sweeping tale of passion, obsession, and the endurance of love.",
    "scores": {
      "literary": 10,
      "romance": 10,
      "classic": 10,
      "character": 10,
      "slow": 8,
      "emotional": 10,
      "atmospheric": 10
    }
  },
  {
    "id": 1230,
    "title": "The Giving Tree",
    "author": "Shel Silverstein",
    "publicationYear": 1964,
    "pageCount": 64,
    "rating": 4.39,
    "ratingsCount": 1239071,
    "awards": [],
    "categories": [
      "Children's",
      "Classic"
    ],
    "synopsis": "A tree gives everything it has to a boy throughout his life in this poignant tale about love, sacrifice, and the relationship between giving and taking.",
    "scores": {
      "classic": 10,
      "character": 9,
      "fast": 10,
      "emotional": 10,
      "philosophical": 9,
      "heartbreaking": 10
    }
  },
  {
    "id": 1231,
    "title": "Green Eggs and Ham",
    "author": "Dr. Seuss",
    "publicationYear": 1960,
    "pageCount": 62,
    "rating": 4.32,
    "ratingsCount": 849176,
    "awards": [],
    "categories": [
      "Children's",
      "Classic"
    ],
    "synopsis": "Sam-I-Am persistently offers green eggs and ham to a grumpy character who refuses to try them, in this beloved tale about keeping an open mind.",
    "scores": {
      "classic": 10,
      "fast": 10,
      "optimistic": 10,
      "whimsical": 10,
      "humorous": 10
    }
  },
  {
    "id": 1232,
    "title": "V for Vendetta",
    "author": "Alan Moore, David Lloyd",
    "publicationYear": 1988,
    "pageCount": 296,
    "rating": 4.26,
    "ratingsCount": 325643,
    "awards": [],
    "categories": [
      "Graphic Novel",
      "Dystopian",
      "Science Fiction"
    ],
    "synopsis": "In a totalitarian Britain, a mysterious masked anarchist known as V wages war against the government, inspiring a young woman to join the resistance.",
    "scores": {
      "graphic_novel": 10,
      "dystopian": 10,
      "political": 10,
      "character": 10,
      "medium": 8,
      "dark": 10,
      "plot": 10,
      "philosophical": 10
    }
  },
  {
    "id": 1233,
    "title": "Watchmen",
    "author": "Alan Moore, Dave Gibbons",
    "publicationYear": 1987,
    "pageCount": 416,
    "rating": 4.39,
    "ratingsCount": 595748,
    "awards": [
      "Hugo Award Special Category (1988)"
    ],
    "categories": [
      "Graphic Novel",
      "Superhero",
      "Science Fiction"
    ],
    "synopsis": "In an alternate 1985 where costumed heroes exist, a retired vigilante investigates the murder of a former colleague, uncovering a conspiracy that threatens the world.",
    "scores": {
      "graphic_novel": 10,
      "superhero": 10,
      "character": 10,
      "slow": 7,
      "dark": 10,
      "plot": 10,
      "philosophical": 10,
      "deconstruction": 10
    }
  },
  {
    "id": 1234,
    "title": "Unwind",
    "author": "Neal Shusterman",
    "publicationYear": 2007,
    "pageCount": 335,
    "rating": 4.17,
    "ratingsCount": 249910,
    "series": {
      "name": "Unwind Dystology",
      "position": 1
    },
    "awards": [],
    "categories": [
      "Young Adult",
      "Dystopian",
      "Science Fiction"
    ],
    "synopsis": "In a future where unwanted teens can be 'unwound' and their body parts harvested, three runaway kids fight for survival and their right to live.",
    "scores": {
      "ya": 10,
      "dystopian": 10,
      "series": 9,
      "character": 9,
      "fast": 9,
      "dark": 10,
      "plot": 10,
      "thought_provoking": 10
    }
  },
  {
    "id": 1235,
    "title": "Wool",
    "author": "Hugh Howey",
    "publicationYear": 2011,
    "pageCount": 509,
    "rating": 4.23,
    "ratingsCount": 277851,
    "series": {
      "name": "Silo",
      "position": 1
    },
    "awards": [],
    "categories": [
      "Science Fiction",
      "Dystopian",
      "Post-Apocalyptic"
    ],
    "synopsis": "In a post-apocalyptic world, the last of humanity lives in a massive underground silo governed by strict rules. When a mechanic discovers forbidden secrets, everything changes.",
    "scores": {
      "scifi": 10,
      "dystopian": 10,
      "series": 10,
      "character": 9,
      "medium": 8,
      "dark": 9,
      "plot": 10,
      "atmospheric": 10
    }
  },
  {
    "id": 1236,
    "title": "Cinder",
    "author": "Marissa Meyer",
    "publicationYear": 2012,
    "pageCount": 390,
    "rating": 4.12,
    "ratingsCount": 1014414,
    "series": {
      "name": "The Lunar Chronicles",
      "position": 1
    },
    "awards": [],
    "categories": [
      "Young Adult",
      "Science Fiction",
      "Fairy Tale Retelling"
    ],
    "synopsis": "A cyborg mechanic in futuristic Beijing becomes entangled in an interplanetary struggle when she discovers secrets about her past and a deadly plague threatens Earth.",
    "scores": {
      "ya": 10,
      "scifi": 10,
      "series": 10,
      "character": 9,
      "fast": 9,
      "optimistic": 8,
      "plot": 9,
      "romance": 8
    }
  },
  {
    "id": 1237,
    "title": "The Selection",
    "author": "Kiera Cass",
    "publicationYear": 2012,
    "pageCount": 327,
    "rating": 4.07,
    "ratingsCount": 1769573,
    "series": {
      "name": "The Selection",
      "position": 1
    },
    "awards": [],
    "categories": [
      "Young Adult",
      "Romance",
      "Dystopian"
    ],
    "synopsis": "Thirty-five girls compete for the heart of a prince in a televised competition that could change their lives forever in a dystopian society divided by castes.",
    "scores": {
      "ya": 10,
      "romance": 10,
      "dystopian": 8,
      "series": 10,
      "character": 8,
      "fast": 9,
      "plot": 8,
      "escapist": 10
    }
  },
  {
    "id": 1238,
    "title": "Battle Royale",
    "author": "Koushun Takami",
    "publicationYear": 1999,
    "pageCount": 617,
    "rating": 4.26,
    "ratingsCount": 86031,
    "awards": [],
    "categories": [
      "Horror",
      "Thriller",
      "Dystopian"
    ],
    "synopsis": "In a totalitarian Japan, a class of middle school students is forced to fight to the death on a deserted island in a government-mandated survival program.",
    "scores": {
      "horror": 10,
      "thriller": 10,
      "dystopian": 10,
      "character": 9,
      "fast": 9,
      "dark": 10,
      "plot": 10,
      "violent": 10
    }
  },
  {
    "id": 1239,
    "title": "Matilda",
    "author": "Roald Dahl",
    "publicationYear": 1988,
    "pageCount": 240,
    "rating": 4.34,
    "ratingsCount": 1114575,
    "awards": [],
    "categories": [
      "Children's",
      "Fantasy",
      "Classic"
    ],
    "synopsis": "A brilliant young girl with telekinetic powers overcomes her neglectful parents and cruel headmistress with the help of a caring teacher.",
    "scores": {
      "childrens": 10,
      "fantasy": 8,
      "classic": 10,
      "character": 10,
      "fast": 9,
      "optimistic": 9,
      "witty": 10,
      "heartwarming": 10
    }
  },
  {
    "id": 1240,
    "title": "Water for Elephants",
    "author": "Sara Gruen",
    "publicationYear": 2006,
    "pageCount": 335,
    "rating": 4.11,
    "ratingsCount": 1704293,
    "awards": [],
    "categories": [
      "Historical Fiction",
      "Romance"
    ],
    "synopsis": "A veterinary student joins a traveling circus during the Great Depression and falls for the star performer's wife in this tale of love, secrets, and a special elephant.",
    "scores": {
      "historical": 10,
      "romance": 9,
      "character": 10,
      "medium": 8,
      "dark": 7,
      "plot": 9,
      "emotional": 9,
      "atmospheric": 10
    }
  },
  {
    "id": 1241,
    "title": "My Sister's Keeper",
    "author": "Jodi Picoult",
    "publicationYear": 2004,
    "pageCount": 423,
    "rating": 4.11,
    "ratingsCount": 1277839,
    "awards": [],
    "categories": [
      "Contemporary Fiction",
      "Literary Fiction"
    ],
    "synopsis": "A thirteen-year-old girl sues her parents for medical emancipation, refusing to donate a kidney to her leukemia-stricken sister who was conceived to be her genetic match.",
    "scores": {
      "contemporary": 10,
      "literary": 9,
      "character": 10,
      "medium": 8,
      "dark": 8,
      "plot": 10,
      "emotional": 10,
      "family": 10
    }
  },
  {
    "id": 1242,
    "title": "Vampire Academy",
    "author": "Richelle Mead",
    "publicationYear": 2007,
    "pageCount": 332,
    "rating": 4.1,
    "ratingsCount": 681501,
    "series": {
      "name": "Vampire Academy",
      "position": 1
    },
    "awards": [],
    "categories": [
      "Young Adult",
      "Paranormal",
      "Romance"
    ],
    "synopsis": "Rose Hathaway, a half-vampire guardian in training, protects her best friend, a royal vampire princess, while navigating romance and dark threats at their academy.",
    "scores": {
      "ya": 10,
      "paranormal": 10,
      "romance": 9,
      "series": 10,
      "character": 9,
      "fast": 9,
      "action": 9
    }
  },
  {
    "id": 1243,
    "title": "The Maze Runner",
    "author": "James Dashner",
    "publicationYear": 2009,
    "pageCount": 374,
    "rating": 4.06,
    "ratingsCount": 1692463,
    "series": {
      "name": "The Maze Runner",
      "position": 1
    },
    "awards": [],
    "categories": [
      "Young Adult",
      "Science Fiction",
      "Dystopian"
    ],
    "synopsis": "Thomas wakes up in an elevator with no memory of his past, finding himself in a community of boys trapped in a maze filled with deadly creatures.",
    "scores": {
      "ya": 10,
      "scifi": 9,
      "dystopian": 10,
      "series": 10,
      "character": 8,
      "fast": 10,
      "plot": 10,
      "action": 10
    }
  },
  {
    "id": 1244,
    "title": "Shatter Me",
    "author": "Tahereh Mafi",
    "publicationYear": 2011,
    "pageCount": 338,
    "rating": 3.84,
    "ratingsCount": 1233407,
    "series": {
      "name": "Shatter Me",
      "position": 1
    },
    "awards": [],
    "categories": [
      "Young Adult",
      "Dystopian",
      "Romance"
    ],
    "synopsis": "Juliette's touch is lethal. Locked away by The Reestablishment, she's offered freedom if she becomes a weapon—but she finds allies who believe she can be more.",
    "scores": {
      "ya": 10,
      "dystopian": 10,
      "romance": 10,
      "series": 10,
      "character": 9,
      "fast": 9,
      "dark": 8,
      "emotional": 9
    }
  },
  {
    "id": 1245,
    "title": "Catching Fire",
    "author": "Suzanne Collins",
    "publicationYear": 2009,
    "pageCount": 391,
    "rating": 4.36,
    "ratingsCount": 4175625,
    "series": {
      "name": "The Hunger Games",
      "position": 2
    },
    "awards": [],
    "categories": [
      "Young Adult",
      "Dystopian",
      "Science Fiction"
    ],
    "synopsis": "Katniss Everdeen has returned home after winning the Hunger Games, but rebellion sparks throughout the districts, and she becomes the symbol of a growing revolution.",
    "scores": {
      "ya": 10,
      "dystopian": 10,
      "series": 10,
      "character": 10,
      "fast": 10,
      "dark": 9,
      "plot": 10,
      "action": 10
    }
  },
  {
    "id": 1246,
    "title": "Mockingjay",
    "author": "Suzanne Collins",
    "publicationYear": 2010,
    "pageCount": 390,
    "rating": 4.12,
    "ratingsCount": 3737640,
    "series": {
      "name": "The Hunger Games",
      "position": 3
    },
    "awards": [],
    "categories": [
      "Young Adult",
      "Dystopian",
      "Science Fiction"
    ],
    "synopsis": "Katniss becomes the Mockingjay, the reluctant leader of a revolution against the Capitol, but the cost of war proves higher than she ever imagined.",
    "scores": {
      "ya": 10,
      "dystopian": 10,
      "series": 10,
      "character": 10,
      "fast": 9,
      "dark": 10,
      "plot": 10,
      "emotional": 10
    }
  },
  {
    "id": 1248,
    "title": "The Guest List",
    "author": "Lucy Foley",
    "publicationYear": 2020,
    "pageCount": 320,
    "rating": 3.8,
    "ratingsCount": 1246615,
    "awards": [],
    "categories": [
      "Mystery",
      "Thriller"
    ],
    "synopsis": "A glamorous wedding on a remote Irish island turns deadly when a body is discovered. Everyone has secrets, and everyone has a motive.",
    "scores": {
      "mystery": 10,
      "thriller": 10,
      "character": 8,
      "fast": 9,
      "dark": 8,
      "plot": 9,
      "atmospheric": 9
    }
  },
  {
    "id": 1249,
    "title": "Eldest",
    "author": "Christopher Paolini",
    "publicationYear": 2005,
    "pageCount": 668,
    "rating": 4.05,
    "ratingsCount": 493275,
    "series": {
      "name": "The Inheritance Cycle",
      "position": 2
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Young Adult"
    ],
    "synopsis": "Eragon and Saphira must journey to the elven land of Ellesméra to continue training while the Varden prepare for war against the Empire.",
    "scores": {
      "fantasy": 10,
      "ya": 10,
      "series": 10,
      "character": 8,
      "slow": 7,
      "plot": 8,
      "worldbuilding": 10
    }
  },
  {
    "id": 1250,
    "title": "Brisingr",
    "author": "Christopher Paolini",
    "publicationYear": 2008,
    "pageCount": 748,
    "rating": 4.11,
    "ratingsCount": 416602,
    "series": {
      "name": "The Inheritance Cycle",
      "position": 3
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Young Adult"
    ],
    "synopsis": "Eragon must make difficult choices as the war against Galbatorix intensifies. Secrets are revealed and new weapons forged.",
    "scores": {
      "fantasy": 10,
      "ya": 10,
      "series": 10,
      "character": 8,
      "medium": 8,
      "plot": 9,
      "epic": 9
    }
  },
  {
    "id": 1251,
    "title": "Inheritance",
    "author": "Christopher Paolini",
    "publicationYear": 2011,
    "pageCount": 849,
    "rating": 4.17,
    "ratingsCount": 312083,
    "series": {
      "name": "The Inheritance Cycle",
      "position": 4
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Young Adult"
    ],
    "synopsis": "The final battle against Galbatorix approaches as Eragon and his allies prepare for an assault on Urû'baen. The fate of Alagaësia hangs in the balance.",
    "scores": {
      "fantasy": 10,
      "ya": 10,
      "series": 10,
      "character": 9,
      "medium": 8,
      "plot": 10,
      "epic": 10,
      "emotional": 9
    }
  },
  {
    "id": 1252,
    "title": "Where the Wild Things Are",
    "author": "Maurice Sendak",
    "publicationYear": 1963,
    "pageCount": 48,
    "rating": 4.26,
    "ratingsCount": 1066509,
    "awards": [
      "Caldecott Medal (1964)"
    ],
    "categories": [
      "Children's",
      "Picture Book",
      "Classic"
    ],
    "synopsis": "Max sails to an island of wild creatures and becomes their king, but eventually realizes there's no place like home.",
    "scores": {
      "classic": 10,
      "childrens": 10,
      "fast": 10,
      "imaginative": 10,
      "emotional": 9
    }
  },
  {
    "id": 1253,
    "title": "Charlie and the Chocolate Factory",
    "author": "Roald Dahl",
    "publicationYear": 1964,
    "pageCount": 155,
    "rating": 4.17,
    "ratingsCount": 932992,
    "series": {
      "name": "Charlie Bucket",
      "position": 1
    },
    "awards": [],
    "categories": [
      "Children's",
      "Fantasy",
      "Classic"
    ],
    "synopsis": "Poor Charlie Bucket wins a Golden Ticket to visit Willy Wonka's magical chocolate factory, where wonders and dangers await.",
    "scores": {
      "childrens": 10,
      "fantasy": 9,
      "classic": 10,
      "fast": 9,
      "whimsical": 10,
      "imaginative": 10
    }
  },
  {
    "id": 1254,
    "title": "The BFG",
    "author": "Roald Dahl",
    "publicationYear": 1982,
    "pageCount": 199,
    "rating": 4.23,
    "ratingsCount": 484804,
    "awards": [],
    "categories": [
      "Children's",
      "Fantasy",
      "Classic"
    ],
    "synopsis": "Sophie is snatched from her bed by the Big Friendly Giant and taken to Giant Country, where they must stop the other giants from eating children.",
    "scores": {
      "childrens": 10,
      "fantasy": 9,
      "classic": 10,
      "fast": 9,
      "whimsical": 10,
      "heartwarming": 10
    }
  },
  {
    "id": 1255,
    "title": "James and the Giant Peach",
    "author": "Roald Dahl",
    "publicationYear": 1961,
    "pageCount": 126,
    "rating": 4.06,
    "ratingsCount": 294167,
    "awards": [],
    "categories": [
      "Children's",
      "Fantasy",
      "Classic"
    ],
    "synopsis": "After James drops magic crocodile tongues near a peach tree, the peach grows enormous and James escapes his cruel aunts inside it with giant insect friends.",
    "scores": {
      "childrens": 10,
      "fantasy": 9,
      "classic": 10,
      "fast": 9,
      "whimsical": 10,
      "adventure": 10
    }
  },
  {
    "id": 1256,
    "title": "The Witches",
    "author": "Roald Dahl",
    "publicationYear": 1983,
    "pageCount": 208,
    "rating": 4.15,
    "ratingsCount": 248647,
    "awards": [
      "Whitbread Award (1983)"
    ],
    "categories": [
      "Children's",
      "Fantasy",
      "Horror"
    ],
    "synopsis": "A young boy and his grandmother encounter a coven of real witches who plan to turn all the children of England into mice.",
    "scores": {
      "childrens": 10,
      "fantasy": 9,
      "horror": 7,
      "fast": 9,
      "dark": 7,
      "exciting": 10
    }
  },
  {
    "id": 1257,
    "title": "Fantastic Mr. Fox",
    "author": "Roald Dahl",
    "publicationYear": 1970,
    "pageCount": 96,
    "rating": 4.17,
    "ratingsCount": 128734,
    "awards": [],
    "categories": [
      "Children's",
      "Classic"
    ],
    "synopsis": "Mr. Fox must outsmart three mean farmers who are determined to catch him after years of raiding their farms.",
    "scores": {
      "childrens": 10,
      "classic": 10,
      "fast": 10,
      "witty": 10,
      "clever": 10
    }
  },
  {
    "id": 1258,
    "title": "Danny, the Champion of the World",
    "author": "Roald Dahl",
    "publicationYear": 1975,
    "pageCount": 196,
    "rating": 4.22,
    "ratingsCount": 76482,
    "awards": [],
    "categories": [
      "Children's",
      "Classic"
    ],
    "synopsis": "Danny discovers his father's secret life as a poacher and helps him with the greatest poaching scheme ever attempted.",
    "scores": {
      "childrens": 10,
      "classic": 10,
      "character": 10,
      "medium": 8,
      "heartwarming": 10,
      "father_son": 10
    }
  },
  {
    "id": 1259,
    "title": "Assassin's Quest",
    "author": "Robin Hobb",
    "publicationYear": 1997,
    "pageCount": 757,
    "rating": 4.32,
    "ratingsCount": 157239,
    "series": {
      "name": "The Farseer Trilogy",
      "position": 3
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "synopsis": "Presumed dead, FitzChivalry Farseer must journey across the Six Duchies to find the exiled King Verity and save his kingdom from the Red Ships.",
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "series": 10,
      "character": 10,
      "slow": 8,
      "dark": 8,
      "emotional": 10,
      "atmospheric": 10
    }
  },
  {
    "id": 1260,
    "title": "The Drawing of the Three",
    "author": "Stephen King",
    "publicationYear": 1987,
    "pageCount": 400,
    "rating": 4.13,
    "ratingsCount": 318294,
    "series": {
      "name": "The Dark Tower",
      "position": 2
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Horror"
    ],
    "synopsis": "Roland draws three people from 20th century New York into his world through magical doorways to help him reach the Dark Tower.",
    "scores": {
      "fantasy": 10,
      "horror": 8,
      "series": 10,
      "character": 10,
      "fast": 9,
      "dark": 9,
      "plot": 10
    }
  },
  {
    "id": 1261,
    "title": "The Waste Lands",
    "author": "Stephen King",
    "publicationYear": 1991,
    "pageCount": 422,
    "rating": 4.18,
    "ratingsCount": 211754,
    "series": {
      "name": "The Dark Tower",
      "position": 3
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Horror"
    ],
    "synopsis": "Roland and his ka-tet journey toward the Dark Tower, rescuing a boy and facing a riddle-spouting train that could kill them all.",
    "scores": {
      "fantasy": 10,
      "horror": 8,
      "series": 10,
      "character": 9,
      "fast": 9,
      "dark": 9,
      "plot": 10
    }
  },
  {
    "id": 1262,
    "title": "Wizard and Glass",
    "author": "Stephen King",
    "publicationYear": 1997,
    "pageCount": 787,
    "rating": 4.23,
    "ratingsCount": 172419,
    "series": {
      "name": "The Dark Tower",
      "position": 4
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Horror",
      "Western"
    ],
    "synopsis": "Roland reveals the tragic story of his youth, his first love Susan Delgado, and the events that set him on the path to the Dark Tower.",
    "scores": {
      "fantasy": 10,
      "horror": 7,
      "series": 10,
      "character": 10,
      "slow": 8,
      "dark": 9,
      "emotional": 10,
      "romantic": 9
    }
  },
  {
    "id": 1263,
    "title": "Wolves of the Calla",
    "author": "Stephen King",
    "publicationYear": 2003,
    "pageCount": 714,
    "rating": 4.11,
    "ratingsCount": 138874,
    "series": {
      "name": "The Dark Tower",
      "position": 5
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Horror",
      "Western"
    ],
    "synopsis": "Roland's ka-tet must help a remote village defend itself against the Wolves, mysterious raiders who kidnap children and return them as vegetables.",
    "scores": {
      "fantasy": 10,
      "horror": 8,
      "series": 10,
      "character": 9,
      "medium": 8,
      "dark": 8,
      "plot": 9
    }
  },
  {
    "id": 1264,
    "title": "Song of Susannah",
    "author": "Stephen King",
    "publicationYear": 2004,
    "pageCount": 432,
    "rating": 3.92,
    "ratingsCount": 116847,
    "series": {
      "name": "The Dark Tower",
      "position": 6
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Horror"
    ],
    "synopsis": "The ka-tet splits up to save Susannah, who has been possessed and sent to New York City where she's about to give birth to something terrible.",
    "scores": {
      "fantasy": 10,
      "horror": 8,
      "series": 10,
      "character": 8,
      "fast": 9,
      "dark": 9,
      "meta": 9
    }
  },
  {
    "id": 1265,
    "title": "The Dark Tower",
    "author": "Stephen King",
    "publicationYear": 2004,
    "pageCount": 845,
    "rating": 4.14,
    "ratingsCount": 132579,
    "series": {
      "name": "The Dark Tower",
      "position": 7
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Horror"
    ],
    "synopsis": "Roland finally reaches the Dark Tower, but the price of his quest proves to be higher than he ever imagined in this epic conclusion.",
    "scores": {
      "fantasy": 10,
      "horror": 8,
      "series": 10,
      "character": 10,
      "medium": 8,
      "dark": 10,
      "emotional": 10,
      "epic": 10
    }
  },
  {
    "id": 1266,
    "title": "Deadhouse Gates",
    "author": "Steven Erikson",
    "publicationYear": 1999,
    "pageCount": 943,
    "rating": 4.33,
    "ratingsCount": 97685,
    "series": {
      "name": "Malazan Book of the Fallen",
      "position": 2
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "synopsis": "As rebellion sweeps the Seven Cities, a desperate march across the desert becomes the Chain of Dogs—one of fantasy's most devastating military campaigns.",
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "series": 10,
      "character": 9,
      "slow": 8,
      "dark": 10,
      "military": 10,
      "emotional": 10
    }
  },
  {
    "id": 1267,
    "title": "Memories of Ice",
    "author": "Steven Erikson",
    "publicationYear": 2001,
    "pageCount": 1187,
    "rating": 4.5,
    "ratingsCount": 80147,
    "series": {
      "name": "Malazan Book of the Fallen",
      "position": 3
    },
    "awards": [],
    "categories": [
      "Fantasy",
      "Epic Fantasy"
    ],
    "synopsis": "The Bridgeburners and their allies face the Pannion Domin, an empire of the undead, in one of fantasy literature's most epic and tragic wars.",
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "series": 10,
      "character": 10,
      "slow": 8,
      "dark": 10,
      "plot": 10,
      "emotional": 10
    }
  },
  {
    "id": 1268,
    "title": "The Green Mile",
    "author": "Stephen King",
    "authorGender": "male",
    "isbn": "1501192264",
    "googleBooksId": "bpD-yQEACAAJ",
    "image": "https://books.google.com/books/content?id=bpD-yQEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "publicationYear": 1996,
    "pageCount": 592,
    "rating": 4.49,
    "ratingsCount": 364996,
    "awards": [
      "Bram Stoker Award Best Novel (1996)"
    ],
    "categories": [
      "Horror",
      "Fiction",
      "Fantasy"
    ],
    "synopsis": "Set at Cold Mountain Penitentiary's death row, prison guard Paul Edgecombe encounters John Coffey, an enormous man convicted of murdering two young girls. As Paul discovers Coffey's miraculous healing abilities, he faces an impossible moral dilemma that will challenge everything he believes about justice, mercy, and the nature of evil.",
    "scores": {
      "horror": 6,
      "fantasy": 7,
      "thriller": 5,
      "character": 10,
      "plot": 9,
      "emotional": 10,
      "dark": 8,
      "atmospheric": 9,
      "medium": 8,
      "standalone": 10,
      "modern": 8,
      "heart": 10,
      "supernatural": 8
    }
  },
  {
    "id": 1269,
    "title": "Doctor Sleep",
    "author": "Stephen King",
    "authorGender": "male",
    "isbn": "1476727651",
    "googleBooksId": "DQTgAAAAQBAJ",
    "image": "https://books.google.com/books/content?id=DQTgAAAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "publicationYear": 2013,
    "pageCount": 531,
    "rating": 4.13,
    "ratingsCount": 298243,
    "series": {
      "name": "The Shining",
      "position": 2
    },
    "awards": [
      "Bram Stoker Award Best Novel (2013)",
      "Goodreads Choice Award Horror (2013)"
    ],
    "categories": [
      "Horror",
      "Fiction",
      "Thriller"
    ],
    "synopsis": "After decades as an itinerant alcoholic, middle-aged Dan Torrance uses his remnant psychic powers to assist the dying at a hospice. When he encounters Abra Stone, a young girl with powerful abilities, he must protect her from the True Knot, a tribe of murderous paranormals who feed on children with the shining.",
    "scores": {
      "horror": 10,
      "thriller": 8,
      "supernatural": 10,
      "character": 9,
      "plot": 8,
      "dark": 9,
      "emotional": 8,
      "series": 8,
      "medium": 8,
      "modern": 10,
      "psychological": 7,
      "atmospheric": 8
    }
  },
  {
    "id": 1270,
    "title": "Billy Summers",
    "author": "Stephen King",
    "authorGender": "male",
    "isbn": "1982173610",
    "googleBooksId": "7wwtzgEACAAJ",
    "image": "https://books.google.com/books/content?id=7wwtzgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "publicationYear": 2021,
    "pageCount": 517,
    "rating": 4.18,
    "ratingsCount": 193509,
    "awards": [
      "Goodreads Choice Award Mystery & Thriller (2021)"
    ],
    "categories": [
      "Fiction",
      "Thriller",
      "Mystery"
    ],
    "synopsis": "Billy Summers is an elite hitman who only kills bad people. Now he wants out. But first there's one last job: a target in a small Southern city. While waiting for the hit, Billy poses as a writer and actually begins crafting a novel about his past. When complications arise, he finds himself drawn into helping a young woman, leading to consequences neither could foresee.",
    "scores": {
      "thriller": 10,
      "mystery": 7,
      "character": 10,
      "plot": 9,
      "dark": 7,
      "emotional": 8,
      "medium": 8,
      "standalone": 10,
      "modern": 10,
      "literary": 7,
      "suspense": 9,
      "crime": 8
    }
  },
  {
    "id": 1271,
    "title": "The Inheritance Games",
    "author": "Jennifer Lynn Barnes",
    "authorGender": "female",
    "isbn": "1368052401",
    "googleBooksId": "9LlSzQEACAAJ",
    "image": "https://books.google.com/books/content?id=9LlSzQEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "publicationYear": 2020,
    "pageCount": 386,
    "rating": 4.12,
    "ratingsCount": 1085337,
    "series": {
      "name": "The Inheritance Games",
      "position": 1
    },
    "awards": [
      "Edgar Award Young Adult (2021)",
      "Goodreads Choice Award Young Adult Fiction (2020)"
    ],
    "categories": [
      "Mystery",
      "Young Adult",
      "Romance"
    ],
    "synopsis": "When Connecticut teenager Avery Grambs inherits billions from a stranger, she must move into his eccentric estate and live with his surviving family—four grandsons who were disinherited. To claim her fortune, she must solve a series of puzzles and riddles left by the deceased billionaire, while navigating family secrets and deadly competition.",
    "scores": {
      "mystery": 10,
      "romance": 7,
      "plot": 9,
      "character": 8,
      "fast": 9,
      "twist": 8,
      "series": 9,
      "modern": 10,
      "accessible": 10,
      "immersive": 9,
      "suspense": 8,
      "young-adult": 10
    }
  },
  {
    "id": 1272,
    "title": "Caraval",
    "author": "Stephanie Garber",
    "authorGender": "female",
    "isbn": "1250095255",
    "googleBooksId": "kA-HDQAAQBAJ",
    "image": "https://books.google.com/books/content?id=kA-HDQAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "publicationYear": 2017,
    "pageCount": 407,
    "rating": 3.97,
    "ratingsCount": 888076,
    "series": {
      "name": "Caraval",
      "position": 1
    },
    "awards": [
      "Goodreads Choice Award Young Adult Fantasy & Science Fiction (2017)"
    ],
    "categories": [
      "Fantasy",
      "Young Adult",
      "Romance"
    ],
    "synopsis": "Sisters Scarlett and Tella finally escape their cruel father to attend Caraval, a magical annual performance where the audience participates in the show. When Tella is kidnapped by the mysterious event organizer Legend, Scarlett must navigate a game of love, heartbreak, and magic to find her sister before the five-night competition ends.",
    "scores": {
      "fantasy": 10,
      "romance": 8,
      "mystery": 7,
      "plot": 8,
      "character": 7,
      "atmospheric": 10,
      "magical": 10,
      "series": 8,
      "modern": 9,
      "fast": 8,
      "immersive": 9,
      "whimsical": 10,
      "young-adult": 10
    }
  },
  {
    "id": 1273,
    "title": "The Priory of the Orange Tree",
    "author": "Samantha Shannon",
    "authorGender": "female",
    "isbn": "1635570301",
    "googleBooksId": "o7nEDwAAQBAJ",
    "image": "https://books.google.com/books/content?id=o7nEDwAAQBAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "publicationYear": 2019,
    "pageCount": 848,
    "rating": 4.17,
    "ratingsCount": 281012,
    "series": {
      "name": "The Roots of Chaos",
      "position": 1
    },
    "awards": [
      "Lambda Literary Award LGBT Science Fiction/Fantasy/Horror (2019)",
      "Goodreads Choice Award Fantasy (2019)"
    ],
    "categories": [
      "Fantasy",
      "LGBTQ+",
      "Epic Fantasy"
    ],
    "synopsis": "Queen Sabran the Ninth must conceive an heir to protect her realm from the return of the Nameless One. Ead Duryan, a lady-in-waiting with secret magical abilities, protects the queen while hiding her true allegiance. Across the sea, dragonrider Tané faces impossible choices. As ancient forces awaken, these women's fates intertwine in a battle that will reshape the world.",
    "scores": {
      "fantasy": 10,
      "epic": 10,
      "LGBTQ": 9,
      "character": 9,
      "plot": 8,
      "worldbuilding": 10,
      "atmospheric": 9,
      "slow": 7,
      "standalone": 8,
      "modern": 10,
      "feminist": 9,
      "dragons": 10
    }
  },
  {
    "id": 1274,
    "title": "A Darker Shade of Magic",
    "author": "V.E. Schwab",
    "authorGender": "female",
    "isbn": "0765376466",
    "googleBooksId": "zKKNrgEACAAJ",
    "image": "https://books.google.com/books/content?id=zKKNrgEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "publicationYear": 2015,
    "pageCount": 400,
    "rating": 4.03,
    "ratingsCount": 432869,
    "series": {
      "name": "Shades of Magic",
      "position": 1
    },
    "awards": [
      "Goodreads Choice Award Fantasy (2015)"
    ],
    "categories": [
      "Fantasy",
      "Fiction",
      "Adventure"
    ],
    "synopsis": "Kell is one of the last Antari, magicians with the rare ability to travel between parallel Londons. He serves as an ambassador but secretly smuggles artifacts between worlds. When a deal goes wrong, he meets Delilah Bard, an ambitious thief who forces him to take her to another London. Together they must stop a dangerous magic that threatens all the worlds.",
    "scores": {
      "fantasy": 10,
      "adventure": 9,
      "plot": 9,
      "character": 8,
      "worldbuilding": 10,
      "atmospheric": 9,
      "medium": 8,
      "series": 9,
      "modern": 10,
      "immersive": 9,
      "magical": 10,
      "dark": 6
    }
  },
  {
    "id": 1277,
    "title": "Under the Whispering Door",
    "author": "T.J. Klune",
    "authorGender": "male",
    "isbn": "1250217342",
    "googleBooksId": "mgl8zQEACAAJ",
    "image": "https://books.google.com/books/content?id=mgl8zQEACAAJ&printsec=frontcover&img=1&zoom=1&source=gbs_api",
    "publicationYear": 2021,
    "pageCount": 376,
    "rating": 4.11,
    "ratingsCount": 322517,
    "awards": [],
    "categories": [
      "Fantasy",
      "Fiction",
      "LGBTQ+"
    ],
    "synopsis": "When Wallace Price dies, he refuses to accept it. His ghost arrives at a tea shop that serves as a waystation between the living and the dead, run by Hugo, a ferryman who helps souls cross over. Given one week to move on, Wallace discovers what it means to truly live—and finds unexpected connections that challenge everything he thought he knew.",
    "scores": {
      "fantasy": 8,
      "LGBTQ": 10,
      "romance": 8,
      "character": 10,
      "emotional": 10,
      "heartwarming": 10,
      "cozy": 10,
      "standalone": 10,
      "modern": 10,
      "optimistic": 10,
      "whimsical": 9,
      "death": 9
    }
  }
];